import * as x from "react";
import N, { forwardRef as Ps, useContext as Cs, isValidElement as pl, cloneElement as ms, Children as EI, createElement as QS, useRef as Xt, useState as Ir, useLayoutEffect as Fc, useCallback as Ln, useMemo as ra, useEffect as Dn, memo as OI, useImperativeHandle as Ss, version as $I } from "react";
import * as Zh from "react-dom";
import cl from "react-dom";
var cd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function e2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ud = { exports: {} }, sc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N1;
function RI() {
  if (N1) return sc;
  N1 = 1;
  var e = N, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, d, p) {
    var f, h = {}, g = null, y = null;
    p !== void 0 && (g = "" + p), d.key !== void 0 && (g = "" + d.key), d.ref !== void 0 && (y = d.ref);
    for (f in d) o.call(d, f) && !i.hasOwnProperty(f) && (h[f] = d[f]);
    if (c && c.defaultProps) for (f in d = c.defaultProps, d) h[f] === void 0 && (h[f] = d[f]);
    return { $$typeof: t, type: c, key: g, ref: y, props: h, _owner: a.current };
  }
  return sc.Fragment = r, sc.jsx = l, sc.jsxs = l, sc;
}
var lc = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M1;
function PI() {
  return M1 || (M1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = N, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), C = Symbol.iterator, b = "@@iterator";
    function v(te) {
      if (te === null || typeof te != "object")
        return null;
      var _e = C && te[C] || te[b];
      return typeof _e == "function" ? _e : null;
    }
    var T = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(te) {
      {
        for (var _e = arguments.length, Xe = new Array(_e > 1 ? _e - 1 : 0), yt = 1; yt < _e; yt++)
          Xe[yt - 1] = arguments[yt];
        $("error", te, Xe);
      }
    }
    function $(te, _e, Xe) {
      {
        var yt = T.ReactDebugCurrentFrame, Ht = yt.getStackAddendum();
        Ht !== "" && (_e += "%s", Xe = Xe.concat([Ht]));
        var Te = Xe.map(function(ve) {
          return String(ve);
        });
        Te.unshift("Warning: " + _e), Function.prototype.apply.call(console[te], console, Te);
      }
    }
    var E = !1, S = !1, k = !1, A = !1, _ = !1, L;
    L = Symbol.for("react.module.reference");
    function O(te) {
      return !!(typeof te == "string" || typeof te == "function" || te === o || te === i || _ || te === a || te === p || te === f || A || te === y || E || S || k || typeof te == "object" && te !== null && (te.$$typeof === g || te.$$typeof === h || te.$$typeof === l || te.$$typeof === c || te.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      te.$$typeof === L || te.getModuleId !== void 0));
    }
    function F(te, _e, Xe) {
      var yt = te.displayName;
      if (yt)
        return yt;
      var Ht = _e.displayName || _e.name || "";
      return Ht !== "" ? Xe + "(" + Ht + ")" : Xe;
    }
    function B(te) {
      return te.displayName || "Context";
    }
    function M(te) {
      if (te == null)
        return null;
      if (typeof te.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof te == "function")
        return te.displayName || te.name || null;
      if (typeof te == "string")
        return te;
      switch (te) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof te == "object")
        switch (te.$$typeof) {
          case c:
            var _e = te;
            return B(_e) + ".Consumer";
          case l:
            var Xe = te;
            return B(Xe._context) + ".Provider";
          case d:
            return F(te, te.render, "ForwardRef");
          case h:
            var yt = te.displayName || null;
            return yt !== null ? yt : M(te.type) || "Memo";
          case g: {
            var Ht = te, Te = Ht._payload, ve = Ht._init;
            try {
              return M(ve(Te));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, W = 0, V, X, U, H, Z, G, ye;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function ne() {
      {
        if (W === 0) {
          V = console.log, X = console.info, U = console.warn, H = console.error, Z = console.group, G = console.groupCollapsed, ye = console.groupEnd;
          var te = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: te,
            log: te,
            warn: te,
            error: te,
            group: te,
            groupCollapsed: te,
            groupEnd: te
          });
        }
        W++;
      }
    }
    function fe() {
      {
        if (W--, W === 0) {
          var te = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, te, {
              value: V
            }),
            info: j({}, te, {
              value: X
            }),
            warn: j({}, te, {
              value: U
            }),
            error: j({}, te, {
              value: H
            }),
            group: j({}, te, {
              value: Z
            }),
            groupCollapsed: j({}, te, {
              value: G
            }),
            groupEnd: j({}, te, {
              value: ye
            })
          });
        }
        W < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = T.ReactCurrentDispatcher, oe;
    function ce(te, _e, Xe) {
      {
        if (oe === void 0)
          try {
            throw Error();
          } catch (Ht) {
            var yt = Ht.stack.trim().match(/\n( *(at )?)/);
            oe = yt && yt[1] || "";
          }
        return `
` + oe + te;
      }
    }
    var Ce = !1, xe;
    {
      var Re = typeof WeakMap == "function" ? WeakMap : Map;
      xe = new Re();
    }
    function J(te, _e) {
      if (!te || Ce)
        return "";
      {
        var Xe = xe.get(te);
        if (Xe !== void 0)
          return Xe;
      }
      var yt;
      Ce = !0;
      var Ht = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Te;
      Te = ie.current, ie.current = null, ne();
      try {
        if (_e) {
          var ve = function() {
            throw Error();
          };
          if (Object.defineProperty(ve.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ve, []);
            } catch (Wr) {
              yt = Wr;
            }
            Reflect.construct(te, [], ve);
          } else {
            try {
              ve.call();
            } catch (Wr) {
              yt = Wr;
            }
            te.call(ve.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wr) {
            yt = Wr;
          }
          te();
        }
      } catch (Wr) {
        if (Wr && yt && typeof Wr.stack == "string") {
          for (var je = Wr.stack.split(`
`), ht = yt.stack.split(`
`), mt = je.length - 1, vt = ht.length - 1; mt >= 1 && vt >= 0 && je[mt] !== ht[vt]; )
            vt--;
          for (; mt >= 1 && vt >= 0; mt--, vt--)
            if (je[mt] !== ht[vt]) {
              if (mt !== 1 || vt !== 1)
                do
                  if (mt--, vt--, vt < 0 || je[mt] !== ht[vt]) {
                    var Kt = `
` + je[mt].replace(" at new ", " at ");
                    return te.displayName && Kt.includes("<anonymous>") && (Kt = Kt.replace("<anonymous>", te.displayName)), typeof te == "function" && xe.set(te, Kt), Kt;
                  }
                while (mt >= 1 && vt >= 0);
              break;
            }
        }
      } finally {
        Ce = !1, ie.current = Te, fe(), Error.prepareStackTrace = Ht;
      }
      var br = te ? te.displayName || te.name : "", $n = br ? ce(br) : "";
      return typeof te == "function" && xe.set(te, $n), $n;
    }
    function Ie(te, _e, Xe) {
      return J(te, !1);
    }
    function le(te) {
      var _e = te.prototype;
      return !!(_e && _e.isReactComponent);
    }
    function qe(te, _e, Xe) {
      if (te == null)
        return "";
      if (typeof te == "function")
        return J(te, le(te));
      if (typeof te == "string")
        return ce(te);
      switch (te) {
        case p:
          return ce("Suspense");
        case f:
          return ce("SuspenseList");
      }
      if (typeof te == "object")
        switch (te.$$typeof) {
          case d:
            return Ie(te.render);
          case h:
            return qe(te.type, _e, Xe);
          case g: {
            var yt = te, Ht = yt._payload, Te = yt._init;
            try {
              return qe(Te(Ht), _e, Xe);
            } catch {
            }
          }
        }
      return "";
    }
    var q = Object.prototype.hasOwnProperty, K = {}, ee = T.ReactDebugCurrentFrame;
    function he(te) {
      if (te) {
        var _e = te._owner, Xe = qe(te.type, te._source, _e ? _e.type : null);
        ee.setExtraStackFrame(Xe);
      } else
        ee.setExtraStackFrame(null);
    }
    function we(te, _e, Xe, yt, Ht) {
      {
        var Te = Function.call.bind(q);
        for (var ve in te)
          if (Te(te, ve)) {
            var je = void 0;
            try {
              if (typeof te[ve] != "function") {
                var ht = Error((yt || "React class") + ": " + Xe + " type `" + ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof te[ve] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ht.name = "Invariant Violation", ht;
              }
              je = te[ve](_e, ve, yt, Xe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (mt) {
              je = mt;
            }
            je && !(je instanceof Error) && (he(Ht), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", yt || "React class", Xe, ve, typeof je), he(null)), je instanceof Error && !(je.message in K) && (K[je.message] = !0, he(Ht), R("Failed %s type: %s", Xe, je.message), he(null));
          }
      }
    }
    var se = Array.isArray;
    function ue(te) {
      return se(te);
    }
    function Qe(te) {
      {
        var _e = typeof Symbol == "function" && Symbol.toStringTag, Xe = _e && te[Symbol.toStringTag] || te.constructor.name || "Object";
        return Xe;
      }
    }
    function We(te) {
      try {
        return be(te), !1;
      } catch {
        return !0;
      }
    }
    function be(te) {
      return "" + te;
    }
    function Se(te) {
      if (We(te))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qe(te)), be(te);
    }
    var De = T.ReactCurrentOwner, Ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, et, Je;
    function tt(te) {
      if (q.call(te, "ref")) {
        var _e = Object.getOwnPropertyDescriptor(te, "ref").get;
        if (_e && _e.isReactWarning)
          return !1;
      }
      return te.ref !== void 0;
    }
    function Rt(te) {
      if (q.call(te, "key")) {
        var _e = Object.getOwnPropertyDescriptor(te, "key").get;
        if (_e && _e.isReactWarning)
          return !1;
      }
      return te.key !== void 0;
    }
    function xt(te, _e) {
      typeof te.ref == "string" && De.current;
    }
    function rt(te, _e) {
      {
        var Xe = function() {
          et || (et = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _e));
        };
        Xe.isReactWarning = !0, Object.defineProperty(te, "key", {
          get: Xe,
          configurable: !0
        });
      }
    }
    function He(te, _e) {
      {
        var Xe = function() {
          Je || (Je = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _e));
        };
        Xe.isReactWarning = !0, Object.defineProperty(te, "ref", {
          get: Xe,
          configurable: !0
        });
      }
    }
    var Oe = function(te, _e, Xe, yt, Ht, Te, ve) {
      var je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: te,
        key: _e,
        ref: Xe,
        props: ve,
        // Record the component responsible for creating this element.
        _owner: Te
      };
      return je._store = {}, Object.defineProperty(je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: yt
      }), Object.defineProperty(je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ht
      }), Object.freeze && (Object.freeze(je.props), Object.freeze(je)), je;
    };
    function Ze(te, _e, Xe, yt, Ht) {
      {
        var Te, ve = {}, je = null, ht = null;
        Xe !== void 0 && (Se(Xe), je = "" + Xe), Rt(_e) && (Se(_e.key), je = "" + _e.key), tt(_e) && (ht = _e.ref, xt(_e, Ht));
        for (Te in _e)
          q.call(_e, Te) && !Ye.hasOwnProperty(Te) && (ve[Te] = _e[Te]);
        if (te && te.defaultProps) {
          var mt = te.defaultProps;
          for (Te in mt)
            ve[Te] === void 0 && (ve[Te] = mt[Te]);
        }
        if (je || ht) {
          var vt = typeof te == "function" ? te.displayName || te.name || "Unknown" : te;
          je && rt(ve, vt), ht && He(ve, vt);
        }
        return Oe(te, je, ht, Ht, yt, De.current, ve);
      }
    }
    var Pt = T.ReactCurrentOwner, Mt = T.ReactDebugCurrentFrame;
    function Ct(te) {
      if (te) {
        var _e = te._owner, Xe = qe(te.type, te._source, _e ? _e.type : null);
        Mt.setExtraStackFrame(Xe);
      } else
        Mt.setExtraStackFrame(null);
    }
    var bt;
    bt = !1;
    function nt(te) {
      return typeof te == "object" && te !== null && te.$$typeof === t;
    }
    function ft() {
      {
        if (Pt.current) {
          var te = M(Pt.current.type);
          if (te)
            return `

Check the render method of \`` + te + "`.";
        }
        return "";
      }
    }
    function er(te) {
      return "";
    }
    var Ut = {};
    function Ft(te) {
      {
        var _e = ft();
        if (!_e) {
          var Xe = typeof te == "string" ? te : te.displayName || te.name;
          Xe && (_e = `

Check the top-level render call using <` + Xe + ">.");
        }
        return _e;
      }
    }
    function ct(te, _e) {
      {
        if (!te._store || te._store.validated || te.key != null)
          return;
        te._store.validated = !0;
        var Xe = Ft(_e);
        if (Ut[Xe])
          return;
        Ut[Xe] = !0;
        var yt = "";
        te && te._owner && te._owner !== Pt.current && (yt = " It was passed a child from " + M(te._owner.type) + "."), Ct(te), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Xe, yt), Ct(null);
      }
    }
    function fr(te, _e) {
      {
        if (typeof te != "object")
          return;
        if (ue(te))
          for (var Xe = 0; Xe < te.length; Xe++) {
            var yt = te[Xe];
            nt(yt) && ct(yt, _e);
          }
        else if (nt(te))
          te._store && (te._store.validated = !0);
        else if (te) {
          var Ht = v(te);
          if (typeof Ht == "function" && Ht !== te.entries)
            for (var Te = Ht.call(te), ve; !(ve = Te.next()).done; )
              nt(ve.value) && ct(ve.value, _e);
        }
      }
    }
    function at(te) {
      {
        var _e = te.type;
        if (_e == null || typeof _e == "string")
          return;
        var Xe;
        if (typeof _e == "function")
          Xe = _e.propTypes;
        else if (typeof _e == "object" && (_e.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _e.$$typeof === h))
          Xe = _e.propTypes;
        else
          return;
        if (Xe) {
          var yt = M(_e);
          we(Xe, te.props, "prop", yt, te);
        } else if (_e.PropTypes !== void 0 && !bt) {
          bt = !0;
          var Ht = M(_e);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ht || "Unknown");
        }
        typeof _e.getDefaultProps == "function" && !_e.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function lt(te) {
      {
        for (var _e = Object.keys(te.props), Xe = 0; Xe < _e.length; Xe++) {
          var yt = _e[Xe];
          if (yt !== "children" && yt !== "key") {
            Ct(te), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", yt), Ct(null);
            break;
          }
        }
        te.ref !== null && (Ct(te), R("Invalid attribute `ref` supplied to `React.Fragment`."), Ct(null));
      }
    }
    var St = {};
    function kt(te, _e, Xe, yt, Ht, Te) {
      {
        var ve = O(te);
        if (!ve) {
          var je = "";
          (te === void 0 || typeof te == "object" && te !== null && Object.keys(te).length === 0) && (je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ht = er();
          ht ? je += ht : je += ft();
          var mt;
          te === null ? mt = "null" : ue(te) ? mt = "array" : te !== void 0 && te.$$typeof === t ? (mt = "<" + (M(te.type) || "Unknown") + " />", je = " Did you accidentally export a JSX literal instead of a component?") : mt = typeof te, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", mt, je);
        }
        var vt = Ze(te, _e, Xe, Ht, Te);
        if (vt == null)
          return vt;
        if (ve) {
          var Kt = _e.children;
          if (Kt !== void 0)
            if (yt)
              if (ue(Kt)) {
                for (var br = 0; br < Kt.length; br++)
                  fr(Kt[br], te);
                Object.freeze && Object.freeze(Kt);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              fr(Kt, te);
        }
        if (q.call(_e, "key")) {
          var $n = M(te), Wr = Object.keys(_e).filter(function(Bs) {
            return Bs !== "key";
          }), ui = Wr.length > 0 ? "{key: someKey, " + Wr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!St[$n + ui]) {
            var Ls = Wr.length > 0 ? "{" + Wr.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ui, $n, Ls, $n), St[$n + ui] = !0;
          }
        }
        return te === o ? lt(vt) : at(vt), vt;
      }
    }
    function Wt(te, _e, Xe) {
      return kt(te, _e, Xe, !0);
    }
    function Lr(te, _e, Xe) {
      return kt(te, _e, Xe, !1);
    }
    var hn = Lr, oo = Wt;
    lc.Fragment = o, lc.jsx = hn, lc.jsxs = oo;
  }()), lc;
}
var _1;
function kI() {
  return _1 || (_1 = 1, process.env.NODE_ENV === "production" ? ud.exports = RI() : ud.exports = PI()), ud.exports;
}
var P = kI(), dd = { exports: {} }, pd = { exports: {} }, ir = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F1;
function AI() {
  if (F1) return ir;
  F1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function $(S) {
    if (typeof S == "object" && S !== null) {
      var k = S.$$typeof;
      switch (k) {
        case t:
          switch (S = S.type, S) {
            case d:
            case p:
            case o:
            case i:
            case a:
            case h:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case c:
                case f:
                case C:
                case y:
                case l:
                  return S;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  function E(S) {
    return $(S) === p;
  }
  return ir.AsyncMode = d, ir.ConcurrentMode = p, ir.ContextConsumer = c, ir.ContextProvider = l, ir.Element = t, ir.ForwardRef = f, ir.Fragment = o, ir.Lazy = C, ir.Memo = y, ir.Portal = r, ir.Profiler = i, ir.StrictMode = a, ir.Suspense = h, ir.isAsyncMode = function(S) {
    return E(S) || $(S) === d;
  }, ir.isConcurrentMode = E, ir.isContextConsumer = function(S) {
    return $(S) === c;
  }, ir.isContextProvider = function(S) {
    return $(S) === l;
  }, ir.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, ir.isForwardRef = function(S) {
    return $(S) === f;
  }, ir.isFragment = function(S) {
    return $(S) === o;
  }, ir.isLazy = function(S) {
    return $(S) === C;
  }, ir.isMemo = function(S) {
    return $(S) === y;
  }, ir.isPortal = function(S) {
    return $(S) === r;
  }, ir.isProfiler = function(S) {
    return $(S) === i;
  }, ir.isStrictMode = function(S) {
    return $(S) === a;
  }, ir.isSuspense = function(S) {
    return $(S) === h;
  }, ir.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === o || S === p || S === i || S === a || S === h || S === g || typeof S == "object" && S !== null && (S.$$typeof === C || S.$$typeof === y || S.$$typeof === l || S.$$typeof === c || S.$$typeof === f || S.$$typeof === v || S.$$typeof === T || S.$$typeof === R || S.$$typeof === b);
  }, ir.typeOf = $, ir;
}
var sr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L1;
function II() {
  return L1 || (L1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function $(J) {
      return typeof J == "string" || typeof J == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      J === o || J === p || J === i || J === a || J === h || J === g || typeof J == "object" && J !== null && (J.$$typeof === C || J.$$typeof === y || J.$$typeof === l || J.$$typeof === c || J.$$typeof === f || J.$$typeof === v || J.$$typeof === T || J.$$typeof === R || J.$$typeof === b);
    }
    function E(J) {
      if (typeof J == "object" && J !== null) {
        var Ie = J.$$typeof;
        switch (Ie) {
          case t:
            var le = J.type;
            switch (le) {
              case d:
              case p:
              case o:
              case i:
              case a:
              case h:
                return le;
              default:
                var qe = le && le.$$typeof;
                switch (qe) {
                  case c:
                  case f:
                  case C:
                  case y:
                  case l:
                    return qe;
                  default:
                    return Ie;
                }
            }
          case r:
            return Ie;
        }
      }
    }
    var S = d, k = p, A = c, _ = l, L = t, O = f, F = o, B = C, M = y, j = r, W = i, V = a, X = h, U = !1;
    function H(J) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Z(J) || E(J) === d;
    }
    function Z(J) {
      return E(J) === p;
    }
    function G(J) {
      return E(J) === c;
    }
    function ye(J) {
      return E(J) === l;
    }
    function de(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function ne(J) {
      return E(J) === f;
    }
    function fe(J) {
      return E(J) === o;
    }
    function ie(J) {
      return E(J) === C;
    }
    function oe(J) {
      return E(J) === y;
    }
    function ce(J) {
      return E(J) === r;
    }
    function Ce(J) {
      return E(J) === i;
    }
    function xe(J) {
      return E(J) === a;
    }
    function Re(J) {
      return E(J) === h;
    }
    sr.AsyncMode = S, sr.ConcurrentMode = k, sr.ContextConsumer = A, sr.ContextProvider = _, sr.Element = L, sr.ForwardRef = O, sr.Fragment = F, sr.Lazy = B, sr.Memo = M, sr.Portal = j, sr.Profiler = W, sr.StrictMode = V, sr.Suspense = X, sr.isAsyncMode = H, sr.isConcurrentMode = Z, sr.isContextConsumer = G, sr.isContextProvider = ye, sr.isElement = de, sr.isForwardRef = ne, sr.isFragment = fe, sr.isLazy = ie, sr.isMemo = oe, sr.isPortal = ce, sr.isProfiler = Ce, sr.isStrictMode = xe, sr.isSuspense = Re, sr.isValidElementType = $, sr.typeOf = E;
  }()), sr;
}
var B1;
function t2() {
  return B1 || (B1 = 1, process.env.NODE_ENV === "production" ? pd.exports = AI() : pd.exports = II()), pd.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qm, D1;
function NI() {
  if (D1) return qm;
  D1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(l).map(function(f) {
        return l[f];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        p[f] = f;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qm = a() ? Object.assign : function(i, l) {
    for (var c, d = o(i), p, f = 1; f < arguments.length; f++) {
      c = Object(arguments[f]);
      for (var h in c)
        t.call(c, h) && (d[h] = c[h]);
      if (e) {
        p = e(c);
        for (var g = 0; g < p.length; g++)
          r.call(c, p[g]) && (d[p[g]] = c[p[g]]);
      }
    }
    return d;
  }, qm;
}
var Km, j1;
function Zg() {
  if (j1) return Km;
  j1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Km = e, Km;
}
var Ym, z1;
function r2() {
  return z1 || (z1 = 1, Ym = Function.call.bind(Object.prototype.hasOwnProperty)), Ym;
}
var Zm, V1;
function MI() {
  if (V1) return Zm;
  V1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Zg(), r = {}, o = /* @__PURE__ */ r2();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(i, l, c, d, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (o(i, f)) {
          var h;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (d || "React class") + ": " + c + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            h = i[f](l, f, d, c, null, t);
          } catch (C) {
            h = C;
          }
          if (h && !(h instanceof Error) && e(
            (d || "React class") + ": type specification of " + c + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var y = p ? p() : "";
            e(
              "Failed " + c + " type: " + h.message + (y ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Zm = a, Zm;
}
var Xm, W1;
function _I() {
  if (W1) return Xm;
  W1 = 1;
  var e = t2(), t = NI(), r = /* @__PURE__ */ Zg(), o = /* @__PURE__ */ r2(), a = /* @__PURE__ */ MI(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Xm = function(c, d) {
    var p = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(Z) {
      var G = Z && (p && Z[p] || Z[f]);
      if (typeof G == "function")
        return G;
    }
    var g = "<<anonymous>>", y = {
      array: T("array"),
      bigint: T("bigint"),
      bool: T("boolean"),
      func: T("function"),
      number: T("number"),
      object: T("object"),
      string: T("string"),
      symbol: T("symbol"),
      any: R(),
      arrayOf: $,
      element: E(),
      elementType: S(),
      instanceOf: k,
      node: O(),
      objectOf: _,
      oneOf: A,
      oneOfType: L,
      shape: B,
      exact: M
    };
    function C(Z, G) {
      return Z === G ? Z !== 0 || 1 / Z === 1 / G : Z !== Z && G !== G;
    }
    function b(Z, G) {
      this.message = Z, this.data = G && typeof G == "object" ? G : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function v(Z) {
      if (process.env.NODE_ENV !== "production")
        var G = {}, ye = 0;
      function de(fe, ie, oe, ce, Ce, xe, Re) {
        if (ce = ce || g, xe = xe || oe, Re !== r) {
          if (d) {
            var J = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw J.name = "Invariant Violation", J;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ie = ce + ":" + oe;
            !G[Ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            ye < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + xe + "` prop on `" + ce + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), G[Ie] = !0, ye++);
          }
        }
        return ie[oe] == null ? fe ? ie[oe] === null ? new b("The " + Ce + " `" + xe + "` is marked as required " + ("in `" + ce + "`, but its value is `null`.")) : new b("The " + Ce + " `" + xe + "` is marked as required in " + ("`" + ce + "`, but its value is `undefined`.")) : null : Z(ie, oe, ce, Ce, xe);
      }
      var ne = de.bind(null, !1);
      return ne.isRequired = de.bind(null, !0), ne;
    }
    function T(Z) {
      function G(ye, de, ne, fe, ie, oe) {
        var ce = ye[de], Ce = V(ce);
        if (Ce !== Z) {
          var xe = X(ce);
          return new b(
            "Invalid " + fe + " `" + ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected ") + ("`" + Z + "`."),
            { expectedType: Z }
          );
        }
        return null;
      }
      return v(G);
    }
    function R() {
      return v(l);
    }
    function $(Z) {
      function G(ye, de, ne, fe, ie) {
        if (typeof Z != "function")
          return new b("Property `" + ie + "` of component `" + ne + "` has invalid PropType notation inside arrayOf.");
        var oe = ye[de];
        if (!Array.isArray(oe)) {
          var ce = V(oe);
          return new b("Invalid " + fe + " `" + ie + "` of type " + ("`" + ce + "` supplied to `" + ne + "`, expected an array."));
        }
        for (var Ce = 0; Ce < oe.length; Ce++) {
          var xe = Z(oe, Ce, ne, fe, ie + "[" + Ce + "]", r);
          if (xe instanceof Error)
            return xe;
        }
        return null;
      }
      return v(G);
    }
    function E() {
      function Z(G, ye, de, ne, fe) {
        var ie = G[ye];
        if (!c(ie)) {
          var oe = V(ie);
          return new b("Invalid " + ne + " `" + fe + "` of type " + ("`" + oe + "` supplied to `" + de + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(Z);
    }
    function S() {
      function Z(G, ye, de, ne, fe) {
        var ie = G[ye];
        if (!e.isValidElementType(ie)) {
          var oe = V(ie);
          return new b("Invalid " + ne + " `" + fe + "` of type " + ("`" + oe + "` supplied to `" + de + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(Z);
    }
    function k(Z) {
      function G(ye, de, ne, fe, ie) {
        if (!(ye[de] instanceof Z)) {
          var oe = Z.name || g, ce = H(ye[de]);
          return new b("Invalid " + fe + " `" + ie + "` of type " + ("`" + ce + "` supplied to `" + ne + "`, expected ") + ("instance of `" + oe + "`."));
        }
        return null;
      }
      return v(G);
    }
    function A(Z) {
      if (!Array.isArray(Z))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function G(ye, de, ne, fe, ie) {
        for (var oe = ye[de], ce = 0; ce < Z.length; ce++)
          if (C(oe, Z[ce]))
            return null;
        var Ce = JSON.stringify(Z, function(Re, J) {
          var Ie = X(J);
          return Ie === "symbol" ? String(J) : J;
        });
        return new b("Invalid " + fe + " `" + ie + "` of value `" + String(oe) + "` " + ("supplied to `" + ne + "`, expected one of " + Ce + "."));
      }
      return v(G);
    }
    function _(Z) {
      function G(ye, de, ne, fe, ie) {
        if (typeof Z != "function")
          return new b("Property `" + ie + "` of component `" + ne + "` has invalid PropType notation inside objectOf.");
        var oe = ye[de], ce = V(oe);
        if (ce !== "object")
          return new b("Invalid " + fe + " `" + ie + "` of type " + ("`" + ce + "` supplied to `" + ne + "`, expected an object."));
        for (var Ce in oe)
          if (o(oe, Ce)) {
            var xe = Z(oe, Ce, ne, fe, ie + "." + Ce, r);
            if (xe instanceof Error)
              return xe;
          }
        return null;
      }
      return v(G);
    }
    function L(Z) {
      if (!Array.isArray(Z))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var G = 0; G < Z.length; G++) {
        var ye = Z[G];
        if (typeof ye != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(ye) + " at index " + G + "."
          ), l;
      }
      function de(ne, fe, ie, oe, ce) {
        for (var Ce = [], xe = 0; xe < Z.length; xe++) {
          var Re = Z[xe], J = Re(ne, fe, ie, oe, ce, r);
          if (J == null)
            return null;
          J.data && o(J.data, "expectedType") && Ce.push(J.data.expectedType);
        }
        var Ie = Ce.length > 0 ? ", expected one of type [" + Ce.join(", ") + "]" : "";
        return new b("Invalid " + oe + " `" + ce + "` supplied to " + ("`" + ie + "`" + Ie + "."));
      }
      return v(de);
    }
    function O() {
      function Z(G, ye, de, ne, fe) {
        return j(G[ye]) ? null : new b("Invalid " + ne + " `" + fe + "` supplied to " + ("`" + de + "`, expected a ReactNode."));
      }
      return v(Z);
    }
    function F(Z, G, ye, de, ne) {
      return new b(
        (Z || "React class") + ": " + G + " type `" + ye + "." + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ne + "`."
      );
    }
    function B(Z) {
      function G(ye, de, ne, fe, ie) {
        var oe = ye[de], ce = V(oe);
        if (ce !== "object")
          return new b("Invalid " + fe + " `" + ie + "` of type `" + ce + "` " + ("supplied to `" + ne + "`, expected `object`."));
        for (var Ce in Z) {
          var xe = Z[Ce];
          if (typeof xe != "function")
            return F(ne, fe, ie, Ce, X(xe));
          var Re = xe(oe, Ce, ne, fe, ie + "." + Ce, r);
          if (Re)
            return Re;
        }
        return null;
      }
      return v(G);
    }
    function M(Z) {
      function G(ye, de, ne, fe, ie) {
        var oe = ye[de], ce = V(oe);
        if (ce !== "object")
          return new b("Invalid " + fe + " `" + ie + "` of type `" + ce + "` " + ("supplied to `" + ne + "`, expected `object`."));
        var Ce = t({}, ye[de], Z);
        for (var xe in Ce) {
          var Re = Z[xe];
          if (o(Z, xe) && typeof Re != "function")
            return F(ne, fe, ie, xe, X(Re));
          if (!Re)
            return new b(
              "Invalid " + fe + " `" + ie + "` key `" + xe + "` supplied to `" + ne + "`.\nBad object: " + JSON.stringify(ye[de], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Z), null, "  ")
            );
          var J = Re(oe, xe, ne, fe, ie + "." + xe, r);
          if (J)
            return J;
        }
        return null;
      }
      return v(G);
    }
    function j(Z) {
      switch (typeof Z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Z;
        case "object":
          if (Array.isArray(Z))
            return Z.every(j);
          if (Z === null || c(Z))
            return !0;
          var G = h(Z);
          if (G) {
            var ye = G.call(Z), de;
            if (G !== Z.entries) {
              for (; !(de = ye.next()).done; )
                if (!j(de.value))
                  return !1;
            } else
              for (; !(de = ye.next()).done; ) {
                var ne = de.value;
                if (ne && !j(ne[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(Z, G) {
      return Z === "symbol" ? !0 : G ? G["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && G instanceof Symbol : !1;
    }
    function V(Z) {
      var G = typeof Z;
      return Array.isArray(Z) ? "array" : Z instanceof RegExp ? "object" : W(G, Z) ? "symbol" : G;
    }
    function X(Z) {
      if (typeof Z > "u" || Z === null)
        return "" + Z;
      var G = V(Z);
      if (G === "object") {
        if (Z instanceof Date)
          return "date";
        if (Z instanceof RegExp)
          return "regexp";
      }
      return G;
    }
    function U(Z) {
      var G = X(Z);
      switch (G) {
        case "array":
        case "object":
          return "an " + G;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + G;
        default:
          return G;
      }
    }
    function H(Z) {
      return !Z.constructor || !Z.constructor.name ? g : Z.constructor.name;
    }
    return y.checkPropTypes = a, y.resetWarningCache = a.resetWarningCache, y.PropTypes = y, y;
  }, Xm;
}
var Jm, U1;
function FI() {
  if (U1) return Jm;
  U1 = 1;
  var e = /* @__PURE__ */ Zg();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Jm = function() {
    function o(l, c, d, p, f, h) {
      if (h !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    o.isRequired = o;
    function a() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: a,
      element: o,
      elementType: o,
      instanceOf: a,
      node: o,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Jm;
}
var H1;
function LI() {
  if (H1) return dd.exports;
  if (H1 = 1, process.env.NODE_ENV !== "production") {
    var e = t2(), t = !0;
    dd.exports = /* @__PURE__ */ _I()(e.isElement, t);
  } else
    dd.exports = /* @__PURE__ */ FI()();
  return dd.exports;
}
var BI = /* @__PURE__ */ LI();
const n = /* @__PURE__ */ e2(BI);
function G1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function q1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G1(Object(r), !0).forEach(function(o) {
      n2(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G1(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function jd(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jd = function(t) {
    return typeof t;
  } : jd = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jd(e);
}
function n2(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function zd(e, t) {
  return DI(e) || jI(e, t) || zI(e, t) || VI();
}
function DI(e) {
  if (Array.isArray(e)) return e;
}
function jI(e, t) {
  var r = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (r != null) {
    var o = [], a = !0, i = !1, l, c;
    try {
      for (r = r.call(e); !(a = (l = r.next()).done) && (o.push(l.value), !(t && o.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, c = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw c;
      }
    }
    return o;
  }
}
function zI(e, t) {
  if (e) {
    if (typeof e == "string") return K1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return K1(e, t);
  }
}
function K1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = new Array(t); r < t; r++) o[r] = e[r];
  return o;
}
function VI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Xh = function(t) {
  var r = N.useRef(t);
  return N.useEffect(function() {
    r.current = t;
  }, [t]), r.current;
}, xl = function(t) {
  return t !== null && jd(t) === "object";
}, WI = function(t) {
  return xl(t) && typeof t.then == "function";
}, UI = function(t) {
  return xl(t) && typeof t.elements == "function" && typeof t.createToken == "function" && typeof t.createPaymentMethod == "function" && typeof t.confirmCardPayment == "function";
}, Y1 = "[object Object]", HI = function e(t, r) {
  if (!xl(t) || !xl(r))
    return t === r;
  var o = Array.isArray(t), a = Array.isArray(r);
  if (o !== a) return !1;
  var i = Object.prototype.toString.call(t) === Y1, l = Object.prototype.toString.call(r) === Y1;
  if (i !== l) return !1;
  if (!i && !o) return t === r;
  var c = Object.keys(t), d = Object.keys(r);
  if (c.length !== d.length) return !1;
  for (var p = {}, f = 0; f < c.length; f += 1)
    p[c[f]] = !0;
  for (var h = 0; h < d.length; h += 1)
    p[d[h]] = !0;
  var g = Object.keys(p);
  if (g.length !== c.length)
    return !1;
  var y = t, C = r, b = function(T) {
    return e(y[T], C[T]);
  };
  return g.every(b);
}, o2 = function(t, r, o) {
  return xl(t) ? Object.keys(t).reduce(function(a, i) {
    var l = !xl(r) || !HI(t[i], r[i]);
    return o.includes(i) ? (l && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), a) : l ? q1(q1({}, a || {}), {}, n2({}, i, t[i])) : a;
  }, null) : null;
}, GI = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", Z1 = function(t) {
  if (t === null || UI(t))
    return t;
  throw new Error(GI);
}, qI = function(t) {
  if (WI(t))
    return {
      tag: "async",
      stripePromise: Promise.resolve(t).then(Z1)
    };
  var r = Z1(t);
  return r === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: r
  };
}, Xg = /* @__PURE__ */ N.createContext(null);
Xg.displayName = "ElementsContext";
var KI = function(t, r) {
  if (!t)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(r, " in an <Elements> provider."));
  return t;
}, Jg = /* @__PURE__ */ N.createContext(null);
Jg.displayName = "CartElementContext";
var YI = function(t, r) {
  if (!t)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(r, " in an <Elements> provider."));
  return t;
}, a2 = function(t) {
  var r = t.stripe, o = t.options, a = t.children, i = N.useMemo(function() {
    return qI(r);
  }, [r]), l = N.useState(null), c = zd(l, 2), d = c[0], p = c[1], f = N.useState(null), h = zd(f, 2), g = h[0], y = h[1], C = N.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(o) : null
    };
  }), b = zd(C, 2), v = b[0], T = b[1];
  N.useEffect(function() {
    var E = !0, S = function(A) {
      T(function(_) {
        return _.stripe ? _ : {
          stripe: A,
          elements: A.elements(o)
        };
      });
    };
    return i.tag === "async" && !v.stripe ? i.stripePromise.then(function(k) {
      k && E && S(k);
    }) : i.tag === "sync" && !v.stripe && S(i.stripe), function() {
      E = !1;
    };
  }, [i, v, o]);
  var R = Xh(r);
  N.useEffect(function() {
    R !== null && R !== r && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [R, r]);
  var $ = Xh(o);
  return N.useEffect(function() {
    if (v.elements) {
      var E = o2(o, $, ["clientSecret", "fonts"]);
      E && v.elements.update(E);
    }
  }, [o, $, v.elements]), N.useEffect(function() {
    var E = v.stripe;
    !E || !E._registerWrapper || !E.registerAppInfo || (E._registerWrapper({
      name: "react-stripe-js",
      version: "1.16.5"
    }), E.registerAppInfo({
      name: "react-stripe-js",
      version: "1.16.5",
      url: "https://stripe.com/docs/stripe-js/react"
    }));
  }, [v.stripe]), /* @__PURE__ */ N.createElement(Xg.Provider, {
    value: v
  }, /* @__PURE__ */ N.createElement(Jg.Provider, {
    value: {
      cart: d,
      setCart: p,
      cartState: g,
      setCartState: y
    }
  }, a));
};
a2.propTypes = {
  stripe: n.any,
  options: n.object
};
var op = function(t) {
  var r = N.useContext(Xg);
  return KI(r, t);
}, X1 = function(t) {
  var r = N.useContext(Jg);
  return YI(r, t);
}, ZI = function() {
  var t = op("calls useElements()"), r = t.elements;
  return r;
}, XI = function() {
  var t = op("calls useStripe()"), r = t.stripe;
  return r;
};
n.func.isRequired;
var An = function(t, r, o) {
  var a = !!o, i = N.useRef(o);
  N.useEffect(function() {
    i.current = o;
  }, [o]), N.useEffect(function() {
    if (!a || !t)
      return function() {
      };
    var l = function() {
      i.current && i.current.apply(i, arguments);
    };
    return t.on(r, l), function() {
      t.off(r, l);
    };
  }, [a, r, t, i]);
}, JI = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, rn = function(t, r) {
  var o = "".concat(JI(t), "Element"), a = function(d) {
    var p = d.id, f = d.className, h = d.options, g = h === void 0 ? {} : h, y = d.onBlur, C = d.onFocus, b = d.onReady, v = d.onChange, T = d.onEscape, R = d.onClick, $ = d.onLoadError, E = d.onLoaderStart, S = d.onNetworksChange, k = d.onCheckout, A = d.onLineItemClick, _ = d.onConfirm, L = d.onCancel, O = d.onShippingAddressChange, F = d.onShippingRateChange, B = op("mounts <".concat(o, ">")), M = B.elements, j = N.useState(null), W = zd(j, 2), V = W[0], X = W[1], U = N.useRef(null), H = N.useRef(null), Z = X1("mounts <".concat(o, ">")), G = Z.setCart, ye = Z.setCartState;
    An(V, "blur", y), An(V, "focus", C), An(V, "escape", T), An(V, "click", R), An(V, "loaderror", $), An(V, "loaderstart", E), An(V, "networkschange", S), An(V, "lineitemclick", A), An(V, "confirm", _), An(V, "cancel", L), An(V, "shippingaddresschange", O), An(V, "shippingratechange", F);
    var de;
    t === "cart" ? de = function(ce) {
      ye(ce), b && b(ce);
    } : b && (t === "payButton" ? de = b : de = function() {
      b(V);
    }), An(V, "ready", de);
    var ne = t === "cart" ? function(oe) {
      ye(oe), v && v(oe);
    } : v;
    An(V, "change", ne);
    var fe = t === "cart" ? function(oe) {
      ye(oe), k && k(oe);
    } : k;
    An(V, "checkout", fe), N.useLayoutEffect(function() {
      if (U.current === null && M && H.current !== null) {
        var oe = M.create(t, g);
        t === "cart" && G && G(oe), U.current = oe, X(oe), oe.mount(H.current);
      }
    }, [M, g, G]);
    var ie = Xh(g);
    return N.useEffect(function() {
      if (U.current) {
        var oe = o2(g, ie, ["paymentRequest"]);
        oe && U.current.update(oe);
      }
    }, [g, ie]), N.useLayoutEffect(function() {
      return function() {
        U.current && (U.current.destroy(), U.current = null);
      };
    }, []), /* @__PURE__ */ N.createElement("div", {
      id: p,
      className: f,
      ref: H
    });
  }, i = function(d) {
    op("mounts <".concat(o, ">")), X1("mounts <".concat(o, ">"));
    var p = d.id, f = d.className;
    return /* @__PURE__ */ N.createElement("div", {
      id: p,
      className: f
    });
  }, l = r ? i : a;
  return l.propTypes = {
    id: n.string,
    className: n.string,
    onChange: n.func,
    onBlur: n.func,
    onFocus: n.func,
    onReady: n.func,
    onEscape: n.func,
    onClick: n.func,
    onLoadError: n.func,
    onLoaderStart: n.func,
    onNetworksChange: n.func,
    onCheckout: n.func,
    onLineItemClick: n.func,
    onConfirm: n.func,
    onCancel: n.func,
    onShippingAddressChange: n.func,
    onShippingRateChange: n.func,
    options: n.object
  }, l.displayName = o, l.__elementType = t, l;
}, nn = typeof window > "u";
rn("auBankAccount", nn);
rn("card", nn);
rn("cardNumber", nn);
rn("cardExpiry", nn);
rn("cardCvc", nn);
rn("fpxBank", nn);
rn("iban", nn);
rn("idealBank", nn);
rn("p24Bank", nn);
rn("epsBank", nn);
var QI = rn("payment", nn);
rn("payButton", nn);
rn("paymentRequestButton", nn);
rn("linkAuthentication", nn);
rn("address", nn);
rn("shippingAddress", nn);
rn("cart", nn);
rn("paymentMethodMessaging", nn);
rn("affirmMessage", nn);
rn("afterpayClearpayMessage", nn);
var i2 = "https://js.stripe.com/v3", e8 = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var t8 = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(i2, '"]')), r = 0; r < t.length; r++) {
    var o = t[r];
    if (e8.test(o.src))
      return o;
  }
  return null;
}, r8 = function(t) {
  var r = "", o = document.createElement("script");
  o.src = "".concat(i2).concat(r);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(o), o;
}, n8 = function(t, r) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "1.54.2",
    startTime: r
  });
}, fd = null, o8 = function(t) {
  return fd !== null || (fd = new Promise(function(r, o) {
    if (typeof window > "u" || typeof document > "u") {
      r(null);
      return;
    }
    if (window.Stripe) {
      r(window.Stripe);
      return;
    }
    try {
      var a = t8();
      a && t || a || (a = r8(t)), a.addEventListener("load", function() {
        window.Stripe ? r(window.Stripe) : o(new Error("Stripe.js not available"));
      }), a.addEventListener("error", function() {
        o(new Error("Failed to load Stripe.js"));
      });
    } catch (i) {
      o(i);
      return;
    }
  })), fd;
}, a8 = function(t, r, o) {
  if (t === null)
    return null;
  var a = t.apply(void 0, r);
  return n8(a, o), a;
}, s2 = Promise.resolve().then(function() {
  return o8(null);
}), l2 = !1;
s2.catch(function(e) {
  l2 || console.warn(e);
});
var i8 = function() {
  for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
    r[o] = arguments[o];
  l2 = !0;
  var a = Date.now();
  return s2.then(function(i) {
    return a8(i, r, a);
  });
};
const Cl = {
  black: "#000",
  white: "#fff"
}, Ji = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, s8 = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, Qi = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, l8 = {
  50: "#ede7f6",
  100: "#d1c4e9",
  200: "#b39ddb",
  300: "#9575cd",
  400: "#7e57c2",
  500: "#673ab7",
  600: "#5e35b1",
  700: "#512da8",
  800: "#4527a0",
  900: "#311b92",
  A100: "#b388ff",
  A200: "#7c4dff",
  A400: "#651fff",
  A700: "#6200ea"
}, c8 = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, es = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, ts = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, u8 = {
  50: "#e0f7fa",
  100: "#b2ebf2",
  200: "#80deea",
  300: "#4dd0e1",
  400: "#26c6da",
  500: "#00bcd4",
  600: "#00acc1",
  700: "#0097a7",
  800: "#00838f",
  900: "#006064",
  A100: "#84ffff",
  A200: "#18ffff",
  A400: "#00e5ff",
  A700: "#00b8d4"
}, d8 = {
  50: "#e0f2f1",
  100: "#b2dfdb",
  200: "#80cbc4",
  300: "#4db6ac",
  400: "#26a69a",
  500: "#009688",
  600: "#00897b",
  700: "#00796b",
  800: "#00695c",
  900: "#004d40",
  A100: "#a7ffeb",
  A200: "#64ffda",
  A400: "#1de9b6",
  A700: "#00bfa5"
}, rs = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, p8 = {
  50: "#f1f8e9",
  100: "#dcedc8",
  200: "#c5e1a5",
  300: "#aed581",
  400: "#9ccc65",
  500: "#8bc34a",
  600: "#7cb342",
  700: "#689f38",
  800: "#558b2f",
  900: "#33691e",
  A100: "#ccff90",
  A200: "#b2ff59",
  A400: "#76ff03",
  A700: "#64dd17"
}, f8 = {
  50: "#f9fbe7",
  100: "#f0f4c3",
  200: "#e6ee9c",
  300: "#dce775",
  400: "#d4e157",
  500: "#cddc39",
  600: "#c0ca33",
  700: "#afb42b",
  800: "#9e9d24",
  900: "#827717",
  A100: "#f4ff81",
  A200: "#eeff41",
  A400: "#c6ff00",
  A700: "#aeea00"
}, m8 = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
}, h8 = {
  50: "#fff8e1",
  100: "#ffecb3",
  200: "#ffe082",
  300: "#ffd54f",
  400: "#ffca28",
  500: "#ffc107",
  600: "#ffb300",
  700: "#ffa000",
  800: "#ff8f00",
  900: "#ff6f00",
  A100: "#ffe57f",
  A200: "#ffd740",
  A400: "#ffc400",
  A700: "#ffab00"
}, nl = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, g8 = {
  50: "#fbe9e7",
  100: "#ffccbc",
  200: "#ffab91",
  300: "#ff8a65",
  400: "#ff7043",
  500: "#ff5722",
  600: "#f4511e",
  700: "#e64a19",
  800: "#d84315",
  900: "#bf360c",
  A100: "#ff9e80",
  A200: "#ff6e40",
  A400: "#ff3d00",
  A700: "#dd2c00"
}, b8 = {
  50: "#efebe9",
  100: "#d7ccc8",
  200: "#bcaaa4",
  300: "#a1887f",
  400: "#8d6e63",
  500: "#795548",
  600: "#6d4c41",
  700: "#5d4037",
  800: "#4e342e",
  900: "#3e2723",
  A100: "#d7ccc8",
  A200: "#bcaaa4",
  A400: "#8d6e63",
  A700: "#5d4037"
}, c2 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, y8 = {
  50: "#eceff1",
  100: "#cfd8dc",
  200: "#b0bec5",
  300: "#90a4ae",
  400: "#78909c",
  500: "#607d8b",
  600: "#546e7a",
  700: "#455a64",
  800: "#37474f",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
}, v8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amber: h8,
  blue: es,
  blueGrey: y8,
  brown: b8,
  common: Cl,
  cyan: u8,
  deepOrange: g8,
  deepPurple: l8,
  green: rs,
  grey: c2,
  indigo: c8,
  lightBlue: ts,
  lightGreen: p8,
  lime: f8,
  orange: nl,
  pink: s8,
  purple: Qi,
  red: Ji,
  teal: d8,
  yellow: m8
}, Symbol.toStringTag, { value: "Module" }));
function jn(e, ...t) {
  const r = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((o) => r.searchParams.append("args[]", o)), `Minified MUI error #${e}; visit ${r} for the full message.`;
}
const wo = "$$material";
function Ea() {
  return Ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var o in r) ({}).hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Ea.apply(null, arguments);
}
function x8(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function C8(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var u2 = /* @__PURE__ */ function() {
  function e(r) {
    var o = this;
    this._insertTag = function(a) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(a, i), o.tags.push(a);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(C8(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = x8(a);
      try {
        i.insertRule(o, i.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      var a;
      return (a = o.parentNode) == null ? void 0 : a.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), wn = "-ms-", ap = "-moz-", nr = "-webkit-", d2 = "comm", Qg = "rule", eb = "decl", S8 = "@import", p2 = "@keyframes", w8 = "@layer", T8 = Math.abs, jp = String.fromCharCode, E8 = Object.assign;
function O8(e, t) {
  return xn(e, 0) ^ 45 ? (((t << 2 ^ xn(e, 0)) << 2 ^ xn(e, 1)) << 2 ^ xn(e, 2)) << 2 ^ xn(e, 3) : 0;
}
function f2(e) {
  return e.trim();
}
function $8(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function or(e, t, r) {
  return e.replace(t, r);
}
function Jh(e, t) {
  return e.indexOf(t);
}
function xn(e, t) {
  return e.charCodeAt(t) | 0;
}
function Lc(e, t, r) {
  return e.slice(t, r);
}
function ba(e) {
  return e.length;
}
function tb(e) {
  return e.length;
}
function md(e, t) {
  return t.push(e), e;
}
function R8(e, t) {
  return e.map(t).join("");
}
var zp = 1, Sl = 1, m2 = 0, Jn = 0, Qr = 0, Ll = "";
function Vp(e, t, r, o, a, i, l) {
  return { value: e, root: t, parent: r, type: o, props: a, children: i, line: zp, column: Sl, length: l, return: "" };
}
function cc(e, t) {
  return E8(Vp("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function P8() {
  return Qr;
}
function k8() {
  return Qr = Jn > 0 ? xn(Ll, --Jn) : 0, Sl--, Qr === 10 && (Sl = 1, zp--), Qr;
}
function To() {
  return Qr = Jn < m2 ? xn(Ll, Jn++) : 0, Sl++, Qr === 10 && (Sl = 1, zp++), Qr;
}
function Sa() {
  return xn(Ll, Jn);
}
function Vd() {
  return Jn;
}
function ru(e, t) {
  return Lc(Ll, e, t);
}
function Bc(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function h2(e) {
  return zp = Sl = 1, m2 = ba(Ll = e), Jn = 0, [];
}
function g2(e) {
  return Ll = "", e;
}
function Wd(e) {
  return f2(ru(Jn - 1, Qh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function A8(e) {
  for (; (Qr = Sa()) && Qr < 33; )
    To();
  return Bc(e) > 2 || Bc(Qr) > 3 ? "" : " ";
}
function I8(e, t) {
  for (; --t && To() && !(Qr < 48 || Qr > 102 || Qr > 57 && Qr < 65 || Qr > 70 && Qr < 97); )
    ;
  return ru(e, Vd() + (t < 6 && Sa() == 32 && To() == 32));
}
function Qh(e) {
  for (; To(); )
    switch (Qr) {
      // ] ) " '
      case e:
        return Jn;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Qh(Qr);
        break;
      // (
      case 40:
        e === 41 && Qh(e);
        break;
      // \
      case 92:
        To();
        break;
    }
  return Jn;
}
function N8(e, t) {
  for (; To() && e + Qr !== 57; )
    if (e + Qr === 84 && Sa() === 47)
      break;
  return "/*" + ru(t, Jn - 1) + "*" + jp(e === 47 ? e : To());
}
function M8(e) {
  for (; !Bc(Sa()); )
    To();
  return ru(e, Jn);
}
function _8(e) {
  return g2(Ud("", null, null, null, [""], e = h2(e), 0, [0], e));
}
function Ud(e, t, r, o, a, i, l, c, d) {
  for (var p = 0, f = 0, h = l, g = 0, y = 0, C = 0, b = 1, v = 1, T = 1, R = 0, $ = "", E = a, S = i, k = o, A = $; v; )
    switch (C = R, R = To()) {
      // (
      case 40:
        if (C != 108 && xn(A, h - 1) == 58) {
          Jh(A += or(Wd(R), "&", "&\f"), "&\f") != -1 && (T = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        A += Wd(R);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        A += A8(C);
        break;
      // \
      case 92:
        A += I8(Vd() - 1, 7);
        continue;
      // /
      case 47:
        switch (Sa()) {
          case 42:
          case 47:
            md(F8(N8(To(), Vd()), t, r), d);
            break;
          default:
            A += "/";
        }
        break;
      // {
      case 123 * b:
        c[p++] = ba(A) * T;
      // } ; \0
      case 125 * b:
      case 59:
      case 0:
        switch (R) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + f:
            T == -1 && (A = or(A, /\f/g, "")), y > 0 && ba(A) - h && md(y > 32 ? Q1(A + ";", o, r, h - 1) : Q1(or(A, " ", "") + ";", o, r, h - 2), d);
            break;
          // @ ;
          case 59:
            A += ";";
          // { rule/at-rule
          default:
            if (md(k = J1(A, t, r, p, f, a, c, $, E = [], S = [], h), i), R === 123)
              if (f === 0)
                Ud(A, t, k, k, E, i, h, c, S);
              else
                switch (g === 99 && xn(A, 3) === 110 ? 100 : g) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ud(e, k, k, o && md(J1(e, k, k, 0, 0, a, c, $, a, E = [], h), S), a, S, h, c, o ? E : S);
                    break;
                  default:
                    Ud(A, k, k, k, [""], S, 0, c, S);
                }
        }
        p = f = y = 0, b = T = 1, $ = A = "", h = l;
        break;
      // :
      case 58:
        h = 1 + ba(A), y = C;
      default:
        if (b < 1) {
          if (R == 123)
            --b;
          else if (R == 125 && b++ == 0 && k8() == 125)
            continue;
        }
        switch (A += jp(R), R * b) {
          // &
          case 38:
            T = f > 0 ? 1 : (A += "\f", -1);
            break;
          // ,
          case 44:
            c[p++] = (ba(A) - 1) * T, T = 1;
            break;
          // @
          case 64:
            Sa() === 45 && (A += Wd(To())), g = Sa(), f = h = ba($ = A += M8(Vd())), R++;
            break;
          // -
          case 45:
            C === 45 && ba(A) == 2 && (b = 0);
        }
    }
  return i;
}
function J1(e, t, r, o, a, i, l, c, d, p, f) {
  for (var h = a - 1, g = a === 0 ? i : [""], y = tb(g), C = 0, b = 0, v = 0; C < o; ++C)
    for (var T = 0, R = Lc(e, h + 1, h = T8(b = l[C])), $ = e; T < y; ++T)
      ($ = f2(b > 0 ? g[T] + " " + R : or(R, /&\f/g, g[T]))) && (d[v++] = $);
  return Vp(e, t, r, a === 0 ? Qg : c, d, p, f);
}
function F8(e, t, r) {
  return Vp(e, t, r, d2, jp(P8()), Lc(e, 2, -2), 0);
}
function Q1(e, t, r, o) {
  return Vp(e, t, r, eb, Lc(e, 0, o), Lc(e, o + 1, -1), o);
}
function fl(e, t) {
  for (var r = "", o = tb(e), a = 0; a < o; a++)
    r += t(e[a], a, e, t) || "";
  return r;
}
function L8(e, t, r, o) {
  switch (e.type) {
    case w8:
      if (e.children.length) break;
    case S8:
    case eb:
      return e.return = e.return || e.value;
    case d2:
      return "";
    case p2:
      return e.return = e.value + "{" + fl(e.children, o) + "}";
    case Qg:
      e.value = e.props.join(",");
  }
  return ba(r = fl(e.children, o)) ? e.return = e.value + "{" + r + "}" : "";
}
function B8(e) {
  var t = tb(e);
  return function(r, o, a, i) {
    for (var l = "", c = 0; c < t; c++)
      l += e[c](r, o, a, i) || "";
    return l;
  };
}
function D8(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function b2(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var j8 = function(t, r, o) {
  for (var a = 0, i = 0; a = i, i = Sa(), a === 38 && i === 12 && (r[o] = 1), !Bc(i); )
    To();
  return ru(t, Jn);
}, z8 = function(t, r) {
  var o = -1, a = 44;
  do
    switch (Bc(a)) {
      case 0:
        a === 38 && Sa() === 12 && (r[o] = 1), t[o] += j8(Jn - 1, r, o);
        break;
      case 2:
        t[o] += Wd(a);
        break;
      case 4:
        if (a === 44) {
          t[++o] = Sa() === 58 ? "&\f" : "", r[o] = t[o].length;
          break;
        }
      // fallthrough
      default:
        t[o] += jp(a);
    }
  while (a = To());
  return t;
}, V8 = function(t, r) {
  return g2(z8(h2(t), r));
}, ex = /* @__PURE__ */ new WeakMap(), W8 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, o = t.parent, a = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !ex.get(o)) && !a) {
      ex.set(t, !0);
      for (var i = [], l = V8(r, i), c = o.props, d = 0, p = 0; d < l.length; d++)
        for (var f = 0; f < c.length; f++, p++)
          t.props[p] = i[d] ? l[d].replace(/&\f/g, c[f]) : c[f] + " " + l[d];
    }
  }
}, U8 = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function y2(e, t) {
  switch (O8(e, t)) {
    // color-adjust
    case 5103:
      return nr + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return nr + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return nr + e + ap + e + wn + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return nr + e + wn + e + e;
    // order
    case 6165:
      return nr + e + wn + "flex-" + e + e;
    // align-items
    case 5187:
      return nr + e + or(e, /(\w+).+(:[^]+)/, nr + "box-$1$2" + wn + "flex-$1$2") + e;
    // align-self
    case 5443:
      return nr + e + wn + "flex-item-" + or(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return nr + e + wn + "flex-line-pack" + or(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return nr + e + wn + or(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return nr + e + wn + or(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return nr + "box-" + or(e, "-grow", "") + nr + e + wn + or(e, "grow", "positive") + e;
    // transition
    case 4554:
      return nr + or(e, /([^-])(transform)/g, "$1" + nr + "$2") + e;
    // cursor
    case 6187:
      return or(or(or(e, /(zoom-|grab)/, nr + "$1"), /(image-set)/, nr + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return or(e, /(image-set\([^]*)/, nr + "$1$`$1");
    // justify-content
    case 4968:
      return or(or(e, /(.+:)(flex-)?(.*)/, nr + "box-pack:$3" + wn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + nr + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return or(e, /(.+)-inline(.+)/, nr + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ba(e) - 1 - t > 6) switch (xn(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (xn(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return or(e, /(.+:)(.+)-([^]+)/, "$1" + nr + "$2-$3$1" + ap + (xn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~Jh(e, "stretch") ? y2(or(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (xn(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (xn(e, ba(e) - 3 - (~Jh(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return or(e, ":", ":" + nr) + e;
        // (inline-)?fl(e)x
        case 101:
          return or(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + nr + (xn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + nr + "$2$3$1" + wn + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (xn(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return nr + e + wn + or(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return nr + e + wn + or(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return nr + e + wn + or(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return nr + e + wn + e + e;
  }
  return e;
}
var H8 = function(t, r, o, a) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case eb:
      t.return = y2(t.value, t.length);
      break;
    case p2:
      return fl([cc(t, {
        value: or(t.value, "@", "@" + nr)
      })], a);
    case Qg:
      if (t.length) return R8(t.props, function(i) {
        switch ($8(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return fl([cc(t, {
              props: [or(i, /:(read-\w+)/, ":" + ap + "$1")]
            })], a);
          // :placeholder
          case "::placeholder":
            return fl([cc(t, {
              props: [or(i, /:(plac\w+)/, ":" + nr + "input-$1")]
            }), cc(t, {
              props: [or(i, /:(plac\w+)/, ":" + ap + "$1")]
            }), cc(t, {
              props: [or(i, /:(plac\w+)/, wn + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, G8 = [H8], v2 = function(t) {
  var r = t.key;
  if (r === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(b) {
      var v = b.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || G8, i = {}, l, c = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(b) {
      for (var v = b.getAttribute("data-emotion").split(" "), T = 1; T < v.length; T++)
        i[v[T]] = !0;
      c.push(b);
    }
  );
  var d, p = [W8, U8];
  {
    var f, h = [L8, D8(function(b) {
      f.insert(b);
    })], g = B8(p.concat(a, h)), y = function(v) {
      return fl(_8(v), g);
    };
    d = function(v, T, R, $) {
      f = R, y(v ? v + "{" + T.styles + "}" : T.styles), $ && (C.inserted[T.name] = !0);
    };
  }
  var C = {
    key: r,
    sheet: new u2({
      key: r,
      container: l,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return C.sheet.hydrate(c), C;
}, hd = { exports: {} }, lr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tx;
function q8() {
  if (tx) return lr;
  tx = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function $(S) {
    if (typeof S == "object" && S !== null) {
      var k = S.$$typeof;
      switch (k) {
        case t:
          switch (S = S.type, S) {
            case d:
            case p:
            case o:
            case i:
            case a:
            case h:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case c:
                case f:
                case C:
                case y:
                case l:
                  return S;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  function E(S) {
    return $(S) === p;
  }
  return lr.AsyncMode = d, lr.ConcurrentMode = p, lr.ContextConsumer = c, lr.ContextProvider = l, lr.Element = t, lr.ForwardRef = f, lr.Fragment = o, lr.Lazy = C, lr.Memo = y, lr.Portal = r, lr.Profiler = i, lr.StrictMode = a, lr.Suspense = h, lr.isAsyncMode = function(S) {
    return E(S) || $(S) === d;
  }, lr.isConcurrentMode = E, lr.isContextConsumer = function(S) {
    return $(S) === c;
  }, lr.isContextProvider = function(S) {
    return $(S) === l;
  }, lr.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, lr.isForwardRef = function(S) {
    return $(S) === f;
  }, lr.isFragment = function(S) {
    return $(S) === o;
  }, lr.isLazy = function(S) {
    return $(S) === C;
  }, lr.isMemo = function(S) {
    return $(S) === y;
  }, lr.isPortal = function(S) {
    return $(S) === r;
  }, lr.isProfiler = function(S) {
    return $(S) === i;
  }, lr.isStrictMode = function(S) {
    return $(S) === a;
  }, lr.isSuspense = function(S) {
    return $(S) === h;
  }, lr.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === o || S === p || S === i || S === a || S === h || S === g || typeof S == "object" && S !== null && (S.$$typeof === C || S.$$typeof === y || S.$$typeof === l || S.$$typeof === c || S.$$typeof === f || S.$$typeof === v || S.$$typeof === T || S.$$typeof === R || S.$$typeof === b);
  }, lr.typeOf = $, lr;
}
var cr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rx;
function K8() {
  return rx || (rx = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function $(J) {
      return typeof J == "string" || typeof J == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      J === o || J === p || J === i || J === a || J === h || J === g || typeof J == "object" && J !== null && (J.$$typeof === C || J.$$typeof === y || J.$$typeof === l || J.$$typeof === c || J.$$typeof === f || J.$$typeof === v || J.$$typeof === T || J.$$typeof === R || J.$$typeof === b);
    }
    function E(J) {
      if (typeof J == "object" && J !== null) {
        var Ie = J.$$typeof;
        switch (Ie) {
          case t:
            var le = J.type;
            switch (le) {
              case d:
              case p:
              case o:
              case i:
              case a:
              case h:
                return le;
              default:
                var qe = le && le.$$typeof;
                switch (qe) {
                  case c:
                  case f:
                  case C:
                  case y:
                  case l:
                    return qe;
                  default:
                    return Ie;
                }
            }
          case r:
            return Ie;
        }
      }
    }
    var S = d, k = p, A = c, _ = l, L = t, O = f, F = o, B = C, M = y, j = r, W = i, V = a, X = h, U = !1;
    function H(J) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Z(J) || E(J) === d;
    }
    function Z(J) {
      return E(J) === p;
    }
    function G(J) {
      return E(J) === c;
    }
    function ye(J) {
      return E(J) === l;
    }
    function de(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function ne(J) {
      return E(J) === f;
    }
    function fe(J) {
      return E(J) === o;
    }
    function ie(J) {
      return E(J) === C;
    }
    function oe(J) {
      return E(J) === y;
    }
    function ce(J) {
      return E(J) === r;
    }
    function Ce(J) {
      return E(J) === i;
    }
    function xe(J) {
      return E(J) === a;
    }
    function Re(J) {
      return E(J) === h;
    }
    cr.AsyncMode = S, cr.ConcurrentMode = k, cr.ContextConsumer = A, cr.ContextProvider = _, cr.Element = L, cr.ForwardRef = O, cr.Fragment = F, cr.Lazy = B, cr.Memo = M, cr.Portal = j, cr.Profiler = W, cr.StrictMode = V, cr.Suspense = X, cr.isAsyncMode = H, cr.isConcurrentMode = Z, cr.isContextConsumer = G, cr.isContextProvider = ye, cr.isElement = de, cr.isForwardRef = ne, cr.isFragment = fe, cr.isLazy = ie, cr.isMemo = oe, cr.isPortal = ce, cr.isProfiler = Ce, cr.isStrictMode = xe, cr.isSuspense = Re, cr.isValidElementType = $, cr.typeOf = E;
  }()), cr;
}
var nx;
function Y8() {
  return nx || (nx = 1, process.env.NODE_ENV === "production" ? hd.exports = q8() : hd.exports = K8()), hd.exports;
}
var Qm, ox;
function Z8() {
  if (ox) return Qm;
  ox = 1;
  var e = Y8(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = o, i[e.Memo] = a;
  function l(C) {
    return e.isMemo(C) ? a : i[C.$$typeof] || t;
  }
  var c = Object.defineProperty, d = Object.getOwnPropertyNames, p = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, h = Object.getPrototypeOf, g = Object.prototype;
  function y(C, b, v) {
    if (typeof b != "string") {
      if (g) {
        var T = h(b);
        T && T !== g && y(C, T, v);
      }
      var R = d(b);
      p && (R = R.concat(p(b)));
      for (var $ = l(C), E = l(b), S = 0; S < R.length; ++S) {
        var k = R[S];
        if (!r[k] && !(v && v[k]) && !(E && E[k]) && !($ && $[k])) {
          var A = f(b, k);
          try {
            c(C, k, A);
          } catch {
          }
        }
      }
    }
    return C;
  }
  return Qm = y, Qm;
}
Z8();
var X8 = !0;
function x2(e, t, r) {
  var o = "";
  return r.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : a && (o += a + " ");
  }), o;
}
var rb = function(t, r, o) {
  var a = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  X8 === !1) && t.registered[a] === void 0 && (t.registered[a] = r.styles);
}, nb = function(t, r, o) {
  rb(t, r, o);
  var a = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var i = r;
    do
      t.insert(r === i ? "." + a : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function J8(e) {
  for (var t = 0, r, o = 0, a = e.length; a >= 4; ++o, a -= 4)
    r = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Q8 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, e9 = /[A-Z]|^ms/g, t9 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, C2 = function(t) {
  return t.charCodeAt(1) === 45;
}, ax = function(t) {
  return t != null && typeof t != "boolean";
}, eh = /* @__PURE__ */ b2(function(e) {
  return C2(e) ? e : e.replace(e9, "-$&").toLowerCase();
}), ix = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(t9, function(o, a, i) {
          return ya = {
            name: a,
            styles: i,
            next: ya
          }, a;
        });
  }
  return Q8[t] !== 1 && !C2(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function Dc(e, t, r) {
  if (r == null)
    return "";
  var o = r;
  if (o.__emotion_styles !== void 0)
    return o;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var a = r;
      if (a.anim === 1)
        return ya = {
          name: a.name,
          styles: a.styles,
          next: ya
        }, a.name;
      var i = r;
      if (i.styles !== void 0) {
        var l = i.next;
        if (l !== void 0)
          for (; l !== void 0; )
            ya = {
              name: l.name,
              styles: l.styles,
              next: ya
            }, l = l.next;
        var c = i.styles + ";";
        return c;
      }
      return r9(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var d = ya, p = r(e);
        return ya = d, Dc(e, t, p);
      }
      break;
    }
  }
  var f = r;
  if (t == null)
    return f;
  var h = t[f];
  return h !== void 0 ? h : f;
}
function r9(e, t, r) {
  var o = "";
  if (Array.isArray(r))
    for (var a = 0; a < r.length; a++)
      o += Dc(e, t, r[a]) + ";";
  else
    for (var i in r) {
      var l = r[i];
      if (typeof l != "object") {
        var c = l;
        t != null && t[c] !== void 0 ? o += i + "{" + t[c] + "}" : ax(c) && (o += eh(i) + ":" + ix(i, c) + ";");
      } else if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
        for (var d = 0; d < l.length; d++)
          ax(l[d]) && (o += eh(i) + ":" + ix(i, l[d]) + ";");
      else {
        var p = Dc(e, t, l);
        switch (i) {
          case "animation":
          case "animationName": {
            o += eh(i) + ":" + p + ";";
            break;
          }
          default:
            o += i + "{" + p + "}";
        }
      }
    }
  return o;
}
var sx = /label:\s*([^\s;{]+)\s*(;|$)/g, ya;
function nu(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, a = "";
  ya = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    o = !1, a += Dc(r, t, i);
  else {
    var l = i;
    a += l[0];
  }
  for (var c = 1; c < e.length; c++)
    if (a += Dc(r, t, e[c]), o) {
      var d = i;
      a += d[c];
    }
  sx.lastIndex = 0;
  for (var p = "", f; (f = sx.exec(a)) !== null; )
    p += "-" + f[1];
  var h = J8(a) + p;
  return {
    name: h,
    styles: a,
    next: ya
  };
}
var n9 = function(t) {
  return t();
}, S2 = x.useInsertionEffect ? x.useInsertionEffect : !1, w2 = S2 || n9, lx = S2 || x.useLayoutEffect, T2 = /* @__PURE__ */ x.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ v2({
    key: "css"
  }) : null
), o9 = T2.Provider, ob = function(t) {
  return /* @__PURE__ */ Ps(function(r, o) {
    var a = Cs(T2);
    return t(r, a, o);
  });
}, ou = /* @__PURE__ */ x.createContext({}), ab = {}.hasOwnProperty, eg = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", a9 = function(t, r) {
  var o = {};
  for (var a in r)
    ab.call(r, a) && (o[a] = r[a]);
  return o[eg] = t, o;
}, i9 = function(t) {
  var r = t.cache, o = t.serialized, a = t.isStringTag;
  return rb(r, o, a), w2(function() {
    return nb(r, o, a);
  }), null;
}, s9 = /* @__PURE__ */ ob(function(e, t, r) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var a = e[eg], i = [o], l = "";
  typeof e.className == "string" ? l = x2(t.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var c = nu(i, void 0, x.useContext(ou));
  l += t.key + "-" + c.name;
  var d = {};
  for (var p in e)
    ab.call(e, p) && p !== "css" && p !== eg && (d[p] = e[p]);
  return d.className = l, r && (d.ref = r), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(i9, {
    cache: t,
    serialized: c,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ x.createElement(a, d));
}), l9 = s9, cx = function(t, r) {
  var o = arguments;
  if (r == null || !ab.call(r, "css"))
    return x.createElement.apply(void 0, o);
  var a = o.length, i = new Array(a);
  i[0] = l9, i[1] = a9(t, r);
  for (var l = 2; l < a; l++)
    i[l] = o[l];
  return x.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(cx || (cx = {}));
var c9 = /* @__PURE__ */ ob(function(e, t) {
  var r = e.styles, o = nu([r], void 0, x.useContext(ou)), a = x.useRef();
  return lx(function() {
    var i = t.key + "-global", l = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), c = !1, d = document.querySelector('style[data-emotion="' + i + " " + o.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), d !== null && (c = !0, d.setAttribute("data-emotion", i), l.hydrate([d])), a.current = [l, c], function() {
      l.flush();
    };
  }, [t]), lx(function() {
    var i = a.current, l = i[0], c = i[1];
    if (c) {
      i[1] = !1;
      return;
    }
    if (o.next !== void 0 && nb(t, o.next, !0), l.tags.length) {
      var d = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = d, l.flush();
    }
    t.insert("", o, l, !1);
  }, [t, o.name]), null;
});
function oi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return nu(t);
}
function Ro() {
  var e = oi.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var u9 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, d9 = /* @__PURE__ */ b2(
  function(e) {
    return u9.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), p9 = d9, f9 = function(t) {
  return t !== "theme";
}, ux = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? p9 : f9;
}, dx = function(t, r, o) {
  var a;
  if (r) {
    var i = r.shouldForwardProp;
    a = t.__emotion_forwardProp && i ? function(l) {
      return t.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof a != "function" && o && (a = t.__emotion_forwardProp), a;
}, m9 = function(t) {
  var r = t.cache, o = t.serialized, a = t.isStringTag;
  return rb(r, o, a), w2(function() {
    return nb(r, o, a);
  }), null;
}, h9 = function e(t, r) {
  var o = t.__emotion_real === t, a = o && t.__emotion_base || t, i, l;
  r !== void 0 && (i = r.label, l = r.target);
  var c = dx(t, r, o), d = c || ux(a), p = !d("as");
  return function() {
    var f = arguments, h = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && h.push("label:" + i + ";"), f[0] == null || f[0].raw === void 0)
      h.push.apply(h, f);
    else {
      var g = f[0];
      h.push(g[0]);
      for (var y = f.length, C = 1; C < y; C++)
        h.push(f[C], g[C]);
    }
    var b = ob(function(v, T, R) {
      var $ = p && v.as || a, E = "", S = [], k = v;
      if (v.theme == null) {
        k = {};
        for (var A in v)
          k[A] = v[A];
        k.theme = x.useContext(ou);
      }
      typeof v.className == "string" ? E = x2(T.registered, S, v.className) : v.className != null && (E = v.className + " ");
      var _ = nu(h.concat(S), T.registered, k);
      E += T.key + "-" + _.name, l !== void 0 && (E += " " + l);
      var L = p && c === void 0 ? ux($) : d, O = {};
      for (var F in v)
        p && F === "as" || L(F) && (O[F] = v[F]);
      return O.className = E, R && (O.ref = R), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(m9, {
        cache: T,
        serialized: _,
        isStringTag: typeof $ == "string"
      }), /* @__PURE__ */ x.createElement($, O));
    });
    return b.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", b.defaultProps = t.defaultProps, b.__emotion_real = b, b.__emotion_base = a, b.__emotion_styles = h, b.__emotion_forwardProp = c, Object.defineProperty(b, "toString", {
      value: function() {
        return "." + l;
      }
    }), b.withComponent = function(v, T) {
      var R = e(v, Ea({}, r, T, {
        shouldForwardProp: dx(b, T, !0)
      }));
      return R.apply(void 0, h);
    }, b;
  };
}, g9 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], tg = h9.bind(null);
g9.forEach(function(e) {
  tg[e] = tg(e);
});
const th = /* @__PURE__ */ new Map(), b9 = (e, t) => {
  const r = v2(e);
  return r.sheet = new t({
    key: r.key,
    nonce: r.sheet.nonce,
    container: r.sheet.container,
    speedy: r.sheet.isSpeedy,
    prepend: r.sheet.prepend,
    insertionPoint: r.sheet.insertionPoint
  }), r;
};
let Ei;
if (typeof document == "object" && (Ei = document.querySelector('[name="emotion-insertion-point"]'), !Ei)) {
  Ei = document.createElement("meta"), Ei.setAttribute("name", "emotion-insertion-point"), Ei.setAttribute("content", "");
  const e = document.querySelector("head");
  e && e.prepend(Ei);
}
function y9(e, t) {
  if (e || t) {
    class r extends u2 {
      insert(i, l) {
        return this.key && this.key.endsWith("global") && (this.before = Ei), super.insert(i, l);
      }
    }
    const o = b9({
      key: "css",
      insertionPoint: e ? Ei : void 0
    }, r);
    if (t) {
      const a = o.insert;
      o.insert = (...i) => (i[1].styles.match(/^@layer\s+[^{]*$/) || (i[1].styles = `@layer mui {${i[1].styles}}`), a(...i));
    }
    return o;
  }
}
function E2(e) {
  const {
    injectFirst: t,
    enableCssLayer: r,
    children: o
  } = e, a = x.useMemo(() => {
    const i = `${t}-${r}`;
    if (typeof document == "object" && th.has(i))
      return th.get(i);
    const l = y9(t, r);
    return th.set(i, l), l;
  }, [t, r]);
  return a ? /* @__PURE__ */ P.jsx(o9, {
    value: a,
    children: o
  }) : o;
}
process.env.NODE_ENV !== "production" && (E2.propTypes = {
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * If `true`, the styles are wrapped in `@layer mui`.
   * Learn more about [Cascade layers](https://developer.mozilla.org/en-US/docs/Learn_web_development/Core/Styling_basics/Cascade_layers).
   */
  enableCssLayer: n.bool,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: n.bool
});
function v9(e) {
  return e == null || Object.keys(e).length === 0;
}
function ib(e) {
  const {
    styles: t,
    defaultTheme: r = {}
  } = e, o = typeof t == "function" ? (a) => t(v9(a) ? r : a) : t;
  return /* @__PURE__ */ P.jsx(c9, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (ib.propTypes = {
  defaultTheme: n.object,
  styles: n.oneOfType([n.array, n.string, n.object, n.func])
});
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function O2(e, t) {
  const r = tg(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const a = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${a})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((i) => i === void 0) && console.error(`MUI: the styled(${a})(...args) API requires all its args to be defined.`), r(...o);
  } : r;
}
function x9(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const px = [];
function Ai(e) {
  return px[0] = e, nu(px);
}
var gd = { exports: {} }, mr = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fx;
function C9() {
  if (fx) return mr;
  fx = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
  function C(b) {
    if (typeof b == "object" && b !== null) {
      var v = b.$$typeof;
      switch (v) {
        case e:
          switch (b = b.type, b) {
            case r:
            case a:
            case o:
            case d:
            case p:
            case g:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case l:
                case c:
                case h:
                case f:
                  return b;
                case i:
                  return b;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return mr.ContextConsumer = i, mr.ContextProvider = l, mr.Element = e, mr.ForwardRef = c, mr.Fragment = r, mr.Lazy = h, mr.Memo = f, mr.Portal = t, mr.Profiler = a, mr.StrictMode = o, mr.Suspense = d, mr.SuspenseList = p, mr.isContextConsumer = function(b) {
    return C(b) === i;
  }, mr.isContextProvider = function(b) {
    return C(b) === l;
  }, mr.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, mr.isForwardRef = function(b) {
    return C(b) === c;
  }, mr.isFragment = function(b) {
    return C(b) === r;
  }, mr.isLazy = function(b) {
    return C(b) === h;
  }, mr.isMemo = function(b) {
    return C(b) === f;
  }, mr.isPortal = function(b) {
    return C(b) === t;
  }, mr.isProfiler = function(b) {
    return C(b) === a;
  }, mr.isStrictMode = function(b) {
    return C(b) === o;
  }, mr.isSuspense = function(b) {
    return C(b) === d;
  }, mr.isSuspenseList = function(b) {
    return C(b) === p;
  }, mr.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === a || b === o || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === f || b.$$typeof === l || b.$$typeof === i || b.$$typeof === c || b.$$typeof === y || b.getModuleId !== void 0);
  }, mr.typeOf = C, mr;
}
var hr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mx;
function S9() {
  return mx || (mx = 1, process.env.NODE_ENV !== "production" && function() {
    function e(b) {
      if (typeof b == "object" && b !== null) {
        var v = b.$$typeof;
        switch (v) {
          case t:
            switch (b = b.type, b) {
              case o:
              case i:
              case a:
              case p:
              case f:
              case y:
                return b;
              default:
                switch (b = b && b.$$typeof, b) {
                  case c:
                  case d:
                  case g:
                  case h:
                    return b;
                  case l:
                    return b;
                  default:
                    return v;
                }
            }
          case r:
            return v;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.view_transition"), C = Symbol.for("react.client.reference");
    hr.ContextConsumer = l, hr.ContextProvider = c, hr.Element = t, hr.ForwardRef = d, hr.Fragment = o, hr.Lazy = g, hr.Memo = h, hr.Portal = r, hr.Profiler = i, hr.StrictMode = a, hr.Suspense = p, hr.SuspenseList = f, hr.isContextConsumer = function(b) {
      return e(b) === l;
    }, hr.isContextProvider = function(b) {
      return e(b) === c;
    }, hr.isElement = function(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }, hr.isForwardRef = function(b) {
      return e(b) === d;
    }, hr.isFragment = function(b) {
      return e(b) === o;
    }, hr.isLazy = function(b) {
      return e(b) === g;
    }, hr.isMemo = function(b) {
      return e(b) === h;
    }, hr.isPortal = function(b) {
      return e(b) === r;
    }, hr.isProfiler = function(b) {
      return e(b) === i;
    }, hr.isStrictMode = function(b) {
      return e(b) === a;
    }, hr.isSuspense = function(b) {
      return e(b) === p;
    }, hr.isSuspenseList = function(b) {
      return e(b) === f;
    }, hr.isValidElementType = function(b) {
      return typeof b == "string" || typeof b == "function" || b === o || b === i || b === a || b === p || b === f || typeof b == "object" && b !== null && (b.$$typeof === g || b.$$typeof === h || b.$$typeof === c || b.$$typeof === l || b.$$typeof === d || b.$$typeof === C || b.getModuleId !== void 0);
    }, hr.typeOf = e;
  }()), hr;
}
var hx;
function w9() {
  return hx || (hx = 1, process.env.NODE_ENV === "production" ? gd.exports = /* @__PURE__ */ C9() : gd.exports = /* @__PURE__ */ S9()), gd.exports;
}
var zn = /* @__PURE__ */ w9();
function xa(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function $2(e) {
  if (/* @__PURE__ */ x.isValidElement(e) || zn.isValidElementType(e) || !xa(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = $2(e[r]);
  }), t;
}
function sn(e, t, r = {
  clone: !0
}) {
  const o = r.clone ? {
    ...e
  } : e;
  return xa(e) && xa(t) && Object.keys(t).forEach((a) => {
    /* @__PURE__ */ x.isValidElement(t[a]) || zn.isValidElementType(t[a]) ? o[a] = t[a] : xa(t[a]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, a) && xa(e[a]) ? o[a] = sn(e[a], t[a], r) : r.clone ? o[a] = xa(t[a]) ? $2(t[a]) : t[a] : o[a] = t[a];
  }), o;
}
const T9 = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, o) => r.val - o.val), t.reduce((r, o) => ({
    ...r,
    [o.key]: o.val
  }), {});
};
function sb(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: o = 5,
    ...a
  } = e, i = T9(t), l = Object.keys(i);
  function c(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r})`;
  }
  function d(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - o / 100}${r})`;
  }
  function p(g, y) {
    const C = l.indexOf(y);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r}) and (max-width:${(C !== -1 && typeof t[l[C]] == "number" ? t[l[C]] : y) - o / 100}${r})`;
  }
  function f(g) {
    return l.indexOf(g) + 1 < l.length ? p(g, l[l.indexOf(g) + 1]) : c(g);
  }
  function h(g) {
    const y = l.indexOf(g);
    return y === 0 ? c(l[1]) : y === l.length - 1 ? d(l[y]) : p(g, l[l.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: l,
    values: i,
    up: c,
    down: d,
    between: p,
    only: f,
    not: h,
    unit: r,
    ...a
  };
}
function gx(e, t) {
  if (!e.containerQueries)
    return t;
  const r = Object.keys(t).filter((o) => o.startsWith("@container")).sort((o, a) => {
    const i = /min-width:\s*([0-9.]+)/;
    return +(o.match(i)?.[1] || 0) - +(a.match(i)?.[1] || 0);
  });
  return r.length ? r.reduce((o, a) => {
    const i = t[a];
    return delete o[a], o[a] = i, o;
  }, {
    ...t
  }) : t;
}
function E9(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((r) => t.startsWith(`@${r}`)) || !!t.match(/^@\d/));
}
function O9(e, t) {
  const r = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!r) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : jn(18, `(${t})`));
    return null;
  }
  const [, o, a] = r, i = Number.isNaN(+o) ? o || 0 : +o;
  return e.containerQueries(a).up(i);
}
function $9(e) {
  const t = (i, l) => i.replace("@media", l ? `@container ${l}` : "@container");
  function r(i, l) {
    i.up = (...c) => t(e.breakpoints.up(...c), l), i.down = (...c) => t(e.breakpoints.down(...c), l), i.between = (...c) => t(e.breakpoints.between(...c), l), i.only = (...c) => t(e.breakpoints.only(...c), l), i.not = (...c) => {
      const d = t(e.breakpoints.not(...c), l);
      return d.includes("not all and") ? d.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : d;
    };
  }
  const o = {}, a = (i) => (r(o, i), o);
  return r(a), {
    ...e,
    containerQueries: a
  };
}
const R9 = {
  borderRadius: 4
}, Mi = process.env.NODE_ENV !== "production" ? n.oneOfType([n.number, n.string, n.object, n.array]) : {};
function Pc(e, t) {
  return t ? sn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Wp = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, bx = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Wp[e]}px)`
}, P9 = {
  containerQueries: (e) => ({
    up: (t) => {
      let r = typeof t == "number" ? t : Wp[t] || t;
      return typeof r == "number" && (r = `${r}px`), e ? `@container ${e} (min-width:${r})` : `@container (min-width:${r})`;
    }
  })
};
function Qn(e, t, r) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const i = o.breakpoints || bx;
    return t.reduce((l, c, d) => (l[i.up(i.keys[d])] = r(t[d]), l), {});
  }
  if (typeof t == "object") {
    const i = o.breakpoints || bx;
    return Object.keys(t).reduce((l, c) => {
      if (E9(i.keys, c)) {
        const d = O9(o.containerQueries ? o : P9, c);
        d && (l[d] = r(t[c], c));
      } else if (Object.keys(i.values || Wp).includes(c)) {
        const d = i.up(c);
        l[d] = r(t[c], c);
      } else {
        const d = c;
        l[d] = t[d];
      }
      return l;
    }, {});
  }
  return r(t);
}
function R2(e = {}) {
  return e.keys?.reduce((r, o) => {
    const a = e.up(o);
    return r[a] = {}, r;
  }, {}) || {};
}
function rg(e, t) {
  return e.reduce((r, o) => {
    const a = r[o];
    return (!a || Object.keys(a).length === 0) && delete r[o], r;
  }, t);
}
function k9(e, ...t) {
  const r = R2(e), o = [r, ...t].reduce((a, i) => sn(a, i), {});
  return rg(Object.keys(r), o);
}
function A9(e, t) {
  if (typeof e != "object")
    return {};
  const r = {}, o = Object.keys(t);
  return Array.isArray(e) ? o.forEach((a, i) => {
    i < e.length && (r[a] = !0);
  }) : o.forEach((a) => {
    e[a] != null && (r[a] = !0);
  }), r;
}
function hs({
  values: e,
  breakpoints: t,
  base: r
}) {
  const o = r || A9(e, t), a = Object.keys(o);
  if (a.length === 0)
    return e;
  let i;
  return a.reduce((l, c, d) => (Array.isArray(e) ? (l[c] = e[d] != null ? e[d] : e[i], i = d) : typeof e == "object" ? (l[c] = e[c] != null ? e[c] : e[i], i = c) : l[c] = e, l), {});
}
function re(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : jn(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function $i(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const o = `vars.${t}`.split(".").reduce((a, i) => a && a[i] ? a[i] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, a) => o && o[a] != null ? o[a] : null, e);
}
function ip(e, t, r, o = r) {
  let a;
  return typeof e == "function" ? a = e(r) : Array.isArray(e) ? a = e[r] || o : a = $i(e, r) || o, t && (a = t(a, o, e)), a;
}
function Kr(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: o,
    transform: a
  } = e, i = (l) => {
    if (l[t] == null)
      return null;
    const c = l[t], d = l.theme, p = $i(d, o) || {};
    return Qn(l, c, (h) => {
      let g = ip(p, a, h);
      return h === g && typeof h == "string" && (g = ip(p, a, `${t}${h === "default" ? "" : re(h)}`, h)), r === !1 ? g : {
        [r]: g
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Mi
  } : {}, i.filterProps = [t], i;
}
function I9(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const N9 = {
  m: "margin",
  p: "padding"
}, M9 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, yx = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, _9 = I9((e) => {
  if (e.length > 2)
    if (yx[e])
      e = yx[e];
    else
      return [e];
  const [t, r] = e.split(""), o = N9[t], a = M9[r] || "";
  return Array.isArray(a) ? a.map((i) => o + i) : [o + a];
}), Up = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Hp = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], F9 = [...Up, ...Hp];
function au(e, t, r, o) {
  const a = $i(e, t, !0) ?? r;
  return typeof a == "number" || typeof a == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${i}.`), typeof a == "string" ? `calc(${i} * ${a})` : a * i) : Array.isArray(a) ? (i) => {
    if (typeof i == "string")
      return i;
    const l = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > a.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(a)}.`, `${l} > ${a.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const c = a[l];
    return i >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof a == "function" ? a : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${a}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Gp(e) {
  return au(e, "spacing", 8, "spacing");
}
function ws(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function L9(e, t) {
  return (r) => e.reduce((o, a) => (o[a] = ws(t, r), o), {});
}
function B9(e, t, r, o) {
  if (!t.includes(r))
    return null;
  const a = _9(r), i = L9(a, o), l = e[r];
  return Qn(e, l, i);
}
function P2(e, t) {
  const r = Gp(e.theme);
  return Object.keys(e).map((o) => B9(e, t, o, r)).reduce(Pc, {});
}
function Dr(e) {
  return P2(e, Up);
}
Dr.propTypes = process.env.NODE_ENV !== "production" ? Up.reduce((e, t) => (e[t] = Mi, e), {}) : {};
Dr.filterProps = Up;
function jr(e) {
  return P2(e, Hp);
}
jr.propTypes = process.env.NODE_ENV !== "production" ? Hp.reduce((e, t) => (e[t] = Mi, e), {}) : {};
jr.filterProps = Hp;
process.env.NODE_ENV !== "production" && F9.reduce((e, t) => (e[t] = Mi, e), {});
function lb(e = 8, t = Gp({
  spacing: e
})) {
  if (e.mui)
    return e;
  const r = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((i) => {
    const l = t(i);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" "));
  return r.mui = !0, r;
}
function qp(...e) {
  const t = e.reduce((o, a) => (a.filterProps.forEach((i) => {
    o[i] = a;
  }), o), {}), r = (o) => Object.keys(o).reduce((a, i) => t[i] ? Pc(a, t[i](o)) : a, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, a) => Object.assign(o, a.propTypes), {}) : {}, r.filterProps = e.reduce((o, a) => o.concat(a.filterProps), []), r;
}
function Vo(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Yo(e, t) {
  return Kr({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const D9 = Yo("border", Vo), j9 = Yo("borderTop", Vo), z9 = Yo("borderRight", Vo), V9 = Yo("borderBottom", Vo), W9 = Yo("borderLeft", Vo), U9 = Yo("borderColor"), H9 = Yo("borderTopColor"), G9 = Yo("borderRightColor"), q9 = Yo("borderBottomColor"), K9 = Yo("borderLeftColor"), Y9 = Yo("outline", Vo), Z9 = Yo("outlineColor"), Kp = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = au(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (o) => ({
      borderRadius: ws(t, o)
    });
    return Qn(e, e.borderRadius, r);
  }
  return null;
};
Kp.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Mi
} : {};
Kp.filterProps = ["borderRadius"];
qp(D9, j9, z9, V9, W9, U9, H9, G9, q9, K9, Kp, Y9, Z9);
const Yp = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = au(e.theme, "spacing", 8, "gap"), r = (o) => ({
      gap: ws(t, o)
    });
    return Qn(e, e.gap, r);
  }
  return null;
};
Yp.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Mi
} : {};
Yp.filterProps = ["gap"];
const Zp = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = au(e.theme, "spacing", 8, "columnGap"), r = (o) => ({
      columnGap: ws(t, o)
    });
    return Qn(e, e.columnGap, r);
  }
  return null;
};
Zp.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Mi
} : {};
Zp.filterProps = ["columnGap"];
const Xp = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = au(e.theme, "spacing", 8, "rowGap"), r = (o) => ({
      rowGap: ws(t, o)
    });
    return Qn(e, e.rowGap, r);
  }
  return null;
};
Xp.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Mi
} : {};
Xp.filterProps = ["rowGap"];
const X9 = Kr({
  prop: "gridColumn"
}), J9 = Kr({
  prop: "gridRow"
}), Q9 = Kr({
  prop: "gridAutoFlow"
}), e7 = Kr({
  prop: "gridAutoColumns"
}), t7 = Kr({
  prop: "gridAutoRows"
}), r7 = Kr({
  prop: "gridTemplateColumns"
}), n7 = Kr({
  prop: "gridTemplateRows"
}), o7 = Kr({
  prop: "gridTemplateAreas"
}), a7 = Kr({
  prop: "gridArea"
});
qp(Yp, Zp, Xp, X9, J9, Q9, e7, t7, r7, n7, o7, a7);
function ml(e, t) {
  return t === "grey" ? t : e;
}
const i7 = Kr({
  prop: "color",
  themeKey: "palette",
  transform: ml
}), s7 = Kr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: ml
}), l7 = Kr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: ml
});
qp(i7, s7, l7);
function yo(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const c7 = Kr({
  prop: "width",
  transform: yo
}), cb = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      const o = e.theme?.breakpoints?.values?.[r] || Wp[r];
      return o ? e.theme?.breakpoints?.unit !== "px" ? {
        maxWidth: `${o}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: o
      } : {
        maxWidth: yo(r)
      };
    };
    return Qn(e, e.maxWidth, t);
  }
  return null;
};
cb.filterProps = ["maxWidth"];
const u7 = Kr({
  prop: "minWidth",
  transform: yo
}), d7 = Kr({
  prop: "height",
  transform: yo
}), p7 = Kr({
  prop: "maxHeight",
  transform: yo
}), f7 = Kr({
  prop: "minHeight",
  transform: yo
});
Kr({
  prop: "size",
  cssProperty: "width",
  transform: yo
});
Kr({
  prop: "size",
  cssProperty: "height",
  transform: yo
});
const m7 = Kr({
  prop: "boxSizing"
});
qp(c7, cb, u7, d7, p7, f7, m7);
const iu = {
  // borders
  border: {
    themeKey: "borders",
    transform: Vo
  },
  borderTop: {
    themeKey: "borders",
    transform: Vo
  },
  borderRight: {
    themeKey: "borders",
    transform: Vo
  },
  borderBottom: {
    themeKey: "borders",
    transform: Vo
  },
  borderLeft: {
    themeKey: "borders",
    transform: Vo
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Vo
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Kp
  },
  // palette
  color: {
    themeKey: "palette",
    transform: ml
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: ml
  },
  backgroundColor: {
    themeKey: "palette",
    transform: ml
  },
  // spacing
  p: {
    style: jr
  },
  pt: {
    style: jr
  },
  pr: {
    style: jr
  },
  pb: {
    style: jr
  },
  pl: {
    style: jr
  },
  px: {
    style: jr
  },
  py: {
    style: jr
  },
  padding: {
    style: jr
  },
  paddingTop: {
    style: jr
  },
  paddingRight: {
    style: jr
  },
  paddingBottom: {
    style: jr
  },
  paddingLeft: {
    style: jr
  },
  paddingX: {
    style: jr
  },
  paddingY: {
    style: jr
  },
  paddingInline: {
    style: jr
  },
  paddingInlineStart: {
    style: jr
  },
  paddingInlineEnd: {
    style: jr
  },
  paddingBlock: {
    style: jr
  },
  paddingBlockStart: {
    style: jr
  },
  paddingBlockEnd: {
    style: jr
  },
  m: {
    style: Dr
  },
  mt: {
    style: Dr
  },
  mr: {
    style: Dr
  },
  mb: {
    style: Dr
  },
  ml: {
    style: Dr
  },
  mx: {
    style: Dr
  },
  my: {
    style: Dr
  },
  margin: {
    style: Dr
  },
  marginTop: {
    style: Dr
  },
  marginRight: {
    style: Dr
  },
  marginBottom: {
    style: Dr
  },
  marginLeft: {
    style: Dr
  },
  marginX: {
    style: Dr
  },
  marginY: {
    style: Dr
  },
  marginInline: {
    style: Dr
  },
  marginInlineStart: {
    style: Dr
  },
  marginInlineEnd: {
    style: Dr
  },
  marginBlock: {
    style: Dr
  },
  marginBlockStart: {
    style: Dr
  },
  marginBlockEnd: {
    style: Dr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Yp
  },
  rowGap: {
    style: Xp
  },
  columnGap: {
    style: Zp
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: yo
  },
  maxWidth: {
    style: cb
  },
  minWidth: {
    transform: yo
  },
  height: {
    transform: yo
  },
  maxHeight: {
    transform: yo
  },
  minHeight: {
    transform: yo
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function h7(...e) {
  const t = e.reduce((o, a) => o.concat(Object.keys(a)), []), r = new Set(t);
  return e.every((o) => r.size === Object.keys(o).length);
}
function g7(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function b7() {
  function e(r, o, a, i) {
    const l = {
      [r]: o,
      theme: a
    }, c = i[r];
    if (!c)
      return {
        [r]: o
      };
    const {
      cssProperty: d = r,
      themeKey: p,
      transform: f,
      style: h
    } = c;
    if (o == null)
      return null;
    if (p === "typography" && o === "inherit")
      return {
        [r]: o
      };
    const g = $i(a, p) || {};
    return h ? h(l) : Qn(l, o, (C) => {
      let b = ip(g, f, C);
      return C === b && typeof C == "string" && (b = ip(g, f, `${r}${C === "default" ? "" : re(C)}`, C)), d === !1 ? b : {
        [d]: b
      };
    });
  }
  function t(r) {
    const {
      sx: o,
      theme: a = {},
      nested: i
    } = r || {};
    if (!o)
      return null;
    const l = a.unstable_sxConfig ?? iu;
    function c(d) {
      let p = d;
      if (typeof d == "function")
        p = d(a);
      else if (typeof d != "object")
        return d;
      if (!p)
        return null;
      const f = R2(a.breakpoints), h = Object.keys(f);
      let g = f;
      return Object.keys(p).forEach((y) => {
        const C = g7(p[y], a);
        if (C != null)
          if (typeof C == "object")
            if (l[y])
              g = Pc(g, e(y, C, a, l));
            else {
              const b = Qn({
                theme: a
              }, C, (v) => ({
                [y]: v
              }));
              h7(b, C) ? g[y] = t({
                sx: C,
                theme: a,
                nested: !0
              }) : g = Pc(g, b);
            }
          else
            g = Pc(g, e(y, C, a, l));
      }), !i && a.modularCssLayers ? {
        "@layer sx": gx(a, rg(h, g))
      } : gx(a, rg(h, g));
    }
    return Array.isArray(o) ? o.map(c) : c(o);
  }
  return t;
}
const Ii = b7();
Ii.filterProps = ["sx"];
function y7(e, t) {
  const r = this;
  if (r.vars) {
    if (!r.colorSchemes?.[e] || typeof r.getColorSchemeSelector != "function")
      return {};
    let o = r.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function Bl(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: o = {},
    spacing: a,
    shape: i = {},
    ...l
  } = e, c = sb(r), d = lb(a);
  let p = sn({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...o
    },
    spacing: d,
    shape: {
      ...R9,
      ...i
    }
  }, l);
  return p = $9(p), p.applyStyles = y7, p = t.reduce((f, h) => sn(f, h), p), p.unstable_sxConfig = {
    ...iu,
    ...l?.unstable_sxConfig
  }, p.unstable_sx = function(h) {
    return Ii({
      sx: h,
      theme: this
    });
  }, p;
}
function v7(e) {
  return Object.keys(e).length === 0;
}
function Jp(e = null) {
  const t = x.useContext(ou);
  return !t || v7(t) ? e : t;
}
const x7 = Bl();
function su(e = x7) {
  return Jp(e);
}
function rh(e) {
  const t = Ai(e);
  return e !== t && t.styles ? (t.styles.match(/^@layer\s+[^{]*$/) || (t.styles = `@layer global{${t.styles}}`), t) : e;
}
function ub({
  styles: e,
  themeId: t,
  defaultTheme: r = {}
}) {
  const o = su(r), a = t && o[t] || o;
  let i = typeof e == "function" ? e(a) : e;
  return a.modularCssLayers && (Array.isArray(i) ? i = i.map((l) => rh(typeof l == "function" ? l(a) : l)) : i = rh(i)), /* @__PURE__ */ P.jsx(ib, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (ub.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: n.object,
  /**
   * @ignore
   */
  styles: n.oneOfType([n.array, n.func, n.number, n.object, n.string, n.bool]),
  /**
   * @ignore
   */
  themeId: n.string
});
const C7 = (e) => {
  const t = {
    systemProps: {},
    otherProps: {}
  }, r = e?.theme?.unstable_sxConfig ?? iu;
  return Object.keys(e).forEach((o) => {
    r[o] ? t.systemProps[o] = e[o] : t.otherProps[o] = e[o];
  }), t;
};
function lu(e) {
  const {
    sx: t,
    ...r
  } = e, {
    systemProps: o,
    otherProps: a
  } = C7(r);
  let i;
  return Array.isArray(t) ? i = [o, ...t] : typeof t == "function" ? i = (...l) => {
    const c = t(...l);
    return xa(c) ? {
      ...o,
      ...c
    } : o;
  } : i = {
    ...o,
    ...t
  }, {
    ...a,
    sx: i
  };
}
const vx = (e) => e, S7 = () => {
  let e = vx;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = vx;
    }
  };
}, db = S7();
function k2(e) {
  var t, r, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = k2(e[t])) && (o && (o += " "), o += r);
  } else for (r in e) e[r] && (o && (o += " "), o += r);
  return o;
}
function ge() {
  for (var e, t, r = 0, o = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = k2(e)) && (o && (o += " "), o += t);
  return o;
}
function w7(e = {}) {
  const {
    themeId: t,
    defaultTheme: r,
    defaultClassName: o = "MuiBox-root",
    generateClassName: a
  } = e, i = O2("div", {
    shouldForwardProp: (c) => c !== "theme" && c !== "sx" && c !== "as"
  })(Ii);
  return /* @__PURE__ */ x.forwardRef(function(d, p) {
    const f = su(r), {
      className: h,
      component: g = "div",
      ...y
    } = lu(d);
    return /* @__PURE__ */ P.jsx(i, {
      as: g,
      ref: p,
      className: ge(h, a ? a(o) : o),
      theme: t && f[t] || f,
      ...y
    });
  });
}
const T7 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Ae(e, t, r = "Mui") {
  const o = T7[t];
  return o ? `${r}-${o}` : `${db.generate(e)}-${t}`;
}
function Ne(e, t, r = "Mui") {
  const o = {};
  return t.forEach((a) => {
    o[a] = Ae(e, a, r);
  }), o;
}
function A2(e, t = "") {
  return e.displayName || e.name || t;
}
function xx(e, t, r) {
  const o = A2(t);
  return e.displayName || (o !== "" ? `${r}(${o})` : r);
}
function I2(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return A2(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case zn.ForwardRef:
          return xx(e, e.render, "ForwardRef");
        case zn.Memo:
          return xx(e, e.type, "memo");
        default:
          return;
      }
  }
}
function N2(e) {
  const {
    variants: t,
    ...r
  } = e, o = {
    variants: t,
    style: Ai(r),
    isProcessed: !0
  };
  return o.style === r || t && t.forEach((a) => {
    typeof a.style != "function" && (a.style = Ai(a.style));
  }), o;
}
const E7 = Bl();
function nh(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function ls(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function O7(e) {
  return e ? (t, r) => r[e] : null;
}
function $7(e, t, r) {
  e.theme = k7(e.theme) ? r : e.theme[t] || e.theme;
}
function Hd(e, t, r) {
  const o = typeof t == "function" ? t(e) : t;
  if (Array.isArray(o))
    return o.flatMap((a) => Hd(e, a, r));
  if (Array.isArray(o?.variants)) {
    let a;
    if (o.isProcessed)
      a = r ? ls(o.style, r) : o.style;
    else {
      const {
        variants: i,
        ...l
      } = o;
      a = r ? ls(Ai(l), r) : l;
    }
    return M2(e, o.variants, [a], r);
  }
  return o?.isProcessed ? r ? ls(Ai(o.style), r) : o.style : r ? ls(Ai(o), r) : o;
}
function M2(e, t, r = [], o = void 0) {
  let a;
  e: for (let i = 0; i < t.length; i += 1) {
    const l = t[i];
    if (typeof l.props == "function") {
      if (a ??= {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }, !l.props(a))
        continue;
    } else
      for (const c in l.props)
        if (e[c] !== l.props[c] && e.ownerState?.[c] !== l.props[c])
          continue e;
    typeof l.style == "function" ? (a ??= {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }, r.push(o ? ls(Ai(l.style(a)), o) : l.style(a))) : r.push(o ? ls(Ai(l.style), o) : l.style);
  }
  return r;
}
function _2(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = E7,
    rootShouldForwardProp: o = nh,
    slotShouldForwardProp: a = nh
  } = e;
  function i(c) {
    $7(c, t, r);
  }
  return (c, d = {}) => {
    x9(c, (k) => k.filter((A) => A !== Ii));
    const {
      name: p,
      slot: f,
      skipVariantsResolver: h,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: y = O7(F2(f)),
      ...C
    } = d, b = p && p.startsWith("Mui") || f ? "components" : "custom", v = h !== void 0 ? h : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), T = g || !1;
    let R = nh;
    f === "Root" || f === "root" ? R = o : f ? R = a : A7(c) && (R = void 0);
    const $ = O2(c, {
      shouldForwardProp: R,
      label: P7(p, f),
      ...C
    }), E = (k) => {
      if (k.__emotion_real === k)
        return k;
      if (typeof k == "function")
        return function(_) {
          return Hd(_, k, _.theme.modularCssLayers ? b : void 0);
        };
      if (xa(k)) {
        const A = N2(k);
        return function(L) {
          return A.variants ? Hd(L, A, L.theme.modularCssLayers ? b : void 0) : L.theme.modularCssLayers ? ls(A.style, b) : A.style;
        };
      }
      return k;
    }, S = (...k) => {
      const A = [], _ = k.map(E), L = [];
      if (A.push(i), p && y && L.push(function(M) {
        const W = M.theme.components?.[p]?.styleOverrides;
        if (!W)
          return null;
        const V = {};
        for (const X in W)
          V[X] = Hd(M, W[X], M.theme.modularCssLayers ? "theme" : void 0);
        return y(M, V);
      }), p && !v && L.push(function(M) {
        const W = M.theme?.components?.[p]?.variants;
        return W ? M2(M, W, [], M.theme.modularCssLayers ? "theme" : void 0) : null;
      }), T || L.push(Ii), Array.isArray(_[0])) {
        const B = _.shift(), M = new Array(A.length).fill(""), j = new Array(L.length).fill("");
        let W;
        W = [...M, ...B, ...j], W.raw = [...M, ...B.raw, ...j], A.unshift(W);
      }
      const O = [...A, ..._, ...L], F = $(...O);
      return c.muiName && (F.muiName = c.muiName), process.env.NODE_ENV !== "production" && (F.displayName = R7(p, f, c)), F;
    };
    return $.withConfig && (S.withConfig = $.withConfig), S;
  };
}
function R7(e, t, r) {
  return e ? `${e}${re(t || "")}` : `Styled(${I2(r)})`;
}
function P7(e, t) {
  let r;
  return process.env.NODE_ENV !== "production" && e && (r = `${e}-${F2(t || "Root")}`), r;
}
function k7(e) {
  for (const t in e)
    return !1;
  return !0;
}
function A7(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function F2(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const pb = _2();
function wl(e, t) {
  const r = {
    ...t
  };
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      const a = o;
      if (a === "components" || a === "slots")
        r[a] = {
          ...e[a],
          ...r[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const i = e[a], l = t[a];
        if (!l)
          r[a] = i || {};
        else if (!i)
          r[a] = l;
        else {
          r[a] = {
            ...l
          };
          for (const c in i)
            if (Object.prototype.hasOwnProperty.call(i, c)) {
              const d = c;
              r[a][d] = wl(i[d], l[d]);
            }
        }
      } else r[a] === void 0 && (r[a] = e[a]);
    }
  return r;
}
function fb(e) {
  const {
    theme: t,
    name: r,
    props: o
  } = e;
  return !t || !t.components || !t.components[r] || !t.components[r].defaultProps ? o : wl(t.components[r].defaultProps, o);
}
function Qp({
  props: e,
  name: t,
  defaultTheme: r,
  themeId: o
}) {
  let a = su(r);
  return o && (a = a[o] || a), fb({
    theme: a,
    name: t,
    props: e
  });
}
const en = typeof window < "u" ? x.useLayoutEffect : x.useEffect;
function I7(e, t, r, o, a) {
  const [i, l] = x.useState(() => a && r ? r(e).matches : o ? o(e).matches : t);
  return en(() => {
    if (!r)
      return;
    const c = r(e), d = () => {
      l(c.matches);
    };
    return d(), c.addEventListener("change", d), () => {
      c.removeEventListener("change", d);
    };
  }, [e, r]), i;
}
const N7 = {
  ...x
}, L2 = N7.useSyncExternalStore;
function M7(e, t, r, o, a) {
  const i = x.useCallback(() => t, [t]), l = x.useMemo(() => {
    if (a && r)
      return () => r(e).matches;
    if (o !== null) {
      const {
        matches: f
      } = o(e);
      return () => f;
    }
    return i;
  }, [i, e, o, a, r]), [c, d] = x.useMemo(() => {
    if (r === null)
      return [i, () => () => {
      }];
    const f = r(e);
    return [() => f.matches, (h) => (f.addEventListener("change", h), () => {
      f.removeEventListener("change", h);
    })];
  }, [i, r, e]);
  return L2(d, c, l);
}
function B2(e = {}) {
  const {
    themeId: t
  } = e;
  return function(o, a = {}) {
    let i = Jp();
    i && t && (i = i[t] || i);
    const l = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: c = !1,
      matchMedia: d = l ? window.matchMedia : null,
      ssrMatchMedia: p = null,
      noSsr: f = !1
    } = fb({
      name: "MuiUseMediaQuery",
      props: a,
      theme: i
    });
    process.env.NODE_ENV !== "production" && typeof o == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let h = typeof o == "function" ? o(i) : o;
    h = h.replace(/^@media( ?)/m, ""), h.includes("print") && console.warn(["MUI: You have provided a `print` query to the `useMediaQuery` hook.", "Using the print media query to modify print styles can lead to unexpected results.", "Consider using the `displayPrint` field in the `sx` prop instead.", "More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print."].join(`
`));
    const y = (L2 !== void 0 ? M7 : I7)(h, c, d, p, f);
    return process.env.NODE_ENV !== "production" && x.useDebugValue({
      query: h,
      match: y
    }), y;
  };
}
B2();
function Oi(e, t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, r));
}
function mb(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), Oi(e, t, r);
}
function D2(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((o) => o + o)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((o, a) => a < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function _7(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Oa(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Oa(D2(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(r))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : jn(9, e));
  let o = e.substring(t + 1, e.length - 1), a;
  if (r === "color") {
    if (o = o.split(" "), a = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(a))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${a}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : jn(10, a));
  } else
    o = o.split(",");
  return o = o.map((i) => parseFloat(i)), {
    type: r,
    values: o,
    colorSpace: a
  };
}
const F7 = (e) => {
  const t = Oa(e);
  return t.values.slice(0, 3).map((r, o) => t.type.includes("hsl") && o !== 0 ? `${r}%` : r).join(" ");
}, xc = (e, t) => {
  try {
    return F7(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function cu(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: o
  } = e;
  return t.includes("rgb") ? o = o.map((a, i) => i < 3 ? parseInt(a, 10) : a) : t.includes("hsl") && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.includes("color") ? o = `${r} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function L7(e) {
  if (e.startsWith("#"))
    return e;
  const {
    values: t
  } = Oa(e);
  return `#${t.map((r, o) => _7(o === 3 ? Math.round(255 * r) : r)).join("")}`;
}
function hb(e) {
  e = Oa(e);
  const {
    values: t
  } = e, r = t[0], o = t[1] / 100, a = t[2] / 100, i = o * Math.min(a, 1 - a), l = (p, f = (p + r / 30) % 12) => a - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let c = "rgb";
  const d = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (c += "a", d.push(t[3])), cu({
    type: c,
    values: d
  });
}
function sp(e) {
  e = Oa(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Oa(hb(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function ng(e, t) {
  const r = sp(e), o = sp(t);
  return (Math.max(r, o) + 0.05) / (Math.min(r, o) + 0.05);
}
function dt(e, t) {
  return e = Oa(e), t = mb(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, cu(e);
}
function bd(e, t, r) {
  try {
    return dt(e, t);
  } catch {
    return e;
  }
}
function na(e, t) {
  if (e = Oa(e), t = mb(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return cu(e);
}
function vr(e, t, r) {
  try {
    return na(e, t);
  } catch {
    return e;
  }
}
function oa(e, t) {
  if (e = Oa(e), t = mb(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return cu(e);
}
function xr(e, t, r) {
  try {
    return oa(e, t);
  } catch {
    return e;
  }
}
function Tl(e, t = 0.15) {
  return sp(e) > 0.5 ? na(e, t) : oa(e, t);
}
function yd(e, t, r) {
  try {
    return Tl(e, t);
  } catch {
    return e;
  }
}
function tn(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function B7(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function j2(e, t, r, o, a) {
  const i = e[t], l = a || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  const d = i.type;
  return typeof d == "function" && !B7(d) && (c = "Did you accidentally use a plain function component for an element instead?"), c !== void 0 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const ai = tn(n.element, j2);
ai.isRequired = tn(n.element.isRequired, j2);
function D7(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function j7(e, t, r, o, a) {
  const i = e[t], l = a || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof i == "function" && !D7(i) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ni = tn(n.elementType, j7), z7 = "exact-prop: ​";
function ks(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [z7]: (t) => {
      const r = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function $a(e, t, r, o, a) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], l = a || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${o} \`${l}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const On = n.oneOfType([n.func, n.object]);
function lp(...e) {
  return e.reduce((t, r) => r == null ? t : function(...a) {
    t.apply(this, a), r.apply(this, a);
  }, () => {
  });
}
function As(e, t = 166) {
  let r;
  function o(...a) {
    const i = () => {
      e.apply(this, a);
    };
    clearTimeout(r), r = setTimeout(i, t);
  }
  return o.clear = () => {
    clearTimeout(r);
  }, o;
}
function V7(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (r, o, a, i, l) => {
    const c = a || "<<anonymous>>", d = l || o;
    return typeof r[o] < "u" ? new Error(`The ${i} \`${d}\` of \`${c}\` is deprecated. ${t}`) : null;
  };
}
function wa(e, t) {
  return /* @__PURE__ */ x.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? e.type?._payload?.value?.muiName
  ) !== -1;
}
function Rr(e) {
  return e && e.ownerDocument || document;
}
function fn(e) {
  return Rr(e).defaultView || window;
}
function gb(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const r = t ? {
    ...t.propTypes
  } : null;
  return (a) => (i, l, c, d, p, ...f) => {
    const h = p || l, g = r?.[h];
    if (g) {
      const y = g(i, l, c, d, p, ...f);
      if (y)
        return y;
    }
    return typeof i[l] < "u" && !i[a] ? new Error(`The prop \`${h}\` of \`${e}\` can only be used together with the \`${a}\` prop.`) : null;
  };
}
function cp(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let Cx = 0;
function W7(e) {
  const [t, r] = x.useState(e), o = e || t;
  return x.useEffect(() => {
    t == null && (Cx += 1, r(`mui-${Cx}`));
  }, [t]), o;
}
const U7 = {
  ...x
}, Sx = U7.useId;
function eo(e) {
  if (Sx !== void 0) {
    const t = Sx();
    return e ?? t;
  }
  return W7(e);
}
function ef(e, t, r, o, a) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = a || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Bn({
  controlled: e,
  default: t,
  name: r,
  state: o = "value"
}) {
  const {
    current: a
  } = x.useRef(e !== void 0), [i, l] = x.useState(t), c = a ? e : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      a !== (e !== void 0) && console.error([`MUI: A component is changing the ${a ? "" : "un"}controlled ${o} state of ${r} to be ${a ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, r, e]);
    const {
      current: p
    } = x.useRef(t);
    x.useEffect(() => {
      !a && !Object.is(p, t) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const d = x.useCallback((p) => {
    a || l(p);
  }, []);
  return [c, d];
}
function Pr(e) {
  const t = x.useRef(e);
  return en(() => {
    t.current = e;
  }), x.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
function Jt(...e) {
  const t = x.useRef(void 0), r = x.useCallback((o) => {
    const a = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const l = i, c = l(o);
        return typeof c == "function" ? c : () => {
          l(null);
        };
      }
      return i.current = o, () => {
        i.current = null;
      };
    });
    return () => {
      a.forEach((i) => i?.());
    };
  }, e);
  return x.useMemo(() => e.every((o) => o == null) ? null : (o) => {
    t.current && (t.current(), t.current = void 0), o != null && (t.current = r(o));
  }, e);
}
const wx = {};
function z2(e, t) {
  const r = x.useRef(wx);
  return r.current === wx && (r.current = e(t)), r;
}
const H7 = [];
function G7(e) {
  x.useEffect(e, H7);
}
class tf {
  static create() {
    return new tf();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
  clear = () => {
    this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
  };
  disposeEffect = () => this.clear;
}
function Ja() {
  const e = z2(tf.create).current;
  return G7(e.disposeEffect), e;
}
function Ra(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function V2(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const bb = (e) => {
  const t = x.useRef({});
  return x.useEffect(() => {
    t.current = e;
  }), t.current;
};
function W2(e) {
  return x.Children.toArray(e).filter((t) => /* @__PURE__ */ x.isValidElement(t));
}
const U2 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function q7(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function H2(e, t, r, o) {
  const a = e[t];
  if (a == null || !Number.isInteger(a)) {
    const i = q7(a);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${i}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function G2(e, t, ...r) {
  return e[t] === void 0 ? null : H2(e, t, ...r);
}
function og() {
  return null;
}
G2.isRequired = H2;
og.isRequired = og;
const Vr = process.env.NODE_ENV === "production" ? og : G2;
function Me(e, t, r = void 0) {
  const o = {};
  for (const a in e) {
    const i = e[a];
    let l = "", c = !0;
    for (let d = 0; d < i.length; d += 1) {
      const p = i[d];
      p && (l += (c === !0 ? "" : " ") + t(p), c = !1, r && r[p] && (l += " " + r[p]));
    }
    o[a] = l;
  }
  return o;
}
function K7(e) {
  return typeof e == "string";
}
function q2(e, t, r) {
  return e === void 0 || K7(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...r
    }
  };
}
function gs(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    r[o] = e[o];
  }), r;
}
function Tx(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function K2(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: o,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const y = ge(r?.className, i, a?.className, o?.className), C = {
      ...r?.style,
      ...a?.style,
      ...o?.style
    }, b = {
      ...r,
      ...a,
      ...o
    };
    return y.length > 0 && (b.className = y), Object.keys(C).length > 0 && (b.style = C), {
      props: b,
      internalRef: void 0
    };
  }
  const l = gs({
    ...a,
    ...o
  }), c = Tx(o), d = Tx(a), p = t(l), f = ge(p?.className, r?.className, i, a?.className, o?.className), h = {
    ...p?.style,
    ...r?.style,
    ...a?.style,
    ...o?.style
  }, g = {
    ...p,
    ...r,
    ...d,
    ...c
  };
  return f.length > 0 && (g.className = f), Object.keys(h).length > 0 && (g.style = h), {
    props: g,
    internalRef: p.ref
  };
}
function Y2(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
function Mn(e) {
  const {
    elementType: t,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: a = !1,
    ...i
  } = e, l = a ? {} : Y2(r, o), {
    props: c,
    internalRef: d
  } = K2({
    ...i,
    externalSlotProps: l
  }), p = Jt(d, l?.ref, e.additionalProps?.ref);
  return q2(t, {
    ...c,
    ref: p
  }, o);
}
function ii(e) {
  return parseInt(x.version, 10) >= 19 ? e?.props?.ref || null : e?.ref || null;
}
const yb = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (yb.displayName = "ThemeContext");
function vb() {
  const e = x.useContext(yb);
  return process.env.NODE_ENV !== "production" && x.useDebugValue(e), e;
}
const Y7 = typeof Symbol == "function" && Symbol.for, Z7 = Y7 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function X7(e, t) {
  if (typeof t == "function") {
    const r = t(e);
    return process.env.NODE_ENV !== "production" && (r || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), r;
  }
  return {
    ...e,
    ...t
  };
}
function up(e) {
  const {
    children: t,
    theme: r
  } = e, o = vb();
  process.env.NODE_ENV !== "production" && o === null && typeof r == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = x.useMemo(() => {
    const i = o === null ? {
      ...r
    } : X7(o, r);
    return i != null && (i[Z7] = o !== null), i;
  }, [r, o]);
  return /* @__PURE__ */ P.jsx(yb.Provider, {
    value: a,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (up.propTypes = {
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: n.oneOfType([n.object, n.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (up.propTypes = ks(up.propTypes));
const Z2 = /* @__PURE__ */ x.createContext();
function X2({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ P.jsx(Z2.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (X2.propTypes = {
  children: n.node,
  value: n.bool
});
const la = () => x.useContext(Z2) ?? !1, J2 = /* @__PURE__ */ x.createContext(void 0);
function Q2({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ P.jsx(J2.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Q2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.node,
  /**
   * @ignore
   */
  value: n.object
});
function J7(e) {
  const {
    theme: t,
    name: r,
    props: o
  } = e;
  if (!t || !t.components || !t.components[r])
    return o;
  const a = t.components[r];
  return a.defaultProps ? wl(a.defaultProps, o) : !a.styleOverrides && !a.variants ? wl(a, o) : o;
}
function Q7({
  props: e,
  name: t
}) {
  const r = x.useContext(J2);
  return J7({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
function eN(e) {
  const t = Jp(), r = eo() || "", {
    modularCssLayers: o
  } = e;
  let a = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
  return !o || t !== null ? a = "" : typeof o == "string" ? a = o.replace(/mui(?!\.)/g, a) : a = `@layer ${a};`, en(() => {
    const i = document.querySelector("head");
    if (!i)
      return;
    const l = i.firstChild;
    if (a) {
      if (l && l.hasAttribute?.("data-mui-layer-order") && l.getAttribute("data-mui-layer-order") === r)
        return;
      const c = document.createElement("style");
      c.setAttribute("data-mui-layer-order", r), c.textContent = a, i.prepend(c);
    } else
      i.querySelector(`style[data-mui-layer-order="${r}"]`)?.remove();
  }, [a, r]), a ? /* @__PURE__ */ P.jsx(ub, {
    styles: a
  }) : null;
}
const Ex = {};
function Ox(e, t, r, o = !1) {
  return x.useMemo(() => {
    const a = e && t[e] || t;
    if (typeof r == "function") {
      const i = r(a), l = e ? {
        ...t,
        [e]: i
      } : i;
      return o ? () => l : l;
    }
    return e ? {
      ...t,
      [e]: r
    } : {
      ...t,
      ...r
    };
  }, [e, t, r, o]);
}
function jc(e) {
  const {
    children: t,
    theme: r,
    themeId: o
  } = e, a = Jp(Ex), i = vb() || Ex;
  process.env.NODE_ENV !== "production" && (a === null && typeof r == "function" || o && a && !a[o] && typeof r == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const l = Ox(o, a, r), c = Ox(o, i, r, !0), d = (o ? l[o] : l).direction === "rtl", p = eN(l);
  return /* @__PURE__ */ P.jsx(up, {
    theme: c,
    children: /* @__PURE__ */ P.jsx(ou.Provider, {
      value: l,
      children: /* @__PURE__ */ P.jsx(X2, {
        value: d,
        children: /* @__PURE__ */ P.jsxs(Q2, {
          value: o ? l[o].components : l.components,
          children: [p, t]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (jc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: n.oneOfType([n.func, n.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: n.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (jc.propTypes = ks(jc.propTypes));
const $x = {
  theme: void 0
};
function tN(e) {
  let t, r;
  return function(a) {
    let i = t;
    return (i === void 0 || a.theme !== r) && ($x.theme = a.theme, i = N2(e($x)), t = i, r = a.theme), i;
  };
}
const xb = "mode", Cb = "color-scheme", rN = "data-color-scheme";
function nN(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: r = "light",
    defaultDarkColorScheme: o = "dark",
    modeStorageKey: a = xb,
    colorSchemeStorageKey: i = Cb,
    attribute: l = rN,
    colorSchemeNode: c = "document.documentElement",
    nonce: d
  } = e || {};
  let p = "", f = l;
  if (l === "class" && (f = ".%s"), l === "data" && (f = "[data-%s]"), f.startsWith(".")) {
    const g = f.substring(1);
    p += `${c}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${c}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const h = f.match(/\[([^\]]+)\]/);
  if (h) {
    const [g, y] = h[1].split("=");
    y || (p += `${c}.removeAttribute('${g}'.replace('%s', light));
      ${c}.removeAttribute('${g}'.replace('%s', dark));`), p += `
      ${c}.setAttribute('${g}'.replace('%s', colorScheme), ${y ? `${y}.replace('%s', colorScheme)` : '""'});`;
  } else
    p += `${c}.setAttribute('${f}', colorScheme);`;
  return /* @__PURE__ */ P.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? d : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${a}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${o}';
  const light = localStorage.getItem('${i}-light') || '${r}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${p}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function oN() {
}
const aN = ({
  key: e,
  storageWindow: t
}) => (!t && typeof window < "u" && (t = window), {
  get(r) {
    if (typeof window > "u")
      return;
    if (!t)
      return r;
    let o;
    try {
      o = t.localStorage.getItem(e);
    } catch {
    }
    return o || r;
  },
  set: (r) => {
    if (t)
      try {
        t.localStorage.setItem(e, r);
      } catch {
      }
  },
  subscribe: (r) => {
    if (!t)
      return oN;
    const o = (a) => {
      const i = a.newValue;
      a.key === e && r(i);
    };
    return t.addEventListener("storage", o), () => {
      t.removeEventListener("storage", o);
    };
  }
});
function oh() {
}
function Rx(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function ew(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function iN(e) {
  return ew(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function sN(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: r,
    defaultDarkColorScheme: o,
    supportedColorSchemes: a = [],
    modeStorageKey: i = xb,
    colorSchemeStorageKey: l = Cb,
    storageWindow: c = typeof window > "u" ? void 0 : window,
    storageManager: d = aN,
    noSsr: p = !1
  } = e, f = a.join(","), h = a.length > 1, g = x.useMemo(() => d?.({
    key: i,
    storageWindow: c
  }), [d, i, c]), y = x.useMemo(() => d?.({
    key: `${l}-light`,
    storageWindow: c
  }), [d, l, c]), C = x.useMemo(() => d?.({
    key: `${l}-dark`,
    storageWindow: c
  }), [d, l, c]), [b, v] = x.useState(() => {
    const _ = g?.get(t) || t, L = y?.get(r) || r, O = C?.get(o) || o;
    return {
      mode: _,
      systemMode: Rx(_),
      lightColorScheme: L,
      darkColorScheme: O
    };
  }), [T, R] = x.useState(p || !h);
  x.useEffect(() => {
    R(!0);
  }, []);
  const $ = iN(b), E = x.useCallback((_) => {
    v((L) => {
      if (_ === L.mode)
        return L;
      const O = _ ?? t;
      return g?.set(O), {
        ...L,
        mode: O,
        systemMode: Rx(O)
      };
    });
  }, [g, t]), S = x.useCallback((_) => {
    _ ? typeof _ == "string" ? _ && !f.includes(_) ? console.error(`\`${_}\` does not exist in \`theme.colorSchemes\`.`) : v((L) => {
      const O = {
        ...L
      };
      return ew(L, (F) => {
        F === "light" && (y?.set(_), O.lightColorScheme = _), F === "dark" && (C?.set(_), O.darkColorScheme = _);
      }), O;
    }) : v((L) => {
      const O = {
        ...L
      }, F = _.light === null ? r : _.light, B = _.dark === null ? o : _.dark;
      return F && (f.includes(F) ? (O.lightColorScheme = F, y?.set(F)) : console.error(`\`${F}\` does not exist in \`theme.colorSchemes\`.`)), B && (f.includes(B) ? (O.darkColorScheme = B, C?.set(B)) : console.error(`\`${B}\` does not exist in \`theme.colorSchemes\`.`)), O;
    }) : v((L) => (y?.set(r), C?.set(o), {
      ...L,
      lightColorScheme: r,
      darkColorScheme: o
    }));
  }, [f, y, C, r, o]), k = x.useCallback((_) => {
    b.mode === "system" && v((L) => {
      const O = _?.matches ? "dark" : "light";
      return L.systemMode === O ? L : {
        ...L,
        systemMode: O
      };
    });
  }, [b.mode]), A = x.useRef(k);
  return A.current = k, x.useEffect(() => {
    if (typeof window.matchMedia != "function" || !h)
      return;
    const _ = (...O) => A.current(...O), L = window.matchMedia("(prefers-color-scheme: dark)");
    return L.addListener(_), _(L), () => {
      L.removeListener(_);
    };
  }, [h]), x.useEffect(() => {
    if (h) {
      const _ = g?.subscribe((F) => {
        (!F || ["light", "dark", "system"].includes(F)) && E(F || t);
      }) || oh, L = y?.subscribe((F) => {
        (!F || f.match(F)) && S({
          light: F
        });
      }) || oh, O = C?.subscribe((F) => {
        (!F || f.match(F)) && S({
          dark: F
        });
      }) || oh;
      return () => {
        _(), L(), O();
      };
    }
  }, [S, E, f, t, c, h, g, y, C]), {
    ...b,
    mode: T ? b.mode : void 0,
    systemMode: T ? b.systemMode : void 0,
    colorScheme: T ? $ : void 0,
    setMode: E,
    setColorScheme: S
  };
}
const lN = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function cN(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: r = {},
    modeStorageKey: o = xb,
    colorSchemeStorageKey: a = Cb,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: l,
    resolveTheme: c
  } = e, d = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, p = /* @__PURE__ */ x.createContext(void 0);
  process.env.NODE_ENV !== "production" && (p.displayName = "ColorSchemeContext");
  const f = () => x.useContext(p) || d, h = {}, g = {};
  function y(T) {
    const {
      children: R,
      theme: $,
      modeStorageKey: E = o,
      colorSchemeStorageKey: S = a,
      disableTransitionOnChange: k = i,
      storageManager: A,
      storageWindow: _ = typeof window > "u" ? void 0 : window,
      documentNode: L = typeof document > "u" ? void 0 : document,
      colorSchemeNode: O = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: F = !1,
      disableStyleSheetGeneration: B = !1,
      defaultMode: M = "system",
      noSsr: j
    } = T, W = x.useRef(!1), V = vb(), X = x.useContext(p), U = !!X && !F, H = x.useMemo(() => $ || (typeof r == "function" ? r() : r), [$]), Z = H[t], G = Z || H, {
      colorSchemes: ye = h,
      components: de = g,
      cssVarPrefix: ne
    } = G, fe = Object.keys(ye).filter((We) => !!ye[We]).join(","), ie = x.useMemo(() => fe.split(","), [fe]), oe = typeof l == "string" ? l : l.light, ce = typeof l == "string" ? l : l.dark, Ce = ye[oe] && ye[ce] ? M : ye[G.defaultColorScheme]?.palette?.mode || G.palette?.mode, {
      mode: xe,
      setMode: Re,
      systemMode: J,
      lightColorScheme: Ie,
      darkColorScheme: le,
      colorScheme: qe,
      setColorScheme: q
    } = sN({
      supportedColorSchemes: ie,
      defaultLightColorScheme: oe,
      defaultDarkColorScheme: ce,
      modeStorageKey: E,
      colorSchemeStorageKey: S,
      defaultMode: Ce,
      storageManager: A,
      storageWindow: _,
      noSsr: j
    });
    let K = xe, ee = qe;
    U && (K = X.mode, ee = X.colorScheme);
    const he = x.useMemo(() => {
      const We = ee || G.defaultColorScheme, be = G.generateThemeVars?.() || G.vars, Se = {
        ...G,
        components: de,
        colorSchemes: ye,
        cssVarPrefix: ne,
        vars: be
      };
      if (typeof Se.generateSpacing == "function" && (Se.spacing = Se.generateSpacing()), We) {
        const De = ye[We];
        De && typeof De == "object" && Object.keys(De).forEach((Ye) => {
          De[Ye] && typeof De[Ye] == "object" ? Se[Ye] = {
            ...Se[Ye],
            ...De[Ye]
          } : Se[Ye] = De[Ye];
        });
      }
      return c ? c(Se) : Se;
    }, [G, ee, de, ye, ne]), we = G.colorSchemeSelector;
    en(() => {
      if (ee && O && we && we !== "media") {
        const We = we;
        let be = we;
        if (We === "class" && (be = ".%s"), We === "data" && (be = "[data-%s]"), We?.startsWith("data-") && !We.includes("%s") && (be = `[${We}="%s"]`), be.startsWith("."))
          O.classList.remove(...ie.map((Se) => be.substring(1).replace("%s", Se))), O.classList.add(be.substring(1).replace("%s", ee));
        else {
          const Se = be.replace("%s", ee).match(/\[([^\]]+)\]/);
          if (Se) {
            const [De, Ye] = Se[1].split("=");
            Ye || ie.forEach((et) => {
              O.removeAttribute(De.replace(ee, et));
            }), O.setAttribute(De, Ye ? Ye.replace(/"|'/g, "") : "");
          } else
            O.setAttribute(be, ee);
        }
      }
    }, [ee, we, O, ie]), x.useEffect(() => {
      let We;
      if (k && W.current && L) {
        const be = L.createElement("style");
        be.appendChild(L.createTextNode(lN)), L.head.appendChild(be), window.getComputedStyle(L.body), We = setTimeout(() => {
          L.head.removeChild(be);
        }, 1);
      }
      return () => {
        clearTimeout(We);
      };
    }, [ee, k, L]), x.useEffect(() => (W.current = !0, () => {
      W.current = !1;
    }), []);
    const se = x.useMemo(() => ({
      allColorSchemes: ie,
      colorScheme: ee,
      darkColorScheme: le,
      lightColorScheme: Ie,
      mode: K,
      setColorScheme: q,
      setMode: process.env.NODE_ENV === "production" ? Re : (We) => {
        he.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), Re(We);
      },
      systemMode: J
    }), [ie, ee, le, Ie, K, q, Re, J, he.colorSchemeSelector]);
    let ue = !0;
    (B || G.cssVariables === !1 || U && V?.cssVarPrefix === ne) && (ue = !1);
    const Qe = /* @__PURE__ */ P.jsxs(x.Fragment, {
      children: [/* @__PURE__ */ P.jsx(jc, {
        themeId: Z ? t : void 0,
        theme: he,
        children: R
      }), ue && /* @__PURE__ */ P.jsx(ib, {
        styles: he.generateStyleSheets?.() || []
      })]
    });
    return U ? Qe : /* @__PURE__ */ P.jsx(p.Provider, {
      value: se,
      children: Qe
    });
  }
  process.env.NODE_ENV !== "production" && (y.propTypes = {
    /**
     * The component tree.
     */
    children: n.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: n.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: n.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: n.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: n.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: n.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: n.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: n.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: n.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: n.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: n.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: n.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: n.object
  });
  const C = typeof l == "string" ? l : l.light, b = typeof l == "string" ? l : l.dark;
  return {
    CssVarsProvider: y,
    useColorScheme: f,
    getInitColorSchemeScript: (T) => nN({
      colorSchemeStorageKey: a,
      defaultLightColorScheme: C,
      defaultDarkColorScheme: b,
      modeStorageKey: o,
      ...T
    })
  };
}
function uN(e = "") {
  function t(...o) {
    if (!o.length)
      return "";
    const a = o[0];
    return typeof a == "string" && !a.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${a}${t(...o.slice(1))})` : `, ${a}`;
  }
  return (o, ...a) => `var(--${e ? `${e}-` : ""}${o}${t(...a)})`;
}
const Px = (e, t, r, o = []) => {
  let a = e;
  t.forEach((i, l) => {
    l === t.length - 1 ? Array.isArray(a) ? a[Number(i)] = r : a && typeof a == "object" && (a[i] = r) : a && typeof a == "object" && (a[i] || (a[i] = o.includes(i) ? [] : {}), a = a[i]);
  });
}, dN = (e, t, r) => {
  function o(a, i = [], l = []) {
    Object.entries(a).forEach(([c, d]) => {
      (!r || r && !r([...i, c])) && d != null && (typeof d == "object" && Object.keys(d).length > 0 ? o(d, [...i, c], Array.isArray(d) ? [...l, c] : l) : t([...i, c], d, l));
    });
  }
  o(e);
}, pN = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((o) => e.includes(o)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function ah(e, t) {
  const {
    prefix: r,
    shouldSkipGeneratingVar: o
  } = t || {}, a = {}, i = {}, l = {};
  return dN(
    e,
    (c, d, p) => {
      if ((typeof d == "string" || typeof d == "number") && (!o || !o(c, d))) {
        const f = `--${r ? `${r}-` : ""}${c.join("-")}`, h = pN(c, d);
        Object.assign(a, {
          [f]: h
        }), Px(i, c, `var(${f})`, p), Px(l, c, `var(${f}, ${h})`, p);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: a,
    vars: i,
    varsWithDefaults: l
  };
}
function fN(e, t = {}) {
  const {
    getSelector: r = v,
    disableCssColorScheme: o,
    colorSchemeSelector: a
  } = t, {
    colorSchemes: i = {},
    components: l,
    defaultColorScheme: c = "light",
    ...d
  } = e, {
    vars: p,
    css: f,
    varsWithDefaults: h
  } = ah(d, t);
  let g = h;
  const y = {}, {
    [c]: C,
    ...b
  } = i;
  if (Object.entries(b || {}).forEach(([$, E]) => {
    const {
      vars: S,
      css: k,
      varsWithDefaults: A
    } = ah(E, t);
    g = sn(g, A), y[$] = {
      css: k,
      vars: S
    };
  }), C) {
    const {
      css: $,
      vars: E,
      varsWithDefaults: S
    } = ah(C, t);
    g = sn(g, S), y[c] = {
      css: $,
      vars: E
    };
  }
  function v($, E) {
    let S = a;
    if (a === "class" && (S = ".%s"), a === "data" && (S = "[data-%s]"), a?.startsWith("data-") && !a.includes("%s") && (S = `[${a}="%s"]`), $) {
      if (S === "media")
        return e.defaultColorScheme === $ ? ":root" : {
          [`@media (prefers-color-scheme: ${i[$]?.palette?.mode || $})`]: {
            ":root": E
          }
        };
      if (S)
        return e.defaultColorScheme === $ ? `:root, ${S.replace("%s", String($))}` : S.replace("%s", String($));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let $ = {
        ...p
      };
      return Object.entries(y).forEach(([, {
        vars: E
      }]) => {
        $ = sn($, E);
      }), $;
    },
    generateStyleSheets: () => {
      const $ = [], E = e.defaultColorScheme || "light";
      function S(_, L) {
        Object.keys(L).length && $.push(typeof _ == "string" ? {
          [_]: {
            ...L
          }
        } : _);
      }
      S(r(void 0, {
        ...f
      }), f);
      const {
        [E]: k,
        ...A
      } = y;
      if (k) {
        const {
          css: _
        } = k, L = i[E]?.palette?.mode, O = !o && L ? {
          colorScheme: L,
          ..._
        } : {
          ..._
        };
        S(r(E, {
          ...O
        }), O);
      }
      return Object.entries(A).forEach(([_, {
        css: L
      }]) => {
        const O = i[_]?.palette?.mode, F = !o && O ? {
          colorScheme: O,
          ...L
        } : {
          ...L
        };
        S(r(_, {
          ...F
        }), F);
      }), $;
    }
  };
}
function mN(e) {
  return function(r) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && r !== "light" && r !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${r}'.`), `@media (prefers-color-scheme: ${r})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${r}"] &` : e === "class" ? `.${r} &` : e === "data" ? `[data-${r}] &` : `${e.replace("%s", r)} &` : "&";
  };
}
const hN = Bl(), gN = pb("div", {
  name: "MuiContainer",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`maxWidth${re(String(r.maxWidth))}`], r.fixed && t.fixed, r.disableGutters && t.disableGutters];
  }
}), bN = (e) => Qp({
  props: e,
  name: "MuiContainer",
  defaultTheme: hN
}), yN = (e, t) => {
  const r = (d) => Ae(t, d), {
    classes: o,
    fixed: a,
    disableGutters: i,
    maxWidth: l
  } = e, c = {
    root: ["root", l && `maxWidth${re(String(l))}`, a && "fixed", i && "disableGutters"]
  };
  return Me(c, r, o);
};
function vN(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = gN,
    useThemeProps: r = bN,
    componentName: o = "MuiContainer"
  } = e, a = t(({
    theme: l,
    ownerState: c
  }) => ({
    width: "100%",
    marginLeft: "auto",
    boxSizing: "border-box",
    marginRight: "auto",
    ...!c.disableGutters && {
      paddingLeft: l.spacing(2),
      paddingRight: l.spacing(2),
      // @ts-ignore module augmentation fails if custom breakpoints are used
      [l.breakpoints.up("sm")]: {
        paddingLeft: l.spacing(3),
        paddingRight: l.spacing(3)
      }
    }
  }), ({
    theme: l,
    ownerState: c
  }) => c.fixed && Object.keys(l.breakpoints.values).reduce((d, p) => {
    const f = p, h = l.breakpoints.values[f];
    return h !== 0 && (d[l.breakpoints.up(f)] = {
      maxWidth: `${h}${l.breakpoints.unit}`
    }), d;
  }, {}), ({
    theme: l,
    ownerState: c
  }) => ({
    // @ts-ignore module augmentation fails if custom breakpoints are used
    ...c.maxWidth === "xs" && {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      [l.breakpoints.up("xs")]: {
        // @ts-ignore module augmentation fails if custom breakpoints are used
        maxWidth: Math.max(l.breakpoints.values.xs, 444)
      }
    },
    ...c.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
    c.maxWidth !== "xs" && {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      [l.breakpoints.up(c.maxWidth)]: {
        // @ts-ignore module augmentation fails if custom breakpoints are used
        maxWidth: `${l.breakpoints.values[c.maxWidth]}${l.breakpoints.unit}`
      }
    }
  })), i = /* @__PURE__ */ x.forwardRef(function(c, d) {
    const p = r(c), {
      className: f,
      component: h = "div",
      disableGutters: g = !1,
      fixed: y = !1,
      maxWidth: C = "lg",
      classes: b,
      ...v
    } = p, T = {
      ...p,
      component: h,
      disableGutters: g,
      fixed: y,
      maxWidth: C
    }, R = yN(T, o);
    return (
      // @ts-ignore theme is injected by the styled util
      /* @__PURE__ */ P.jsx(a, {
        as: h,
        ownerState: T,
        className: ge(R.root, f),
        ref: d,
        ...v
      })
    );
  });
  return process.env.NODE_ENV !== "production" && (i.propTypes = {
    children: n.node,
    classes: n.object,
    className: n.string,
    component: n.elementType,
    disableGutters: n.bool,
    fixed: n.bool,
    maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
  }), i;
}
const xN = (e, t) => e.filter((r) => t.includes(r)), Dl = (e, t, r) => {
  const o = e.keys[0];
  Array.isArray(t) ? t.forEach((a, i) => {
    r((l, c) => {
      i <= e.keys.length - 1 && (i === 0 ? Object.assign(l, c) : l[e.up(e.keys[i])] = c);
    }, a);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : xN(e.keys, Object.keys(t))).forEach((i) => {
    if (e.keys.includes(i)) {
      const l = t[i];
      l !== void 0 && r((c, d) => {
        o === i ? Object.assign(c, d) : c[e.up(i)] = d;
      }, l);
    }
  }) : (typeof t == "number" || typeof t == "string") && r((a, i) => {
    Object.assign(a, i);
  }, t);
};
function dp(e) {
  return `--Grid-${e}Spacing`;
}
function rf(e) {
  return `--Grid-parent-${e}Spacing`;
}
const kx = "--Grid-columns", hl = "--Grid-parent-columns", CN = ({
  theme: e,
  ownerState: t
}) => {
  const r = {};
  return Dl(e.breakpoints, t.size, (o, a) => {
    let i = {};
    a === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), a === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof a == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${a} / var(${hl}) - (var(${hl}) - ${a}) * (var(${rf("column")}) / var(${hl})))`
    }), o(r, i);
  }), r;
}, SN = ({
  theme: e,
  ownerState: t
}) => {
  const r = {};
  return Dl(e.breakpoints, t.offset, (o, a) => {
    let i = {};
    a === "auto" && (i = {
      marginLeft: "auto"
    }), typeof a == "number" && (i = {
      marginLeft: a === 0 ? "0px" : `calc(100% * ${a} / var(${hl}) + var(${rf("column")}) * ${a} / var(${hl}))`
    }), o(r, i);
  }), r;
}, wN = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = {
    [kx]: 12
  };
  return Dl(e.breakpoints, t.columns, (o, a) => {
    const i = a ?? 12;
    o(r, {
      [kx]: i,
      "> *": {
        [hl]: i
      }
    });
  }), r;
}, TN = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = {};
  return Dl(e.breakpoints, t.rowSpacing, (o, a) => {
    const i = typeof a == "string" ? a : e.spacing?.(a);
    o(r, {
      [dp("row")]: i,
      "> *": {
        [rf("row")]: i
      }
    });
  }), r;
}, EN = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = {};
  return Dl(e.breakpoints, t.columnSpacing, (o, a) => {
    const i = typeof a == "string" ? a : e.spacing?.(a);
    o(r, {
      [dp("column")]: i,
      "> *": {
        [rf("column")]: i
      }
    });
  }), r;
}, ON = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = {};
  return Dl(e.breakpoints, t.direction, (o, a) => {
    o(r, {
      flexDirection: a
    });
  }), r;
}, $N = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${dp("row")}) var(${dp("column")})`
  }
}), RN = (e) => {
  const t = [];
  return Object.entries(e).forEach(([r, o]) => {
    o !== !1 && o !== void 0 && t.push(`grid-${r}-${String(o)}`);
  }), t;
}, PN = (e, t = "xs") => {
  function r(o) {
    return o === void 0 ? !1 : typeof o == "string" && !Number.isNaN(Number(o)) || typeof o == "number" && o > 0;
  }
  if (r(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const o = [];
    return Object.entries(e).forEach(([a, i]) => {
      r(i) && o.push(`spacing-${a}-${String(i)}`);
    }), o;
  }
  return [];
}, kN = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, r]) => `direction-${t}-${r}`) : [`direction-xs-${String(e)}`], AN = (e) => ["item", "zeroMinWidth"].includes(e) ? `The \`${e}\` prop has been removed and is no longer necessary. You can safely remove it.` : `The \`${e}\` prop has been removed. See https://v6.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`, Ax = [];
function IN(e, t) {
  const r = [];
  e.item !== void 0 && (delete e.item, r.push("item")), e.zeroMinWidth !== void 0 && (delete e.zeroMinWidth, r.push("zeroMinWidth")), t.keys.forEach((o) => {
    e[o] !== void 0 && (r.push(o), delete e[o]);
  }), process.env.NODE_ENV !== "production" && r.forEach((o) => {
    Ax.includes(o) || (Ax.push(o), console.warn(`MUI Grid2: ${AN(o)}
`));
  });
}
const NN = Bl(), MN = pb("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function _N(e) {
  return Qp({
    props: e,
    name: "MuiGrid",
    defaultTheme: NN
  });
}
function FN(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = MN,
    useThemeProps: r = _N,
    useTheme: o = su,
    componentName: a = "MuiGrid"
  } = e, i = (p, f) => {
    const {
      container: h,
      direction: g,
      spacing: y,
      wrap: C,
      size: b
    } = p, v = {
      root: ["root", h && "container", C !== "wrap" && `wrap-xs-${String(C)}`, ...kN(g), ...RN(b), ...h ? PN(y, f.breakpoints.keys[0]) : []]
    };
    return Me(v, (T) => Ae(a, T), {});
  };
  function l(p, f, h = () => !0) {
    const g = {};
    return p === null || (Array.isArray(p) ? p.forEach((y, C) => {
      y !== null && h(y) && f.keys[C] && (g[f.keys[C]] = y);
    }) : typeof p == "object" ? Object.keys(p).forEach((y) => {
      const C = p[y];
      C != null && h(C) && (g[y] = C);
    }) : g[f.keys[0]] = p), g;
  }
  const c = t(wN, EN, TN, CN, ON, $N, SN), d = /* @__PURE__ */ x.forwardRef(function(f, h) {
    const g = o(), y = r(f), C = lu(y);
    IN(C, g.breakpoints);
    const {
      className: b,
      children: v,
      columns: T = 12,
      container: R = !1,
      component: $ = "div",
      direction: E = "row",
      wrap: S = "wrap",
      size: k = {},
      offset: A = {},
      spacing: _ = 0,
      rowSpacing: L = _,
      columnSpacing: O = _,
      unstable_level: F = 0,
      ...B
    } = C, M = l(k, g.breakpoints, (G) => G !== !1), j = l(A, g.breakpoints), W = f.columns ?? (F ? void 0 : T), V = f.spacing ?? (F ? void 0 : _), X = f.rowSpacing ?? f.spacing ?? (F ? void 0 : L), U = f.columnSpacing ?? f.spacing ?? (F ? void 0 : O), H = {
      ...C,
      level: F,
      columns: W,
      container: R,
      direction: E,
      wrap: S,
      spacing: V,
      rowSpacing: X,
      columnSpacing: U,
      size: M,
      offset: j
    }, Z = i(H, g);
    return /* @__PURE__ */ P.jsx(c, {
      ref: h,
      as: $,
      ownerState: H,
      className: ge(Z.root, b),
      ...B,
      children: x.Children.map(v, (G) => /* @__PURE__ */ x.isValidElement(G) && wa(G, ["Grid"]) && R && G.props.container ? /* @__PURE__ */ x.cloneElement(G, {
        unstable_level: G.props?.unstable_level ?? F + 1
      }) : G)
    });
  });
  return process.env.NODE_ENV !== "production" && (d.propTypes = {
    children: n.node,
    className: n.string,
    columns: n.oneOfType([n.arrayOf(n.number), n.number, n.object]),
    columnSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    component: n.elementType,
    container: n.bool,
    direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
    offset: n.oneOfType([n.string, n.number, n.arrayOf(n.oneOfType([n.string, n.number])), n.object]),
    rowSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    size: n.oneOfType([n.string, n.bool, n.number, n.arrayOf(n.oneOfType([n.string, n.bool, n.number])), n.object]),
    spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
    wrap: n.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), d.muiName = "Grid", d;
}
const LN = Bl(), BN = pb("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function DN(e) {
  return Qp({
    props: e,
    name: "MuiStack",
    defaultTheme: LN
  });
}
function jN(e, t) {
  const r = x.Children.toArray(e).filter(Boolean);
  return r.reduce((o, a, i) => (o.push(a), i < r.length - 1 && o.push(/* @__PURE__ */ x.cloneElement(t, {
    key: `separator-${i}`
  })), o), []);
}
const zN = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], VN = ({
  ownerState: e,
  theme: t
}) => {
  let r = {
    display: "flex",
    flexDirection: "column",
    ...Qn({
      theme: t
    }, hs({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (o) => ({
      flexDirection: o
    }))
  };
  if (e.spacing) {
    const o = Gp(t), a = Object.keys(t.breakpoints.values).reduce((d, p) => ((typeof e.spacing == "object" && e.spacing[p] != null || typeof e.direction == "object" && e.direction[p] != null) && (d[p] = !0), d), {}), i = hs({
      values: e.direction,
      base: a
    }), l = hs({
      values: e.spacing,
      base: a
    });
    typeof i == "object" && Object.keys(i).forEach((d, p, f) => {
      if (!i[d]) {
        const g = p > 0 ? i[f[p - 1]] : "column";
        i[d] = g;
      }
    }), r = sn(r, Qn({
      theme: t
    }, l, (d, p) => e.useFlexGap ? {
      gap: ws(o, d)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${zN(p ? i[p] : e.direction)}`]: ws(o, d)
      }
    }));
  }
  return r = k9(t.breakpoints, r), r;
};
function WN(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = BN,
    useThemeProps: r = DN,
    componentName: o = "MuiStack"
  } = e, a = () => Me({
    root: ["root"]
  }, (d) => Ae(o, d), {}), i = t(VN), l = /* @__PURE__ */ x.forwardRef(function(d, p) {
    const f = r(d), h = lu(f), {
      component: g = "div",
      direction: y = "column",
      spacing: C = 0,
      divider: b,
      children: v,
      className: T,
      useFlexGap: R = !1,
      ...$
    } = h, E = {
      direction: y,
      spacing: C,
      useFlexGap: R
    }, S = a();
    return /* @__PURE__ */ P.jsx(i, {
      as: g,
      ownerState: E,
      ref: p,
      className: ge(S.root, T),
      ...$,
      children: b ? jN(v, b) : v
    });
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: n.node,
    direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
    divider: n.node,
    spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
  }), l;
}
function UN(e) {
  process.env.NODE_ENV !== "production" && console.warn(["MUI: adaptV4Theme() is deprecated.", "Follow the upgrade guide on https://mui.com/r/migration-v4#theme."].join(`
`));
  const {
    defaultProps: t = {},
    mixins: r = {},
    overrides: o = {},
    palette: a = {},
    props: i = {},
    styleOverrides: l = {},
    ...c
  } = e, d = {
    ...c,
    components: {}
  };
  Object.keys(t).forEach((b) => {
    const v = d.components[b] || {};
    v.defaultProps = t[b], d.components[b] = v;
  }), Object.keys(i).forEach((b) => {
    const v = d.components[b] || {};
    v.defaultProps = i[b], d.components[b] = v;
  }), Object.keys(l).forEach((b) => {
    const v = d.components[b] || {};
    v.styleOverrides = l[b], d.components[b] = v;
  }), Object.keys(o).forEach((b) => {
    const v = d.components[b] || {};
    v.styleOverrides = o[b], d.components[b] = v;
  }), d.spacing = lb(e.spacing);
  const p = sb(e.breakpoints || {}), f = d.spacing;
  d.mixins = {
    gutters: (b = {}) => ({
      paddingLeft: f(2),
      paddingRight: f(2),
      ...b,
      [p.up("sm")]: {
        paddingLeft: f(3),
        paddingRight: f(3),
        ...b[p.up("sm")]
      }
    }),
    ...r
  };
  const {
    type: h,
    mode: g,
    ...y
  } = a, C = g || h || "light";
  return d.palette = {
    // theme.palette.text.hint
    text: {
      hint: C === "dark" ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.38)"
    },
    mode: C,
    type: C,
    ...y
  }, d;
}
function tw() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Cl.white,
      default: Cl.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const HN = tw();
function rw() {
  return {
    text: {
      primary: Cl.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Cl.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Ix = rw();
function Nx(e, t, r, o) {
  const a = o.light || o, i = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = oa(e.main, a) : t === "dark" && (e.dark = na(e.main, i)));
}
function GN(e = "light") {
  return e === "dark" ? {
    main: es[200],
    light: es[50],
    dark: es[400]
  } : {
    main: es[700],
    light: es[400],
    dark: es[800]
  };
}
function qN(e = "light") {
  return e === "dark" ? {
    main: Qi[200],
    light: Qi[50],
    dark: Qi[400]
  } : {
    main: Qi[500],
    light: Qi[300],
    dark: Qi[700]
  };
}
function KN(e = "light") {
  return e === "dark" ? {
    main: Ji[500],
    light: Ji[300],
    dark: Ji[700]
  } : {
    main: Ji[700],
    light: Ji[400],
    dark: Ji[800]
  };
}
function YN(e = "light") {
  return e === "dark" ? {
    main: ts[400],
    light: ts[300],
    dark: ts[700]
  } : {
    main: ts[700],
    light: ts[500],
    dark: ts[900]
  };
}
function ZN(e = "light") {
  return e === "dark" ? {
    main: rs[400],
    light: rs[300],
    dark: rs[700]
  } : {
    main: rs[800],
    light: rs[500],
    dark: rs[900]
  };
}
function XN(e = "light") {
  return e === "dark" ? {
    main: nl[400],
    light: nl[300],
    dark: nl[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: nl[500],
    dark: nl[900]
  };
}
function Sb(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: o = 0.2,
    ...a
  } = e, i = e.primary || GN(t), l = e.secondary || qN(t), c = e.error || KN(t), d = e.info || YN(t), p = e.success || ZN(t), f = e.warning || XN(t);
  function h(b) {
    const v = ng(b, Ix.text.primary) >= r ? Ix.text.primary : HN.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const T = ng(b, v);
      T < 3 && console.error([`MUI: The contrast ratio of ${T}:1 for ${v} on ${b}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return v;
  }
  const g = ({
    color: b,
    name: v,
    mainShade: T = 500,
    lightShade: R = 300,
    darkShade: $ = 700
  }) => {
    if (b = {
      ...b
    }, !b.main && b[T] && (b.main = b[T]), !b.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${T}\` property.` : jn(11, v ? ` (${v})` : "", T));
    if (typeof b.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(b.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : jn(12, v ? ` (${v})` : "", JSON.stringify(b.main)));
    return Nx(b, "light", R, o), Nx(b, "dark", $, o), b.contrastText || (b.contrastText = h(b.main)), b;
  };
  let y;
  return t === "light" ? y = tw() : t === "dark" && (y = rw()), process.env.NODE_ENV !== "production" && (y || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), sn({
    // A collection of common colors.
    common: {
      ...Cl
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: l,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: d,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: p,
      name: "success"
    }),
    // The grey colors.
    grey: c2,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: h,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o,
    // The light and dark mode object.
    ...y
  }, a);
}
function JN(e) {
  const t = {};
  return Object.entries(e).forEach((o) => {
    const [a, i] = o;
    typeof i == "object" && (t[a] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function nw(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function QN(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Mx = {
  textTransform: "uppercase"
}, _x = '"Roboto", "Helvetica", "Arial", sans-serif';
function wb(e, t) {
  const {
    fontFamily: r = _x,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: p,
    pxToRem: f,
    ...h
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = o / 14, y = f || ((v) => `${v / d * g}rem`), C = (v, T, R, $, E) => ({
    fontFamily: r,
    fontWeight: v,
    fontSize: y(T),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: R,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...r === _x ? {
      letterSpacing: `${QN($ / T)}em`
    } : {},
    ...E,
    ...p
  }), b = {
    h1: C(a, 96, 1.167, -1.5),
    h2: C(a, 60, 1.2, -0.5),
    h3: C(i, 48, 1.167, 0),
    h4: C(i, 34, 1.235, 0.25),
    h5: C(i, 24, 1.334, 0),
    h6: C(l, 20, 1.6, 0.15),
    subtitle1: C(i, 16, 1.75, 0.15),
    subtitle2: C(l, 14, 1.57, 0.1),
    body1: C(i, 16, 1.5, 0.15),
    body2: C(i, 14, 1.43, 0.15),
    button: C(l, 14, 1.75, 0.4, Mx),
    caption: C(i, 12, 1.66, 0.4),
    overline: C(i, 12, 2.66, 1, Mx),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return sn({
    htmlFontSize: d,
    pxToRem: y,
    fontFamily: r,
    fontSize: o,
    fontWeightLight: a,
    fontWeightRegular: i,
    fontWeightMedium: l,
    fontWeightBold: c,
    ...b
  }, h, {
    clone: !1
    // No need to clone deep
  });
}
const eM = 0.2, tM = 0.14, rM = 0.12;
function Mr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${eM})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${tM})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${rM})`].join(",");
}
const nM = ["none", Mr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Mr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Mr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Mr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Mr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Mr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Mr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Mr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Mr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Mr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Mr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Mr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Mr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Mr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Mr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Mr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Mr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Mr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Mr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Mr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Mr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Mr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Mr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Mr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ow = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Tb = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Fx(e) {
  return `${Math.round(e)}ms`;
}
function oM(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function aw(e) {
  const t = {
    ...ow,
    ...e.easing
  }, r = {
    ...Tb,
    ...e.duration
  };
  return {
    getAutoHeightDuration: oM,
    create: (a = ["all"], i = {}) => {
      const {
        duration: l = r.standard,
        easing: c = t.easeInOut,
        delay: d = 0,
        ...p
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const f = (g) => typeof g == "string", h = (g) => !Number.isNaN(parseFloat(g));
        !f(a) && !Array.isArray(a) && console.error('MUI: Argument "props" must be a string or Array.'), !h(l) && !f(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), f(c) || console.error('MUI: Argument "easing" must be a string.'), !h(d) && !f(d) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(p).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(p).join(",")}].`);
      }
      return (Array.isArray(a) ? a : [a]).map((f) => `${f} ${typeof l == "string" ? l : Fx(l)} ${c} ${typeof d == "string" ? d : Fx(d)}`).join(",");
    },
    ...e,
    easing: t,
    duration: r
  };
}
const aM = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function iM(e) {
  return xa(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function iw(e = {}) {
  const t = {
    ...e
  };
  function r(o) {
    const a = Object.entries(o);
    for (let i = 0; i < a.length; i++) {
      const [l, c] = a[i];
      !iM(c) || l.startsWith("unstable_") ? delete o[l] : xa(c) && (o[l] = {
        ...c
      }, r(o[l]));
    }
  }
  return r(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function pp(e = {}, ...t) {
  const {
    breakpoints: r,
    mixins: o = {},
    spacing: a,
    palette: i = {},
    transitions: l = {},
    typography: c = {},
    shape: d,
    ...p
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : jn(20));
  const f = Sb(i), h = Bl(e);
  let g = sn(h, {
    mixins: nw(h.breakpoints, o),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: nM.slice(),
    typography: wb(f, c),
    transitions: aw(l),
    zIndex: {
      ...aM
    }
  });
  if (g = sn(g, p), g = t.reduce((y, C) => sn(y, C), g), process.env.NODE_ENV !== "production") {
    const y = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], C = (b, v) => {
      let T;
      for (T in b) {
        const R = b[T];
        if (y.includes(T) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const $ = Ae("", T);
            console.error([`MUI: The \`${v}\` component increases the CSS specificity of the \`${T}\` internal state.`, "You can not override it like this: ", JSON.stringify(b, null, 2), "", `Instead, you need to use the '&.${$}' syntax:`, JSON.stringify({
              root: {
                [`&.${$}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          b[T] = {};
        }
      }
    };
    Object.keys(g.components).forEach((b) => {
      const v = g.components[b].styleOverrides;
      v && b.startsWith("Mui") && C(v, b);
    });
  }
  return g.unstable_sxConfig = {
    ...iu,
    ...p?.unstable_sxConfig
  }, g.unstable_sx = function(C) {
    return Ii({
      sx: C,
      theme: this
    });
  }, g.toRuntimeSource = iw, g;
}
let Lx = !1;
function sM(...e) {
  return process.env.NODE_ENV !== "production" && (Lx || (Lx = !0, console.error(["MUI: the createMuiTheme function was renamed to createTheme.", "", "You should use `import { createTheme } from '@mui/material/styles'`"].join(`
`)))), pp(...e);
}
function fp(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const lM = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const r = fp(t);
  return `linear-gradient(rgba(255 255 255 / ${r}), rgba(255 255 255 / ${r}))`;
});
function sw(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function lw(e) {
  return e === "dark" ? lM : [];
}
function cw(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: r,
    overlays: o,
    ...a
  } = e, i = Sb(t);
  return {
    palette: i,
    opacity: {
      ...sw(i.mode),
      ...r
    },
    overlays: o || lw(i.mode),
    ...a
  };
}
function uw(e) {
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const dw = (e) => [...[...Array(25)].map((t, r) => `--${e ? `${e}-` : ""}overlays-${r}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], cM = (e) => (t, r) => {
  const o = e.rootSelector || ":root", a = e.colorSchemeSelector;
  let i = a;
  if (a === "class" && (i = ".%s"), a === "data" && (i = "[data-%s]"), a?.startsWith("data-") && !a.includes("%s") && (i = `[${a}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const l = {};
      return dw(e.cssVarPrefix).forEach((c) => {
        l[c] = r[c], delete r[c];
      }), i === "media" ? {
        [o]: r,
        "@media (prefers-color-scheme: dark)": {
          [o]: l
        }
      } : i ? {
        [i.replace("%s", t)]: l,
        [`${o}, ${i.replace("%s", t)}`]: r
      } : {
        [o]: {
          ...r,
          ...l
        }
      };
    }
    if (i && i !== "media")
      return `${o}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [o]: r
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return o;
};
function uM(e, t) {
  t.forEach((r) => {
    e[r] || (e[r] = {});
  });
}
function Pe(e, t, r) {
  !e[t] && r && (e[t] = r);
}
function Cc(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : hb(e);
}
function Va(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = xc(Cc(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function dM(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const ma = (e) => {
  try {
    return e();
  } catch {
  }
}, pM = (e = "mui") => uN(e);
function ih(e, t, r, o) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const a = o === "dark" ? "dark" : "light";
  if (!r) {
    e[o] = cw({
      ...t,
      palette: {
        mode: a,
        ...t?.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...l
  } = pp({
    ...r,
    palette: {
      mode: a,
      ...t?.palette
    }
  });
  return e[o] = {
    ...t,
    palette: i,
    opacity: {
      ...sw(a),
      ...t?.opacity
    },
    overlays: t?.overlays || lw(a)
  }, l;
}
function Eb(e = {}, ...t) {
  const {
    colorSchemes: r = {
      light: !0
    },
    defaultColorScheme: o,
    disableCssColorScheme: a = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: l = uw,
    colorSchemeSelector: c = r.light && r.dark ? "media" : void 0,
    rootSelector: d = ":root",
    ...p
  } = e, f = Object.keys(r)[0], h = o || (r.light && f !== "light" ? "light" : f), g = pM(i), {
    [h]: y,
    light: C,
    dark: b,
    ...v
  } = r, T = {
    ...v
  };
  let R = y;
  if ((h === "dark" && !("dark" in r) || h === "light" && !("light" in r)) && (R = !0), !R)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${h}\` option is either missing or invalid.` : jn(21, h));
  const $ = ih(T, R, p, h);
  C && !T.light && ih(T, C, void 0, "light"), b && !T.dark && ih(T, b, void 0, "dark");
  let E = {
    defaultColorScheme: h,
    ...$,
    cssVarPrefix: i,
    colorSchemeSelector: c,
    rootSelector: d,
    getCssVar: g,
    colorSchemes: T,
    font: {
      ...JN($.typography),
      ...$.font
    },
    spacing: dM(p.spacing)
  };
  Object.keys(E.colorSchemes).forEach((L) => {
    const O = E.colorSchemes[L].palette, F = (B) => {
      const M = B.split("-"), j = M[1], W = M[2];
      return g(B, O[j][W]);
    };
    if (O.mode === "light" && (Pe(O.common, "background", "#fff"), Pe(O.common, "onBackground", "#000")), O.mode === "dark" && (Pe(O.common, "background", "#000"), Pe(O.common, "onBackground", "#fff")), uM(O, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), O.mode === "light") {
      Pe(O.Alert, "errorColor", vr(O.error.light, 0.6)), Pe(O.Alert, "infoColor", vr(O.info.light, 0.6)), Pe(O.Alert, "successColor", vr(O.success.light, 0.6)), Pe(O.Alert, "warningColor", vr(O.warning.light, 0.6)), Pe(O.Alert, "errorFilledBg", F("palette-error-main")), Pe(O.Alert, "infoFilledBg", F("palette-info-main")), Pe(O.Alert, "successFilledBg", F("palette-success-main")), Pe(O.Alert, "warningFilledBg", F("palette-warning-main")), Pe(O.Alert, "errorFilledColor", ma(() => O.getContrastText(O.error.main))), Pe(O.Alert, "infoFilledColor", ma(() => O.getContrastText(O.info.main))), Pe(O.Alert, "successFilledColor", ma(() => O.getContrastText(O.success.main))), Pe(O.Alert, "warningFilledColor", ma(() => O.getContrastText(O.warning.main))), Pe(O.Alert, "errorStandardBg", xr(O.error.light, 0.9)), Pe(O.Alert, "infoStandardBg", xr(O.info.light, 0.9)), Pe(O.Alert, "successStandardBg", xr(O.success.light, 0.9)), Pe(O.Alert, "warningStandardBg", xr(O.warning.light, 0.9)), Pe(O.Alert, "errorIconColor", F("palette-error-main")), Pe(O.Alert, "infoIconColor", F("palette-info-main")), Pe(O.Alert, "successIconColor", F("palette-success-main")), Pe(O.Alert, "warningIconColor", F("palette-warning-main")), Pe(O.AppBar, "defaultBg", F("palette-grey-100")), Pe(O.Avatar, "defaultBg", F("palette-grey-400")), Pe(O.Button, "inheritContainedBg", F("palette-grey-300")), Pe(O.Button, "inheritContainedHoverBg", F("palette-grey-A100")), Pe(O.Chip, "defaultBorder", F("palette-grey-400")), Pe(O.Chip, "defaultAvatarColor", F("palette-grey-700")), Pe(O.Chip, "defaultIconColor", F("palette-grey-700")), Pe(O.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Pe(O.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Pe(O.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Pe(O.LinearProgress, "primaryBg", xr(O.primary.main, 0.62)), Pe(O.LinearProgress, "secondaryBg", xr(O.secondary.main, 0.62)), Pe(O.LinearProgress, "errorBg", xr(O.error.main, 0.62)), Pe(O.LinearProgress, "infoBg", xr(O.info.main, 0.62)), Pe(O.LinearProgress, "successBg", xr(O.success.main, 0.62)), Pe(O.LinearProgress, "warningBg", xr(O.warning.main, 0.62)), Pe(O.Skeleton, "bg", `rgba(${F("palette-text-primaryChannel")} / 0.11)`), Pe(O.Slider, "primaryTrack", xr(O.primary.main, 0.62)), Pe(O.Slider, "secondaryTrack", xr(O.secondary.main, 0.62)), Pe(O.Slider, "errorTrack", xr(O.error.main, 0.62)), Pe(O.Slider, "infoTrack", xr(O.info.main, 0.62)), Pe(O.Slider, "successTrack", xr(O.success.main, 0.62)), Pe(O.Slider, "warningTrack", xr(O.warning.main, 0.62));
      const B = yd(O.background.default, 0.8);
      Pe(O.SnackbarContent, "bg", B), Pe(O.SnackbarContent, "color", ma(() => O.getContrastText(B))), Pe(O.SpeedDialAction, "fabHoverBg", yd(O.background.paper, 0.15)), Pe(O.StepConnector, "border", F("palette-grey-400")), Pe(O.StepContent, "border", F("palette-grey-400")), Pe(O.Switch, "defaultColor", F("palette-common-white")), Pe(O.Switch, "defaultDisabledColor", F("palette-grey-100")), Pe(O.Switch, "primaryDisabledColor", xr(O.primary.main, 0.62)), Pe(O.Switch, "secondaryDisabledColor", xr(O.secondary.main, 0.62)), Pe(O.Switch, "errorDisabledColor", xr(O.error.main, 0.62)), Pe(O.Switch, "infoDisabledColor", xr(O.info.main, 0.62)), Pe(O.Switch, "successDisabledColor", xr(O.success.main, 0.62)), Pe(O.Switch, "warningDisabledColor", xr(O.warning.main, 0.62)), Pe(O.TableCell, "border", xr(bd(O.divider, 1), 0.88)), Pe(O.Tooltip, "bg", bd(O.grey[700], 0.92));
    }
    if (O.mode === "dark") {
      Pe(O.Alert, "errorColor", xr(O.error.light, 0.6)), Pe(O.Alert, "infoColor", xr(O.info.light, 0.6)), Pe(O.Alert, "successColor", xr(O.success.light, 0.6)), Pe(O.Alert, "warningColor", xr(O.warning.light, 0.6)), Pe(O.Alert, "errorFilledBg", F("palette-error-dark")), Pe(O.Alert, "infoFilledBg", F("palette-info-dark")), Pe(O.Alert, "successFilledBg", F("palette-success-dark")), Pe(O.Alert, "warningFilledBg", F("palette-warning-dark")), Pe(O.Alert, "errorFilledColor", ma(() => O.getContrastText(O.error.dark))), Pe(O.Alert, "infoFilledColor", ma(() => O.getContrastText(O.info.dark))), Pe(O.Alert, "successFilledColor", ma(() => O.getContrastText(O.success.dark))), Pe(O.Alert, "warningFilledColor", ma(() => O.getContrastText(O.warning.dark))), Pe(O.Alert, "errorStandardBg", vr(O.error.light, 0.9)), Pe(O.Alert, "infoStandardBg", vr(O.info.light, 0.9)), Pe(O.Alert, "successStandardBg", vr(O.success.light, 0.9)), Pe(O.Alert, "warningStandardBg", vr(O.warning.light, 0.9)), Pe(O.Alert, "errorIconColor", F("palette-error-main")), Pe(O.Alert, "infoIconColor", F("palette-info-main")), Pe(O.Alert, "successIconColor", F("palette-success-main")), Pe(O.Alert, "warningIconColor", F("palette-warning-main")), Pe(O.AppBar, "defaultBg", F("palette-grey-900")), Pe(O.AppBar, "darkBg", F("palette-background-paper")), Pe(O.AppBar, "darkColor", F("palette-text-primary")), Pe(O.Avatar, "defaultBg", F("palette-grey-600")), Pe(O.Button, "inheritContainedBg", F("palette-grey-800")), Pe(O.Button, "inheritContainedHoverBg", F("palette-grey-700")), Pe(O.Chip, "defaultBorder", F("palette-grey-700")), Pe(O.Chip, "defaultAvatarColor", F("palette-grey-300")), Pe(O.Chip, "defaultIconColor", F("palette-grey-300")), Pe(O.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Pe(O.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Pe(O.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Pe(O.LinearProgress, "primaryBg", vr(O.primary.main, 0.5)), Pe(O.LinearProgress, "secondaryBg", vr(O.secondary.main, 0.5)), Pe(O.LinearProgress, "errorBg", vr(O.error.main, 0.5)), Pe(O.LinearProgress, "infoBg", vr(O.info.main, 0.5)), Pe(O.LinearProgress, "successBg", vr(O.success.main, 0.5)), Pe(O.LinearProgress, "warningBg", vr(O.warning.main, 0.5)), Pe(O.Skeleton, "bg", `rgba(${F("palette-text-primaryChannel")} / 0.13)`), Pe(O.Slider, "primaryTrack", vr(O.primary.main, 0.5)), Pe(O.Slider, "secondaryTrack", vr(O.secondary.main, 0.5)), Pe(O.Slider, "errorTrack", vr(O.error.main, 0.5)), Pe(O.Slider, "infoTrack", vr(O.info.main, 0.5)), Pe(O.Slider, "successTrack", vr(O.success.main, 0.5)), Pe(O.Slider, "warningTrack", vr(O.warning.main, 0.5));
      const B = yd(O.background.default, 0.98);
      Pe(O.SnackbarContent, "bg", B), Pe(O.SnackbarContent, "color", ma(() => O.getContrastText(B))), Pe(O.SpeedDialAction, "fabHoverBg", yd(O.background.paper, 0.15)), Pe(O.StepConnector, "border", F("palette-grey-600")), Pe(O.StepContent, "border", F("palette-grey-600")), Pe(O.Switch, "defaultColor", F("palette-grey-300")), Pe(O.Switch, "defaultDisabledColor", F("palette-grey-600")), Pe(O.Switch, "primaryDisabledColor", vr(O.primary.main, 0.55)), Pe(O.Switch, "secondaryDisabledColor", vr(O.secondary.main, 0.55)), Pe(O.Switch, "errorDisabledColor", vr(O.error.main, 0.55)), Pe(O.Switch, "infoDisabledColor", vr(O.info.main, 0.55)), Pe(O.Switch, "successDisabledColor", vr(O.success.main, 0.55)), Pe(O.Switch, "warningDisabledColor", vr(O.warning.main, 0.55)), Pe(O.TableCell, "border", vr(bd(O.divider, 1), 0.68)), Pe(O.Tooltip, "bg", bd(O.grey[700], 0.92));
    }
    Va(O.background, "default"), Va(O.background, "paper"), Va(O.common, "background"), Va(O.common, "onBackground"), Va(O, "divider"), Object.keys(O).forEach((B) => {
      const M = O[B];
      B !== "tonalOffset" && M && typeof M == "object" && (M.main && Pe(O[B], "mainChannel", xc(Cc(M.main))), M.light && Pe(O[B], "lightChannel", xc(Cc(M.light))), M.dark && Pe(O[B], "darkChannel", xc(Cc(M.dark))), M.contrastText && Pe(O[B], "contrastTextChannel", xc(Cc(M.contrastText))), B === "text" && (Va(O[B], "primary"), Va(O[B], "secondary")), B === "action" && (M.active && Va(O[B], "active"), M.selected && Va(O[B], "selected")));
    });
  }), E = t.reduce((L, O) => sn(L, O), E);
  const S = {
    prefix: i,
    disableCssColorScheme: a,
    shouldSkipGeneratingVar: l,
    getSelector: cM(E)
  }, {
    vars: k,
    generateThemeVars: A,
    generateStyleSheets: _
  } = fN(E, S);
  return E.vars = k, Object.entries(E.colorSchemes[E.defaultColorScheme]).forEach(([L, O]) => {
    E[L] = O;
  }), E.generateThemeVars = A, E.generateStyleSheets = _, E.generateSpacing = function() {
    return lb(p.spacing, Gp(this));
  }, E.getColorSchemeSelector = mN(c), E.spacing = E.generateSpacing(), E.shouldSkipGeneratingVar = l, E.unstable_sxConfig = {
    ...iu,
    ...p?.unstable_sxConfig
  }, E.unstable_sx = function(O) {
    return Ii({
      sx: O,
      theme: this
    });
  }, E.toRuntimeSource = iw, E;
}
function Bx(e, t, r) {
  e.colorSchemes && r && (e.colorSchemes[t] = {
    ...r !== !0 && r,
    palette: Sb({
      ...r === !0 ? {} : r.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function uu(e = {}, ...t) {
  const {
    palette: r,
    cssVariables: o = !1,
    colorSchemes: a = r ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = r?.mode,
    ...l
  } = e, c = i || "light", d = a?.[c], p = {
    ...a,
    ...r ? {
      [c]: {
        ...typeof d != "boolean" && d,
        palette: r
      }
    } : void 0
  };
  if (o === !1) {
    if (!("colorSchemes" in e))
      return pp(e, ...t);
    let f = r;
    "palette" in e || p[c] && (p[c] !== !0 ? f = p[c].palette : c === "dark" && (f = {
      mode: "dark"
    }));
    const h = pp({
      ...e,
      palette: f
    }, ...t);
    return h.defaultColorScheme = c, h.colorSchemes = p, h.palette.mode === "light" && (h.colorSchemes.light = {
      ...p.light !== !0 && p.light,
      palette: h.palette
    }, Bx(h, "dark", p.dark)), h.palette.mode === "dark" && (h.colorSchemes.dark = {
      ...p.dark !== !0 && p.dark,
      palette: h.palette
    }, Bx(h, "light", p.light)), h;
  }
  return !r && !("light" in p) && c === "light" && (p.light = !0), Eb({
    ...l,
    colorSchemes: p,
    defaultColorScheme: c,
    ...typeof o != "boolean" && o
  }, ...t);
}
function fM(e, ...t) {
  return uu(sn({
    unstable_strictMode: !0
  }, e), ...t);
}
let Dx = !1;
function mM(e) {
  return Dx || (console.warn(["MUI: createStyles from @mui/material/styles is deprecated.", "Please use @mui/styles/createStyles"].join(`
`)), Dx = !0), e;
}
function jx(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function Ob(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Ya(e) {
  return parseFloat(e);
}
function hM(e) {
  return (t, r) => {
    const o = Ob(t);
    if (o === r)
      return t;
    let a = Ya(t);
    o !== "px" && (o === "em" || o === "rem") && (a = Ya(t) * Ya(e));
    let i = a;
    if (r !== "px")
      if (r === "em")
        i = a / Ya(e);
      else if (r === "rem")
        i = a / Ya(e);
      else
        return t;
    return parseFloat(i.toFixed(5)) + r;
  };
}
function gM({
  size: e,
  grid: t
}) {
  const r = e - e % t, o = r + t;
  return e - r < o - e ? r : o;
}
function bM({
  lineHeight: e,
  pixels: t,
  htmlFontSize: r
}) {
  return t / (e * r);
}
function yM({
  cssProperty: e,
  min: t,
  max: r,
  unit: o = "rem",
  breakpoints: a = [600, 900, 1200],
  transform: i = null
}) {
  const l = {
    [e]: `${t}${o}`
  }, c = (r - t) / a[a.length - 1];
  return a.forEach((d) => {
    let p = t + c * d;
    i !== null && (p = i(p)), l[`@media (min-width:${d}px)`] = {
      [e]: `${Math.round(p * 1e4) / 1e4}${o}`
    };
  }), l;
}
function vM(e, t = {}) {
  const {
    breakpoints: r = ["sm", "md", "lg"],
    disableAlign: o = !1,
    factor: a = 2,
    variants: i = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, l = {
    ...e
  };
  l.typography = {
    ...l.typography
  };
  const c = l.typography, d = hM(c.htmlFontSize), p = r.map((f) => l.breakpoints.values[f]);
  return i.forEach((f) => {
    const h = c[f];
    if (!h)
      return;
    const g = parseFloat(d(h.fontSize, "rem"));
    if (g <= 1)
      return;
    const y = g, C = 1 + (y - 1) / a;
    let {
      lineHeight: b
    } = h;
    if (!jx(b) && !o)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported non-unitless line height with grid alignment.
Use unitless line heights instead.` : jn(6));
    jx(b) || (b = parseFloat(d(b, "rem")) / parseFloat(g));
    let v = null;
    o || (v = (T) => gM({
      size: T,
      grid: bM({
        pixels: 4,
        lineHeight: b,
        htmlFontSize: c.htmlFontSize
      })
    })), c[f] = {
      ...h,
      ...yM({
        cssProperty: "fontSize",
        min: C,
        max: y,
        unit: "rem",
        breakpoints: p,
        transform: v
      })
    };
  }), l;
}
const nf = uu();
function Yr() {
  const e = su(nf);
  return process.env.NODE_ENV !== "production" && x.useDebugValue(e), e[wo] || e;
}
function xM({
  props: e,
  name: t
}) {
  return Qp({
    props: e,
    name: t,
    defaultTheme: nf,
    themeId: wo
  });
}
function jl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Zr = (e) => jl(e) && e !== "classes", Y = _2({
  themeId: wo,
  defaultTheme: nf,
  rootShouldForwardProp: Zr
});
function CM({
  theme: e,
  ...t
}) {
  const r = wo in e ? e[wo] : void 0;
  return /* @__PURE__ */ P.jsx(jc, {
    ...t,
    themeId: r ? wo : void 0,
    theme: r || e
  });
}
const vd = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: pw,
  useColorScheme: SM,
  getInitColorSchemeScript: wM
} = cN({
  themeId: wo,
  // @ts-ignore ignore module augmentation tests
  theme: () => uu({
    cssVariables: !0
  }),
  colorSchemeStorageKey: vd.colorSchemeStorageKey,
  modeStorageKey: vd.modeStorageKey,
  defaultColorScheme: {
    light: vd.defaultLightColorScheme,
    dark: vd.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: wb(e.palette, e.typography)
    };
    return t.unstable_sx = function(o) {
      return Ii({
        sx: o,
        theme: this
      });
    }, t;
  }
});
let zx = !1;
function TM(e) {
  return process.env.NODE_ENV !== "production" && (zx || (console.warn(["MUI: The Experimental_CssVarsProvider component has been ported into ThemeProvider.", "", "You should use `import { ThemeProvider } from '@mui/material/styles'` instead.", "For more details, check out https://mui.com/material-ui/customization/css-theme-variables/usage/"].join(`
`)), zx = !0)), /* @__PURE__ */ P.jsx(pw, {
    ...e
  });
}
let Vx = !1;
const EM = (e) => (Vx || (console.warn(["MUI: The getInitColorSchemeScript function has been deprecated.", "", "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`", "and replace the function call with `<InitColorSchemeScript />` instead."].join(`
`)), Vx = !0), wM(e)), fw = pw;
function OM({
  theme: e,
  ...t
}) {
  const r = x.useMemo(() => {
    if (typeof e == "function")
      return e;
    const o = wo in e ? e[wo] : e;
    return "colorSchemes" in o ? null : "vars" in o ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return r ? /* @__PURE__ */ P.jsx(CM, {
    theme: r,
    ...t
  }) : /* @__PURE__ */ P.jsx(fw, {
    theme: e,
    ...t
  });
}
function $M() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: makeStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : jn(14));
}
function RM() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : jn(15));
}
function PM() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withTheme is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : jn(16));
}
let Wx = !1;
function kM(...e) {
  return Wx || (console.warn(["MUI: The `experimental_extendTheme` has been stabilized.", "", "You should use `import { extendTheme } from '@mui/material/styles'`"].join(`
`)), Wx = !0), Eb(...e);
}
function AM() {
  throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `experimental_sx` has been moved to `theme.unstable_sx`.For more details, see https://github.com/mui/material-ui/pull/35150." : jn(19));
}
function $b(e) {
  return /* @__PURE__ */ P.jsx(ub, {
    ...e,
    defaultTheme: nf,
    themeId: wo
  });
}
process.env.NODE_ENV !== "production" && ($b.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: n.oneOfType([n.array, n.func, n.number, n.object, n.string, n.bool])
});
function Rb(e) {
  return function(r) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ P.jsx($b, {
        styles: typeof e == "function" ? (o) => e({
          theme: o,
          ...r
        }) : e
      })
    );
  };
}
function IM() {
  return lu;
}
const $e = tN;
process.env.NODE_ENV !== "production" && (n.node, n.object.isRequired);
function Fe(e) {
  return Q7(e);
}
function mw(e) {
  return Ae("MuiSvgIcon", e);
}
const NM = Ne("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]), MM = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: o
  } = e, a = {
    root: ["root", t !== "inherit" && `color${re(t)}`, `fontSize${re(r)}`]
  };
  return Me(a, mw, o);
}, _M = Y("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${re(r.color)}`], t[`fontSize${re(r.fontSize)}`]];
  }
})($e(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: e.transitions?.create?.("fill", {
    duration: (e.vars ?? e).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (t) => !t.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((e.vars ?? e).palette).filter(([, t]) => t && t.main).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (e.vars ?? e).palette?.[t]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
}))), El = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: l = "inherit",
    component: c = "svg",
    fontSize: d = "medium",
    htmlColor: p,
    inheritViewBox: f = !1,
    titleAccess: h,
    viewBox: g = "0 0 24 24",
    ...y
  } = o, C = /* @__PURE__ */ x.isValidElement(a) && a.type === "svg", b = {
    ...o,
    color: l,
    component: c,
    fontSize: d,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: g,
    hasSvgAsChild: C
  }, v = {};
  f || (v.viewBox = g);
  const T = MM(b);
  return /* @__PURE__ */ P.jsxs(_M, {
    as: c,
    className: ge(T.root, i),
    focusable: "false",
    color: p,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: r,
    ...v,
    ...y,
    ...C && a.props,
    ownerState: b,
    children: [C ? a.props.children : a, h ? /* @__PURE__ */ P.jsx("title", {
      children: h
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (El.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: n.oneOfType([n.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: n.oneOfType([n.oneOf(["inherit", "large", "medium", "small"]), n.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: n.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: n.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: n.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: n.string
});
El.muiName = "SvgIcon";
function Sr(e, t) {
  function r(o, a) {
    return /* @__PURE__ */ P.jsx(El, {
      "data-testid": `${t}Icon`,
      ref: a,
      ...o,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (r.displayName = `${t}Icon`), r.muiName = El.muiName, /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(r));
}
function Ts(e, t) {
  if (!e)
    return t;
  if (typeof e == "function" || typeof t == "function")
    return (a) => {
      const i = typeof t == "function" ? t(a) : t, l = typeof e == "function" ? e({
        ...a,
        ...i
      }) : e, c = ge(a?.className, i?.className, l?.className);
      return {
        ...i,
        ...l,
        ...!!c && {
          className: c
        },
        ...i?.style && l?.style && {
          style: {
            ...i.style,
            ...l.style
          }
        },
        ...i?.sx && l?.sx && {
          sx: [...Array.isArray(i.sx) ? i.sx : [i.sx], ...Array.isArray(l.sx) ? l.sx : [l.sx]]
        }
      };
    };
  const r = t, o = ge(r?.className, e?.className);
  return {
    ...t,
    ...e,
    ...!!o && {
      className: o
    },
    ...r?.style && e?.style && {
      style: {
        ...r.style,
        ...e.style
      }
    },
    ...r?.sx && e?.sx && {
      sx: [...Array.isArray(r.sx) ? r.sx : [r.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
const FM = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), db.configure(e);
  }
};
function Pb(e, t) {
  if (e == null) return {};
  var r = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    r[o] = e[o];
  }
  return r;
}
function mp(e, t) {
  return mp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, mp(e, t);
}
function hw(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, mp(e, t);
}
const Ux = {
  disabled: !1
};
var LM = process.env.NODE_ENV !== "production" ? n.oneOfType([n.number, n.shape({
  enter: n.number,
  exit: n.number,
  appear: n.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && n.oneOfType([n.string, n.shape({
  enter: n.string,
  exit: n.string,
  active: n.string
}), n.shape({
  enter: n.string,
  enterDone: n.string,
  enterActive: n.string,
  exit: n.string,
  exitDone: n.string,
  exitActive: n.string
})]);
const hp = N.createContext(null);
var BM = function(t) {
  return t.scrollTop;
}, Sc = "unmounted", ns = "exited", os = "entering", ol = "entered", ag = "exiting", Po = /* @__PURE__ */ function(e) {
  hw(t, e);
  function t(o, a) {
    var i;
    i = e.call(this, o, a) || this;
    var l = a, c = l && !l.isMounting ? o.enter : o.appear, d;
    return i.appearStatus = null, o.in ? c ? (d = ns, i.appearStatus = os) : d = ol : o.unmountOnExit || o.mountOnEnter ? d = Sc : d = ns, i.state = {
      status: d
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(a, i) {
    var l = a.in;
    return l && i.status === Sc ? {
      status: ns
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function(a) {
    var i = null;
    if (a !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== os && l !== ol && (i = os) : (l === os || l === ol) && (i = ag);
    }
    this.updateStatus(!1, i);
  }, r.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, r.getTimeouts = function() {
    var a = this.props.timeout, i, l, c;
    return i = l = c = a, a != null && typeof a != "number" && (i = a.exit, l = a.enter, c = a.appear !== void 0 ? a.appear : l), {
      exit: i,
      enter: l,
      appear: c
    };
  }, r.updateStatus = function(a, i) {
    if (a === void 0 && (a = !1), i !== null)
      if (this.cancelNextCallback(), i === os) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : cl.findDOMNode(this);
          l && BM(l);
        }
        this.performEnter(a);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ns && this.setState({
      status: Sc
    });
  }, r.performEnter = function(a) {
    var i = this, l = this.props.enter, c = this.context ? this.context.isMounting : a, d = this.props.nodeRef ? [c] : [cl.findDOMNode(this), c], p = d[0], f = d[1], h = this.getTimeouts(), g = c ? h.appear : h.enter;
    if (!a && !l || Ux.disabled) {
      this.safeSetState({
        status: ol
      }, function() {
        i.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, f), this.safeSetState({
      status: os
    }, function() {
      i.props.onEntering(p, f), i.onTransitionEnd(g, function() {
        i.safeSetState({
          status: ol
        }, function() {
          i.props.onEntered(p, f);
        });
      });
    });
  }, r.performExit = function() {
    var a = this, i = this.props.exit, l = this.getTimeouts(), c = this.props.nodeRef ? void 0 : cl.findDOMNode(this);
    if (!i || Ux.disabled) {
      this.safeSetState({
        status: ns
      }, function() {
        a.props.onExited(c);
      });
      return;
    }
    this.props.onExit(c), this.safeSetState({
      status: ag
    }, function() {
      a.props.onExiting(c), a.onTransitionEnd(l.exit, function() {
        a.safeSetState({
          status: ns
        }, function() {
          a.props.onExited(c);
        });
      });
    });
  }, r.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function(a, i) {
    i = this.setNextCallback(i), this.setState(a, i);
  }, r.setNextCallback = function(a) {
    var i = this, l = !0;
    return this.nextCallback = function(c) {
      l && (l = !1, i.nextCallback = null, a(c));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function(a, i) {
    this.setNextCallback(i);
    var l = this.props.nodeRef ? this.props.nodeRef.current : cl.findDOMNode(this), c = a == null && !this.props.addEndListener;
    if (!l || c) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], p = d[0], f = d[1];
      this.props.addEndListener(p, f);
    }
    a != null && setTimeout(this.nextCallback, a);
  }, r.render = function() {
    var a = this.state.status;
    if (a === Sc)
      return null;
    var i = this.props, l = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var c = Pb(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ N.createElement(hp.Provider, {
        value: null
      }, typeof l == "function" ? l(a, c) : N.cloneElement(N.Children.only(l), c))
    );
  }, t;
}(N.Component);
Po.contextType = hp;
Po.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: n.shape({
    current: typeof Element > "u" ? n.any : function(e, t, r, o, a, i) {
      var l = e[t];
      return n.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, r, o, a, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: n.oneOfType([n.func.isRequired, n.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: n.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: n.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: n.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: n.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: n.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: n.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var r = LM;
    t.addEndListener || (r = r.isRequired);
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      a[i - 1] = arguments[i];
    return r.apply(void 0, [t].concat(a));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: n.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: n.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: n.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: n.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: n.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: n.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: n.func
} : {};
function Qs() {
}
Po.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Qs,
  onEntering: Qs,
  onEntered: Qs,
  onExit: Qs,
  onExiting: Qs,
  onExited: Qs
};
Po.UNMOUNTED = Sc;
Po.EXITED = ns;
Po.ENTERING = os;
Po.ENTERED = ol;
Po.EXITING = ag;
function gw(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kb(e, t) {
  var r = function(i) {
    return t && pl(i) ? t(i) : i;
  }, o = /* @__PURE__ */ Object.create(null);
  return e && EI.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    o[a.key] = r(a);
  }), o;
}
function DM(e, t) {
  e = e || {}, t = t || {};
  function r(f) {
    return f in t ? t[f] : e[f];
  }
  var o = /* @__PURE__ */ Object.create(null), a = [];
  for (var i in e)
    i in t ? a.length && (o[i] = a, a = []) : a.push(i);
  var l, c = {};
  for (var d in t) {
    if (o[d])
      for (l = 0; l < o[d].length; l++) {
        var p = o[d][l];
        c[o[d][l]] = r(p);
      }
    c[d] = r(d);
  }
  for (l = 0; l < a.length; l++)
    c[a[l]] = r(a[l]);
  return c;
}
function cs(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function jM(e, t) {
  return kb(e.children, function(r) {
    return ms(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: cs(r, "appear", e),
      enter: cs(r, "enter", e),
      exit: cs(r, "exit", e)
    });
  });
}
function zM(e, t, r) {
  var o = kb(e.children), a = DM(t, o);
  return Object.keys(a).forEach(function(i) {
    var l = a[i];
    if (pl(l)) {
      var c = i in t, d = i in o, p = t[i], f = pl(p) && !p.props.in;
      d && (!c || f) ? a[i] = ms(l, {
        onExited: r.bind(null, l),
        in: !0,
        exit: cs(l, "exit", e),
        enter: cs(l, "enter", e)
      }) : !d && c && !f ? a[i] = ms(l, {
        in: !1
      }) : d && c && pl(p) && (a[i] = ms(l, {
        onExited: r.bind(null, l),
        in: p.props.in,
        exit: cs(l, "exit", e),
        enter: cs(l, "enter", e)
      }));
    }
  }), a;
}
var VM = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, WM = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Ab = /* @__PURE__ */ function(e) {
  hw(t, e);
  function t(o, a) {
    var i;
    i = e.call(this, o, a) || this;
    var l = i.handleExited.bind(gw(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, i;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, i) {
    var l = i.children, c = i.handleExited, d = i.firstRender;
    return {
      children: d ? jM(a, c) : zM(a, l, c),
      firstRender: !1
    };
  }, r.handleExited = function(a, i) {
    var l = kb(this.props.children);
    a.key in l || (a.props.onExited && a.props.onExited(i), this.mounted && this.setState(function(c) {
      var d = Ea({}, c.children);
      return delete d[a.key], {
        children: d
      };
    }));
  }, r.render = function() {
    var a = this.props, i = a.component, l = a.childFactory, c = Pb(a, ["component", "childFactory"]), d = this.state.contextValue, p = VM(this.state.children).map(l);
    return delete c.appear, delete c.enter, delete c.exit, i === null ? /* @__PURE__ */ N.createElement(hp.Provider, {
      value: d
    }, p) : /* @__PURE__ */ N.createElement(hp.Provider, {
      value: d
    }, /* @__PURE__ */ N.createElement(i, c, p));
  }, t;
}(N.Component);
Ab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: n.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: n.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: n.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: n.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: n.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: n.func
} : {};
Ab.defaultProps = WM;
const of = (e) => e.scrollTop;
function aa(e, t) {
  const {
    timeout: r,
    easing: o,
    style: a = {}
  } = e;
  return {
    duration: a.transitionDuration ?? (typeof r == "number" ? r : r[t.mode] || 0),
    easing: a.transitionTimingFunction ?? (typeof o == "object" ? o[t.mode] : o),
    delay: a.transitionDelay
  };
}
function bw(e) {
  return Ae("MuiCollapse", e);
}
const UM = Ne("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]), HM = (e) => {
  const {
    orientation: t,
    classes: r
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Me(o, bw, r);
}, GM = Y("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.orientation], r.state === "entered" && t.entered, r.state === "exited" && !r.in && r.collapsedSize === "0px" && t.hidden];
  }
})($e(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), qM = Y("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), KM = Y("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), Es = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: a,
    children: i,
    className: l,
    collapsedSize: c = "0px",
    component: d,
    easing: p,
    in: f,
    onEnter: h,
    onEntered: g,
    onEntering: y,
    onExit: C,
    onExited: b,
    onExiting: v,
    orientation: T = "vertical",
    style: R,
    timeout: $ = Tb.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: E = Po,
    ...S
  } = o, k = {
    ...o,
    orientation: T,
    collapsedSize: c
  }, A = HM(k), _ = Yr(), L = Ja(), O = x.useRef(null), F = x.useRef(), B = typeof c == "number" ? `${c}px` : c, M = T === "horizontal", j = M ? "width" : "height", W = x.useRef(null), V = Jt(r, W), X = (ie) => (oe) => {
    if (ie) {
      const ce = W.current;
      oe === void 0 ? ie(ce) : ie(ce, oe);
    }
  }, U = () => O.current ? O.current[M ? "clientWidth" : "clientHeight"] : 0, H = X((ie, oe) => {
    O.current && M && (O.current.style.position = "absolute"), ie.style[j] = B, h && h(ie, oe);
  }), Z = X((ie, oe) => {
    const ce = U();
    O.current && M && (O.current.style.position = "");
    const {
      duration: Ce,
      easing: xe
    } = aa({
      style: R,
      timeout: $,
      easing: p
    }, {
      mode: "enter"
    });
    if ($ === "auto") {
      const Re = _.transitions.getAutoHeightDuration(ce);
      ie.style.transitionDuration = `${Re}ms`, F.current = Re;
    } else
      ie.style.transitionDuration = typeof Ce == "string" ? Ce : `${Ce}ms`;
    ie.style[j] = `${ce}px`, ie.style.transitionTimingFunction = xe, y && y(ie, oe);
  }), G = X((ie, oe) => {
    ie.style[j] = "auto", g && g(ie, oe);
  }), ye = X((ie) => {
    ie.style[j] = `${U()}px`, C && C(ie);
  }), de = X(b), ne = X((ie) => {
    const oe = U(), {
      duration: ce,
      easing: Ce
    } = aa({
      style: R,
      timeout: $,
      easing: p
    }, {
      mode: "exit"
    });
    if ($ === "auto") {
      const xe = _.transitions.getAutoHeightDuration(oe);
      ie.style.transitionDuration = `${xe}ms`, F.current = xe;
    } else
      ie.style.transitionDuration = typeof ce == "string" ? ce : `${ce}ms`;
    ie.style[j] = B, ie.style.transitionTimingFunction = Ce, v && v(ie);
  }), fe = (ie) => {
    $ === "auto" && L.start(F.current || 0, ie), a && a(W.current, ie);
  };
  return /* @__PURE__ */ P.jsx(E, {
    in: f,
    onEnter: H,
    onEntered: G,
    onEntering: Z,
    onExit: ye,
    onExited: de,
    onExiting: ne,
    addEndListener: fe,
    nodeRef: W,
    timeout: $ === "auto" ? null : $,
    ...S,
    children: (ie, {
      ownerState: oe,
      ...ce
    }) => /* @__PURE__ */ P.jsx(GM, {
      as: d,
      className: ge(A.root, l, {
        entered: A.entered,
        exited: !f && B === "0px" && A.hidden
      }[ie]),
      style: {
        [M ? "minWidth" : "minHeight"]: B,
        ...R
      },
      ref: V,
      ownerState: {
        ...k,
        state: ie
      },
      ...ce,
      children: /* @__PURE__ */ P.jsx(qM, {
        ownerState: {
          ...k,
          state: ie
        },
        className: A.wrapper,
        ref: O,
        children: /* @__PURE__ */ P.jsx(KM, {
          ownerState: {
            ...k,
            state: ie
          },
          className: A.wrapperInner,
          children: i
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Es.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * The content node to be collapsed.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: n.oneOfType([n.number, n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ni,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
Es && (Es.muiSupportAuto = !0);
function yw(e) {
  return Ae("MuiPaper", e);
}
const YM = Ne("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]), ZM = (e) => {
  const {
    square: t,
    elevation: r,
    variant: o,
    classes: a
  } = e, i = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${r}`]
  };
  return Me(i, yw, a);
}, XM = Y("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})($e(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), no = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiPaper"
  }), a = Yr(), {
    className: i,
    component: l = "div",
    elevation: c = 1,
    square: d = !1,
    variant: p = "elevation",
    ...f
  } = o, h = {
    ...o,
    component: l,
    elevation: c,
    square: d,
    variant: p
  }, g = ZM(h);
  return process.env.NODE_ENV !== "production" && a.shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ P.jsx(XM, {
    as: l,
    ownerState: h,
    className: ge(g.root, i),
    ref: r,
    ...f,
    style: {
      ...p === "elevation" && {
        "--Paper-shadow": (a.vars || a).shadows[c],
        ...a.vars && {
          "--Paper-overlay": a.vars.overlays?.[c]
        },
        ...!a.vars && a.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${dt("#fff", fp(c))}, ${dt("#fff", fp(c))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (no.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: tn(Vr, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: n.bool,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: n.oneOfType([n.oneOf(["elevation", "outlined"]), n.string])
});
const Ib = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (Ib.displayName = "AccordionContext");
function ze(e, t) {
  const {
    className: r,
    elementType: o,
    ownerState: a,
    externalForwardedProps: i,
    internalForwardedProps: l,
    shouldForwardComponentProp: c = !1,
    ...d
  } = t, {
    component: p,
    slots: f = {
      [e]: void 0
    },
    slotProps: h = {
      [e]: void 0
    },
    ...g
  } = i, y = f[e] || o, C = Y2(h[e], a), {
    props: {
      component: b,
      ...v
    },
    internalRef: T
  } = K2({
    className: r,
    ...d,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: C
  }), R = Jt(T, C?.ref, t.ref), $ = e === "root" ? b || p : b, E = q2(y, {
    ...e === "root" && !p && !f[e] && l,
    ...e !== "root" && !f[e] && l,
    ...v,
    ...$ && !c && {
      as: $
    },
    ...$ && c && {
      component: $
    },
    ref: R
  }, a);
  return [y, E];
}
function vw(e) {
  return Ae("MuiAccordion", e);
}
const wc = Ne("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]), JM = (e) => {
  const {
    classes: t,
    square: r,
    expanded: o,
    disabled: a,
    disableGutters: i
  } = e;
  return Me({
    root: ["root", !r && "rounded", o && "expanded", a && "disabled", !i && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, vw, t);
}, QM = Y(no, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${wc.region}`]: t.region
    }, t.root, !r.square && t.rounded, !r.disableGutters && t.gutters];
  }
})($e(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${wc.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${wc.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), $e(({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${wc.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), e_ = Y("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, t) => t.heading
})({
  all: "unset"
}), xw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAccordion"
  }), {
    children: a,
    className: i,
    defaultExpanded: l = !1,
    disabled: c = !1,
    disableGutters: d = !1,
    expanded: p,
    onChange: f,
    square: h = !1,
    slots: g = {},
    slotProps: y = {},
    TransitionComponent: C,
    TransitionProps: b,
    ...v
  } = o, [T, R] = Bn({
    controlled: p,
    default: l,
    name: "Accordion",
    state: "expanded"
  }), $ = x.useCallback((U) => {
    R(!T), f && f(U, !T);
  }, [T, f, R]), [E, ...S] = x.Children.toArray(a), k = x.useMemo(() => ({
    expanded: T,
    disabled: c,
    disableGutters: d,
    toggle: $
  }), [T, c, d, $]), A = {
    ...o,
    square: h,
    disabled: c,
    disableGutters: d,
    expanded: T
  }, _ = JM(A), L = {
    transition: C,
    ...g
  }, O = {
    transition: b,
    ...y
  }, F = {
    slots: L,
    slotProps: O
  }, [B, M] = ze("root", {
    elementType: QM,
    externalForwardedProps: {
      ...F,
      ...v
    },
    className: ge(_.root, i),
    shouldForwardComponentProp: !0,
    ownerState: A,
    ref: r,
    additionalProps: {
      square: h
    }
  }), [j, W] = ze("heading", {
    elementType: e_,
    externalForwardedProps: F,
    className: _.heading,
    ownerState: A
  }), [V, X] = ze("transition", {
    elementType: Es,
    externalForwardedProps: F,
    ownerState: A
  });
  return /* @__PURE__ */ P.jsxs(B, {
    ...M,
    children: [/* @__PURE__ */ P.jsx(j, {
      ...W,
      children: /* @__PURE__ */ P.jsx(Ib.Provider, {
        value: k,
        children: E
      })
    }), /* @__PURE__ */ P.jsx(V, {
      in: T,
      timeout: "auto",
      ...X,
      children: /* @__PURE__ */ P.jsx("div", {
        "aria-labelledby": E.props.id,
        id: E.props["aria-controls"],
        role: "region",
        className: _.region,
        children: S
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (xw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: tn(n.node.isRequired, (e) => {
    const t = x.Children.toArray(e.children)[0];
    return zn.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ x.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: n.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: n.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    heading: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    heading: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: n.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: n.object
});
function Cw(e) {
  return Ae("MuiAccordionActions", e);
}
const t_ = Ne("MuiAccordionActions", ["root", "spacing"]), r_ = (e) => {
  const {
    classes: t,
    disableSpacing: r
  } = e;
  return Me({
    root: ["root", !r && "spacing"]
  }, Cw, t);
}, n_ = Y("div", {
  name: "MuiAccordionActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  variants: [{
    props: (e) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), Sw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAccordionActions"
  }), {
    className: a,
    disableSpacing: i = !1,
    ...l
  } = o, c = {
    ...o,
    disableSpacing: i
  }, d = r_(c);
  return /* @__PURE__ */ P.jsx(n_, {
    className: ge(d.root, a),
    ref: r,
    ownerState: c,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Sw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function ww(e) {
  return Ae("MuiAccordionDetails", e);
}
const o_ = Ne("MuiAccordionDetails", ["root"]), a_ = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, ww, t);
}, i_ = Y("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), Tw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: a,
    ...i
  } = o, l = o, c = a_(l);
  return /* @__PURE__ */ P.jsx(i_, {
    className: ge(c.root, a),
    ref: r,
    ownerState: l,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (Tw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
class gp {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new gp();
  }
  static use() {
    const t = z2(gp.create).current, [r, o] = x.useState(!1);
    return t.shouldMount = r, t.setShouldMount = o, x.useEffect(t.mountEffect, [r]), t;
  }
  constructor() {
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  mount() {
    return this.mounted || (this.mounted = l_(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  mountEffect = () => {
    this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
  };
  /* Ripple API */
  start(...t) {
    this.mount().then(() => this.ref.current?.start(...t));
  }
  stop(...t) {
    this.mount().then(() => this.ref.current?.stop(...t));
  }
  pulsate(...t) {
    this.mount().then(() => this.ref.current?.pulsate(...t));
  }
}
function s_() {
  return gp.use();
}
function l_() {
  let e, t;
  const r = new Promise((o, a) => {
    e = o, t = a;
  });
  return r.resolve = e, r.reject = t, r;
}
function Ew(e) {
  const {
    className: t,
    classes: r,
    pulsate: o = !1,
    rippleX: a,
    rippleY: i,
    rippleSize: l,
    in: c,
    onExited: d,
    timeout: p
  } = e, [f, h] = x.useState(!1), g = ge(t, r.ripple, r.rippleVisible, o && r.ripplePulsate), y = {
    width: l,
    height: l,
    top: -(l / 2) + i,
    left: -(l / 2) + a
  }, C = ge(r.child, f && r.childLeaving, o && r.childPulsate);
  return !c && !f && h(!0), x.useEffect(() => {
    if (!c && d != null) {
      const b = setTimeout(d, p);
      return () => {
        clearTimeout(b);
      };
    }
  }, [d, c, p]), /* @__PURE__ */ P.jsx("span", {
    className: g,
    style: y,
    children: /* @__PURE__ */ P.jsx("span", {
      className: C
    })
  });
}
process.env.NODE_ENV !== "production" && (Ew.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object.isRequired,
  className: n.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: n.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: n.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: n.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: n.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: n.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: n.number,
  /**
   * exit delay
   */
  timeout: n.number.isRequired
});
function c_(e) {
  return Ae("MuiTouchRipple", e);
}
const bo = Ne("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), ig = 550, u_ = 80, d_ = Ro`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, p_ = Ro`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, f_ = Ro`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, m_ = Y("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), h_ = Y(Ew, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${bo.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${d_};
    animation-duration: ${ig}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${bo.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${bo.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${bo.childLeaving} {
    opacity: 0;
    animation-name: ${p_};
    animation-duration: ${ig}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${bo.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${f_};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, Ow = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: a = !1,
    classes: i = {},
    className: l,
    ...c
  } = o, [d, p] = x.useState([]), f = x.useRef(0), h = x.useRef(null);
  x.useEffect(() => {
    h.current && (h.current(), h.current = null);
  }, [d]);
  const g = x.useRef(!1), y = Ja(), C = x.useRef(null), b = x.useRef(null), v = x.useCallback((E) => {
    const {
      pulsate: S,
      rippleX: k,
      rippleY: A,
      rippleSize: _,
      cb: L
    } = E;
    p((O) => [...O, /* @__PURE__ */ P.jsx(h_, {
      classes: {
        ripple: ge(i.ripple, bo.ripple),
        rippleVisible: ge(i.rippleVisible, bo.rippleVisible),
        ripplePulsate: ge(i.ripplePulsate, bo.ripplePulsate),
        child: ge(i.child, bo.child),
        childLeaving: ge(i.childLeaving, bo.childLeaving),
        childPulsate: ge(i.childPulsate, bo.childPulsate)
      },
      timeout: ig,
      pulsate: S,
      rippleX: k,
      rippleY: A,
      rippleSize: _
    }, f.current)]), f.current += 1, h.current = L;
  }, [i]), T = x.useCallback((E = {}, S = {}, k = () => {
  }) => {
    const {
      pulsate: A = !1,
      center: _ = a || S.pulsate,
      fakeElement: L = !1
      // For test purposes
    } = S;
    if (E?.type === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    E?.type === "touchstart" && (g.current = !0);
    const O = L ? null : b.current, F = O ? O.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let B, M, j;
    if (_ || E === void 0 || E.clientX === 0 && E.clientY === 0 || !E.clientX && !E.touches)
      B = Math.round(F.width / 2), M = Math.round(F.height / 2);
    else {
      const {
        clientX: W,
        clientY: V
      } = E.touches && E.touches.length > 0 ? E.touches[0] : E;
      B = Math.round(W - F.left), M = Math.round(V - F.top);
    }
    if (_)
      j = Math.sqrt((2 * F.width ** 2 + F.height ** 2) / 3), j % 2 === 0 && (j += 1);
    else {
      const W = Math.max(Math.abs((O ? O.clientWidth : 0) - B), B) * 2 + 2, V = Math.max(Math.abs((O ? O.clientHeight : 0) - M), M) * 2 + 2;
      j = Math.sqrt(W ** 2 + V ** 2);
    }
    E?.touches ? C.current === null && (C.current = () => {
      v({
        pulsate: A,
        rippleX: B,
        rippleY: M,
        rippleSize: j,
        cb: k
      });
    }, y.start(u_, () => {
      C.current && (C.current(), C.current = null);
    })) : v({
      pulsate: A,
      rippleX: B,
      rippleY: M,
      rippleSize: j,
      cb: k
    });
  }, [a, v, y]), R = x.useCallback(() => {
    T({}, {
      pulsate: !0
    });
  }, [T]), $ = x.useCallback((E, S) => {
    if (y.clear(), E?.type === "touchend" && C.current) {
      C.current(), C.current = null, y.start(0, () => {
        $(E, S);
      });
      return;
    }
    C.current = null, p((k) => k.length > 0 ? k.slice(1) : k), h.current = S;
  }, [y]);
  return x.useImperativeHandle(r, () => ({
    pulsate: R,
    start: T,
    stop: $
  }), [R, T, $]), /* @__PURE__ */ P.jsx(m_, {
    className: ge(bo.root, i.root, l),
    ref: b,
    ...c,
    children: /* @__PURE__ */ P.jsx(Ab, {
      component: null,
      exit: !0,
      children: d
    })
  });
});
process.env.NODE_ENV !== "production" && (Ow.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string
});
function $w(e) {
  return Ae("MuiButtonBase", e);
}
const Nb = Ne("MuiButtonBase", ["root", "disabled", "focusVisible"]), g_ = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: o,
    classes: a
  } = e, l = Me({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, $w, a);
  return r && o && (l.root += ` ${o}`), l;
}, b_ = Y("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Nb.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), qr = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: a,
    centerRipple: i = !1,
    children: l,
    className: c,
    component: d = "button",
    disabled: p = !1,
    disableRipple: f = !1,
    disableTouchRipple: h = !1,
    focusRipple: g = !1,
    focusVisibleClassName: y,
    LinkComponent: C = "a",
    onBlur: b,
    onClick: v,
    onContextMenu: T,
    onDragLeave: R,
    onFocus: $,
    onFocusVisible: E,
    onKeyDown: S,
    onKeyUp: k,
    onMouseDown: A,
    onMouseLeave: _,
    onMouseUp: L,
    onTouchEnd: O,
    onTouchMove: F,
    onTouchStart: B,
    tabIndex: M = 0,
    TouchRippleProps: j,
    touchRippleRef: W,
    type: V,
    ...X
  } = o, U = x.useRef(null), H = s_(), Z = Jt(H.ref, W), [G, ye] = x.useState(!1);
  p && G && ye(!1), x.useImperativeHandle(a, () => ({
    focusVisible: () => {
      ye(!0), U.current.focus();
    }
  }), []);
  const de = H.shouldMount && !f && !p;
  x.useEffect(() => {
    G && g && !f && H.pulsate();
  }, [f, g, G, H]);
  const ne = Wa(H, "start", A, h), fe = Wa(H, "stop", T, h), ie = Wa(H, "stop", R, h), oe = Wa(H, "stop", L, h), ce = Wa(H, "stop", (ue) => {
    G && ue.preventDefault(), _ && _(ue);
  }, h), Ce = Wa(H, "start", B, h), xe = Wa(H, "stop", O, h), Re = Wa(H, "stop", F, h), J = Wa(H, "stop", (ue) => {
    Ra(ue.target) || ye(!1), b && b(ue);
  }, !1), Ie = Pr((ue) => {
    U.current || (U.current = ue.currentTarget), Ra(ue.target) && (ye(!0), E && E(ue)), $ && $(ue);
  }), le = () => {
    const ue = U.current;
    return d && d !== "button" && !(ue.tagName === "A" && ue.href);
  }, qe = Pr((ue) => {
    g && !ue.repeat && G && ue.key === " " && H.stop(ue, () => {
      H.start(ue);
    }), ue.target === ue.currentTarget && le() && ue.key === " " && ue.preventDefault(), S && S(ue), ue.target === ue.currentTarget && le() && ue.key === "Enter" && !p && (ue.preventDefault(), v && v(ue));
  }), q = Pr((ue) => {
    g && ue.key === " " && G && !ue.defaultPrevented && H.stop(ue, () => {
      H.pulsate(ue);
    }), k && k(ue), v && ue.target === ue.currentTarget && le() && ue.key === " " && !ue.defaultPrevented && v(ue);
  });
  let K = d;
  K === "button" && (X.href || X.to) && (K = C);
  const ee = {};
  K === "button" ? (ee.type = V === void 0 ? "button" : V, ee.disabled = p) : (!X.href && !X.to && (ee.role = "button"), p && (ee["aria-disabled"] = p));
  const he = Jt(r, U), we = {
    ...o,
    centerRipple: i,
    component: d,
    disabled: p,
    disableRipple: f,
    disableTouchRipple: h,
    focusRipple: g,
    tabIndex: M,
    focusVisible: G
  }, se = g_(we);
  return /* @__PURE__ */ P.jsxs(b_, {
    as: K,
    className: ge(se.root, c),
    ownerState: we,
    onBlur: J,
    onClick: v,
    onContextMenu: fe,
    onFocus: Ie,
    onKeyDown: qe,
    onKeyUp: q,
    onMouseDown: ne,
    onMouseLeave: ce,
    onMouseUp: oe,
    onDragLeave: ie,
    onTouchEnd: xe,
    onTouchMove: Re,
    onTouchStart: Ce,
    ref: he,
    tabIndex: p ? -1 : M,
    type: V,
    ...ee,
    ...X,
    children: [l, de ? /* @__PURE__ */ P.jsx(Ow, {
      ref: Z,
      center: i,
      ...j
    }) : null]
  });
});
function Wa(e, t, r, o = !1) {
  return Pr((a) => (r && r(a), o || e[t](a), !0));
}
process.env.NODE_ENV !== "production" && (qr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: On,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ni,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: n.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  href: n.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: n.elementType,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onContextMenu: n.func,
  /**
   * @ignore
   */
  onDragLeave: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * @ignore
   */
  onMouseDown: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * @ignore
   */
  onMouseUp: n.func,
  /**
   * @ignore
   */
  onTouchEnd: n.func,
  /**
   * @ignore
   */
  onTouchMove: n.func,
  /**
   * @ignore
   */
  onTouchStart: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @default 0
   */
  tabIndex: n.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: n.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: n.oneOfType([n.func, n.shape({
    current: n.shape({
      pulsate: n.func.isRequired,
      start: n.func.isRequired,
      stop: n.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: n.oneOfType([n.oneOf(["button", "reset", "submit"]), n.string])
});
function Rw(e) {
  return Ae("MuiAccordionSummary", e);
}
const us = Ne("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), y_ = (e) => {
  const {
    classes: t,
    expanded: r,
    disabled: o,
    disableGutters: a
  } = e;
  return Me({
    root: ["root", r && "expanded", o && "disabled", !a && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", r && "expanded", !a && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", r && "expanded"]
  }, Rw, t);
}, v_ = Y(qr, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    width: "100%",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${us.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${us.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${us.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (r) => !r.disableGutters,
      style: {
        [`&.${us.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), x_ = Y("span", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})($e(({
  theme: e
}) => ({
  display: "flex",
  textAlign: "start",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${us.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), C_ = Y("span", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})($e(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${us.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), Pw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: a,
    className: i,
    expandIcon: l,
    focusVisibleClassName: c,
    onClick: d,
    slots: p,
    slotProps: f,
    ...h
  } = o, {
    disabled: g = !1,
    disableGutters: y,
    expanded: C,
    toggle: b
  } = x.useContext(Ib), v = (O) => {
    b && b(O), d && d(O);
  }, T = {
    ...o,
    expanded: C,
    disabled: g,
    disableGutters: y
  }, R = y_(T), $ = {
    slots: p,
    slotProps: f
  }, [E, S] = ze("root", {
    ref: r,
    shouldForwardComponentProp: !0,
    className: ge(R.root, i),
    elementType: v_,
    externalForwardedProps: {
      ...$,
      ...h
    },
    ownerState: T,
    additionalProps: {
      focusRipple: !1,
      disableRipple: !0,
      disabled: g,
      "aria-expanded": C,
      focusVisibleClassName: ge(R.focusVisible, c)
    },
    getSlotProps: (O) => ({
      ...O,
      onClick: (F) => {
        O.onClick?.(F), v(F);
      }
    })
  }), [k, A] = ze("content", {
    className: R.content,
    elementType: x_,
    externalForwardedProps: $,
    ownerState: T
  }), [_, L] = ze("expandIconWrapper", {
    className: R.expandIconWrapper,
    elementType: C_,
    externalForwardedProps: $,
    ownerState: T
  });
  return /* @__PURE__ */ P.jsxs(E, {
    ...S,
    children: [/* @__PURE__ */ P.jsx(k, {
      ...A,
      children: a
    }), l && /* @__PURE__ */ P.jsx(_, {
      ...L,
      children: l
    })]
  });
});
process.env.NODE_ENV !== "production" && (Pw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: n.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    content: n.oneOfType([n.func, n.object]),
    expandIconWrapper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    content: n.elementType,
    expandIconWrapper: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function S_(e) {
  return typeof e.main == "string";
}
function w_(e, t = []) {
  if (!S_(e))
    return !1;
  for (const r of t)
    if (!e.hasOwnProperty(r) || typeof e[r] != "string")
      return !1;
  return !0;
}
function Vt(e = []) {
  return ([, t]) => t && w_(t, e);
}
function kw(e) {
  return Ae("MuiAlert", e);
}
const sg = Ne("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function Aw(e) {
  return Ae("MuiCircularProgress", e);
}
const T_ = Ne("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]), xi = 44, lg = Ro`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, cg = Ro`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, E_ = typeof lg != "string" ? oi`
        animation: ${lg} 1.4s linear infinite;
      ` : null, O_ = typeof cg != "string" ? oi`
        animation: ${cg} 1.4s ease-in-out infinite;
      ` : null, $_ = (e) => {
  const {
    classes: t,
    variant: r,
    color: o,
    disableShrink: a
  } = e, i = {
    root: ["root", r, `color${re(o)}`],
    svg: ["svg"],
    circle: ["circle", `circle${re(r)}`, a && "circleDisableShrink"]
  };
  return Me(i, Aw, t);
}, R_ = Y("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`color${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: E_ || {
      animation: `${lg} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), P_ = Y("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), k_ = Y("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.circle, t[`circle${re(r.variant)}`], r.disableShrink && t.circleDisableShrink];
  }
})($e(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: O_ || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${cg} 1.4s ease-in-out infinite`
    }
  }]
}))), af = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: a,
    color: i = "primary",
    disableShrink: l = !1,
    size: c = 40,
    style: d,
    thickness: p = 3.6,
    value: f = 0,
    variant: h = "indeterminate",
    ...g
  } = o, y = {
    ...o,
    color: i,
    disableShrink: l,
    size: c,
    thickness: p,
    value: f,
    variant: h
  }, C = $_(y), b = {}, v = {}, T = {};
  if (h === "determinate") {
    const R = 2 * Math.PI * ((xi - p) / 2);
    b.strokeDasharray = R.toFixed(3), T["aria-valuenow"] = Math.round(f), b.strokeDashoffset = `${((100 - f) / 100 * R).toFixed(3)}px`, v.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ P.jsx(R_, {
    className: ge(C.root, a),
    style: {
      width: c,
      height: c,
      ...v,
      ...d
    },
    ownerState: y,
    ref: r,
    role: "progressbar",
    ...T,
    ...g,
    children: /* @__PURE__ */ P.jsx(P_, {
      className: C.svg,
      ownerState: y,
      viewBox: `${xi / 2} ${xi / 2} ${xi} ${xi}`,
      children: /* @__PURE__ */ P.jsx(k_, {
        className: C.circle,
        style: b,
        ownerState: y,
        cx: xi,
        cy: xi,
        r: (xi - p) / 2,
        fill: "none",
        strokeWidth: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (af.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: tn(n.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: n.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: n.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: n.oneOf(["determinate", "indeterminate"])
});
function Iw(e) {
  return Ae("MuiIconButton", e);
}
const ug = Ne("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), A_ = (e) => {
  const {
    classes: t,
    disabled: r,
    color: o,
    edge: a,
    size: i,
    loading: l
  } = e, c = {
    root: ["root", l && "loading", r && "disabled", o !== "default" && `color${re(o)}`, a && `edge${re(a)}`, `size${re(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Me(c, Iw, t);
}, I_ = Y(qr, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.loading && t.loading, r.color !== "default" && t[`color${re(r.color)}`], r.edge && t[`edge${re(r.edge)}`], t[`size${re(r.size)}`]];
  }
})($e(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), $e(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${ug.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${ug.loading}`]: {
    color: "transparent"
  }
}))), N_ = Y("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Qa = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: a = !1,
    children: i,
    className: l,
    color: c = "default",
    disabled: d = !1,
    disableFocusRipple: p = !1,
    size: f = "medium",
    id: h,
    loading: g = null,
    loadingIndicator: y,
    ...C
  } = o, b = eo(h), v = y ?? /* @__PURE__ */ P.jsx(af, {
    "aria-labelledby": b,
    color: "inherit",
    size: 16
  }), T = {
    ...o,
    edge: a,
    color: c,
    disabled: d,
    disableFocusRipple: p,
    loading: g,
    loadingIndicator: v,
    size: f
  }, R = A_(T);
  return /* @__PURE__ */ P.jsxs(I_, {
    id: g ? b : h,
    className: ge(R.root, l),
    centerRipple: !0,
    focusRipple: !p,
    disabled: d || g,
    ref: r,
    ...C,
    ownerState: T,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ P.jsx("span", {
      className: R.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ P.jsx(N_, {
        className: R.loadingIndicator,
        ownerState: T,
        children: g && v
      })
    }), i]
  });
});
process.env.NODE_ENV !== "production" && (Qa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: tn(n.node, (e) => x.Children.toArray(e.children).some((r) => /* @__PURE__ */ x.isValidElement(r) && r.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: n.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: n.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: n.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const M_ = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), __ = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), F_ = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), L_ = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), Nw = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), B_ = (e) => {
  const {
    variant: t,
    color: r,
    severity: o,
    classes: a
  } = e, i = {
    root: ["root", `color${re(r || o)}`, `${t}${re(r || o)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Me(i, kw, a);
}, D_ = Y(no, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`${r.variant}${re(r.color || r.severity)}`]];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? na : oa, r = e.palette.mode === "light" ? oa : na;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(Vt(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${o}StandardBg`] : r(e.palette[o].light, 0.9),
        [`& .${sg.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(Vt(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[o].light}`,
        [`& .${sg.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(Vt(["dark"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${o}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${o}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[o].dark : e.palette[o].main,
          color: e.palette.getContrastText(e.palette[o].main)
        }
      }
    }))]
  };
})), j_ = Y("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), z_ = Y("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), V_ = Y("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), Hx = {
  success: /* @__PURE__ */ P.jsx(M_, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ P.jsx(__, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ P.jsx(F_, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ P.jsx(L_, {
    fontSize: "inherit"
  })
}, Mw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAlert"
  }), {
    action: a,
    children: i,
    className: l,
    closeText: c = "Close",
    color: d,
    components: p = {},
    componentsProps: f = {},
    icon: h,
    iconMapping: g = Hx,
    onClose: y,
    role: C = "alert",
    severity: b = "success",
    slotProps: v = {},
    slots: T = {},
    variant: R = "standard",
    ...$
  } = o, E = {
    ...o,
    color: d,
    severity: b,
    variant: R,
    colorSeverity: d || b
  }, S = B_(E), k = {
    slots: {
      closeButton: p.CloseButton,
      closeIcon: p.CloseIcon,
      ...T
    },
    slotProps: {
      ...f,
      ...v
    }
  }, [A, _] = ze("root", {
    ref: r,
    shouldForwardComponentProp: !0,
    className: ge(S.root, l),
    elementType: D_,
    externalForwardedProps: {
      ...k,
      ...$
    },
    ownerState: E,
    additionalProps: {
      role: C,
      elevation: 0
    }
  }), [L, O] = ze("icon", {
    className: S.icon,
    elementType: j_,
    externalForwardedProps: k,
    ownerState: E
  }), [F, B] = ze("message", {
    className: S.message,
    elementType: z_,
    externalForwardedProps: k,
    ownerState: E
  }), [M, j] = ze("action", {
    className: S.action,
    elementType: V_,
    externalForwardedProps: k,
    ownerState: E
  }), [W, V] = ze("closeButton", {
    elementType: Qa,
    externalForwardedProps: k,
    ownerState: E
  }), [X, U] = ze("closeIcon", {
    elementType: Nw,
    externalForwardedProps: k,
    ownerState: E
  });
  return /* @__PURE__ */ P.jsxs(A, {
    ..._,
    children: [h !== !1 ? /* @__PURE__ */ P.jsx(L, {
      ...O,
      children: h || g[b] || Hx[b]
    }) : null, /* @__PURE__ */ P.jsx(F, {
      ...B,
      children: i
    }), a != null ? /* @__PURE__ */ P.jsx(M, {
      ...j,
      children: a
    }) : null, a == null && y ? /* @__PURE__ */ P.jsx(M, {
      ...j,
      children: /* @__PURE__ */ P.jsx(W, {
        size: "small",
        "aria-label": c,
        title: c,
        color: "inherit",
        onClick: y,
        ...V,
        children: /* @__PURE__ */ P.jsx(X, {
          fontSize: "small",
          ...U
        })
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Mw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: n.node,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: n.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "success", "warning"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    CloseButton: n.elementType,
    CloseIcon: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    closeButton: n.object,
    closeIcon: n.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: n.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: n.shape({
    error: n.node,
    info: n.node,
    success: n.node,
    warning: n.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: n.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: n.oneOfType([n.oneOf(["error", "info", "success", "warning"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    action: n.oneOfType([n.func, n.object]),
    closeButton: n.oneOfType([n.func, n.object]),
    closeIcon: n.oneOfType([n.func, n.object]),
    icon: n.oneOfType([n.func, n.object]),
    message: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    action: n.elementType,
    closeButton: n.elementType,
    closeIcon: n.elementType,
    icon: n.elementType,
    message: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined", "standard"]), n.string])
});
function _w(e) {
  return Ae("MuiTypography", e);
}
const zc = Ne("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), W_ = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, U_ = IM(), H_ = (e) => {
  const {
    align: t,
    gutterBottom: r,
    noWrap: o,
    paragraph: a,
    variant: i,
    classes: l
  } = e, c = {
    root: ["root", i, e.align !== "inherit" && `align${re(t)}`, r && "gutterBottom", o && "noWrap", a && "paragraph"]
  };
  return Me(c, _w, l);
}, G_ = Y("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.variant && t[r.variant], r.align !== "inherit" && t[`align${re(r.align)}`], r.noWrap && t.noWrap, r.gutterBottom && t.gutterBottom, r.paragraph && t.paragraph];
  }
})($e(({
  theme: e
}) => ({
  margin: 0,
  variants: [{
    props: {
      variant: "inherit"
    },
    style: {
      // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
      font: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  }, ...Object.entries(e.typography).filter(([t, r]) => t !== "inherit" && r && typeof r == "object").map(([t, r]) => ({
    props: {
      variant: t
    },
    style: r
  })), ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette?.text || {}).filter(([, t]) => typeof t == "string").map(([t]) => ({
    props: {
      color: `text${re(t)}`
    },
    style: {
      color: (e.vars || e).palette.text[t]
    }
  })), {
    props: ({
      ownerState: t
    }) => t.align !== "inherit",
    style: {
      textAlign: "var(--Typography-textAlign)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.noWrap,
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.gutterBottom,
    style: {
      marginBottom: "0.35em"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.paragraph,
    style: {
      marginBottom: 16
    }
  }]
}))), Gx = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, pn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    color: o,
    ...a
  } = Fe({
    props: t,
    name: "MuiTypography"
  }), i = !W_[o], l = U_({
    ...a,
    ...i && {
      color: o
    }
  }), {
    align: c = "inherit",
    className: d,
    component: p,
    gutterBottom: f = !1,
    noWrap: h = !1,
    paragraph: g = !1,
    variant: y = "body1",
    variantMapping: C = Gx,
    ...b
  } = l, v = {
    ...l,
    align: c,
    color: o,
    className: d,
    component: p,
    gutterBottom: f,
    noWrap: h,
    paragraph: g,
    variant: y,
    variantMapping: C
  }, T = p || (g ? "p" : C[y] || Gx[y]) || "span", R = H_(v);
  return /* @__PURE__ */ P.jsx(G_, {
    as: T,
    ref: r,
    className: ge(R.root, d),
    ...b,
    ownerState: v,
    style: {
      ...c !== "inherit" && {
        "--Typography-textAlign": c
      },
      ...b.style
    }
  });
});
process.env.NODE_ENV !== "production" && (pn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: n.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: n.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: n.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: n.bool,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: n.oneOfType([n.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), n.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: n.object
});
function Fw(e) {
  return Ae("MuiAlertTitle", e);
}
const q_ = Ne("MuiAlertTitle", ["root"]), K_ = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, Fw, t);
}, Y_ = Y(pn, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  fontWeight: e.typography.fontWeightMedium,
  marginTop: -2
}))), Lw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAlertTitle"
  }), {
    className: a,
    ...i
  } = o, l = o, c = K_(l);
  return /* @__PURE__ */ P.jsx(Y_, {
    gutterBottom: !0,
    component: "div",
    ownerState: l,
    ref: r,
    className: ge(c.root, a),
    ...i
  });
});
process.env.NODE_ENV !== "production" && (Lw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function Bw(e) {
  return Ae("MuiAppBar", e);
}
const Z_ = Ne("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]), X_ = (e) => {
  const {
    color: t,
    position: r,
    classes: o
  } = e, a = {
    root: ["root", `color${re(t)}`, `position${re(r)}`]
  };
  return Me(a, Bw, o);
}, qx = (e, t) => e ? `${e?.replace(")", "")}, ${t})` : t, J_ = Y(no, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`position${re(r.position)}`], t[`color${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  boxSizing: "border-box",
  // Prevent padding issue with the Modal and fixed positioned AppBar.
  flexShrink: 0,
  variants: [{
    props: {
      position: "fixed"
    },
    style: {
      position: "fixed",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    }
  }, {
    props: {
      position: "absolute"
    },
    style: {
      position: "absolute",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "sticky"
    },
    style: {
      position: "sticky",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "static"
    },
    style: {
      position: "static"
    }
  }, {
    props: {
      position: "relative"
    },
    style: {
      position: "relative"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      "--AppBar-color": "inherit"
    }
  }, {
    props: {
      color: "default"
    },
    style: {
      "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[100],
      "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[100]),
      ...e.applyStyles("dark", {
        "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[900],
        "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[900])
      })
    }
  }, ...Object.entries(e.palette).filter(Vt(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--AppBar-background": (e.vars ?? e).palette[t].main,
      "--AppBar-color": (e.vars ?? e).palette[t].contrastText
    }
  })), {
    props: (t) => t.enableColorOnDark === !0 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)"
    }
  }, {
    props: (t) => t.enableColorOnDark === !1 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundColor: e.vars ? qx(e.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
        color: e.vars ? qx(e.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
      })
    }
  }, {
    props: {
      color: "transparent"
    },
    style: {
      "--AppBar-background": "transparent",
      "--AppBar-color": "inherit",
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundImage: "none"
      })
    }
  }]
}))), Dw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAppBar"
  }), {
    className: a,
    color: i = "primary",
    enableColorOnDark: l = !1,
    position: c = "fixed",
    ...d
  } = o, p = {
    ...o,
    color: i,
    position: c,
    enableColorOnDark: l
  }, f = X_(p);
  return /* @__PURE__ */ P.jsx(J_, {
    square: !0,
    component: "header",
    ownerState: p,
    elevation: 4,
    className: ge(f.root, a, c === "fixed" && "mui-fixed"),
    ref: r,
    ...d
  });
});
process.env.NODE_ENV !== "production" && (Dw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), n.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: n.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/position).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: n.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function Kx(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function Mb(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: r = !0,
    limit: o,
    matchFrom: a = "any",
    stringify: i,
    trim: l = !1
  } = e;
  return (c, {
    inputValue: d,
    getOptionLabel: p
  }) => {
    let f = l ? d.trim() : d;
    r && (f = f.toLowerCase()), t && (f = Kx(f));
    const h = f ? c.filter((g) => {
      let y = (i || p)(g);
      return r && (y = y.toLowerCase()), t && (y = Kx(y)), a === "start" ? y.startsWith(f) : y.includes(f);
    }) : c;
    return typeof o == "number" ? h.slice(0, o) : h;
  };
}
const Q_ = Mb(), Yx = 5, eF = (e) => e.current !== null && e.current.parentElement?.contains(document.activeElement), tF = [];
function Zx(e, t, r) {
  if (t || e == null)
    return "";
  const o = r(e);
  return typeof o == "string" ? o : "";
}
function jw(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = eF,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: r = "Mui",
    autoComplete: o = !1,
    autoHighlight: a = !1,
    autoSelect: i = !1,
    blurOnSelect: l = !1,
    clearOnBlur: c = !e.freeSolo,
    clearOnEscape: d = !1,
    componentName: p = "useAutocomplete",
    defaultValue: f = e.multiple ? tF : null,
    disableClearable: h = !1,
    disableCloseOnSelect: g = !1,
    disabled: y,
    disabledItemsFocusable: C = !1,
    disableListWrap: b = !1,
    filterOptions: v = Q_,
    filterSelectedOptions: T = !1,
    freeSolo: R = !1,
    getOptionDisabled: $,
    getOptionKey: E,
    getOptionLabel: S = (Te) => Te.label ?? Te,
    groupBy: k,
    handleHomeEndKeys: A = !e.freeSolo,
    id: _,
    includeInputInList: L = !1,
    inputValue: O,
    isOptionEqualToValue: F = (Te, ve) => Te === ve,
    multiple: B = !1,
    onChange: M,
    onClose: j,
    onHighlightChange: W,
    onInputChange: V,
    onOpen: X,
    open: U,
    openOnFocus: H = !1,
    options: Z,
    readOnly: G = !1,
    selectOnFocus: ye = !e.freeSolo,
    value: de
  } = e, ne = eo(_);
  let fe = S;
  fe = (Te) => {
    const ve = S(Te);
    if (typeof ve != "string") {
      if (process.env.NODE_ENV !== "production") {
        const je = ve === void 0 ? "undefined" : `${typeof ve} (${ve})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${p} returned ${je} instead of a string for ${JSON.stringify(Te)}.`);
      }
      return String(ve);
    }
    return ve;
  };
  const ie = x.useRef(!1), oe = x.useRef(!0), ce = x.useRef(null), Ce = x.useRef(null), [xe, Re] = x.useState(null), [J, Ie] = x.useState(-1), le = a ? 0 : -1, qe = x.useRef(le), q = x.useRef(Zx(f ?? de, B, fe)).current, [K, ee] = Bn({
    controlled: de,
    default: f,
    name: p
  }), [he, we] = Bn({
    controlled: O,
    default: q,
    name: p,
    state: "inputValue"
  }), [se, ue] = x.useState(!1), Qe = x.useCallback((Te, ve, je) => {
    if (!(B ? K.length < ve.length : ve !== null) && !c)
      return;
    const mt = Zx(ve, B, fe);
    he !== mt && (we(mt), V && V(Te, mt, je));
  }, [fe, he, B, V, we, c, K]), [We, be] = Bn({
    controlled: U,
    default: !1,
    name: p,
    state: "open"
  }), [Se, De] = x.useState(!0), Ye = !B && K != null && he === fe(K), et = We && !G, Je = et ? v(
    Z.filter((Te) => !(T && (B ? K : [K]).some((ve) => ve !== null && F(Te, ve)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ye && Se ? "" : he,
      getOptionLabel: fe
    }
  ) : [], tt = bb({
    filteredOptions: Je,
    value: K,
    inputValue: he
  });
  x.useEffect(() => {
    const Te = K !== tt.value;
    se && !Te || R && !Te || Qe(null, K, "reset");
  }, [K, Qe, se, tt.value, R]);
  const Rt = We && Je.length > 0 && !G, xt = Pr((Te) => {
    Te === -1 ? ce.current.focus() : xe.querySelector(`[data-tag-index="${Te}"]`).focus();
  });
  x.useEffect(() => {
    B && J > K.length - 1 && (Ie(-1), xt(-1));
  }, [K, B, J, xt]);
  function rt(Te, ve) {
    if (!Ce.current || Te < 0 || Te >= Je.length)
      return -1;
    let je = Te;
    for (; ; ) {
      const ht = Ce.current.querySelector(`[data-option-index="${je}"]`), mt = C ? !1 : !ht || ht.disabled || ht.getAttribute("aria-disabled") === "true";
      if (ht && ht.hasAttribute("tabindex") && !mt)
        return je;
      if (ve === "next" ? je = (je + 1) % Je.length : je = (je - 1 + Je.length) % Je.length, je === Te)
        return -1;
    }
  }
  const He = Pr(({
    event: Te,
    index: ve,
    reason: je
  }) => {
    if (qe.current = ve, ve === -1 ? ce.current.removeAttribute("aria-activedescendant") : ce.current.setAttribute("aria-activedescendant", `${ne}-option-${ve}`), W && ["mouse", "keyboard", "touch"].includes(je) && W(Te, ve === -1 ? null : Je[ve], je), !Ce.current)
      return;
    const ht = Ce.current.querySelector(`[role="option"].${r}-focused`);
    ht && (ht.classList.remove(`${r}-focused`), ht.classList.remove(`${r}-focusVisible`));
    let mt = Ce.current;
    if (Ce.current.getAttribute("role") !== "listbox" && (mt = Ce.current.parentElement.querySelector('[role="listbox"]')), !mt)
      return;
    if (ve === -1) {
      mt.scrollTop = 0;
      return;
    }
    const vt = Ce.current.querySelector(`[data-option-index="${ve}"]`);
    if (vt && (vt.classList.add(`${r}-focused`), je === "keyboard" && vt.classList.add(`${r}-focusVisible`), mt.scrollHeight > mt.clientHeight && je !== "mouse" && je !== "touch")) {
      const Kt = vt, br = mt.clientHeight + mt.scrollTop, $n = Kt.offsetTop + Kt.offsetHeight;
      $n > br ? mt.scrollTop = $n - mt.clientHeight : Kt.offsetTop - Kt.offsetHeight * (k ? 1.3 : 0) < mt.scrollTop && (mt.scrollTop = Kt.offsetTop - Kt.offsetHeight * (k ? 1.3 : 0));
    }
  }), Oe = Pr(({
    event: Te,
    diff: ve,
    direction: je = "next",
    reason: ht
  }) => {
    if (!et)
      return;
    const vt = rt((() => {
      const Kt = Je.length - 1;
      if (ve === "reset")
        return le;
      if (ve === "start")
        return 0;
      if (ve === "end")
        return Kt;
      const br = qe.current + ve;
      return br < 0 ? br === -1 && L ? -1 : b && qe.current !== -1 || Math.abs(ve) > 1 ? 0 : Kt : br > Kt ? br === Kt + 1 && L ? -1 : b || Math.abs(ve) > 1 ? Kt : 0 : br;
    })(), je);
    if (He({
      index: vt,
      reason: ht,
      event: Te
    }), o && ve !== "reset")
      if (vt === -1)
        ce.current.value = he;
      else {
        const Kt = fe(Je[vt]);
        ce.current.value = Kt, Kt.toLowerCase().indexOf(he.toLowerCase()) === 0 && he.length > 0 && ce.current.setSelectionRange(he.length, Kt.length);
      }
  }), Ze = () => {
    const Te = (ve, je) => {
      const ht = ve ? fe(ve) : "", mt = je ? fe(je) : "";
      return ht === mt;
    };
    if (qe.current !== -1 && tt.filteredOptions && tt.filteredOptions.length !== Je.length && tt.inputValue === he && (B ? K.length === tt.value.length && tt.value.every((ve, je) => fe(K[je]) === fe(ve)) : Te(tt.value, K))) {
      const ve = tt.filteredOptions[qe.current];
      if (ve)
        return Je.findIndex((je) => fe(je) === fe(ve));
    }
    return -1;
  }, Pt = x.useCallback(() => {
    if (!et)
      return;
    const Te = Ze();
    if (Te !== -1) {
      qe.current = Te;
      return;
    }
    const ve = B ? K[0] : K;
    if (Je.length === 0 || ve == null) {
      Oe({
        diff: "reset"
      });
      return;
    }
    if (Ce.current) {
      if (ve != null) {
        const je = Je[qe.current];
        if (B && je && K.findIndex((mt) => F(je, mt)) !== -1)
          return;
        const ht = Je.findIndex((mt) => F(mt, ve));
        ht === -1 ? Oe({
          diff: "reset"
        }) : He({
          index: ht
        });
        return;
      }
      if (qe.current >= Je.length - 1) {
        He({
          index: Je.length - 1
        });
        return;
      }
      He({
        index: qe.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Je.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    B ? !1 : K,
    T,
    Oe,
    He,
    et,
    he,
    B
  ]), Mt = Pr((Te) => {
    cp(Ce, Te), Te && Pt();
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    (!ce.current || ce.current.nodeName !== "INPUT") && (ce.current && ce.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${p} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${ce.current} while an HTMLInputElement was expected.`, `Instead, ${p} expects an input element.`, "", p === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [p]), x.useEffect(() => {
    Pt();
  }, [Pt]);
  const Ct = (Te) => {
    We || (be(!0), De(!0), X && X(Te));
  }, bt = (Te, ve) => {
    We && (be(!1), j && j(Te, ve));
  }, nt = (Te, ve, je, ht) => {
    if (B) {
      if (K.length === ve.length && K.every((mt, vt) => mt === ve[vt]))
        return;
    } else if (K === ve)
      return;
    M && M(Te, ve, je, ht), ee(ve);
  }, ft = x.useRef(!1), er = (Te, ve, je = "selectOption", ht = "options") => {
    let mt = je, vt = ve;
    if (B) {
      if (vt = Array.isArray(K) ? K.slice() : [], process.env.NODE_ENV !== "production") {
        const br = vt.filter(($n) => F(ve, $n));
        br.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${p} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${br.length} matches.`].join(`
`));
      }
      const Kt = vt.findIndex((br) => F(ve, br));
      Kt === -1 ? vt.push(ve) : ht !== "freeSolo" && (vt.splice(Kt, 1), mt = "removeOption");
    }
    Qe(Te, vt, mt), nt(Te, vt, mt, {
      option: ve
    }), !g && (!Te || !Te.ctrlKey && !Te.metaKey) && bt(Te, mt), (l === !0 || l === "touch" && ft.current || l === "mouse" && !ft.current) && ce.current.blur();
  };
  function Ut(Te, ve) {
    if (Te === -1)
      return -1;
    let je = Te;
    for (; ; ) {
      if (ve === "next" && je === K.length || ve === "previous" && je === -1)
        return -1;
      const ht = xe.querySelector(`[data-tag-index="${je}"]`);
      if (!ht || !ht.hasAttribute("tabindex") || ht.disabled || ht.getAttribute("aria-disabled") === "true")
        je += ve === "next" ? 1 : -1;
      else
        return je;
    }
  }
  const Ft = (Te, ve) => {
    if (!B)
      return;
    he === "" && bt(Te, "toggleInput");
    let je = J;
    J === -1 ? he === "" && ve === "previous" && (je = K.length - 1) : (je += ve === "next" ? 1 : -1, je < 0 && (je = 0), je === K.length && (je = -1)), je = Ut(je, ve), Ie(je), xt(je);
  }, ct = (Te) => {
    ie.current = !0, we(""), V && V(Te, "", "clear"), nt(Te, B ? [] : null, "clear");
  }, fr = (Te) => (ve) => {
    if (Te.onKeyDown && Te.onKeyDown(ve), !ve.defaultMuiPrevented && (J !== -1 && !["ArrowLeft", "ArrowRight"].includes(ve.key) && (Ie(-1), xt(-1)), ve.which !== 229))
      switch (ve.key) {
        case "Home":
          et && A && (ve.preventDefault(), Oe({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: ve
          }));
          break;
        case "End":
          et && A && (ve.preventDefault(), Oe({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: ve
          }));
          break;
        case "PageUp":
          ve.preventDefault(), Oe({
            diff: -Yx,
            direction: "previous",
            reason: "keyboard",
            event: ve
          }), Ct(ve);
          break;
        case "PageDown":
          ve.preventDefault(), Oe({
            diff: Yx,
            direction: "next",
            reason: "keyboard",
            event: ve
          }), Ct(ve);
          break;
        case "ArrowDown":
          ve.preventDefault(), Oe({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: ve
          }), Ct(ve);
          break;
        case "ArrowUp":
          ve.preventDefault(), Oe({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: ve
          }), Ct(ve);
          break;
        case "ArrowLeft":
          Ft(ve, "previous");
          break;
        case "ArrowRight":
          Ft(ve, "next");
          break;
        case "Enter":
          if (qe.current !== -1 && et) {
            const je = Je[qe.current], ht = $ ? $(je) : !1;
            if (ve.preventDefault(), ht)
              return;
            er(ve, je, "selectOption"), o && ce.current.setSelectionRange(ce.current.value.length, ce.current.value.length);
          } else R && he !== "" && Ye === !1 && (B && ve.preventDefault(), er(ve, he, "createOption", "freeSolo"));
          break;
        case "Escape":
          et ? (ve.preventDefault(), ve.stopPropagation(), bt(ve, "escape")) : d && (he !== "" || B && K.length > 0) && (ve.preventDefault(), ve.stopPropagation(), ct(ve));
          break;
        case "Backspace":
          if (B && !G && he === "" && K.length > 0) {
            const je = J === -1 ? K.length - 1 : J, ht = K.slice();
            ht.splice(je, 1), nt(ve, ht, "removeOption", {
              option: K[je]
            });
          }
          break;
        case "Delete":
          if (B && !G && he === "" && K.length > 0 && J !== -1) {
            const je = J, ht = K.slice();
            ht.splice(je, 1), nt(ve, ht, "removeOption", {
              option: K[je]
            });
          }
          break;
      }
  }, at = (Te) => {
    ue(!0), H && !ie.current && Ct(Te);
  }, lt = (Te) => {
    if (t(Ce)) {
      ce.current.focus();
      return;
    }
    ue(!1), oe.current = !0, ie.current = !1, i && qe.current !== -1 && et ? er(Te, Je[qe.current], "blur") : i && R && he !== "" ? er(Te, he, "blur", "freeSolo") : c && Qe(Te, K, "blur"), bt(Te, "blur");
  }, St = (Te) => {
    const ve = Te.target.value;
    he !== ve && (we(ve), De(!1), V && V(Te, ve, "input")), ve === "" ? !h && !B && nt(Te, null, "clear") : Ct(Te);
  }, kt = (Te) => {
    const ve = Number(Te.currentTarget.getAttribute("data-option-index"));
    qe.current !== ve && He({
      event: Te,
      index: ve,
      reason: "mouse"
    });
  }, Wt = (Te) => {
    He({
      event: Te,
      index: Number(Te.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), ft.current = !0;
  }, Lr = (Te) => {
    const ve = Number(Te.currentTarget.getAttribute("data-option-index"));
    er(Te, Je[ve], "selectOption"), ft.current = !1;
  }, hn = (Te) => (ve) => {
    const je = K.slice();
    je.splice(Te, 1), nt(ve, je, "removeOption", {
      option: K[Te]
    });
  }, oo = (Te) => {
    We ? bt(Te, "toggleInput") : Ct(Te);
  }, te = (Te) => {
    Te.currentTarget.contains(Te.target) && Te.target.getAttribute("id") !== ne && Te.preventDefault();
  }, _e = (Te) => {
    Te.currentTarget.contains(Te.target) && (ce.current.focus(), ye && oe.current && ce.current.selectionEnd - ce.current.selectionStart === 0 && ce.current.select(), oe.current = !1);
  }, Xe = (Te) => {
    !y && (he === "" || !We) && oo(Te);
  };
  let yt = R && he.length > 0;
  yt = yt || (B ? K.length > 0 : K !== null);
  let Ht = Je;
  if (k) {
    const Te = /* @__PURE__ */ new Map();
    let ve = !1;
    Ht = Je.reduce((je, ht, mt) => {
      const vt = k(ht);
      return je.length > 0 && je[je.length - 1].group === vt ? je[je.length - 1].options.push(ht) : (process.env.NODE_ENV !== "production" && (Te.get(vt) && !ve && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${p} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), ve = !0), Te.set(vt, !0)), je.push({
        key: mt,
        index: mt,
        group: vt,
        options: [ht]
      })), je;
    }, []);
  }
  return y && se && lt(), {
    getRootProps: (Te = {}) => ({
      ...Te,
      onKeyDown: fr(Te),
      onMouseDown: te,
      onClick: _e
    }),
    getInputLabelProps: () => ({
      id: `${ne}-label`,
      htmlFor: ne
    }),
    getInputProps: () => ({
      id: ne,
      value: he,
      onBlur: lt,
      onFocus: at,
      onChange: St,
      onMouseDown: Xe,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": et ? "" : null,
      "aria-autocomplete": o ? "both" : "list",
      "aria-controls": Rt ? `${ne}-listbox` : void 0,
      "aria-expanded": Rt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: ce,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: y
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: ct
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: oo
    }),
    getTagProps: ({
      index: Te
    }) => ({
      key: Te,
      "data-tag-index": Te,
      tabIndex: -1,
      ...!G && {
        onDelete: hn(Te)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${ne}-listbox`,
      "aria-labelledby": `${ne}-label`,
      ref: Mt,
      onMouseDown: (Te) => {
        Te.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Te,
      option: ve
    }) => {
      const je = (B ? K : [K]).some((mt) => mt != null && F(ve, mt)), ht = $ ? $(ve) : !1;
      return {
        key: E?.(ve) ?? fe(ve),
        tabIndex: -1,
        role: "option",
        id: `${ne}-option-${Te}`,
        onMouseMove: kt,
        onClick: Lr,
        onTouchStart: Wt,
        "data-option-index": Te,
        "aria-disabled": ht,
        "aria-selected": je
      };
    },
    id: ne,
    inputValue: he,
    value: K,
    dirty: yt,
    expanded: et && xe,
    popupOpen: et,
    focused: se || J !== -1,
    anchorEl: xe,
    setAnchorEl: Re,
    focusedTag: J,
    groupedOptions: Ht
  };
}
var Zn = "top", qo = "bottom", Ko = "right", Xn = "left", _b = "auto", du = [Zn, qo, Ko, Xn], Ol = "start", Vc = "end", rF = "clippingParents", zw = "viewport", uc = "popper", nF = "reference", Xx = /* @__PURE__ */ du.reduce(function(e, t) {
  return e.concat([t + "-" + Ol, t + "-" + Vc]);
}, []), Vw = /* @__PURE__ */ [].concat(du, [_b]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ol, t + "-" + Vc]);
}, []), oF = "beforeRead", aF = "read", iF = "afterRead", sF = "beforeMain", lF = "main", cF = "afterMain", uF = "beforeWrite", dF = "write", pF = "afterWrite", fF = [oF, aF, iF, sF, lF, cF, uF, dF, pF];
function Pa(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Oo(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Os(e) {
  var t = Oo(e).Element;
  return e instanceof t || e instanceof Element;
}
function Go(e) {
  var t = Oo(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Fb(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Oo(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function mF(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var o = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !Go(i) || !Pa(i) || (Object.assign(i.style, o), Object.keys(a).forEach(function(l) {
      var c = a[l];
      c === !1 ? i.removeAttribute(l) : i.setAttribute(l, c === !0 ? "" : c);
    }));
  });
}
function hF(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var a = t.elements[o], i = t.attributes[o] || {}, l = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : r[o]), c = l.reduce(function(d, p) {
        return d[p] = "", d;
      }, {});
      !Go(a) || !Pa(a) || (Object.assign(a.style, c), Object.keys(i).forEach(function(d) {
        a.removeAttribute(d);
      }));
    });
  };
}
const gF = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: mF,
  effect: hF,
  requires: ["computeStyles"]
};
function Ta(e) {
  return e.split("-")[0];
}
var bs = Math.max, bp = Math.min, $l = Math.round;
function dg() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Ww() {
  return !/^((?!chrome|android).)*safari/i.test(dg());
}
function Rl(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var o = e.getBoundingClientRect(), a = 1, i = 1;
  t && Go(e) && (a = e.offsetWidth > 0 && $l(o.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && $l(o.height) / e.offsetHeight || 1);
  var l = Os(e) ? Oo(e) : window, c = l.visualViewport, d = !Ww() && r, p = (o.left + (d && c ? c.offsetLeft : 0)) / a, f = (o.top + (d && c ? c.offsetTop : 0)) / i, h = o.width / a, g = o.height / i;
  return {
    width: h,
    height: g,
    top: f,
    right: p + h,
    bottom: f + g,
    left: p,
    x: p,
    y: f
  };
}
function Lb(e) {
  var t = Rl(e), r = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: o
  };
}
function Uw(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Fb(r)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function ni(e) {
  return Oo(e).getComputedStyle(e);
}
function bF(e) {
  return ["table", "td", "th"].indexOf(Pa(e)) >= 0;
}
function _i(e) {
  return ((Os(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function sf(e) {
  return Pa(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Fb(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    _i(e)
  );
}
function Jx(e) {
  return !Go(e) || // https://github.com/popperjs/popper-core/issues/837
  ni(e).position === "fixed" ? null : e.offsetParent;
}
function yF(e) {
  var t = /firefox/i.test(dg()), r = /Trident/i.test(dg());
  if (r && Go(e)) {
    var o = ni(e);
    if (o.position === "fixed")
      return null;
  }
  var a = sf(e);
  for (Fb(a) && (a = a.host); Go(a) && ["html", "body"].indexOf(Pa(a)) < 0; ) {
    var i = ni(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function pu(e) {
  for (var t = Oo(e), r = Jx(e); r && bF(r) && ni(r).position === "static"; )
    r = Jx(r);
  return r && (Pa(r) === "html" || Pa(r) === "body" && ni(r).position === "static") ? t : r || yF(e) || t;
}
function Bb(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function kc(e, t, r) {
  return bs(e, bp(t, r));
}
function vF(e, t, r) {
  var o = kc(e, t, r);
  return o > r ? r : o;
}
function Hw() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Gw(e) {
  return Object.assign({}, Hw(), e);
}
function qw(e, t) {
  return t.reduce(function(r, o) {
    return r[o] = e, r;
  }, {});
}
var xF = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Gw(typeof t != "number" ? t : qw(t, du));
};
function CF(e) {
  var t, r = e.state, o = e.name, a = e.options, i = r.elements.arrow, l = r.modifiersData.popperOffsets, c = Ta(r.placement), d = Bb(c), p = [Xn, Ko].indexOf(c) >= 0, f = p ? "height" : "width";
  if (!(!i || !l)) {
    var h = xF(a.padding, r), g = Lb(i), y = d === "y" ? Zn : Xn, C = d === "y" ? qo : Ko, b = r.rects.reference[f] + r.rects.reference[d] - l[d] - r.rects.popper[f], v = l[d] - r.rects.reference[d], T = pu(i), R = T ? d === "y" ? T.clientHeight || 0 : T.clientWidth || 0 : 0, $ = b / 2 - v / 2, E = h[y], S = R - g[f] - h[C], k = R / 2 - g[f] / 2 + $, A = kc(E, k, S), _ = d;
    r.modifiersData[o] = (t = {}, t[_] = A, t.centerOffset = A - k, t);
  }
}
function SF(e) {
  var t = e.state, r = e.options, o = r.element, a = o === void 0 ? "[data-popper-arrow]" : o;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Uw(t.elements.popper, a) && (t.elements.arrow = a));
}
const wF = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: CF,
  effect: SF,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Pl(e) {
  return e.split("-")[1];
}
var TF = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function EF(e, t) {
  var r = e.x, o = e.y, a = t.devicePixelRatio || 1;
  return {
    x: $l(r * a) / a || 0,
    y: $l(o * a) / a || 0
  };
}
function Qx(e) {
  var t, r = e.popper, o = e.popperRect, a = e.placement, i = e.variation, l = e.offsets, c = e.position, d = e.gpuAcceleration, p = e.adaptive, f = e.roundOffsets, h = e.isFixed, g = l.x, y = g === void 0 ? 0 : g, C = l.y, b = C === void 0 ? 0 : C, v = typeof f == "function" ? f({
    x: y,
    y: b
  }) : {
    x: y,
    y: b
  };
  y = v.x, b = v.y;
  var T = l.hasOwnProperty("x"), R = l.hasOwnProperty("y"), $ = Xn, E = Zn, S = window;
  if (p) {
    var k = pu(r), A = "clientHeight", _ = "clientWidth";
    if (k === Oo(r) && (k = _i(r), ni(k).position !== "static" && c === "absolute" && (A = "scrollHeight", _ = "scrollWidth")), k = k, a === Zn || (a === Xn || a === Ko) && i === Vc) {
      E = qo;
      var L = h && k === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[A]
      );
      b -= L - o.height, b *= d ? 1 : -1;
    }
    if (a === Xn || (a === Zn || a === qo) && i === Vc) {
      $ = Ko;
      var O = h && k === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[_]
      );
      y -= O - o.width, y *= d ? 1 : -1;
    }
  }
  var F = Object.assign({
    position: c
  }, p && TF), B = f === !0 ? EF({
    x: y,
    y: b
  }, Oo(r)) : {
    x: y,
    y: b
  };
  if (y = B.x, b = B.y, d) {
    var M;
    return Object.assign({}, F, (M = {}, M[E] = R ? "0" : "", M[$] = T ? "0" : "", M.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + b + "px)" : "translate3d(" + y + "px, " + b + "px, 0)", M));
  }
  return Object.assign({}, F, (t = {}, t[E] = R ? b + "px" : "", t[$] = T ? y + "px" : "", t.transform = "", t));
}
function OF(e) {
  var t = e.state, r = e.options, o = r.gpuAcceleration, a = o === void 0 ? !0 : o, i = r.adaptive, l = i === void 0 ? !0 : i, c = r.roundOffsets, d = c === void 0 ? !0 : c, p = {
    placement: Ta(t.placement),
    variation: Pl(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Qx(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: d
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Qx(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const $F = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: OF,
  data: {}
};
var xd = {
  passive: !0
};
function RF(e) {
  var t = e.state, r = e.instance, o = e.options, a = o.scroll, i = a === void 0 ? !0 : a, l = o.resize, c = l === void 0 ? !0 : l, d = Oo(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && p.forEach(function(f) {
    f.addEventListener("scroll", r.update, xd);
  }), c && d.addEventListener("resize", r.update, xd), function() {
    i && p.forEach(function(f) {
      f.removeEventListener("scroll", r.update, xd);
    }), c && d.removeEventListener("resize", r.update, xd);
  };
}
const PF = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: RF,
  data: {}
};
var kF = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Gd(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return kF[t];
  });
}
var AF = {
  start: "end",
  end: "start"
};
function eC(e) {
  return e.replace(/start|end/g, function(t) {
    return AF[t];
  });
}
function Db(e) {
  var t = Oo(e), r = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: o
  };
}
function jb(e) {
  return Rl(_i(e)).left + Db(e).scrollLeft;
}
function IF(e, t) {
  var r = Oo(e), o = _i(e), a = r.visualViewport, i = o.clientWidth, l = o.clientHeight, c = 0, d = 0;
  if (a) {
    i = a.width, l = a.height;
    var p = Ww();
    (p || !p && t === "fixed") && (c = a.offsetLeft, d = a.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: c + jb(e),
    y: d
  };
}
function NF(e) {
  var t, r = _i(e), o = Db(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = bs(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), l = bs(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), c = -o.scrollLeft + jb(e), d = -o.scrollTop;
  return ni(a || r).direction === "rtl" && (c += bs(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: c,
    y: d
  };
}
function zb(e) {
  var t = ni(e), r = t.overflow, o = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + o);
}
function Kw(e) {
  return ["html", "body", "#document"].indexOf(Pa(e)) >= 0 ? e.ownerDocument.body : Go(e) && zb(e) ? e : Kw(sf(e));
}
function Ac(e, t) {
  var r;
  t === void 0 && (t = []);
  var o = Kw(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Oo(o), l = a ? [i].concat(i.visualViewport || [], zb(o) ? o : []) : o, c = t.concat(l);
  return a ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(Ac(sf(l)))
  );
}
function pg(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function MF(e, t) {
  var r = Rl(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function tC(e, t, r) {
  return t === zw ? pg(IF(e, r)) : Os(t) ? MF(t, r) : pg(NF(_i(e)));
}
function _F(e) {
  var t = Ac(sf(e)), r = ["absolute", "fixed"].indexOf(ni(e).position) >= 0, o = r && Go(e) ? pu(e) : e;
  return Os(o) ? t.filter(function(a) {
    return Os(a) && Uw(a, o) && Pa(a) !== "body";
  }) : [];
}
function FF(e, t, r, o) {
  var a = t === "clippingParents" ? _F(e) : [].concat(t), i = [].concat(a, [r]), l = i[0], c = i.reduce(function(d, p) {
    var f = tC(e, p, o);
    return d.top = bs(f.top, d.top), d.right = bp(f.right, d.right), d.bottom = bp(f.bottom, d.bottom), d.left = bs(f.left, d.left), d;
  }, tC(e, l, o));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function Yw(e) {
  var t = e.reference, r = e.element, o = e.placement, a = o ? Ta(o) : null, i = o ? Pl(o) : null, l = t.x + t.width / 2 - r.width / 2, c = t.y + t.height / 2 - r.height / 2, d;
  switch (a) {
    case Zn:
      d = {
        x: l,
        y: t.y - r.height
      };
      break;
    case qo:
      d = {
        x: l,
        y: t.y + t.height
      };
      break;
    case Ko:
      d = {
        x: t.x + t.width,
        y: c
      };
      break;
    case Xn:
      d = {
        x: t.x - r.width,
        y: c
      };
      break;
    default:
      d = {
        x: t.x,
        y: t.y
      };
  }
  var p = a ? Bb(a) : null;
  if (p != null) {
    var f = p === "y" ? "height" : "width";
    switch (i) {
      case Ol:
        d[p] = d[p] - (t[f] / 2 - r[f] / 2);
        break;
      case Vc:
        d[p] = d[p] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return d;
}
function Wc(e, t) {
  t === void 0 && (t = {});
  var r = t, o = r.placement, a = o === void 0 ? e.placement : o, i = r.strategy, l = i === void 0 ? e.strategy : i, c = r.boundary, d = c === void 0 ? rF : c, p = r.rootBoundary, f = p === void 0 ? zw : p, h = r.elementContext, g = h === void 0 ? uc : h, y = r.altBoundary, C = y === void 0 ? !1 : y, b = r.padding, v = b === void 0 ? 0 : b, T = Gw(typeof v != "number" ? v : qw(v, du)), R = g === uc ? nF : uc, $ = e.rects.popper, E = e.elements[C ? R : g], S = FF(Os(E) ? E : E.contextElement || _i(e.elements.popper), d, f, l), k = Rl(e.elements.reference), A = Yw({
    reference: k,
    element: $,
    placement: a
  }), _ = pg(Object.assign({}, $, A)), L = g === uc ? _ : k, O = {
    top: S.top - L.top + T.top,
    bottom: L.bottom - S.bottom + T.bottom,
    left: S.left - L.left + T.left,
    right: L.right - S.right + T.right
  }, F = e.modifiersData.offset;
  if (g === uc && F) {
    var B = F[a];
    Object.keys(O).forEach(function(M) {
      var j = [Ko, qo].indexOf(M) >= 0 ? 1 : -1, W = [Zn, qo].indexOf(M) >= 0 ? "y" : "x";
      O[M] += B[W] * j;
    });
  }
  return O;
}
function LF(e, t) {
  t === void 0 && (t = {});
  var r = t, o = r.placement, a = r.boundary, i = r.rootBoundary, l = r.padding, c = r.flipVariations, d = r.allowedAutoPlacements, p = d === void 0 ? Vw : d, f = Pl(o), h = f ? c ? Xx : Xx.filter(function(C) {
    return Pl(C) === f;
  }) : du, g = h.filter(function(C) {
    return p.indexOf(C) >= 0;
  });
  g.length === 0 && (g = h);
  var y = g.reduce(function(C, b) {
    return C[b] = Wc(e, {
      placement: b,
      boundary: a,
      rootBoundary: i,
      padding: l
    })[Ta(b)], C;
  }, {});
  return Object.keys(y).sort(function(C, b) {
    return y[C] - y[b];
  });
}
function BF(e) {
  if (Ta(e) === _b)
    return [];
  var t = Gd(e);
  return [eC(e), t, eC(t)];
}
function DF(e) {
  var t = e.state, r = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, l = r.altAxis, c = l === void 0 ? !0 : l, d = r.fallbackPlacements, p = r.padding, f = r.boundary, h = r.rootBoundary, g = r.altBoundary, y = r.flipVariations, C = y === void 0 ? !0 : y, b = r.allowedAutoPlacements, v = t.options.placement, T = Ta(v), R = T === v, $ = d || (R || !C ? [Gd(v)] : BF(v)), E = [v].concat($).reduce(function(ne, fe) {
      return ne.concat(Ta(fe) === _b ? LF(t, {
        placement: fe,
        boundary: f,
        rootBoundary: h,
        padding: p,
        flipVariations: C,
        allowedAutoPlacements: b
      }) : fe);
    }, []), S = t.rects.reference, k = t.rects.popper, A = /* @__PURE__ */ new Map(), _ = !0, L = E[0], O = 0; O < E.length; O++) {
      var F = E[O], B = Ta(F), M = Pl(F) === Ol, j = [Zn, qo].indexOf(B) >= 0, W = j ? "width" : "height", V = Wc(t, {
        placement: F,
        boundary: f,
        rootBoundary: h,
        altBoundary: g,
        padding: p
      }), X = j ? M ? Ko : Xn : M ? qo : Zn;
      S[W] > k[W] && (X = Gd(X));
      var U = Gd(X), H = [];
      if (i && H.push(V[B] <= 0), c && H.push(V[X] <= 0, V[U] <= 0), H.every(function(ne) {
        return ne;
      })) {
        L = F, _ = !1;
        break;
      }
      A.set(F, H);
    }
    if (_)
      for (var Z = C ? 3 : 1, G = function(fe) {
        var ie = E.find(function(oe) {
          var ce = A.get(oe);
          if (ce)
            return ce.slice(0, fe).every(function(Ce) {
              return Ce;
            });
        });
        if (ie)
          return L = ie, "break";
      }, ye = Z; ye > 0; ye--) {
        var de = G(ye);
        if (de === "break") break;
      }
    t.placement !== L && (t.modifiersData[o]._skip = !0, t.placement = L, t.reset = !0);
  }
}
const jF = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: DF,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function rC(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function nC(e) {
  return [Zn, Ko, qo, Xn].some(function(t) {
    return e[t] >= 0;
  });
}
function zF(e) {
  var t = e.state, r = e.name, o = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, l = Wc(t, {
    elementContext: "reference"
  }), c = Wc(t, {
    altBoundary: !0
  }), d = rC(l, o), p = rC(c, a, i), f = nC(d), h = nC(p);
  t.modifiersData[r] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: p,
    isReferenceHidden: f,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": h
  });
}
const VF = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: zF
};
function WF(e, t, r) {
  var o = Ta(e), a = [Xn, Zn].indexOf(o) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, l = i[0], c = i[1];
  return l = l || 0, c = (c || 0) * a, [Xn, Ko].indexOf(o) >= 0 ? {
    x: c,
    y: l
  } : {
    x: l,
    y: c
  };
}
function UF(e) {
  var t = e.state, r = e.options, o = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, l = Vw.reduce(function(f, h) {
    return f[h] = WF(h, t.rects, i), f;
  }, {}), c = l[t.placement], d = c.x, p = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += p), t.modifiersData[o] = l;
}
const HF = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: UF
};
function GF(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Yw({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const qF = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: GF,
  data: {}
};
function KF(e) {
  return e === "x" ? "y" : "x";
}
function YF(e) {
  var t = e.state, r = e.options, o = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, l = r.altAxis, c = l === void 0 ? !1 : l, d = r.boundary, p = r.rootBoundary, f = r.altBoundary, h = r.padding, g = r.tether, y = g === void 0 ? !0 : g, C = r.tetherOffset, b = C === void 0 ? 0 : C, v = Wc(t, {
    boundary: d,
    rootBoundary: p,
    padding: h,
    altBoundary: f
  }), T = Ta(t.placement), R = Pl(t.placement), $ = !R, E = Bb(T), S = KF(E), k = t.modifiersData.popperOffsets, A = t.rects.reference, _ = t.rects.popper, L = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, O = typeof L == "number" ? {
    mainAxis: L,
    altAxis: L
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, L), F = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var M, j = E === "y" ? Zn : Xn, W = E === "y" ? qo : Ko, V = E === "y" ? "height" : "width", X = k[E], U = X + v[j], H = X - v[W], Z = y ? -_[V] / 2 : 0, G = R === Ol ? A[V] : _[V], ye = R === Ol ? -_[V] : -A[V], de = t.elements.arrow, ne = y && de ? Lb(de) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Hw(), ie = fe[j], oe = fe[W], ce = kc(0, A[V], ne[V]), Ce = $ ? A[V] / 2 - Z - ce - ie - O.mainAxis : G - ce - ie - O.mainAxis, xe = $ ? -A[V] / 2 + Z + ce + oe + O.mainAxis : ye + ce + oe + O.mainAxis, Re = t.elements.arrow && pu(t.elements.arrow), J = Re ? E === "y" ? Re.clientTop || 0 : Re.clientLeft || 0 : 0, Ie = (M = F?.[E]) != null ? M : 0, le = X + Ce - Ie - J, qe = X + xe - Ie, q = kc(y ? bp(U, le) : U, X, y ? bs(H, qe) : H);
      k[E] = q, B[E] = q - X;
    }
    if (c) {
      var K, ee = E === "x" ? Zn : Xn, he = E === "x" ? qo : Ko, we = k[S], se = S === "y" ? "height" : "width", ue = we + v[ee], Qe = we - v[he], We = [Zn, Xn].indexOf(T) !== -1, be = (K = F?.[S]) != null ? K : 0, Se = We ? ue : we - A[se] - _[se] - be + O.altAxis, De = We ? we + A[se] + _[se] - be - O.altAxis : Qe, Ye = y && We ? vF(Se, we, De) : kc(y ? Se : ue, we, y ? De : Qe);
      k[S] = Ye, B[S] = Ye - we;
    }
    t.modifiersData[o] = B;
  }
}
const ZF = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: YF,
  requiresIfExists: ["offset"]
};
function XF(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function JF(e) {
  return e === Oo(e) || !Go(e) ? Db(e) : XF(e);
}
function QF(e) {
  var t = e.getBoundingClientRect(), r = $l(t.width) / e.offsetWidth || 1, o = $l(t.height) / e.offsetHeight || 1;
  return r !== 1 || o !== 1;
}
function eL(e, t, r) {
  r === void 0 && (r = !1);
  var o = Go(t), a = Go(t) && QF(t), i = _i(t), l = Rl(e, a, r), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (o || !o && !r) && ((Pa(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  zb(i)) && (c = JF(t)), Go(t) ? (d = Rl(t, !0), d.x += t.clientLeft, d.y += t.clientTop) : i && (d.x = jb(i))), {
    x: l.left + c.scrollLeft - d.x,
    y: l.top + c.scrollTop - d.y,
    width: l.width,
    height: l.height
  };
}
function tL(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(c) {
      if (!r.has(c)) {
        var d = t.get(c);
        d && a(d);
      }
    }), o.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), o;
}
function rL(e) {
  var t = tL(e);
  return fF.reduce(function(r, o) {
    return r.concat(t.filter(function(a) {
      return a.phase === o;
    }));
  }, []);
}
function nL(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function oL(e) {
  var t = e.reduce(function(r, o) {
    var a = r[o.name];
    return r[o.name] = a ? Object.assign({}, a, o, {
      options: Object.assign({}, a.options, o.options),
      data: Object.assign({}, a.data, o.data)
    }) : o, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var oC = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function aC() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function aL(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, o = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? oC : a;
  return function(c, d, p) {
    p === void 0 && (p = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, oC, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: d
      },
      attributes: {},
      styles: {}
    }, h = [], g = !1, y = {
      state: f,
      setOptions: function(T) {
        var R = typeof T == "function" ? T(f.options) : T;
        b(), f.options = Object.assign({}, i, f.options, R), f.scrollParents = {
          reference: Os(c) ? Ac(c) : c.contextElement ? Ac(c.contextElement) : [],
          popper: Ac(d)
        };
        var $ = rL(oL([].concat(o, f.options.modifiers)));
        return f.orderedModifiers = $.filter(function(E) {
          return E.enabled;
        }), C(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var T = f.elements, R = T.reference, $ = T.popper;
          if (aC(R, $)) {
            f.rects = {
              reference: eL(R, pu($), f.options.strategy === "fixed"),
              popper: Lb($)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(O) {
              return f.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var E = 0; E < f.orderedModifiers.length; E++) {
              if (f.reset === !0) {
                f.reset = !1, E = -1;
                continue;
              }
              var S = f.orderedModifiers[E], k = S.fn, A = S.options, _ = A === void 0 ? {} : A, L = S.name;
              typeof k == "function" && (f = k({
                state: f,
                options: _,
                name: L,
                instance: y
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: nL(function() {
        return new Promise(function(v) {
          y.forceUpdate(), v(f);
        });
      }),
      destroy: function() {
        b(), g = !0;
      }
    };
    if (!aC(c, d))
      return y;
    y.setOptions(p).then(function(v) {
      !g && p.onFirstUpdate && p.onFirstUpdate(v);
    });
    function C() {
      f.orderedModifiers.forEach(function(v) {
        var T = v.name, R = v.options, $ = R === void 0 ? {} : R, E = v.effect;
        if (typeof E == "function") {
          var S = E({
            state: f,
            name: T,
            instance: y,
            options: $
          }), k = function() {
          };
          h.push(S || k);
        }
      });
    }
    function b() {
      h.forEach(function(v) {
        return v();
      }), h = [];
    }
    return y;
  };
}
var iL = [PF, qF, $F, gF, HF, jF, ZF, wF, VF], sL = /* @__PURE__ */ aL({
  defaultModifiers: iL
});
function lL(e) {
  return typeof e == "function" ? e() : e;
}
const kl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    children: o,
    container: a,
    disablePortal: i = !1
  } = t, [l, c] = x.useState(null), d = Jt(/* @__PURE__ */ x.isValidElement(o) ? ii(o) : null, r);
  if (en(() => {
    i || c(lL(a) || document.body);
  }, [a, i]), en(() => {
    if (l && !i)
      return cp(r, l), () => {
        cp(r, null);
      };
  }, [r, l, i]), i) {
    if (/* @__PURE__ */ x.isValidElement(o)) {
      const p = {
        ref: d
      };
      return /* @__PURE__ */ x.cloneElement(o, p);
    }
    return o;
  }
  return l && /* @__PURE__ */ Zh.createPortal(o, l);
});
process.env.NODE_ENV !== "production" && (kl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: n.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([$a, n.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool
});
process.env.NODE_ENV !== "production" && (kl.propTypes = ks(kl.propTypes));
function Zw(e) {
  return Ae("MuiPopper", e);
}
Ne("MuiPopper", ["root"]);
function cL(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function yp(e) {
  return typeof e == "function" ? e() : e;
}
function lf(e) {
  return e.nodeType !== void 0;
}
function uL(e) {
  return !lf(e);
}
const dL = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, Zw, t);
}, pL = {}, fL = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    anchorEl: o,
    children: a,
    direction: i,
    disablePortal: l,
    modifiers: c,
    open: d,
    placement: p,
    popperOptions: f,
    popperRef: h,
    slotProps: g = {},
    slots: y = {},
    TransitionProps: C,
    // @ts-ignore internal logic
    ownerState: b,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...v
  } = t, T = x.useRef(null), R = Jt(T, r), $ = x.useRef(null), E = Jt($, h), S = x.useRef(E);
  en(() => {
    S.current = E;
  }, [E]), x.useImperativeHandle(h, () => $.current, []);
  const k = cL(p, i), [A, _] = x.useState(k), [L, O] = x.useState(yp(o));
  x.useEffect(() => {
    $.current && $.current.forceUpdate();
  }), x.useEffect(() => {
    o && O(yp(o));
  }, [o]), en(() => {
    if (!L || !d)
      return;
    const W = (U) => {
      _(U.placement);
    };
    if (process.env.NODE_ENV !== "production" && L && lf(L) && L.nodeType === 1) {
      const U = L.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && U.top === 0 && U.left === 0 && U.right === 0 && U.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let V = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: U
      }) => {
        W(U);
      }
    }];
    c != null && (V = V.concat(c)), f && f.modifiers != null && (V = V.concat(f.modifiers));
    const X = sL(L, T.current, {
      placement: k,
      ...f,
      modifiers: V
    });
    return S.current(X), () => {
      X.destroy(), S.current(null);
    };
  }, [L, l, c, d, f, k]);
  const F = {
    placement: A
  };
  C !== null && (F.TransitionProps = C);
  const B = dL(t), M = y.root ?? "div", j = Mn({
    elementType: M,
    externalSlotProps: g.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: R
    },
    ownerState: t,
    className: B.root
  });
  return /* @__PURE__ */ P.jsx(M, {
    ...j,
    children: typeof a == "function" ? a(F) : a
  });
}), Xw = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    anchorEl: o,
    children: a,
    container: i,
    direction: l = "ltr",
    disablePortal: c = !1,
    keepMounted: d = !1,
    modifiers: p,
    open: f,
    placement: h = "bottom",
    popperOptions: g = pL,
    popperRef: y,
    style: C,
    transition: b = !1,
    slotProps: v = {},
    slots: T = {},
    ...R
  } = t, [$, E] = x.useState(!0), S = () => {
    E(!1);
  }, k = () => {
    E(!0);
  };
  if (!d && !f && (!b || $))
    return null;
  let A;
  if (i)
    A = i;
  else if (o) {
    const O = yp(o);
    A = O && lf(O) ? Rr(O).body : Rr(null).body;
  }
  const _ = !f && d && (!b || $) ? "none" : void 0, L = b ? {
    in: f,
    onEnter: S,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ P.jsx(kl, {
    disablePortal: c,
    container: A,
    children: /* @__PURE__ */ P.jsx(fL, {
      anchorEl: o,
      direction: l,
      disablePortal: c,
      modifiers: p,
      ref: r,
      open: b ? !$ : f,
      placement: h,
      popperOptions: g,
      popperRef: y,
      slotProps: v,
      slots: T,
      ...R,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: _,
        ...C
      },
      TransitionProps: L,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (Xw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: tn(n.oneOfType([$a, n.object, n.func]), (e) => {
    if (e.open) {
      const t = yp(e.anchorEl);
      if (t && lf(t) && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || uL(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: n.oneOfType([n.node, n.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([$a, n.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: n.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: n.arrayOf(n.shape({
    data: n.object,
    effect: n.func,
    enabled: n.bool,
    fn: n.func,
    name: n.any,
    options: n.object,
    phase: n.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: n.arrayOf(n.string),
    requiresIfExists: n.arrayOf(n.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: n.shape({
    modifiers: n.array,
    onFirstUpdate: n.func,
    placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: n.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: On,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: n.bool
});
const mL = Y(Xw, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Is = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = la(), a = Fe({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: l,
    components: c,
    componentsProps: d,
    container: p,
    disablePortal: f,
    keepMounted: h,
    modifiers: g,
    open: y,
    placement: C,
    popperOptions: b,
    popperRef: v,
    transition: T,
    slots: R,
    slotProps: $,
    ...E
  } = a, S = R?.root ?? c?.Root, k = {
    anchorEl: i,
    container: p,
    disablePortal: f,
    keepMounted: h,
    modifiers: g,
    open: y,
    placement: C,
    popperOptions: b,
    popperRef: v,
    transition: T,
    ...E
  };
  return /* @__PURE__ */ P.jsx(mL, {
    as: l,
    direction: o ? "rtl" : "ltr",
    slots: {
      root: S
    },
    slotProps: $ ?? d,
    ...k,
    ref: r
  });
});
process.env.NODE_ENV !== "production" && (Is.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: n.oneOfType([$a, n.object, n.func]),
  /**
   * Popper render function or node.
   */
  children: n.oneOfType([n.node, n.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([$a, n.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: n.arrayOf(n.shape({
    data: n.object,
    effect: n.func,
    enabled: n.bool,
    fn: n.func,
    name: n.any,
    options: n.object,
    phase: n.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: n.arrayOf(n.string),
    requiresIfExists: n.arrayOf(n.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: n.shape({
    modifiers: n.array,
    onFirstUpdate: n.func,
    placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: n.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: On,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: n.bool
});
function Jw(e) {
  return Ae("MuiListSubheader", e);
}
const hL = Ne("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]), gL = (e) => {
  const {
    classes: t,
    color: r,
    disableGutters: o,
    inset: a,
    disableSticky: i
  } = e, l = {
    root: ["root", r !== "default" && `color${re(r)}`, !o && "gutters", a && "inset", !i && "sticky"]
  };
  return Me(l, Jw, t);
}, bL = Y("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "default" && t[`color${re(r.color)}`], !r.disableGutters && t.gutters, r.inset && t.inset, !r.disableSticky && t.sticky];
  }
})($e(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Uc = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: a,
    color: i = "default",
    component: l = "li",
    disableGutters: c = !1,
    disableSticky: d = !1,
    inset: p = !1,
    ...f
  } = o, h = {
    ...o,
    color: i,
    component: l,
    disableGutters: c,
    disableSticky: d,
    inset: p
  }, g = gL(h);
  return /* @__PURE__ */ P.jsx(bL, {
    as: l,
    className: ge(g.root, a),
    ref: r,
    ownerState: h,
    ...f
  });
});
Uc && (Uc.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Uc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: n.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: n.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const yL = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function Qw(e) {
  return Ae("MuiChip", e);
}
const Bt = Ne("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), vL = (e) => {
  const {
    classes: t,
    disabled: r,
    size: o,
    color: a,
    iconColor: i,
    onDelete: l,
    clickable: c,
    variant: d
  } = e, p = {
    root: ["root", d, r && "disabled", `size${re(o)}`, `color${re(a)}`, c && "clickable", c && `clickableColor${re(a)}`, l && "deletable", l && `deletableColor${re(a)}`, `${d}${re(a)}`],
    label: ["label", `label${re(o)}`],
    avatar: ["avatar", `avatar${re(o)}`, `avatarColor${re(a)}`],
    icon: ["icon", `icon${re(o)}`, `iconColor${re(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${re(o)}`, `deleteIconColor${re(a)}`, `deleteIcon${re(d)}Color${re(a)}`]
  };
  return Me(p, Qw, t);
}, xL = Y("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      color: o,
      iconColor: a,
      clickable: i,
      onDelete: l,
      size: c,
      variant: d
    } = r;
    return [{
      [`& .${Bt.avatar}`]: t.avatar
    }, {
      [`& .${Bt.avatar}`]: t[`avatar${re(c)}`]
    }, {
      [`& .${Bt.avatar}`]: t[`avatarColor${re(o)}`]
    }, {
      [`& .${Bt.icon}`]: t.icon
    }, {
      [`& .${Bt.icon}`]: t[`icon${re(c)}`]
    }, {
      [`& .${Bt.icon}`]: t[`iconColor${re(a)}`]
    }, {
      [`& .${Bt.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Bt.deleteIcon}`]: t[`deleteIcon${re(c)}`]
    }, {
      [`& .${Bt.deleteIcon}`]: t[`deleteIconColor${re(o)}`]
    }, {
      [`& .${Bt.deleteIcon}`]: t[`deleteIcon${re(d)}Color${re(o)}`]
    }, t.root, t[`size${re(c)}`], t[`color${re(o)}`], i && t.clickable, i && o !== "default" && t[`clickableColor${re(o)})`], l && t.deletable, l && o !== "default" && t[`deletableColor${re(o)}`], t[d], t[`${d}${re(o)}`]];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Bt.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Bt.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Bt.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Bt.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Bt.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Bt.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${Bt.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : dt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : dt(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${Bt.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${Bt.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Vt(["contrastText"])).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        backgroundColor: (e.vars || e).palette[r].main,
        color: (e.vars || e).palette[r].contrastText,
        [`& .${Bt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].contrastTextChannel} / 0.7)` : dt(e.palette[r].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].contrastText
          }
        }
      }
    })), {
      props: (r) => r.iconColor === r.color,
      style: {
        [`& .${Bt.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (r) => r.iconColor === r.color && r.color !== "default",
      style: {
        [`& .${Bt.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${Bt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Vt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        onDelete: !0
      },
      style: {
        [`&.${Bt.focusVisible}`]: {
          background: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${Bt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Vt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        clickable: !0
      },
      style: {
        [`&:hover, &.${Bt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${Bt.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${Bt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${Bt.avatar}`]: {
          marginLeft: 4
        },
        [`& .${Bt.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${Bt.icon}`]: {
          marginLeft: 4
        },
        [`& .${Bt.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${Bt.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${Bt.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Vt()).map(([r]) => ({
      props: {
        variant: "outlined",
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : dt(e.palette[r].main, 0.7)}`,
        [`&.${Bt.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[r].main, e.palette.action.hoverOpacity)
        },
        [`&.${Bt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.focusOpacity})` : dt(e.palette[r].main, e.palette.action.focusOpacity)
        },
        [`& .${Bt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : dt(e.palette[r].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].main
          }
        }
      }
    }))]
  };
})), CL = Y("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      size: o
    } = r;
    return [t.label, t[`label${re(o)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function iC(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const cf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiChip"
  }), {
    avatar: a,
    className: i,
    clickable: l,
    color: c = "default",
    component: d,
    deleteIcon: p,
    disabled: f = !1,
    icon: h,
    label: g,
    onClick: y,
    onDelete: C,
    onKeyDown: b,
    onKeyUp: v,
    size: T = "medium",
    variant: R = "filled",
    tabIndex: $,
    skipFocusWhenDisabled: E = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...S
  } = o, k = x.useRef(null), A = Jt(k, r), _ = (H) => {
    H.stopPropagation(), C && C(H);
  }, L = (H) => {
    H.currentTarget === H.target && iC(H) && H.preventDefault(), b && b(H);
  }, O = (H) => {
    H.currentTarget === H.target && C && iC(H) && C(H), v && v(H);
  }, F = l !== !1 && y ? !0 : l, B = F || C ? qr : d || "div", M = {
    ...o,
    component: B,
    disabled: f,
    size: T,
    color: c,
    iconColor: /* @__PURE__ */ x.isValidElement(h) && h.props.color || c,
    onDelete: !!C,
    clickable: F,
    variant: R
  }, j = vL(M), W = B === qr ? {
    component: d || "div",
    focusVisibleClassName: j.focusVisible,
    ...C && {
      disableRipple: !0
    }
  } : {};
  let V = null;
  C && (V = p && /* @__PURE__ */ x.isValidElement(p) ? /* @__PURE__ */ x.cloneElement(p, {
    className: ge(p.props.className, j.deleteIcon),
    onClick: _
  }) : /* @__PURE__ */ P.jsx(yL, {
    className: ge(j.deleteIcon),
    onClick: _
  }));
  let X = null;
  a && /* @__PURE__ */ x.isValidElement(a) && (X = /* @__PURE__ */ x.cloneElement(a, {
    className: ge(j.avatar, a.props.className)
  }));
  let U = null;
  return h && /* @__PURE__ */ x.isValidElement(h) && (U = /* @__PURE__ */ x.cloneElement(h, {
    className: ge(j.icon, h.props.className)
  })), process.env.NODE_ENV !== "production" && X && U && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ P.jsxs(xL, {
    as: B,
    className: ge(j.root, i),
    disabled: F && f ? !0 : void 0,
    onClick: y,
    onKeyDown: L,
    onKeyUp: O,
    ref: A,
    tabIndex: E && f ? -1 : $,
    ownerState: M,
    ...W,
    ...S,
    children: [X || U, /* @__PURE__ */ P.jsx(CL, {
      className: ge(j.label),
      ownerState: M,
      children: g
    }), V]
  });
});
process.env.NODE_ENV !== "production" && (cf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: n.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: ef,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: n.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: n.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Icon element.
   */
  icon: n.element,
  /**
   * The content of the component.
   */
  label: n.node,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @ignore
   */
  tabIndex: n.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined"]), n.string])
});
function Cd(e) {
  return parseInt(e, 10) || 0;
}
const SL = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function wL(e) {
  for (const t in e)
    return !1;
  return !0;
}
function sC(e) {
  return wL(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const Vb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    onChange: o,
    maxRows: a,
    minRows: i = 1,
    style: l,
    value: c,
    ...d
  } = t, {
    current: p
  } = x.useRef(c != null), f = x.useRef(null), h = Jt(r, f), g = x.useRef(null), y = x.useRef(null), C = x.useCallback(() => {
    const $ = f.current, E = y.current;
    if (!$ || !E)
      return;
    const k = fn($).getComputedStyle($);
    if (k.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    E.style.width = k.width, E.value = $.value || t.placeholder || "x", E.value.slice(-1) === `
` && (E.value += " ");
    const A = k.boxSizing, _ = Cd(k.paddingBottom) + Cd(k.paddingTop), L = Cd(k.borderBottomWidth) + Cd(k.borderTopWidth), O = E.scrollHeight;
    E.value = "x";
    const F = E.scrollHeight;
    let B = O;
    i && (B = Math.max(Number(i) * F, B)), a && (B = Math.min(Number(a) * F, B)), B = Math.max(B, F);
    const M = B + (A === "border-box" ? _ + L : 0), j = Math.abs(B - O) <= 1;
    return {
      outerHeightStyle: M,
      overflowing: j
    };
  }, [a, i, t.placeholder]), b = Pr(() => {
    const $ = f.current, E = C();
    if (!$ || !E || sC(E))
      return !1;
    const S = E.outerHeightStyle;
    return g.current != null && g.current !== S;
  }), v = x.useCallback(() => {
    const $ = f.current, E = C();
    if (!$ || !E || sC(E))
      return;
    const S = E.outerHeightStyle;
    g.current !== S && (g.current = S, $.style.height = `${S}px`), $.style.overflow = E.overflowing ? "hidden" : "";
  }, [C]), T = x.useRef(-1);
  en(() => {
    const $ = As(v), E = f?.current;
    if (!E)
      return;
    const S = fn(E);
    S.addEventListener("resize", $);
    let k;
    return typeof ResizeObserver < "u" && (k = new ResizeObserver(() => {
      b() && (k.unobserve(E), cancelAnimationFrame(T.current), v(), T.current = requestAnimationFrame(() => {
        k.observe(E);
      }));
    }), k.observe(E)), () => {
      $.clear(), cancelAnimationFrame(T.current), S.removeEventListener("resize", $), k && k.disconnect();
    };
  }, [C, v, b]), en(() => {
    v();
  });
  const R = ($) => {
    p || v(), o && o($);
  };
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx("textarea", {
      value: c,
      onChange: R,
      ref: h,
      rows: i,
      style: l,
      ...d
    }), /* @__PURE__ */ P.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: y,
      tabIndex: -1,
      style: {
        ...SL.shadow,
        ...l,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (Vb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  placeholder: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * @ignore
   */
  value: n.oneOfType([n.arrayOf(n.string), n.number, n.string])
});
function ri(e) {
  return typeof e == "string";
}
function si({
  props: e,
  states: t,
  muiFormControl: r
}) {
  return t.reduce((o, a) => (o[a] = e[a], r && typeof e[a] > "u" && (o[a] = r[a]), o), {});
}
const fu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (fu.displayName = "FormControlContext");
function ko() {
  return x.useContext(fu);
}
function lC(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function vp(e, t = !1) {
  return e && (lC(e.value) && e.value !== "" || t && lC(e.defaultValue) && e.defaultValue !== "");
}
function TL(e) {
  return e.startAdornment;
}
function eT(e) {
  return Ae("MuiInputBase", e);
}
const qn = Ne("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var cC;
const uf = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.formControl && t.formControl, r.startAdornment && t.adornedStart, r.endAdornment && t.adornedEnd, r.error && t.error, r.size === "small" && t.sizeSmall, r.multiline && t.multiline, r.color && t[`color${re(r.color)}`], r.fullWidth && t.fullWidth, r.hiddenLabel && t.hiddenLabel];
}, df = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.input, r.size === "small" && t.inputSizeSmall, r.multiline && t.inputMultiline, r.type === "search" && t.inputTypeSearch, r.startAdornment && t.inputAdornedStart, r.endAdornment && t.inputAdornedEnd, r.hiddenLabel && t.inputHiddenLabel];
}, EL = (e) => {
  const {
    classes: t,
    color: r,
    disabled: o,
    error: a,
    endAdornment: i,
    focused: l,
    formControl: c,
    fullWidth: d,
    hiddenLabel: p,
    multiline: f,
    readOnly: h,
    size: g,
    startAdornment: y,
    type: C
  } = e, b = {
    root: ["root", `color${re(r)}`, o && "disabled", a && "error", d && "fullWidth", l && "focused", c && "formControl", g && g !== "medium" && `size${re(g)}`, f && "multiline", y && "adornedStart", i && "adornedEnd", p && "hiddenLabel", h && "readOnly"],
    input: ["input", o && "disabled", C === "search" && "inputTypeSearch", f && "inputMultiline", g === "small" && "inputSizeSmall", p && "inputHiddenLabel", y && "inputAdornedStart", i && "inputAdornedEnd", h && "readOnly"]
  };
  return Me(b, eT, t);
}, pf = Y("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: uf
})($e(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${qn.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: r
    }) => t.multiline && r === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), ff = Y("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: df
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light", r = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, o = {
    opacity: "0 !important"
  }, a = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${qn.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": a,
      "&:focus::-moz-placeholder": a,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": a
      // Edge
    },
    [`&.${qn.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), uC = Rb({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), zl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": a,
    autoComplete: i,
    autoFocus: l,
    className: c,
    color: d,
    components: p = {},
    componentsProps: f = {},
    defaultValue: h,
    disabled: g,
    disableInjectingGlobalStyles: y,
    endAdornment: C,
    error: b,
    fullWidth: v = !1,
    id: T,
    inputComponent: R = "input",
    inputProps: $ = {},
    inputRef: E,
    margin: S,
    maxRows: k,
    minRows: A,
    multiline: _ = !1,
    name: L,
    onBlur: O,
    onChange: F,
    onClick: B,
    onFocus: M,
    onKeyDown: j,
    onKeyUp: W,
    placeholder: V,
    readOnly: X,
    renderSuffix: U,
    rows: H,
    size: Z,
    slotProps: G = {},
    slots: ye = {},
    startAdornment: de,
    type: ne = "text",
    value: fe,
    ...ie
  } = o, oe = $.value != null ? $.value : fe, {
    current: ce
  } = x.useRef(oe != null), Ce = x.useRef(), xe = x.useCallback((tt) => {
    process.env.NODE_ENV !== "production" && tt && tt.nodeName !== "INPUT" && !tt.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Re = Jt(Ce, E, $.ref, xe), [J, Ie] = x.useState(!1), le = ko();
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (le)
      return le.registerEffect();
  }, [le]);
  const qe = si({
    props: o,
    muiFormControl: le,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  qe.focused = le ? le.focused : J, x.useEffect(() => {
    !le && g && J && (Ie(!1), O && O());
  }, [le, g, J, O]);
  const q = le && le.onFilled, K = le && le.onEmpty, ee = x.useCallback((tt) => {
    vp(tt) ? q && q() : K && K();
  }, [q, K]);
  en(() => {
    ce && ee({
      value: oe
    });
  }, [oe, ee, ce]);
  const he = (tt) => {
    M && M(tt), $.onFocus && $.onFocus(tt), le && le.onFocus ? le.onFocus(tt) : Ie(!0);
  }, we = (tt) => {
    O && O(tt), $.onBlur && $.onBlur(tt), le && le.onBlur ? le.onBlur(tt) : Ie(!1);
  }, se = (tt, ...Rt) => {
    if (!ce) {
      const xt = tt.target || Ce.current;
      if (xt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : jn(1));
      ee({
        value: xt.value
      });
    }
    $.onChange && $.onChange(tt, ...Rt), F && F(tt, ...Rt);
  };
  x.useEffect(() => {
    ee(Ce.current);
  }, []);
  const ue = (tt) => {
    Ce.current && tt.currentTarget === tt.target && Ce.current.focus(), B && B(tt);
  };
  let Qe = R, We = $;
  _ && Qe === "input" && (H ? (process.env.NODE_ENV !== "production" && (A || k) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), We = {
    type: void 0,
    minRows: H,
    maxRows: H,
    ...We
  }) : We = {
    type: void 0,
    maxRows: k,
    minRows: A,
    ...We
  }, Qe = Vb);
  const be = (tt) => {
    ee(tt.animationName === "mui-auto-fill-cancel" ? Ce.current : {
      value: "x"
    });
  };
  x.useEffect(() => {
    le && le.setAdornedStart(!!de);
  }, [le, de]);
  const Se = {
    ...o,
    color: qe.color || "primary",
    disabled: qe.disabled,
    endAdornment: C,
    error: qe.error,
    focused: qe.focused,
    formControl: le,
    fullWidth: v,
    hiddenLabel: qe.hiddenLabel,
    multiline: _,
    size: qe.size,
    startAdornment: de,
    type: ne
  }, De = EL(Se), Ye = ye.root || p.Root || pf, et = G.root || f.root || {}, Je = ye.input || p.Input || ff;
  return We = {
    ...We,
    ...G.input ?? f.input
  }, /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [!y && typeof uC == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (cC || (cC = /* @__PURE__ */ P.jsx(uC, {}))), /* @__PURE__ */ P.jsxs(Ye, {
      ...et,
      ref: r,
      onClick: ue,
      ...ie,
      ...!ri(Ye) && {
        ownerState: {
          ...Se,
          ...et.ownerState
        }
      },
      className: ge(De.root, et.className, c, X && "MuiInputBase-readOnly"),
      children: [de, /* @__PURE__ */ P.jsx(fu.Provider, {
        value: null,
        children: /* @__PURE__ */ P.jsx(Je, {
          "aria-invalid": qe.error,
          "aria-describedby": a,
          autoComplete: i,
          autoFocus: l,
          defaultValue: h,
          disabled: qe.disabled,
          id: T,
          onAnimationStart: be,
          name: L,
          placeholder: V,
          readOnly: X,
          required: qe.required,
          rows: H,
          value: oe,
          onKeyDown: j,
          onKeyUp: W,
          type: ne,
          ...We,
          ...!ri(Je) && {
            as: Qe,
            ownerState: {
              ...Se,
              ...We.ownerState
            }
          },
          ref: Re,
          className: ge(De.input, We.className, X && "MuiInputBase-readOnly"),
          onBlur: we,
          onChange: se,
          onFocus: he
        })
      }), C, U ? U({
        ...qe,
        startAdornment: de
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (zl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": n.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Ni,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: n.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * @ignore
   */
  renderSuffix: n.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The size of the component.
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
function tT(e) {
  return Ae("MuiInput", e);
}
const Xa = {
  ...qn,
  ...Ne("MuiInput", ["root", "underline", "input"])
};
function rT(e) {
  return Ae("MuiOutlinedInput", e);
}
const jt = {
  ...qn,
  ...Ne("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function nT(e) {
  return Ae("MuiFilledInput", e);
}
const Kn = {
  ...qn,
  ...Ne("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, Wb = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function oT(e) {
  return Ae("MuiAutocomplete", e);
}
const Ke = Ne("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var dC, pC;
const OL = (e) => {
  const {
    classes: t,
    disablePortal: r,
    expanded: o,
    focused: a,
    fullWidth: i,
    hasClearIcon: l,
    hasPopupIcon: c,
    inputFocused: d,
    popupOpen: p,
    size: f
  } = e, h = {
    root: ["root", o && "expanded", a && "focused", i && "fullWidth", l && "hasClearIcon", c && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", d && "inputFocused"],
    tag: ["tag", `tagSize${re(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", p && "popupIndicatorOpen"],
    popper: ["popper", r && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Me(h, oT, t);
}, $L = Y("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      fullWidth: o,
      hasClearIcon: a,
      hasPopupIcon: i,
      inputFocused: l,
      size: c
    } = r;
    return [{
      [`& .${Ke.tag}`]: t.tag
    }, {
      [`& .${Ke.tag}`]: t[`tagSize${re(c)}`]
    }, {
      [`& .${Ke.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Ke.input}`]: t.input
    }, {
      [`& .${Ke.input}`]: l && t.inputFocused
    }, t.root, o && t.fullWidth, i && t.hasPopupIcon, a && t.hasClearIcon];
  }
})({
  [`&.${Ke.focused} .${Ke.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Ke.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Ke.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Ke.inputRoot}`]: {
    [`.${Ke.hasPopupIcon}&, .${Ke.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Ke.hasPopupIcon}.${Ke.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Ke.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Xa.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Xa.root}.${qn.sizeSmall}`]: {
    [`& .${Xa.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${jt.root}`]: {
    padding: 9,
    [`.${Ke.hasPopupIcon}&, .${Ke.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ke.hasPopupIcon}.${Ke.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Ke.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Ke.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${jt.root}.${qn.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Ke.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Kn.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Ke.hasPopupIcon}&, .${Ke.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ke.hasPopupIcon}.${Ke.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Kn.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Ke.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Kn.root}.${qn.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Kn.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${qn.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Kn.root}.${qn.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Ke.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Kn.root}.${qn.hiddenLabel}.${qn.sizeSmall}`]: {
    [`& .${Ke.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Ke.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Ke.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Ke.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Ke.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), RL = Y("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), PL = Y(Qa, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), kL = Y(Qa, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.popupIndicator, r.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), AL = Y(Is, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${Ke.option}`]: t.option
    }, t.popper, r.disablePortal && t.popperDisablePortal];
  }
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), IL = Y(no, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})($e(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), NL = Y("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), ML = Y("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), _L = Y("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})($e(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Ke.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Ke.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Ke.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Ke.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Ke.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), FL = Y(Uc, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})($e(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), LL = Y("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Ke.option}`]: {
    paddingLeft: 24
  }
}), Ub = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: a = !1,
    autoHighlight: i = !1,
    autoSelect: l = !1,
    blurOnSelect: c = !1,
    ChipProps: d,
    className: p,
    clearIcon: f = dC || (dC = /* @__PURE__ */ P.jsx(Nw, {
      fontSize: "small"
    })),
    clearOnBlur: h = !o.freeSolo,
    clearOnEscape: g = !1,
    clearText: y = "Clear",
    closeText: C = "Close",
    componentsProps: b,
    defaultValue: v = o.multiple ? [] : null,
    disableClearable: T = !1,
    disableCloseOnSelect: R = !1,
    disabled: $ = !1,
    disabledItemsFocusable: E = !1,
    disableListWrap: S = !1,
    disablePortal: k = !1,
    filterOptions: A,
    filterSelectedOptions: _ = !1,
    forcePopupIcon: L = "auto",
    freeSolo: O = !1,
    fullWidth: F = !1,
    getLimitTagsText: B = (Qt) => `+${Qt}`,
    getOptionDisabled: M,
    getOptionKey: j,
    getOptionLabel: W,
    isOptionEqualToValue: V,
    groupBy: X,
    handleHomeEndKeys: U = !o.freeSolo,
    id: H,
    includeInputInList: Z = !1,
    inputValue: G,
    limitTags: ye = -1,
    ListboxComponent: de,
    ListboxProps: ne,
    loading: fe = !1,
    loadingText: ie = "Loading…",
    multiple: oe = !1,
    noOptionsText: ce = "No options",
    onChange: Ce,
    onClose: xe,
    onHighlightChange: Re,
    onInputChange: J,
    onOpen: Ie,
    open: le,
    openOnFocus: qe = !1,
    openText: q = "Open",
    options: K,
    PaperComponent: ee,
    PopperComponent: he,
    popupIcon: we = pC || (pC = /* @__PURE__ */ P.jsx(Wb, {})),
    readOnly: se = !1,
    renderGroup: ue,
    renderInput: Qe,
    renderOption: We,
    renderTags: be,
    selectOnFocus: Se = !o.freeSolo,
    size: De = "medium",
    slots: Ye = {},
    slotProps: et = {},
    value: Je,
    ...tt
  } = o, {
    getRootProps: Rt,
    getInputProps: xt,
    getInputLabelProps: rt,
    getPopupIndicatorProps: He,
    getClearProps: Oe,
    getTagProps: Ze,
    getListboxProps: Pt,
    getOptionProps: Mt,
    value: Ct,
    dirty: bt,
    expanded: nt,
    id: ft,
    popupOpen: er,
    focused: Ut,
    focusedTag: Ft,
    anchorEl: ct,
    setAnchorEl: fr,
    inputValue: at,
    groupedOptions: lt
  } = jw({
    ...o,
    componentName: "Autocomplete"
  }), St = !T && !$ && bt && !se, kt = (!O || L === !0) && L !== !1, {
    onMouseDown: Wt
  } = xt(), {
    ref: Lr,
    ...hn
  } = Pt(), te = W || ((Qt) => Qt.label ?? Qt), _e = {
    ...o,
    disablePortal: k,
    expanded: nt,
    focused: Ut,
    fullWidth: F,
    getOptionLabel: te,
    hasClearIcon: St,
    hasPopupIcon: kt,
    inputFocused: Ft === -1,
    popupOpen: er,
    size: De
  }, Xe = OL(_e), yt = {
    slots: {
      paper: ee,
      popper: he,
      ...Ye
    },
    slotProps: {
      chip: d,
      listbox: ne,
      ...b,
      ...et
    }
  }, [Ht, Te] = ze("listbox", {
    elementType: _L,
    externalForwardedProps: yt,
    ownerState: _e,
    className: Xe.listbox,
    additionalProps: hn,
    ref: Lr
  }), [ve, je] = ze("paper", {
    elementType: no,
    externalForwardedProps: yt,
    ownerState: _e,
    className: Xe.paper
  }), [ht, mt] = ze("popper", {
    elementType: Is,
    externalForwardedProps: yt,
    ownerState: _e,
    className: Xe.popper,
    additionalProps: {
      disablePortal: k,
      style: {
        width: ct ? ct.clientWidth : null
      },
      role: "presentation",
      anchorEl: ct,
      open: er
    }
  });
  let vt;
  if (oe && Ct.length > 0) {
    const Qt = (ao) => ({
      className: Xe.tag,
      disabled: $,
      ...Ze(ao)
    });
    be ? vt = be(Ct, Qt, _e) : vt = Ct.map((ao, Zo) => {
      const {
        key: ji,
        ...Ff
      } = Qt({
        index: Zo
      });
      return /* @__PURE__ */ P.jsx(cf, {
        label: te(ao),
        size: De,
        ...Ff,
        ...yt.slotProps.chip
      }, ji);
    });
  }
  if (ye > -1 && Array.isArray(vt)) {
    const Qt = vt.length - ye;
    !Ut && Qt > 0 && (vt = vt.splice(0, ye), vt.push(/* @__PURE__ */ P.jsx("span", {
      className: Xe.tag,
      children: B(Qt)
    }, vt.length)));
  }
  const br = ue || ((Qt) => /* @__PURE__ */ P.jsxs("li", {
    children: [/* @__PURE__ */ P.jsx(FL, {
      className: Xe.groupLabel,
      ownerState: _e,
      component: "div",
      children: Qt.group
    }), /* @__PURE__ */ P.jsx(LL, {
      className: Xe.groupUl,
      ownerState: _e,
      children: Qt.children
    })]
  }, Qt.key)), Wr = We || ((Qt, ao) => {
    const {
      key: Zo,
      ...ji
    } = Qt;
    return /* @__PURE__ */ P.jsx("li", {
      ...ji,
      children: te(ao)
    }, Zo);
  }), ui = (Qt, ao) => {
    const Zo = Mt({
      option: Qt,
      index: ao
    });
    return Wr({
      ...Zo,
      className: Xe.option
    }, Qt, {
      selected: Zo["aria-selected"],
      index: ao,
      inputValue: at
    }, _e);
  }, Ls = yt.slotProps.clearIndicator, Bs = yt.slotProps.popupIndicator;
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx($L, {
      ref: r,
      className: ge(Xe.root, p),
      ownerState: _e,
      ...Rt(tt),
      children: Qe({
        id: ft,
        disabled: $,
        fullWidth: !0,
        size: De === "small" ? "small" : void 0,
        InputLabelProps: rt(),
        InputProps: {
          ref: fr,
          className: Xe.inputRoot,
          startAdornment: vt,
          onMouseDown: (Qt) => {
            Qt.target === Qt.currentTarget && Wt(Qt);
          },
          ...(St || kt) && {
            endAdornment: /* @__PURE__ */ P.jsxs(RL, {
              className: Xe.endAdornment,
              ownerState: _e,
              children: [St ? /* @__PURE__ */ P.jsx(PL, {
                ...Oe(),
                "aria-label": y,
                title: y,
                ownerState: _e,
                ...Ls,
                className: ge(Xe.clearIndicator, Ls?.className),
                children: f
              }) : null, kt ? /* @__PURE__ */ P.jsx(kL, {
                ...He(),
                disabled: $,
                "aria-label": er ? C : q,
                title: er ? C : q,
                ownerState: _e,
                ...Bs,
                className: ge(Xe.popupIndicator, Bs?.className),
                children: we
              }) : null]
            })
          }
        },
        inputProps: {
          className: Xe.input,
          disabled: $,
          readOnly: se,
          ...xt()
        }
      })
    }), ct ? /* @__PURE__ */ P.jsx(AL, {
      as: ht,
      ...mt,
      children: /* @__PURE__ */ P.jsxs(IL, {
        as: ve,
        ...je,
        children: [fe && lt.length === 0 ? /* @__PURE__ */ P.jsx(NL, {
          className: Xe.loading,
          ownerState: _e,
          children: ie
        }) : null, lt.length === 0 && !O && !fe ? /* @__PURE__ */ P.jsx(ML, {
          className: Xe.noOptions,
          ownerState: _e,
          role: "presentation",
          onMouseDown: (Qt) => {
            Qt.preventDefault();
          },
          children: ce
        }) : null, lt.length > 0 ? /* @__PURE__ */ P.jsx(Ht, {
          as: de,
          ...Te,
          children: lt.map((Qt, ao) => X ? br({
            key: Qt.key,
            group: Qt.group,
            children: Qt.options.map((Zo, ji) => ui(Zo, Qt.index + ji))
          }) : ui(Qt, ao))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Ub.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: n.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: n.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: n.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: n.oneOfType([n.oneOf(["mouse", "touch"]), n.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: n.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: n.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: n.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: n.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: n.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: n.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: n.shape({
    clearIndicator: n.object,
    paper: n.object,
    popper: n.object,
    popupIndicator: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: tn(n.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: n.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: n.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: n.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: n.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: n.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: n.oneOfType([n.oneOf(["auto"]), n.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: n.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: n.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: n.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: n.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: n.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: n.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: n.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: n.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: n.bool,
  /**
   * The input value.
   */
  inputValue: n.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: n.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Vr,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: n.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: n.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: n.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: n.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: n.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: n.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: n.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: n.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: n.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: n.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: n.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: n.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: n.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: n.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: n.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: n.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: n.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: n.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: n.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: n.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    chip: n.oneOfType([n.func, n.object]),
    clearIndicator: n.oneOfType([n.func, n.object]),
    listbox: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    popper: n.oneOfType([n.func, n.object]),
    popupIndicator: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    listbox: n.elementType,
    paper: n.elementType,
    popper: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: tn(n.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const BL = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function aT(e) {
  return Ae("MuiAvatar", e);
}
const iT = Ne("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]), DL = (e) => {
  const {
    classes: t,
    variant: r,
    colorDefault: o
  } = e;
  return Me({
    root: ["root", r, o && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, aT, t);
}, jL = Y("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], r.colorDefault && t.colorDefault];
  }
})($e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), zL = Y("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), VL = Y(BL, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function WL({
  crossOrigin: e,
  referrerPolicy: t,
  src: r,
  srcSet: o
}) {
  const [a, i] = x.useState(!1);
  return x.useEffect(() => {
    if (!r && !o)
      return;
    i(!1);
    let l = !0;
    const c = new Image();
    return c.onload = () => {
      l && i("loaded");
    }, c.onerror = () => {
      l && i("error");
    }, c.crossOrigin = e, c.referrerPolicy = t, c.src = r, o && (c.srcset = o), () => {
      l = !1;
    };
  }, [e, t, r, o]), a;
}
const gl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: a,
    children: i,
    className: l,
    component: c = "div",
    slots: d = {},
    slotProps: p = {},
    imgProps: f,
    sizes: h,
    src: g,
    srcSet: y,
    variant: C = "circular",
    ...b
  } = o;
  let v = null;
  const T = {
    ...o,
    component: c,
    variant: C
  }, R = WL({
    ...f,
    ...typeof p.img == "function" ? p.img(T) : p.img,
    src: g,
    srcSet: y
  }), $ = g || y, E = $ && R !== "error";
  T.colorDefault = !E, delete T.ownerState;
  const S = DL(T), [k, A] = ze("img", {
    className: S.img,
    elementType: zL,
    externalForwardedProps: {
      slots: d,
      slotProps: {
        img: {
          ...f,
          ...p.img
        }
      }
    },
    additionalProps: {
      alt: a,
      src: g,
      srcSet: y,
      sizes: h
    },
    ownerState: T
  });
  return E ? v = /* @__PURE__ */ P.jsx(k, {
    ...A
  }) : i || i === 0 ? v = i : $ && a ? v = a[0] : v = /* @__PURE__ */ P.jsx(VL, {
    ownerState: T,
    className: S.fallback
  }), /* @__PURE__ */ P.jsx(jL, {
    as: c,
    className: ge(S.root, l),
    ref: r,
    ...b,
    ownerState: T,
    children: v
  });
});
process.env.NODE_ENV !== "production" && (gl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: n.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: n.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    img: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    img: n.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: n.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rounded", "square"]), n.string])
});
function sT(e) {
  return Ae("MuiAvatarGroup", e);
}
const lT = Ne("MuiAvatarGroup", ["root", "avatar"]), sh = {
  small: -16,
  medium: -8
}, UL = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    avatar: ["avatar"]
  }, sT, t);
}, HL = Y("div", {
  name: "MuiAvatarGroup",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${lT.avatar}`]: t.avatar
  }, t.root]
})($e(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row-reverse",
  [`& .${iT.root}`]: {
    border: `2px solid ${(e.vars || e).palette.background.default}`,
    boxSizing: "content-box",
    marginLeft: "var(--AvatarGroup-spacing, -8px)",
    "&:last-child": {
      marginLeft: 0
    }
  }
}))), cT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiAvatarGroup"
  }), {
    children: a,
    className: i,
    component: l = "div",
    componentsProps: c,
    max: d = 5,
    renderSurplus: p,
    slotProps: f = {},
    slots: h = {},
    spacing: g = "medium",
    total: y,
    variant: C = "circular",
    ...b
  } = o;
  let v = d < 2 ? 2 : d;
  const T = {
    ...o,
    max: d,
    spacing: g,
    component: l,
    variant: C
  }, R = UL(T), $ = x.Children.toArray(a).filter((B) => (process.env.NODE_ENV !== "production" && zn.isFragment(B) && console.error(["MUI: The AvatarGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ x.isValidElement(B))), E = y || $.length;
  E === v && (v += 1), v = Math.min(E + 1, v);
  const S = Math.min($.length, v - 1), k = Math.max(E - v, E - S, 0), A = p ? p(k) : `+${k}`;
  let _;
  T.spacing && sh[T.spacing] !== void 0 ? _ = sh[T.spacing] : T.spacing === 0 ? _ = 0 : _ = -T.spacing || sh.medium;
  const L = {
    slots: h,
    slotProps: {
      surplus: f.additionalAvatar ?? c?.additionalAvatar,
      ...c,
      ...f
    }
  }, [O, F] = ze("surplus", {
    elementType: gl,
    externalForwardedProps: L,
    className: R.avatar,
    ownerState: T,
    additionalProps: {
      variant: C
    }
  });
  return /* @__PURE__ */ P.jsxs(HL, {
    as: l,
    ownerState: T,
    className: ge(R.root, i),
    ref: r,
    ...b,
    style: {
      "--AvatarGroup-spacing": `${_}px`,
      // marginValue is always defined
      ...b.style
    },
    children: [k ? /* @__PURE__ */ P.jsx(O, {
      ...F,
      children: A
    }) : null, $.slice(0, S).reverse().map((B) => /* @__PURE__ */ x.cloneElement(B, {
      className: ge(B.props.className, R.avatar),
      variant: B.props.variant || C
    }))]
  });
});
process.env.NODE_ENV !== "production" && (cT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The avatars to stack.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: n.shape({
    additionalAvatar: n.object
  }),
  /**
   * Max avatars to show before +x.
   * @default 5
   */
  max: tn(n.number, (e) => e.max < 2 ? new Error(["MUI: The prop `max` should be equal to 2 or above.", "A value below is clamped to 2."].join(`
`)) : null),
  /**
   * custom renderer of extraAvatars
   * @param {number} surplus number of extra avatars
   * @returns {React.ReactNode} custom element to display
   */
  renderSurplus: n.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    additionalAvatar: n.object,
    surplus: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    surplus: n.elementType
  }),
  /**
   * Spacing between avatars.
   * @default 'medium'
   */
  spacing: n.oneOfType([n.oneOf(["medium", "small"]), n.number]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */
  total: n.number,
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rounded", "square"]), n.string])
});
const GL = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Al = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Yr(), a = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: l = !0,
    children: c,
    easing: d,
    in: p,
    onEnter: f,
    onEntered: h,
    onEntering: g,
    onExit: y,
    onExited: C,
    onExiting: b,
    style: v,
    timeout: T = a,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: R = Po,
    ...$
  } = t, E = x.useRef(null), S = Jt(E, ii(c), r), k = (j) => (W) => {
    if (j) {
      const V = E.current;
      W === void 0 ? j(V) : j(V, W);
    }
  }, A = k(g), _ = k((j, W) => {
    of(j);
    const V = aa({
      style: v,
      timeout: T,
      easing: d
    }, {
      mode: "enter"
    });
    j.style.webkitTransition = o.transitions.create("opacity", V), j.style.transition = o.transitions.create("opacity", V), f && f(j, W);
  }), L = k(h), O = k(b), F = k((j) => {
    const W = aa({
      style: v,
      timeout: T,
      easing: d
    }, {
      mode: "exit"
    });
    j.style.webkitTransition = o.transitions.create("opacity", W), j.style.transition = o.transitions.create("opacity", W), y && y(j);
  }), B = k(C), M = (j) => {
    i && i(E.current, j);
  };
  return /* @__PURE__ */ P.jsx(R, {
    appear: l,
    in: p,
    nodeRef: E,
    onEnter: _,
    onEntered: L,
    onEntering: A,
    onExit: F,
    onExited: B,
    onExiting: O,
    addEndListener: M,
    timeout: T,
    ...$,
    children: (j, {
      ownerState: W,
      ...V
    }) => /* @__PURE__ */ x.cloneElement(c, {
      style: {
        opacity: 0,
        visibility: j === "exited" && !p ? "hidden" : void 0,
        ...GL[j],
        ...v,
        ...c.props.style
      },
      ref: S,
      ...V
    })
  });
});
process.env.NODE_ENV !== "production" && (Al.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: ai.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
function uT(e) {
  return Ae("MuiBackdrop", e);
}
const dT = Ne("MuiBackdrop", ["root", "invisible"]), qL = (e) => {
  const {
    classes: t,
    invisible: r
  } = e;
  return Me({
    root: ["root", r && "invisible"]
  }, uT, t);
}, KL = Y("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), mu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: a,
    className: i,
    component: l = "div",
    invisible: c = !1,
    open: d,
    components: p = {},
    componentsProps: f = {},
    slotProps: h = {},
    slots: g = {},
    TransitionComponent: y,
    transitionDuration: C,
    ...b
  } = o, v = {
    ...o,
    component: l,
    invisible: c
  }, T = qL(v), R = {
    transition: y,
    root: p.Root,
    ...g
  }, $ = {
    ...f,
    ...h
  }, E = {
    slots: R,
    slotProps: $
  }, [S, k] = ze("root", {
    elementType: KL,
    externalForwardedProps: E,
    className: ge(T.root, i),
    ownerState: v
  }), [A, _] = ze("transition", {
    elementType: Al,
    externalForwardedProps: E,
    ownerState: v
  });
  return /* @__PURE__ */ P.jsx(A, {
    in: d,
    timeout: C,
    ...b,
    ..._,
    children: /* @__PURE__ */ P.jsx(S, {
      "aria-hidden": !0,
      ...k,
      classes: T,
      ref: r,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (mu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    root: n.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: n.bool,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
function YL(e) {
  const {
    badgeContent: t,
    invisible: r = !1,
    max: o = 99,
    showZero: a = !1
  } = e, i = bb({
    badgeContent: t,
    max: o
  });
  let l = r;
  r === !1 && t === 0 && !a && (l = !0);
  const {
    badgeContent: c,
    max: d = o
  } = l ? i : e, p = c && Number(c) > d ? `${d}+` : c;
  return {
    badgeContent: c,
    invisible: l,
    max: d,
    displayValue: p
  };
}
function pT(e) {
  return Ae("MuiBadge", e);
}
const Ka = Ne("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), lh = 10, ch = 4, ZL = (e) => {
  const {
    color: t,
    anchorOrigin: r,
    invisible: o,
    overlap: a,
    variant: i,
    classes: l = {}
  } = e, c = {
    root: ["root"],
    badge: ["badge", i, o && "invisible", `anchorOrigin${re(r.vertical)}${re(r.horizontal)}`, `anchorOrigin${re(r.vertical)}${re(r.horizontal)}${re(a)}`, `overlap${re(a)}`, t !== "default" && `color${re(t)}`]
  };
  return Me(c, pT, l);
}, XL = Y("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), JL = Y("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.badge, t[r.variant], t[`anchorOrigin${re(r.anchorOrigin.vertical)}${re(r.anchorOrigin.horizontal)}${re(r.overlap)}`], r.color !== "default" && t[`color${re(r.color)}`], r.invisible && t.invisible];
  }
})($e(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: lh * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: lh * 2,
  borderRadius: lh,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Vt(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: ch,
      height: ch * 2,
      minWidth: ch * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ka.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function fC(e) {
  return {
    vertical: e?.vertical ?? "top",
    horizontal: e?.horizontal ?? "right"
  };
}
const Hb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: a,
    className: i,
    classes: l,
    component: c,
    components: d = {},
    componentsProps: p = {},
    children: f,
    overlap: h = "rectangular",
    color: g = "default",
    invisible: y = !1,
    max: C = 99,
    badgeContent: b,
    slots: v,
    slotProps: T,
    showZero: R = !1,
    variant: $ = "standard",
    ...E
  } = o, {
    badgeContent: S,
    invisible: k,
    max: A,
    displayValue: _
  } = YL({
    max: C,
    invisible: y,
    badgeContent: b,
    showZero: R
  }), L = bb({
    anchorOrigin: fC(a),
    color: g,
    overlap: h,
    variant: $,
    badgeContent: b
  }), O = k || S == null && $ !== "dot", {
    color: F = g,
    overlap: B = h,
    anchorOrigin: M,
    variant: j = $
  } = O ? L : o, W = fC(M), V = j !== "dot" ? _ : void 0, X = {
    ...o,
    badgeContent: S,
    invisible: O,
    max: A,
    displayValue: V,
    showZero: R,
    anchorOrigin: W,
    color: F,
    overlap: B,
    variant: j
  }, U = ZL(X), H = {
    slots: {
      root: v?.root ?? d.Root,
      badge: v?.badge ?? d.Badge
    },
    slotProps: {
      root: T?.root ?? p.root,
      badge: T?.badge ?? p.badge
    }
  }, [Z, G] = ze("root", {
    elementType: XL,
    externalForwardedProps: {
      ...H,
      ...E
    },
    ownerState: X,
    className: ge(U.root, i),
    ref: r,
    additionalProps: {
      as: c
    }
  }), [ye, de] = ze("badge", {
    elementType: JL,
    externalForwardedProps: H,
    ownerState: X,
    className: U.badge
  });
  return /* @__PURE__ */ P.jsxs(Z, {
    ...G,
    children: [f, /* @__PURE__ */ P.jsx(ye, {
      ...de,
      children: V
    })]
  });
});
process.env.NODE_ENV !== "production" && (Hb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOf(["left", "right"]),
    vertical: n.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: n.node,
  /**
   * The badge will be added relative to this node.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Badge: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    badge: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: n.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: n.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: n.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    badge: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    badge: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["dot", "standard"]), n.string])
});
function fT(e) {
  return Ae("MuiBottomNavigation", e);
}
const QL = Ne("MuiBottomNavigation", ["root"]), eB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, fT, t);
}, tB = Y("div", {
  name: "MuiBottomNavigation",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  height: 56,
  backgroundColor: (e.vars || e).palette.background.paper
}))), mT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiBottomNavigation"
  }), {
    children: a,
    className: i,
    component: l = "div",
    onChange: c,
    showLabels: d = !1,
    value: p,
    ...f
  } = o, h = {
    ...o,
    component: l,
    showLabels: d
  }, g = eB(h);
  return /* @__PURE__ */ P.jsx(tB, {
    as: l,
    className: ge(g.root, i),
    ref: r,
    ownerState: h,
    ...f,
    children: x.Children.map(a, (y, C) => {
      if (!/* @__PURE__ */ x.isValidElement(y))
        return null;
      process.env.NODE_ENV !== "production" && zn.isFragment(y) && console.error(["MUI: The BottomNavigation component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
      const b = y.props.value === void 0 ? C : y.props.value;
      return /* @__PURE__ */ x.cloneElement(y, {
        selected: b === p,
        showLabel: y.props.showLabel !== void 0 ? y.props.showLabel : d,
        value: b,
        onChange: c
      });
    })
  });
});
process.env.NODE_ENV !== "production" && (mT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child.
   */
  onChange: n.func,
  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   * @default false
   */
  showLabels: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: n.any
});
function hT(e) {
  return Ae("MuiBottomNavigationAction", e);
}
const Gb = Ne("MuiBottomNavigationAction", ["root", "iconOnly", "selected", "label"]), rB = (e) => {
  const {
    classes: t,
    showLabel: r,
    selected: o
  } = e;
  return Me({
    root: ["root", !r && !o && "iconOnly", o && "selected"],
    label: ["label", !r && !o && "iconOnly", o && "selected"]
  }, hT, t);
}, nB = Y(qr, {
  name: "MuiBottomNavigationAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.showLabel && !r.selected && t.iconOnly];
  }
})($e(({
  theme: e
}) => ({
  transition: e.transitions.create(["color", "padding-top"], {
    duration: e.transitions.duration.short
  }),
  padding: "0px 12px",
  minWidth: 80,
  maxWidth: 168,
  color: (e.vars || e).palette.text.secondary,
  flexDirection: "column",
  flex: "1",
  [`&.${Gb.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  variants: [{
    props: ({
      showLabel: t,
      selected: r
    }) => !t && !r,
    style: {
      paddingTop: 14
    }
  }, {
    props: ({
      showLabel: t,
      selected: r,
      label: o
    }) => !t && !r && !o,
    style: {
      paddingTop: 0
    }
  }]
}))), oB = Y("span", {
  name: "MuiBottomNavigationAction",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})($e(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(12),
  opacity: 1,
  transition: "font-size 0.2s, opacity 0.2s",
  transitionDelay: "0.1s",
  [`&.${Gb.selected}`]: {
    fontSize: e.typography.pxToRem(14)
  },
  variants: [{
    props: ({
      showLabel: t,
      selected: r
    }) => !t && !r,
    style: {
      opacity: 0,
      transitionDelay: "0s"
    }
  }]
}))), gT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiBottomNavigationAction"
  }), {
    className: a,
    icon: i,
    label: l,
    onChange: c,
    onClick: d,
    // eslint-disable-next-line react/prop-types -- private, always overridden by BottomNavigation
    selected: p,
    showLabel: f,
    value: h,
    slots: g = {},
    slotProps: y = {},
    ...C
  } = o, b = o, v = rB(b), T = (A) => {
    c && c(A, h), d && d(A);
  }, R = {
    slots: g,
    slotProps: y
  }, [$, E] = ze("root", {
    elementType: nB,
    externalForwardedProps: {
      ...R,
      ...C
    },
    shouldForwardComponentProp: !0,
    ownerState: b,
    ref: r,
    className: ge(v.root, a),
    additionalProps: {
      focusRipple: !0
    },
    getSlotProps: (A) => ({
      ...A,
      onClick: (_) => {
        A.onClick?.(_), T(_);
      }
    })
  }), [S, k] = ze("label", {
    elementType: oB,
    externalForwardedProps: R,
    ownerState: b,
    className: v.label
  });
  return /* @__PURE__ */ P.jsxs($, {
    ...E,
    children: [i, /* @__PURE__ */ P.jsx(S, {
      ...k,
      children: l
    })]
  });
});
process.env.NODE_ENV !== "production" && (gT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: ef,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display.
   */
  icon: n.node,
  /**
   * The label element.
   */
  label: n.node,
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   *
   * The prop defaults to the value (`false`) inherited from the parent BottomNavigation component.
   */
  showLabel: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    label: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    label: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: n.any
});
const bT = Ne("MuiBox", ["root"]), aB = uu(), Tt = w7({
  themeId: wo,
  defaultTheme: aB,
  defaultClassName: bT.root,
  generateClassName: db.generate
});
process.env.NODE_ENV !== "production" && (Tt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const iB = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), sB = Y(qr, {
  name: "MuiBreadcrumbCollapsed"
})($e(({
  theme: e
}) => ({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`,
  ...e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[100],
    color: e.palette.grey[700]
  } : {
    backgroundColor: e.palette.grey[700],
    color: e.palette.grey[100]
  },
  borderRadius: 2,
  "&:hover, &:focus": {
    ...e.palette.mode === "light" ? {
      backgroundColor: e.palette.grey[200]
    } : {
      backgroundColor: e.palette.grey[600]
    }
  },
  "&:active": {
    boxShadow: e.shadows[0],
    ...e.palette.mode === "light" ? {
      backgroundColor: Tl(e.palette.grey[200], 0.12)
    } : {
      backgroundColor: Tl(e.palette.grey[600], 0.12)
    }
  }
}))), lB = Y(iB)({
  width: 24,
  height: 16
});
function yT(e) {
  const {
    slots: t = {},
    slotProps: r = {},
    ...o
  } = e, a = e;
  return /* @__PURE__ */ P.jsx("li", {
    children: /* @__PURE__ */ P.jsx(sB, {
      focusRipple: !0,
      ...o,
      ownerState: a,
      children: /* @__PURE__ */ P.jsx(lB, {
        as: t.CollapsedIcon,
        ownerState: a,
        ...r.collapsedIcon
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (yT.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: n.shape({
    collapsedIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    CollapsedIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.object
});
function vT(e) {
  return Ae("MuiBreadcrumbs", e);
}
const xT = Ne("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), cB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, vT, t);
}, uB = Y(pn, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${xT.li}`]: t.li
  }, t.root]
})({}), dB = Y("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), pB = Y("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function fB(e, t, r, o) {
  return e.reduce((a, i, l) => (l < e.length - 1 ? a = a.concat(i, /* @__PURE__ */ P.jsx(pB, {
    "aria-hidden": !0,
    className: t,
    ownerState: o,
    children: r
  }, `separator-${l}`)) : a.push(i), a), []);
}
const CT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: a,
    className: i,
    component: l = "nav",
    slots: c = {},
    slotProps: d = {},
    expandText: p = "Show path",
    itemsAfterCollapse: f = 1,
    itemsBeforeCollapse: h = 1,
    maxItems: g = 8,
    separator: y = "/",
    ...C
  } = o, [b, v] = x.useState(!1), T = {
    ...o,
    component: l,
    expanded: b,
    expandText: p,
    itemsAfterCollapse: f,
    itemsBeforeCollapse: h,
    maxItems: g,
    separator: y
  }, R = cB(T), $ = Mn({
    elementType: c.CollapsedIcon,
    externalSlotProps: d.collapsedIcon,
    ownerState: T
  }), E = x.useRef(null), S = (A) => {
    const _ = () => {
      v(!0);
      const L = E.current.querySelector("a[href],button,[tabindex]");
      L && L.focus();
    };
    return h + f >= A.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${f}} + itemsBeforeCollapse={${h}} >= maxItems={${g}}`].join(`
`)), A) : [...A.slice(0, h), /* @__PURE__ */ P.jsx(yT, {
      "aria-label": p,
      slots: {
        CollapsedIcon: c.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: $
      },
      onClick: _
    }, "ellipsis"), ...A.slice(A.length - f, A.length)];
  }, k = x.Children.toArray(a).filter((A) => (process.env.NODE_ENV !== "production" && zn.isFragment(A) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ x.isValidElement(A))).map((A, _) => /* @__PURE__ */ P.jsx("li", {
    className: R.li,
    children: A
  }, `child-${_}`));
  return /* @__PURE__ */ P.jsx(uB, {
    ref: r,
    component: l,
    color: "textSecondary",
    className: ge(R.root, i),
    ownerState: T,
    ...C,
    children: /* @__PURE__ */ P.jsx(dB, {
      className: R.ol,
      ref: E,
      ownerState: T,
      children: fB(b || g && k.length <= g ? k : S(k), R.separator, y, T)
    })
  });
});
process.env.NODE_ENV !== "production" && (CT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: n.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: Vr,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: Vr,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: Vr,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: n.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: n.shape({
    collapsedIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    CollapsedIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function ST(e) {
  return Ae("MuiButton", e);
}
const Ti = Ne("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), mf = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (mf.displayName = "ButtonGroupContext");
const hf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (hf.displayName = "ButtonGroupButtonContext");
const mB = (e) => {
  const {
    color: t,
    disableElevation: r,
    fullWidth: o,
    size: a,
    variant: i,
    loading: l,
    loadingPosition: c,
    classes: d
  } = e, p = {
    root: ["root", l && "loading", i, `${i}${re(t)}`, `size${re(a)}`, `${i}Size${re(a)}`, `color${re(t)}`, r && "disableElevation", o && "fullWidth", l && `loadingPosition${re(c)}`],
    startIcon: ["icon", "startIcon", `iconSize${re(a)}`],
    endIcon: ["icon", "endIcon", `iconSize${re(a)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, f = Me(p, ST, d);
  return {
    ...d,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...f
  };
}, wT = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], hB = Y(qr, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`${r.variant}${re(r.color)}`], t[`size${re(r.size)}`], t[`${r.variant}Size${re(r.size)}`], r.color === "inherit" && t.colorInherit, r.disableElevation && t.disableElevation, r.fullWidth && t.fullWidth, r.loading && t.loading];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], r = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${Ti.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${Ti.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${Ti.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${Ti.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Vt()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[o].main,
        "--variant-outlinedColor": (e.vars || e).palette[o].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / 0.5)` : dt(e.palette[o].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[o].contrastText,
        "--variant-containedBg": (e.vars || e).palette[o].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[o].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[o].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[o].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[o].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : r,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${Ti.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${Ti.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${Ti.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), gB = Y("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.startIcon, r.loading && t.startIconLoadingStart, t[`iconSize${re(r.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...wT]
})), bB = Y("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.endIcon, r.loading && t.endIconLoadingEnd, t[`iconSize${re(r.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...wT]
})), yB = Y("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), mC = Y("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), hu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = x.useContext(mf), a = x.useContext(hf), i = wl(o, t), l = Fe({
    props: i,
    name: "MuiButton"
  }), {
    children: c,
    color: d = "primary",
    component: p = "button",
    className: f,
    disabled: h = !1,
    disableElevation: g = !1,
    disableFocusRipple: y = !1,
    endIcon: C,
    focusVisibleClassName: b,
    fullWidth: v = !1,
    id: T,
    loading: R = null,
    loadingIndicator: $,
    loadingPosition: E = "center",
    size: S = "medium",
    startIcon: k,
    type: A,
    variant: _ = "text",
    ...L
  } = l, O = eo(T), F = $ ?? /* @__PURE__ */ P.jsx(af, {
    "aria-labelledby": O,
    color: "inherit",
    size: 16
  }), B = {
    ...l,
    color: d,
    component: p,
    disabled: h,
    disableElevation: g,
    disableFocusRipple: y,
    fullWidth: v,
    loading: R,
    loadingIndicator: F,
    loadingPosition: E,
    size: S,
    type: A,
    variant: _
  }, M = mB(B), j = (k || R && E === "start") && /* @__PURE__ */ P.jsx(gB, {
    className: M.startIcon,
    ownerState: B,
    children: k || /* @__PURE__ */ P.jsx(mC, {
      className: M.loadingIconPlaceholder,
      ownerState: B
    })
  }), W = (C || R && E === "end") && /* @__PURE__ */ P.jsx(bB, {
    className: M.endIcon,
    ownerState: B,
    children: C || /* @__PURE__ */ P.jsx(mC, {
      className: M.loadingIconPlaceholder,
      ownerState: B
    })
  }), V = a || "", X = typeof R == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ P.jsx("span", {
      className: M.loadingWrapper,
      style: {
        display: "contents"
      },
      children: R && /* @__PURE__ */ P.jsx(yB, {
        className: M.loadingIndicator,
        ownerState: B,
        children: F
      })
    })
  ) : null;
  return /* @__PURE__ */ P.jsxs(hB, {
    ownerState: B,
    className: ge(o.className, M.root, f, V),
    component: p,
    disabled: h || R,
    focusRipple: !y,
    focusVisibleClassName: ge(M.focusVisible, b),
    ref: r,
    type: A,
    id: R ? O : T,
    ...L,
    classes: M,
    children: [j, E !== "end" && X, c, E === "end" && X, W]
  });
});
process.env.NODE_ENV !== "production" && (hu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * Element placed after the children.
   */
  endIcon: n.node,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: n.string,
  /**
   * @ignore
   */
  id: n.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: n.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: n.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: n.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * Element placed before the children.
   */
  startIcon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @ignore
   */
  type: n.oneOfType([n.oneOf(["button", "reset", "submit"]), n.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["contained", "outlined", "text"]), n.string])
});
function TT(e) {
  return Ae("MuiButtonGroup", e);
}
const Nt = Ne("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), vB = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [{
    [`& .${Nt.grouped}`]: t.grouped
  }, {
    [`& .${Nt.grouped}`]: t[`grouped${re(r.orientation)}`]
  }, {
    [`& .${Nt.grouped}`]: t[`grouped${re(r.variant)}`]
  }, {
    [`& .${Nt.grouped}`]: t[`grouped${re(r.variant)}${re(r.orientation)}`]
  }, {
    [`& .${Nt.grouped}`]: t[`grouped${re(r.variant)}${re(r.color)}`]
  }, {
    [`& .${Nt.firstButton}`]: t.firstButton
  }, {
    [`& .${Nt.lastButton}`]: t.lastButton
  }, {
    [`& .${Nt.middleButton}`]: t.middleButton
  }, t.root, t[r.variant], r.disableElevation === !0 && t.disableElevation, r.fullWidth && t.fullWidth, r.orientation === "vertical" && t.vertical];
}, xB = (e) => {
  const {
    classes: t,
    color: r,
    disabled: o,
    disableElevation: a,
    fullWidth: i,
    orientation: l,
    variant: c
  } = e, d = {
    root: ["root", c, l, i && "fullWidth", a && "disableElevation", `color${re(r)}`],
    grouped: ["grouped", `grouped${re(l)}`, `grouped${re(c)}`, `grouped${re(c)}${re(l)}`, `grouped${re(c)}${re(r)}`, o && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Me(d, TT, t);
}, CB = Y("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: vB
})($e(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (e.vars || e).shadows[2]
    }
  }, {
    props: {
      disableElevation: !0
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${Nt.lastButton},& .${Nt.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Nt.lastButton},& .${Nt.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${Nt.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${Nt.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Vt()).flatMap(([t]) => [{
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : dt(e.palette[t].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${Nt.lastButton},& .${Nt.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${Nt.lastButton},& .${Nt.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${Nt.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${Nt.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Vt(["dark"])).map(([t]) => ({
    props: {
      variant: "contained",
      color: t
    },
    style: {
      [`& .${Nt.firstButton},& .${Nt.middleButton}`]: {
        borderColor: (e.vars || e).palette[t].dark
      }
    }
  }))],
  [`& .${Nt.grouped}`]: {
    minWidth: 40,
    boxShadow: "none",
    props: {
      variant: "contained"
    },
    style: {
      "&:hover": {
        boxShadow: "none"
      }
    }
  }
}))), ET = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: a,
    className: i,
    color: l = "primary",
    component: c = "div",
    disabled: d = !1,
    disableElevation: p = !1,
    disableFocusRipple: f = !1,
    disableRipple: h = !1,
    fullWidth: g = !1,
    orientation: y = "horizontal",
    size: C = "medium",
    variant: b = "outlined",
    ...v
  } = o, T = {
    ...o,
    color: l,
    component: c,
    disabled: d,
    disableElevation: p,
    disableFocusRipple: f,
    disableRipple: h,
    fullWidth: g,
    orientation: y,
    size: C,
    variant: b
  }, R = xB(T), $ = x.useMemo(() => ({
    className: R.grouped,
    color: l,
    disabled: d,
    disableElevation: p,
    disableFocusRipple: f,
    disableRipple: h,
    fullWidth: g,
    size: C,
    variant: b
  }), [l, d, p, f, h, g, C, b, R.grouped]), E = W2(a), S = E.length, k = (A) => {
    const _ = A === 0, L = A === S - 1;
    return _ && L ? "" : _ ? R.firstButton : L ? R.lastButton : R.middleButton;
  };
  return /* @__PURE__ */ P.jsx(CB, {
    as: c,
    role: "group",
    className: ge(R.root, i),
    ref: r,
    ownerState: T,
    ...v,
    children: /* @__PURE__ */ P.jsx(mf.Provider, {
      value: $,
      children: E.map((A, _) => /* @__PURE__ */ P.jsx(hf.Provider, {
        value: k(_),
        children: A
      }, _))
    })
  });
});
process.env.NODE_ENV !== "production" && (ET.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: n.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOfType([n.oneOf(["contained", "outlined", "text"]), n.string])
});
function OT(e) {
  return Ae("MuiCard", e);
}
const SB = Ne("MuiCard", ["root"]), wB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, OT, t);
}, TB = Y(no, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflow: "hidden"
}), $T = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCard"
  }), {
    className: a,
    raised: i = !1,
    ...l
  } = o, c = {
    ...o,
    raised: i
  }, d = wB(c);
  return /* @__PURE__ */ P.jsx(TB, {
    className: ge(d.root, a),
    elevation: i ? 8 : void 0,
    ref: r,
    ownerState: c,
    ...l
  });
});
process.env.NODE_ENV !== "production" && ($T.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: tn(n.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function RT(e) {
  return Ae("MuiCardActionArea", e);
}
const qd = Ne("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), EB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, RT, t);
}, OB = Y(qr, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${qd.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${qd.focusVisible} .${qd.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.focusOpacity
  }
}))), $B = Y("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (e, t) => t.focusHighlight
})($e(({
  theme: e
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: e.transitions.create("opacity", {
    duration: e.transitions.duration.short
  })
}))), PT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCardActionArea"
  }), {
    children: a,
    className: i,
    focusVisibleClassName: l,
    slots: c = {},
    slotProps: d = {},
    ...p
  } = o, f = o, h = EB(f), g = {
    slots: c,
    slotProps: d
  }, [y, C] = ze("root", {
    elementType: OB,
    externalForwardedProps: {
      ...g,
      ...p
    },
    shouldForwardComponentProp: !0,
    ownerState: f,
    ref: r,
    className: ge(h.root, i),
    additionalProps: {
      focusVisibleClassName: ge(l, h.focusVisible)
    }
  }), [b, v] = ze("focusHighlight", {
    elementType: $B,
    externalForwardedProps: g,
    ownerState: f,
    ref: r,
    className: h.focusHighlight
  });
  return /* @__PURE__ */ P.jsxs(y, {
    ...C,
    children: [a, /* @__PURE__ */ P.jsx(b, {
      ...v
    })]
  });
});
process.env.NODE_ENV !== "production" && (PT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    focusHighlight: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    focusHighlight: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function kT(e) {
  return Ae("MuiCardActions", e);
}
const RB = Ne("MuiCardActions", ["root", "spacing"]), PB = (e) => {
  const {
    classes: t,
    disableSpacing: r
  } = e;
  return Me({
    root: ["root", !r && "spacing"]
  }, kT, t);
}, kB = Y("div", {
  name: "MuiCardActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  variants: [{
    props: {
      disableSpacing: !1
    },
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), AT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCardActions"
  }), {
    disableSpacing: a = !1,
    className: i,
    ...l
  } = o, c = {
    ...o,
    disableSpacing: a
  }, d = PB(c);
  return /* @__PURE__ */ P.jsx(kB, {
    className: ge(d.root, i),
    ownerState: c,
    ref: r,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (AT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function IT(e) {
  return Ae("MuiCardContent", e);
}
const AB = Ne("MuiCardContent", ["root"]), IB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, IT, t);
}, NB = Y("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
}), NT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCardContent"
  }), {
    className: a,
    component: i = "div",
    ...l
  } = o, c = {
    ...o,
    component: i
  }, d = IB(c);
  return /* @__PURE__ */ P.jsx(NB, {
    as: i,
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (NT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function MT(e) {
  return Ae("MuiCardHeader", e);
}
const Hc = Ne("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), MB = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, MT, t);
}, _B = Y("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${Hc.title}`]: t.title
  }, {
    [`& .${Hc.subheader}`]: t.subheader
  }, t.root]
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), FB = Y("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), LB = Y("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), BB = Y("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto",
  [`.${zc.root}:where(& .${Hc.title})`]: {
    display: "block"
  },
  [`.${zc.root}:where(& .${Hc.subheader})`]: {
    display: "block"
  }
}), _T = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: a,
    avatar: i,
    component: l = "div",
    disableTypography: c = !1,
    subheader: d,
    subheaderTypographyProps: p,
    title: f,
    titleTypographyProps: h,
    slots: g = {},
    slotProps: y = {},
    ...C
  } = o, b = {
    ...o,
    component: l,
    disableTypography: c
  }, v = MB(b), T = {
    slots: g,
    slotProps: {
      title: h,
      subheader: p,
      ...y
    }
  };
  let R = f;
  const [$, E] = ze("title", {
    className: v.title,
    elementType: pn,
    externalForwardedProps: T,
    ownerState: b,
    additionalProps: {
      variant: i ? "body2" : "h5",
      component: "span"
    }
  });
  R != null && R.type !== pn && !c && (R = /* @__PURE__ */ P.jsx($, {
    ...E,
    children: R
  }));
  let S = d;
  const [k, A] = ze("subheader", {
    className: v.subheader,
    elementType: pn,
    externalForwardedProps: T,
    ownerState: b,
    additionalProps: {
      variant: i ? "body2" : "body1",
      color: "textSecondary",
      component: "span"
    }
  });
  S != null && S.type !== pn && !c && (S = /* @__PURE__ */ P.jsx(k, {
    ...A,
    children: S
  }));
  const [_, L] = ze("root", {
    ref: r,
    className: v.root,
    elementType: _B,
    externalForwardedProps: {
      ...T,
      ...C,
      component: l
    },
    ownerState: b
  }), [O, F] = ze("avatar", {
    className: v.avatar,
    elementType: FB,
    externalForwardedProps: T,
    ownerState: b
  }), [B, M] = ze("content", {
    className: v.content,
    elementType: BB,
    externalForwardedProps: T,
    ownerState: b
  }), [j, W] = ze("action", {
    className: v.action,
    elementType: LB,
    externalForwardedProps: T,
    ownerState: b
  });
  return /* @__PURE__ */ P.jsxs(_, {
    ...L,
    children: [i && /* @__PURE__ */ P.jsx(O, {
      ...F,
      children: i
    }), /* @__PURE__ */ P.jsxs(B, {
      ...M,
      children: [R, S]
    }), a && /* @__PURE__ */ P.jsx(j, {
      ...W,
      children: a
    })]
  });
});
process.env.NODE_ENV !== "production" && (_T.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: n.node,
  /**
   * The Avatar element to display.
   */
  avatar: n.node,
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    action: n.oneOfType([n.func, n.object]),
    avatar: n.oneOfType([n.func, n.object]),
    content: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    subheader: n.oneOfType([n.func, n.object]),
    title: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    action: n.elementType,
    avatar: n.elementType,
    content: n.elementType,
    root: n.elementType,
    subheader: n.elementType,
    title: n.elementType
  }),
  /**
   * The content of the component.
   */
  subheader: n.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.subheader` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  subheaderTypographyProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The content of the component.
   */
  title: n.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.title` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  titleTypographyProps: n.object
});
function FT(e) {
  return Ae("MuiCardMedia", e);
}
const DB = Ne("MuiCardMedia", ["root", "media", "img"]), jB = (e) => {
  const {
    classes: t,
    isMediaComponent: r,
    isImageComponent: o
  } = e;
  return Me({
    root: ["root", r && "media", o && "img"]
  }, FT, t);
}, zB = Y("div", {
  name: "MuiCardMedia",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      isMediaComponent: o,
      isImageComponent: a
    } = r;
    return [t.root, o && t.media, a && t.img];
  }
})({
  display: "block",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  variants: [{
    props: {
      isMediaComponent: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      isImageComponent: !0
    },
    style: {
      objectFit: "cover"
    }
  }]
}), VB = ["video", "audio", "picture", "iframe", "img"], WB = ["picture", "img"], LT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCardMedia"
  }), {
    children: a,
    className: i,
    component: l = "div",
    image: c,
    src: d,
    style: p,
    ...f
  } = o, h = VB.includes(l), g = !h && c ? {
    backgroundImage: `url("${c}")`,
    ...p
  } : p, y = {
    ...o,
    component: l,
    isMediaComponent: h,
    isImageComponent: WB.includes(l)
  }, C = jB(y);
  return /* @__PURE__ */ P.jsx(zB, {
    className: ge(C.root, i),
    as: l,
    role: !h && c ? "img" : void 0,
    ref: r,
    style: g,
    ownerState: y,
    src: h ? c || d : void 0,
    ...f,
    children: a
  });
});
process.env.NODE_ENV !== "production" && (LT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: tn(n.node, (e) => !e.children && !e.image && !e.src && !e.component ? new Error("MUI: Either `children`, `image`, `src` or `component` prop must be specified.") : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: n.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function UB(e) {
  return Ae("PrivateSwitchBase", e);
}
Ne("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const HB = (e) => {
  const {
    classes: t,
    checked: r,
    disabled: o,
    edge: a
  } = e, i = {
    root: ["root", r && "checked", o && "disabled", a && `edge${re(a)}`],
    input: ["input"]
  };
  return Me(i, UB, t);
}, GB = Y(qr, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), qB = Y("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: Zr
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), gf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    autoFocus: o,
    checked: a,
    checkedIcon: i,
    defaultChecked: l,
    disabled: c,
    disableFocusRipple: d = !1,
    edge: p = !1,
    icon: f,
    id: h,
    inputProps: g,
    inputRef: y,
    name: C,
    onBlur: b,
    onChange: v,
    onFocus: T,
    readOnly: R,
    required: $ = !1,
    tabIndex: E,
    type: S,
    value: k,
    slots: A = {},
    slotProps: _ = {},
    ...L
  } = t, [O, F] = Bn({
    controlled: a,
    default: !!l,
    name: "SwitchBase",
    state: "checked"
  }), B = ko(), M = (fe) => {
    T && T(fe), B && B.onFocus && B.onFocus(fe);
  }, j = (fe) => {
    b && b(fe), B && B.onBlur && B.onBlur(fe);
  }, W = (fe) => {
    if (fe.nativeEvent.defaultPrevented)
      return;
    const ie = fe.target.checked;
    F(ie), v && v(fe, ie);
  };
  let V = c;
  B && typeof V > "u" && (V = B.disabled);
  const X = S === "checkbox" || S === "radio", U = {
    ...t,
    checked: O,
    disabled: V,
    disableFocusRipple: d,
    edge: p
  }, H = HB(U), Z = {
    slots: A,
    slotProps: {
      input: g,
      ..._
    }
  }, [G, ye] = ze("root", {
    ref: r,
    elementType: GB,
    className: H.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...Z,
      component: "span",
      ...L
    },
    getSlotProps: (fe) => ({
      ...fe,
      onFocus: (ie) => {
        fe.onFocus?.(ie), M(ie);
      },
      onBlur: (ie) => {
        fe.onBlur?.(ie), j(ie);
      }
    }),
    ownerState: U,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !d,
      disabled: V,
      role: void 0,
      tabIndex: null
    }
  }), [de, ne] = ze("input", {
    ref: y,
    elementType: qB,
    className: H.input,
    externalForwardedProps: Z,
    getSlotProps: (fe) => ({
      onChange: (ie) => {
        fe.onChange?.(ie), W(ie);
      }
    }),
    ownerState: U,
    additionalProps: {
      autoFocus: o,
      checked: a,
      defaultChecked: l,
      disabled: V,
      id: X ? h : void 0,
      name: C,
      readOnly: R,
      required: $,
      tabIndex: E,
      type: S,
      ...S === "checkbox" && k === void 0 ? {} : {
        value: k
      }
    }
  });
  return /* @__PURE__ */ P.jsxs(G, {
    ...ye,
    children: [/* @__PURE__ */ P.jsx(de, {
      ...ne
    }), O ? i : f]
  });
});
process.env.NODE_ENV !== "production" && (gf.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: n.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: n.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /*
   * @ignore
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.object,
  /**
   * @ignore
   */
  tabIndex: n.oneOfType([n.number, n.string]),
  /**
   * The input component prop `type`.
   */
  type: n.string.isRequired,
  /**
   * The value of the component.
   */
  value: n.any
});
const KB = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), YB = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), ZB = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function BT(e) {
  return Ae("MuiCheckbox", e);
}
const Kd = Ne("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), XB = (e) => {
  const {
    classes: t,
    indeterminate: r,
    color: o,
    size: a
  } = e, i = {
    root: ["root", r && "indeterminate", `color${re(o)}`, `size${re(a)}`]
  }, l = Me(i, BT, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...l
  };
}, JB = Y(gf, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.indeterminate && t.indeterminate, t[`size${re(r.size)}`], r.color !== "default" && t[`color${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Kd.checked}, &.${Kd.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${Kd.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), QB = /* @__PURE__ */ P.jsx(YB, {}), eD = /* @__PURE__ */ P.jsx(KB, {}), tD = /* @__PURE__ */ P.jsx(ZB, {}), qb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: a = QB,
    color: i = "primary",
    icon: l = eD,
    indeterminate: c = !1,
    indeterminateIcon: d = tD,
    inputProps: p,
    size: f = "medium",
    disableRipple: h = !1,
    className: g,
    slots: y = {},
    slotProps: C = {},
    ...b
  } = o, v = c ? d : l, T = c ? d : a, R = {
    ...o,
    disableRipple: h,
    color: i,
    indeterminate: c,
    size: f
  }, $ = XB(R), E = C.input ?? p, [S, k] = ze("root", {
    ref: r,
    elementType: JB,
    className: ge($.root, g),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: y,
      slotProps: C,
      ...b
    },
    ownerState: R,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ x.cloneElement(v, {
        fontSize: v.props.fontSize ?? f
      }),
      checkedIcon: /* @__PURE__ */ x.cloneElement(T, {
        fontSize: T.props.fontSize ?? f
      }),
      disableRipple: h,
      slots: y,
      slotProps: {
        input: Ts(typeof E == "function" ? E(R) : E, {
          "data-indeterminate": c
        })
      }
    }
  });
  return /* @__PURE__ */ P.jsx(S, {
    ...k,
    classes: $
  });
});
process.env.NODE_ENV !== "production" && (qb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: n.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: n.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: n.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: n.any
});
function hC(e) {
  return e.substring(2).toLowerCase();
}
function rD(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function Il(e) {
  const {
    children: t,
    disableReactTree: r = !1,
    mouseEvent: o = "onClick",
    onClickAway: a,
    touchEvent: i = "onTouchEnd"
  } = e, l = x.useRef(!1), c = x.useRef(null), d = x.useRef(!1), p = x.useRef(!1);
  x.useEffect(() => (setTimeout(() => {
    d.current = !0;
  }, 0), () => {
    d.current = !1;
  }), []);
  const f = Jt(ii(t), c), h = Pr((C) => {
    const b = p.current;
    p.current = !1;
    const v = Rr(c.current);
    if (!d.current || !c.current || "clientX" in C && rD(C, v))
      return;
    if (l.current) {
      l.current = !1;
      return;
    }
    let T;
    C.composedPath ? T = C.composedPath().includes(c.current) : T = !v.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      C.target
    ) || c.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      C.target
    ), !T && (r || !b) && a(C);
  }), g = (C) => (b) => {
    p.current = !0;
    const v = t.props[C];
    v && v(b);
  }, y = {
    ref: f
  };
  return i !== !1 && (y[i] = g(i)), x.useEffect(() => {
    if (i !== !1) {
      const C = hC(i), b = Rr(c.current), v = () => {
        l.current = !0;
      };
      return b.addEventListener(C, h), b.addEventListener("touchmove", v), () => {
        b.removeEventListener(C, h), b.removeEventListener("touchmove", v);
      };
    }
  }, [h, i]), o !== !1 && (y[o] = g(o)), x.useEffect(() => {
    if (o !== !1) {
      const C = hC(o), b = Rr(c.current);
      return b.addEventListener(C, h), () => {
        b.removeEventListener(C, h);
      };
    }
  }, [h, o]), /* @__PURE__ */ x.cloneElement(t, y);
}
process.env.NODE_ENV !== "production" && (Il.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: ai.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: n.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: n.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: n.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: n.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (Il.propTypes = ks(Il.propTypes));
const DT = vN({
  createStyledComponent: Y("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: r
      } = e;
      return [t.root, t[`maxWidth${re(String(r.maxWidth))}`], r.fixed && t.fixed, r.disableGutters && t.disableGutters];
    }
  }),
  useThemeProps: (e) => Fe({
    props: e,
    name: "MuiContainer"
  })
});
process.env.NODE_ENV !== "production" && (DT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: n.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function nD(e) {
  return Ae("MuiContainer", e);
}
const oD = Ne("MuiContainer", ["root", "disableGutters", "fixed", "maxWidthXs", "maxWidthSm", "maxWidthMd", "maxWidthLg", "maxWidthXl"]), fg = typeof Rb({}) == "function", jT = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t && !e.vars && {
    colorScheme: e.palette.mode
  }
}), zT = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), VT = (e, t = !1) => {
  const r = {};
  t && e.colorSchemes && typeof e.getColorSchemeSelector == "function" && Object.entries(e.colorSchemes).forEach(([i, l]) => {
    const c = e.getColorSchemeSelector(i);
    c.startsWith("@") ? r[c] = {
      ":root": {
        colorScheme: l.palette?.mode
      }
    } : r[c.replace(/\s*&/, "")] = {
      colorScheme: l.palette?.mode
    };
  });
  let o = {
    html: jT(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: {
      margin: 0,
      // Remove the margin in all browsers.
      ...zT(e),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    },
    ...r
  };
  const a = e.components?.MuiCssBaseline?.styleOverrides;
  return a && (o = [o, a]), o;
}, Yd = "mui-ecs", aD = (e) => {
  const t = VT(e, !1), r = Array.isArray(t) ? t[0] : t;
  return !e.vars && r && (r.html[`:root:has(${Yd})`] = {
    colorScheme: e.palette.mode
  }), e.colorSchemes && Object.entries(e.colorSchemes).forEach(([o, a]) => {
    const i = e.getColorSchemeSelector(o);
    i.startsWith("@") ? r[i] = {
      [`:root:not(:has(.${Yd}))`]: {
        colorScheme: a.palette?.mode
      }
    } : r[i.replace(/\s*&/, "")] = {
      [`&:not(:has(.${Yd}))`]: {
        colorScheme: a.palette?.mode
      }
    };
  }), t;
}, iD = Rb(fg ? ({
  theme: e,
  enableColorScheme: t
}) => VT(e, t) : ({
  theme: e
}) => aD(e));
function WT(e) {
  const t = Fe({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: r,
    enableColorScheme: o = !1
  } = t;
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [fg && /* @__PURE__ */ P.jsx(iD, {
      enableColorScheme: o
    }), !fg && !o && /* @__PURE__ */ P.jsx("span", {
      className: Yd,
      style: {
        display: "none"
      }
    }), r]
  });
}
process.env.NODE_ENV !== "production" && (WT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: n.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: n.bool
});
const sD = {
  track: "#2b2b2b",
  thumb: "#6b6b6b",
  active: "#959595"
};
function lD(e = sD) {
  return {
    scrollbarColor: `${e.thumb} ${e.track}`,
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
      backgroundColor: e.track
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
      borderRadius: 8,
      backgroundColor: e.thumb,
      minHeight: 24,
      border: `3px solid ${e.track}`
    },
    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
      backgroundColor: e.track
    }
  };
}
function cD(e) {
  const t = Rr(e);
  return t.body === e ? fn(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Ic(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function gC(e) {
  return parseInt(fn(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function uD(e) {
  const r = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return r || o;
}
function bC(e, t, r, o, a) {
  const i = [t, r, ...o];
  [].forEach.call(e.children, (l) => {
    const c = !i.includes(l), d = !uD(l);
    c && d && Ic(l, a);
  });
}
function uh(e, t) {
  let r = -1;
  return e.some((o, a) => t(o) ? (r = a, !0) : !1), r;
}
function dD(e, t) {
  const r = [], o = e.container;
  if (!t.disableScrollLock) {
    if (cD(o)) {
      const l = V2(fn(o));
      r.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${gC(o) + l}px`;
      const c = Rr(o).querySelectorAll(".mui-fixed");
      [].forEach.call(c, (d) => {
        r.push({
          value: d.style.paddingRight,
          property: "padding-right",
          el: d
        }), d.style.paddingRight = `${gC(d) + l}px`;
      });
    }
    let i;
    if (o.parentNode instanceof DocumentFragment)
      i = Rr(o).body;
    else {
      const l = o.parentElement, c = fn(o);
      i = l?.nodeName === "HTML" && c.getComputedStyle(l).overflowY === "scroll" ? l : o;
    }
    r.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: i,
      el: l,
      property: c
    }) => {
      i ? l.style.setProperty(c, i) : l.style.removeProperty(c);
    });
  };
}
function pD(e) {
  const t = [];
  return [].forEach.call(e.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && t.push(r);
  }), t;
}
class UT {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, r) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && Ic(t.modalRef, !1);
    const a = pD(r);
    bC(r, t.mount, t.modalRef, a, !0);
    const i = uh(this.containers, (l) => l.container === r);
    return i !== -1 ? (this.containers[i].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: r,
      restore: null,
      hiddenSiblings: a
    }), o);
  }
  mount(t, r) {
    const o = uh(this.containers, (i) => i.modals.includes(t)), a = this.containers[o];
    a.restore || (a.restore = dD(a, r));
  }
  remove(t, r = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const a = uh(this.containers, (l) => l.modals.includes(t)), i = this.containers[a];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(o, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && Ic(t.modalRef, r), bC(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(a, 1);
    else {
      const l = i.modals[i.modals.length - 1];
      l.modalRef && Ic(l.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const fD = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function mD(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function hD(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`);
  let r = t(`[name="${e.name}"]:checked`);
  return r || (r = t(`[name="${e.name}"]`)), r !== e;
}
function gD(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || hD(e));
}
function bD(e) {
  const t = [], r = [];
  return Array.from(e.querySelectorAll(fD)).forEach((o, a) => {
    const i = mD(o);
    i === -1 || !gD(o) || (i === 0 ? t.push(o) : r.push({
      documentOrder: a,
      tabIndex: i,
      node: o
    }));
  }), r.sort((o, a) => o.tabIndex === a.tabIndex ? o.documentOrder - a.documentOrder : o.tabIndex - a.tabIndex).map((o) => o.node).concat(t);
}
function yD() {
  return !0;
}
function Gc(e) {
  const {
    children: t,
    disableAutoFocus: r = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: a = !1,
    getTabbable: i = bD,
    isEnabled: l = yD,
    open: c
  } = e, d = x.useRef(!1), p = x.useRef(null), f = x.useRef(null), h = x.useRef(null), g = x.useRef(null), y = x.useRef(!1), C = x.useRef(null), b = Jt(ii(t), C), v = x.useRef(null);
  x.useEffect(() => {
    !c || !C.current || (y.current = !r);
  }, [r, c]), x.useEffect(() => {
    if (!c || !C.current)
      return;
    const $ = Rr(C.current);
    return C.current.contains($.activeElement) || (C.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), C.current.setAttribute("tabIndex", "-1")), y.current && C.current.focus()), () => {
      a || (h.current && h.current.focus && (d.current = !0, h.current.focus()), h.current = null);
    };
  }, [c]), x.useEffect(() => {
    if (!c || !C.current)
      return;
    const $ = Rr(C.current), E = (A) => {
      v.current = A, !(o || !l() || A.key !== "Tab") && $.activeElement === C.current && A.shiftKey && (d.current = !0, f.current && f.current.focus());
    }, S = () => {
      const A = C.current;
      if (A === null)
        return;
      if (!$.hasFocus() || !l() || d.current) {
        d.current = !1;
        return;
      }
      if (A.contains($.activeElement) || o && $.activeElement !== p.current && $.activeElement !== f.current)
        return;
      if ($.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!y.current)
        return;
      let _ = [];
      if (($.activeElement === p.current || $.activeElement === f.current) && (_ = i(C.current)), _.length > 0) {
        const L = !!(v.current?.shiftKey && v.current?.key === "Tab"), O = _[0], F = _[_.length - 1];
        typeof O != "string" && typeof F != "string" && (L ? F.focus() : O.focus());
      } else
        A.focus();
    };
    $.addEventListener("focusin", S), $.addEventListener("keydown", E, !0);
    const k = setInterval(() => {
      $.activeElement && $.activeElement.tagName === "BODY" && S();
    }, 50);
    return () => {
      clearInterval(k), $.removeEventListener("focusin", S), $.removeEventListener("keydown", E, !0);
    };
  }, [r, o, a, l, c, i]);
  const T = ($) => {
    h.current === null && (h.current = $.relatedTarget), y.current = !0, g.current = $.target;
    const E = t.props.onFocus;
    E && E($);
  }, R = ($) => {
    h.current === null && (h.current = $.relatedTarget), y.current = !0;
  };
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: R,
      ref: p,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ x.cloneElement(t, {
      ref: b,
      onFocus: T
    }), /* @__PURE__ */ P.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: R,
      ref: f,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Gc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: ai,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: n.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: n.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: n.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: n.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: n.func,
  /**
   * If `true`, focus is locked.
   */
  open: n.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Gc.propTypes = ks(Gc.propTypes));
function vD(e) {
  return typeof e == "function" ? e() : e;
}
function xD(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const yC = () => {
}, Sd = new UT();
function CD(e) {
  const {
    container: t,
    disableEscapeKeyDown: r = !1,
    disableScrollLock: o = !1,
    closeAfterTransition: a = !1,
    onTransitionEnter: i,
    onTransitionExited: l,
    children: c,
    onClose: d,
    open: p,
    rootRef: f
  } = e, h = x.useRef({}), g = x.useRef(null), y = x.useRef(null), C = Jt(y, f), [b, v] = x.useState(!p), T = xD(c);
  let R = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (R = !1);
  const $ = () => Rr(g.current), E = () => (h.current.modalRef = y.current, h.current.mount = g.current, h.current), S = () => {
    Sd.mount(E(), {
      disableScrollLock: o
    }), y.current && (y.current.scrollTop = 0);
  }, k = Pr(() => {
    const W = vD(t) || $().body;
    Sd.add(E(), W), y.current && S();
  }), A = () => Sd.isTopModal(E()), _ = Pr((W) => {
    g.current = W, W && (p && A() ? S() : y.current && Ic(y.current, R));
  }), L = x.useCallback(() => {
    Sd.remove(E(), R);
  }, [R]);
  x.useEffect(() => () => {
    L();
  }, [L]), x.useEffect(() => {
    p ? k() : (!T || !a) && L();
  }, [p, L, T, a, k]);
  const O = (W) => (V) => {
    W.onKeyDown?.(V), !(V.key !== "Escape" || V.which === 229 || // Wait until IME is settled.
    !A()) && (r || (V.stopPropagation(), d && d(V, "escapeKeyDown")));
  }, F = (W) => (V) => {
    W.onClick?.(V), V.target === V.currentTarget && d && d(V, "backdropClick");
  };
  return {
    getRootProps: (W = {}) => {
      const V = gs(e);
      delete V.onTransitionEnter, delete V.onTransitionExited;
      const X = {
        ...V,
        ...W
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...X,
        onKeyDown: O(X),
        ref: C
      };
    },
    getBackdropProps: (W = {}) => {
      const V = W;
      return {
        "aria-hidden": !0,
        ...V,
        onClick: F(V),
        open: p
      };
    },
    getTransitionProps: () => {
      const W = () => {
        v(!1), i && i();
      }, V = () => {
        v(!0), l && l(), a && L();
      };
      return {
        onEnter: lp(W, c?.props.onEnter ?? yC),
        onExited: lp(V, c?.props.onExited ?? yC)
      };
    },
    rootRef: C,
    portalRef: _,
    isTopModal: A,
    exited: b,
    hasTransition: T
  };
}
function HT(e) {
  return Ae("MuiModal", e);
}
const SD = Ne("MuiModal", ["root", "hidden", "backdrop"]), wD = (e) => {
  const {
    open: t,
    exited: r,
    classes: o
  } = e;
  return Me({
    root: ["root", !t && r && "hidden"],
    backdrop: ["backdrop"]
  }, HT, o);
}, TD = Y("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.open && r.exited && t.hidden];
  }
})($e(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), ED = Y(mu, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), gu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: a = ED,
    BackdropProps: i,
    classes: l,
    className: c,
    closeAfterTransition: d = !1,
    children: p,
    container: f,
    component: h,
    components: g = {},
    componentsProps: y = {},
    disableAutoFocus: C = !1,
    disableEnforceFocus: b = !1,
    disableEscapeKeyDown: v = !1,
    disablePortal: T = !1,
    disableRestoreFocus: R = !1,
    disableScrollLock: $ = !1,
    hideBackdrop: E = !1,
    keepMounted: S = !1,
    onBackdropClick: k,
    onClose: A,
    onTransitionEnter: _,
    onTransitionExited: L,
    open: O,
    slotProps: F = {},
    slots: B = {},
    // eslint-disable-next-line react/prop-types
    theme: M,
    ...j
  } = o, W = {
    ...o,
    closeAfterTransition: d,
    disableAutoFocus: C,
    disableEnforceFocus: b,
    disableEscapeKeyDown: v,
    disablePortal: T,
    disableRestoreFocus: R,
    disableScrollLock: $,
    hideBackdrop: E,
    keepMounted: S
  }, {
    getRootProps: V,
    getBackdropProps: X,
    getTransitionProps: U,
    portalRef: H,
    isTopModal: Z,
    exited: G,
    hasTransition: ye
  } = CD({
    ...W,
    rootRef: r
  }), de = {
    ...W,
    exited: G
  }, ne = wD(de), fe = {};
  if (p.props.tabIndex === void 0 && (fe.tabIndex = "-1"), ye) {
    const {
      onEnter: Re,
      onExited: J
    } = U();
    fe.onEnter = Re, fe.onExited = J;
  }
  const ie = {
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...B
    },
    slotProps: {
      ...y,
      ...F
    }
  }, [oe, ce] = ze("root", {
    ref: r,
    elementType: TD,
    externalForwardedProps: {
      ...ie,
      ...j,
      component: h
    },
    getSlotProps: V,
    ownerState: de,
    className: ge(c, ne?.root, !de.open && de.exited && ne?.hidden)
  }), [Ce, xe] = ze("backdrop", {
    ref: i?.ref,
    elementType: a,
    externalForwardedProps: ie,
    shouldForwardComponentProp: !0,
    additionalProps: i,
    getSlotProps: (Re) => X({
      ...Re,
      onClick: (J) => {
        k && k(J), Re?.onClick && Re.onClick(J);
      }
    }),
    className: ge(i?.className, ne?.backdrop),
    ownerState: de
  });
  return !S && !O && (!ye || G) ? null : /* @__PURE__ */ P.jsx(kl, {
    ref: H,
    container: f,
    disablePortal: T,
    children: /* @__PURE__ */ P.jsxs(oe, {
      ...ce,
      children: [!E && a ? /* @__PURE__ */ P.jsx(Ce, {
        ...xe
      }) : null, /* @__PURE__ */ P.jsx(Gc, {
        disableEnforceFocus: b,
        disableAutoFocus: C,
        disableRestoreFocus: R,
        isEnabled: Z,
        open: O,
        children: /* @__PURE__ */ x.cloneElement(p, fe)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (gu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: n.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: n.object,
  /**
   * A single child content element.
   */
  children: ai.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: n.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Backdrop: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([$a, n.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: n.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: n.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: n.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: n.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: n.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: n.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function GT(e) {
  return Ae("MuiDialog", e);
}
const Zd = Ne("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), Kb = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (Kb.displayName = "DialogContext");
const OD = Y(mu, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), $D = (e) => {
  const {
    classes: t,
    scroll: r,
    maxWidth: o,
    fullWidth: a,
    fullScreen: i
  } = e, l = {
    root: ["root"],
    container: ["container", `scroll${re(r)}`],
    paper: ["paper", `paperScroll${re(r)}`, `paperWidth${re(String(o))}`, a && "paperFullWidth", i && "paperFullScreen"]
  };
  return Me(l, GT, t);
}, RD = Y(gu, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), PD = Y("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.container, t[`scroll${re(r.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), kD = Y(no, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.paper, t[`scrollPaper${re(r.scroll)}`], t[`paperWidth${re(String(r.maxWidth))}`], r.fullWidth && t.paperFullWidth, r.fullScreen && t.paperFullScreen];
  }
})($e(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${Zd.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${Zd.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${Zd.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), qT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDialog"
  }), a = Yr(), i = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    "aria-describedby": l,
    "aria-labelledby": c,
    "aria-modal": d = !0,
    BackdropComponent: p,
    BackdropProps: f,
    children: h,
    className: g,
    disableEscapeKeyDown: y = !1,
    fullScreen: C = !1,
    fullWidth: b = !1,
    maxWidth: v = "sm",
    onBackdropClick: T,
    onClick: R,
    onClose: $,
    open: E,
    PaperComponent: S = no,
    PaperProps: k = {},
    scroll: A = "paper",
    slots: _ = {},
    slotProps: L = {},
    TransitionComponent: O = Al,
    transitionDuration: F = i,
    TransitionProps: B,
    ...M
  } = o, j = {
    ...o,
    disableEscapeKeyDown: y,
    fullScreen: C,
    fullWidth: b,
    maxWidth: v,
    scroll: A
  }, W = $D(j), V = x.useRef(), X = (le) => {
    V.current = le.target === le.currentTarget;
  }, U = (le) => {
    R && R(le), V.current && (V.current = null, T && T(le), $ && $(le, "backdropClick"));
  }, H = eo(c), Z = x.useMemo(() => ({
    titleId: H
  }), [H]), G = {
    transition: O,
    ..._
  }, ye = {
    transition: B,
    paper: k,
    backdrop: f,
    ...L
  }, de = {
    slots: G,
    slotProps: ye
  }, [ne, fe] = ze("root", {
    elementType: RD,
    shouldForwardComponentProp: !0,
    externalForwardedProps: de,
    ownerState: j,
    className: ge(W.root, g),
    ref: r
  }), [ie, oe] = ze("backdrop", {
    elementType: OD,
    shouldForwardComponentProp: !0,
    externalForwardedProps: de,
    ownerState: j
  }), [ce, Ce] = ze("paper", {
    elementType: kD,
    shouldForwardComponentProp: !0,
    externalForwardedProps: de,
    ownerState: j,
    className: ge(W.paper, k.className)
  }), [xe, Re] = ze("container", {
    elementType: PD,
    externalForwardedProps: de,
    ownerState: j,
    className: ge(W.container)
  }), [J, Ie] = ze("transition", {
    elementType: Al,
    externalForwardedProps: de,
    ownerState: j,
    additionalProps: {
      appear: !0,
      in: E,
      timeout: F,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ P.jsx(ne, {
    closeAfterTransition: !0,
    slots: {
      backdrop: ie
    },
    slotProps: {
      backdrop: {
        transitionDuration: F,
        as: p,
        ...oe
      }
    },
    disableEscapeKeyDown: y,
    onClose: $,
    open: E,
    onClick: U,
    ...fe,
    ...M,
    children: /* @__PURE__ */ P.jsx(J, {
      ...Ie,
      children: /* @__PURE__ */ P.jsx(xe, {
        onMouseDown: X,
        ...Re,
        children: /* @__PURE__ */ P.jsx(ce, {
          as: S,
          elevation: 24,
          role: "dialog",
          "aria-describedby": l,
          "aria-labelledby": H,
          "aria-modal": d,
          ...Ce,
          children: /* @__PURE__ */ P.jsx(Kb.Provider, {
            value: Z,
            children: h
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (qT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": n.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": n.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": n.oneOfType([n.oneOf(["false", "true"]), n.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: n.elementType,
  /**
   * @ignore
   */
  BackdropProps: n.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: n.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: n.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: n.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: n.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: n.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    container: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    container: n.elementType,
    paper: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: n.object
});
function KT(e) {
  return Ae("MuiDialogActions", e);
}
const AD = Ne("MuiDialogActions", ["root", "spacing"]), ID = (e) => {
  const {
    classes: t,
    disableSpacing: r
  } = e;
  return Me({
    root: ["root", !r && "spacing"]
  }, KT, t);
}, ND = Y("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), YT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: a,
    disableSpacing: i = !1,
    ...l
  } = o, c = {
    ...o,
    disableSpacing: i
  }, d = ID(c);
  return /* @__PURE__ */ P.jsx(ND, {
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (YT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function ZT(e) {
  return Ae("MuiDialogContent", e);
}
const MD = Ne("MuiDialogContent", ["root", "dividers"]);
function XT(e) {
  return Ae("MuiDialogTitle", e);
}
const JT = Ne("MuiDialogTitle", ["root"]), _D = (e) => {
  const {
    classes: t,
    dividers: r
  } = e;
  return Me({
    root: ["root", r && "dividers"]
  }, ZT, t);
}, FD = Y("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.dividers && t.dividers];
  }
})($e(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${JT.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), QT = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: a,
    dividers: i = !1,
    ...l
  } = o, c = {
    ...o,
    dividers: i
  }, d = _D(c);
  return /* @__PURE__ */ P.jsx(FD, {
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (QT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function eE(e) {
  return Ae("MuiDialogContentText", e);
}
const LD = Ne("MuiDialogContentText", ["root"]), BD = (e) => {
  const {
    classes: t
  } = e, o = Me({
    root: ["root"]
  }, eE, t);
  return {
    ...t,
    // forward classes to the Typography
    ...o
  };
}, DD = Y(pn, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), tE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDialogContentText"
  }), {
    children: a,
    className: i,
    ...l
  } = o, c = BD(l);
  return /* @__PURE__ */ P.jsx(DD, {
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: r,
    ownerState: l,
    className: ge(c.root, i),
    ...o,
    classes: c
  });
});
process.env.NODE_ENV !== "production" && (tE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const jD = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, XT, t);
}, zD = Y(pn, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), rE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: a,
    id: i,
    ...l
  } = o, c = o, d = jD(c), {
    titleId: p = i
  } = x.useContext(Kb);
  return /* @__PURE__ */ P.jsx(zD, {
    component: "h2",
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    variant: "h6",
    id: i ?? p,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (rE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  id: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function nE(e) {
  return Ae("MuiDivider", e);
}
const mg = Ne("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), VD = (e) => {
  const {
    absolute: t,
    children: r,
    classes: o,
    flexItem: a,
    light: i,
    orientation: l,
    textAlign: c,
    variant: d
  } = e;
  return Me({
    root: ["root", t && "absolute", d, i && "light", l === "vertical" && "vertical", a && "flexItem", r && "withChildren", r && l === "vertical" && "withChildrenVertical", c === "right" && l !== "vertical" && "textAlignRight", c === "left" && l !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", l === "vertical" && "wrapperVertical"]
  }, nE, o);
}, WD = Y("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.absolute && t.absolute, t[r.variant], r.light && t.light, r.orientation === "vertical" && t.vertical, r.flexItem && t.flexItem, r.children && t.withChildren, r.children && r.orientation === "vertical" && t.withChildrenVertical, r.textAlign === "right" && r.orientation !== "vertical" && t.textAlignRight, r.textAlign === "left" && r.orientation !== "vertical" && t.textAlignLeft];
  }
})($e(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : dt(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), UD = Y("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.wrapper, r.orientation === "vertical" && t.wrapperVertical];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), qc = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: a = !1,
    children: i,
    className: l,
    orientation: c = "horizontal",
    component: d = i || c === "vertical" ? "div" : "hr",
    flexItem: p = !1,
    light: f = !1,
    role: h = d !== "hr" ? "separator" : void 0,
    textAlign: g = "center",
    variant: y = "fullWidth",
    ...C
  } = o, b = {
    ...o,
    absolute: a,
    component: d,
    flexItem: p,
    light: f,
    orientation: c,
    role: h,
    textAlign: g,
    variant: y
  }, v = VD(b);
  return /* @__PURE__ */ P.jsx(WD, {
    as: d,
    className: ge(v.root, l),
    role: h,
    ref: r,
    ownerState: b,
    "aria-orientation": h === "separator" && (d !== "hr" || c === "vertical") ? c : void 0,
    ...C,
    children: i ? /* @__PURE__ */ P.jsx(UD, {
      className: v.wrapper,
      ownerState: b,
      children: i
    }) : null
  });
});
qc && (qc.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: n.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: n.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: n.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: n.oneOfType([n.oneOf(["fullWidth", "inset", "middle"]), n.string])
});
function HD(e, t, r) {
  const o = t.getBoundingClientRect(), a = r && r.getBoundingClientRect(), i = fn(t);
  let l;
  if (t.fakeTransform)
    l = t.fakeTransform;
  else {
    const p = i.getComputedStyle(t);
    l = p.getPropertyValue("-webkit-transform") || p.getPropertyValue("transform");
  }
  let c = 0, d = 0;
  if (l && l !== "none" && typeof l == "string") {
    const p = l.split("(")[1].split(")")[0].split(",");
    c = parseInt(p[4], 10), d = parseInt(p[5], 10);
  }
  return e === "left" ? a ? `translateX(${a.right + c - o.left}px)` : `translateX(${i.innerWidth + c - o.left}px)` : e === "right" ? a ? `translateX(-${o.right - a.left - c}px)` : `translateX(-${o.left + o.width - c}px)` : e === "up" ? a ? `translateY(${a.bottom + d - o.top}px)` : `translateY(${i.innerHeight + d - o.top}px)` : a ? `translateY(-${o.top - a.top + o.height - d}px)` : `translateY(-${o.top + o.height - d}px)`;
}
function oE(e) {
  return typeof e == "function" ? e() : e;
}
function wd(e, t, r) {
  const o = oE(r), a = HD(e, t, o);
  a && (t.style.webkitTransform = a, t.style.transform = a);
}
const Yb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Yr(), a = {
    enter: o.transitions.easing.easeOut,
    exit: o.transitions.easing.sharp
  }, i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: l,
    appear: c = !0,
    children: d,
    container: p,
    direction: f = "down",
    easing: h = a,
    in: g,
    onEnter: y,
    onEntered: C,
    onEntering: b,
    onExit: v,
    onExited: T,
    onExiting: R,
    style: $,
    timeout: E = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = Po,
    ...k
  } = t, A = x.useRef(null), _ = Jt(ii(d), A, r), L = (U) => (H) => {
    U && (H === void 0 ? U(A.current) : U(A.current, H));
  }, O = L((U, H) => {
    wd(f, U, p), of(U), y && y(U, H);
  }), F = L((U, H) => {
    const Z = aa({
      timeout: E,
      style: $,
      easing: h
    }, {
      mode: "enter"
    });
    U.style.webkitTransition = o.transitions.create("-webkit-transform", {
      ...Z
    }), U.style.transition = o.transitions.create("transform", {
      ...Z
    }), U.style.webkitTransform = "none", U.style.transform = "none", b && b(U, H);
  }), B = L(C), M = L(R), j = L((U) => {
    const H = aa({
      timeout: E,
      style: $,
      easing: h
    }, {
      mode: "exit"
    });
    U.style.webkitTransition = o.transitions.create("-webkit-transform", H), U.style.transition = o.transitions.create("transform", H), wd(f, U, p), v && v(U);
  }), W = L((U) => {
    U.style.webkitTransition = "", U.style.transition = "", T && T(U);
  }), V = (U) => {
    l && l(A.current, U);
  }, X = x.useCallback(() => {
    A.current && wd(f, A.current, p);
  }, [f, p]);
  return x.useEffect(() => {
    if (g || f === "down" || f === "right")
      return;
    const U = As(() => {
      A.current && wd(f, A.current, p);
    }), H = fn(A.current);
    return H.addEventListener("resize", U), () => {
      U.clear(), H.removeEventListener("resize", U);
    };
  }, [f, g, p]), x.useEffect(() => {
    g || X();
  }, [g, X]), /* @__PURE__ */ P.jsx(S, {
    nodeRef: A,
    onEnter: O,
    onEntered: B,
    onEntering: F,
    onExit: j,
    onExited: W,
    onExiting: M,
    addEndListener: V,
    appear: c,
    in: g,
    timeout: E,
    ...k,
    children: (U, {
      ownerState: H,
      ...Z
    }) => /* @__PURE__ */ x.cloneElement(d, {
      ref: _,
      style: {
        visibility: U === "exited" && !g ? "hidden" : void 0,
        ...$,
        ...d.props.style
      },
      ...Z
    })
  });
});
process.env.NODE_ENV !== "production" && (Yb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: ai.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: tn(n.oneOfType([$a, n.func]), (e) => {
    if (e.open) {
      const t = oE(e.container);
      if (t && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: n.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
function aE(e) {
  return Ae("MuiDrawer", e);
}
const GD = Ne("MuiDrawer", ["root", "docked", "paper", "anchorLeft", "anchorRight", "anchorTop", "anchorBottom", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]), iE = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, (r.variant === "permanent" || r.variant === "persistent") && t.docked, t.modal];
}, qD = (e) => {
  const {
    classes: t,
    anchor: r,
    variant: o
  } = e, a = {
    root: ["root", `anchor${re(r)}`],
    docked: [(o === "permanent" || o === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${re(r)}`, o !== "temporary" && `paperAnchorDocked${re(r)}`]
  };
  return Me(a, aE, t);
}, KD = Y(gu, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: iE
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), YD = Y("div", {
  shouldForwardProp: Zr,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: iE
})({
  flex: "0 0 auto"
}), ZD = Y(no, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.paper, t[`paperAnchor${re(r.anchor)}`], r.variant !== "temporary" && t[`paperAnchorDocked${re(r.anchor)}`]];
  }
})($e(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), sE = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function as(e) {
  return ["left", "right"].includes(e);
}
function Tc({
  direction: e
}, t) {
  return e === "rtl" && as(t) ? sE[t] : t;
}
const Zb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiDrawer"
  }), a = Yr(), i = la(), l = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    anchor: c = "left",
    BackdropProps: d,
    children: p,
    className: f,
    elevation: h = 16,
    hideBackdrop: g = !1,
    ModalProps: {
      BackdropProps: y,
      ...C
    } = {},
    onClose: b,
    open: v = !1,
    PaperProps: T = {},
    SlideProps: R,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $,
    transitionDuration: E = l,
    variant: S = "temporary",
    slots: k = {},
    slotProps: A = {},
    ..._
  } = o, L = x.useRef(!1);
  x.useEffect(() => {
    L.current = !0;
  }, []);
  const O = Tc({
    direction: i ? "rtl" : "ltr"
  }, c), B = {
    ...o,
    anchor: c,
    elevation: h,
    open: v,
    variant: S,
    ..._
  }, M = qD(B), j = {
    slots: {
      transition: $,
      ...k
    },
    slotProps: {
      paper: T,
      transition: R,
      ...A,
      backdrop: Ts(A.backdrop || {
        ...d,
        ...y
      }, {
        transitionDuration: E
      })
    }
  }, [W, V] = ze("root", {
    ref: r,
    elementType: KD,
    className: ge(M.root, M.modal, f),
    shouldForwardComponentProp: !0,
    ownerState: B,
    externalForwardedProps: {
      ...j,
      ..._,
      ...C
    },
    additionalProps: {
      open: v,
      onClose: b,
      hideBackdrop: g,
      slots: {
        backdrop: j.slots.backdrop
      },
      slotProps: {
        backdrop: j.slotProps.backdrop
      }
    }
  }), [X, U] = ze("paper", {
    elementType: ZD,
    shouldForwardComponentProp: !0,
    className: ge(M.paper, T.className),
    ownerState: B,
    externalForwardedProps: j,
    additionalProps: {
      elevation: S === "temporary" ? h : 0,
      square: !0
    }
  }), [H, Z] = ze("docked", {
    elementType: YD,
    ref: r,
    className: ge(M.root, M.docked, f),
    ownerState: B,
    externalForwardedProps: j,
    additionalProps: _
    // pass `other` here because `DockedSlot` is also a root slot for some variants
  }), [G, ye] = ze("transition", {
    elementType: Yb,
    ownerState: B,
    externalForwardedProps: j,
    additionalProps: {
      in: v,
      direction: sE[O],
      timeout: E,
      appear: L.current
    }
  }), de = /* @__PURE__ */ P.jsx(X, {
    ...U,
    children: p
  });
  if (S === "permanent")
    return /* @__PURE__ */ P.jsx(H, {
      ...Z,
      children: de
    });
  const ne = /* @__PURE__ */ P.jsx(G, {
    ...ye,
    children: de
  });
  return S === "persistent" ? /* @__PURE__ */ P.jsx(H, {
    ...Z,
    children: ne
  }) : /* @__PURE__ */ P.jsx(W, {
    ...V,
    children: ne
  });
});
process.env.NODE_ENV !== "production" && (Zb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: n.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: n.object,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: Vr,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: n.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: n.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: n.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PaperProps: n.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SlideProps: n.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    docked: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    docked: n.elementType,
    paper: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: n.oneOf(["permanent", "persistent", "temporary"])
});
function lE(e) {
  return Ae("MuiFab", e);
}
const hg = Ne("MuiFab", ["root", "primary", "secondary", "extended", "circular", "focusVisible", "disabled", "colorInherit", "sizeSmall", "sizeMedium", "sizeLarge", "info", "error", "warning", "success"]), XD = (e) => {
  const {
    color: t,
    variant: r,
    classes: o,
    size: a
  } = e, i = {
    root: ["root", r, `size${re(a)}`, t === "inherit" ? "colorInherit" : t]
  }, l = Me(i, lE, o);
  return {
    ...o,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...l
  };
}, JD = Y(qr, {
  name: "MuiFab",
  slot: "Root",
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`size${re(r.size)}`], r.color === "inherit" && t.colorInherit, t[re(r.size)], t[r.color]];
  }
})($e(({
  theme: e
}) => ({
  ...e.typography.button,
  minHeight: 36,
  transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
    duration: e.transitions.duration.short
  }),
  borderRadius: "50%",
  padding: 0,
  minWidth: 0,
  width: 56,
  height: 56,
  zIndex: (e.vars || e).zIndex.fab,
  boxShadow: (e.vars || e).shadows[6],
  "&:active": {
    boxShadow: (e.vars || e).shadows[12]
  },
  color: e.vars ? e.vars.palette.text.primary : e.palette.getContrastText?.(e.palette.grey[300]),
  backgroundColor: (e.vars || e).palette.grey[300],
  "&:hover": {
    backgroundColor: (e.vars || e).palette.grey.A100,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: (e.vars || e).palette.grey[300]
    },
    textDecoration: "none"
  },
  [`&.${hg.focusVisible}`]: {
    boxShadow: (e.vars || e).shadows[6]
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 40
    }
  }, {
    props: {
      size: "medium"
    },
    style: {
      width: 48,
      height: 48
    }
  }, {
    props: {
      variant: "extended"
    },
    style: {
      borderRadius: 48 / 2,
      padding: "0 16px",
      width: "auto",
      minHeight: "auto",
      minWidth: 48,
      height: 48
    }
  }, {
    props: {
      variant: "extended",
      size: "small"
    },
    style: {
      width: "auto",
      padding: "0 8px",
      borderRadius: 34 / 2,
      minWidth: 34,
      height: 34
    }
  }, {
    props: {
      variant: "extended",
      size: "medium"
    },
    style: {
      width: "auto",
      padding: "0 16px",
      borderRadius: 40 / 2,
      minWidth: 40,
      height: 40
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }]
})), $e(({
  theme: e
}) => ({
  variants: [...Object.entries(e.palette).filter(Vt(["dark", "contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].contrastText,
      backgroundColor: (e.vars || e).palette[t].main,
      "&:hover": {
        backgroundColor: (e.vars || e).palette[t].dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette[t].main
        }
      }
    }
  }))]
})), $e(({
  theme: e
}) => ({
  [`&.${hg.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    boxShadow: (e.vars || e).shadows[0],
    backgroundColor: (e.vars || e).palette.action.disabledBackground
  }
}))), bf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFab"
  }), {
    children: a,
    className: i,
    color: l = "default",
    component: c = "button",
    disabled: d = !1,
    disableFocusRipple: p = !1,
    focusVisibleClassName: f,
    size: h = "large",
    variant: g = "circular",
    ...y
  } = o, C = {
    ...o,
    color: l,
    component: c,
    disabled: d,
    disableFocusRipple: p,
    size: h,
    variant: g
  }, b = XD(C);
  return /* @__PURE__ */ P.jsx(JD, {
    className: ge(b.root, i),
    component: c,
    disabled: d,
    focusRipple: !p,
    focusVisibleClassName: ge(b.focusVisible, f),
    ownerState: C,
    ref: r,
    ...y,
    classes: b,
    children: a
  });
});
process.env.NODE_ENV !== "production" && (bf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "error", "info", "inherit", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: n.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: n.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "extended"]), n.string])
});
const QD = (e) => {
  const {
    classes: t,
    disableUnderline: r,
    startAdornment: o,
    endAdornment: a,
    size: i,
    hiddenLabel: l,
    multiline: c
  } = e, d = {
    root: ["root", !r && "underline", o && "adornedStart", a && "adornedEnd", i === "small" && `size${re(i)}`, l && "hiddenLabel", c && "multiline"],
    input: ["input"]
  }, p = Me(d, nT, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...p
  };
}, ej = Y(pf, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [...uf(e, t), !r.disableUnderline && t.underline];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light", r = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${Kn.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${Kn.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: l
      }) => !l.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Kn.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Kn.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : r}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Kn.disabled}, .${Kn.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${Kn.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Vt()).map(([l]) => ({
      props: {
        disableUnderline: !1,
        color: l
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[l]?.main}`
        }
      }
    })), {
      props: ({
        ownerState: l
      }) => l.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: l,
        size: c
      }) => l.multiline && c === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel && l.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), tj = Y(ff, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: df
})($e(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), bu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: a = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: c = !1,
    hiddenLabel: d,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: f = !1,
    slotProps: h,
    slots: g = {},
    type: y = "text",
    ...C
  } = o, b = {
    ...o,
    disableUnderline: a,
    fullWidth: c,
    inputComponent: p,
    multiline: f,
    type: y
  }, v = QD(o), T = {
    root: {
      ownerState: b
    },
    input: {
      ownerState: b
    }
  }, R = h ?? l ? sn(T, h ?? l) : T, $ = g.root ?? i.Root ?? ej, E = g.input ?? i.Input ?? tj;
  return /* @__PURE__ */ P.jsx(zl, {
    slots: {
      root: $,
      input: E
    },
    slotProps: R,
    fullWidth: c,
    inputComponent: p,
    multiline: f,
    ref: r,
    type: y,
    ...C,
    classes: v
  });
});
process.env.NODE_ENV !== "production" && (bu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
bu.muiName = "Input";
function cE(e) {
  return Ae("MuiFormControl", e);
}
const rj = Ne("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]), nj = (e) => {
  const {
    classes: t,
    margin: r,
    fullWidth: o
  } = e, a = {
    root: ["root", r !== "none" && `margin${re(r)}`, o && "fullWidth"]
  };
  return Me(a, cE, t);
}, oj = Y("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`margin${re(r.margin)}`], r.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), Xb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFormControl"
  }), {
    children: a,
    className: i,
    color: l = "primary",
    component: c = "div",
    disabled: d = !1,
    error: p = !1,
    focused: f,
    fullWidth: h = !1,
    hiddenLabel: g = !1,
    margin: y = "none",
    required: C = !1,
    size: b = "medium",
    variant: v = "outlined",
    ...T
  } = o, R = {
    ...o,
    color: l,
    component: c,
    disabled: d,
    error: p,
    fullWidth: h,
    hiddenLabel: g,
    margin: y,
    required: C,
    size: b,
    variant: v
  }, $ = nj(R), [E, S] = x.useState(() => {
    let V = !1;
    return a && x.Children.forEach(a, (X) => {
      if (!wa(X, ["Input", "Select"]))
        return;
      const U = wa(X, ["Select"]) ? X.props.input : X;
      U && TL(U.props) && (V = !0);
    }), V;
  }), [k, A] = x.useState(() => {
    let V = !1;
    return a && x.Children.forEach(a, (X) => {
      wa(X, ["Input", "Select"]) && (vp(X.props, !0) || vp(X.props.inputProps, !0)) && (V = !0);
    }), V;
  }), [_, L] = x.useState(!1);
  d && _ && L(!1);
  const O = f !== void 0 && !d ? f : _;
  let F;
  const B = x.useRef(!1);
  process.env.NODE_ENV !== "production" && (F = () => (B.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), B.current = !0, () => {
    B.current = !1;
  }));
  const M = x.useCallback(() => {
    A(!0);
  }, []), j = x.useCallback(() => {
    A(!1);
  }, []), W = x.useMemo(() => ({
    adornedStart: E,
    setAdornedStart: S,
    color: l,
    disabled: d,
    error: p,
    filled: k,
    focused: O,
    fullWidth: h,
    hiddenLabel: g,
    size: b,
    onBlur: () => {
      L(!1);
    },
    onFocus: () => {
      L(!0);
    },
    onEmpty: j,
    onFilled: M,
    registerEffect: F,
    required: C,
    variant: v
  }), [E, l, d, p, k, O, h, g, F, j, M, C, b, v]);
  return /* @__PURE__ */ P.jsx(fu.Provider, {
    value: W,
    children: /* @__PURE__ */ P.jsx(oj, {
      as: c,
      ownerState: R,
      className: ge($.root, i),
      ref: r,
      ...T,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (Xb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: n.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: n.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: n.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: n.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
function uE(e) {
  return Ae("MuiFormControlLabel", e);
}
const ul = Ne("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), aj = (e) => {
  const {
    classes: t,
    disabled: r,
    labelPlacement: o,
    error: a,
    required: i
  } = e, l = {
    root: ["root", r && "disabled", `labelPlacement${re(o)}`, a && "error", i && "required"],
    label: ["label", r && "disabled"],
    asterisk: ["asterisk", a && "error"]
  };
  return Me(l, uE, t);
}, ij = Y("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ul.label}`]: t.label
    }, t.root, t[`labelPlacement${re(r.labelPlacement)}`]];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${ul.disabled}`]: {
    cursor: "default"
  },
  [`& .${ul.label}`]: {
    [`&.${ul.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), sj = Y("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})($e(({
  theme: e
}) => ({
  [`&.${ul.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), dE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: a,
    className: i,
    componentsProps: l = {},
    control: c,
    disabled: d,
    disableTypography: p,
    inputRef: f,
    label: h,
    labelPlacement: g = "end",
    name: y,
    onChange: C,
    required: b,
    slots: v = {},
    slotProps: T = {},
    value: R,
    ...$
  } = o, E = ko(), S = d ?? c.props.disabled ?? E?.disabled, k = b ?? c.props.required, A = {
    disabled: S,
    required: k
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((W) => {
    typeof c.props[W] > "u" && typeof o[W] < "u" && (A[W] = o[W]);
  });
  const _ = si({
    props: o,
    muiFormControl: E,
    states: ["error"]
  }), L = {
    ...o,
    disabled: S,
    labelPlacement: g,
    required: k,
    error: _.error
  }, O = aj(L), F = {
    slots: v,
    slotProps: {
      ...l,
      ...T
    }
  }, [B, M] = ze("typography", {
    elementType: pn,
    externalForwardedProps: F,
    ownerState: L
  });
  let j = h;
  return j != null && j.type !== pn && !p && (j = /* @__PURE__ */ P.jsx(B, {
    component: "span",
    ...M,
    className: ge(O.label, M?.className),
    children: j
  })), /* @__PURE__ */ P.jsxs(ij, {
    className: ge(O.root, i),
    ownerState: L,
    ref: r,
    ...$,
    children: [/* @__PURE__ */ x.cloneElement(c, A), k ? /* @__PURE__ */ P.jsxs("div", {
      children: [j, /* @__PURE__ */ P.jsxs(sj, {
        ownerState: L,
        "aria-hidden": !0,
        className: O.asterisk,
        children: [" ", "*"]
      })]
    }) : j]
  });
});
process.env.NODE_ENV !== "production" && (dE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: n.shape({
    typography: n.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: n.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: n.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: n.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: n.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: n.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    typography: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    typography: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component.
   */
  value: n.any
});
function pE(e) {
  return Ae("MuiFormGroup", e);
}
const lj = Ne("MuiFormGroup", ["root", "row", "error"]), cj = (e) => {
  const {
    classes: t,
    row: r,
    error: o
  } = e;
  return Me({
    root: ["root", r && "row", o && "error"]
  }, pE, t);
}, uj = Y("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.row && t.row];
  }
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), Jb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: a,
    row: i = !1,
    ...l
  } = o, c = ko(), d = si({
    props: o,
    muiFormControl: c,
    states: ["error"]
  }), p = {
    ...o,
    row: i,
    error: d.error
  }, f = cj(p);
  return /* @__PURE__ */ P.jsx(uj, {
    className: ge(f.root, a),
    ownerState: p,
    ref: r,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Jb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function fE(e) {
  return Ae("MuiFormHelperText", e);
}
const Kc = Ne("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var vC;
const dj = (e) => {
  const {
    classes: t,
    contained: r,
    size: o,
    disabled: a,
    error: i,
    filled: l,
    focused: c,
    required: d
  } = e, p = {
    root: ["root", a && "disabled", i && "error", o && `size${re(o)}`, r && "contained", c && "focused", l && "filled", d && "required"]
  };
  return Me(p, fE, t);
}, pj = Y("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.size && t[`size${re(r.size)}`], r.contained && t.contained, r.filled && t.filled];
  }
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${Kc.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Kc.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), yf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: a,
    className: i,
    component: l = "p",
    disabled: c,
    error: d,
    filled: p,
    focused: f,
    margin: h,
    required: g,
    variant: y,
    ...C
  } = o, b = ko(), v = si({
    props: o,
    muiFormControl: b,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), T = {
    ...o,
    component: l,
    contained: v.variant === "filled" || v.variant === "outlined",
    variant: v.variant,
    size: v.size,
    disabled: v.disabled,
    error: v.error,
    filled: v.filled,
    focused: v.focused,
    required: v.required
  };
  delete T.ownerState;
  const R = dj(T);
  return /* @__PURE__ */ P.jsx(pj, {
    as: l,
    className: ge(R.root, i),
    ref: r,
    ...C,
    ownerState: T,
    children: a === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      vC || (vC = /* @__PURE__ */ P.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : a
  });
});
process.env.NODE_ENV !== "production" && (yf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: n.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: n.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: n.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: n.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined", "standard"]), n.string])
});
function mE(e) {
  return Ae("MuiFormLabel", e);
}
const ys = Ne("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), fj = (e) => {
  const {
    classes: t,
    color: r,
    focused: o,
    disabled: a,
    error: i,
    filled: l,
    required: c
  } = e, d = {
    root: ["root", `color${re(r)}`, a && "disabled", i && "error", l && "filled", o && "focused", c && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return Me(d, mE, t);
}, hE = Y("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color === "secondary" && t.colorSecondary, r.filled && t.filled];
  }
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${ys.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${ys.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${ys.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), mj = Y("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})($e(({
  theme: e
}) => ({
  [`&.${ys.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), Qb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: a,
    className: i,
    color: l,
    component: c = "label",
    disabled: d,
    error: p,
    filled: f,
    focused: h,
    required: g,
    ...y
  } = o, C = ko(), b = si({
    props: o,
    muiFormControl: C,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), v = {
    ...o,
    color: b.color || "primary",
    component: c,
    disabled: b.disabled,
    error: b.error,
    filled: b.filled,
    focused: b.focused,
    required: b.required
  }, T = fj(v);
  return /* @__PURE__ */ P.jsxs(hE, {
    as: c,
    ownerState: v,
    className: ge(T.root, i),
    ref: r,
    ...y,
    children: [a, b.required && /* @__PURE__ */ P.jsxs(mj, {
      ownerState: v,
      "aria-hidden": !0,
      className: T.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Qb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: n.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: n.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const gg = /* @__PURE__ */ x.createContext();
process.env.NODE_ENV !== "production" && (gg.displayName = "GridContext");
function hj(e) {
  return Ae("MuiGrid", e);
}
const gj = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], bj = ["column-reverse", "column", "row-reverse", "row"], yj = ["nowrap", "wrap-reverse", "wrap"], dc = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Yc = Ne("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...gj.map((e) => `spacing-xs-${e}`),
  // direction values
  ...bj.map((e) => `direction-xs-${e}`),
  // wrap values
  ...yj.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...dc.map((e) => `grid-xs-${e}`),
  ...dc.map((e) => `grid-sm-${e}`),
  ...dc.map((e) => `grid-md-${e}`),
  ...dc.map((e) => `grid-lg-${e}`),
  ...dc.map((e) => `grid-xl-${e}`)
]);
function vj({
  theme: e,
  ownerState: t
}) {
  let r;
  return e.breakpoints.keys.reduce((o, a) => {
    let i = {};
    if (t[a] && (r = t[a]), !r)
      return o;
    if (r === !0)
      i = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (r === "auto")
      i = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const l = hs({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), c = typeof l == "object" ? l[a] : l;
      if (c == null)
        return o;
      const d = `${Math.round(r / c * 1e8) / 1e6}%`;
      let p = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const f = e.spacing(t.columnSpacing);
        if (f !== "0px") {
          const h = `calc(${d} + ${f})`;
          p = {
            flexBasis: h,
            maxWidth: h
          };
        }
      }
      i = {
        flexBasis: d,
        flexGrow: 0,
        maxWidth: d,
        ...p
      };
    }
    return e.breakpoints.values[a] === 0 ? Object.assign(o, i) : o[e.breakpoints.up(a)] = i, o;
  }, {});
}
function xj({
  theme: e,
  ownerState: t
}) {
  const r = hs({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return Qn({
    theme: e
  }, r, (o) => {
    const a = {
      flexDirection: o
    };
    return o.startsWith("column") && (a[`& > .${Yc.item}`] = {
      maxWidth: "none"
    }), a;
  });
}
function gE({
  breakpoints: e,
  values: t
}) {
  let r = "";
  Object.keys(t).forEach((a) => {
    r === "" && t[a] !== 0 && (r = a);
  });
  const o = Object.keys(e).sort((a, i) => e[a] - e[i]);
  return o.slice(0, o.indexOf(r));
}
function Cj({
  theme: e,
  ownerState: t
}) {
  const {
    container: r,
    rowSpacing: o
  } = t;
  let a = {};
  if (r && o !== 0) {
    const i = hs({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let l;
    typeof i == "object" && (l = gE({
      breakpoints: e.breakpoints.values,
      values: i
    })), a = Qn({
      theme: e
    }, i, (c, d) => {
      const p = e.spacing(c);
      return p !== "0px" ? {
        marginTop: `calc(-1 * ${p})`,
        [`& > .${Yc.item}`]: {
          paddingTop: p
        }
      } : l?.includes(d) ? {} : {
        marginTop: 0,
        [`& > .${Yc.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return a;
}
function Sj({
  theme: e,
  ownerState: t
}) {
  const {
    container: r,
    columnSpacing: o
  } = t;
  let a = {};
  if (r && o !== 0) {
    const i = hs({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let l;
    typeof i == "object" && (l = gE({
      breakpoints: e.breakpoints.values,
      values: i
    })), a = Qn({
      theme: e
    }, i, (c, d) => {
      const p = e.spacing(c);
      if (p !== "0px") {
        const f = `calc(-1 * ${p})`;
        return {
          width: `calc(100% + ${p})`,
          marginLeft: f,
          [`& > .${Yc.item}`]: {
            paddingLeft: p
          }
        };
      }
      return l?.includes(d) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Yc.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return a;
}
function wj(e, t, r = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [r[`spacing-xs-${String(e)}`]];
  const o = [];
  return t.forEach((a) => {
    const i = e[a];
    Number(i) > 0 && o.push(r[`spacing-${a}-${String(i)}`]);
  }), o;
}
const Tj = Y("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      container: o,
      direction: a,
      item: i,
      spacing: l,
      wrap: c,
      zeroMinWidth: d,
      breakpoints: p
    } = r;
    let f = [];
    o && (f = wj(l, p, t));
    const h = [];
    return p.forEach((g) => {
      const y = r[g];
      y && h.push(t[`grid-${g}-${String(y)}`]);
    }), [t.root, o && t.container, i && t.item, d && t.zeroMinWidth, ...f, a !== "row" && t[`direction-xs-${String(a)}`], c !== "wrap" && t[`wrap-xs-${String(c)}`], ...h];
  }
})(
  // FIXME(romgrk): Can't use memoTheme here
  ({
    ownerState: e
  }) => ({
    boxSizing: "border-box",
    ...e.container && {
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    ...e.item && {
      margin: 0
      // For instance, it's useful when used with a `figure` element.
    },
    ...e.zeroMinWidth && {
      minWidth: 0
    },
    ...e.wrap !== "wrap" && {
      flexWrap: e.wrap
    }
  }),
  xj,
  Cj,
  Sj,
  vj
);
function Ej(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const r = [];
  return t.forEach((o) => {
    const a = e[o];
    if (Number(a) > 0) {
      const i = `spacing-${o}-${String(a)}`;
      r.push(i);
    }
  }), r;
}
const Oj = (e) => {
  const {
    classes: t,
    container: r,
    direction: o,
    item: a,
    spacing: i,
    wrap: l,
    zeroMinWidth: c,
    breakpoints: d
  } = e;
  let p = [];
  r && (p = Ej(i, d));
  const f = [];
  d.forEach((g) => {
    const y = e[g];
    y && f.push(`grid-${g}-${String(y)}`);
  });
  const h = {
    root: ["root", r && "container", a && "item", c && "zeroMinWidth", ...p, o !== "row" && `direction-xs-${String(o)}`, l !== "wrap" && `wrap-xs-${String(l)}`, ...f]
  };
  return Me(h, hj, t);
}, Gn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: a
  } = Yr(), i = lu(o), {
    className: l,
    columns: c,
    columnSpacing: d,
    component: p = "div",
    container: f = !1,
    direction: h = "row",
    item: g = !1,
    rowSpacing: y,
    spacing: C = 0,
    wrap: b = "wrap",
    zeroMinWidth: v = !1,
    ...T
  } = i, R = y || C, $ = d || C, E = x.useContext(gg), S = f ? c || 12 : E, k = {}, A = {
    ...T
  };
  a.keys.forEach((O) => {
    T[O] != null && (k[O] = T[O], delete A[O]);
  });
  const _ = {
    ...i,
    columns: S,
    container: f,
    direction: h,
    item: g,
    rowSpacing: R,
    columnSpacing: $,
    wrap: b,
    zeroMinWidth: v,
    spacing: C,
    ...k,
    breakpoints: a.keys
  }, L = Oj(_);
  return /* @__PURE__ */ P.jsx(gg.Provider, {
    value: S,
    children: /* @__PURE__ */ P.jsx(Tj, {
      ownerState: _,
      className: ge(L.root, l),
      as: p,
      ref: r,
      ...A
    })
  });
});
process.env.NODE_ENV !== "production" && (Gn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: n.oneOfType([n.arrayOf(n.number), n.number, n.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: n.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: n.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: n.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: n.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = gb("Grid", Gn);
  Gn.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...Gn.propTypes,
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  };
}
const ey = FN({
  createStyledComponent: Y("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: r
      } = e;
      return [t.root, r.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => Fe({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: Yr
});
process.env.NODE_ENV !== "production" && (ey.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: n.oneOfType([n.arrayOf(n.number), n.number, n.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: n.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: n.oneOfType([n.string, n.number, n.arrayOf(n.oneOfType([n.string, n.number])), n.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: n.oneOfType([n.string, n.bool, n.number, n.arrayOf(n.oneOfType([n.string, n.bool, n.number])), n.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * @ignore
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: n.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: n.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const e = ey, t = gb("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function $j(e) {
  return Ae("MuiGrid2", e);
}
const Rj = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Pj = ["column-reverse", "column", "row-reverse", "row"], kj = ["nowrap", "wrap-reverse", "wrap"], pc = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Aj = Ne("MuiGrid2", [
  "root",
  "container",
  // spacings
  ...Rj.map((e) => `spacing-xs-${e}`),
  // direction values
  ...Pj.map((e) => `direction-xs-${e}`),
  // wrap values
  ...kj.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...pc.map((e) => `grid-xs-${e}`),
  ...pc.map((e) => `grid-sm-${e}`),
  ...pc.map((e) => `grid-md-${e}`),
  ...pc.map((e) => `grid-lg-${e}`),
  ...pc.map((e) => `grid-xl-${e}`)
]);
function bg(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Ij = {
  entering: {
    opacity: 1,
    transform: bg(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, dh = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), $s = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    addEndListener: o,
    appear: a = !0,
    children: i,
    easing: l,
    in: c,
    onEnter: d,
    onEntered: p,
    onEntering: f,
    onExit: h,
    onExited: g,
    onExiting: y,
    style: C,
    timeout: b = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = Po,
    ...T
  } = t, R = Ja(), $ = x.useRef(), E = Yr(), S = x.useRef(null), k = Jt(S, ii(i), r), A = (W) => (V) => {
    if (W) {
      const X = S.current;
      V === void 0 ? W(X) : W(X, V);
    }
  }, _ = A(f), L = A((W, V) => {
    of(W);
    const {
      duration: X,
      delay: U,
      easing: H
    } = aa({
      style: C,
      timeout: b,
      easing: l
    }, {
      mode: "enter"
    });
    let Z;
    b === "auto" ? (Z = E.transitions.getAutoHeightDuration(W.clientHeight), $.current = Z) : Z = X, W.style.transition = [E.transitions.create("opacity", {
      duration: Z,
      delay: U
    }), E.transitions.create("transform", {
      duration: dh ? Z : Z * 0.666,
      delay: U,
      easing: H
    })].join(","), d && d(W, V);
  }), O = A(p), F = A(y), B = A((W) => {
    const {
      duration: V,
      delay: X,
      easing: U
    } = aa({
      style: C,
      timeout: b,
      easing: l
    }, {
      mode: "exit"
    });
    let H;
    b === "auto" ? (H = E.transitions.getAutoHeightDuration(W.clientHeight), $.current = H) : H = V, W.style.transition = [E.transitions.create("opacity", {
      duration: H,
      delay: X
    }), E.transitions.create("transform", {
      duration: dh ? H : H * 0.666,
      delay: dh ? X : X || H * 0.333,
      easing: U
    })].join(","), W.style.opacity = 0, W.style.transform = bg(0.75), h && h(W);
  }), M = A(g), j = (W) => {
    b === "auto" && R.start($.current || 0, W), o && o(S.current, W);
  };
  return /* @__PURE__ */ P.jsx(v, {
    appear: a,
    in: c,
    nodeRef: S,
    onEnter: L,
    onEntered: O,
    onEntering: _,
    onExit: B,
    onExited: M,
    onExiting: F,
    addEndListener: j,
    timeout: b === "auto" ? null : b,
    ...T,
    children: (W, {
      ownerState: V,
      ...X
    }) => /* @__PURE__ */ x.cloneElement(i, {
      style: {
        opacity: 0,
        transform: bg(0.75),
        visibility: W === "exited" && !c ? "hidden" : void 0,
        ...Ij[W],
        ...C,
        ...i.props.style
      },
      ref: k,
      ...X
    })
  });
});
process.env.NODE_ENV !== "production" && ($s.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: ai.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
$s && ($s.muiSupportAuto = !0);
const bE = B2({
  themeId: wo
}), Ri = ["xs", "sm", "md", "lg", "xl"], Nj = (e, t, r = !0) => r ? Ri.indexOf(e) <= Ri.indexOf(t) : Ri.indexOf(e) < Ri.indexOf(t), Mj = (e, t, r = !1) => r ? Ri.indexOf(t) <= Ri.indexOf(e) : Ri.indexOf(t) < Ri.indexOf(e), _j = (e = {}) => (t) => {
  const {
    withTheme: r = !1,
    noSSR: o = !1,
    initialWidth: a
  } = e;
  function i(l) {
    const c = Yr(), d = l.theme || c, {
      initialWidth: p,
      width: f,
      ...h
    } = fb({
      theme: d,
      name: "MuiWithWidth",
      props: l
    }), [g, y] = x.useState(!1);
    en(() => {
      y(!0);
    }, []);
    const b = d.breakpoints.keys.slice().reverse().reduce((T, R) => {
      const $ = bE(d.breakpoints.up(R));
      return !T && $ ? R : T;
    }, null), v = {
      width: f || (g || o ? b : void 0) || p || a,
      ...r ? {
        theme: d
      } : {},
      ...h
    };
    return v.width === void 0 ? null : /* @__PURE__ */ P.jsx(t, {
      ...v
    });
  }
  return process.env.NODE_ENV !== "production" && (i.propTypes = {
    /**
     * As `window.innerWidth` is unavailable on the server,
     * we default to rendering an empty component during the first mount.
     * You might want to use a heuristic to approximate
     * the screen width of the client browser screen width.
     *
     * For instance, you could be using the user-agent or the client-hints.
     * https://caniuse.com/#search=client%20hint
     */
    initialWidth: n.oneOf(["xs", "sm", "md", "lg", "xl"]),
    /**
     * @ignore
     */
    theme: n.object,
    /**
     * Bypass the width calculation logic.
     */
    width: n.oneOf(["xs", "sm", "md", "lg", "xl"])
  }), process.env.NODE_ENV !== "production" && (i.displayName = `WithWidth(${I2(t)})`), i;
};
function xp(e) {
  const {
    children: t,
    only: r,
    width: o
  } = e, a = Yr();
  let i = !0;
  if (r)
    if (Array.isArray(r))
      for (let l = 0; l < r.length; l += 1) {
        const c = r[l];
        if (o === c) {
          i = !1;
          break;
        }
      }
    else r && o === r && (i = !1);
  if (i)
    for (let l = 0; l < a.breakpoints.keys.length; l += 1) {
      const c = a.breakpoints.keys[l], d = e[`${c}Up`], p = e[`${c}Down`];
      if (d && Nj(c, o) || p && Mj(c, o)) {
        i = !1;
        break;
      }
    }
  return i ? t : null;
}
xp.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smUp: n.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: n.string.isRequired,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsUp: n.bool
};
process.env.NODE_ENV !== "production" && (xp.propTypes = ks(xp.propTypes));
const Fj = _j()(xp);
function Lj(e) {
  return Ae("PrivateHiddenCss", e);
}
Ne("PrivateHiddenCss", ["root", "xlDown", "xlUp", "onlyXl", "lgDown", "lgUp", "onlyLg", "mdDown", "mdUp", "onlyMd", "smDown", "smUp", "onlySm", "xsDown", "xsUp", "onlyXs"]);
const Bj = (e) => {
  const {
    classes: t,
    breakpoints: r
  } = e, o = {
    root: ["root", ...r.map(({
      breakpoint: a,
      dir: i
    }) => i === "only" ? `${i}${re(a)}` : `${a}${re(i)}`)]
  };
  return Me(o, Lj, t);
}, Dj = Y("div", {
  name: "PrivateHiddenCss",
  slot: "Root"
})(({
  theme: e,
  ownerState: t
}) => {
  const r = {
    display: "none"
  };
  return {
    ...t.breakpoints.map(({
      breakpoint: o,
      dir: a
    }) => a === "only" ? {
      [e.breakpoints.only(o)]: r
    } : a === "up" ? {
      [e.breakpoints.up(o)]: r
    } : {
      [e.breakpoints.down(o)]: r
    }).reduce((o, a) => (Object.keys(a).forEach((i) => {
      o[i] = a[i];
    }), o), {})
  };
});
function yE(e) {
  const {
    children: t,
    className: r,
    only: o,
    ...a
  } = e, i = Yr();
  if (process.env.NODE_ENV !== "production") {
    const p = Object.keys(a).filter((f) => {
      const h = !i.breakpoints.keys.some((g) => `${g}Up` === f || `${g}Down` === f);
      return !["classes", "theme", "isRtl", "sx"].includes(f) && h;
    });
    p.length > 0 && console.error(`MUI: Unsupported props received by \`<Hidden implementation="css" />\`: ${p.join(", ")}. Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?`);
  }
  const l = [];
  for (let p = 0; p < i.breakpoints.keys.length; p += 1) {
    const f = i.breakpoints.keys[p], h = a[`${f}Up`], g = a[`${f}Down`];
    h && l.push({
      breakpoint: f,
      dir: "up"
    }), g && l.push({
      breakpoint: f,
      dir: "down"
    });
  }
  o && (Array.isArray(o) ? o : [o]).forEach((f) => {
    l.push({
      breakpoint: f,
      dir: "only"
    });
  });
  const c = {
    ...e,
    breakpoints: l
  }, d = Bj(c);
  return /* @__PURE__ */ P.jsx(Dj, {
    className: ge(d.root, r),
    ownerState: c,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (yE.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: n.oneOf(["js", "css"]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  lgDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  lgUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  mdDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  smDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  smUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xlDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xlUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xsDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xsUp: n.bool
});
function vE(e) {
  const {
    implementation: t = "js",
    lgDown: r = !1,
    lgUp: o = !1,
    mdDown: a = !1,
    mdUp: i = !1,
    smDown: l = !1,
    smUp: c = !1,
    xlDown: d = !1,
    xlUp: p = !1,
    xsDown: f = !1,
    xsUp: h = !1,
    ...g
  } = e;
  return t === "js" ? /* @__PURE__ */ P.jsx(Fj, {
    lgDown: r,
    lgUp: o,
    mdDown: a,
    mdUp: i,
    smDown: l,
    smUp: c,
    xlDown: d,
    xlUp: p,
    xsDown: f,
    xsUp: h,
    ...g
  }) : /* @__PURE__ */ P.jsx(yE, {
    lgDown: r,
    lgUp: o,
    mdDown: a,
    mdUp: i,
    smDown: l,
    smUp: c,
    xlDown: d,
    xlUp: p,
    xsDown: f,
    xsUp: h,
    ...g
  });
}
process.env.NODE_ENV !== "production" && (vE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   * @default 'js'
   */
  implementation: n.oneOf(["css", "js"]),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use a heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: n.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  lgDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  lgUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  mdDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]).isRequired)]),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  smDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  smUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xlDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xlUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xsDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xsUp: n.bool
});
function xE(e) {
  return Ae("MuiIcon", e);
}
const jj = Ne("MuiIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]), zj = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: o
  } = e, a = {
    root: ["root", t !== "inherit" && `color${re(t)}`, `fontSize${re(r)}`]
  };
  return Me(a, xE, o);
}, Vj = Y("span", {
  name: "MuiIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${re(r.color)}`], t[`fontSize${re(r.fontSize)}`]];
  }
})($e(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  // Chrome fix for https://issues.chromium.org/issues/41375697
  // To remove at some point.
  overflow: "hidden",
  display: "inline-block",
  // allow overflow hidden to take action
  textAlign: "center",
  // support non-square icon
  flexShrink: 0,
  variants: [{
    props: {
      fontSize: "inherit"
    },
    style: {
      fontSize: "inherit"
    }
  }, {
    props: {
      fontSize: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(20)
    }
  }, {
    props: {
      fontSize: "medium"
    },
    style: {
      fontSize: e.typography.pxToRem(24)
    }
  }, {
    props: {
      fontSize: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(36)
    }
  }, {
    props: {
      color: "action"
    },
    style: {
      color: (e.vars || e).palette.action.active
    }
  }, {
    props: {
      color: "disabled"
    },
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: void 0
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), ty = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiIcon"
  }), {
    baseClassName: a = "material-icons",
    className: i,
    color: l = "inherit",
    component: c = "span",
    fontSize: d = "medium",
    ...p
  } = o, f = {
    ...o,
    baseClassName: a,
    color: l,
    component: c,
    fontSize: d
  }, h = zj(f);
  return /* @__PURE__ */ P.jsx(Vj, {
    as: c,
    className: ge(
      a,
      // Prevent the translation of the text content.
      // The font relies on the exact text content to render the icon.
      "notranslate",
      h.root,
      i
    ),
    ownerState: f,
    "aria-hidden": !0,
    ref: r,
    ...p
  });
});
process.env.NODE_ENV !== "production" && (ty.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: n.string,
  /**
   * The name of the icon font ligature.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */
  color: n.oneOfType([n.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: n.oneOfType([n.oneOf(["inherit", "large", "medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
ty.muiName = "Icon";
function CE(e) {
  return Ae("MuiImageList", e);
}
const Wj = Ne("MuiImageList", ["root", "masonry", "quilted", "standard", "woven"]), ry = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (ry.displayName = "ImageListContext");
const Uj = (e) => {
  const {
    classes: t,
    variant: r
  } = e;
  return Me({
    root: ["root", r]
  }, CE, t);
}, Hj = Y("ul", {
  name: "MuiImageList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant]];
  }
})({
  display: "grid",
  overflowY: "auto",
  listStyle: "none",
  padding: 0,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  variants: [{
    props: {
      variant: "masonry"
    },
    style: {
      display: "block"
    }
  }]
}), SE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiImageList"
  }), {
    children: a,
    className: i,
    cols: l = 2,
    component: c = "ul",
    rowHeight: d = "auto",
    gap: p = 4,
    style: f,
    variant: h = "standard",
    ...g
  } = o, y = x.useMemo(() => ({
    rowHeight: d,
    gap: p,
    variant: h
  }), [d, p, h]), C = h === "masonry" ? {
    columnCount: l,
    columnGap: p,
    ...f
  } : {
    gridTemplateColumns: `repeat(${l}, 1fr)`,
    gap: p,
    ...f
  }, b = {
    ...o,
    component: c,
    gap: p,
    rowHeight: d,
    variant: h
  }, v = Uj(b);
  return /* @__PURE__ */ P.jsx(Hj, {
    as: c,
    className: ge(v.root, v[h], i),
    ref: r,
    style: C,
    ownerState: b,
    ...g,
    children: /* @__PURE__ */ P.jsx(ry.Provider, {
      value: y,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (SE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `ImageListItem`s.
   */
  children: n.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Number of columns.
   * @default 2
   */
  cols: Vr,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The gap between items in px.
   * @default 4
   */
  gap: n.number,
  /**
   * The height of one row in px.
   * @default 'auto'
   */
  rowHeight: n.oneOfType([n.oneOf(["auto"]), n.number]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["masonry", "quilted", "standard", "woven"]), n.string])
});
function wE(e) {
  return Ae("MuiImageListItem", e);
}
const Xd = Ne("MuiImageListItem", ["root", "img", "standard", "woven", "masonry", "quilted"]), Gj = (e) => {
  const {
    classes: t,
    variant: r
  } = e;
  return Me({
    root: ["root", r],
    img: ["img"]
  }, wE, t);
}, qj = Y("li", {
  name: "MuiImageListItem",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${Xd.img}`]: t.img
    }, t.root, t[r.variant]];
  }
})({
  display: "block",
  position: "relative",
  [`& .${Xd.img}`]: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    display: "block"
  },
  variants: [{
    props: {
      variant: "standard"
    },
    style: {
      // For titlebar under list item
      display: "flex",
      flexDirection: "column"
    }
  }, {
    props: {
      variant: "woven"
    },
    style: {
      height: "100%",
      alignSelf: "center",
      "&:nth-of-type(even)": {
        height: "70%"
      }
    }
  }, {
    props: {
      variant: "standard"
    },
    style: {
      [`& .${Xd.img}`]: {
        height: "auto",
        flexGrow: 1
      }
    }
  }]
}), TE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiImageListItem"
  }), {
    children: a,
    className: i,
    cols: l = 1,
    component: c = "li",
    rows: d = 1,
    style: p,
    ...f
  } = o, {
    rowHeight: h = "auto",
    gap: g,
    variant: y
  } = x.useContext(ry);
  let C = "auto";
  y === "woven" ? C = void 0 : h !== "auto" && (C = h * d + g * (d - 1));
  const b = {
    ...o,
    cols: l,
    component: c,
    gap: g,
    rowHeight: h,
    rows: d,
    variant: y
  }, v = Gj(b);
  return /* @__PURE__ */ P.jsx(qj, {
    as: c,
    className: ge(v.root, v[y], i),
    ref: r,
    style: {
      height: C,
      gridColumnEnd: y !== "masonry" ? `span ${l}` : void 0,
      gridRowEnd: y !== "masonry" ? `span ${d}` : void 0,
      marginBottom: y === "masonry" ? g : void 0,
      breakInside: y === "masonry" ? "avoid" : void 0,
      ...p
    },
    ownerState: b,
    ...f,
    children: x.Children.map(a, (T) => /* @__PURE__ */ x.isValidElement(T) ? (process.env.NODE_ENV !== "production" && zn.isFragment(T) && console.error(["MUI: The ImageListItem component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), T.type === "img" || wa(T, ["Image"]) ? /* @__PURE__ */ x.cloneElement(T, {
      className: ge(v.img, T.props.className)
    }) : T) : null)
  });
});
process.env.NODE_ENV !== "production" && (TE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `<img>`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Width of the item in number of grid columns.
   * @default 1
   */
  cols: Vr,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Height of the item in number of grid rows.
   * @default 1
   */
  rows: Vr,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function EE(e) {
  return Ae("MuiImageListItemBar", e);
}
const Kj = Ne("MuiImageListItemBar", ["root", "positionBottom", "positionTop", "positionBelow", "actionPositionLeft", "actionPositionRight", "titleWrap", "titleWrapBottom", "titleWrapTop", "titleWrapBelow", "titleWrapActionPosLeft", "titleWrapActionPosRight", "title", "subtitle", "actionIcon", "actionIconActionPosLeft", "actionIconActionPosRight"]), Yj = (e) => {
  const {
    classes: t,
    position: r,
    actionIcon: o,
    actionPosition: a
  } = e, i = {
    root: ["root", `position${re(r)}`, `actionPosition${re(a)}`],
    titleWrap: ["titleWrap", `titleWrap${re(r)}`, o && `titleWrapActionPos${re(a)}`],
    title: ["title"],
    subtitle: ["subtitle"],
    actionIcon: ["actionIcon", `actionIconActionPos${re(a)}`]
  };
  return Me(i, EE, t);
}, Zj = Y("div", {
  name: "MuiImageListItemBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`position${re(r.position)}`]];
  }
})($e(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  right: 0,
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  fontFamily: e.typography.fontFamily,
  variants: [{
    props: {
      position: "bottom"
    },
    style: {
      bottom: 0
    }
  }, {
    props: {
      position: "top"
    },
    style: {
      top: 0
    }
  }, {
    props: {
      position: "below"
    },
    style: {
      position: "relative",
      background: "transparent",
      alignItems: "normal"
    }
  }]
}))), Xj = Y("div", {
  name: "MuiImageListItemBar",
  slot: "TitleWrap",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.titleWrap, t[`titleWrap${re(r.position)}`], r.actionIcon && t[`titleWrapActionPos${re(r.actionPosition)}`]];
  }
})($e(({
  theme: e
}) => ({
  flexGrow: 1,
  padding: "12px 16px",
  color: (e.vars || e).palette.common.white,
  overflow: "hidden",
  variants: [{
    props: {
      position: "below"
    },
    style: {
      padding: "6px 0 12px",
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.actionIcon && t.actionPosition === "left",
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.actionIcon && t.actionPosition === "right",
    style: {
      paddingRight: 0
    }
  }]
}))), Jj = Y("div", {
  name: "MuiImageListItemBar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})($e(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(16),
  lineHeight: "24px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
}))), Qj = Y("div", {
  name: "MuiImageListItemBar",
  slot: "Subtitle",
  overridesResolver: (e, t) => t.subtitle
})($e(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(12),
  lineHeight: 1,
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
}))), ez = Y("div", {
  name: "MuiImageListItemBar",
  slot: "ActionIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.actionIcon, t[`actionIconActionPos${re(r.actionPosition)}`]];
  }
})({
  variants: [{
    props: {
      actionPosition: "left"
    },
    style: {
      order: -1
    }
  }]
}), OE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiImageListItemBar"
  }), {
    actionIcon: a,
    actionPosition: i = "right",
    className: l,
    subtitle: c,
    title: d,
    position: p = "bottom",
    ...f
  } = o, h = {
    ...o,
    position: p,
    actionPosition: i
  }, g = Yj(h);
  return /* @__PURE__ */ P.jsxs(Zj, {
    ownerState: h,
    className: ge(g.root, l),
    ref: r,
    ...f,
    children: [/* @__PURE__ */ P.jsxs(Xj, {
      ownerState: h,
      className: g.titleWrap,
      children: [/* @__PURE__ */ P.jsx(Jj, {
        className: g.title,
        children: d
      }), c ? /* @__PURE__ */ P.jsx(Qj, {
        className: g.subtitle,
        children: c
      }) : null]
    }), a ? /* @__PURE__ */ P.jsx(ez, {
      ownerState: h,
      className: g.actionIcon,
      children: a
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (OE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the item itself).
   */
  actionIcon: n.node,
  /**
   * Position of secondary action IconButton.
   * @default 'right'
   */
  actionPosition: n.oneOf(["left", "right"]),
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Position of the title bar.
   * @default 'bottom'
   */
  position: n.oneOf(["below", "bottom", "top"]),
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Title to be displayed.
   */
  title: n.node
});
const tz = (e) => {
  const {
    classes: t,
    disableUnderline: r
  } = e, a = Me({
    root: ["root", !r && "underline"],
    input: ["input"]
  }, tT, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...a
  };
}, rz = Y(pf, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [...uf(e, t), !r.disableUnderline && t.underline];
  }
})($e(({
  theme: e
}) => {
  let r = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (r = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: o
      }) => o.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => !o.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Xa.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Xa.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${r}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Xa.disabled}, .${Xa.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${r}`
          }
        },
        [`&.${Xa.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Vt()).map(([o]) => ({
      props: {
        color: o,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[o].main}`
        }
      }
    }))]
  };
})), nz = Y(ff, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: df
})({}), Vl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: a = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: c = !1,
    inputComponent: d = "input",
    multiline: p = !1,
    slotProps: f,
    slots: h = {},
    type: g = "text",
    ...y
  } = o, C = tz(o), v = {
    root: {
      ownerState: {
        disableUnderline: a
      }
    }
  }, T = f ?? l ? sn(f ?? l, v) : v, R = h.root ?? i.Root ?? rz, $ = h.input ?? i.Input ?? nz;
  return /* @__PURE__ */ P.jsx(zl, {
    slots: {
      root: R,
      input: $
    },
    slotProps: T,
    fullWidth: c,
    inputComponent: d,
    multiline: p,
    ref: r,
    type: g,
    ...y,
    classes: C
  });
});
process.env.NODE_ENV !== "production" && (Vl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
Vl.muiName = "Input";
function $E(e) {
  return Ae("MuiInputAdornment", e);
}
const yg = Ne("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var xC;
const oz = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, t[`position${re(r.position)}`], r.disablePointerEvents === !0 && t.disablePointerEvents, t[r.variant]];
}, az = (e) => {
  const {
    classes: t,
    disablePointerEvents: r,
    hiddenLabel: o,
    position: a,
    size: i,
    variant: l
  } = e, c = {
    root: ["root", r && "disablePointerEvents", a && `position${re(a)}`, l, o && "hiddenLabel", i && `size${re(i)}`]
  };
  return Me(c, $E, t);
}, iz = Y("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: oz
})($e(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${yg.positionStart}&:not(.${yg.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), RE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: a,
    className: i,
    component: l = "div",
    disablePointerEvents: c = !1,
    disableTypography: d = !1,
    position: p,
    variant: f,
    ...h
  } = o, g = ko() || {};
  let y = f;
  f && g.variant && process.env.NODE_ENV !== "production" && f === g.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g && !y && (y = g.variant);
  const C = {
    ...o,
    hiddenLabel: g.hiddenLabel,
    size: g.size,
    disablePointerEvents: c,
    position: p,
    variant: y
  }, b = az(C);
  return /* @__PURE__ */ P.jsx(fu.Provider, {
    value: null,
    children: /* @__PURE__ */ P.jsx(iz, {
      as: l,
      ownerState: C,
      className: ge(b.root, i),
      ref: r,
      ...h,
      children: typeof a == "string" && !d ? /* @__PURE__ */ P.jsx(pn, {
        color: "textSecondary",
        children: a
      }) : /* @__PURE__ */ P.jsxs(x.Fragment, {
        children: [p === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          xC || (xC = /* @__PURE__ */ P.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, a]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (RE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: n.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: n.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
function PE(e) {
  return Ae("MuiInputLabel", e);
}
const sz = Ne("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]), lz = (e) => {
  const {
    classes: t,
    formControl: r,
    size: o,
    shrink: a,
    disableAnimation: i,
    variant: l,
    required: c
  } = e, d = {
    root: ["root", r && "formControl", !i && "animated", a && "shrink", o && o !== "normal" && `size${re(o)}`, l],
    asterisk: [c && "asterisk"]
  }, p = Me(d, PE, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...p
  };
}, cz = Y(Qb, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ys.asterisk}`]: t.asterisk
    }, t.root, r.formControl && t.formControl, r.size === "small" && t.sizeSmall, r.shrink && t.shrink, !r.disableAnimation && t.animated, r.focused && t.focused, t[r.variant]];
  }
})($e(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: r
    }) => t === "filled" && r.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: r,
      size: o
    }) => t === "filled" && r.shrink && o === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: r
    }) => t === "outlined" && r.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), ny = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: a = !1,
    margin: i,
    shrink: l,
    variant: c,
    className: d,
    ...p
  } = o, f = ko();
  let h = l;
  typeof h > "u" && f && (h = f.filled || f.focused || f.adornedStart);
  const g = si({
    props: o,
    muiFormControl: f,
    states: ["size", "variant", "required", "focused"]
  }), y = {
    ...o,
    disableAnimation: a,
    formControl: f,
    shrink: h,
    size: g.size,
    variant: g.variant,
    required: g.required,
    focused: g.focused
  }, C = lz(y);
  return /* @__PURE__ */ P.jsx(cz, {
    "data-shrink": h,
    ref: r,
    className: ge(C.root, d),
    ...p,
    ownerState: y,
    classes: C
  });
});
process.env.NODE_ENV !== "production" && (ny.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: n.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: n.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: n.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: n.oneOfType([n.oneOf(["normal", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
function kE(e) {
  return Ae("MuiLinearProgress", e);
}
const uz = Ne("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "bar1", "bar2", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]), vg = 4, xg = Ro`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, dz = typeof xg != "string" ? oi`
        animation: ${xg} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, Cg = Ro`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, pz = typeof Cg != "string" ? oi`
        animation: ${Cg} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, Sg = Ro`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, fz = typeof Sg != "string" ? oi`
        animation: ${Sg} 3s infinite linear;
      ` : null, mz = (e) => {
  const {
    classes: t,
    variant: r,
    color: o
  } = e, a = {
    root: ["root", `color${re(o)}`, r],
    dashed: ["dashed", `dashedColor${re(o)}`],
    bar1: ["bar", "bar1", `barColor${re(o)}`, (r === "indeterminate" || r === "query") && "bar1Indeterminate", r === "determinate" && "bar1Determinate", r === "buffer" && "bar1Buffer"],
    bar2: ["bar", "bar2", r !== "buffer" && `barColor${re(o)}`, r === "buffer" && `color${re(o)}`, (r === "indeterminate" || r === "query") && "bar2Indeterminate", r === "buffer" && "bar2Buffer"]
  };
  return Me(a, kE, t);
}, oy = (e, t) => e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? oa(e.palette[t].main, 0.62) : na(e.palette[t].main, 0.5), hz = Y("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`color${re(r.color)}`], t[r.variant]];
  }
})($e(({
  theme: e
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: oy(e, t)
    }
  })), {
    props: ({
      ownerState: t
    }) => t.color === "inherit" && t.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), gz = Y("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.dashed, t[`dashedColor${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => {
    const r = oy(e, t);
    return {
      props: {
        color: t
      },
      style: {
        backgroundImage: `radial-gradient(${r} 0%, ${r} 16%, transparent 42%)`
      }
    };
  })]
})), fz || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${Sg} 3s infinite linear`
}), bz = Y("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.bar, t.bar1, t[`barColor${re(r.color)}`], (r.variant === "indeterminate" || r.variant === "query") && t.bar1Indeterminate, r.variant === "determinate" && t.bar1Determinate, r.variant === "buffer" && t.bar1Buffer];
  }
})($e(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${vg}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${vg}s linear`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: dz || {
      animation: `${xg} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), yz = Y("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.bar, t.bar2, t[`barColor${re(r.color)}`], (r.variant === "indeterminate" || r.variant === "query") && t.bar2Indeterminate, r.variant === "buffer" && t.bar2Buffer];
  }
})($e(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--LinearProgressBar2-barColor": (e.vars || e).palette[t].main
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t,
      variant: "buffer"
    },
    style: {
      backgroundColor: oy(e, t),
      transition: `transform .${vg}s linear`
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: pz || {
      animation: `${Cg} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), ay = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: a,
    color: i = "primary",
    value: l,
    valueBuffer: c,
    variant: d = "indeterminate",
    ...p
  } = o, f = {
    ...o,
    color: i,
    variant: d
  }, h = mz(f), g = la(), y = {}, C = {
    bar1: {},
    bar2: {}
  };
  if (d === "determinate" || d === "buffer")
    if (l !== void 0) {
      y["aria-valuenow"] = Math.round(l), y["aria-valuemin"] = 0, y["aria-valuemax"] = 100;
      let b = l - 100;
      g && (b = -b), C.bar1.transform = `translateX(${b}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (d === "buffer")
    if (c !== void 0) {
      let b = (c || 0) - 100;
      g && (b = -b), C.bar2.transform = `translateX(${b}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ P.jsxs(hz, {
    className: ge(h.root, a),
    ownerState: f,
    role: "progressbar",
    ...y,
    ref: r,
    ...p,
    children: [d === "buffer" ? /* @__PURE__ */ P.jsx(gz, {
      className: h.dashed,
      ownerState: f
    }) : null, /* @__PURE__ */ P.jsx(bz, {
      className: h.bar1,
      ownerState: f,
      style: C.bar1
    }), d === "determinate" ? null : /* @__PURE__ */ P.jsx(yz, {
      className: h.bar2,
      ownerState: f,
      style: C.bar2
    })]
  });
});
process.env.NODE_ENV !== "production" && (ay.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: n.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: n.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: n.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function AE(e) {
  return Ae("MuiLink", e);
}
const IE = Ne("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), vz = ({
  theme: e,
  ownerState: t
}) => {
  const r = t.color, o = $i(e, `palette.${r}.main`, !1) || $i(e, `palette.${r}`, !1) || t.color, a = $i(e, `palette.${r}.mainChannel`) || $i(e, `palette.${r}Channel`);
  return "vars" in e && a ? `rgba(${a} / 0.4)` : dt(o, 0.4);
}, CC = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, xz = (e) => {
  const {
    classes: t,
    component: r,
    focusVisible: o,
    underline: a
  } = e, i = {
    root: ["root", `underline${re(a)}`, r === "button" && "button", o && "focusVisible"]
  };
  return Me(i, AE, t);
}, Cz = Y(pn, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`underline${re(r.underline)}`], r.component === "button" && t.button];
  }
})($e(({
  theme: e
}) => ({
  variants: [{
    props: {
      underline: "none"
    },
    style: {
      textDecoration: "none"
    }
  }, {
    props: {
      underline: "hover"
    },
    style: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }, {
    props: {
      underline: "always"
    },
    style: {
      textDecoration: "underline",
      "&:hover": {
        textDecorationColor: "inherit"
      }
    }
  }, {
    props: ({
      underline: t,
      ownerState: r
    }) => t === "always" && r.color !== "inherit",
    style: {
      textDecorationColor: "var(--Link-underlineColor)"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      underline: "always",
      color: t
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.4)` : dt(e.palette[t].main, 0.4)
    }
  })), {
    props: {
      underline: "always",
      color: "textPrimary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : dt(e.palette.text.primary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textSecondary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.secondaryChannel} / 0.4)` : dt(e.palette.text.secondary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textDisabled"
    },
    style: {
      "--Link-underlineColor": (e.vars || e).palette.text.disabled
    }
  }, {
    props: {
      component: "button"
    },
    style: {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      MozAppearance: "none",
      // Reset
      WebkitAppearance: "none",
      // Reset
      "&::-moz-focus-inner": {
        borderStyle: "none"
        // Remove Firefox dotted outline.
      },
      [`&.${IE.focusVisible}`]: {
        outline: "auto"
      }
    }
  }]
}))), iy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiLink"
  }), a = Yr(), {
    className: i,
    color: l = "primary",
    component: c = "a",
    onBlur: d,
    onFocus: p,
    TypographyClasses: f,
    underline: h = "always",
    variant: g = "inherit",
    sx: y,
    ...C
  } = o, [b, v] = x.useState(!1), T = (S) => {
    Ra(S.target) || v(!1), d && d(S);
  }, R = (S) => {
    Ra(S.target) && v(!0), p && p(S);
  }, $ = {
    ...o,
    color: l,
    component: c,
    focusVisible: b,
    underline: h,
    variant: g
  }, E = xz($);
  return /* @__PURE__ */ P.jsx(Cz, {
    color: l,
    className: ge(E.root, i),
    classes: f,
    component: c,
    onBlur: T,
    onFocus: R,
    ref: r,
    ownerState: $,
    variant: g,
    ...C,
    sx: [...CC[l] === void 0 ? [{
      color: l
    }] : [], ...Array.isArray(y) ? y : [y]],
    style: {
      ...C.style,
      ...h === "always" && l !== "inherit" && !CC[l] && {
        "--Link-underlineColor": vz({
          theme: a,
          ownerState: $
        })
      }
    }
  });
});
process.env.NODE_ENV !== "production" && (iy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ni,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */
  TypographyClasses: n.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: n.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: n.oneOfType([n.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), n.string])
});
const Eo = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (Eo.displayName = "ListContext");
function NE(e) {
  return Ae("MuiList", e);
}
const Sz = Ne("MuiList", ["root", "padding", "dense", "subheader"]), wz = (e) => {
  const {
    classes: t,
    disablePadding: r,
    dense: o,
    subheader: a
  } = e;
  return Me({
    root: ["root", !r && "padding", o && "dense", a && "subheader"]
  }, NE, t);
}, Tz = Y("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disablePadding && t.padding, r.dense && t.dense, r.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), sy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiList"
  }), {
    children: a,
    className: i,
    component: l = "ul",
    dense: c = !1,
    disablePadding: d = !1,
    subheader: p,
    ...f
  } = o, h = x.useMemo(() => ({
    dense: c
  }), [c]), g = {
    ...o,
    component: l,
    dense: c,
    disablePadding: d
  }, y = wz(g);
  return /* @__PURE__ */ P.jsx(Eo.Provider, {
    value: h,
    children: /* @__PURE__ */ P.jsxs(Tz, {
      as: l,
      className: ge(y.root, i),
      ref: r,
      ownerState: g,
      ...f,
      children: [p, a]
    })
  });
});
process.env.NODE_ENV !== "production" && (sy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: n.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function ME(e) {
  return Ae("MuiListItem", e);
}
const Ez = Ne("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function _E(e) {
  return Ae("MuiListItemButton", e);
}
const is = Ne("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), Oz = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.alignItems === "flex-start" && t.alignItemsFlexStart, r.divider && t.divider, !r.disableGutters && t.gutters];
}, $z = (e) => {
  const {
    alignItems: t,
    classes: r,
    dense: o,
    disabled: a,
    disableGutters: i,
    divider: l,
    selected: c
  } = e, p = Me({
    root: ["root", o && "dense", !i && "gutters", l && "divider", a && "disabled", t === "flex-start" && "alignItemsFlexStart", c && "selected"]
  }, _E, r);
  return {
    ...r,
    ...p
  };
}, Rz = Y(qr, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: Oz
})($e(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${is.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${is.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${is.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${is.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${is.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), FE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: a = "center",
    autoFocus: i = !1,
    component: l = "div",
    children: c,
    dense: d = !1,
    disableGutters: p = !1,
    divider: f = !1,
    focusVisibleClassName: h,
    selected: g = !1,
    className: y,
    ...C
  } = o, b = x.useContext(Eo), v = x.useMemo(() => ({
    dense: d || b.dense || !1,
    alignItems: a,
    disableGutters: p
  }), [a, b.dense, d, p]), T = x.useRef(null);
  en(() => {
    i && (T.current ? T.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [i]);
  const R = {
    ...o,
    alignItems: a,
    dense: v.dense,
    disableGutters: p,
    divider: f,
    selected: g
  }, $ = $z(R), E = Jt(T, r);
  return /* @__PURE__ */ P.jsx(Eo.Provider, {
    value: v,
    children: /* @__PURE__ */ P.jsx(Rz, {
      ref: E,
      href: C.href || C.to,
      component: (C.href || C.to) && l === "div" ? "button" : l,
      focusVisibleClassName: ge($.focusVisible, h),
      ownerState: R,
      className: ge($.root, y),
      ...C,
      classes: $,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (FE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: n.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  href: n.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function LE(e) {
  return Ae("MuiListItemSecondaryAction", e);
}
const Pz = Ne("MuiListItemSecondaryAction", ["root", "disableGutters"]), kz = (e) => {
  const {
    disableGutters: t,
    classes: r
  } = e;
  return Me({
    root: ["root", t && "disableGutters"]
  }, LE, r);
}, Az = Y("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), vf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: a,
    ...i
  } = o, l = x.useContext(Eo), c = {
    ...o,
    disableGutters: l.disableGutters
  }, d = kz(c);
  return /* @__PURE__ */ P.jsx(Az, {
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (vf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
vf.muiName = "ListItemSecondaryAction";
const Iz = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.alignItems === "flex-start" && t.alignItemsFlexStart, r.divider && t.divider, !r.disableGutters && t.gutters, !r.disablePadding && t.padding, r.hasSecondaryAction && t.secondaryAction];
}, Nz = (e) => {
  const {
    alignItems: t,
    classes: r,
    dense: o,
    disableGutters: a,
    disablePadding: i,
    divider: l,
    hasSecondaryAction: c
  } = e;
  return Me({
    root: ["root", o && "dense", !a && "gutters", !i && "padding", l && "divider", t === "flex-start" && "alignItemsFlexStart", c && "secondaryAction"],
    container: ["container"]
  }, ME, r);
}, Mz = Y("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: Iz
})($e(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${is.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), _z = Y("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), BE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: a = "center",
    children: i,
    className: l,
    component: c,
    components: d = {},
    componentsProps: p = {},
    ContainerComponent: f = "li",
    ContainerProps: {
      className: h,
      ...g
    } = {},
    dense: y = !1,
    disableGutters: C = !1,
    disablePadding: b = !1,
    divider: v = !1,
    secondaryAction: T,
    slotProps: R = {},
    slots: $ = {},
    ...E
  } = o, S = x.useContext(Eo), k = x.useMemo(() => ({
    dense: y || S.dense || !1,
    alignItems: a,
    disableGutters: C
  }), [a, S.dense, y, C]), A = x.useRef(null), _ = x.Children.toArray(i), L = _.length && wa(_[_.length - 1], ["ListItemSecondaryAction"]), O = {
    ...o,
    alignItems: a,
    dense: k.dense,
    disableGutters: C,
    disablePadding: b,
    divider: v,
    hasSecondaryAction: L
  }, F = Nz(O), B = Jt(A, r), M = $.root || d.Root || Mz, j = R.root || p.root || {}, W = {
    className: ge(F.root, j.className, l),
    ...E
  };
  let V = c || "li";
  return L ? (V = !W.component && !c ? "div" : V, f === "li" && (V === "li" ? V = "div" : W.component === "li" && (W.component = "div")), /* @__PURE__ */ P.jsx(Eo.Provider, {
    value: k,
    children: /* @__PURE__ */ P.jsxs(_z, {
      as: f,
      className: ge(F.container, h),
      ref: B,
      ownerState: O,
      ...g,
      children: [/* @__PURE__ */ P.jsx(M, {
        ...j,
        ...!ri(M) && {
          as: V,
          ownerState: {
            ...O,
            ...j.ownerState
          }
        },
        ...W,
        children: _
      }), _.pop()]
    })
  })) : /* @__PURE__ */ P.jsx(Eo.Provider, {
    value: k,
    children: /* @__PURE__ */ P.jsxs(M, {
      ...j,
      as: V,
      ref: B,
      ...!ri(M) && {
        ownerState: {
          ...O,
          ...j.ownerState
        }
      },
      ...W,
      children: [_, T && /* @__PURE__ */ P.jsx(vf, {
        children: T
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (BE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: n.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: tn(n.node, (e) => {
    const t = x.Children.toArray(e.children);
    let r = -1;
    for (let o = t.length - 1; o >= 0; o -= 1) {
      const a = t[o];
      if (wa(a, ["ListItemSecondaryAction"])) {
        r = o;
        break;
      }
    }
    return r !== -1 && r !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: n.shape({
    root: n.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Ni,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: n.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: n.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: n.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: n.shape({
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function DE(e) {
  return Ae("MuiListItemAvatar", e);
}
const Fz = Ne("MuiListItemAvatar", ["root", "alignItemsFlexStart"]), Lz = (e) => {
  const {
    alignItems: t,
    classes: r
  } = e;
  return Me({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, DE, r);
}, Bz = Y("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})({
  minWidth: 56,
  flexShrink: 0,
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}), jE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: a,
    ...i
  } = o, l = x.useContext(Eo), c = {
    ...o,
    alignItems: l.alignItems
  }, d = Lz(c);
  return /* @__PURE__ */ P.jsx(Bz, {
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (jE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function zE(e) {
  return Ae("MuiListItemIcon", e);
}
const wg = Ne("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Dz = (e) => {
  const {
    alignItems: t,
    classes: r
  } = e;
  return Me({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, zE, r);
}, jz = Y("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})($e(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), VE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: a,
    ...i
  } = o, l = x.useContext(Eo), c = {
    ...o,
    alignItems: l.alignItems
  }, d = Dz(c);
  return /* @__PURE__ */ P.jsx(jz, {
    className: ge(d.root, a),
    ownerState: c,
    ref: r,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (VE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function WE(e) {
  return Ae("MuiListItemText", e);
}
const ds = Ne("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), zz = (e) => {
  const {
    classes: t,
    inset: r,
    primary: o,
    secondary: a,
    dense: i
  } = e;
  return Me({
    root: ["root", r && "inset", i && "dense", o && a && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, WE, t);
}, Vz = Y("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ds.primary}`]: t.primary
    }, {
      [`& .${ds.secondary}`]: t.secondary
    }, t.root, r.inset && t.inset, r.primary && r.secondary && t.multiline, r.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${zc.root}:where(& .${ds.primary})`]: {
    display: "block"
  },
  [`.${zc.root}:where(& .${ds.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), UE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiListItemText"
  }), {
    children: a,
    className: i,
    disableTypography: l = !1,
    inset: c = !1,
    primary: d,
    primaryTypographyProps: p,
    secondary: f,
    secondaryTypographyProps: h,
    slots: g = {},
    slotProps: y = {},
    ...C
  } = o, {
    dense: b
  } = x.useContext(Eo);
  let v = d ?? a, T = f;
  const R = {
    ...o,
    disableTypography: l,
    inset: c,
    primary: !!v,
    secondary: !!T,
    dense: b
  }, $ = zz(R), E = {
    slots: g,
    slotProps: {
      primary: p,
      secondary: h,
      ...y
    }
  }, [S, k] = ze("root", {
    className: ge($.root, i),
    elementType: Vz,
    externalForwardedProps: {
      ...E,
      ...C
    },
    ownerState: R,
    ref: r
  }), [A, _] = ze("primary", {
    className: $.primary,
    elementType: pn,
    externalForwardedProps: E,
    ownerState: R
  }), [L, O] = ze("secondary", {
    className: $.secondary,
    elementType: pn,
    externalForwardedProps: E,
    ownerState: R
  });
  return v != null && v.type !== pn && !l && (v = /* @__PURE__ */ P.jsx(A, {
    variant: b ? "body2" : "body1",
    component: _?.variant ? void 0 : "span",
    ..._,
    children: v
  })), T != null && T.type !== pn && !l && (T = /* @__PURE__ */ P.jsx(L, {
    variant: "body2",
    color: "textSecondary",
    ...O,
    children: T
  })), /* @__PURE__ */ P.jsxs(S, {
    ...k,
    children: [v, T]
  });
});
process.env.NODE_ENV !== "production" && (UE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: n.bool,
  /**
   * The main content element.
   */
  primary: n.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: n.object,
  /**
   * The secondary content element.
   */
  secondary: n.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: n.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    primary: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    secondary: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    primary: n.elementType,
    root: n.elementType,
    secondary: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function ph(e, t, r) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : r ? null : e.firstChild;
}
function SC(e, t, r) {
  return e === t ? r ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : r ? null : e.lastChild;
}
function HE(e, t) {
  if (t === void 0)
    return !0;
  let r = e.innerText;
  return r === void 0 && (r = e.textContent), r = r.trim().toLowerCase(), r.length === 0 ? !1 : t.repeating ? r[0] === t.keys[0] : r.startsWith(t.keys.join(""));
}
function fc(e, t, r, o, a, i) {
  let l = !1, c = a(e, t, t ? r : !1);
  for (; c; ) {
    if (c === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const d = o ? !1 : c.disabled || c.getAttribute("aria-disabled") === "true";
    if (!c.hasAttribute("tabindex") || !HE(c, i) || d)
      c = a(e, c, r);
    else
      return c.focus(), !0;
  }
  return !1;
}
const ly = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: a = !1,
    autoFocusItem: i = !1,
    children: l,
    className: c,
    disabledItemsFocusable: d = !1,
    disableListWrap: p = !1,
    onKeyDown: f,
    variant: h = "selectedMenu",
    ...g
  } = t, y = x.useRef(null), C = x.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  en(() => {
    a && y.current.focus();
  }, [a]), x.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: ($, {
      direction: E
    }) => {
      const S = !y.current.style.width;
      if ($.clientHeight < y.current.clientHeight && S) {
        const k = `${V2(fn($))}px`;
        y.current.style[E === "rtl" ? "paddingLeft" : "paddingRight"] = k, y.current.style.width = `calc(100% + ${k})`;
      }
      return y.current;
    }
  }), []);
  const b = ($) => {
    const E = y.current, S = $.key;
    if ($.ctrlKey || $.metaKey || $.altKey) {
      f && f($);
      return;
    }
    const A = Rr(E).activeElement;
    if (S === "ArrowDown")
      $.preventDefault(), fc(E, A, p, d, ph);
    else if (S === "ArrowUp")
      $.preventDefault(), fc(E, A, p, d, SC);
    else if (S === "Home")
      $.preventDefault(), fc(E, null, p, d, ph);
    else if (S === "End")
      $.preventDefault(), fc(E, null, p, d, SC);
    else if (S.length === 1) {
      const _ = C.current, L = S.toLowerCase(), O = performance.now();
      _.keys.length > 0 && (O - _.lastTime > 500 ? (_.keys = [], _.repeating = !0, _.previousKeyMatched = !0) : _.repeating && L !== _.keys[0] && (_.repeating = !1)), _.lastTime = O, _.keys.push(L);
      const F = A && !_.repeating && HE(A, _);
      _.previousKeyMatched && (F || fc(E, A, !1, d, ph, _)) ? $.preventDefault() : _.previousKeyMatched = !1;
    }
    f && f($);
  }, v = Jt(y, r);
  let T = -1;
  x.Children.forEach(l, ($, E) => {
    if (!/* @__PURE__ */ x.isValidElement($)) {
      T === E && (T += 1, T >= l.length && (T = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && zn.isFragment($) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), $.props.disabled || (h === "selectedMenu" && $.props.selected || T === -1) && (T = E), T === E && ($.props.disabled || $.props.muiSkipListHighlight || $.type.muiSkipListHighlight) && (T += 1, T >= l.length && (T = -1));
  });
  const R = x.Children.map(l, ($, E) => {
    if (E === T) {
      const S = {};
      return i && (S.autoFocus = !0), $.props.tabIndex === void 0 && h === "selectedMenu" && (S.tabIndex = 0), /* @__PURE__ */ x.cloneElement($, S);
    }
    return $;
  });
  return /* @__PURE__ */ P.jsx(sy, {
    role: "menu",
    ref: v,
    className: c,
    onKeyDown: b,
    tabIndex: a ? 0 : -1,
    ...g,
    children: R
  });
});
process.env.NODE_ENV !== "production" && (ly.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: n.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: n.node,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: n.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: n.bool,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: n.oneOf(["menu", "selectedMenu"])
});
function GE(e) {
  return Ae("MuiPopover", e);
}
const Wz = Ne("MuiPopover", ["root", "paper"]);
function Tg(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.height / 2 : t === "bottom" && (r = e.height), r;
}
function Eg(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.width / 2 : t === "right" && (r = e.width), r;
}
function wC(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Ec(e) {
  return typeof e == "function" ? e() : e;
}
const Uz = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    paper: ["paper"]
  }, GE, t);
}, qE = Y(gu, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), cy = Y(no, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), uy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiPopover"
  }), {
    action: a,
    anchorEl: i,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: c,
    anchorReference: d = "anchorEl",
    children: p,
    className: f,
    container: h,
    elevation: g = 8,
    marginThreshold: y = 16,
    open: C,
    PaperProps: b = {},
    // TODO: remove in v7
    slots: v = {},
    slotProps: T = {},
    transformOrigin: R = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: $,
    // TODO: remove in v7
    transitionDuration: E = "auto",
    TransitionProps: S = {},
    // TODO: remove in v7
    disableScrollLock: k = !1,
    ...A
  } = o, _ = x.useRef(), L = {
    ...o,
    anchorOrigin: l,
    anchorReference: d,
    elevation: g,
    marginThreshold: y,
    transformOrigin: R,
    TransitionComponent: $,
    transitionDuration: E,
    TransitionProps: S
  }, O = Uz(L), F = x.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (c || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), c;
    const xe = Ec(i), Re = xe && xe.nodeType === 1 ? xe : Rr(_.current).body, J = Re.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const Ie = Re.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Ie.top === 0 && Ie.left === 0 && Ie.right === 0 && Ie.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: J.top + Tg(J, l.vertical),
      left: J.left + Eg(J, l.horizontal)
    };
  }, [i, l.horizontal, l.vertical, c, d]), B = x.useCallback((xe) => ({
    vertical: Tg(xe, R.vertical),
    horizontal: Eg(xe, R.horizontal)
  }), [R.horizontal, R.vertical]), M = x.useCallback((xe) => {
    const Re = {
      width: xe.offsetWidth,
      height: xe.offsetHeight
    }, J = B(Re);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: wC(J)
      };
    const Ie = F();
    let le = Ie.top - J.vertical, qe = Ie.left - J.horizontal;
    const q = le + Re.height, K = qe + Re.width, ee = fn(Ec(i)), he = ee.innerHeight - y, we = ee.innerWidth - y;
    if (y !== null && le < y) {
      const se = le - y;
      le -= se, J.vertical += se;
    } else if (y !== null && q > he) {
      const se = q - he;
      le -= se, J.vertical += se;
    }
    if (process.env.NODE_ENV !== "production" && Re.height > he && Re.height && he && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Re.height - he}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), y !== null && qe < y) {
      const se = qe - y;
      qe -= se, J.horizontal += se;
    } else if (K > we) {
      const se = K - we;
      qe -= se, J.horizontal += se;
    }
    return {
      top: `${Math.round(le)}px`,
      left: `${Math.round(qe)}px`,
      transformOrigin: wC(J)
    };
  }, [i, d, F, B, y]), [j, W] = x.useState(C), V = x.useCallback(() => {
    const xe = _.current;
    if (!xe)
      return;
    const Re = M(xe);
    Re.top !== null && xe.style.setProperty("top", Re.top), Re.left !== null && (xe.style.left = Re.left), xe.style.transformOrigin = Re.transformOrigin, W(!0);
  }, [M]);
  x.useEffect(() => (k && window.addEventListener("scroll", V), () => window.removeEventListener("scroll", V)), [i, k, V]);
  const X = () => {
    V();
  }, U = () => {
    W(!1);
  };
  x.useEffect(() => {
    C && V();
  }), x.useImperativeHandle(a, () => C ? {
    updatePosition: () => {
      V();
    }
  } : null, [C, V]), x.useEffect(() => {
    if (!C)
      return;
    const xe = As(() => {
      V();
    }), Re = fn(Ec(i));
    return Re.addEventListener("resize", xe), () => {
      xe.clear(), Re.removeEventListener("resize", xe);
    };
  }, [i, C, V]);
  let H = E;
  const Z = {
    slots: {
      transition: $,
      ...v
    },
    slotProps: {
      transition: S,
      paper: b,
      ...T
    }
  }, [G, ye] = ze("transition", {
    elementType: $s,
    externalForwardedProps: Z,
    ownerState: L,
    getSlotProps: (xe) => ({
      ...xe,
      onEntering: (Re, J) => {
        xe.onEntering?.(Re, J), X();
      },
      onExited: (Re) => {
        xe.onExited?.(Re), U();
      }
    }),
    additionalProps: {
      appear: !0,
      in: C
    }
  });
  E === "auto" && !G.muiSupportAuto && (H = void 0);
  const de = h || (i ? Rr(Ec(i)).body : void 0), [ne, {
    slots: fe,
    slotProps: ie,
    ...oe
  }] = ze("root", {
    ref: r,
    elementType: qE,
    externalForwardedProps: {
      ...Z,
      ...A
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: v.backdrop
      },
      slotProps: {
        backdrop: Ts(typeof T.backdrop == "function" ? T.backdrop(L) : T.backdrop, {
          invisible: !0
        })
      },
      container: de,
      open: C
    },
    ownerState: L,
    className: ge(O.root, f)
  }), [ce, Ce] = ze("paper", {
    ref: _,
    className: O.paper,
    elementType: cy,
    externalForwardedProps: Z,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: g,
      style: j ? void 0 : {
        opacity: 0
      }
    },
    ownerState: L
  });
  return /* @__PURE__ */ P.jsx(ne, {
    ...oe,
    ...!ri(ne) && {
      slots: fe,
      slotProps: ie,
      disableScrollLock: k
    },
    children: /* @__PURE__ */ P.jsx(G, {
      ...ye,
      timeout: H,
      children: /* @__PURE__ */ P.jsx(ce, {
        ...Ce,
        children: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (uy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: On,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: tn(n.oneOfType([$a, n.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Ec(e.anchorEl);
      if (t && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOfType([n.oneOf(["center", "left", "right"]), n.number]).isRequired,
    vertical: n.oneOfType([n.oneOf(["bottom", "center", "top"]), n.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: n.shape({
    left: n.number.isRequired,
    top: n.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: n.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: n.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: n.object,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([$a, n.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: n.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Vr,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: n.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: n.shape({
    component: Ni
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    paper: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: n.shape({
    horizontal: n.oneOfType([n.oneOf(["center", "left", "right"]), n.number]).isRequired,
    vertical: n.oneOfType([n.oneOf(["bottom", "center", "top"]), n.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: n.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: n.object
});
function KE(e) {
  return Ae("MuiMenu", e);
}
const Hz = Ne("MuiMenu", ["root", "paper", "list"]), Gz = {
  vertical: "top",
  horizontal: "right"
}, qz = {
  vertical: "top",
  horizontal: "left"
}, Kz = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, KE, t);
}, Yz = Y(uy, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Zz = Y(cy, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Xz = Y(ly, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), dy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: i,
    className: l,
    disableAutoFocusItem: c = !1,
    MenuListProps: d = {},
    onClose: p,
    open: f,
    PaperProps: h = {},
    PopoverClasses: g,
    transitionDuration: y = "auto",
    TransitionProps: {
      onEntering: C,
      ...b
    } = {},
    variant: v = "selectedMenu",
    slots: T = {},
    slotProps: R = {},
    ...$
  } = o, E = la(), S = {
    ...o,
    autoFocus: a,
    disableAutoFocusItem: c,
    MenuListProps: d,
    onEntering: C,
    PaperProps: h,
    transitionDuration: y,
    TransitionProps: b,
    variant: v
  }, k = Kz(S), A = a && !c && f, _ = x.useRef(null), L = (H, Z) => {
    _.current && _.current.adjustStyleForScrollbar(H, {
      direction: E ? "rtl" : "ltr"
    }), C && C(H, Z);
  }, O = (H) => {
    H.key === "Tab" && (H.preventDefault(), p && p(H, "tabKeyDown"));
  };
  let F = -1;
  x.Children.map(i, (H, Z) => {
    /* @__PURE__ */ x.isValidElement(H) && (process.env.NODE_ENV !== "production" && zn.isFragment(H) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), H.props.disabled || (v === "selectedMenu" && H.props.selected || F === -1) && (F = Z));
  });
  const B = {
    slots: T,
    slotProps: {
      list: d,
      transition: b,
      paper: h,
      ...R
    }
  }, M = Mn({
    elementType: T.root,
    externalSlotProps: R.root,
    ownerState: S,
    className: [k.root, l]
  }), [j, W] = ze("paper", {
    className: k.paper,
    elementType: Zz,
    externalForwardedProps: B,
    shouldForwardComponentProp: !0,
    ownerState: S
  }), [V, X] = ze("list", {
    className: ge(k.list, d.className),
    elementType: Xz,
    shouldForwardComponentProp: !0,
    externalForwardedProps: B,
    getSlotProps: (H) => ({
      ...H,
      onKeyDown: (Z) => {
        O(Z), H.onKeyDown?.(Z);
      }
    }),
    ownerState: S
  }), U = typeof B.slotProps.transition == "function" ? B.slotProps.transition(S) : B.slotProps.transition;
  return /* @__PURE__ */ P.jsx(Yz, {
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: E ? "right" : "left"
    },
    transformOrigin: E ? Gz : qz,
    slots: {
      root: T.root,
      paper: j,
      backdrop: T.backdrop,
      ...T.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: T.transition
      }
    },
    slotProps: {
      root: M,
      paper: W,
      backdrop: typeof R.backdrop == "function" ? R.backdrop(S) : R.backdrop,
      transition: {
        ...U,
        onEntering: (...H) => {
          L(...H), U?.onEntering?.(...H);
        }
      }
    },
    open: f,
    ref: r,
    transitionDuration: y,
    ownerState: S,
    ...$,
    classes: g,
    children: /* @__PURE__ */ P.jsx(V, {
      actions: _,
      autoFocus: a && (F === -1 || c),
      autoFocusItem: A,
      variant: v,
      ...X,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (dy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: n.oneOfType([$a, n.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: n.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: n.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: n.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: n.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: n.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    list: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    list: n.elementType,
    paper: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: n.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: n.oneOf(["menu", "selectedMenu"])
});
function YE(e) {
  return Ae("MuiMenuItem", e);
}
const al = Ne("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Jz = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.divider && t.divider, !r.disableGutters && t.gutters];
}, Qz = (e) => {
  const {
    disabled: t,
    dense: r,
    divider: o,
    disableGutters: a,
    selected: i,
    classes: l
  } = e, d = Me({
    root: ["root", r && "dense", t && "disabled", !a && "gutters", o && "divider", i && "selected"]
  }, YE, l);
  return {
    ...l,
    ...d
  };
}, eV = Y(qr, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Jz
})($e(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${al.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${al.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${al.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${al.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${al.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${mg.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${mg.inset}`]: {
    marginLeft: 52
  },
  [`& .${ds.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${ds.inset}`]: {
    paddingLeft: 36
  },
  [`& .${wg.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${wg.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), py = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: a = !1,
    component: i = "li",
    dense: l = !1,
    divider: c = !1,
    disableGutters: d = !1,
    focusVisibleClassName: p,
    role: f = "menuitem",
    tabIndex: h,
    className: g,
    ...y
  } = o, C = x.useContext(Eo), b = x.useMemo(() => ({
    dense: l || C.dense || !1,
    disableGutters: d
  }), [C.dense, l, d]), v = x.useRef(null);
  en(() => {
    a && (v.current ? v.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [a]);
  const T = {
    ...o,
    dense: b.dense,
    divider: c,
    disableGutters: d
  }, R = Qz(o), $ = Jt(v, r);
  let E;
  return o.disabled || (E = h !== void 0 ? h : -1), /* @__PURE__ */ P.jsx(Eo.Provider, {
    value: b,
    children: /* @__PURE__ */ P.jsx(eV, {
      ref: $,
      role: f,
      tabIndex: E,
      component: i,
      focusVisibleClassName: ge(R.focusVisible, p),
      className: ge(R.root, g),
      ...y,
      ownerState: T,
      classes: R
    })
  });
});
process.env.NODE_ENV !== "production" && (py.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: n.bool,
  /**
   * @ignore
   */
  disabled: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  role: n.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @default 0
   */
  tabIndex: n.number
});
function ZE(e) {
  return Ae("MuiMobileStepper", e);
}
const tV = Ne("MuiMobileStepper", ["root", "positionBottom", "positionTop", "positionStatic", "dots", "dot", "dotActive", "progress"]), rV = (e) => {
  const {
    classes: t,
    position: r
  } = e, o = {
    root: ["root", `position${re(r)}`],
    dots: ["dots"],
    dot: ["dot"],
    dotActive: ["dotActive"],
    progress: ["progress"]
  };
  return Me(o, ZE, t);
}, nV = Y(no, {
  name: "MuiMobileStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`position${re(r.position)}`]];
  }
})($e(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  background: (e.vars || e).palette.background.default,
  padding: 8,
  variants: [{
    props: ({
      position: t
    }) => t === "top" || t === "bottom",
    style: {
      position: "fixed",
      left: 0,
      right: 0,
      zIndex: (e.vars || e).zIndex.mobileStepper
    }
  }, {
    props: {
      position: "top"
    },
    style: {
      top: 0
    }
  }, {
    props: {
      position: "bottom"
    },
    style: {
      bottom: 0
    }
  }]
}))), oV = Y("div", {
  name: "MuiMobileStepper",
  slot: "Dots",
  overridesResolver: (e, t) => t.dots
})({
  variants: [{
    props: {
      variant: "dots"
    },
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }]
}), aV = Y("div", {
  name: "MuiMobileStepper",
  slot: "Dot",
  shouldForwardProp: (e) => jl(e) && e !== "dotActive",
  overridesResolver: (e, t) => {
    const {
      dotActive: r
    } = e;
    return [t.dot, r && t.dotActive];
  }
})($e(({
  theme: e
}) => ({
  variants: [{
    props: {
      variant: "dots"
    },
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      backgroundColor: (e.vars || e).palette.action.disabled,
      borderRadius: "50%",
      width: 8,
      height: 8,
      margin: "0 2px"
    }
  }, {
    props: {
      variant: "dots",
      dotActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }]
}))), iV = Y(ay, {
  name: "MuiMobileStepper",
  slot: "Progress",
  overridesResolver: (e, t) => t.progress
})({
  variants: [{
    props: {
      variant: "progress"
    },
    style: {
      width: "50%"
    }
  }]
}), XE = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiMobileStepper"
  }), {
    activeStep: a = 0,
    backButton: i,
    className: l,
    LinearProgressProps: c,
    nextButton: d,
    position: p = "bottom",
    steps: f,
    variant: h = "dots",
    slots: g = {},
    slotProps: y = {},
    ...C
  } = o, b = {
    ...o,
    activeStep: a,
    position: p,
    variant: h
  };
  let v;
  h === "progress" && (f === 1 ? v = 100 : v = Math.ceil(a / (f - 1) * 100));
  const T = rV(b), R = {
    slots: g,
    slotProps: {
      progress: c,
      ...y
    }
  }, [$, E] = ze("root", {
    ref: r,
    elementType: nV,
    shouldForwardComponentProp: !0,
    className: ge(T.root, l),
    externalForwardedProps: {
      ...R,
      ...C
    },
    ownerState: b,
    additionalProps: {
      square: !0,
      elevation: 0
    }
  }), [S, k] = ze("dots", {
    className: T.dots,
    elementType: oV,
    externalForwardedProps: R,
    ownerState: b
  }), [A, _] = ze("dot", {
    elementType: aV,
    externalForwardedProps: R,
    ownerState: b
  }), [L, O] = ze("progress", {
    className: T.progress,
    elementType: iV,
    shouldForwardComponentProp: !0,
    externalForwardedProps: R,
    ownerState: b,
    additionalProps: {
      value: v,
      variant: "determinate"
    }
  });
  return /* @__PURE__ */ P.jsxs($, {
    ...E,
    children: [i, h === "text" && /* @__PURE__ */ P.jsxs(x.Fragment, {
      children: [a + 1, " / ", f]
    }), h === "dots" && /* @__PURE__ */ P.jsx(S, {
      ...k,
      children: [...new Array(f)].map((F, B) => /* @__PURE__ */ P.jsx(A, {
        ..._,
        className: ge(T.dot, _.className, B === a && T.dotActive),
        dotActive: B === a
      }, B))
    }), h === "progress" && /* @__PURE__ */ P.jsx(L, {
      ...O
    }), d]
  });
});
process.env.NODE_ENV !== "production" && (XE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   * @default 0
   */
  activeStep: Vr,
  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Props applied to the `LinearProgress` element.
   * @deprecated Use `slotProps.progress` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  LinearProgressProps: n.object,
  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: n.node,
  /**
   * Set the positioning type.
   * @default 'bottom'
   */
  position: n.oneOf(["bottom", "static", "top"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    dot: n.oneOfType([n.func, n.object]),
    dots: n.oneOfType([n.func, n.object]),
    progress: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    dot: n.elementType,
    dots: n.elementType,
    progress: n.elementType,
    root: n.elementType
  }),
  /**
   * The total steps.
   */
  steps: Vr.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'dots'
   */
  variant: n.oneOf(["dots", "progress", "text"])
});
function fy(e) {
  return Ae("MuiNativeSelect", e);
}
const xf = Ne("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), sV = (e) => {
  const {
    classes: t,
    variant: r,
    disabled: o,
    multiple: a,
    open: i,
    error: l
  } = e, c = {
    select: ["select", r, o && "disabled", a && "multiple", l && "error"],
    icon: ["icon", `icon${re(r)}`, i && "iconOpen", o && "disabled"]
  };
  return Me(c, fy, t);
}, JE = Y("select", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${xf.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), lV = Y(JE, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Zr,
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.select, t[r.variant], r.error && t.error, {
      [`&.${xf.multiple}`]: t.multiple
    }];
  }
})({}), QE = Y("svg", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${xf.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), cV = Y(QE, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.icon, r.variant && t[`icon${re(r.variant)}`], r.open && t.iconOpen];
  }
})({}), my = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    className: o,
    disabled: a,
    error: i,
    IconComponent: l,
    inputRef: c,
    variant: d = "standard",
    ...p
  } = t, f = {
    ...t,
    disabled: a,
    variant: d,
    error: i
  }, h = sV(f);
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx(lV, {
      ownerState: f,
      className: ge(h.select, o),
      disabled: a,
      ref: c || r,
      ...p
    }), t.multiple ? null : /* @__PURE__ */ P.jsx(cV, {
      as: l,
      ownerState: f,
      className: h.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (my.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The CSS class name of the select element.
   */
  className: n.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: n.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: n.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: On,
  /**
   * @ignore
   */
  multiple: n.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: n.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The input value.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["standard", "outlined", "filled"])
});
const uV = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, fy, t);
}, dV = /* @__PURE__ */ P.jsx(Vl, {}), hy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiNativeSelect",
    props: t
  }), {
    className: a,
    children: i,
    classes: l = {},
    IconComponent: c = Wb,
    input: d = dV,
    inputProps: p,
    variant: f,
    ...h
  } = o, g = ko(), y = si({
    props: o,
    muiFormControl: g,
    states: ["variant"]
  }), C = {
    ...o,
    classes: l
  }, b = uV(C), {
    root: v,
    ...T
  } = l;
  return /* @__PURE__ */ P.jsx(x.Fragment, {
    children: /* @__PURE__ */ x.cloneElement(d, {
      // Most of the logic is implemented in `NativeSelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: my,
      inputProps: {
        children: i,
        classes: T,
        IconComponent: c,
        variant: y.variant,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        ...p,
        ...d ? d.props.inputProps : {}
      },
      ref: r,
      ...h,
      className: ge(b.root, d.props.className, a)
    })
  });
});
process.env.NODE_ENV !== "production" && (hy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: n.elementType,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */
  input: n.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attributes) applied to the `select` element.
   */
  inputProps: n.object,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The `input` value. The DOM API casts this to a string.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
hy.muiName = "Select";
function Zc(e) {
  const {
    children: t,
    defer: r = !1,
    fallback: o = null
  } = e, [a, i] = x.useState(!1);
  return en(() => {
    r || i(!0);
  }, [r]), x.useEffect(() => {
    r && i(!0);
  }, [r]), a ? t : o;
}
process.env.NODE_ENV !== "production" && (Zc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: n.node,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */
  defer: n.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: n.node
});
process.env.NODE_ENV !== "production" && (Zc.propTypes = ks(Zc.propTypes));
var TC;
const pV = Y("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: Zr
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), fV = Y("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: Zr
})($e(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function eO(e) {
  const {
    children: t,
    classes: r,
    className: o,
    label: a,
    notched: i,
    ...l
  } = e, c = a != null && a !== "", d = {
    ...e,
    notched: i,
    withLabel: c
  };
  return /* @__PURE__ */ P.jsx(pV, {
    "aria-hidden": !0,
    className: o,
    ownerState: d,
    ...l,
    children: /* @__PURE__ */ P.jsx(fV, {
      ownerState: d,
      children: c ? /* @__PURE__ */ P.jsx("span", {
        children: a
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        TC || (TC = /* @__PURE__ */ P.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (eO.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The label.
   */
  label: n.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: n.bool.isRequired,
  /**
   * @ignore
   */
  style: n.object
});
const mV = (e) => {
  const {
    classes: t
  } = e, o = Me({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, rT, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, hV = Y(pf, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: uf
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${jt.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${jt.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${jt.focused} .${jt.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Vt()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        [`&.${jt.focused} .${jt.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[r].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${jt.error} .${jt.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${jt.disabled} .${jt.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => r.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: r
      }) => r.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: r
      }) => r.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: r,
        size: o
      }) => r.multiline && o === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), gV = Y(eO, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), bV = Y(ff, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: df
})($e(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), yu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: a = {},
    fullWidth: i = !1,
    inputComponent: l = "input",
    label: c,
    multiline: d = !1,
    notched: p,
    slots: f = {},
    slotProps: h = {},
    type: g = "text",
    ...y
  } = o, C = mV(o), b = ko(), v = si({
    props: o,
    muiFormControl: b,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), T = {
    ...o,
    color: v.color || "primary",
    disabled: v.disabled,
    error: v.error,
    focused: v.focused,
    formControl: b,
    fullWidth: i,
    hiddenLabel: v.hiddenLabel,
    multiline: d,
    size: v.size,
    type: g
  }, R = f.root ?? a.Root ?? hV, $ = f.input ?? a.Input ?? bV, [E, S] = ze("notchedOutline", {
    elementType: gV,
    className: C.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: T,
    externalForwardedProps: {
      slots: f,
      slotProps: h
    },
    additionalProps: {
      label: c != null && c !== "" && v.required ? /* @__PURE__ */ P.jsxs(x.Fragment, {
        children: [c, " ", "*"]
      }) : c
    }
  });
  return /* @__PURE__ */ P.jsx(zl, {
    slots: {
      root: R,
      input: $
    },
    slotProps: h,
    renderSuffix: (k) => /* @__PURE__ */ P.jsx(E, {
      ...S,
      notched: typeof p < "u" ? p : !!(k.startAdornment || k.filled || k.focused)
    }),
    fullWidth: i,
    inputComponent: l,
    multiline: d,
    ref: r,
    type: g,
    ...y,
    classes: {
      ...C,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (yu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: n.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: n.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    notchedOutline: n.oneOfType([n.func, n.object]),
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    notchedOutline: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
yu.muiName = "Input";
function tO(e) {
  return Ae("MuiPagination", e);
}
const yV = Ne("MuiPagination", ["root", "ul", "outlined", "text"]);
function rO(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: r = "usePagination",
    count: o = 1,
    defaultPage: a = 1,
    disabled: i = !1,
    hideNextButton: l = !1,
    hidePrevButton: c = !1,
    onChange: d,
    page: p,
    showFirstButton: f = !1,
    showLastButton: h = !1,
    siblingCount: g = 1,
    ...y
  } = e, [C, b] = Bn({
    controlled: p,
    default: a,
    name: r,
    state: "page"
  }), v = (L, O) => {
    p || b(O), d && d(L, O);
  }, T = (L, O) => {
    const F = O - L + 1;
    return Array.from({
      length: F
    }, (B, M) => L + M);
  }, R = T(1, Math.min(t, o)), $ = T(Math.max(o - t + 1, t + 1), o), E = Math.max(
    Math.min(
      // Natural start
      C - g,
      // Lower boundary when page is high
      o - t - g * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), S = Math.min(
    Math.max(
      // Natural end
      C + g,
      // Upper boundary when page is low
      t + g * 2 + 2
    ),
    // Less than endPages
    o - t - 1
  ), k = [
    ...f ? ["first"] : [],
    ...c ? [] : ["previous"],
    ...R,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...E > t + 2 ? ["start-ellipsis"] : t + 1 < o - t ? [t + 1] : [],
    // Sibling pages
    ...T(E, S),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...S < o - t - 1 ? ["end-ellipsis"] : o - t > t ? [o - t] : [],
    ...$,
    ...l ? [] : ["next"],
    ...h ? ["last"] : []
  ], A = (L) => {
    switch (L) {
      case "first":
        return 1;
      case "previous":
        return C - 1;
      case "next":
        return C + 1;
      case "last":
        return o;
      default:
        return null;
    }
  };
  return {
    items: k.map((L) => typeof L == "number" ? {
      onClick: (O) => {
        v(O, L);
      },
      type: "page",
      page: L,
      selected: L === C,
      disabled: i,
      "aria-current": L === C ? "page" : void 0
    } : {
      onClick: (O) => {
        v(O, A(L));
      },
      type: L,
      page: A(L),
      selected: !1,
      disabled: i || !L.includes("ellipsis") && (L === "next" || L === "last" ? C >= o : C <= 1)
    }),
    ...y
  };
}
function nO(e) {
  return Ae("MuiPaginationItem", e);
}
const Tn = Ne("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), oO = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), aO = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), vV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), xV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), iO = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, t[r.variant], t[`size${re(r.size)}`], r.variant === "text" && t[`text${re(r.color)}`], r.variant === "outlined" && t[`outlined${re(r.color)}`], r.shape === "rounded" && t.rounded, r.type === "page" && t.page, (r.type === "start-ellipsis" || r.type === "end-ellipsis") && t.ellipsis, (r.type === "previous" || r.type === "next") && t.previousNext, (r.type === "first" || r.type === "last") && t.firstLast];
}, CV = (e) => {
  const {
    classes: t,
    color: r,
    disabled: o,
    selected: a,
    size: i,
    shape: l,
    type: c,
    variant: d
  } = e, p = {
    root: ["root", `size${re(i)}`, d, l, r !== "standard" && `color${re(r)}`, r !== "standard" && `${d}${re(r)}`, o && "disabled", a && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[c]],
    icon: ["icon"]
  };
  return Me(p, nO, t);
}, SV = Y("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: iO
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Tn.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), wV = Y(qr, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: iO
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Tn.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Tn.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Tn.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Tn.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Tn.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${Tn.selected}`]: {
        [`&.${Tn.disabled}`]: {
          borderColor: (e.vars || e).palette.action.disabledBackground,
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${Tn.selected}`]: {
        [`&.${Tn.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Vt(["dark", "contrastText"])).map(([t]) => ({
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`&.${Tn.selected}`]: {
        color: (e.vars || e).palette[t].contrastText,
        backgroundColor: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: (e.vars || e).palette[t].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (e.vars || e).palette[t].main
          }
        },
        [`&.${Tn.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[t].dark
        },
        [`&.${Tn.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(e.palette).filter(Vt(["light"])).map(([t]) => ({
    props: {
      variant: "outlined",
      color: t
    },
    style: {
      [`&.${Tn.selected}`]: {
        color: (e.vars || e).palette[t].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : dt(e.palette[t].main, 0.5)}`,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : dt(e.palette[t].main, e.palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Tn.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
        }
      }
    }
  }))]
}))), TV = Y("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})($e(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(22)
    }
  }]
}))), gy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: a,
    color: i = "standard",
    component: l,
    components: c = {},
    disabled: d = !1,
    page: p,
    selected: f = !1,
    shape: h = "circular",
    size: g = "medium",
    slots: y = {},
    slotProps: C = {},
    type: b = "page",
    variant: v = "text",
    ...T
  } = o, R = {
    ...o,
    color: i,
    disabled: d,
    selected: f,
    shape: h,
    size: g,
    type: b,
    variant: v
  }, $ = la(), E = CV(R), S = {
    slots: {
      previous: y.previous ?? c.previous,
      next: y.next ?? c.next,
      first: y.first ?? c.first,
      last: y.last ?? c.last
    },
    slotProps: C
  }, [k, A] = ze("previous", {
    elementType: vV,
    externalForwardedProps: S,
    ownerState: R
  }), [_, L] = ze("next", {
    elementType: xV,
    externalForwardedProps: S,
    ownerState: R
  }), [O, F] = ze("first", {
    elementType: oO,
    externalForwardedProps: S,
    ownerState: R
  }), [B, M] = ze("last", {
    elementType: aO,
    externalForwardedProps: S,
    ownerState: R
  }), j = $ ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[b] : b, W = {
    previous: k,
    next: _,
    first: O,
    last: B
  }[j], V = {
    previous: A,
    next: L,
    first: F,
    last: M
  }[j];
  return b === "start-ellipsis" || b === "end-ellipsis" ? /* @__PURE__ */ P.jsx(SV, {
    ref: r,
    ownerState: R,
    className: ge(E.root, a),
    children: "…"
  }) : /* @__PURE__ */ P.jsxs(wV, {
    ref: r,
    ownerState: R,
    component: l,
    disabled: d,
    className: ge(E.root, a),
    ...T,
    children: [b === "page" && p, W ? /* @__PURE__ */ P.jsx(TV, {
      ...V,
      className: E.icon,
      as: W
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (gy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "standard"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: n.shape({
    first: n.elementType,
    last: n.elementType,
    next: n.elementType,
    previous: n.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The current page number.
   */
  page: n.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: n.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: n.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    first: n.oneOfType([n.func, n.object]),
    last: n.oneOfType([n.func, n.object]),
    next: n.oneOfType([n.func, n.object]),
    previous: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    first: n.elementType,
    last: n.elementType,
    next: n.elementType,
    previous: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: n.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["outlined", "text"]), n.string])
});
const EV = (e) => {
  const {
    classes: t,
    variant: r
  } = e;
  return Me({
    root: ["root", r],
    ul: ["ul"]
  }, tO, t);
}, OV = Y("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant]];
  }
})({}), $V = Y("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function RV(e, t, r) {
  return e === "page" ? `${r ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const sO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: a = 1,
    className: i,
    color: l = "standard",
    count: c = 1,
    defaultPage: d = 1,
    disabled: p = !1,
    getItemAriaLabel: f = RV,
    hideNextButton: h = !1,
    hidePrevButton: g = !1,
    onChange: y,
    page: C,
    renderItem: b = (O) => /* @__PURE__ */ P.jsx(gy, {
      ...O
    }),
    shape: v = "circular",
    showFirstButton: T = !1,
    showLastButton: R = !1,
    siblingCount: $ = 1,
    size: E = "medium",
    variant: S = "text",
    ...k
  } = o, {
    items: A
  } = rO({
    ...o,
    componentName: "Pagination"
  }), _ = {
    ...o,
    boundaryCount: a,
    color: l,
    count: c,
    defaultPage: d,
    disabled: p,
    getItemAriaLabel: f,
    hideNextButton: h,
    hidePrevButton: g,
    renderItem: b,
    shape: v,
    showFirstButton: T,
    showLastButton: R,
    siblingCount: $,
    size: E,
    variant: S
  }, L = EV(_);
  return /* @__PURE__ */ P.jsx(OV, {
    "aria-label": "pagination navigation",
    className: ge(L.root, i),
    ownerState: _,
    ref: r,
    ...k,
    children: /* @__PURE__ */ P.jsx($V, {
      className: L.ul,
      ownerState: _,
      children: A.map((O, F) => /* @__PURE__ */ P.jsx("li", {
        children: b({
          ...O,
          color: l,
          "aria-label": f(O.type, O.page, O.selected),
          shape: v,
          size: E,
          variant: S
        })
      }, F))
    })
  });
});
process.env.NODE_ENV !== "production" && (sO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Vr,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "standard"]), n.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Vr,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Vr,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: n.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: n.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: n.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: n.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: Vr,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: n.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: n.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: n.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: n.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Vr,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["outlined", "text"]), n.string])
});
const PV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), kV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), AV = Y("span", {
  name: "MuiRadioButtonIcon",
  shouldForwardProp: Zr
})({
  position: "relative",
  display: "flex"
}), IV = Y(PV, {
  name: "MuiRadioButtonIcon"
})({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), NV = Y(kV, {
  name: "MuiRadioButtonIcon"
})($e(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function by(e) {
  const {
    checked: t = !1,
    classes: r = {},
    fontSize: o
  } = e, a = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ P.jsxs(AV, {
    className: r.root,
    ownerState: a,
    children: [/* @__PURE__ */ P.jsx(IV, {
      fontSize: o,
      className: r.background,
      ownerState: a
    }), /* @__PURE__ */ P.jsx(NV, {
      fontSize: o,
      className: r.dot,
      ownerState: a
    })]
  });
}
process.env.NODE_ENV !== "production" && (by.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: n.oneOf(["small", "medium"])
});
const yy = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (yy.displayName = "RadioGroupContext");
function lO() {
  return x.useContext(yy);
}
function cO(e) {
  return Ae("MuiRadio", e);
}
const Og = Ne("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), MV = (e) => {
  const {
    classes: t,
    color: r,
    size: o
  } = e, a = {
    root: ["root", `color${re(r)}`, o !== "medium" && `size${re(o)}`]
  };
  return {
    ...t,
    ...Me(a, cO, t)
  };
}, _V = Y(gf, {
  shouldForwardProp: (e) => Zr(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.size !== "medium" && t[`size${re(r.size)}`], t[`color${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${Og.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${Og.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function FV(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const LV = /* @__PURE__ */ P.jsx(by, {
  checked: !0
}), BV = /* @__PURE__ */ P.jsx(by, {}), uO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiRadio"
  }), {
    checked: a,
    checkedIcon: i = LV,
    color: l = "primary",
    icon: c = BV,
    name: d,
    onChange: p,
    size: f = "medium",
    className: h,
    disabled: g,
    disableRipple: y = !1,
    slots: C = {},
    slotProps: b = {},
    inputProps: v,
    ...T
  } = o, R = ko();
  let $ = g;
  R && typeof $ > "u" && ($ = R.disabled), $ ??= !1;
  const E = {
    ...o,
    disabled: $,
    disableRipple: y,
    color: l,
    size: f
  }, S = MV(E), k = lO();
  let A = a;
  const _ = lp(p, k && k.onChange);
  let L = d;
  k && (typeof A > "u" && (A = FV(k.value, o.value)), typeof L > "u" && (L = k.name));
  const O = b.input ?? v, [F, B] = ze("root", {
    ref: r,
    elementType: _V,
    className: ge(S.root, h),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: C,
      slotProps: b,
      ...T
    },
    getSlotProps: (M) => ({
      ...M,
      onChange: (j, ...W) => {
        M.onChange?.(j, ...W), _(j, ...W);
      }
    }),
    ownerState: E,
    additionalProps: {
      type: "radio",
      icon: /* @__PURE__ */ x.cloneElement(c, {
        fontSize: c.props.fontSize ?? f
      }),
      checkedIcon: /* @__PURE__ */ x.cloneElement(i, {
        fontSize: i.props.fontSize ?? f
      }),
      disabled: $,
      name: L,
      checked: A,
      slots: C,
      slotProps: {
        // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
        input: typeof O == "function" ? O(E) : O
      }
    }
  });
  return /* @__PURE__ */ P.jsx(F, {
    ...B,
    classes: S
  });
});
process.env.NODE_ENV !== "production" && (uO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: On,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: n.any
});
function dO(e) {
  return Ae("MuiRadioGroup", e);
}
const DV = Ne("MuiRadioGroup", ["root", "row", "error"]), jV = (e) => {
  const {
    classes: t,
    row: r,
    error: o
  } = e;
  return Me({
    root: ["root", r && "row", o && "error"]
  }, dO, t);
}, pO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    children: a,
    className: i,
    defaultValue: l,
    name: c,
    onChange: d,
    value: p,
    ...f
  } = t, h = x.useRef(null), g = jV(t), [y, C] = Bn({
    controlled: p,
    default: l,
    name: "RadioGroup"
  });
  x.useImperativeHandle(o, () => ({
    focus: () => {
      let R = h.current.querySelector("input:not(:disabled):checked");
      R || (R = h.current.querySelector("input:not(:disabled)")), R && R.focus();
    }
  }), []);
  const b = Jt(r, h), v = eo(c), T = x.useMemo(() => ({
    name: v,
    onChange(R) {
      C(R.target.value), d && d(R, R.target.value);
    },
    value: y
  }), [v, d, C, y]);
  return /* @__PURE__ */ P.jsx(yy.Provider, {
    value: T,
    children: /* @__PURE__ */ P.jsx(Jb, {
      role: "radiogroup",
      ref: b,
      className: ge(g.root, i),
      ...f,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (pO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: n.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: n.any
});
const zV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star"), VV = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
function fO(e) {
  return Ae("MuiRating", e);
}
const il = Ne("MuiRating", ["root", "sizeSmall", "sizeMedium", "sizeLarge", "readOnly", "disabled", "focusVisible", "visuallyHidden", "pristine", "label", "labelEmptyValueActive", "icon", "iconEmpty", "iconFilled", "iconHover", "iconFocus", "iconActive", "decimal"]);
function WV(e) {
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function fh(e, t) {
  if (e == null)
    return e;
  const r = Math.round(e / t) * t;
  return Number(r.toFixed(WV(t)));
}
const UV = (e) => {
  const {
    classes: t,
    size: r,
    readOnly: o,
    disabled: a,
    emptyValueFocused: i,
    focusVisible: l
  } = e, c = {
    root: ["root", `size${re(r)}`, a && "disabled", l && "focusVisible", o && "readOnly"],
    label: ["label", "pristine"],
    labelEmptyValue: [i && "labelEmptyValueActive"],
    icon: ["icon"],
    iconEmpty: ["iconEmpty"],
    iconFilled: ["iconFilled"],
    iconHover: ["iconHover"],
    iconFocus: ["iconFocus"],
    iconActive: ["iconActive"],
    decimal: ["decimal"],
    visuallyHidden: ["visuallyHidden"]
  };
  return Me(c, fO, t);
}, HV = Y("span", {
  name: "MuiRating",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${il.visuallyHidden}`]: t.visuallyHidden
    }, t.root, t[`size${re(r.size)}`], r.readOnly && t.readOnly];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-flex",
  // Required to position the pristine input absolutely
  position: "relative",
  fontSize: e.typography.pxToRem(24),
  color: "#faaf00",
  cursor: "pointer",
  textAlign: "left",
  width: "min-content",
  WebkitTapHighlightColor: "transparent",
  [`&.${il.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    pointerEvents: "none"
  },
  [`&.${il.focusVisible} .${il.iconActive}`]: {
    outline: "1px solid #999"
  },
  [`& .${il.visuallyHidden}`]: U2,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(30)
    }
  }, {
    // TODO v6: use the .Mui-readOnly global state class
    props: ({
      ownerState: t
    }) => t.readOnly,
    style: {
      pointerEvents: "none"
    }
  }]
}))), mO = Y("label", {
  name: "MuiRating",
  slot: "Label",
  overridesResolver: ({
    ownerState: e
  }, t) => [t.label, e.emptyValueFocused && t.labelEmptyValueActive]
})({
  cursor: "inherit",
  variants: [{
    props: ({
      ownerState: e
    }) => e.emptyValueFocused,
    style: {
      top: 0,
      bottom: 0,
      position: "absolute",
      outline: "1px solid #999",
      width: "100%"
    }
  }]
}), GV = Y("span", {
  name: "MuiRating",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.icon, r.iconEmpty && t.iconEmpty, r.iconFilled && t.iconFilled, r.iconHover && t.iconHover, r.iconFocus && t.iconFocus, r.iconActive && t.iconActive];
  }
})($e(({
  theme: e
}) => ({
  // Fit wrapper to actual icon size.
  display: "flex",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => t.iconActive,
    style: {
      transform: "scale(1.2)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.iconEmpty,
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }]
}))), qV = Y("span", {
  name: "MuiRating",
  slot: "Decimal",
  shouldForwardProp: (e) => jl(e) && e !== "iconActive",
  overridesResolver: (e, t) => {
    const {
      iconActive: r
    } = e;
    return [t.decimal, r && t.iconActive];
  }
})({
  position: "relative",
  variants: [{
    props: ({
      iconActive: e
    }) => e,
    style: {
      transform: "scale(1.2)"
    }
  }]
});
function hO(e) {
  const {
    value: t,
    ...r
  } = e;
  return /* @__PURE__ */ P.jsx("span", {
    ...r
  });
}
process.env.NODE_ENV !== "production" && (hO.propTypes = {
  value: n.number.isRequired
});
function $g(e) {
  const {
    classes: t,
    disabled: r,
    emptyIcon: o,
    focus: a,
    getLabelText: i,
    highlightSelectedOnly: l,
    hover: c,
    icon: d,
    IconContainerComponent: p,
    isActive: f,
    itemValue: h,
    labelProps: g,
    name: y,
    onBlur: C,
    onChange: b,
    onClick: v,
    onFocus: T,
    readOnly: R,
    ownerState: $,
    ratingValue: E,
    ratingValueRounded: S,
    slots: k = {},
    slotProps: A = {}
  } = e, _ = l ? h === E : h <= E, L = h <= c, O = h <= a, F = h === S, B = `${y}-${eo()}`, M = {
    slots: k,
    slotProps: A
  }, [j, W] = ze("icon", {
    elementType: GV,
    className: ge(t.icon, _ ? t.iconFilled : t.iconEmpty, L && t.iconHover, O && t.iconFocus, f && t.iconActive),
    externalForwardedProps: M,
    ownerState: {
      ...$,
      iconEmpty: !_,
      iconFilled: _,
      iconHover: L,
      iconFocus: O,
      iconActive: f
    },
    additionalProps: {
      value: h
    },
    internalForwardedProps: {
      // TODO: remove this in v7 because `IconContainerComponent` is deprecated
      // only forward if `slots.icon` is NOT provided
      as: p
    }
  }), [V, X] = ze("label", {
    elementType: mO,
    externalForwardedProps: M,
    ownerState: {
      ...$,
      emptyValueFocused: void 0
    },
    additionalProps: {
      style: g?.style,
      htmlFor: B
    }
  }), U = /* @__PURE__ */ P.jsx(j, {
    ...W,
    children: o && !_ ? o : d
  });
  return R ? /* @__PURE__ */ P.jsx("span", {
    ...g,
    children: U
  }) : /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsxs(V, {
      ...X,
      children: [U, /* @__PURE__ */ P.jsx("span", {
        className: t.visuallyHidden,
        children: i(h)
      })]
    }), /* @__PURE__ */ P.jsx("input", {
      className: t.visuallyHidden,
      onFocus: T,
      onBlur: C,
      onChange: b,
      onClick: v,
      disabled: r,
      value: h,
      id: B,
      type: "radio",
      name: y,
      checked: F
    })]
  });
}
process.env.NODE_ENV !== "production" && ($g.propTypes = {
  classes: n.object.isRequired,
  disabled: n.bool.isRequired,
  emptyIcon: n.node,
  focus: n.number.isRequired,
  getLabelText: n.func.isRequired,
  highlightSelectedOnly: n.bool.isRequired,
  hover: n.number.isRequired,
  icon: n.node,
  IconContainerComponent: n.elementType.isRequired,
  isActive: n.bool.isRequired,
  itemValue: n.number.isRequired,
  labelProps: n.object,
  name: n.string,
  onBlur: n.func.isRequired,
  onChange: n.func.isRequired,
  onClick: n.func.isRequired,
  onFocus: n.func.isRequired,
  ownerState: n.object.isRequired,
  ratingValue: n.number,
  ratingValueRounded: n.number,
  readOnly: n.bool.isRequired,
  slotProps: n.object,
  slots: n.object
});
const KV = /* @__PURE__ */ P.jsx(zV, {
  fontSize: "inherit"
}), YV = /* @__PURE__ */ P.jsx(VV, {
  fontSize: "inherit"
});
function ZV(e) {
  return `${e || "0"} Star${e !== 1 ? "s" : ""}`;
}
const gO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiRating",
    props: t
  }), {
    component: a = "span",
    className: i,
    defaultValue: l = null,
    disabled: c = !1,
    emptyIcon: d = YV,
    emptyLabelText: p = "Empty",
    getLabelText: f = ZV,
    highlightSelectedOnly: h = !1,
    icon: g = KV,
    IconContainerComponent: y = hO,
    max: C = 5,
    name: b,
    onChange: v,
    onChangeActive: T,
    onMouseLeave: R,
    onMouseMove: $,
    precision: E = 1,
    readOnly: S = !1,
    size: k = "medium",
    value: A,
    slots: _ = {},
    slotProps: L = {},
    ...O
  } = o, F = eo(b), [B, M] = Bn({
    controlled: A,
    default: l,
    name: "Rating"
  }), j = fh(B, E), W = la(), [{
    hover: V,
    focus: X
  }, U] = x.useState({
    hover: -1,
    focus: -1
  });
  let H = j;
  V !== -1 && (H = V), X !== -1 && (H = X);
  const [Z, G] = x.useState(!1), ye = x.useRef(), de = Jt(ye, r), ne = (se) => {
    $ && $(se);
    const ue = ye.current, {
      right: Qe,
      left: We,
      width: be
    } = ue.getBoundingClientRect();
    let Se;
    W ? Se = (Qe - se.clientX) / be : Se = (se.clientX - We) / be;
    let De = fh(C * Se + E / 2, E);
    De = Oi(De, E, C), U((Ye) => Ye.hover === De && Ye.focus === De ? Ye : {
      hover: De,
      focus: De
    }), G(!1), T && V !== De && T(se, De);
  }, fe = (se) => {
    R && R(se);
    const ue = -1;
    U({
      hover: ue,
      focus: ue
    }), T && V !== ue && T(se, ue);
  }, ie = (se) => {
    let ue = se.target.value === "" ? null : parseFloat(se.target.value);
    V !== -1 && (ue = V), M(ue), v && v(se, ue);
  }, oe = (se) => {
    se.clientX === 0 && se.clientY === 0 || (U({
      hover: -1,
      focus: -1
    }), M(null), v && parseFloat(se.target.value) === j && v(se, null));
  }, ce = (se) => {
    Ra(se.target) && G(!0);
    const ue = parseFloat(se.target.value);
    U((Qe) => ({
      hover: Qe.hover,
      focus: ue
    }));
  }, Ce = (se) => {
    if (V !== -1)
      return;
    Ra(se.target) || G(!1);
    const ue = -1;
    U((Qe) => ({
      hover: Qe.hover,
      focus: ue
    }));
  }, [xe, Re] = x.useState(!1), J = {
    ...o,
    component: a,
    defaultValue: l,
    disabled: c,
    emptyIcon: d,
    emptyLabelText: p,
    emptyValueFocused: xe,
    focusVisible: Z,
    getLabelText: f,
    icon: g,
    IconContainerComponent: y,
    max: C,
    precision: E,
    readOnly: S,
    size: k
  }, Ie = UV(J), le = {
    slots: _,
    slotProps: L
  }, [qe, q] = ze("root", {
    ref: de,
    className: ge(Ie.root, i),
    elementType: HV,
    externalForwardedProps: {
      ...le,
      ...O,
      component: a
    },
    getSlotProps: (se) => ({
      ...se,
      onMouseMove: (ue) => {
        ne(ue), se.onMouseMove?.(ue);
      },
      onMouseLeave: (ue) => {
        fe(ue), se.onMouseLeave?.(ue);
      }
    }),
    ownerState: J,
    additionalProps: {
      role: S ? "img" : null,
      "aria-label": S ? f(H) : null
    }
  }), [K, ee] = ze("label", {
    className: ge(Ie.label, Ie.labelEmptyValue),
    elementType: mO,
    externalForwardedProps: le,
    ownerState: J
  }), [he, we] = ze("decimal", {
    className: Ie.decimal,
    elementType: qV,
    externalForwardedProps: le,
    ownerState: J
  });
  return /* @__PURE__ */ P.jsxs(qe, {
    ...q,
    children: [Array.from(new Array(C)).map((se, ue) => {
      const Qe = ue + 1, We = {
        classes: Ie,
        disabled: c,
        emptyIcon: d,
        focus: X,
        getLabelText: f,
        highlightSelectedOnly: h,
        hover: V,
        icon: g,
        IconContainerComponent: y,
        name: F,
        onBlur: Ce,
        onChange: ie,
        onClick: oe,
        onFocus: ce,
        ratingValue: H,
        ratingValueRounded: j,
        readOnly: S,
        ownerState: J,
        slots: _,
        slotProps: L
      }, be = Qe === Math.ceil(H) && (V !== -1 || X !== -1);
      if (E < 1) {
        const Se = Array.from(new Array(1 / E));
        return /* @__PURE__ */ QS(he, {
          ...we,
          key: Qe,
          className: ge(we.className, be && Ie.iconActive),
          iconActive: be
        }, Se.map((De, Ye) => {
          const et = fh(Qe - 1 + (Ye + 1) * E, E);
          return /* @__PURE__ */ P.jsx($g, {
            ...We,
            // The icon is already displayed as active
            isActive: !1,
            itemValue: et,
            labelProps: {
              style: Se.length - 1 === Ye ? {} : {
                width: et === H ? `${(Ye + 1) * E * 100}%` : "0%",
                overflow: "hidden",
                position: "absolute"
              }
            }
          }, et);
        }));
      }
      return /* @__PURE__ */ P.jsx($g, {
        ...We,
        isActive: be,
        itemValue: Qe
      }, Qe);
    }), !S && !c && /* @__PURE__ */ P.jsxs(K, {
      ...ee,
      children: [/* @__PURE__ */ P.jsx("input", {
        className: Ie.visuallyHidden,
        value: "",
        id: `${F}-empty`,
        type: "radio",
        name: F,
        checked: j == null,
        onFocus: () => Re(!0),
        onBlur: () => Re(!1),
        onChange: ie
      }), /* @__PURE__ */ P.jsx("span", {
        className: Ie.visuallyHidden,
        children: p
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (gO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The default value. Use when the component is not controlled.
   * @default null
   */
  defaultValue: n.number,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */
  emptyIcon: n.node,
  /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */
  emptyLabelText: n.node,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
   * }
   */
  getLabelText: n.func,
  /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */
  highlightSelectedOnly: n.bool,
  /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */
  icon: n.node,
  /**
   * The component containing the icon.
   * @deprecated Use `slotProps.icon.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */
  IconContainerComponent: n.elementType,
  /**
   * Maximum rating.
   * @default 5
   */
  max: n.number,
  /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generate IDs.
   */
  name: n.string,
  /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */
  onChange: n.func,
  /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * @ignore
   */
  onMouseMove: n.func,
  /**
   * The minimum increment value change allowed.
   * @default 1
   */
  precision: tn(n.number, (e) => e.precision < 0.1 ? new Error(["MUI: The prop `precision` should be above 0.1.", "A value below this limit has an imperceptible impact."].join(`
`)) : null),
  /**
   * Removes all hover effects and pointer events.
   * @default false
   */
  readOnly: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    decimal: n.oneOfType([n.func, n.object]),
    icon: n.oneOfType([n.func, n.object]),
    label: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    decimal: n.elementType,
    icon: n.elementType,
    label: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The rating value.
   */
  value: n.number
});
function bO(e) {
  return Ae("MuiScopedCssBaseline", e);
}
const XV = Ne("MuiScopedCssBaseline", ["root"]), JV = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, bO, t);
}, QV = Y("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => {
  const t = {};
  return e.colorSchemes && Object.entries(e.colorSchemes).forEach(([r, o]) => {
    const a = e.getColorSchemeSelector(r);
    a.startsWith("@") ? t[a] = {
      colorScheme: o.palette?.mode
    } : t[`&${a.replace(/\s*&/, "")}`] = {
      colorScheme: o.palette?.mode
    };
  }), {
    ...jT(e, !1),
    ...zT(e),
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    },
    variants: [{
      props: {
        enableColorScheme: !0
      },
      style: e.vars ? t : {
        colorScheme: e.palette.mode
      }
    }]
  };
})), yO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: a,
    component: i = "div",
    enableColorScheme: l,
    ...c
  } = o, d = {
    ...o,
    component: i
  }, p = JV(d);
  return /* @__PURE__ */ P.jsx(QV, {
    as: i,
    className: ge(p.root, a),
    ref: r,
    ownerState: d,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (yO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function vy(e) {
  return Ae("MuiSelect", e);
}
const sl = Ne("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var EC;
const eW = Y(JE, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${sl.select}`]: t.select
      },
      {
        [`&.${sl.select}`]: t[r.variant]
      },
      {
        [`&.${sl.error}`]: t.error
      },
      {
        [`&.${sl.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${sl.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), tW = Y(QE, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.icon, r.variant && t[`icon${re(r.variant)}`], r.open && t.iconOpen];
  }
})({}), rW = Y("input", {
  shouldForwardProp: (e) => jl(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function OC(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function nW(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const oW = (e) => {
  const {
    classes: t,
    variant: r,
    disabled: o,
    multiple: a,
    open: i,
    error: l
  } = e, c = {
    select: ["select", r, o && "disabled", a && "multiple", l && "error"],
    icon: ["icon", `icon${re(r)}`, i && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Me(c, vy, t);
}, vO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    "aria-describedby": o,
    "aria-label": a,
    autoFocus: i,
    autoWidth: l,
    children: c,
    className: d,
    defaultOpen: p,
    defaultValue: f,
    disabled: h,
    displayEmpty: g,
    error: y = !1,
    IconComponent: C,
    inputRef: b,
    labelId: v,
    MenuProps: T = {},
    multiple: R,
    name: $,
    onBlur: E,
    onChange: S,
    onClose: k,
    onFocus: A,
    onOpen: _,
    open: L,
    readOnly: O,
    renderValue: F,
    required: B,
    SelectDisplayProps: M = {},
    tabIndex: j,
    // catching `type` from Input which makes no sense for SelectInput
    type: W,
    value: V,
    variant: X = "standard",
    ...U
  } = t, [H, Z] = Bn({
    controlled: V,
    default: f,
    name: "Select"
  }), [G, ye] = Bn({
    controlled: L,
    default: p,
    name: "Select"
  }), de = x.useRef(null), ne = x.useRef(null), [fe, ie] = x.useState(null), {
    current: oe
  } = x.useRef(L != null), [ce, Ce] = x.useState(), xe = Jt(r, b), Re = x.useCallback((He) => {
    ne.current = He, He && ie(He);
  }, []), J = fe?.parentNode;
  x.useImperativeHandle(xe, () => ({
    focus: () => {
      ne.current.focus();
    },
    node: de.current,
    value: H
  }), [H]), x.useEffect(() => {
    p && G && fe && !oe && (Ce(l ? null : J.clientWidth), ne.current.focus());
  }, [fe, l]), x.useEffect(() => {
    i && ne.current.focus();
  }, [i]), x.useEffect(() => {
    if (!v)
      return;
    const He = Rr(ne.current).getElementById(v);
    if (He) {
      const Oe = () => {
        getSelection().isCollapsed && ne.current.focus();
      };
      return He.addEventListener("click", Oe), () => {
        He.removeEventListener("click", Oe);
      };
    }
  }, [v]);
  const Ie = (He, Oe) => {
    He ? _ && _(Oe) : k && k(Oe), oe || (Ce(l ? null : J.clientWidth), ye(He));
  }, le = (He) => {
    He.button === 0 && (He.preventDefault(), ne.current.focus(), Ie(!0, He));
  }, qe = (He) => {
    Ie(!1, He);
  }, q = x.Children.toArray(c), K = (He) => {
    const Oe = q.find((Ze) => Ze.props.value === He.target.value);
    Oe !== void 0 && (Z(Oe.props.value), S && S(He, Oe));
  }, ee = (He) => (Oe) => {
    let Ze;
    if (Oe.currentTarget.hasAttribute("tabindex")) {
      if (R) {
        Ze = Array.isArray(H) ? H.slice() : [];
        const Pt = H.indexOf(He.props.value);
        Pt === -1 ? Ze.push(He.props.value) : Ze.splice(Pt, 1);
      } else
        Ze = He.props.value;
      if (He.props.onClick && He.props.onClick(Oe), H !== Ze && (Z(Ze), S)) {
        const Pt = Oe.nativeEvent || Oe, Mt = new Pt.constructor(Pt.type, Pt);
        Object.defineProperty(Mt, "target", {
          writable: !0,
          value: {
            value: Ze,
            name: $
          }
        }), S(Mt, He);
      }
      R || Ie(!1, Oe);
    }
  }, he = (He) => {
    O || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(He.key) && (He.preventDefault(), Ie(!0, He));
  }, we = fe !== null && G, se = (He) => {
    !we && E && (Object.defineProperty(He, "target", {
      writable: !0,
      value: {
        value: H,
        name: $
      }
    }), E(He));
  };
  delete U["aria-invalid"];
  let ue, Qe;
  const We = [];
  let be = !1, Se = !1;
  (vp({
    value: H
  }) || g) && (F ? ue = F(H) : be = !0);
  const De = q.map((He) => {
    if (!/* @__PURE__ */ x.isValidElement(He))
      return null;
    process.env.NODE_ENV !== "production" && zn.isFragment(He) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Oe;
    if (R) {
      if (!Array.isArray(H))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : jn(2));
      Oe = H.some((Ze) => OC(Ze, He.props.value)), Oe && be && We.push(He.props.children);
    } else
      Oe = OC(H, He.props.value), Oe && be && (Qe = He.props.children);
    return Oe && (Se = !0), /* @__PURE__ */ x.cloneElement(He, {
      "aria-selected": Oe ? "true" : "false",
      onClick: ee(He),
      onKeyUp: (Ze) => {
        Ze.key === " " && Ze.preventDefault(), He.props.onKeyUp && He.props.onKeyUp(Ze);
      },
      role: "option",
      selected: Oe,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": He.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!Se && !R && H !== "") {
      const He = q.map((Oe) => Oe.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${H}\` for the select ${$ ? `(name="${$}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${He.filter((Oe) => Oe != null).map((Oe) => `\`${Oe}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Se, q, R, $, H]), be && (R ? We.length === 0 ? ue = null : ue = We.reduce((He, Oe, Ze) => (He.push(Oe), Ze < We.length - 1 && He.push(", "), He), []) : ue = Qe);
  let Ye = ce;
  !l && oe && fe && (Ye = J.clientWidth);
  let et;
  typeof j < "u" ? et = j : et = h ? null : 0;
  const Je = M.id || ($ ? `mui-component-select-${$}` : void 0), tt = {
    ...t,
    variant: X,
    value: H,
    open: we,
    error: y
  }, Rt = oW(tt), xt = {
    ...T.PaperProps,
    ...T.slotProps?.paper
  }, rt = eo();
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx(eW, {
      as: "div",
      ref: Re,
      tabIndex: et,
      role: "combobox",
      "aria-controls": we ? rt : void 0,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": we ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": a,
      "aria-labelledby": [v, Je].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      "aria-required": B ? "true" : void 0,
      "aria-invalid": y ? "true" : void 0,
      onKeyDown: he,
      onMouseDown: h || O ? null : le,
      onBlur: se,
      onFocus: A,
      ...M,
      ownerState: tt,
      className: ge(M.className, Rt.select, d),
      id: Je,
      children: nW(ue) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        EC || (EC = /* @__PURE__ */ P.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : ue
    }), /* @__PURE__ */ P.jsx(rW, {
      "aria-invalid": y,
      value: Array.isArray(H) ? H.join(",") : H,
      name: $,
      ref: de,
      "aria-hidden": !0,
      onChange: K,
      tabIndex: -1,
      disabled: h,
      className: Rt.nativeInput,
      autoFocus: i,
      required: B,
      ...U,
      ownerState: tt
    }), /* @__PURE__ */ P.jsx(tW, {
      as: C,
      className: Rt.icon,
      ownerState: tt
    }), /* @__PURE__ */ P.jsx(dy, {
      id: `menu-${$ || ""}`,
      anchorEl: J,
      open: we,
      onClose: qe,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...T,
      slotProps: {
        ...T.slotProps,
        list: {
          "aria-labelledby": v,
          role: "listbox",
          "aria-multiselectable": R ? "true" : void 0,
          disableListWrap: !0,
          id: rt,
          ...T.MenuListProps
        },
        paper: {
          ...xt,
          style: {
            minWidth: Ye,
            ...xt != null ? xt.style : null
          }
        }
      },
      children: De
    })]
  });
});
process.env.NODE_ENV !== "production" && (vO.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": n.string,
  /**
   * @ignore
   */
  "aria-label": n.string,
  /**
   * @ignore
   */
  autoFocus: n.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: n.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The CSS class name of the select element.
   */
  className: n.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: n.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: n.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: n.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: n.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: On,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: n.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: n.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: n.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * @ignore
   */
  readOnly: n.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: n.func,
  /**
   * If `true`, the component is required.
   */
  required: n.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: n.object,
  /**
   * @ignore
   */
  tabIndex: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  type: n.any,
  /**
   * The input value.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["standard", "outlined", "filled"])
});
const aW = (e) => {
  const {
    classes: t
  } = e, o = Me({
    root: ["root"]
  }, vy, t);
  return {
    ...t,
    ...o
  };
}, xy = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Zr(e) && e !== "variant",
  slot: "Root"
}, iW = Y(Vl, xy)(""), sW = Y(yu, xy)(""), lW = Y(bu, xy)(""), vu = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: a = !1,
    children: i,
    classes: l = {},
    className: c,
    defaultOpen: d = !1,
    displayEmpty: p = !1,
    IconComponent: f = Wb,
    id: h,
    input: g,
    inputProps: y,
    label: C,
    labelId: b,
    MenuProps: v,
    multiple: T = !1,
    native: R = !1,
    onClose: $,
    onOpen: E,
    open: S,
    renderValue: k,
    SelectDisplayProps: A,
    variant: _ = "outlined",
    ...L
  } = o, O = R ? my : vO, F = ko(), B = si({
    props: o,
    muiFormControl: F,
    states: ["variant", "error"]
  }), M = B.variant || _, j = {
    ...o,
    variant: M,
    classes: l
  }, W = aW(j), {
    root: V,
    ...X
  } = W, U = g || {
    standard: /* @__PURE__ */ P.jsx(iW, {
      ownerState: j
    }),
    outlined: /* @__PURE__ */ P.jsx(sW, {
      label: C,
      ownerState: j
    }),
    filled: /* @__PURE__ */ P.jsx(lW, {
      ownerState: j
    })
  }[M], H = Jt(r, ii(U));
  return /* @__PURE__ */ P.jsx(x.Fragment, {
    children: /* @__PURE__ */ x.cloneElement(U, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: O,
      inputProps: {
        children: i,
        error: B.error,
        IconComponent: f,
        variant: M,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: T,
        ...R ? {
          id: h
        } : {
          autoWidth: a,
          defaultOpen: d,
          displayEmpty: p,
          labelId: b,
          MenuProps: v,
          onClose: $,
          onOpen: E,
          open: S,
          renderValue: k,
          SelectDisplayProps: {
            id: h,
            ...A
          }
        },
        ...y,
        classes: y ? sn(X, y.classes) : X,
        ...g ? g.props.inputProps : {}
      },
      ...(T && R || p) && M === "outlined" ? {
        notched: !0
      } : {},
      ref: H,
      className: ge(U.props.className, c, W.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!g && {
        variant: M
      },
      ...L
    })
  });
});
process.env.NODE_ENV !== "production" && (vu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: n.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: n.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: n.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: n.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: n.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: n.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: n.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: n.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: n.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: n.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: n.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: n.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: n.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: n.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: n.oneOfType([n.oneOf([""]), n.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
vu.muiName = "Select";
function xO(e) {
  return Ae("MuiSkeleton", e);
}
const cW = Ne("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]), uW = (e) => {
  const {
    classes: t,
    variant: r,
    animation: o,
    hasChildren: a,
    width: i,
    height: l
  } = e;
  return Me({
    root: ["root", r, o, a && "withChildren", a && !i && "fitContent", a && !l && "heightAuto"]
  }, xO, t);
}, Rg = Ro`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, Pg = Ro`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, dW = typeof Rg != "string" ? oi`
        animation: ${Rg} 2s ease-in-out 0.5s infinite;
      ` : null, pW = typeof Pg != "string" ? oi`
        &::after {
          animation: ${Pg} 2s linear 0.5s infinite;
        }
      ` : null, fW = Y("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], r.animation !== !1 && t[r.animation], r.hasChildren && t.withChildren, r.hasChildren && !r.width && t.fitContent, r.hasChildren && !r.height && t.heightAuto];
  }
})($e(({
  theme: e
}) => {
  const t = Ob(e.shape.borderRadius) || "px", r = Ya(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : dt(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${r}${t}/${Math.round(r / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: dW || {
        animation: `${Rg} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: pW || {
        "&::after": {
          animation: `${Pg} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), CO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: a = "pulse",
    className: i,
    component: l = "span",
    height: c,
    style: d,
    variant: p = "text",
    width: f,
    ...h
  } = o, g = {
    ...o,
    animation: a,
    component: l,
    variant: p,
    hasChildren: !!h.children
  }, y = uW(g);
  return /* @__PURE__ */ P.jsx(fW, {
    as: l,
    ref: r,
    className: ge(y.root, i),
    ownerState: g,
    ...h,
    style: {
      width: f,
      height: c,
      ...d
    }
  });
});
process.env.NODE_ENV !== "production" && (CO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: n.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rectangular", "rounded", "text"]), n.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: n.oneOfType([n.number, n.string])
});
function mW(e, t, r = (o, a) => o === a) {
  return e.length === t.length && e.every((o, a) => r(o, t[a]));
}
const hW = 2;
function el(e, t, r, o, a) {
  return r === 1 ? Math.min(e + t, a) : Math.max(e - t, o);
}
function SO(e, t) {
  return e - t;
}
function $C(e, t) {
  const {
    index: r
  } = e.reduce((o, a, i) => {
    const l = Math.abs(t - a);
    return o === null || l < o.distance || l === o.distance ? {
      distance: l,
      index: i
    } : o;
  }, null) ?? {};
  return r;
}
function Td(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const r = e;
    for (let o = 0; o < r.changedTouches.length; o += 1) {
      const a = r.changedTouches[o];
      if (a.identifier === t.current)
        return {
          x: a.clientX,
          y: a.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Cp(e, t, r) {
  return (e - t) * 100 / (r - t);
}
function gW(e, t, r) {
  return (r - t) * e + t;
}
function bW(e) {
  if (Math.abs(e) < 1) {
    const r = e.toExponential().split("e-"), o = r[0].split(".")[1];
    return (o ? o.length : 0) + parseInt(r[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function yW(e, t, r) {
  const o = Math.round((e - r) / t) * t + r;
  return Number(o.toFixed(bW(t)));
}
function RC({
  values: e,
  newValue: t,
  index: r
}) {
  const o = e.slice();
  return o[r] = t, o.sort(SO);
}
function Ed({
  sliderRef: e,
  activeIndex: t,
  setActive: r
}) {
  const o = Rr(e.current);
  (!e.current?.contains(o.activeElement) || Number(o?.activeElement?.getAttribute("data-index")) !== t) && e.current?.querySelector(`[type="range"][data-index="${t}"]`).focus(), r && r(t);
}
function Od(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? mW(e, t) : !1;
}
const vW = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, xW = (e) => e;
let $d;
function PC() {
  return $d === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? $d = CSS.supports("touch-action", "none") : $d = !0), $d;
}
function CW(e) {
  const {
    "aria-labelledby": t,
    defaultValue: r,
    disabled: o = !1,
    disableSwap: a = !1,
    isRtl: i = !1,
    marks: l = !1,
    max: c = 100,
    min: d = 0,
    name: p,
    onChange: f,
    onChangeCommitted: h,
    orientation: g = "horizontal",
    rootRef: y,
    scale: C = xW,
    step: b = 1,
    shiftStep: v = 10,
    tabIndex: T,
    value: R
  } = e, $ = x.useRef(void 0), [E, S] = x.useState(-1), [k, A] = x.useState(-1), [_, L] = x.useState(!1), O = x.useRef(0), F = x.useRef(null), [B, M] = Bn({
    controlled: R,
    default: r ?? d,
    name: "Slider"
  }), j = f && ((be, Se, De) => {
    const Ye = be.nativeEvent || be, et = new Ye.constructor(Ye.type, Ye);
    Object.defineProperty(et, "target", {
      writable: !0,
      value: {
        value: Se,
        name: p
      }
    }), F.current = Se, f(et, Se, De);
  }), W = Array.isArray(B);
  let V = W ? B.slice().sort(SO) : [B];
  V = V.map((be) => be == null ? d : Oi(be, d, c));
  const X = l === !0 && b !== null ? [...Array(Math.floor((c - d) / b) + 1)].map((be, Se) => ({
    value: d + b * Se
  })) : l || [], U = X.map((be) => be.value), [H, Z] = x.useState(-1), G = x.useRef(null), ye = Jt(y, G), de = (be) => (Se) => {
    const De = Number(Se.currentTarget.getAttribute("data-index"));
    Ra(Se.target) && Z(De), A(De), be?.onFocus?.(Se);
  }, ne = (be) => (Se) => {
    Ra(Se.target) || Z(-1), A(-1), be?.onBlur?.(Se);
  }, fe = (be, Se) => {
    const De = Number(be.currentTarget.getAttribute("data-index")), Ye = V[De], et = U.indexOf(Ye);
    let Je = Se;
    if (X && b == null) {
      const tt = U[U.length - 1];
      Je >= tt ? Je = tt : Je <= U[0] ? Je = U[0] : Je = Je < Ye ? U[et - 1] : U[et + 1];
    }
    if (Je = Oi(Je, d, c), W) {
      a && (Je = Oi(Je, V[De - 1] || -1 / 0, V[De + 1] || 1 / 0));
      const tt = Je;
      Je = RC({
        values: V,
        newValue: Je,
        index: De
      });
      let Rt = De;
      a || (Rt = Je.indexOf(tt)), Ed({
        sliderRef: G,
        activeIndex: Rt
      });
    }
    M(Je), Z(De), j && !Od(Je, B) && j(be, Je, De), h && h(be, F.current ?? Je);
  }, ie = (be) => (Se) => {
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(Se.key)) {
      Se.preventDefault();
      const De = Number(Se.currentTarget.getAttribute("data-index")), Ye = V[De];
      let et = null;
      if (b != null) {
        const Je = Se.shiftKey ? v : b;
        switch (Se.key) {
          case "ArrowUp":
            et = el(Ye, Je, 1, d, c);
            break;
          case "ArrowRight":
            et = el(Ye, Je, i ? -1 : 1, d, c);
            break;
          case "ArrowDown":
            et = el(Ye, Je, -1, d, c);
            break;
          case "ArrowLeft":
            et = el(Ye, Je, i ? 1 : -1, d, c);
            break;
          case "PageUp":
            et = el(Ye, v, 1, d, c);
            break;
          case "PageDown":
            et = el(Ye, v, -1, d, c);
            break;
          case "Home":
            et = d;
            break;
          case "End":
            et = c;
            break;
        }
      } else if (X) {
        const Je = U[U.length - 1], tt = U.indexOf(Ye), Rt = [i ? "ArrowRight" : "ArrowLeft", "ArrowDown", "PageDown", "Home"], xt = [i ? "ArrowLeft" : "ArrowRight", "ArrowUp", "PageUp", "End"];
        Rt.includes(Se.key) ? tt === 0 ? et = U[0] : et = U[tt - 1] : xt.includes(Se.key) && (tt === U.length - 1 ? et = Je : et = U[tt + 1]);
      }
      et != null && fe(Se, et);
    }
    be?.onKeyDown?.(Se);
  };
  en(() => {
    o && G.current.contains(document.activeElement) && document.activeElement?.blur();
  }, [o]), o && E !== -1 && S(-1), o && H !== -1 && Z(-1);
  const oe = (be) => (Se) => {
    be.onChange?.(Se), fe(Se, Se.target.valueAsNumber);
  }, ce = x.useRef(void 0);
  let Ce = g;
  i && g === "horizontal" && (Ce += "-reverse");
  const xe = ({
    finger: be,
    move: Se = !1
  }) => {
    const {
      current: De
    } = G, {
      width: Ye,
      height: et,
      bottom: Je,
      left: tt
    } = De.getBoundingClientRect();
    let Rt;
    Ce.startsWith("vertical") ? Rt = (Je - be.y) / et : Rt = (be.x - tt) / Ye, Ce.includes("-reverse") && (Rt = 1 - Rt);
    let xt;
    if (xt = gW(Rt, d, c), b)
      xt = yW(xt, b, d);
    else {
      const He = $C(U, xt);
      xt = U[He];
    }
    xt = Oi(xt, d, c);
    let rt = 0;
    if (W) {
      Se ? rt = ce.current : rt = $C(V, xt), a && (xt = Oi(xt, V[rt - 1] || -1 / 0, V[rt + 1] || 1 / 0));
      const He = xt;
      xt = RC({
        values: V,
        newValue: xt,
        index: rt
      }), a && Se || (rt = xt.indexOf(He), ce.current = rt);
    }
    return {
      newValue: xt,
      activeIndex: rt
    };
  }, Re = Pr((be) => {
    const Se = Td(be, $);
    if (!Se)
      return;
    if (O.current += 1, be.type === "mousemove" && be.buttons === 0) {
      J(be);
      return;
    }
    const {
      newValue: De,
      activeIndex: Ye
    } = xe({
      finger: Se,
      move: !0
    });
    Ed({
      sliderRef: G,
      activeIndex: Ye,
      setActive: S
    }), M(De), !_ && O.current > hW && L(!0), j && !Od(De, B) && j(be, De, Ye);
  }), J = Pr((be) => {
    const Se = Td(be, $);
    if (L(!1), !Se)
      return;
    const {
      newValue: De
    } = xe({
      finger: Se,
      move: !0
    });
    S(-1), be.type === "touchend" && A(-1), h && h(be, F.current ?? De), $.current = void 0, le();
  }), Ie = Pr((be) => {
    if (o)
      return;
    PC() || be.preventDefault();
    const Se = be.changedTouches[0];
    Se != null && ($.current = Se.identifier);
    const De = Td(be, $);
    if (De !== !1) {
      const {
        newValue: et,
        activeIndex: Je
      } = xe({
        finger: De
      });
      Ed({
        sliderRef: G,
        activeIndex: Je,
        setActive: S
      }), M(et), j && !Od(et, B) && j(be, et, Je);
    }
    O.current = 0;
    const Ye = Rr(G.current);
    Ye.addEventListener("touchmove", Re, {
      passive: !0
    }), Ye.addEventListener("touchend", J, {
      passive: !0
    });
  }), le = x.useCallback(() => {
    const be = Rr(G.current);
    be.removeEventListener("mousemove", Re), be.removeEventListener("mouseup", J), be.removeEventListener("touchmove", Re), be.removeEventListener("touchend", J);
  }, [J, Re]);
  x.useEffect(() => {
    const {
      current: be
    } = G;
    return be.addEventListener("touchstart", Ie, {
      passive: PC()
    }), () => {
      be.removeEventListener("touchstart", Ie), le();
    };
  }, [le, Ie]), x.useEffect(() => {
    o && le();
  }, [o, le]);
  const qe = (be) => (Se) => {
    if (be.onMouseDown?.(Se), o || Se.defaultPrevented || Se.button !== 0)
      return;
    Se.preventDefault();
    const De = Td(Se, $);
    if (De !== !1) {
      const {
        newValue: et,
        activeIndex: Je
      } = xe({
        finger: De
      });
      Ed({
        sliderRef: G,
        activeIndex: Je,
        setActive: S
      }), M(et), j && !Od(et, B) && j(Se, et, Je);
    }
    O.current = 0;
    const Ye = Rr(G.current);
    Ye.addEventListener("mousemove", Re, {
      passive: !0
    }), Ye.addEventListener("mouseup", J);
  }, q = Cp(W ? V[0] : d, d, c), K = Cp(V[V.length - 1], d, c) - q, ee = (be = {}) => {
    const Se = gs(be), De = {
      onMouseDown: qe(Se || {})
    }, Ye = {
      ...Se,
      ...De
    };
    return {
      ...be,
      ref: ye,
      ...Ye
    };
  }, he = (be) => (Se) => {
    be.onMouseOver?.(Se);
    const De = Number(Se.currentTarget.getAttribute("data-index"));
    A(De);
  }, we = (be) => (Se) => {
    be.onMouseLeave?.(Se), A(-1);
  }, se = (be = {}) => {
    const Se = gs(be), De = {
      onMouseOver: he(Se || {}),
      onMouseLeave: we(Se || {})
    };
    return {
      ...be,
      ...Se,
      ...De
    };
  }, ue = (be) => ({
    // So the non active thumb doesn't show its label on hover.
    pointerEvents: E !== -1 && E !== be ? "none" : void 0
  });
  let Qe;
  return g === "vertical" && (Qe = i ? "vertical-rl" : "vertical-lr"), {
    active: E,
    axis: Ce,
    axisProps: vW,
    dragging: _,
    focusedThumbIndex: H,
    getHiddenInputProps: (be = {}) => {
      const Se = gs(be), De = {
        onChange: oe(Se || {}),
        onFocus: de(Se || {}),
        onBlur: ne(Se || {}),
        onKeyDown: ie(Se || {})
      }, Ye = {
        ...Se,
        ...De
      };
      return {
        tabIndex: T,
        "aria-labelledby": t,
        "aria-orientation": g,
        "aria-valuemax": C(c),
        "aria-valuemin": C(d),
        name: p,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: o,
        ...be,
        ...Ye,
        style: {
          ...U2,
          direction: i ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%",
          writingMode: Qe
        }
      };
    },
    getRootProps: ee,
    getThumbProps: se,
    marks: X,
    open: k,
    range: W,
    rootRef: ye,
    trackLeap: K,
    trackOffset: q,
    values: V,
    getThumbStyle: ue
  };
}
const SW = (e) => !e || !ri(e);
function wO(e) {
  return Ae("MuiSlider", e);
}
const vo = Ne("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), wW = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: ge(t && vo.valueLabelOpen),
    circle: vo.valueLabelCircle,
    label: vo.valueLabelLabel
  };
};
function TO(e) {
  const {
    children: t,
    className: r,
    value: o
  } = e, a = wW(e);
  return t ? /* @__PURE__ */ x.cloneElement(t, {
    className: ge(t.props.className)
  }, /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [t.props.children, /* @__PURE__ */ P.jsx("span", {
      className: ge(a.offset, r),
      "aria-hidden": !0,
      children: /* @__PURE__ */ P.jsx("span", {
        className: a.circle,
        children: /* @__PURE__ */ P.jsx("span", {
          className: a.label,
          children: o
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (TO.propTypes = {
  children: n.element.isRequired,
  className: n.string,
  value: n.node
});
function kC(e) {
  return e;
}
const EO = Y("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`color${re(r.color)}`], r.size !== "medium" && t[`size${re(r.size)}`], r.marked && t.marked, r.orientation === "vertical" && t.vertical, r.track === "inverted" && t.trackInverted, r.track === !1 && t.trackFalse];
  }
})($e(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${vo.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${vo.dragging}`]: {
    [`& .${vo.thumb}, & .${vo.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), OO = Y("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), $O = Y("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})($e(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${t}Track`],
        borderColor: e.vars.palette.Slider[`${t}Track`]
      } : {
        backgroundColor: oa(e.palette[t].main, 0.62),
        borderColor: oa(e.palette[t].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: na(e.palette[t].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: na(e.palette[t].main, 0.5)
        })
      }
    }
  }))]
}))), RO = Y("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.thumb, t[`thumbColor${re(r.color)}`], r.size !== "medium" && t[`thumbSize${re(r.size)}`]];
  }
})($e(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${vo.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&:hover, &.${vo.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${dt(e.palette[t].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${vo.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${dt(e.palette[t].main, 0.16)}`
        }
      }
    }
  }))]
}))), Cy = Y(TO, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})($e(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${vo.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${vo.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})));
process.env.NODE_ENV !== "production" && (Cy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: n.element.isRequired,
  /**
   * @ignore
   */
  index: n.number.isRequired,
  /**
   * @ignore
   */
  open: n.bool.isRequired,
  /**
   * @ignore
   */
  value: n.node
});
const PO = Y("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => jl(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: r
    } = e;
    return [t.mark, r && t.markActive];
  }
})($e(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), kO = Y("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => jl(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), TW = (e) => {
  const {
    disabled: t,
    dragging: r,
    marked: o,
    orientation: a,
    track: i,
    classes: l,
    color: c,
    size: d
  } = e, p = {
    root: ["root", t && "disabled", r && "dragging", o && "marked", a === "vertical" && "vertical", i === "inverted" && "trackInverted", i === !1 && "trackFalse", c && `color${re(c)}`, d && `size${re(d)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", d && `thumbSize${re(d)}`, c && `thumbColor${re(c)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Me(p, wO, l);
}, EW = ({
  children: e
}) => e, AO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSlider"
  }), a = la(), {
    "aria-label": i,
    "aria-valuetext": l,
    "aria-labelledby": c,
    // eslint-disable-next-line react/prop-types
    component: d = "span",
    components: p = {},
    componentsProps: f = {},
    color: h = "primary",
    classes: g,
    className: y,
    disableSwap: C = !1,
    disabled: b = !1,
    getAriaLabel: v,
    getAriaValueText: T,
    marks: R = !1,
    max: $ = 100,
    min: E = 0,
    name: S,
    onChange: k,
    onChangeCommitted: A,
    orientation: _ = "horizontal",
    shiftStep: L = 10,
    size: O = "medium",
    step: F = 1,
    scale: B = kC,
    slotProps: M,
    slots: j,
    tabIndex: W,
    track: V = "normal",
    value: X,
    valueLabelDisplay: U = "off",
    valueLabelFormat: H = kC,
    ...Z
  } = o, G = {
    ...o,
    isRtl: a,
    max: $,
    min: E,
    classes: g,
    disabled: b,
    disableSwap: C,
    orientation: _,
    marks: R,
    color: h,
    size: O,
    step: F,
    shiftStep: L,
    scale: B,
    track: V,
    valueLabelDisplay: U,
    valueLabelFormat: H
  }, {
    axisProps: ye,
    getRootProps: de,
    getHiddenInputProps: ne,
    getThumbProps: fe,
    open: ie,
    active: oe,
    axis: ce,
    focusedThumbIndex: Ce,
    range: xe,
    dragging: Re,
    marks: J,
    values: Ie,
    trackOffset: le,
    trackLeap: qe,
    getThumbStyle: q
  } = CW({
    ...G,
    rootRef: r
  });
  G.marked = J.length > 0 && J.some((nt) => nt.label), G.dragging = Re, G.focusedThumbIndex = Ce;
  const K = TW(G), ee = j?.root ?? p.Root ?? EO, he = j?.rail ?? p.Rail ?? OO, we = j?.track ?? p.Track ?? $O, se = j?.thumb ?? p.Thumb ?? RO, ue = j?.valueLabel ?? p.ValueLabel ?? Cy, Qe = j?.mark ?? p.Mark ?? PO, We = j?.markLabel ?? p.MarkLabel ?? kO, be = j?.input ?? p.Input ?? "input", Se = M?.root ?? f.root, De = M?.rail ?? f.rail, Ye = M?.track ?? f.track, et = M?.thumb ?? f.thumb, Je = M?.valueLabel ?? f.valueLabel, tt = M?.mark ?? f.mark, Rt = M?.markLabel ?? f.markLabel, xt = M?.input ?? f.input, rt = Mn({
    elementType: ee,
    getSlotProps: de,
    externalSlotProps: Se,
    externalForwardedProps: Z,
    additionalProps: {
      ...SW(ee) && {
        as: d
      }
    },
    ownerState: {
      ...G,
      ...Se?.ownerState
    },
    className: [K.root, y]
  }), He = Mn({
    elementType: he,
    externalSlotProps: De,
    ownerState: G,
    className: K.rail
  }), Oe = Mn({
    elementType: we,
    externalSlotProps: Ye,
    additionalProps: {
      style: {
        ...ye[ce].offset(le),
        ...ye[ce].leap(qe)
      }
    },
    ownerState: {
      ...G,
      ...Ye?.ownerState
    },
    className: K.track
  }), Ze = Mn({
    elementType: se,
    getSlotProps: fe,
    externalSlotProps: et,
    ownerState: {
      ...G,
      ...et?.ownerState
    },
    className: K.thumb
  }), Pt = Mn({
    elementType: ue,
    externalSlotProps: Je,
    ownerState: {
      ...G,
      ...Je?.ownerState
    },
    className: K.valueLabel
  }), Mt = Mn({
    elementType: Qe,
    externalSlotProps: tt,
    ownerState: G,
    className: K.mark
  }), Ct = Mn({
    elementType: We,
    externalSlotProps: Rt,
    ownerState: G,
    className: K.markLabel
  }), bt = Mn({
    elementType: be,
    getSlotProps: ne,
    externalSlotProps: xt,
    ownerState: G
  });
  return /* @__PURE__ */ P.jsxs(ee, {
    ...rt,
    children: [/* @__PURE__ */ P.jsx(he, {
      ...He
    }), /* @__PURE__ */ P.jsx(we, {
      ...Oe
    }), J.filter((nt) => nt.value >= E && nt.value <= $).map((nt, ft) => {
      const er = Cp(nt.value, E, $), Ut = ye[ce].offset(er);
      let Ft;
      return V === !1 ? Ft = Ie.includes(nt.value) : Ft = V === "normal" && (xe ? nt.value >= Ie[0] && nt.value <= Ie[Ie.length - 1] : nt.value <= Ie[0]) || V === "inverted" && (xe ? nt.value <= Ie[0] || nt.value >= Ie[Ie.length - 1] : nt.value >= Ie[0]), /* @__PURE__ */ P.jsxs(x.Fragment, {
        children: [/* @__PURE__ */ P.jsx(Qe, {
          "data-index": ft,
          ...Mt,
          ...!ri(Qe) && {
            markActive: Ft
          },
          style: {
            ...Ut,
            ...Mt.style
          },
          className: ge(Mt.className, Ft && K.markActive)
        }), nt.label != null ? /* @__PURE__ */ P.jsx(We, {
          "aria-hidden": !0,
          "data-index": ft,
          ...Ct,
          ...!ri(We) && {
            markLabelActive: Ft
          },
          style: {
            ...Ut,
            ...Ct.style
          },
          className: ge(K.markLabel, Ct.className, Ft && K.markLabelActive),
          children: nt.label
        }) : null]
      }, ft);
    }), Ie.map((nt, ft) => {
      const er = Cp(nt, E, $), Ut = ye[ce].offset(er), Ft = U === "off" ? EW : ue;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ P.jsx(Ft, {
          ...!ri(Ft) && {
            valueLabelFormat: H,
            valueLabelDisplay: U,
            value: typeof H == "function" ? H(B(nt), ft) : H,
            index: ft,
            open: ie === ft || oe === ft || U === "on",
            disabled: b
          },
          ...Pt,
          children: /* @__PURE__ */ P.jsx(se, {
            "data-index": ft,
            ...Ze,
            className: ge(K.thumb, Ze.className, oe === ft && K.active, Ce === ft && K.focusVisible),
            style: {
              ...Ut,
              ...q(ft),
              ...Ze.style
            },
            children: /* @__PURE__ */ P.jsx(be, {
              "data-index": ft,
              "aria-label": v ? v(ft) : i,
              "aria-valuenow": B(nt),
              "aria-labelledby": c,
              "aria-valuetext": T ? T(B(nt), ft) : l,
              value: Ie[ft],
              ...bt
            })
          })
        }, ft)
      );
    })]
  });
});
process.env.NODE_ENV !== "production" && (AO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": tn(n.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": n.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": tn(n.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Mark: n.elementType,
    MarkLabel: n.elementType,
    Rail: n.elementType,
    Root: n.elementType,
    Thumb: n.elementType,
    Track: n.elementType,
    ValueLabel: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    mark: n.oneOfType([n.func, n.object]),
    markLabel: n.oneOfType([n.func, n.object]),
    rail: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    thumb: n.oneOfType([n.func, n.object]),
    track: n.oneOfType([n.func, n.object]),
    valueLabel: n.oneOfType([n.func, n.shape({
      children: n.element,
      className: n.string,
      open: n.bool,
      style: n.object,
      value: n.node,
      valueLabelDisplay: n.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.oneOfType([n.arrayOf(n.number), n.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: n.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: n.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: n.oneOfType([n.arrayOf(n.shape({
    label: n.node,
    value: n.number.isRequired
  })), n.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: n.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: n.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: n.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: n.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: n.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: n.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: n.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium"]), n.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    mark: n.oneOfType([n.func, n.object]),
    markLabel: n.oneOfType([n.func, n.object]),
    rail: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    thumb: n.oneOfType([n.func, n.object]),
    track: n.oneOfType([n.func, n.object]),
    valueLabel: n.oneOfType([n.func, n.shape({
      children: n.element,
      className: n.string,
      open: n.bool,
      style: n.object,
      value: n.node,
      valueLabelDisplay: n.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    mark: n.elementType,
    markLabel: n.elementType,
    rail: n.elementType,
    root: n.elementType,
    thumb: n.elementType,
    track: n.elementType,
    valueLabel: n.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: n.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: n.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: n.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: n.oneOfType([n.arrayOf(n.number), n.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: n.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: n.oneOfType([n.func, n.string])
});
function OW(e = {}) {
  const {
    autoHideDuration: t = null,
    disableWindowBlurListener: r = !1,
    onClose: o,
    open: a,
    resumeHideDuration: i
  } = e, l = Ja();
  x.useEffect(() => {
    if (!a)
      return;
    function T(R) {
      R.defaultPrevented || R.key === "Escape" && o?.(R, "escapeKeyDown");
    }
    return document.addEventListener("keydown", T), () => {
      document.removeEventListener("keydown", T);
    };
  }, [a, o]);
  const c = Pr((T, R) => {
    o?.(T, R);
  }), d = Pr((T) => {
    !o || T == null || l.start(T, () => {
      c(null, "timeout");
    });
  });
  x.useEffect(() => (a && d(t), l.clear), [a, t, d, l]);
  const p = (T) => {
    o?.(T, "clickaway");
  }, f = l.clear, h = x.useCallback(() => {
    t != null && d(i ?? t * 0.5);
  }, [t, i, d]), g = (T) => (R) => {
    const $ = T.onBlur;
    $?.(R), h();
  }, y = (T) => (R) => {
    const $ = T.onFocus;
    $?.(R), f();
  }, C = (T) => (R) => {
    const $ = T.onMouseEnter;
    $?.(R), f();
  }, b = (T) => (R) => {
    const $ = T.onMouseLeave;
    $?.(R), h();
  };
  return x.useEffect(() => {
    if (!r && a)
      return window.addEventListener("focus", h), window.addEventListener("blur", f), () => {
        window.removeEventListener("focus", h), window.removeEventListener("blur", f);
      };
  }, [r, a, h, f]), {
    getRootProps: (T = {}) => {
      const R = {
        ...gs(e),
        ...gs(T)
      };
      return {
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation",
        ...T,
        ...R,
        onBlur: g(R),
        onFocus: y(R),
        onMouseEnter: C(R),
        onMouseLeave: b(R)
      };
    },
    onClickAway: p
  };
}
function IO(e) {
  return Ae("MuiSnackbarContent", e);
}
const $W = Ne("MuiSnackbarContent", ["root", "message", "action"]), RW = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    action: ["action"],
    message: ["message"]
  }, IO, t);
}, PW = Y(no, {
  name: "MuiSnackbarContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? 0.8 : 0.98, r = Tl(e.palette.background.default, t);
  return {
    ...e.typography.body2,
    color: e.vars ? e.vars.palette.SnackbarContent.color : e.palette.getContrastText(r),
    backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : r,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    flexGrow: 1,
    [e.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 288
    }
  };
})), kW = Y("div", {
  name: "MuiSnackbarContent",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0"
}), AW = Y("div", {
  name: "MuiSnackbarContent",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  paddingLeft: 16,
  marginRight: -8
}), Sy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSnackbarContent"
  }), {
    action: a,
    className: i,
    message: l,
    role: c = "alert",
    ...d
  } = o, p = o, f = RW(p);
  return /* @__PURE__ */ P.jsxs(PW, {
    role: c,
    square: !0,
    elevation: 6,
    className: ge(f.root, i),
    ownerState: p,
    ref: r,
    ...d,
    children: [/* @__PURE__ */ P.jsx(kW, {
      className: f.message,
      ownerState: p,
      children: l
    }), a ? /* @__PURE__ */ P.jsx(AW, {
      className: f.action,
      ownerState: p,
      children: a
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Sy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The message to display.
   */
  message: n.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function NO(e) {
  return Ae("MuiSnackbar", e);
}
const IW = Ne("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft"]), NW = (e) => {
  const {
    classes: t,
    anchorOrigin: r
  } = e, o = {
    root: ["root", `anchorOrigin${re(r.vertical)}${re(r.horizontal)}`]
  };
  return Me(o, NO, t);
}, MW = Y("div", {
  name: "MuiSnackbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`anchorOrigin${re(r.anchorOrigin.vertical)}${re(r.anchorOrigin.horizontal)}`]];
  }
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.snackbar,
  position: "fixed",
  display: "flex",
  left: 8,
  right: 8,
  justifyContent: "center",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top",
    style: {
      top: 8,
      [e.breakpoints.up("sm")]: {
        top: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical !== "top",
    style: {
      bottom: 8,
      [e.breakpoints.up("sm")]: {
        bottom: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "left",
    style: {
      justifyContent: "flex-start",
      [e.breakpoints.up("sm")]: {
        left: 24,
        right: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "right",
    style: {
      justifyContent: "flex-end",
      [e.breakpoints.up("sm")]: {
        right: 24,
        left: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "center",
    style: {
      [e.breakpoints.up("sm")]: {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
      }
    }
  }]
}))), MO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSnackbar"
  }), a = Yr(), i = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    action: l,
    anchorOrigin: {
      vertical: c,
      horizontal: d
    } = {
      vertical: "bottom",
      horizontal: "left"
    },
    autoHideDuration: p = null,
    children: f,
    className: h,
    ClickAwayListenerProps: g,
    ContentProps: y,
    disableWindowBlurListener: C = !1,
    message: b,
    onBlur: v,
    onClose: T,
    onFocus: R,
    onMouseEnter: $,
    onMouseLeave: E,
    open: S,
    resumeHideDuration: k,
    slots: A = {},
    slotProps: _ = {},
    TransitionComponent: L,
    transitionDuration: O = i,
    TransitionProps: {
      onEnter: F,
      onExited: B,
      ...M
    } = {},
    ...j
  } = o, W = {
    ...o,
    anchorOrigin: {
      vertical: c,
      horizontal: d
    },
    autoHideDuration: p,
    disableWindowBlurListener: C,
    TransitionComponent: L,
    transitionDuration: O
  }, V = NW(W), {
    getRootProps: X,
    onClickAway: U
  } = OW({
    ...W
  }), [H, Z] = x.useState(!0), G = (Ie) => {
    Z(!0), B && B(Ie);
  }, ye = (Ie, le) => {
    Z(!1), F && F(Ie, le);
  }, de = {
    slots: {
      transition: L,
      ...A
    },
    slotProps: {
      content: y,
      clickAwayListener: g,
      transition: M,
      ..._
    }
  }, [ne, fe] = ze("root", {
    ref: r,
    className: [V.root, h],
    elementType: MW,
    getSlotProps: X,
    externalForwardedProps: {
      ...de,
      ...j
    },
    ownerState: W
  }), [ie, {
    ownerState: oe,
    ...ce
  }] = ze("clickAwayListener", {
    elementType: Il,
    externalForwardedProps: de,
    getSlotProps: (Ie) => ({
      onClickAway: (...le) => {
        Ie.onClickAway?.(...le), U(...le);
      }
    }),
    ownerState: W
  }), [Ce, xe] = ze("content", {
    elementType: Sy,
    shouldForwardComponentProp: !0,
    externalForwardedProps: de,
    additionalProps: {
      message: b,
      action: l
    },
    ownerState: W
  }), [Re, J] = ze("transition", {
    elementType: $s,
    externalForwardedProps: de,
    getSlotProps: (Ie) => ({
      onEnter: (...le) => {
        Ie.onEnter?.(...le), ye(...le);
      },
      onExited: (...le) => {
        Ie.onExited?.(...le), G(...le);
      }
    }),
    additionalProps: {
      appear: !0,
      in: S,
      timeout: O,
      direction: c === "top" ? "down" : "up"
    },
    ownerState: W
  });
  return !S && H ? null : /* @__PURE__ */ P.jsx(ie, {
    ...ce,
    ...A.clickAwayListener && {
      ownerState: oe
    },
    children: /* @__PURE__ */ P.jsx(ne, {
      ...fe,
      children: /* @__PURE__ */ P.jsx(Re, {
        ...J,
        children: f || /* @__PURE__ */ P.jsx(Ce, {
          ...xe
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (MO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: n.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOf(["center", "left", "right"]).isRequired,
    vertical: n.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: n.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: n.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   * @deprecated Use `slotProps.clickAwayListener` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ClickAwayListenerProps: n.object,
  /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   * @deprecated Use `slotProps.content` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContentProps: n.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: n.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: n.node,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * @ignore
   */
  onMouseEnter: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: n.number,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    clickAwayListener: n.oneOfType([n.func, n.shape({
      children: n.element.isRequired,
      disableReactTree: n.bool,
      mouseEvent: n.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
      onClickAway: n.func,
      touchEvent: n.oneOf(["onTouchEnd", "onTouchStart", !1])
    })]),
    content: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    clickAwayListener: n.elementType,
    content: n.elementType,
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: n.object
});
const _W = {
  entering: {
    transform: "none"
  },
  entered: {
    transform: "none"
  }
}, wy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Yr(), a = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: l = !0,
    children: c,
    easing: d,
    in: p,
    onEnter: f,
    onEntered: h,
    onEntering: g,
    onExit: y,
    onExited: C,
    onExiting: b,
    style: v,
    timeout: T = a,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: R = Po,
    ...$
  } = t, E = x.useRef(null), S = Jt(E, ii(c), r), k = (j) => (W) => {
    if (j) {
      const V = E.current;
      W === void 0 ? j(V) : j(V, W);
    }
  }, A = k(g), _ = k((j, W) => {
    of(j);
    const V = aa({
      style: v,
      timeout: T,
      easing: d
    }, {
      mode: "enter"
    });
    j.style.webkitTransition = o.transitions.create("transform", V), j.style.transition = o.transitions.create("transform", V), f && f(j, W);
  }), L = k(h), O = k(b), F = k((j) => {
    const W = aa({
      style: v,
      timeout: T,
      easing: d
    }, {
      mode: "exit"
    });
    j.style.webkitTransition = o.transitions.create("transform", W), j.style.transition = o.transitions.create("transform", W), y && y(j);
  }), B = k(C), M = (j) => {
    i && i(E.current, j);
  };
  return /* @__PURE__ */ P.jsx(R, {
    appear: l,
    in: p,
    nodeRef: E,
    onEnter: _,
    onEntered: L,
    onEntering: A,
    onExit: F,
    onExited: B,
    onExiting: O,
    addEndListener: M,
    timeout: T,
    ...$,
    children: (j, {
      ownerState: W,
      ...V
    }) => /* @__PURE__ */ x.cloneElement(c, {
      style: {
        transform: "scale(0)",
        visibility: j === "exited" && !p ? "hidden" : void 0,
        ..._W[j],
        ...v,
        ...c.props.style
      },
      ref: S,
      ...V
    })
  });
});
process.env.NODE_ENV !== "production" && (wy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: ai.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
function _O(e) {
  return Ae("MuiSpeedDial", e);
}
const Oc = Ne("MuiSpeedDial", ["root", "fab", "directionUp", "directionDown", "directionLeft", "directionRight", "actions", "actionsClosed"]), FW = (e) => {
  const {
    classes: t,
    open: r,
    direction: o
  } = e, a = {
    root: ["root", `direction${re(o)}`],
    fab: ["fab"],
    actions: ["actions", !r && "actionsClosed"]
  };
  return Me(a, _O, t);
};
function mc(e) {
  if (e === "up" || e === "down")
    return "vertical";
  if (e === "right" || e === "left")
    return "horizontal";
}
const Ci = 32, Rd = 16, LW = Y("div", {
  name: "MuiSpeedDial",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`direction${re(r.direction)}`]];
  }
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.speedDial,
  display: "flex",
  alignItems: "center",
  pointerEvents: "none",
  variants: [{
    props: {
      direction: "up"
    },
    style: {
      flexDirection: "column-reverse",
      [`& .${Oc.actions}`]: {
        flexDirection: "column-reverse",
        marginBottom: -Ci,
        paddingBottom: Rd + Ci
      }
    }
  }, {
    props: {
      direction: "down"
    },
    style: {
      flexDirection: "column",
      [`& .${Oc.actions}`]: {
        flexDirection: "column",
        marginTop: -Ci,
        paddingTop: Rd + Ci
      }
    }
  }, {
    props: {
      direction: "left"
    },
    style: {
      flexDirection: "row-reverse",
      [`& .${Oc.actions}`]: {
        flexDirection: "row-reverse",
        marginRight: -Ci,
        paddingRight: Rd + Ci
      }
    }
  }, {
    props: {
      direction: "right"
    },
    style: {
      flexDirection: "row",
      [`& .${Oc.actions}`]: {
        flexDirection: "row",
        marginLeft: -Ci,
        paddingLeft: Rd + Ci
      }
    }
  }]
}))), BW = Y(bf, {
  name: "MuiSpeedDial",
  slot: "Fab",
  overridesResolver: (e, t) => t.fab
})({
  pointerEvents: "auto"
}), DW = Y("div", {
  name: "MuiSpeedDial",
  slot: "Actions",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.actions, !r.open && t.actionsClosed];
  }
})({
  display: "flex",
  pointerEvents: "auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.open,
    style: {
      transition: "top 0s linear 0.2s",
      pointerEvents: "none"
    }
  }]
}), FO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSpeedDial"
  }), a = Yr(), i = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    ariaLabel: l,
    FabProps: {
      ref: c,
      ...d
    } = {},
    children: p,
    className: f,
    direction: h = "up",
    hidden: g = !1,
    icon: y,
    onBlur: C,
    onClose: b,
    onFocus: v,
    onKeyDown: T,
    onMouseEnter: R,
    onMouseLeave: $,
    onOpen: E,
    open: S,
    openIcon: k,
    slots: A = {},
    slotProps: _ = {},
    TransitionComponent: L,
    TransitionProps: O,
    transitionDuration: F = i,
    ...B
  } = o, [M, j] = Bn({
    controlled: S,
    default: !1,
    name: "SpeedDial",
    state: "open"
  }), W = {
    ...o,
    open: M,
    direction: h
  }, V = FW(W), X = Ja(), U = x.useRef(0), H = x.useRef(), Z = x.useRef([]);
  Z.current = [Z.current[0]];
  const G = x.useCallback((ee) => {
    Z.current[0] = ee;
  }, []), ye = Jt(c, G), de = (ee, he) => (we) => {
    Z.current[ee + 1] = we, he && he(we);
  }, ne = (ee) => {
    T && T(ee);
    const he = ee.key.replace("Arrow", "").toLowerCase(), {
      current: we = he
    } = H;
    if (ee.key === "Escape") {
      j(!1), Z.current[0].focus(), b && b(ee, "escapeKeyDown");
      return;
    }
    if (mc(he) === mc(we) && mc(he) !== void 0) {
      ee.preventDefault();
      const se = he === we ? 1 : -1, ue = Oi(U.current + se, 0, Z.current.length - 1);
      Z.current[ue].focus(), U.current = ue, H.current = we;
    }
  };
  x.useEffect(() => {
    M || (U.current = 0, H.current = void 0);
  }, [M]);
  const fe = (ee) => {
    ee.type === "mouseleave" && $ && $(ee), ee.type === "blur" && C && C(ee), X.clear(), ee.type === "blur" ? X.start(0, () => {
      j(!1), b && b(ee, "blur");
    }) : (j(!1), b && b(ee, "mouseLeave"));
  }, ie = (ee) => {
    d.onClick && d.onClick(ee), X.clear(), M ? (j(!1), b && b(ee, "toggle")) : (j(!0), E && E(ee, "toggle"));
  }, oe = (ee) => {
    ee.type === "mouseenter" && R && R(ee), ee.type === "focus" && v && v(ee), X.clear(), M || X.start(0, () => {
      j(!0), E && E(ee, {
        focus: "focus",
        mouseenter: "mouseEnter"
      }[ee.type]);
    });
  }, ce = l.replace(/^[^a-z]+|[^\w:.-]+/gi, ""), Ce = x.Children.toArray(p).filter((ee) => (process.env.NODE_ENV !== "production" && zn.isFragment(ee) && console.error(["MUI: The SpeedDial component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ x.isValidElement(ee))), xe = Ce.map((ee, he) => {
    const {
      FabProps: {
        ref: we,
        ...se
      } = {},
      tooltipPlacement: ue
    } = ee.props, Qe = ue || (mc(h) === "vertical" ? "left" : "top");
    return /* @__PURE__ */ x.cloneElement(ee, {
      FabProps: {
        ...se,
        ref: de(he, we)
      },
      delay: 30 * (M ? he : Ce.length - he),
      open: M,
      tooltipPlacement: Qe,
      id: `${ce}-action-${he}`
    });
  }), Re = {
    transition: L,
    ...A
  }, J = {
    transition: O,
    ..._
  }, Ie = {
    slots: Re,
    slotProps: J
  }, [le, qe] = ze("root", {
    elementType: LW,
    externalForwardedProps: {
      ...Ie,
      ...B
    },
    ownerState: W,
    ref: r,
    className: ge(V.root, f),
    additionalProps: {
      role: "presentation"
    },
    getSlotProps: (ee) => ({
      ...ee,
      onKeyDown: (he) => {
        ee.onKeyDown?.(he), ne(he);
      },
      onBlur: (he) => {
        ee.onBlur?.(he), fe(he);
      },
      onFocus: (he) => {
        ee.onFocus?.(he), oe(he);
      },
      onMouseEnter: (he) => {
        ee.onMouseEnter?.(he), oe(he);
      },
      onMouseLeave: (he) => {
        ee.onMouseLeave?.(he), fe(he);
      }
    })
  }), [q, K] = ze("transition", {
    elementType: wy,
    externalForwardedProps: Ie,
    ownerState: W
  });
  return /* @__PURE__ */ P.jsxs(le, {
    ...qe,
    children: [/* @__PURE__ */ P.jsx(q, {
      in: !g,
      timeout: F,
      unmountOnExit: !0,
      ...K,
      children: /* @__PURE__ */ P.jsx(BW, {
        color: "primary",
        "aria-label": l,
        "aria-haspopup": "true",
        "aria-expanded": M,
        "aria-controls": `${ce}-actions`,
        ...d,
        onClick: ie,
        className: ge(V.fab, d.className),
        ref: ye,
        ownerState: W,
        children: /* @__PURE__ */ x.isValidElement(y) && wa(y, ["SpeedDialIcon"]) ? /* @__PURE__ */ x.cloneElement(y, {
          open: M
        }) : y
      })
    }), /* @__PURE__ */ P.jsx(DW, {
      id: `${ce}-actions`,
      role: "menu",
      "aria-orientation": mc(h),
      className: ge(V.actions, !M && V.actionsClosed),
      ownerState: W,
      children: xe
    })]
  });
});
process.env.NODE_ENV !== "production" && (FO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */
  ariaLabel: n.string.isRequired,
  /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The direction the actions open relative to the floating action button.
   * @default 'up'
   */
  direction: n.oneOf(["down", "left", "right", "up"]),
  /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) element.
   * @default {}
   */
  FabProps: n.object,
  /**
   * If `true`, the SpeedDial is hidden.
   * @default false
   */
  hidden: n.bool,
  /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */
  icon: n.node,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onMouseEnter: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"focus"`, `"mouseEnter"`.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */
  openIcon: n.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Zoom
   * * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  TransitionProps: n.object
});
function LO(e) {
  return Ae("MuiTooltip", e);
}
const Fr = Ne("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function jW(e) {
  return Math.round(e * 1e5) / 1e5;
}
const zW = (e) => {
  const {
    classes: t,
    disableInteractive: r,
    arrow: o,
    touch: a,
    placement: i
  } = e, l = {
    popper: ["popper", !r && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", a && "touch", `tooltipPlacement${re(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Me(l, LO, t);
}, VW = Y(Is, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.popper, !r.disableInteractive && t.popperInteractive, r.arrow && t.popperArrow, !r.open && t.popperClose];
  }
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${Fr.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${Fr.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${Fr.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${Fr.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Fr.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Fr.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Fr.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Fr.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), WW = Y("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.tooltip, r.touch && t.touch, r.arrow && t.tooltipArrow, t[`tooltipPlacement${re(r.placement.split("-")[0])}`]];
  }
})($e(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : dt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${Fr.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${Fr.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${Fr.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${Fr.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${jW(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${Fr.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${Fr.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${Fr.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${Fr.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${Fr.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${Fr.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${Fr.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${Fr.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Fr.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Fr.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), UW = Y("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})($e(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : dt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let Pd = !1;
const AC = new tf();
let hc = {
  x: 0,
  y: 0
};
function kd(e, t) {
  return (r, ...o) => {
    t && t(r, ...o), e(r, ...o);
  };
}
const Cf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: a = !1,
    children: i,
    classes: l,
    components: c = {},
    componentsProps: d = {},
    describeChild: p = !1,
    disableFocusListener: f = !1,
    disableHoverListener: h = !1,
    disableInteractive: g = !1,
    disableTouchListener: y = !1,
    enterDelay: C = 100,
    enterNextDelay: b = 0,
    enterTouchDelay: v = 700,
    followCursor: T = !1,
    id: R,
    leaveDelay: $ = 0,
    leaveTouchDelay: E = 1500,
    onClose: S,
    onOpen: k,
    open: A,
    placement: _ = "bottom",
    PopperComponent: L,
    PopperProps: O = {},
    slotProps: F = {},
    slots: B = {},
    title: M,
    TransitionComponent: j,
    TransitionProps: W,
    ...V
  } = o, X = /* @__PURE__ */ x.isValidElement(i) ? i : /* @__PURE__ */ P.jsx("span", {
    children: i
  }), U = Yr(), H = la(), [Z, G] = x.useState(), [ye, de] = x.useState(null), ne = x.useRef(!1), fe = g || T, ie = Ja(), oe = Ja(), ce = Ja(), Ce = Ja(), [xe, Re] = Bn({
    controlled: A,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let J = xe;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: ct
    } = x.useRef(A !== void 0);
    x.useEffect(() => {
      Z && Z.disabled && !ct && M !== "" && Z.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [M, Z, ct]);
  }
  const Ie = eo(R), le = x.useRef(), qe = Pr(() => {
    le.current !== void 0 && (document.body.style.WebkitUserSelect = le.current, le.current = void 0), Ce.clear();
  });
  x.useEffect(() => qe, [qe]);
  const q = (ct) => {
    AC.clear(), Pd = !0, Re(!0), k && !J && k(ct);
  }, K = Pr(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (ct) => {
      AC.start(800 + $, () => {
        Pd = !1;
      }), Re(!1), S && J && S(ct), ie.start(U.transitions.duration.shortest, () => {
        ne.current = !1;
      });
    }
  ), ee = (ct) => {
    ne.current && ct.type !== "touchstart" || (Z && Z.removeAttribute("title"), oe.clear(), ce.clear(), C || Pd && b ? oe.start(Pd ? b : C, () => {
      q(ct);
    }) : q(ct));
  }, he = (ct) => {
    oe.clear(), ce.start($, () => {
      K(ct);
    });
  }, [, we] = x.useState(!1), se = (ct) => {
    Ra(ct.target) || (we(!1), he(ct));
  }, ue = (ct) => {
    Z || G(ct.currentTarget), Ra(ct.target) && (we(!0), ee(ct));
  }, Qe = (ct) => {
    ne.current = !0;
    const fr = X.props;
    fr.onTouchStart && fr.onTouchStart(ct);
  }, We = (ct) => {
    Qe(ct), ce.clear(), ie.clear(), qe(), le.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Ce.start(v, () => {
      document.body.style.WebkitUserSelect = le.current, ee(ct);
    });
  }, be = (ct) => {
    X.props.onTouchEnd && X.props.onTouchEnd(ct), qe(), ce.start(E, () => {
      K(ct);
    });
  };
  x.useEffect(() => {
    if (!J)
      return;
    function ct(fr) {
      fr.key === "Escape" && K(fr);
    }
    return document.addEventListener("keydown", ct), () => {
      document.removeEventListener("keydown", ct);
    };
  }, [K, J]);
  const Se = Jt(ii(X), G, r);
  !M && M !== 0 && (J = !1);
  const De = x.useRef(), Ye = (ct) => {
    const fr = X.props;
    fr.onMouseMove && fr.onMouseMove(ct), hc = {
      x: ct.clientX,
      y: ct.clientY
    }, De.current && De.current.update();
  }, et = {}, Je = typeof M == "string";
  p ? (et.title = !J && Je && !h ? M : null, et["aria-describedby"] = J ? Ie : null) : (et["aria-label"] = Je ? M : null, et["aria-labelledby"] = J && !Je ? Ie : null);
  const tt = {
    ...et,
    ...V,
    ...X.props,
    className: ge(V.className, X.props.className),
    onTouchStart: Qe,
    ref: Se,
    ...T ? {
      onMouseMove: Ye
    } : {}
  };
  process.env.NODE_ENV !== "production" && (tt["data-mui-internal-clone-element"] = !0, x.useEffect(() => {
    Z && !Z.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Z]));
  const Rt = {};
  y || (tt.onTouchStart = We, tt.onTouchEnd = be), h || (tt.onMouseOver = kd(ee, tt.onMouseOver), tt.onMouseLeave = kd(he, tt.onMouseLeave), fe || (Rt.onMouseOver = ee, Rt.onMouseLeave = he)), f || (tt.onFocus = kd(ue, tt.onFocus), tt.onBlur = kd(se, tt.onBlur), fe || (Rt.onFocus = ue, Rt.onBlur = se)), process.env.NODE_ENV !== "production" && X.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${X.props.title}\` or the Tooltip component.`].join(`
`));
  const xt = {
    ...o,
    isRtl: H,
    arrow: a,
    disableInteractive: fe,
    placement: _,
    PopperComponentProp: L,
    touch: ne.current
  }, rt = typeof F.popper == "function" ? F.popper(xt) : F.popper, He = x.useMemo(() => {
    let ct = [{
      name: "arrow",
      enabled: !!ye,
      options: {
        element: ye,
        padding: 4
      }
    }];
    return O.popperOptions?.modifiers && (ct = ct.concat(O.popperOptions.modifiers)), rt?.popperOptions?.modifiers && (ct = ct.concat(rt.popperOptions.modifiers)), {
      ...O.popperOptions,
      ...rt?.popperOptions,
      modifiers: ct
    };
  }, [ye, O.popperOptions, rt?.popperOptions]), Oe = zW(xt), Ze = typeof F.transition == "function" ? F.transition(xt) : F.transition, Pt = {
    slots: {
      popper: c.Popper,
      transition: c.Transition ?? j,
      tooltip: c.Tooltip,
      arrow: c.Arrow,
      ...B
    },
    slotProps: {
      arrow: F.arrow ?? d.arrow,
      popper: {
        ...O,
        ...rt ?? d.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: F.tooltip ?? d.tooltip,
      transition: {
        ...W,
        ...Ze ?? d.transition
      }
    }
  }, [Mt, Ct] = ze("popper", {
    elementType: VW,
    externalForwardedProps: Pt,
    ownerState: xt,
    className: ge(Oe.popper, O?.className)
  }), [bt, nt] = ze("transition", {
    elementType: $s,
    externalForwardedProps: Pt,
    ownerState: xt
  }), [ft, er] = ze("tooltip", {
    elementType: WW,
    className: Oe.tooltip,
    externalForwardedProps: Pt,
    ownerState: xt
  }), [Ut, Ft] = ze("arrow", {
    elementType: UW,
    className: Oe.arrow,
    externalForwardedProps: Pt,
    ownerState: xt,
    ref: de
  });
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ x.cloneElement(X, tt), /* @__PURE__ */ P.jsx(Mt, {
      as: L ?? Is,
      placement: _,
      anchorEl: T ? {
        getBoundingClientRect: () => ({
          top: hc.y,
          left: hc.x,
          right: hc.x,
          bottom: hc.y,
          width: 0,
          height: 0
        })
      } : Z,
      popperRef: De,
      open: Z ? J : !1,
      id: Ie,
      transition: !0,
      ...Rt,
      ...Ct,
      popperOptions: He,
      children: ({
        TransitionProps: ct
      }) => /* @__PURE__ */ P.jsx(bt, {
        timeout: U.transitions.duration.shorter,
        ...ct,
        ...nt,
        children: /* @__PURE__ */ P.jsxs(ft, {
          ...er,
          children: [M, a ? /* @__PURE__ */ P.jsx(Ut, {
            ...Ft
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Cf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: n.bool,
  /**
   * Tooltip reference element.
   */
  children: ai.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: n.shape({
    Arrow: n.elementType,
    Popper: n.elementType,
    Tooltip: n.elementType,
    Transition: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: n.shape({
    arrow: n.object,
    popper: n.object,
    tooltip: n.object,
    transition: n.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: n.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: n.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: n.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: n.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: n.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: n.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: n.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: n.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: n.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: n.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: n.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: n.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: n.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: n.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    arrow: n.oneOfType([n.func, n.object]),
    popper: n.oneOfType([n.func, n.object]),
    tooltip: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    arrow: n.elementType,
    popper: n.elementType,
    tooltip: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: n.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: n.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: n.object
});
function BO(e) {
  return Ae("MuiSpeedDialAction", e);
}
const $c = Ne("MuiSpeedDialAction", ["fab", "fabClosed", "staticTooltip", "staticTooltipClosed", "staticTooltipLabel", "tooltipPlacementLeft", "tooltipPlacementRight"]), HW = (e) => {
  const {
    open: t,
    tooltipPlacement: r,
    classes: o
  } = e, a = {
    fab: ["fab", !t && "fabClosed"],
    staticTooltip: ["staticTooltip", `tooltipPlacement${re(r)}`, !t && "staticTooltipClosed"],
    staticTooltipLabel: ["staticTooltipLabel"]
  };
  return Me(a, BO, o);
}, GW = Y(bf, {
  name: "MuiSpeedDialAction",
  slot: "Fab",
  skipVariantsResolver: !1,
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.fab, !r.open && t.fabClosed];
  }
})($e(({
  theme: e
}) => ({
  margin: 8,
  color: (e.vars || e).palette.text.secondary,
  backgroundColor: (e.vars || e).palette.background.paper,
  "&:hover": {
    backgroundColor: e.vars ? e.vars.palette.SpeedDialAction.fabHoverBg : Tl(e.palette.background.paper, 0.15)
  },
  transition: `${e.transitions.create("transform", {
    duration: e.transitions.duration.shorter
  })}, opacity 0.8s`,
  opacity: 1,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open,
    style: {
      opacity: 0,
      transform: "scale(0)"
    }
  }]
}))), qW = Y("span", {
  name: "MuiSpeedDialAction",
  slot: "StaticTooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.staticTooltip, !r.open && t.staticTooltipClosed, t[`tooltipPlacement${re(r.tooltipPlacement)}`]];
  }
})($e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  [`& .${$c.staticTooltipLabel}`]: {
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.shorter
    }),
    opacity: 1
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open,
    style: {
      [`& .${$c.staticTooltipLabel}`]: {
        opacity: 0,
        transform: "scale(0.5)"
      }
    }
  }, {
    props: {
      tooltipPlacement: "left"
    },
    style: {
      [`& .${$c.staticTooltipLabel}`]: {
        transformOrigin: "100% 50%",
        right: "100%",
        marginRight: 8
      }
    }
  }, {
    props: {
      tooltipPlacement: "right"
    },
    style: {
      [`& .${$c.staticTooltipLabel}`]: {
        transformOrigin: "0% 50%",
        left: "100%",
        marginLeft: 8
      }
    }
  }]
}))), KW = Y("span", {
  name: "MuiSpeedDialAction",
  slot: "StaticTooltipLabel",
  overridesResolver: (e, t) => t.staticTooltipLabel
})($e(({
  theme: e
}) => ({
  position: "absolute",
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.paper,
  borderRadius: (e.vars || e).shape.borderRadius,
  boxShadow: (e.vars || e).shadows[1],
  color: (e.vars || e).palette.text.secondary,
  padding: "4px 16px",
  wordBreak: "keep-all"
}))), DO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSpeedDialAction"
  }), {
    className: a,
    delay: i = 0,
    FabProps: l = {},
    icon: c,
    id: d,
    open: p,
    TooltipClasses: f,
    tooltipOpen: h = !1,
    tooltipPlacement: g = "left",
    tooltipTitle: y,
    slots: C = {},
    slotProps: b = {},
    ...v
  } = o, T = {
    ...o,
    tooltipPlacement: g
  }, R = HW(T), $ = {
    slots: C,
    slotProps: {
      fab: l,
      ...b,
      tooltip: Ts(typeof b.tooltip == "function" ? b.tooltip(T) : b.tooltip, {
        title: y,
        open: h,
        placement: g,
        classes: f
      })
    }
  }, [E, S] = x.useState($.slotProps.tooltip?.open), k = () => {
    S(!1);
  }, A = () => {
    S(!0);
  }, _ = {
    transitionDelay: `${i}ms`
  }, [L, O] = ze("fab", {
    elementType: GW,
    externalForwardedProps: $,
    ownerState: T,
    shouldForwardComponentProp: !0,
    className: ge(R.fab, a),
    additionalProps: {
      style: _,
      tabIndex: -1,
      role: "menuitem",
      size: "small"
    }
  }), [F, B] = ze("tooltip", {
    elementType: Cf,
    externalForwardedProps: $,
    shouldForwardComponentProp: !0,
    ref: r,
    additionalProps: {
      id: d
    },
    ownerState: T,
    getSlotProps: (U) => ({
      ...U,
      onClose: (H) => {
        U.onClose?.(H), k();
      },
      onOpen: (H) => {
        U.onOpen?.(H), A();
      }
    })
  }), [M, j] = ze("staticTooltip", {
    elementType: qW,
    externalForwardedProps: $,
    ownerState: T,
    ref: r,
    className: R.staticTooltip,
    additionalProps: {
      id: d
    }
  }), [W, V] = ze("staticTooltipLabel", {
    elementType: KW,
    externalForwardedProps: $,
    ownerState: T,
    className: R.staticTooltipLabel,
    additionalProps: {
      style: _,
      id: `${d}-label`
    }
  }), X = /* @__PURE__ */ P.jsx(L, {
    ...O,
    children: c
  });
  return B.open ? /* @__PURE__ */ P.jsxs(M, {
    ...j,
    ...v,
    children: [/* @__PURE__ */ P.jsx(W, {
      ...V,
      children: B.title
    }), /* @__PURE__ */ x.cloneElement(X, {
      "aria-labelledby": `${d}-label`
    })]
  }) : (!p && E && S(!1), /* @__PURE__ */ P.jsx(F, {
    ...B,
    title: B.title,
    open: p && E,
    placement: B.placement,
    classes: B.classes,
    ...v,
    children: X
  }));
});
process.env.NODE_ENV !== "production" && (DO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   * @default 0
   */
  delay: n.number,
  /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) component.
   * @default {}
   * @deprecated Use `slotProps.fab` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FabProps: n.object,
  /**
   * The icon to display in the SpeedDial Fab.
   */
  icon: n.node,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: n.string,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    fab: n.oneOfType([n.func, n.object]),
    staticTooltip: n.oneOfType([n.func, n.object]),
    staticTooltipLabel: n.oneOfType([n.func, n.object]),
    tooltip: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    fab: n.elementType,
    staticTooltip: n.elementType,
    staticTooltipLabel: n.elementType,
    tooltip: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * `classes` prop applied to the [`Tooltip`](https://mui.com/material-ui/api/tooltip/) element.
   * @deprecated Use `slotProps.tooltip.classes` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TooltipClasses: n.object,
  /**
   * Make the tooltip always visible when the SpeedDial is open.
   * @default false
   * @deprecated Use `slotProps.tooltip.open` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  tooltipOpen: n.bool,
  /**
   * Placement of the tooltip.
   * @default 'left'
   * @deprecated Use `slotProps.tooltip.placement` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  tooltipPlacement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Label to display in the tooltip.
   * @deprecated Use `slotProps.tooltip.title` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  tooltipTitle: n.node
});
const YW = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
function jO(e) {
  return Ae("MuiSpeedDialIcon", e);
}
const ta = Ne("MuiSpeedDialIcon", ["root", "icon", "iconOpen", "iconWithOpenIconOpen", "openIcon", "openIconOpen"]), ZW = (e) => {
  const {
    classes: t,
    open: r,
    openIcon: o
  } = e;
  return Me({
    root: ["root"],
    icon: ["icon", r && "iconOpen", o && r && "iconWithOpenIconOpen"],
    openIcon: ["openIcon", r && "openIconOpen"]
  }, jO, t);
}, XW = Y("span", {
  name: "MuiSpeedDialIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ta.icon}`]: t.icon
    }, {
      [`& .${ta.icon}`]: r.open && t.iconOpen
    }, {
      [`& .${ta.icon}`]: r.open && r.openIcon && t.iconWithOpenIconOpen
    }, {
      [`& .${ta.openIcon}`]: t.openIcon
    }, {
      [`& .${ta.openIcon}`]: r.open && t.openIconOpen
    }, t.root];
  }
})($e(({
  theme: e
}) => ({
  height: 24,
  [`& .${ta.icon}`]: {
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.short
    })
  },
  [`& .${ta.openIcon}`]: {
    position: "absolute",
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.short
    }),
    opacity: 0,
    transform: "rotate(-45deg)"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      [`& .${ta.icon}`]: {
        transform: "rotate(45deg)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.open && t.openIcon,
    style: {
      [`& .${ta.icon}`]: {
        opacity: 0
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      [`& .${ta.openIcon}`]: {
        transform: "rotate(0deg)",
        opacity: 1
      }
    }
  }]
}))), Ty = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSpeedDialIcon"
  }), {
    className: a,
    icon: i,
    open: l,
    openIcon: c,
    ...d
  } = o, p = o, f = ZW(p);
  function h(g, y) {
    return /* @__PURE__ */ x.isValidElement(g) ? /* @__PURE__ */ x.cloneElement(g, {
      className: y
    }) : g;
  }
  return /* @__PURE__ */ P.jsxs(XW, {
    className: ge(f.root, a),
    ref: r,
    ownerState: p,
    ...d,
    children: [c ? h(c, f.openIcon) : null, i ? h(i, f.icon) : /* @__PURE__ */ P.jsx(YW, {
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ty.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display.
   */
  icon: n.node,
  /**
   * @ignore
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */
  openIcon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
Ty.muiName = "SpeedDialIcon";
const zO = WN({
  createStyledComponent: Y("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Fe({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (zO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
  /**
   * Add an element between each child.
   */
  divider: n.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: n.bool
});
const JW = Ne("MuiStack", ["root"]), li = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (li.displayName = "StepperContext");
function QW() {
  return x.useContext(li);
}
const Fi = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (Fi.displayName = "StepContext");
function eU() {
  return x.useContext(Fi);
}
function VO(e) {
  return Ae("MuiStep", e);
}
const tU = Ne("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]), rU = (e) => {
  const {
    classes: t,
    orientation: r,
    alternativeLabel: o,
    completed: a
  } = e;
  return Me({
    root: ["root", r, o && "alternativeLabel", a && "completed"]
  }, VO, t);
}, nU = Y("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.orientation], r.alternativeLabel && t.alternativeLabel, r.completed && t.completed];
  }
})({
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      flex: 1,
      position: "relative"
    }
  }]
}), WO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStep"
  }), {
    active: a,
    children: i,
    className: l,
    component: c = "div",
    completed: d,
    disabled: p,
    expanded: f = !1,
    index: h,
    last: g,
    ...y
  } = o, {
    activeStep: C,
    connector: b,
    alternativeLabel: v,
    orientation: T,
    nonLinear: R
  } = x.useContext(li);
  let [$ = !1, E = !1, S = !1] = [a, d, p];
  C === h ? $ = a !== void 0 ? a : !0 : !R && C > h ? E = d !== void 0 ? d : !0 : !R && C < h && (S = p !== void 0 ? p : !0);
  const k = x.useMemo(() => ({
    index: h,
    last: g,
    expanded: f,
    icon: h + 1,
    active: $,
    completed: E,
    disabled: S
  }), [h, g, f, $, E, S]), A = {
    ...o,
    active: $,
    orientation: T,
    alternativeLabel: v,
    completed: E,
    disabled: S,
    expanded: f,
    component: c
  }, _ = rU(A), L = /* @__PURE__ */ P.jsxs(nU, {
    as: c,
    className: ge(_.root, l),
    ref: r,
    ownerState: A,
    ...y,
    children: [b && v && h !== 0 ? b : null, i]
  });
  return /* @__PURE__ */ P.jsx(Fi.Provider, {
    value: k,
    children: b && !v && h !== 0 ? /* @__PURE__ */ P.jsxs(x.Fragment, {
      children: [b, L]
    }) : L
  });
});
process.env.NODE_ENV !== "production" && (WO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: n.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: n.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: n.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: n.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: Vr,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const oU = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), aU = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function UO(e) {
  return Ae("MuiStepIcon", e);
}
const Jd = Ne("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var IC;
const iU = (e) => {
  const {
    classes: t,
    active: r,
    completed: o,
    error: a
  } = e;
  return Me({
    root: ["root", r && "active", o && "completed", a && "error"],
    text: ["text"]
  }, UO, t);
}, mh = Y(El, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${Jd.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Jd.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Jd.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), sU = Y("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})($e(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
}))), Ey = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: a = !1,
    className: i,
    completed: l = !1,
    error: c = !1,
    icon: d,
    ...p
  } = o, f = {
    ...o,
    active: a,
    completed: l,
    error: c
  }, h = iU(f);
  if (typeof d == "number" || typeof d == "string") {
    const g = ge(i, h.root);
    return c ? /* @__PURE__ */ P.jsx(mh, {
      as: aU,
      className: g,
      ref: r,
      ownerState: f,
      ...p
    }) : l ? /* @__PURE__ */ P.jsx(mh, {
      as: oU,
      className: g,
      ref: r,
      ownerState: f,
      ...p
    }) : /* @__PURE__ */ P.jsxs(mh, {
      className: g,
      ref: r,
      ownerState: f,
      ...p,
      children: [IC || (IC = /* @__PURE__ */ P.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ P.jsx(sU, {
        className: h.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: f,
        children: d
      })]
    });
  }
  return d;
});
process.env.NODE_ENV !== "production" && (Ey.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: n.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: n.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function HO(e) {
  return Ae("MuiStepLabel", e);
}
const ei = Ne("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), lU = (e) => {
  const {
    classes: t,
    orientation: r,
    active: o,
    completed: a,
    error: i,
    disabled: l,
    alternativeLabel: c
  } = e;
  return Me({
    root: ["root", r, i && "error", l && "disabled", c && "alternativeLabel"],
    label: ["label", o && "active", a && "completed", i && "error", l && "disabled", c && "alternativeLabel"],
    iconContainer: ["iconContainer", o && "active", a && "completed", i && "error", l && "disabled", c && "alternativeLabel"],
    labelContainer: ["labelContainer", c && "alternativeLabel"]
  }, HO, t);
}, cU = Y("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.orientation]];
  }
})({
  display: "flex",
  alignItems: "center",
  [`&.${ei.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${ei.disabled}`]: {
    cursor: "default"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      textAlign: "left",
      padding: "8px 0"
    }
  }]
}), uU = Y("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${ei.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${ei.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${ei.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${ei.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), dU = Y("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})({
  flexShrink: 0,
  display: "flex",
  paddingRight: 8,
  [`&.${ei.alternativeLabel}`]: {
    paddingRight: 0
  }
}), pU = Y("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})($e(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${ei.alternativeLabel}`]: {
    textAlign: "center"
  }
}))), Sf = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: a,
    className: i,
    componentsProps: l = {},
    error: c = !1,
    icon: d,
    optional: p,
    slots: f = {},
    slotProps: h = {},
    StepIconComponent: g,
    StepIconProps: y,
    ...C
  } = o, {
    alternativeLabel: b,
    orientation: v
  } = x.useContext(li), {
    active: T,
    disabled: R,
    completed: $,
    icon: E
  } = x.useContext(Fi), S = d || E;
  let k = g;
  S && !k && (k = Ey);
  const A = {
    ...o,
    active: T,
    alternativeLabel: b,
    completed: $,
    disabled: R,
    error: c,
    orientation: v
  }, _ = lU(A), L = {
    slots: f,
    slotProps: {
      stepIcon: y,
      ...l,
      ...h
    }
  }, [O, F] = ze("root", {
    elementType: cU,
    externalForwardedProps: {
      ...L,
      ...C
    },
    ownerState: A,
    ref: r,
    className: ge(_.root, i)
  }), [B, M] = ze("label", {
    elementType: uU,
    externalForwardedProps: L,
    ownerState: A
  }), [j, W] = ze("stepIcon", {
    elementType: k,
    externalForwardedProps: L,
    ownerState: A
  });
  return /* @__PURE__ */ P.jsxs(O, {
    ...F,
    children: [S || j ? /* @__PURE__ */ P.jsx(dU, {
      className: _.iconContainer,
      ownerState: A,
      children: /* @__PURE__ */ P.jsx(j, {
        completed: $,
        active: T,
        error: c,
        icon: S,
        ...W
      })
    }) : null, /* @__PURE__ */ P.jsxs(pU, {
      className: _.labelContainer,
      ownerState: A,
      children: [a ? /* @__PURE__ */ P.jsx(B, {
        ...M,
        className: ge(_.label, M?.className),
        children: a
      }) : null, p]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Sf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: n.shape({
    label: n.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: n.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: n.node,
  /**
   * The optional node to display.
   */
  optional: n.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    label: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    stepIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    label: n.elementType,
    root: n.elementType,
    stepIcon: n.elementType
  }),
  /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconComponent: n.elementType,
  /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
Sf.muiName = "StepLabel";
function GO(e) {
  return Ae("MuiStepButton", e);
}
const kg = Ne("MuiStepButton", ["root", "horizontal", "vertical", "touchRipple"]), fU = (e) => {
  const {
    classes: t,
    orientation: r
  } = e;
  return Me({
    root: ["root", r],
    touchRipple: ["touchRipple"]
  }, GO, t);
}, mU = Y(qr, {
  name: "MuiStepButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${kg.touchRipple}`]: t.touchRipple
    }, t.root, t[r.orientation]];
  }
})({
  width: "100%",
  padding: "24px 16px",
  margin: "-24px -16px",
  boxSizing: "content-box",
  [`& .${kg.touchRipple}`]: {
    color: "rgba(0, 0, 0, 0.3)"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      justifyContent: "flex-start",
      padding: "8px",
      margin: "-8px"
    }
  }]
}), qO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepButton"
  }), {
    children: a,
    className: i,
    icon: l,
    optional: c,
    ...d
  } = o, {
    disabled: p,
    active: f
  } = x.useContext(Fi), {
    orientation: h
  } = x.useContext(li), g = {
    ...o,
    orientation: h
  }, y = fU(g), C = {
    icon: l,
    optional: c
  }, b = wa(a, ["StepLabel"]) ? /* @__PURE__ */ x.cloneElement(a, C) : /* @__PURE__ */ P.jsx(Sf, {
    ...C,
    children: a
  });
  return /* @__PURE__ */ P.jsx(mU, {
    focusRipple: !0,
    disabled: p,
    TouchRippleProps: {
      className: y.touchRipple
    },
    className: ge(y.root, i),
    ref: r,
    ownerState: g,
    "aria-current": f ? "step" : void 0,
    ...d,
    children: b
  });
});
process.env.NODE_ENV !== "production" && (qO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon displayed by the step label.
   */
  icon: n.node,
  /**
   * The optional node to display.
   */
  optional: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function KO(e) {
  return Ae("MuiStepConnector", e);
}
const hU = Ne("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]), gU = (e) => {
  const {
    classes: t,
    orientation: r,
    alternativeLabel: o,
    active: a,
    completed: i,
    disabled: l
  } = e, c = {
    root: ["root", r, o && "alternativeLabel", a && "active", i && "completed", l && "disabled"],
    line: ["line", `line${re(r)}`]
  };
  return Me(c, KO, t);
}, bU = Y("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.orientation], r.alternativeLabel && t.alternativeLabel, r.completed && t.completed];
  }
})({
  flex: "1 1 auto",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      marginLeft: 12
      // half icon
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      position: "absolute",
      top: 12,
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)"
    }
  }]
}), yU = Y("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.line, t[`line${re(r.orientation)}`]];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[600];
  return {
    display: "block",
    borderColor: e.vars ? e.vars.palette.StepConnector.border : t,
    variants: [{
      props: {
        orientation: "horizontal"
      },
      style: {
        borderTopStyle: "solid",
        borderTopWidth: 1
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
      }
    }]
  };
})), Oy = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: a,
    ...i
  } = o, {
    alternativeLabel: l,
    orientation: c = "horizontal"
  } = x.useContext(li), {
    active: d,
    disabled: p,
    completed: f
  } = x.useContext(Fi), h = {
    ...o,
    alternativeLabel: l,
    orientation: c,
    active: d,
    completed: f,
    disabled: p
  }, g = gU(h);
  return /* @__PURE__ */ P.jsx(bU, {
    className: ge(g.root, a),
    ref: r,
    ownerState: h,
    ...i,
    children: /* @__PURE__ */ P.jsx(yU, {
      className: g.line,
      ownerState: h
    })
  });
});
process.env.NODE_ENV !== "production" && (Oy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function YO(e) {
  return Ae("MuiStepContent", e);
}
const vU = Ne("MuiStepContent", ["root", "last", "transition"]), xU = (e) => {
  const {
    classes: t,
    last: r
  } = e;
  return Me({
    root: ["root", r && "last"],
    transition: ["transition"]
  }, YO, t);
}, CU = Y("div", {
  name: "MuiStepContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.last && t.last];
  }
})($e(({
  theme: e
}) => ({
  marginLeft: 12,
  // half icon
  paddingLeft: 20,
  // margin + half icon
  paddingRight: 8,
  borderLeft: e.vars ? `1px solid ${e.vars.palette.StepContent.border}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[600]}`,
  variants: [{
    props: {
      last: !0
    },
    style: {
      borderLeft: "none"
    }
  }]
}))), SU = Y(Es, {
  name: "MuiStepContent",
  slot: "Transition",
  overridesResolver: (e, t) => t.transition
})({}), ZO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepContent"
  }), {
    children: a,
    className: i,
    TransitionComponent: l = Es,
    transitionDuration: c = "auto",
    TransitionProps: d,
    slots: p = {},
    slotProps: f = {},
    ...h
  } = o, {
    orientation: g
  } = x.useContext(li), {
    active: y,
    last: C,
    expanded: b
  } = x.useContext(Fi), v = {
    ...o,
    last: C
  }, T = xU(v);
  process.env.NODE_ENV !== "production" && g !== "vertical" && console.error("MUI: <StepContent /> is only designed for use with the vertical stepper.");
  let R = c;
  c === "auto" && !l.muiSupportAuto && (R = void 0);
  const $ = {
    slots: p,
    slotProps: {
      transition: d,
      ...f
    }
  }, [E, S] = ze("transition", {
    elementType: SU,
    externalForwardedProps: $,
    ownerState: v,
    className: T.transition,
    additionalProps: {
      in: y || b,
      timeout: R,
      unmountOnExit: !0
    }
  });
  return /* @__PURE__ */ P.jsx(CU, {
    className: ge(T.root, i),
    ref: r,
    ownerState: v,
    ...h,
    children: /* @__PURE__ */ P.jsx(E, {
      as: l,
      ...S,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (ZO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: n.elementType,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: n.object
});
function XO(e) {
  return Ae("MuiStepper", e);
}
const wU = Ne("MuiStepper", ["root", "horizontal", "vertical", "nonLinear", "alternativeLabel"]), TU = (e) => {
  const {
    orientation: t,
    nonLinear: r,
    alternativeLabel: o,
    classes: a
  } = e;
  return Me({
    root: ["root", t, r && "nonLinear", o && "alternativeLabel"]
  }, XO, a);
}, EU = Y("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.orientation], r.alternativeLabel && t.alternativeLabel, r.nonLinear && t.nonLinear];
  }
})({
  display: "flex",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      flexDirection: "row",
      alignItems: "center"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      alignItems: "flex-start"
    }
  }]
}), OU = /* @__PURE__ */ P.jsx(Oy, {}), JO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: a = 0,
    alternativeLabel: i = !1,
    children: l,
    className: c,
    component: d = "div",
    connector: p = OU,
    nonLinear: f = !1,
    orientation: h = "horizontal",
    ...g
  } = o, y = {
    ...o,
    nonLinear: f,
    alternativeLabel: i,
    orientation: h,
    component: d
  }, C = TU(y), b = x.Children.toArray(l).filter(Boolean), v = b.map((R, $) => /* @__PURE__ */ x.cloneElement(R, {
    index: $,
    last: $ + 1 === b.length,
    ...R.props
  })), T = x.useMemo(() => ({
    activeStep: a,
    alternativeLabel: i,
    connector: p,
    nonLinear: f,
    orientation: h
  }), [a, i, p, f, h]);
  return /* @__PURE__ */ P.jsx(li.Provider, {
    value: T,
    children: /* @__PURE__ */ P.jsx(EU, {
      as: d,
      ownerState: y,
      className: ge(C.root, c),
      ref: r,
      ...g,
      children: v
    })
  });
});
process.env.NODE_ENV !== "production" && (JO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: Vr,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: n.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: n.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: n.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const $U = Y("div", {
  name: "MuiSwipeArea",
  shouldForwardProp: Zr
})($e(({
  theme: e
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: e.zIndex.drawer - 1,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      right: "auto"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      left: "auto",
      right: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      bottom: "auto",
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      bottom: 0,
      right: 0
    }
  }]
}))), QO = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    anchor: o,
    classes: a = {},
    className: i,
    width: l,
    style: c,
    ...d
  } = t, p = t;
  return /* @__PURE__ */ P.jsx($U, {
    className: ge("PrivateSwipeArea-root", a.root, a[`anchor${re(o)}`], i),
    ref: r,
    style: {
      [as(o) ? "width" : "height"]: l,
      ...c
    },
    ownerState: p,
    ...d
  });
});
process.env.NODE_ENV !== "production" && (QO.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: n.oneOf(["left", "top", "right", "bottom"]).isRequired,
  /**
   * @ignore
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */
  width: n.number.isRequired
});
const Ad = 3, hh = 20;
let Ua = null;
function gh(e, t, r) {
  return e === "right" ? r.body.offsetWidth - t[0].pageX : t[0].pageX;
}
function bh(e, t, r) {
  return e === "bottom" ? r.innerHeight - t[0].clientY : t[0].clientY;
}
function gc(e, t) {
  return e ? t.clientWidth : t.clientHeight;
}
function NC(e, t, r, o) {
  return Math.min(Math.max(r ? t - e : o + t - e, 0), o);
}
function RU(e, t) {
  const r = [];
  for (; e && e !== t.parentElement; ) {
    const o = fn(t).getComputedStyle(e);
    // Ignore the scroll children if the element is absolute positioned.
    o.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
    o.getPropertyValue("overflow-x") === "hidden" || (e.clientWidth > 0 && e.scrollWidth > e.clientWidth || e.clientHeight > 0 && e.scrollHeight > e.clientHeight) && r.push(e), e = e.parentElement;
  }
  return r;
}
function PU({
  domTreeShapes: e,
  start: t,
  current: r,
  anchor: o
}) {
  const a = {
    scrollPosition: {
      x: "scrollLeft",
      y: "scrollTop"
    },
    scrollLength: {
      x: "scrollWidth",
      y: "scrollHeight"
    },
    clientLength: {
      x: "clientWidth",
      y: "clientHeight"
    }
  };
  return e.some((i) => {
    let l = r >= t;
    (o === "top" || o === "left") && (l = !l);
    const c = o === "left" || o === "right" ? "x" : "y", d = Math.round(i[a.scrollPosition[c]]), p = d > 0, f = d + i[a.clientLength[c]] < i[a.scrollLength[c]];
    return !!(l && f || !l && p);
  });
}
const kU = typeof navigator < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent), e5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    name: "MuiSwipeableDrawer",
    props: t
  }), a = Yr(), i = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    anchor: l = "left",
    disableBackdropTransition: c = !1,
    disableDiscovery: d = !1,
    disableSwipeToOpen: p = kU,
    hideBackdrop: f,
    hysteresis: h = 0.52,
    allowSwipeInChildren: g = !1,
    minFlingVelocity: y = 450,
    ModalProps: {
      BackdropProps: C,
      ...b
    } = {},
    onClose: v,
    onOpen: T,
    open: R = !1,
    PaperProps: $ = {},
    SwipeAreaProps: E,
    swipeAreaWidth: S = 20,
    transitionDuration: k = i,
    variant: A = "temporary",
    // Mobile first.
    slots: _ = {},
    slotProps: L = {},
    ...O
  } = o, [F, B] = x.useState(!1), M = x.useRef({
    isSwiping: null
  }), j = x.useRef(), W = x.useRef(), V = x.useRef(), X = Jt($.ref, V), U = x.useRef(!1), H = x.useRef();
  en(() => {
    H.current = null;
  }, [R]);
  const Z = x.useCallback((oe, ce = {}) => {
    const {
      mode: Ce = null,
      changeTransition: xe = !0
    } = ce, Re = Tc(a, l), J = ["right", "bottom"].includes(Re) ? 1 : -1, Ie = as(l), le = Ie ? `translate(${J * oe}px, 0)` : `translate(0, ${J * oe}px)`, qe = V.current.style;
    qe.webkitTransform = le, qe.transform = le;
    let q = "";
    if (Ce && (q = a.transitions.create("all", aa({
      easing: void 0,
      style: void 0,
      timeout: k
    }, {
      mode: Ce
    }))), xe && (qe.webkitTransition = q, qe.transition = q), !c && !f) {
      const K = W.current.style;
      K.opacity = 1 - oe / gc(Ie, V.current), xe && (K.webkitTransition = q, K.transition = q);
    }
  }, [l, c, f, a, k]), G = Pr((oe) => {
    if (!U.current)
      return;
    if (Ua = null, U.current = !1, Zh.flushSync(() => {
      B(!1);
    }), !M.current.isSwiping) {
      M.current.isSwiping = null;
      return;
    }
    M.current.isSwiping = null;
    const ce = Tc(a, l), Ce = as(l);
    let xe;
    Ce ? xe = gh(ce, oe.changedTouches, Rr(oe.currentTarget)) : xe = bh(ce, oe.changedTouches, fn(oe.currentTarget));
    const Re = Ce ? M.current.startX : M.current.startY, J = gc(Ce, V.current), Ie = NC(xe, Re, R, J), le = Ie / J;
    if (Math.abs(M.current.velocity) > y && (H.current = Math.abs((J - Ie) / M.current.velocity) * 1e3), R) {
      M.current.velocity > y || le > h ? v() : Z(0, {
        mode: "exit"
      });
      return;
    }
    M.current.velocity < -y || 1 - le > h ? T() : Z(gc(Ce, V.current), {
      mode: "enter"
    });
  }), ye = (oe = !1) => {
    if (!F) {
      (oe || !(d && g)) && Zh.flushSync(() => {
        B(!0);
      });
      const ce = as(l);
      !R && V.current && Z(gc(ce, V.current) + (d ? 15 : -hh), {
        changeTransition: !1
      }), M.current.velocity = 0, M.current.lastTime = null, M.current.lastTranslate = null, M.current.paperHit = !1, U.current = !0;
    }
  }, de = Pr((oe) => {
    if (!V.current || !U.current || Ua !== null && Ua !== M.current)
      return;
    ye(!0);
    const ce = Tc(a, l), Ce = as(l), xe = gh(ce, oe.touches, Rr(oe.currentTarget)), Re = bh(ce, oe.touches, fn(oe.currentTarget));
    if (R && V.current.contains(oe.target) && Ua === null) {
      const q = RU(oe.target, V.current);
      if (PU({
        domTreeShapes: q,
        start: Ce ? M.current.startX : M.current.startY,
        current: Ce ? xe : Re,
        anchor: l
      })) {
        Ua = !0;
        return;
      }
      Ua = M.current;
    }
    if (M.current.isSwiping == null) {
      const q = Math.abs(xe - M.current.startX), K = Math.abs(Re - M.current.startY), ee = Ce ? q > K && q > Ad : K > q && K > Ad;
      if (ee && oe.cancelable && oe.preventDefault(), ee === !0 || (Ce ? K > Ad : q > Ad)) {
        if (M.current.isSwiping = ee, !ee) {
          G(oe);
          return;
        }
        M.current.startX = xe, M.current.startY = Re, !d && !R && (Ce ? M.current.startX -= hh : M.current.startY -= hh);
      }
    }
    if (!M.current.isSwiping)
      return;
    const J = gc(Ce, V.current);
    let Ie = Ce ? M.current.startX : M.current.startY;
    R && !M.current.paperHit && (Ie = Math.min(Ie, J));
    const le = NC(Ce ? xe : Re, Ie, R, J);
    if (R)
      if (M.current.paperHit)
        le === 0 && (M.current.startX = xe, M.current.startY = Re);
      else if (Ce ? xe < J : Re < J)
        M.current.paperHit = !0, M.current.startX = xe, M.current.startY = Re;
      else
        return;
    M.current.lastTranslate === null && (M.current.lastTranslate = le, M.current.lastTime = performance.now() + 1);
    const qe = (le - M.current.lastTranslate) / (performance.now() - M.current.lastTime) * 1e3;
    M.current.velocity = M.current.velocity * 0.4 + qe * 0.6, M.current.lastTranslate = le, M.current.lastTime = performance.now(), oe.cancelable && oe.preventDefault(), Z(le);
  }), ne = Pr((oe) => {
    if (oe.defaultPrevented || oe.defaultMuiPrevented || R && (f || !W.current.contains(oe.target)) && !V.current.contains(oe.target))
      return;
    const ce = Tc(a, l), Ce = as(l), xe = gh(ce, oe.touches, Rr(oe.currentTarget)), Re = bh(ce, oe.touches, fn(oe.currentTarget));
    if (!R) {
      if (p || !(oe.target === j.current || V.current?.contains(oe.target) && (typeof g == "function" ? g(oe, j.current, V.current) : g)))
        return;
      if (Ce) {
        if (xe > S)
          return;
      } else if (Re > S)
        return;
    }
    oe.defaultMuiPrevented = !0, Ua = null, M.current.startX = xe, M.current.startY = Re, ye();
  });
  x.useEffect(() => {
    if (A === "temporary") {
      const oe = Rr(V.current);
      return oe.addEventListener("touchstart", ne), oe.addEventListener("touchmove", de, {
        passive: !R
      }), oe.addEventListener("touchend", G), () => {
        oe.removeEventListener("touchstart", ne), oe.removeEventListener("touchmove", de, {
          passive: !R
        }), oe.removeEventListener("touchend", G);
      };
    }
  }, [A, R, ne, de, G]), x.useEffect(() => () => {
    Ua === M.current && (Ua = null);
  }, []), x.useEffect(() => {
    R || B(!1);
  }, [R]);
  const [fe, ie] = ze("swipeArea", {
    ref: j,
    elementType: QO,
    ownerState: o,
    externalForwardedProps: {
      slots: _,
      slotProps: {
        swipeArea: E,
        ...L
      }
    },
    additionalProps: {
      width: S,
      anchor: l
    }
  });
  return /* @__PURE__ */ P.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ P.jsx(Zb, {
      open: A === "temporary" && F ? !0 : R,
      variant: A,
      ModalProps: {
        BackdropProps: {
          ...C,
          ref: W
        },
        // Ensures that paperRef.current will be defined inside the touch start event handler
        // See https://github.com/mui/material-ui/issues/30414 for more information
        ...A === "temporary" && {
          keepMounted: !0
        },
        ...b
      },
      hideBackdrop: f,
      anchor: l,
      transitionDuration: H.current || k,
      onClose: v,
      ref: r,
      slots: _,
      slotProps: {
        ...L,
        backdrop: Ts(L.backdrop ?? C, {
          ref: W
        }),
        paper: Ts(L.paper ?? $, {
          style: {
            pointerEvents: A === "temporary" && !R && !g ? "none" : ""
          },
          ref: X
        })
      },
      ...O
    }), !p && A === "temporary" && /* @__PURE__ */ P.jsx(Zc, {
      children: /* @__PURE__ */ P.jsx(fe, {
        ...ie
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (e5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If set to true, the swipe event will open the drawer even if the user begins the swipe on one of the drawer's children.
   * This can be useful in scenarios where the drawer is partially visible.
   * You can customize it further with a callback that determines which children the user can drag over to open the drawer
   * (for example, to ignore other elements that handle touch move events, like sliders).
   *
   * @param {TouchEvent} event The 'touchstart' event
   * @param {HTMLDivElement} swipeArea The swipe area element
   * @param {HTMLDivElement} paper The drawer's paper element
   *
   * @default false
   */
  allowSwipeInChildren: n.oneOfType([n.func, n.bool]),
  /**
   * @ignore
   */
  anchor: n.oneOf(["bottom", "left", "right", "top"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   * @default false
   */
  disableBackdropTransition: n.bool,
  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   * @default false
   */
  disableDiscovery: n.bool,
  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   * @default typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
   */
  disableSwipeToOpen: n.bool,
  /**
   * @ignore
   */
  hideBackdrop: n.bool,
  /**
   * Affects how far the drawer must be opened/closed to change its state.
   * Specified as percent (0-1) of the width of the drawer
   * @default 0.52
   */
  hysteresis: n.number,
  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   * @default 450
   */
  minFlingVelocity: n.number,
  /**
   * @ignore
   */
  ModalProps: n.shape({
    BackdropProps: n.shape({
      component: Ni
    })
  }),
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onClose: n.func.isRequired,
  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onOpen: n.func.isRequired,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: n.bool,
  /**
   * @ignore
   */
  PaperProps: n.shape({
    component: Ni,
    style: n.object
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    docked: n.oneOfType([n.func, n.object]),
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    swipeArea: n.oneOfType([n.func, n.object]),
    transition: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    docked: n.elementType,
    paper: n.elementType,
    root: n.elementType,
    swipeArea: n.elementType,
    transition: n.elementType
  }),
  /**
   * The element is used to intercept the touch events on the edge.
   * @deprecated use the `slotProps.swipeArea` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SwipeAreaProps: n.object,
  /**
   * The width of the left most (or right most) area in `px` that
   * the drawer can be swiped open from.
   * @default 20
   */
  swipeAreaWidth: n.number,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * @ignore
   */
  variant: n.oneOf(["permanent", "persistent", "temporary"])
});
function t5(e) {
  return Ae("MuiSwitch", e);
}
const En = Ne("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), AU = (e) => {
  const {
    classes: t,
    edge: r,
    size: o,
    color: a,
    checked: i,
    disabled: l
  } = e, c = {
    root: ["root", r && `edge${re(r)}`, `size${re(o)}`],
    switchBase: ["switchBase", `color${re(a)}`, i && "checked", l && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, d = Me(c, t5, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...d
  };
}, IU = Y("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.edge && t[`edge${re(r.edge)}`], t[`size${re(r.size)}`]];
  }
})({
  display: "inline-flex",
  width: 58,
  height: 38,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${En.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${En.switchBase}`]: {
        padding: 4,
        [`&.${En.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), NU = Y(gf, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.switchBase, {
      [`& .${En.input}`]: t.input
    }, r.color !== "default" && t[`color${re(r.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${En.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${En.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${En.checked} + .${En.track}`]: {
    opacity: 0.5
  },
  [`&.${En.disabled} + .${En.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${En.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), $e(({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(Vt(["light"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${En.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${En.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? oa(e.palette[t].main, 0.62) : na(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${En.checked} + .${En.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
}))), MU = Y("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})($e(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
}))), _U = Y("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})($e(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), r5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiSwitch"
  }), {
    className: a,
    color: i = "primary",
    edge: l = !1,
    size: c = "medium",
    sx: d,
    slots: p = {},
    slotProps: f = {},
    ...h
  } = o, g = {
    ...o,
    color: i,
    edge: l,
    size: c
  }, y = AU(g), C = {
    slots: p,
    slotProps: f
  }, [b, v] = ze("root", {
    className: ge(y.root, a),
    elementType: IU,
    externalForwardedProps: C,
    ownerState: g,
    additionalProps: {
      sx: d
    }
  }), [T, R] = ze("thumb", {
    className: y.thumb,
    elementType: _U,
    externalForwardedProps: C,
    ownerState: g
  }), $ = /* @__PURE__ */ P.jsx(T, {
    ...R
  }), [E, S] = ze("track", {
    className: y.track,
    elementType: MU,
    externalForwardedProps: C,
    ownerState: g
  });
  return /* @__PURE__ */ P.jsxs(b, {
    ...v,
    children: [/* @__PURE__ */ P.jsx(NU, {
      type: "checkbox",
      icon: $,
      checkedIcon: $,
      ref: r,
      ownerState: g,
      ...h,
      classes: {
        ...y,
        root: y.switchBase
      },
      slots: {
        ...p.switchBase && {
          root: p.switchBase
        },
        ...p.input && {
          input: p.input
        }
      },
      slotProps: {
        ...f.switchBase && {
          root: typeof f.switchBase == "function" ? f.switchBase(g) : f.switchBase
        },
        ...f.input && {
          input: typeof f.input == "function" ? f.input(g) : f.input
        }
      }
    }), /* @__PURE__ */ P.jsx(E, {
      ...S
    })]
  });
});
process.env.NODE_ENV !== "production" && (r5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: On,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    switchBase: n.oneOfType([n.func, n.object]),
    thumb: n.oneOfType([n.func, n.object]),
    track: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType,
    switchBase: n.elementType,
    thumb: n.elementType,
    track: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: n.any
});
function n5(e) {
  return Ae("MuiTab", e);
}
const fo = Ne("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]), FU = (e) => {
  const {
    classes: t,
    textColor: r,
    fullWidth: o,
    wrapped: a,
    icon: i,
    label: l,
    selected: c,
    disabled: d
  } = e, p = {
    root: ["root", i && l && "labelIcon", `textColor${re(r)}`, o && "fullWidth", a && "wrapped", c && "selected", d && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return Me(p, n5, t);
}, LU = Y(qr, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.label && r.icon && t.labelIcon, t[`textColor${re(r.textColor)}`], r.fullWidth && t.fullWidth, r.wrapped && t.wrapped, {
      [`& .${fo.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${fo.icon}`]: t.icon
    }];
  }
})($e(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.icon && t.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: r
    }) => t.icon && t.label && r === "top",
    style: {
      [`& > .${fo.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: r
    }) => t.icon && t.label && r === "bottom",
    style: {
      [`& > .${fo.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: r
    }) => t.icon && t.label && r === "start",
    style: {
      [`& > .${fo.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: r
    }) => t.icon && t.label && r === "end",
    style: {
      [`& > .${fo.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${fo.selected}`]: {
        opacity: 1
      },
      [`&.${fo.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${fo.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${fo.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${fo.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${fo.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.wrapped,
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), o5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTab"
  }), {
    className: a,
    disabled: i = !1,
    disableFocusRipple: l = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: c,
    icon: d,
    iconPosition: p = "top",
    // eslint-disable-next-line react/prop-types
    indicator: f,
    label: h,
    onChange: g,
    onClick: y,
    onFocus: C,
    // eslint-disable-next-line react/prop-types
    selected: b,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: v,
    // eslint-disable-next-line react/prop-types
    textColor: T = "inherit",
    value: R,
    wrapped: $ = !1,
    ...E
  } = o, S = {
    ...o,
    disabled: i,
    disableFocusRipple: l,
    selected: b,
    icon: !!d,
    iconPosition: p,
    label: !!h,
    fullWidth: c,
    textColor: T,
    wrapped: $
  }, k = FU(S), A = d && h && /* @__PURE__ */ x.isValidElement(d) ? /* @__PURE__ */ x.cloneElement(d, {
    className: ge(k.icon, d.props.className)
  }) : d, _ = (O) => {
    !b && g && g(O, R), y && y(O);
  }, L = (O) => {
    v && !b && g && g(O, R), C && C(O);
  };
  return /* @__PURE__ */ P.jsxs(LU, {
    focusRipple: !l,
    className: ge(k.root, a),
    ref: r,
    role: "tab",
    "aria-selected": b,
    disabled: i,
    onClick: _,
    onFocus: L,
    ownerState: S,
    tabIndex: b ? 0 : -1,
    ...E,
    children: [p === "top" || p === "start" ? /* @__PURE__ */ P.jsxs(x.Fragment, {
      children: [A, h]
    }) : /* @__PURE__ */ P.jsxs(x.Fragment, {
      children: [h, A]
    }), f]
  });
});
process.env.NODE_ENV !== "production" && (o5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: ef,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display.
   */
  icon: n.oneOfType([n.element, n.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: n.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: n.node,
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: n.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: n.bool
});
const $y = /* @__PURE__ */ x.createContext();
process.env.NODE_ENV !== "production" && ($y.displayName = "TableContext");
function a5(e) {
  return Ae("MuiTable", e);
}
const BU = Ne("MuiTable", ["root", "stickyHeader"]), DU = (e) => {
  const {
    classes: t,
    stickyHeader: r
  } = e;
  return Me({
    root: ["root", r && "stickyHeader"]
  }, a5, t);
}, jU = Y("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.stickyHeader && t.stickyHeader];
  }
})($e(({
  theme: e
}) => ({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": {
    ...e.typography.body2,
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      borderCollapse: "separate"
    }
  }]
}))), MC = "table", i5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTable"
  }), {
    className: a,
    component: i = MC,
    padding: l = "normal",
    size: c = "medium",
    stickyHeader: d = !1,
    ...p
  } = o, f = {
    ...o,
    component: i,
    padding: l,
    size: c,
    stickyHeader: d
  }, h = DU(f), g = x.useMemo(() => ({
    padding: l,
    size: c,
    stickyHeader: d
  }), [l, c, d]);
  return /* @__PURE__ */ P.jsx($y.Provider, {
    value: g,
    children: /* @__PURE__ */ P.jsx(jU, {
      as: i,
      role: i === MC ? null : "table",
      ref: r,
      className: ge(h.root, a),
      ownerState: f,
      ...p
    })
  });
});
process.env.NODE_ENV !== "production" && (i5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: n.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * Set the header sticky.
   * @default false
   */
  stickyHeader: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Wl = /* @__PURE__ */ x.createContext();
process.env.NODE_ENV !== "production" && (Wl.displayName = "Tablelvl2Context");
function s5(e) {
  return Ae("MuiTableBody", e);
}
const zU = Ne("MuiTableBody", ["root"]), VU = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, s5, t);
}, WU = Y("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), UU = {
  variant: "body"
}, _C = "tbody", l5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableBody"
  }), {
    className: a,
    component: i = _C,
    ...l
  } = o, c = {
    ...o,
    component: i
  }, d = VU(c);
  return /* @__PURE__ */ P.jsx(Wl.Provider, {
    value: UU,
    children: /* @__PURE__ */ P.jsx(WU, {
      className: ge(d.root, a),
      as: i,
      ref: r,
      role: i === _C ? null : "rowgroup",
      ownerState: c,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (l5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function c5(e) {
  return Ae("MuiTableCell", e);
}
const u5 = Ne("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), HU = (e) => {
  const {
    classes: t,
    variant: r,
    align: o,
    padding: a,
    size: i,
    stickyHeader: l
  } = e, c = {
    root: ["root", r, l && "stickyHeader", o !== "inherit" && `align${re(o)}`, a !== "normal" && `padding${re(a)}`, `size${re(i)}`]
  };
  return Me(c, c5, t);
}, GU = Y("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`size${re(r.size)}`], r.padding !== "normal" && t[`padding${re(r.padding)}`], r.align !== "inherit" && t[`align${re(r.align)}`], r.stickyHeader && t.stickyHeader];
  }
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? oa(dt(e.palette.divider, 1), 0.88) : na(dt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${u5.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), Xc = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableCell"
  }), {
    align: a = "inherit",
    className: i,
    component: l,
    padding: c,
    scope: d,
    size: p,
    sortDirection: f,
    variant: h,
    ...g
  } = o, y = x.useContext($y), C = x.useContext(Wl), b = C && C.variant === "head";
  let v;
  l ? v = l : v = b ? "th" : "td";
  let T = d;
  v === "td" ? T = void 0 : !T && b && (T = "col");
  const R = h || C && C.variant, $ = {
    ...o,
    align: a,
    component: v,
    padding: c || (y && y.padding ? y.padding : "normal"),
    size: p || (y && y.size ? y.size : "medium"),
    sortDirection: f,
    stickyHeader: R === "head" && y && y.stickyHeader,
    variant: R
  }, E = HU($);
  let S = null;
  return f && (S = f === "asc" ? "ascending" : "descending"), /* @__PURE__ */ P.jsx(GU, {
    as: v,
    ref: r,
    className: ge(E.root, i),
    "aria-sort": S,
    scope: T,
    ownerState: $,
    ...g
  });
});
process.env.NODE_ENV !== "production" && (Xc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: n.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: n.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: n.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: n.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: n.oneOfType([n.oneOf(["body", "footer", "head"]), n.string])
});
function d5(e) {
  return Ae("MuiTableContainer", e);
}
const qU = Ne("MuiTableContainer", ["root"]), KU = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, d5, t);
}, YU = Y("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), p5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: a,
    component: i = "div",
    ...l
  } = o, c = {
    ...o,
    component: i
  }, d = KU(c);
  return /* @__PURE__ */ P.jsx(YU, {
    ref: r,
    as: i,
    className: ge(d.root, a),
    ownerState: c,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (p5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function f5(e) {
  return Ae("MuiTableFooter", e);
}
const ZU = Ne("MuiTableFooter", ["root"]), XU = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, f5, t);
}, JU = Y("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-footer-group"
}), QU = {
  variant: "footer"
}, FC = "tfoot", m5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableFooter"
  }), {
    className: a,
    component: i = FC,
    ...l
  } = o, c = {
    ...o,
    component: i
  }, d = XU(c);
  return /* @__PURE__ */ P.jsx(Wl.Provider, {
    value: QU,
    children: /* @__PURE__ */ P.jsx(JU, {
      as: i,
      className: ge(d.root, a),
      ref: r,
      role: i === FC ? null : "rowgroup",
      ownerState: c,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (m5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function h5(e) {
  return Ae("MuiTableHead", e);
}
const eH = Ne("MuiTableHead", ["root"]), tH = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, h5, t);
}, rH = Y("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), nH = {
  variant: "head"
}, LC = "thead", g5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableHead"
  }), {
    className: a,
    component: i = LC,
    ...l
  } = o, c = {
    ...o,
    component: i
  }, d = tH(c);
  return /* @__PURE__ */ P.jsx(Wl.Provider, {
    value: nH,
    children: /* @__PURE__ */ P.jsx(rH, {
      as: i,
      className: ge(d.root, a),
      ref: r,
      role: i === LC ? null : "rowgroup",
      ownerState: c,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (g5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function b5(e) {
  return Ae("MuiToolbar", e);
}
const oH = Ne("MuiToolbar", ["root", "gutters", "regular", "dense"]), aH = (e) => {
  const {
    classes: t,
    disableGutters: r,
    variant: o
  } = e;
  return Me({
    root: ["root", !r && "gutters", o]
  }, b5, t);
}, iH = Y("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableGutters && t.gutters, t[r.variant]];
  }
})($e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), Ry = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiToolbar"
  }), {
    className: a,
    component: i = "div",
    disableGutters: l = !1,
    variant: c = "regular",
    ...d
  } = o, p = {
    ...o,
    component: i,
    disableGutters: l,
    variant: c
  }, f = aH(p);
  return /* @__PURE__ */ P.jsx(iH, {
    as: i,
    className: ge(f.root, a),
    ref: r,
    ownerState: p,
    ...d
  });
});
process.env.NODE_ENV !== "production" && (Ry.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: n.oneOfType([n.oneOf(["dense", "regular"]), n.string])
});
const y5 = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), v5 = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), x5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    backIconButtonProps: o,
    count: a,
    disabled: i = !1,
    getItemAriaLabel: l,
    nextIconButtonProps: c,
    onPageChange: d,
    page: p,
    rowsPerPage: f,
    showFirstButton: h,
    showLastButton: g,
    slots: y = {},
    slotProps: C = {},
    ...b
  } = t, v = la(), T = (G) => {
    d(G, 0);
  }, R = (G) => {
    d(G, p - 1);
  }, $ = (G) => {
    d(G, p + 1);
  }, E = (G) => {
    d(G, Math.max(0, Math.ceil(a / f) - 1));
  }, S = y.firstButton ?? Qa, k = y.lastButton ?? Qa, A = y.nextButton ?? Qa, _ = y.previousButton ?? Qa, L = y.firstButtonIcon ?? oO, O = y.lastButtonIcon ?? aO, F = y.nextButtonIcon ?? v5, B = y.previousButtonIcon ?? y5, M = v ? k : S, j = v ? A : _, W = v ? _ : A, V = v ? S : k, X = v ? C.lastButton : C.firstButton, U = v ? C.nextButton : C.previousButton, H = v ? C.previousButton : C.nextButton, Z = v ? C.firstButton : C.lastButton;
  return /* @__PURE__ */ P.jsxs("div", {
    ref: r,
    ...b,
    children: [h && /* @__PURE__ */ P.jsx(M, {
      onClick: T,
      disabled: i || p === 0,
      "aria-label": l("first", p),
      title: l("first", p),
      ...X,
      children: v ? /* @__PURE__ */ P.jsx(O, {
        ...C.lastButtonIcon
      }) : /* @__PURE__ */ P.jsx(L, {
        ...C.firstButtonIcon
      })
    }), /* @__PURE__ */ P.jsx(j, {
      onClick: R,
      disabled: i || p === 0,
      color: "inherit",
      "aria-label": l("previous", p),
      title: l("previous", p),
      ...U ?? o,
      children: v ? /* @__PURE__ */ P.jsx(F, {
        ...C.nextButtonIcon
      }) : /* @__PURE__ */ P.jsx(B, {
        ...C.previousButtonIcon
      })
    }), /* @__PURE__ */ P.jsx(W, {
      onClick: $,
      disabled: i || (a !== -1 ? p >= Math.ceil(a / f) - 1 : !1),
      color: "inherit",
      "aria-label": l("next", p),
      title: l("next", p),
      ...H ?? c,
      children: v ? /* @__PURE__ */ P.jsx(B, {
        ...C.previousButtonIcon
      }) : /* @__PURE__ */ P.jsx(F, {
        ...C.nextButtonIcon
      })
    }), g && /* @__PURE__ */ P.jsx(V, {
      onClick: E,
      disabled: i || p >= Math.ceil(a / f) - 1,
      "aria-label": l("last", p),
      title: l("last", p),
      ...Z,
      children: v ? /* @__PURE__ */ P.jsx(L, {
        ...C.firstButtonIcon
      }) : /* @__PURE__ */ P.jsx(O, {
        ...C.lastButtonIcon
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (x5.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: n.object,
  /**
   * The total number of rows.
   */
  count: n.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: n.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: n.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: n.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: n.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: n.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: n.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: n.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: n.shape({
    firstButton: n.object,
    firstButtonIcon: n.object,
    lastButton: n.object,
    lastButtonIcon: n.object,
    nextButton: n.object,
    nextButtonIcon: n.object,
    previousButton: n.object,
    previousButtonIcon: n.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    firstButton: n.elementType,
    firstButtonIcon: n.elementType,
    lastButton: n.elementType,
    lastButtonIcon: n.elementType,
    nextButton: n.elementType,
    nextButtonIcon: n.elementType,
    previousButton: n.elementType,
    previousButtonIcon: n.elementType
  })
});
function C5(e) {
  return Ae("MuiTablePagination", e);
}
const bl = Ne("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var BC;
const sH = Y(Xc, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
}))), lH = Y(Ry, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => ({
    [`& .${bl.actions}`]: t.actions,
    ...t.toolbar
  })
})($e(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${bl.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}))), cH = Y("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), uH = Y("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
}))), dH = Y(vu, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => ({
    [`& .${bl.selectIcon}`]: t.selectIcon,
    [`& .${bl.select}`]: t.select,
    ...t.input,
    ...t.selectRoot
  })
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${bl.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), pH = Y(py, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), fH = Y("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})($e(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
})));
function mH({
  from: e,
  to: t,
  count: r
}) {
  return `${e}–${t} of ${r !== -1 ? r : `more than ${t}`}`;
}
function hH(e) {
  return `Go to ${e} page`;
}
const gH = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, C5, t);
}, S5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: a = x5,
    backIconButtonProps: i,
    colSpan: l,
    component: c = Xc,
    count: d,
    disabled: p = !1,
    getItemAriaLabel: f = hH,
    labelDisplayedRows: h = mH,
    labelRowsPerPage: g = "Rows per page:",
    nextIconButtonProps: y,
    onPageChange: C,
    onRowsPerPageChange: b,
    page: v,
    rowsPerPage: T,
    rowsPerPageOptions: R = [10, 25, 50, 100],
    SelectProps: $ = {},
    showFirstButton: E = !1,
    showLastButton: S = !1,
    slotProps: k = {},
    slots: A = {},
    ..._
  } = o, L = o, O = gH(L), F = k?.select ?? $, B = F.native ? "option" : pH;
  let M;
  (c === Xc || c === "td") && (M = l || 1e3);
  const j = eo(F.id), W = eo(F.labelId), V = () => d === -1 ? (v + 1) * T : T === -1 ? d : Math.min(d, (v + 1) * T), X = {
    slots: A,
    slotProps: k
  }, [U, H] = ze("root", {
    ref: r,
    className: O.root,
    elementType: sH,
    externalForwardedProps: {
      ...X,
      component: c,
      ..._
    },
    ownerState: L,
    additionalProps: {
      colSpan: M
    }
  }), [Z, G] = ze("toolbar", {
    className: O.toolbar,
    elementType: lH,
    externalForwardedProps: X,
    ownerState: L
  }), [ye, de] = ze("spacer", {
    className: O.spacer,
    elementType: cH,
    externalForwardedProps: X,
    ownerState: L
  }), [ne, fe] = ze("selectLabel", {
    className: O.selectLabel,
    elementType: uH,
    externalForwardedProps: X,
    ownerState: L,
    additionalProps: {
      id: W
    }
  }), [ie, oe] = ze("select", {
    className: O.select,
    elementType: dH,
    externalForwardedProps: X,
    ownerState: L
  }), [ce, Ce] = ze("menuItem", {
    className: O.menuItem,
    elementType: B,
    externalForwardedProps: X,
    ownerState: L
  }), [xe, Re] = ze("displayedRows", {
    className: O.displayedRows,
    elementType: fH,
    externalForwardedProps: X,
    ownerState: L
  });
  return /* @__PURE__ */ P.jsx(U, {
    ...H,
    children: /* @__PURE__ */ P.jsxs(Z, {
      ...G,
      children: [/* @__PURE__ */ P.jsx(ye, {
        ...de
      }), R.length > 1 && /* @__PURE__ */ P.jsx(ne, {
        ...fe,
        children: g
      }), R.length > 1 && /* @__PURE__ */ P.jsx(ie, {
        variant: "standard",
        ...!F.variant && {
          input: BC || (BC = /* @__PURE__ */ P.jsx(zl, {}))
        },
        value: T,
        onChange: b,
        id: j,
        labelId: W,
        ...F,
        classes: {
          ...F.classes,
          // TODO v5 remove `classes.input`
          root: ge(O.input, O.selectRoot, (F.classes || {}).root),
          select: ge(O.select, (F.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: ge(O.selectIcon, (F.classes || {}).icon)
        },
        disabled: p,
        ...oe,
        children: R.map((J) => /* @__PURE__ */ QS(ce, {
          ...Ce,
          key: J.label ? J.label : J,
          value: J.value ? J.value : J
        }, J.label ? J.label : J))
      }), /* @__PURE__ */ P.jsx(xe, {
        ...Re,
        children: h({
          from: d === 0 ? 0 : v * T + 1,
          to: V(),
          count: d === -1 ? -1 : d,
          page: v
        })
      }), /* @__PURE__ */ P.jsx(a, {
        className: O.actions,
        backIconButtonProps: i,
        count: d,
        nextIconButtonProps: y,
        onPageChange: C,
        page: v,
        rowsPerPage: T,
        showFirstButton: E,
        showLastButton: S,
        slotProps: k.actions,
        slots: A.actions,
        getItemAriaLabel: f,
        disabled: p
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (S5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: n.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: n.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  colSpan: n.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: Vr.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: n.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: n.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: n.node,
  /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: n.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: n.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: n.func,
  /**
   * The zero-based index of the current page.
   */
  page: tn(Vr.isRequired, (e) => {
    const {
      count: t,
      page: r,
      rowsPerPage: o
    } = e;
    if (t === -1)
      return null;
    const a = Math.max(0, Math.ceil(t / o) - 1);
    return r < 0 || r > a ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${a}, but page is ${r}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: Vr.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: n.arrayOf(n.oneOfType([n.number, n.shape({
    label: n.string.isRequired,
    value: n.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: n.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: n.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    actions: n.shape({
      firstButton: n.object,
      firstButtonIcon: n.object,
      lastButton: n.object,
      lastButtonIcon: n.object,
      nextButton: n.object,
      nextButtonIcon: n.object,
      previousButton: n.object,
      previousButtonIcon: n.object
    }),
    displayedRows: n.oneOfType([n.func, n.object]),
    menuItem: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    select: n.object,
    selectLabel: n.oneOfType([n.func, n.object]),
    spacer: n.oneOfType([n.func, n.object]),
    toolbar: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    actions: n.shape({
      firstButton: n.elementType,
      firstButtonIcon: n.elementType,
      lastButton: n.elementType,
      lastButtonIcon: n.elementType,
      nextButton: n.elementType,
      nextButtonIcon: n.elementType,
      previousButton: n.elementType,
      previousButtonIcon: n.elementType
    }),
    displayedRows: n.elementType,
    menuItem: n.elementType,
    root: n.elementType,
    select: n.elementType,
    selectLabel: n.elementType,
    spacer: n.elementType,
    toolbar: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function w5(e) {
  return Ae("MuiTableRow", e);
}
const Ag = Ne("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), bH = (e) => {
  const {
    classes: t,
    selected: r,
    hover: o,
    head: a,
    footer: i
  } = e;
  return Me({
    root: ["root", r && "selected", o && "hover", a && "head", i && "footer"]
  }, w5, t);
}, yH = Y("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.head && t.head, r.footer && t.footer];
  }
})($e(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Ag.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Ag.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
}))), DC = "tr", T5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableRow"
  }), {
    className: a,
    component: i = DC,
    hover: l = !1,
    selected: c = !1,
    ...d
  } = o, p = x.useContext(Wl), f = {
    ...o,
    component: i,
    hover: l,
    selected: c,
    head: p && p.variant === "head",
    footer: p && p.variant === "footer"
  }, h = bH(f);
  return /* @__PURE__ */ P.jsx(yH, {
    as: i,
    ref: r,
    className: ge(h.root, a),
    role: i === DC ? null : "row",
    ownerState: f,
    ...d
  });
});
process.env.NODE_ENV !== "production" && (T5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: n.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const vH = Sr(/* @__PURE__ */ P.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function E5(e) {
  return Ae("MuiTableSortLabel", e);
}
const Qd = Ne("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc", "directionDesc", "directionAsc"]), xH = (e) => {
  const {
    classes: t,
    direction: r,
    active: o
  } = e, a = {
    root: ["root", o && "active", `direction${re(r)}`],
    icon: ["icon", `iconDirection${re(r)}`]
  };
  return Me(a, E5, t);
}, CH = Y(qr, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.active && t.active];
  }
})($e(({
  theme: e
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (e.vars || e).palette.text.secondary
  },
  "&:hover": {
    color: (e.vars || e).palette.text.secondary,
    [`& .${Qd.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${Qd.active}`]: {
    color: (e.vars || e).palette.text.primary,
    [`& .${Qd.icon}`]: {
      opacity: 1,
      color: (e.vars || e).palette.text.secondary
    }
  }
}))), SH = Y("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.icon, t[`iconDirection${re(r.direction)}`]];
  }
})($e(({
  theme: e
}) => ({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: e.transitions.create(["opacity", "transform"], {
    duration: e.transitions.duration.shorter
  }),
  userSelect: "none",
  variants: [{
    props: {
      direction: "desc"
    },
    style: {
      transform: "rotate(0deg)"
    }
  }, {
    props: {
      direction: "asc"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), O5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTableSortLabel"
  }), {
    active: a = !1,
    children: i,
    className: l,
    direction: c = "asc",
    hideSortIcon: d = !1,
    IconComponent: p = vH,
    slots: f = {},
    slotProps: h = {},
    ...g
  } = o, y = {
    ...o,
    active: a,
    direction: c,
    hideSortIcon: d,
    IconComponent: p
  }, C = xH(y), b = {
    slots: f,
    slotProps: h
  }, [v, T] = ze("root", {
    elementType: CH,
    externalForwardedProps: b,
    ownerState: y,
    className: ge(C.root, l),
    ref: r
  }), [R, $] = ze("icon", {
    elementType: SH,
    externalForwardedProps: b,
    ownerState: y,
    className: C.icon
  });
  return /* @__PURE__ */ P.jsxs(v, {
    disableRipple: !0,
    component: "span",
    ...T,
    ...g,
    children: [i, d && !a ? null : /* @__PURE__ */ P.jsx(R, {
      as: p,
      ...$
    })]
  });
});
process.env.NODE_ENV !== "production" && (O5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: n.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: n.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: n.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: n.elementType,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    icon: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    icon: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function wH(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function TH(e, t, r, o = {}, a = () => {
}) {
  const {
    ease: i = wH,
    duration: l = 300
    // standard
  } = o;
  let c = null;
  const d = t[e];
  let p = !1;
  const f = () => {
    p = !0;
  }, h = (g) => {
    if (p) {
      a(new Error("Animation cancelled"));
      return;
    }
    c === null && (c = g);
    const y = Math.min(1, (g - c) / l);
    if (t[e] = i(y) * (r - d) + d, y >= 1) {
      requestAnimationFrame(() => {
        a(null);
      });
      return;
    }
    requestAnimationFrame(h);
  };
  return d === r ? (a(new Error("Element already at target position")), f) : (requestAnimationFrame(h), f);
}
const EH = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function $5(e) {
  const {
    onChange: t,
    ...r
  } = e, o = x.useRef(), a = x.useRef(null), i = () => {
    o.current = a.current.offsetHeight - a.current.clientHeight;
  };
  return en(() => {
    const l = As(() => {
      const d = o.current;
      i(), d !== o.current && t(o.current);
    }), c = fn(a.current);
    return c.addEventListener("resize", l), () => {
      l.clear(), c.removeEventListener("resize", l);
    };
  }, [t]), x.useEffect(() => {
    i(), t(o.current);
  }, [t]), /* @__PURE__ */ P.jsx("div", {
    style: EH,
    ...r,
    ref: a
  });
}
process.env.NODE_ENV !== "production" && ($5.propTypes = {
  onChange: n.func.isRequired
});
function R5(e) {
  return Ae("MuiTabScrollButton", e);
}
const P5 = Ne("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), OH = (e) => {
  const {
    classes: t,
    orientation: r,
    disabled: o
  } = e;
  return Me({
    root: ["root", r, o && "disabled"]
  }, R5, t);
}, $H = Y(qr, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.orientation && t[r.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${P5.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), Py = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: a,
    slots: i = {},
    slotProps: l = {},
    direction: c,
    orientation: d,
    disabled: p,
    ...f
  } = o, h = la(), g = {
    isRtl: h,
    ...o
  }, y = OH(g), C = i.StartScrollButtonIcon ?? y5, b = i.EndScrollButtonIcon ?? v5, v = Mn({
    elementType: C,
    externalSlotProps: l.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: g
  }), T = Mn({
    elementType: b,
    externalSlotProps: l.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: g
  });
  return /* @__PURE__ */ P.jsx($H, {
    component: "div",
    className: ge(y.root, a),
    ref: r,
    role: null,
    ownerState: g,
    tabIndex: null,
    ...f,
    style: {
      ...f.style,
      ...d === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${h ? -90 : 90}deg)`
      }
    },
    children: c === "left" ? /* @__PURE__ */ P.jsx(C, {
      ...v
    }) : /* @__PURE__ */ P.jsx(b, {
      ...T
    })
  });
});
process.env.NODE_ENV !== "production" && (Py.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The direction the button should indicate.
   */
  direction: n.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: n.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: n.shape({
    endScrollButtonIcon: n.oneOfType([n.func, n.object]),
    startScrollButtonIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    EndScrollButtonIcon: n.elementType,
    StartScrollButtonIcon: n.elementType
  }),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function k5(e) {
  return Ae("MuiTabs", e);
}
const ep = Ne("MuiTabs", ["root", "vertical", "list", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), jC = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, zC = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, Id = (e, t, r) => {
  let o = !1, a = r(e, t);
  for (; a; ) {
    if (a === e.firstChild) {
      if (o)
        return;
      o = !0;
    }
    const i = a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || i)
      a = r(e, a);
    else {
      a.focus();
      return;
    }
  }
}, RH = (e) => {
  const {
    vertical: t,
    fixed: r,
    hideScrollbar: o,
    scrollableX: a,
    scrollableY: i,
    centered: l,
    scrollButtonsHideMobile: c,
    classes: d
  } = e;
  return Me({
    root: ["root", t && "vertical"],
    scroller: ["scroller", r && "fixed", o && "hideScrollbar", a && "scrollableX", i && "scrollableY"],
    list: ["list", "flexContainer", t && "flexContainerVertical", t && "vertical", l && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", c && "scrollButtonsHideMobile"],
    scrollableX: [a && "scrollableX"],
    hideScrollbar: [o && "hideScrollbar"]
  }, k5, d);
}, PH = Y("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ep.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${ep.scrollButtons}`]: r.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, r.vertical && t.vertical];
  }
})($e(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollButtonsHideMobile,
    style: {
      [`& .${ep.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), kH = Y("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.scroller, r.fixed && t.fixed, r.hideScrollbar && t.hideScrollbar, r.scrollableX && t.scrollableX, r.scrollableY && t.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: e
    }) => e.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), AH = Y("div", {
  name: "MuiTabs",
  slot: "List",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.list, t.flexContainer, r.vertical && t.flexContainerVertical, r.centered && t.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: e
    }) => e.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), IH = Y("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})($e(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), NH = Y($5)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), VC = {};
let WC = !1;
const A5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTabs"
  }), a = Yr(), i = la(), {
    "aria-label": l,
    "aria-labelledby": c,
    action: d,
    centered: p = !1,
    children: f,
    className: h,
    component: g = "div",
    allowScrollButtonsMobile: y = !1,
    indicatorColor: C = "primary",
    onChange: b,
    orientation: v = "horizontal",
    ScrollButtonComponent: T,
    // TODO: remove in v7 (deprecated in v6)
    scrollButtons: R = "auto",
    selectionFollowsFocus: $,
    slots: E = {},
    slotProps: S = {},
    TabIndicatorProps: k = {},
    // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps: A = {},
    // TODO: remove in v7 (deprecated in v6)
    textColor: _ = "primary",
    value: L,
    variant: O = "standard",
    visibleScrollbar: F = !1,
    ...B
  } = o, M = O === "scrollable", j = v === "vertical", W = j ? "scrollTop" : "scrollLeft", V = j ? "top" : "left", X = j ? "bottom" : "right", U = j ? "clientHeight" : "clientWidth", H = j ? "height" : "width", Z = {
    ...o,
    component: g,
    allowScrollButtonsMobile: y,
    indicatorColor: C,
    orientation: v,
    vertical: j,
    scrollButtons: R,
    textColor: _,
    variant: O,
    visibleScrollbar: F,
    fixed: !M,
    hideScrollbar: M && !F,
    scrollableX: M && !j,
    scrollableY: M && j,
    centered: p && !M,
    scrollButtonsHideMobile: !y
  }, G = RH(Z), ye = Mn({
    elementType: E.StartScrollButtonIcon,
    externalSlotProps: S.startScrollButtonIcon,
    ownerState: Z
  }), de = Mn({
    elementType: E.EndScrollButtonIcon,
    externalSlotProps: S.endScrollButtonIcon,
    ownerState: Z
  });
  process.env.NODE_ENV !== "production" && p && M && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [ne, fe] = x.useState(!1), [ie, oe] = x.useState(VC), [ce, Ce] = x.useState(!1), [xe, Re] = x.useState(!1), [J, Ie] = x.useState(!1), [le, qe] = x.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), q = /* @__PURE__ */ new Map(), K = x.useRef(null), ee = x.useRef(null), he = {
    slots: E,
    slotProps: {
      indicator: k,
      scrollButton: A,
      ...S
    }
  }, we = () => {
    const at = K.current;
    let lt;
    if (at) {
      const kt = at.getBoundingClientRect();
      lt = {
        clientWidth: at.clientWidth,
        scrollLeft: at.scrollLeft,
        scrollTop: at.scrollTop,
        scrollWidth: at.scrollWidth,
        top: kt.top,
        bottom: kt.bottom,
        left: kt.left,
        right: kt.right
      };
    }
    let St;
    if (at && L !== !1) {
      const kt = ee.current.children;
      if (kt.length > 0) {
        const Wt = kt[q.get(L)];
        process.env.NODE_ENV !== "production" && (Wt || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${L}".`, q.keys ? `You can provide one of the following values: ${Array.from(q.keys()).join(", ")}.` : null].join(`
`))), St = Wt ? Wt.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !WC && St && St.width === 0 && St.height === 0 && // if the whole Tabs component is hidden, don't warn
        lt.clientWidth !== 0 && (lt = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${L}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), WC = !0);
      }
    }
    return {
      tabsMeta: lt,
      tabMeta: St
    };
  }, se = Pr(() => {
    const {
      tabsMeta: at,
      tabMeta: lt
    } = we();
    let St = 0, kt;
    j ? (kt = "top", lt && at && (St = lt.top - at.top + at.scrollTop)) : (kt = i ? "right" : "left", lt && at && (St = (i ? -1 : 1) * (lt[kt] - at[kt] + at.scrollLeft)));
    const Wt = {
      [kt]: St,
      // May be wrong until the font is loaded.
      [H]: lt ? lt[H] : 0
    };
    if (typeof ie[kt] != "number" || typeof ie[H] != "number")
      oe(Wt);
    else {
      const Lr = Math.abs(ie[kt] - Wt[kt]), hn = Math.abs(ie[H] - Wt[H]);
      (Lr >= 1 || hn >= 1) && oe(Wt);
    }
  }), ue = (at, {
    animation: lt = !0
  } = {}) => {
    lt ? TH(W, K.current, at, {
      duration: a.transitions.duration.standard
    }) : K.current[W] = at;
  }, Qe = (at) => {
    let lt = K.current[W];
    j ? lt += at : lt += at * (i ? -1 : 1), ue(lt);
  }, We = () => {
    const at = K.current[U];
    let lt = 0;
    const St = Array.from(ee.current.children);
    for (let kt = 0; kt < St.length; kt += 1) {
      const Wt = St[kt];
      if (lt + Wt[U] > at) {
        kt === 0 && (lt = at);
        break;
      }
      lt += Wt[U];
    }
    return lt;
  }, be = () => {
    Qe(-1 * We());
  }, Se = () => {
    Qe(We());
  }, [De, {
    onChange: Ye,
    ...et
  }] = ze("scrollbar", {
    className: ge(G.scrollableX, G.hideScrollbar),
    elementType: NH,
    shouldForwardComponentProp: !0,
    externalForwardedProps: he,
    ownerState: Z
  }), Je = x.useCallback((at) => {
    Ye?.(at), qe({
      overflow: null,
      scrollbarWidth: at
    });
  }, [Ye]), [tt, Rt] = ze("scrollButtons", {
    className: ge(G.scrollButtons, A.className),
    elementType: Py,
    externalForwardedProps: he,
    ownerState: Z,
    additionalProps: {
      orientation: v,
      slots: {
        StartScrollButtonIcon: E.startScrollButtonIcon || E.StartScrollButtonIcon,
        EndScrollButtonIcon: E.endScrollButtonIcon || E.EndScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: ye,
        endScrollButtonIcon: de
      }
    }
  }), xt = () => {
    const at = {};
    at.scrollbarSizeListener = M ? /* @__PURE__ */ P.jsx(De, {
      ...et,
      onChange: Je
    }) : null;
    const St = M && (R === "auto" && (ce || xe) || R === !0);
    return at.scrollButtonStart = St ? /* @__PURE__ */ P.jsx(tt, {
      direction: i ? "right" : "left",
      onClick: be,
      disabled: !ce,
      ...Rt
    }) : null, at.scrollButtonEnd = St ? /* @__PURE__ */ P.jsx(tt, {
      direction: i ? "left" : "right",
      onClick: Se,
      disabled: !xe,
      ...Rt
    }) : null, at;
  }, rt = Pr((at) => {
    const {
      tabsMeta: lt,
      tabMeta: St
    } = we();
    if (!(!St || !lt)) {
      if (St[V] < lt[V]) {
        const kt = lt[W] + (St[V] - lt[V]);
        ue(kt, {
          animation: at
        });
      } else if (St[X] > lt[X]) {
        const kt = lt[W] + (St[X] - lt[X]);
        ue(kt, {
          animation: at
        });
      }
    }
  }), He = Pr(() => {
    M && R !== !1 && Ie(!J);
  });
  x.useEffect(() => {
    const at = As(() => {
      K.current && se();
    });
    let lt;
    const St = (Lr) => {
      Lr.forEach((hn) => {
        hn.removedNodes.forEach((oo) => {
          lt?.unobserve(oo);
        }), hn.addedNodes.forEach((oo) => {
          lt?.observe(oo);
        });
      }), at(), He();
    }, kt = fn(K.current);
    kt.addEventListener("resize", at);
    let Wt;
    return typeof ResizeObserver < "u" && (lt = new ResizeObserver(at), Array.from(ee.current.children).forEach((Lr) => {
      lt.observe(Lr);
    })), typeof MutationObserver < "u" && (Wt = new MutationObserver(St), Wt.observe(ee.current, {
      childList: !0
    })), () => {
      at.clear(), kt.removeEventListener("resize", at), Wt?.disconnect(), lt?.disconnect();
    };
  }, [se, He]), x.useEffect(() => {
    const at = Array.from(ee.current.children), lt = at.length;
    if (typeof IntersectionObserver < "u" && lt > 0 && M && R !== !1) {
      const St = at[0], kt = at[lt - 1], Wt = {
        root: K.current,
        threshold: 0.99
      }, Lr = (_e) => {
        Ce(!_e[0].isIntersecting);
      }, hn = new IntersectionObserver(Lr, Wt);
      hn.observe(St);
      const oo = (_e) => {
        Re(!_e[0].isIntersecting);
      }, te = new IntersectionObserver(oo, Wt);
      return te.observe(kt), () => {
        hn.disconnect(), te.disconnect();
      };
    }
  }, [M, R, J, f?.length]), x.useEffect(() => {
    fe(!0);
  }, []), x.useEffect(() => {
    se();
  }), x.useEffect(() => {
    rt(VC !== ie);
  }, [rt, ie]), x.useImperativeHandle(d, () => ({
    updateIndicator: se,
    updateScrollButtons: He
  }), [se, He]);
  const [Oe, Ze] = ze("indicator", {
    className: ge(G.indicator, k.className),
    elementType: IH,
    externalForwardedProps: he,
    ownerState: Z,
    additionalProps: {
      style: ie
    }
  }), Pt = /* @__PURE__ */ P.jsx(Oe, {
    ...Ze
  });
  let Mt = 0;
  const Ct = x.Children.map(f, (at) => {
    if (!/* @__PURE__ */ x.isValidElement(at))
      return null;
    process.env.NODE_ENV !== "production" && zn.isFragment(at) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const lt = at.props.value === void 0 ? Mt : at.props.value;
    q.set(lt, Mt);
    const St = lt === L;
    return Mt += 1, /* @__PURE__ */ x.cloneElement(at, {
      fullWidth: O === "fullWidth",
      indicator: St && !ne && Pt,
      selected: St,
      selectionFollowsFocus: $,
      onChange: b,
      textColor: _,
      value: lt,
      ...Mt === 1 && L === !1 && !at.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), bt = (at) => {
    if (at.altKey || at.shiftKey || at.ctrlKey || at.metaKey)
      return;
    const lt = ee.current, St = Rr(lt).activeElement;
    if (St.getAttribute("role") !== "tab")
      return;
    let Wt = v === "horizontal" ? "ArrowLeft" : "ArrowUp", Lr = v === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (v === "horizontal" && i && (Wt = "ArrowRight", Lr = "ArrowLeft"), at.key) {
      case Wt:
        at.preventDefault(), Id(lt, St, zC);
        break;
      case Lr:
        at.preventDefault(), Id(lt, St, jC);
        break;
      case "Home":
        at.preventDefault(), Id(lt, null, jC);
        break;
      case "End":
        at.preventDefault(), Id(lt, null, zC);
        break;
    }
  }, nt = xt(), [ft, er] = ze("root", {
    ref: r,
    className: ge(G.root, h),
    elementType: PH,
    externalForwardedProps: {
      ...he,
      ...B,
      component: g
    },
    ownerState: Z
  }), [Ut, Ft] = ze("scroller", {
    ref: K,
    className: G.scroller,
    elementType: kH,
    externalForwardedProps: he,
    ownerState: Z,
    additionalProps: {
      style: {
        overflow: le.overflow,
        [j ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: F ? void 0 : -le.scrollbarWidth
      }
    }
  }), [ct, fr] = ze("list", {
    ref: ee,
    className: ge(G.list, G.flexContainer),
    elementType: AH,
    externalForwardedProps: he,
    ownerState: Z,
    getSlotProps: (at) => ({
      ...at,
      onKeyDown: (lt) => {
        bt(lt), at.onKeyDown?.(lt);
      }
    })
  });
  return /* @__PURE__ */ P.jsxs(ft, {
    ...er,
    children: [nt.scrollButtonStart, nt.scrollbarSizeListener, /* @__PURE__ */ P.jsxs(Ut, {
      ...Ft,
      children: [/* @__PURE__ */ P.jsx(ct, {
        "aria-label": l,
        "aria-labelledby": c,
        "aria-orientation": v === "vertical" ? "vertical" : null,
        role: "tablist",
        ...fr,
        children: Ct
      }), ne && Pt]
    }), nt.scrollButtonEnd]
  });
});
process.env.NODE_ENV !== "production" && (A5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: On,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: n.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": n.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": n.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: n.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */
  ScrollButtonComponent: n.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: n.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    endScrollButtonIcon: n.oneOfType([n.func, n.object]),
    indicator: n.oneOfType([n.func, n.object]),
    list: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    scrollbar: n.oneOfType([n.func, n.object]),
    scrollButtons: n.oneOfType([n.func, n.object]),
    scroller: n.oneOfType([n.func, n.object]),
    startScrollButtonIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    endScrollButtonIcon: n.elementType,
    EndScrollButtonIcon: n.elementType,
    indicator: n.elementType,
    list: n.elementType,
    root: n.elementType,
    scrollbar: n.elementType,
    scrollButtons: n.elementType,
    scroller: n.elementType,
    startScrollButtonIcon: n.elementType,
    StartScrollButtonIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */
  TabIndicatorProps: n.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TabScrollButtonProps: n.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: n.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: n.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: n.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: n.bool
});
function I5(e) {
  return Ae("MuiTextField", e);
}
const MH = Ne("MuiTextField", ["root"]), _H = {
  standard: Vl,
  filled: bu,
  outlined: yu
}, FH = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, I5, t);
}, LH = Y(Xb, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ky = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: a,
    autoFocus: i = !1,
    children: l,
    className: c,
    color: d = "primary",
    defaultValue: p,
    disabled: f = !1,
    error: h = !1,
    FormHelperTextProps: g,
    fullWidth: y = !1,
    helperText: C,
    id: b,
    InputLabelProps: v,
    inputProps: T,
    InputProps: R,
    inputRef: $,
    label: E,
    maxRows: S,
    minRows: k,
    multiline: A = !1,
    name: _,
    onBlur: L,
    onChange: O,
    onFocus: F,
    placeholder: B,
    required: M = !1,
    rows: j,
    select: W = !1,
    SelectProps: V,
    slots: X = {},
    slotProps: U = {},
    type: H,
    value: Z,
    variant: G = "outlined",
    ...ye
  } = o, de = {
    ...o,
    autoFocus: i,
    color: d,
    disabled: f,
    error: h,
    fullWidth: y,
    multiline: A,
    required: M,
    select: W,
    variant: G
  }, ne = FH(de);
  process.env.NODE_ENV !== "production" && W && !l && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const fe = eo(b), ie = C && fe ? `${fe}-helper-text` : void 0, oe = E && fe ? `${fe}-label` : void 0, ce = _H[G], Ce = {
    slots: X,
    slotProps: {
      input: R,
      inputLabel: v,
      htmlInput: T,
      formHelperText: g,
      select: V,
      ...U
    }
  }, xe = {}, Re = Ce.slotProps.inputLabel;
  G === "outlined" && (Re && typeof Re.shrink < "u" && (xe.notched = Re.shrink), xe.label = E), W && ((!V || !V.native) && (xe.id = void 0), xe["aria-describedby"] = void 0);
  const [J, Ie] = ze("root", {
    elementType: LH,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...Ce,
      ...ye
    },
    ownerState: de,
    className: ge(ne.root, c),
    ref: r,
    additionalProps: {
      disabled: f,
      error: h,
      fullWidth: y,
      required: M,
      color: d,
      variant: G
    }
  }), [le, qe] = ze("input", {
    elementType: ce,
    externalForwardedProps: Ce,
    additionalProps: xe,
    ownerState: de
  }), [q, K] = ze("inputLabel", {
    elementType: ny,
    externalForwardedProps: Ce,
    ownerState: de
  }), [ee, he] = ze("htmlInput", {
    elementType: "input",
    externalForwardedProps: Ce,
    ownerState: de
  }), [we, se] = ze("formHelperText", {
    elementType: yf,
    externalForwardedProps: Ce,
    ownerState: de
  }), [ue, Qe] = ze("select", {
    elementType: vu,
    externalForwardedProps: Ce,
    ownerState: de
  }), We = /* @__PURE__ */ P.jsx(le, {
    "aria-describedby": ie,
    autoComplete: a,
    autoFocus: i,
    defaultValue: p,
    fullWidth: y,
    multiline: A,
    name: _,
    rows: j,
    maxRows: S,
    minRows: k,
    type: H,
    value: Z,
    id: fe,
    inputRef: $,
    onBlur: L,
    onChange: O,
    onFocus: F,
    placeholder: B,
    inputProps: he,
    slots: {
      input: X.htmlInput ? ee : void 0
    },
    ...qe
  });
  return /* @__PURE__ */ P.jsxs(J, {
    ...Ie,
    children: [E != null && E !== "" && /* @__PURE__ */ P.jsx(q, {
      htmlFor: fe,
      id: oe,
      ...K,
      children: E
    }), W ? /* @__PURE__ */ P.jsx(ue, {
      "aria-describedby": ie,
      id: fe,
      labelId: oe,
      value: Z,
      input: We,
      ...Qe,
      children: l
    }) : We, C && /* @__PURE__ */ P.jsx(we, {
      id: ie,
      ...se,
      children: C
    })]
  });
});
process.env.NODE_ENV !== "production" && (ky.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: n.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: n.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The helper text content.
   */
  helperText: n.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: n.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: n.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: n.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: On,
  /**
   * The label content.
   */
  label: n.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: n.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: n.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: n.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    formHelperText: n.oneOfType([n.func, n.object]),
    htmlInput: n.oneOfType([n.func, n.object]),
    input: n.oneOfType([n.func, n.object]),
    inputLabel: n.oneOfType([n.func, n.object]),
    select: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    formHelperText: n.elementType,
    htmlInput: n.elementType,
    input: n.elementType,
    inputLabel: n.elementType,
    root: n.elementType,
    select: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
function N5(e) {
  return Ae("MuiToggleButton", e);
}
const Pi = Ne("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), Ay = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (Ay.displayName = "ToggleButtonGroupContext");
const Iy = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Iy.displayName = "ToggleButtonGroupButtonContext");
function BH(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.includes(e) : e === t;
}
const DH = (e) => {
  const {
    classes: t,
    fullWidth: r,
    selected: o,
    disabled: a,
    size: i,
    color: l
  } = e, c = {
    root: ["root", o && "selected", a && "disabled", r && "fullWidth", `size${re(i)}`, l]
  };
  return Me(c, N5, t);
}, jH = Y(qr, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`size${re(r.size)}`]];
  }
})($e(({
  theme: e
}) => ({
  ...e.typography.button,
  borderRadius: (e.vars || e).shape.borderRadius,
  padding: 11,
  border: `1px solid ${(e.vars || e).palette.divider}`,
  color: (e.vars || e).palette.action.active,
  [`&.${Pi.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
  },
  "&:hover": {
    textDecoration: "none",
    // Reset on mouse devices
    backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.text.primary, e.palette.action.hoverOpacity),
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [{
    props: {
      color: "standard"
    },
    style: {
      [`&.${Pi.selected}`]: {
        color: (e.vars || e).palette.text.primary,
        backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.text.primary, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.text.primary, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.text.primary, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Vt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Pi.selected}`]: {
        color: (e.vars || e).palette[t].main,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette[t].main, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette[t].main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette[t].main, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  })), {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: 7,
      fontSize: e.typography.pxToRem(13)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 15,
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), M5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    value: o,
    ...a
  } = x.useContext(Ay), i = x.useContext(Iy), l = wl({
    ...a,
    selected: BH(t.value, o)
  }, t), c = Fe({
    props: l,
    name: "MuiToggleButton"
  }), {
    children: d,
    className: p,
    color: f = "standard",
    disabled: h = !1,
    disableFocusRipple: g = !1,
    fullWidth: y = !1,
    onChange: C,
    onClick: b,
    selected: v,
    size: T = "medium",
    value: R,
    ...$
  } = c, E = {
    ...c,
    color: f,
    disabled: h,
    disableFocusRipple: g,
    fullWidth: y,
    size: T
  }, S = DH(E), k = (_) => {
    b && (b(_, R), _.defaultPrevented) || C && C(_, R);
  }, A = i || "";
  return /* @__PURE__ */ P.jsx(jH, {
    className: ge(a.className, S.root, p, A),
    disabled: h,
    focusRipple: !g,
    ref: r,
    onClick: k,
    onChange: C,
    value: R,
    ownerState: E,
    "aria-pressed": v,
    ...$,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (M5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: n.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: n.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: n.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: n.any.isRequired
});
function _5(e) {
  return Ae("MuiToggleButtonGroup", e);
}
const Tr = Ne("MuiToggleButtonGroup", ["root", "selected", "horizontal", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical", "fullWidth", "firstButton", "lastButton", "middleButton"]), zH = (e) => {
  const {
    classes: t,
    orientation: r,
    fullWidth: o,
    disabled: a
  } = e, i = {
    root: ["root", r, o && "fullWidth"],
    grouped: ["grouped", `grouped${re(r)}`, a && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Me(i, _5, t);
}, VH = Y("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${Tr.grouped}`]: t.grouped
    }, {
      [`& .${Tr.grouped}`]: t[`grouped${re(r.orientation)}`]
    }, {
      [`& .${Tr.firstButton}`]: t.firstButton
    }, {
      [`& .${Tr.lastButton}`]: t.lastButton
    }, {
      [`& .${Tr.middleButton}`]: t.middleButton
    }, t.root, r.orientation === "vertical" && t.vertical, r.fullWidth && t.fullWidth];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${Tr.grouped}`]: {
        [`&.${Tr.selected} + .${Tr.grouped}.${Tr.selected}`]: {
          borderTop: 0,
          marginTop: 0
        }
      },
      [`& .${Tr.firstButton},& .${Tr.middleButton}`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Tr.lastButton},& .${Tr.middleButton}`]: {
        marginTop: -1,
        borderTop: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      [`& .${Tr.lastButton}.${Pi.disabled},& .${Tr.middleButton}.${Pi.disabled}`]: {
        borderTop: "1px solid transparent"
      }
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${Tr.grouped}`]: {
        [`&.${Tr.selected} + .${Tr.grouped}.${Tr.selected}`]: {
          borderLeft: 0,
          marginLeft: 0
        }
      },
      [`& .${Tr.firstButton},& .${Tr.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Tr.lastButton},& .${Tr.middleButton}`]: {
        marginLeft: -1,
        borderLeft: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      [`& .${Tr.lastButton}.${Pi.disabled},& .${Tr.middleButton}.${Pi.disabled}`]: {
        borderLeft: "1px solid transparent"
      }
    }
  }]
}))), F5 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const o = Fe({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: a,
    className: i,
    color: l = "standard",
    disabled: c = !1,
    exclusive: d = !1,
    fullWidth: p = !1,
    onChange: f,
    orientation: h = "horizontal",
    size: g = "medium",
    value: y,
    ...C
  } = o, b = {
    ...o,
    disabled: c,
    fullWidth: p,
    orientation: h,
    size: g
  }, v = zH(b), T = x.useCallback((A, _) => {
    if (!f)
      return;
    const L = y && y.indexOf(_);
    let O;
    y && L >= 0 ? (O = y.slice(), O.splice(L, 1)) : O = y ? y.concat(_) : [_], f(A, O);
  }, [f, y]), R = x.useCallback((A, _) => {
    f && f(A, y === _ ? null : _);
  }, [f, y]), $ = x.useMemo(() => ({
    className: v.grouped,
    onChange: d ? R : T,
    value: y,
    size: g,
    fullWidth: p,
    color: l,
    disabled: c
  }), [v.grouped, d, R, T, y, g, p, l, c]), E = W2(a), S = E.length, k = (A) => {
    const _ = A === 0, L = A === S - 1;
    return _ && L ? "" : _ ? v.firstButton : L ? v.lastButton : v.middleButton;
  };
  return /* @__PURE__ */ P.jsx(VH, {
    role: "group",
    className: ge(v.root, i),
    ref: r,
    ownerState: b,
    ...C,
    children: /* @__PURE__ */ P.jsx(Ay.Provider, {
      value: $,
      children: E.map((A, _) => (process.env.NODE_ENV !== "production" && zn.isFragment(A) && console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ P.jsx(Iy.Provider, {
        value: k(_),
        children: A
      }, _)))
    })
  });
});
process.env.NODE_ENV !== "production" && (F5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */
  exclusive: n.bool,
  /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: n.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */
  value: n.any
});
function WH(e, t) {
  const {
    disableHysteresis: r = !1,
    threshold: o = 100,
    target: a
  } = t, i = e.current;
  return a && (e.current = a.pageYOffset !== void 0 ? a.pageYOffset : a.scrollTop), !r && i !== void 0 && e.current < i ? !1 : e.current > o;
}
const UH = typeof window < "u" ? window : null;
function HH(e = {}) {
  const {
    getTrigger: t = WH,
    target: r = UH,
    ...o
  } = e, a = x.useRef(), [i, l] = x.useState(() => t(a, o));
  return x.useEffect(() => {
    if (r === null)
      return l(!1);
    const c = () => {
      l(t(a, {
        target: r,
        ...o
      }));
    };
    return c(), r.addEventListener("scroll", c, {
      passive: !0
    }), () => {
      r.removeEventListener("scroll", c, {
        passive: !0
      });
    };
  }, [r, t, JSON.stringify(o)]), i;
}
const GH = "6.5.0", qH = 6, KH = 5, YH = 0, ZH = void 0;
/**
 * @mui/material v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const L5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Accordion: xw,
  AccordionActions: Sw,
  AccordionDetails: Tw,
  AccordionSummary: Pw,
  Alert: Mw,
  AlertTitle: Lw,
  AppBar: Dw,
  Autocomplete: Ub,
  Avatar: gl,
  AvatarGroup: cT,
  Backdrop: mu,
  Badge: Hb,
  BottomNavigation: mT,
  BottomNavigationAction: gT,
  Box: Tt,
  Breadcrumbs: CT,
  Button: hu,
  ButtonBase: qr,
  ButtonGroup: ET,
  ButtonGroupButtonContext: hf,
  ButtonGroupContext: mf,
  Card: $T,
  CardActionArea: PT,
  CardActions: AT,
  CardContent: NT,
  CardHeader: _T,
  CardMedia: LT,
  Checkbox: qb,
  Chip: cf,
  CircularProgress: af,
  ClickAwayListener: Il,
  Collapse: Es,
  Container: DT,
  CssBaseline: WT,
  CssVarsProvider: fw,
  Dialog: qT,
  DialogActions: YT,
  DialogContent: QT,
  DialogContentText: tE,
  DialogTitle: rE,
  Divider: qc,
  Drawer: Zb,
  Experimental_CssVarsProvider: TM,
  Fab: bf,
  Fade: Al,
  FilledInput: bu,
  FormControl: Xb,
  FormControlLabel: dE,
  FormGroup: Jb,
  FormHelperText: yf,
  FormLabel: Qb,
  FormLabelRoot: hE,
  GlobalStyles: $b,
  Grid: Gn,
  Grid2: ey,
  Grow: $s,
  Hidden: vE,
  Icon: ty,
  IconButton: Qa,
  ImageList: SE,
  ImageListItem: TE,
  ImageListItemBar: OE,
  Input: Vl,
  InputAdornment: RE,
  InputBase: zl,
  InputLabel: ny,
  LinearProgress: ay,
  Link: iy,
  List: sy,
  ListItem: BE,
  ListItemAvatar: jE,
  ListItemButton: FE,
  ListItemIcon: VE,
  ListItemSecondaryAction: vf,
  ListItemText: UE,
  ListSubheader: Uc,
  Menu: dy,
  MenuItem: py,
  MenuList: ly,
  MobileStepper: XE,
  Modal: gu,
  ModalManager: UT,
  NativeSelect: hy,
  NoSsr: Zc,
  OutlinedInput: yu,
  Pagination: sO,
  PaginationItem: gy,
  Paper: no,
  Popover: uy,
  PopoverPaper: cy,
  PopoverRoot: qE,
  Popper: Is,
  Portal: kl,
  Radio: uO,
  RadioGroup: pO,
  Rating: gO,
  ScopedCssBaseline: yO,
  Select: vu,
  Skeleton: CO,
  Slide: Yb,
  Slider: AO,
  SliderMark: PO,
  SliderMarkLabel: kO,
  SliderRail: OO,
  SliderRoot: EO,
  SliderThumb: RO,
  SliderTrack: $O,
  SliderValueLabel: Cy,
  Snackbar: MO,
  SnackbarContent: Sy,
  SpeedDial: FO,
  SpeedDialAction: DO,
  SpeedDialIcon: Ty,
  Stack: zO,
  Step: WO,
  StepButton: qO,
  StepConnector: Oy,
  StepContent: ZO,
  StepContext: Fi,
  StepIcon: Ey,
  StepLabel: Sf,
  Stepper: JO,
  StepperContext: li,
  StyledEngineProvider: E2,
  SvgIcon: El,
  SwipeableDrawer: e5,
  Switch: r5,
  THEME_ID: wo,
  Tab: o5,
  TabScrollButton: Py,
  Table: i5,
  TableBody: l5,
  TableCell: Xc,
  TableContainer: p5,
  TableFooter: m5,
  TableHead: g5,
  TablePagination: S5,
  TableRow: T5,
  TableSortLabel: O5,
  Tabs: A5,
  TextField: ky,
  TextareaAutosize: Vb,
  ThemeProvider: OM,
  ToggleButton: M5,
  ToggleButtonGroup: F5,
  Toolbar: Ry,
  Tooltip: Cf,
  Typography: pn,
  Unstable_TrapFocus: Gc,
  Zoom: wy,
  accordionActionsClasses: t_,
  accordionClasses: wc,
  accordionDetailsClasses: o_,
  accordionSummaryClasses: us,
  adaptV4Theme: UN,
  alertClasses: sg,
  alertTitleClasses: q_,
  alpha: dt,
  appBarClasses: Z_,
  autocompleteClasses: Ke,
  avatarClasses: iT,
  avatarGroupClasses: lT,
  backdropClasses: dT,
  badgeClasses: Ka,
  bottomNavigationActionClasses: Gb,
  bottomNavigationClasses: QL,
  boxClasses: bT,
  breadcrumbsClasses: xT,
  buttonBaseClasses: Nb,
  buttonClasses: Ti,
  buttonGroupClasses: Nt,
  capitalize: re,
  cardActionAreaClasses: qd,
  cardActionsClasses: RB,
  cardClasses: SB,
  cardContentClasses: AB,
  cardHeaderClasses: Hc,
  cardMediaClasses: DB,
  checkboxClasses: Kd,
  chipClasses: Bt,
  circularProgressClasses: T_,
  collapseClasses: UM,
  colors: v8,
  containerClasses: oD,
  createChainedFunction: lp,
  createColorScheme: cw,
  createFilterOptions: Mb,
  createMuiTheme: sM,
  createStyles: mM,
  createSvgIcon: Sr,
  createTheme: uu,
  createTransitions: aw,
  css: oi,
  darkScrollbar: lD,
  darken: na,
  debounce: As,
  decomposeColor: Oa,
  deprecatedPropType: V7,
  dialogActionsClasses: AD,
  dialogClasses: Zd,
  dialogContentClasses: MD,
  dialogContentTextClasses: LD,
  dialogTitleClasses: JT,
  dividerClasses: mg,
  drawerClasses: GD,
  duration: Tb,
  easing: ow,
  emphasize: Tl,
  experimentalStyled: Y,
  experimental_extendTheme: kM,
  experimental_sx: AM,
  extendTheme: Eb,
  fabClasses: hg,
  filledInputClasses: Kn,
  formControlClasses: rj,
  formControlLabelClasses: ul,
  formGroupClasses: lj,
  formHelperTextClasses: Kc,
  formLabelClasses: ys,
  generateUtilityClass: Ae,
  generateUtilityClasses: Ne,
  getAccordionActionsUtilityClass: Cw,
  getAccordionDetailsUtilityClass: ww,
  getAccordionSummaryUtilityClass: Rw,
  getAccordionUtilityClass: vw,
  getAlertTitleUtilityClass: Fw,
  getAlertUtilityClass: kw,
  getAppBarUtilityClass: Bw,
  getAutocompleteUtilityClass: oT,
  getAvatarGroupUtilityClass: sT,
  getAvatarUtilityClass: aT,
  getBackdropUtilityClass: uT,
  getBadgeUtilityClass: pT,
  getBottomNavigationActionUtilityClass: hT,
  getBottomNavigationUtilityClass: fT,
  getBreadcrumbsUtilityClass: vT,
  getButtonBaseUtilityClass: $w,
  getButtonGroupUtilityClass: TT,
  getButtonUtilityClass: ST,
  getCardActionAreaUtilityClass: RT,
  getCardActionsUtilityClass: kT,
  getCardContentUtilityClass: IT,
  getCardHeaderUtilityClass: MT,
  getCardMediaUtilityClass: FT,
  getCardUtilityClass: OT,
  getCheckboxUtilityClass: BT,
  getChipUtilityClass: Qw,
  getCircularProgressUtilityClass: Aw,
  getCollapseUtilityClass: bw,
  getContainerUtilityClass: nD,
  getContrastRatio: ng,
  getDialogActionsUtilityClass: KT,
  getDialogContentTextUtilityClass: eE,
  getDialogContentUtilityClass: ZT,
  getDialogTitleUtilityClass: XT,
  getDialogUtilityClass: GT,
  getDividerUtilityClass: nE,
  getDrawerUtilityClass: aE,
  getFabUtilityClass: lE,
  getFilledInputUtilityClass: nT,
  getFormControlLabelUtilityClasses: uE,
  getFormControlUtilityClasses: cE,
  getFormGroupUtilityClass: pE,
  getFormHelperTextUtilityClasses: fE,
  getFormLabelUtilityClasses: mE,
  getGrid2UtilityClass: $j,
  getIconButtonUtilityClass: Iw,
  getIconUtilityClass: xE,
  getImageListItemBarUtilityClass: EE,
  getImageListItemUtilityClass: wE,
  getImageListUtilityClass: CE,
  getInitColorSchemeScript: EM,
  getInputAdornmentUtilityClass: $E,
  getInputBaseUtilityClass: eT,
  getInputLabelUtilityClasses: PE,
  getInputUtilityClass: tT,
  getLinearProgressUtilityClass: kE,
  getLinkUtilityClass: AE,
  getListItemAvatarUtilityClass: DE,
  getListItemButtonUtilityClass: _E,
  getListItemIconUtilityClass: zE,
  getListItemSecondaryActionClassesUtilityClass: LE,
  getListItemTextUtilityClass: WE,
  getListItemUtilityClass: ME,
  getListSubheaderUtilityClass: Jw,
  getListUtilityClass: NE,
  getLuminance: sp,
  getMenuItemUtilityClass: YE,
  getMenuUtilityClass: KE,
  getMobileStepperUtilityClass: ZE,
  getModalUtilityClass: HT,
  getNativeSelectUtilityClasses: fy,
  getOffsetLeft: Eg,
  getOffsetTop: Tg,
  getOutlinedInputUtilityClass: rT,
  getOverlayAlpha: fp,
  getPaginationItemUtilityClass: nO,
  getPaginationUtilityClass: tO,
  getPaperUtilityClass: yw,
  getPopoverUtilityClass: GE,
  getPopperUtilityClass: Zw,
  getRadioGroupUtilityClass: dO,
  getRadioUtilityClass: cO,
  getRatingUtilityClass: fO,
  getScopedCssBaselineUtilityClass: bO,
  getSelectUtilityClasses: vy,
  getSkeletonUtilityClass: xO,
  getSliderUtilityClass: wO,
  getSnackbarContentUtilityClass: IO,
  getSnackbarUtilityClass: NO,
  getSpeedDialActionUtilityClass: BO,
  getSpeedDialIconUtilityClass: jO,
  getSpeedDialUtilityClass: _O,
  getStepButtonUtilityClass: GO,
  getStepConnectorUtilityClass: KO,
  getStepContentUtilityClass: YO,
  getStepIconUtilityClass: UO,
  getStepLabelUtilityClass: HO,
  getStepUtilityClass: VO,
  getStepperUtilityClass: XO,
  getSvgIconUtilityClass: mw,
  getSwitchUtilityClass: t5,
  getTabScrollButtonUtilityClass: R5,
  getTabUtilityClass: n5,
  getTableBodyUtilityClass: s5,
  getTableCellUtilityClass: c5,
  getTableContainerUtilityClass: d5,
  getTableFooterUtilityClass: f5,
  getTableHeadUtilityClass: h5,
  getTablePaginationUtilityClass: C5,
  getTableRowUtilityClass: w5,
  getTableSortLabelUtilityClass: E5,
  getTableUtilityClass: a5,
  getTabsUtilityClass: k5,
  getTextFieldUtilityClass: I5,
  getToggleButtonGroupUtilityClass: _5,
  getToggleButtonUtilityClass: N5,
  getToolbarUtilityClass: b5,
  getTooltipUtilityClass: LO,
  getTouchRippleUtilityClass: c_,
  getTypographyUtilityClass: _w,
  grid2Classes: Aj,
  hexToRgb: D2,
  hslToRgb: hb,
  iconButtonClasses: ug,
  iconClasses: jj,
  imageListClasses: Wj,
  imageListItemBarClasses: Kj,
  imageListItemClasses: Xd,
  inputAdornmentClasses: yg,
  inputBaseClasses: qn,
  inputClasses: Xa,
  inputLabelClasses: sz,
  isMuiElement: wa,
  keyframes: Ro,
  lighten: oa,
  linearProgressClasses: uz,
  linkClasses: IE,
  listClasses: Sz,
  listItemAvatarClasses: Fz,
  listItemButtonClasses: is,
  listItemClasses: Ez,
  listItemIconClasses: wg,
  listItemSecondaryActionClasses: Pz,
  listItemTextClasses: ds,
  listSubheaderClasses: hL,
  major: qH,
  makeStyles: $M,
  menuClasses: Hz,
  menuItemClasses: al,
  mergeSlotProps: Ts,
  minor: KH,
  mobileStepperClasses: tV,
  modalClasses: SD,
  nativeSelectClasses: xf,
  outlinedInputClasses: jt,
  ownerDocument: Rr,
  ownerWindow: fn,
  paginationClasses: yV,
  paginationItemClasses: Tn,
  paperClasses: YM,
  patch: YH,
  popoverClasses: Wz,
  prerelease: ZH,
  private_createMixins: nw,
  private_createTypography: wb,
  private_excludeVariablesFromRoot: dw,
  radioClasses: Og,
  radioGroupClasses: DV,
  ratingClasses: il,
  recomposeColor: cu,
  requirePropFactory: gb,
  responsiveFontSizes: vM,
  rgbToHex: L7,
  scopedCssBaselineClasses: XV,
  selectClasses: sl,
  setRef: cp,
  shouldSkipGeneratingVar: uw,
  skeletonClasses: cW,
  sliderClasses: vo,
  snackbarClasses: IW,
  snackbarContentClasses: $W,
  speedDialActionClasses: $c,
  speedDialClasses: Oc,
  speedDialIconClasses: ta,
  stackClasses: JW,
  stepButtonClasses: kg,
  stepClasses: tU,
  stepConnectorClasses: hU,
  stepContentClasses: vU,
  stepIconClasses: Jd,
  stepLabelClasses: ei,
  stepperClasses: wU,
  styled: Y,
  svgIconClasses: NM,
  switchClasses: En,
  tabClasses: fo,
  tabScrollButtonClasses: P5,
  tableBodyClasses: zU,
  tableCellClasses: u5,
  tableClasses: BU,
  tableContainerClasses: qU,
  tableFooterClasses: ZU,
  tableHeadClasses: eH,
  tablePaginationClasses: bl,
  tableRowClasses: Ag,
  tableSortLabelClasses: Qd,
  tabsClasses: ep,
  textFieldClasses: MH,
  toggleButtonClasses: Pi,
  toggleButtonGroupClasses: Tr,
  toolbarClasses: oH,
  tooltipClasses: Fr,
  touchRippleClasses: bo,
  typographyClasses: zc,
  unstable_ClassNameGenerator: FM,
  unstable_composeClasses: Me,
  unstable_createBreakpoints: sb,
  unstable_createMuiStrictModeTheme: fM,
  unstable_getUnit: Ob,
  unstable_memoTheme: $e,
  unstable_toUnitless: Ya,
  unstable_useEnhancedEffect: en,
  unstable_useId: eo,
  unsupportedProp: ef,
  useAutocomplete: jw,
  useColorScheme: SM,
  useControlled: Bn,
  useEventCallback: Pr,
  useForkRef: Jt,
  useFormControl: ko,
  useMediaQuery: bE,
  usePagination: rO,
  useRadioGroup: lO,
  useScrollTrigger: HH,
  useStepContext: eU,
  useStepperContext: QW,
  useTheme: Yr,
  useThemeProps: xM,
  version: GH,
  withStyles: RM,
  withTheme: PM
}, Symbol.toStringTag, { value: "Module" }));
function B5(e) {
  var t, r, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = B5(e[t])) && (o && (o += " "), o += r);
  else for (t in e) e[t] && (o && (o += " "), o += t);
  return o;
}
function ot() {
  for (var e, t, r = 0, o = ""; r < arguments.length; ) (e = arguments[r++]) && (t = B5(e)) && (o && (o += " "), o += t);
  return o;
}
var D5 = typeof global == "object" && global && global.Object === Object && global, XH = typeof self == "object" && self && self.Object === Object && self, Ia = D5 || XH || Function("return this")(), ka = Ia.Symbol, j5 = Object.prototype, JH = j5.hasOwnProperty, QH = j5.toString, bc = ka ? ka.toStringTag : void 0;
function eG(e) {
  var t = JH.call(e, bc), r = e[bc];
  try {
    e[bc] = void 0;
    var o = !0;
  } catch {
  }
  var a = QH.call(e);
  return o && (t ? e[bc] = r : delete e[bc]), a;
}
var tG = Object.prototype, rG = tG.toString;
function nG(e) {
  return rG.call(e);
}
var oG = "[object Null]", aG = "[object Undefined]", UC = ka ? ka.toStringTag : void 0;
function Ns(e) {
  return e == null ? e === void 0 ? aG : oG : UC && UC in Object(e) ? eG(e) : nG(e);
}
function Li(e) {
  return e != null && typeof e == "object";
}
var iG = "[object Symbol]";
function Ny(e) {
  return typeof e == "symbol" || Li(e) && Ns(e) == iG;
}
function z5(e, t) {
  for (var r = -1, o = e == null ? 0 : e.length, a = Array(o); ++r < o; )
    a[r] = t(e[r], r, e);
  return a;
}
var ia = Array.isArray, HC = ka ? ka.prototype : void 0, GC = HC ? HC.toString : void 0;
function V5(e) {
  if (typeof e == "string")
    return e;
  if (ia(e))
    return z5(e, V5) + "";
  if (Ny(e))
    return GC ? GC.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function sa(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function W5(e) {
  return e;
}
var sG = "[object AsyncFunction]", lG = "[object Function]", cG = "[object GeneratorFunction]", uG = "[object Proxy]";
function My(e) {
  if (!sa(e))
    return !1;
  var t = Ns(e);
  return t == lG || t == cG || t == sG || t == uG;
}
var yh = Ia["__core-js_shared__"], qC = function() {
  var e = /[^.]+$/.exec(yh && yh.keys && yh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function dG(e) {
  return !!qC && qC in e;
}
var pG = Function.prototype, fG = pG.toString;
function Ms(e) {
  if (e != null) {
    try {
      return fG.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var mG = /[\\^$.*+?()[\]{}|]/g, hG = /^\[object .+?Constructor\]$/, gG = Function.prototype, bG = Object.prototype, yG = gG.toString, vG = bG.hasOwnProperty, xG = RegExp(
  "^" + yG.call(vG).replace(mG, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function CG(e) {
  if (!sa(e) || dG(e))
    return !1;
  var t = My(e) ? xG : hG;
  return t.test(Ms(e));
}
function SG(e, t) {
  return e?.[t];
}
function _s(e, t) {
  var r = SG(e, t);
  return CG(r) ? r : void 0;
}
var Ig = _s(Ia, "WeakMap"), KC = Object.create, wG = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!sa(t))
      return {};
    if (KC)
      return KC(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
function TG(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function EG(e, t) {
  var r = -1, o = e.length;
  for (t || (t = Array(o)); ++r < o; )
    t[r] = e[r];
  return t;
}
var OG = 800, $G = 16, RG = Date.now;
function PG(e) {
  var t = 0, r = 0;
  return function() {
    var o = RG(), a = $G - (o - r);
    if (r = o, a > 0) {
      if (++t >= OG)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function kG(e) {
  return function() {
    return e;
  };
}
var Sp = function() {
  try {
    var e = _s(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), AG = Sp ? function(e, t) {
  return Sp(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: kG(t),
    writable: !0
  });
} : W5, U5 = PG(AG);
function IG(e, t) {
  for (var r = -1, o = e == null ? 0 : e.length; ++r < o && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var NG = 9007199254740991, MG = /^(?:0|[1-9]\d*)$/;
function wf(e, t) {
  var r = typeof e;
  return t = t ?? NG, !!t && (r == "number" || r != "symbol" && MG.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function _y(e, t, r) {
  t == "__proto__" && Sp ? Sp(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function Tf(e, t) {
  return e === t || e !== e && t !== t;
}
var _G = Object.prototype, FG = _G.hasOwnProperty;
function Fy(e, t, r) {
  var o = e[t];
  (!(FG.call(e, t) && Tf(o, r)) || r === void 0 && !(t in e)) && _y(e, t, r);
}
function H5(e, t, r, o) {
  var a = !r;
  r || (r = {});
  for (var i = -1, l = t.length; ++i < l; ) {
    var c = t[i], d = void 0;
    d === void 0 && (d = e[c]), a ? _y(r, c, d) : Fy(r, c, d);
  }
  return r;
}
var YC = Math.max;
function G5(e, t, r) {
  return t = YC(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, a = -1, i = YC(o.length - t, 0), l = Array(i); ++a < i; )
      l[a] = o[t + a];
    a = -1;
    for (var c = Array(t + 1); ++a < t; )
      c[a] = o[a];
    return c[t] = r(l), TG(e, this, c);
  };
}
function LG(e, t) {
  return U5(G5(e, t, W5), e + "");
}
var BG = 9007199254740991;
function Ly(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= BG;
}
function xu(e) {
  return e != null && Ly(e.length) && !My(e);
}
function DG(e, t, r) {
  if (!sa(r))
    return !1;
  var o = typeof t;
  return (o == "number" ? xu(r) && wf(t, r.length) : o == "string" && t in r) ? Tf(r[t], e) : !1;
}
function jG(e) {
  return LG(function(t, r) {
    var o = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, l = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, l && DG(r[0], r[1], l) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++o < a; ) {
      var c = r[o];
      c && e(t, c, o, i);
    }
    return t;
  });
}
var zG = Object.prototype;
function Ef(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || zG;
  return e === r;
}
function VG(e, t) {
  for (var r = -1, o = Array(e); ++r < e; )
    o[r] = t(r);
  return o;
}
var WG = "[object Arguments]";
function ZC(e) {
  return Li(e) && Ns(e) == WG;
}
var q5 = Object.prototype, UG = q5.hasOwnProperty, HG = q5.propertyIsEnumerable, Nl = ZC(/* @__PURE__ */ function() {
  return arguments;
}()) ? ZC : function(e) {
  return Li(e) && UG.call(e, "callee") && !HG.call(e, "callee");
};
function GG() {
  return !1;
}
var K5 = typeof exports == "object" && exports && !exports.nodeType && exports, XC = K5 && typeof module == "object" && module && !module.nodeType && module, qG = XC && XC.exports === K5, JC = qG ? Ia.Buffer : void 0, KG = JC ? JC.isBuffer : void 0, Of = KG || GG, YG = "[object Arguments]", ZG = "[object Array]", XG = "[object Boolean]", JG = "[object Date]", QG = "[object Error]", eq = "[object Function]", tq = "[object Map]", rq = "[object Number]", nq = "[object Object]", oq = "[object RegExp]", aq = "[object Set]", iq = "[object String]", sq = "[object WeakMap]", lq = "[object ArrayBuffer]", cq = "[object DataView]", uq = "[object Float32Array]", dq = "[object Float64Array]", pq = "[object Int8Array]", fq = "[object Int16Array]", mq = "[object Int32Array]", hq = "[object Uint8Array]", gq = "[object Uint8ClampedArray]", bq = "[object Uint16Array]", yq = "[object Uint32Array]", Ar = {};
Ar[uq] = Ar[dq] = Ar[pq] = Ar[fq] = Ar[mq] = Ar[hq] = Ar[gq] = Ar[bq] = Ar[yq] = !0;
Ar[YG] = Ar[ZG] = Ar[lq] = Ar[XG] = Ar[cq] = Ar[JG] = Ar[QG] = Ar[eq] = Ar[tq] = Ar[rq] = Ar[nq] = Ar[oq] = Ar[aq] = Ar[iq] = Ar[sq] = !1;
function vq(e) {
  return Li(e) && Ly(e.length) && !!Ar[Ns(e)];
}
function By(e) {
  return function(t) {
    return e(t);
  };
}
var Y5 = typeof exports == "object" && exports && !exports.nodeType && exports, Nc = Y5 && typeof module == "object" && module && !module.nodeType && module, xq = Nc && Nc.exports === Y5, vh = xq && D5.process, Ml = function() {
  try {
    var e = Nc && Nc.require && Nc.require("util").types;
    return e || vh && vh.binding && vh.binding("util");
  } catch {
  }
}(), QC = Ml && Ml.isTypedArray, Dy = QC ? By(QC) : vq, Cq = Object.prototype, Sq = Cq.hasOwnProperty;
function Z5(e, t) {
  var r = ia(e), o = !r && Nl(e), a = !r && !o && Of(e), i = !r && !o && !a && Dy(e), l = r || o || a || i, c = l ? VG(e.length, String) : [], d = c.length;
  for (var p in e)
    (t || Sq.call(e, p)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    wf(p, d))) && c.push(p);
  return c;
}
function X5(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var wq = X5(Object.keys, Object), Tq = Object.prototype, Eq = Tq.hasOwnProperty;
function J5(e) {
  if (!Ef(e))
    return wq(e);
  var t = [];
  for (var r in Object(e))
    Eq.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Oq(e) {
  return xu(e) ? Z5(e) : J5(e);
}
function $q(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Rq = Object.prototype, Pq = Rq.hasOwnProperty;
function kq(e) {
  if (!sa(e))
    return $q(e);
  var t = Ef(e), r = [];
  for (var o in e)
    o == "constructor" && (t || !Pq.call(e, o)) || r.push(o);
  return r;
}
function jy(e) {
  return xu(e) ? Z5(e, !0) : kq(e);
}
var Aq = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Iq = /^\w*$/;
function Nq(e, t) {
  if (ia(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Ny(e) ? !0 : Iq.test(e) || !Aq.test(e) || t != null && e in Object(t);
}
var Jc = _s(Object, "create");
function Mq() {
  this.__data__ = Jc ? Jc(null) : {}, this.size = 0;
}
function _q(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Fq = "__lodash_hash_undefined__", Lq = Object.prototype, Bq = Lq.hasOwnProperty;
function Dq(e) {
  var t = this.__data__;
  if (Jc) {
    var r = t[e];
    return r === Fq ? void 0 : r;
  }
  return Bq.call(t, e) ? t[e] : void 0;
}
var jq = Object.prototype, zq = jq.hasOwnProperty;
function Vq(e) {
  var t = this.__data__;
  return Jc ? t[e] !== void 0 : zq.call(t, e);
}
var Wq = "__lodash_hash_undefined__";
function Uq(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Jc && t === void 0 ? Wq : t, this;
}
function Rs(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Rs.prototype.clear = Mq;
Rs.prototype.delete = _q;
Rs.prototype.get = Dq;
Rs.prototype.has = Vq;
Rs.prototype.set = Uq;
function Hq() {
  this.__data__ = [], this.size = 0;
}
function $f(e, t) {
  for (var r = e.length; r--; )
    if (Tf(e[r][0], t))
      return r;
  return -1;
}
var Gq = Array.prototype, qq = Gq.splice;
function Kq(e) {
  var t = this.__data__, r = $f(t, e);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : qq.call(t, r, 1), --this.size, !0;
}
function Yq(e) {
  var t = this.__data__, r = $f(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Zq(e) {
  return $f(this.__data__, e) > -1;
}
function Xq(e, t) {
  var r = this.__data__, o = $f(r, e);
  return o < 0 ? (++this.size, r.push([e, t])) : r[o][1] = t, this;
}
function ci(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
ci.prototype.clear = Hq;
ci.prototype.delete = Kq;
ci.prototype.get = Yq;
ci.prototype.has = Zq;
ci.prototype.set = Xq;
var Qc = _s(Ia, "Map");
function Jq() {
  this.size = 0, this.__data__ = {
    hash: new Rs(),
    map: new (Qc || ci)(),
    string: new Rs()
  };
}
function Qq(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Rf(e, t) {
  var r = e.__data__;
  return Qq(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function eK(e) {
  var t = Rf(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function tK(e) {
  return Rf(this, e).get(e);
}
function rK(e) {
  return Rf(this, e).has(e);
}
function nK(e, t) {
  var r = Rf(this, e), o = r.size;
  return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
}
function Bi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Bi.prototype.clear = Jq;
Bi.prototype.delete = eK;
Bi.prototype.get = tK;
Bi.prototype.has = rK;
Bi.prototype.set = nK;
var oK = "Expected a function";
function zy(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(oK);
  var r = function() {
    var o = arguments, a = t ? t.apply(this, o) : o[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var l = e.apply(this, o);
    return r.cache = i.set(a, l) || i, l;
  };
  return r.cache = new (zy.Cache || Bi)(), r;
}
zy.Cache = Bi;
var aK = 500;
function iK(e) {
  var t = zy(e, function(o) {
    return r.size === aK && r.clear(), o;
  }), r = t.cache;
  return t;
}
var sK = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lK = /\\(\\)?/g, cK = iK(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(sK, function(r, o, a, i) {
    t.push(a ? i.replace(lK, "$1") : o || r);
  }), t;
});
function uK(e) {
  return e == null ? "" : V5(e);
}
function Ul(e, t) {
  return ia(e) ? e : Nq(e, t) ? [e] : cK(uK(e));
}
function Pf(e) {
  if (typeof e == "string" || Ny(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Vy(e, t) {
  t = Ul(t, e);
  for (var r = 0, o = t.length; e != null && r < o; )
    e = e[Pf(t[r++])];
  return r && r == o ? e : void 0;
}
function ps(e, t, r) {
  var o = e == null ? void 0 : Vy(e, t);
  return o === void 0 ? r : o;
}
function Wy(e, t) {
  for (var r = -1, o = t.length, a = e.length; ++r < o; )
    e[a + r] = t[r];
  return e;
}
var eS = ka ? ka.isConcatSpreadable : void 0;
function dK(e) {
  return ia(e) || Nl(e) || !!(eS && e && e[eS]);
}
function pK(e, t, r, o, a) {
  var i = -1, l = e.length;
  for (r || (r = dK), a || (a = []); ++i < l; ) {
    var c = e[i];
    r(c) ? Wy(a, c) : a[a.length] = c;
  }
  return a;
}
function fK(e) {
  var t = e == null ? 0 : e.length;
  return t ? pK(e) : [];
}
function Q5(e) {
  return U5(G5(e, void 0, fK), e + "");
}
var Uy = X5(Object.getPrototypeOf, Object), mK = "[object Object]", hK = Function.prototype, gK = Object.prototype, e4 = hK.toString, bK = gK.hasOwnProperty, yK = e4.call(Object);
function t4(e) {
  if (!Li(e) || Ns(e) != mK)
    return !1;
  var t = Uy(e);
  if (t === null)
    return !0;
  var r = bK.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && e4.call(r) == yK;
}
function vK(e, t, r) {
  var o = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++o < a; )
    i[o] = e[o + t];
  return i;
}
function xK() {
  this.__data__ = new ci(), this.size = 0;
}
function CK(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function SK(e) {
  return this.__data__.get(e);
}
function wK(e) {
  return this.__data__.has(e);
}
var TK = 200;
function EK(e, t) {
  var r = this.__data__;
  if (r instanceof ci) {
    var o = r.__data__;
    if (!Qc || o.length < TK - 1)
      return o.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Bi(o);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Fs(e) {
  var t = this.__data__ = new ci(e);
  this.size = t.size;
}
Fs.prototype.clear = xK;
Fs.prototype.delete = CK;
Fs.prototype.get = SK;
Fs.prototype.has = wK;
Fs.prototype.set = EK;
var r4 = typeof exports == "object" && exports && !exports.nodeType && exports, tS = r4 && typeof module == "object" && module && !module.nodeType && module, OK = tS && tS.exports === r4, rS = OK ? Ia.Buffer : void 0, nS = rS ? rS.allocUnsafe : void 0;
function n4(e, t) {
  if (t)
    return e.slice();
  var r = e.length, o = nS ? nS(r) : new e.constructor(r);
  return e.copy(o), o;
}
function $K(e, t) {
  for (var r = -1, o = e == null ? 0 : e.length, a = 0, i = []; ++r < o; ) {
    var l = e[r];
    t(l, r, e) && (i[a++] = l);
  }
  return i;
}
function o4() {
  return [];
}
var RK = Object.prototype, PK = RK.propertyIsEnumerable, oS = Object.getOwnPropertySymbols, kK = oS ? function(e) {
  return e == null ? [] : (e = Object(e), $K(oS(e), function(t) {
    return PK.call(e, t);
  }));
} : o4, AK = Object.getOwnPropertySymbols, IK = AK ? function(e) {
  for (var t = []; e; )
    Wy(t, kK(e)), e = Uy(e);
  return t;
} : o4;
function NK(e, t, r) {
  var o = t(e);
  return ia(e) ? o : Wy(o, r(e));
}
function a4(e) {
  return NK(e, jy, IK);
}
var Ng = _s(Ia, "DataView"), Mg = _s(Ia, "Promise"), _g = _s(Ia, "Set"), aS = "[object Map]", MK = "[object Object]", iS = "[object Promise]", sS = "[object Set]", lS = "[object WeakMap]", cS = "[object DataView]", _K = Ms(Ng), FK = Ms(Qc), LK = Ms(Mg), BK = Ms(_g), DK = Ms(Ig), va = Ns;
(Ng && va(new Ng(new ArrayBuffer(1))) != cS || Qc && va(new Qc()) != aS || Mg && va(Mg.resolve()) != iS || _g && va(new _g()) != sS || Ig && va(new Ig()) != lS) && (va = function(e) {
  var t = Ns(e), r = t == MK ? e.constructor : void 0, o = r ? Ms(r) : "";
  if (o)
    switch (o) {
      case _K:
        return cS;
      case FK:
        return aS;
      case LK:
        return iS;
      case BK:
        return sS;
      case DK:
        return lS;
    }
  return t;
});
var jK = Object.prototype, zK = jK.hasOwnProperty;
function VK(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && zK.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var uS = Ia.Uint8Array;
function Hy(e) {
  var t = new e.constructor(e.byteLength);
  return new uS(t).set(new uS(e)), t;
}
function WK(e, t) {
  var r = Hy(e.buffer);
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var UK = /\w*$/;
function HK(e) {
  var t = new e.constructor(e.source, UK.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var dS = ka ? ka.prototype : void 0, pS = dS ? dS.valueOf : void 0;
function GK(e) {
  return pS ? Object(pS.call(e)) : {};
}
function i4(e, t) {
  var r = t ? Hy(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var qK = "[object Boolean]", KK = "[object Date]", YK = "[object Map]", ZK = "[object Number]", XK = "[object RegExp]", JK = "[object Set]", QK = "[object String]", eY = "[object Symbol]", tY = "[object ArrayBuffer]", rY = "[object DataView]", nY = "[object Float32Array]", oY = "[object Float64Array]", aY = "[object Int8Array]", iY = "[object Int16Array]", sY = "[object Int32Array]", lY = "[object Uint8Array]", cY = "[object Uint8ClampedArray]", uY = "[object Uint16Array]", dY = "[object Uint32Array]";
function pY(e, t, r) {
  var o = e.constructor;
  switch (t) {
    case tY:
      return Hy(e);
    case qK:
    case KK:
      return new o(+e);
    case rY:
      return WK(e);
    case nY:
    case oY:
    case aY:
    case iY:
    case sY:
    case lY:
    case cY:
    case uY:
    case dY:
      return i4(e, r);
    case YK:
      return new o();
    case ZK:
    case QK:
      return new o(e);
    case XK:
      return HK(e);
    case JK:
      return new o();
    case eY:
      return GK(e);
  }
}
function fY(e) {
  return typeof e.constructor == "function" && !Ef(e) ? wG(Uy(e)) : {};
}
var mY = "[object Map]";
function hY(e) {
  return Li(e) && va(e) == mY;
}
var fS = Ml && Ml.isMap, gY = fS ? By(fS) : hY, bY = "[object Set]";
function yY(e) {
  return Li(e) && va(e) == bY;
}
var mS = Ml && Ml.isSet, vY = mS ? By(mS) : yY, xY = 1, s4 = "[object Arguments]", CY = "[object Array]", SY = "[object Boolean]", wY = "[object Date]", TY = "[object Error]", l4 = "[object Function]", EY = "[object GeneratorFunction]", OY = "[object Map]", $Y = "[object Number]", c4 = "[object Object]", RY = "[object RegExp]", PY = "[object Set]", kY = "[object String]", AY = "[object Symbol]", IY = "[object WeakMap]", NY = "[object ArrayBuffer]", MY = "[object DataView]", _Y = "[object Float32Array]", FY = "[object Float64Array]", LY = "[object Int8Array]", BY = "[object Int16Array]", DY = "[object Int32Array]", jY = "[object Uint8Array]", zY = "[object Uint8ClampedArray]", VY = "[object Uint16Array]", WY = "[object Uint32Array]", Er = {};
Er[s4] = Er[CY] = Er[NY] = Er[MY] = Er[SY] = Er[wY] = Er[_Y] = Er[FY] = Er[LY] = Er[BY] = Er[DY] = Er[OY] = Er[$Y] = Er[c4] = Er[RY] = Er[PY] = Er[kY] = Er[AY] = Er[jY] = Er[zY] = Er[VY] = Er[WY] = !0;
Er[TY] = Er[l4] = Er[IY] = !1;
function tp(e, t, r, o, a, i) {
  var l, c = t & xY;
  if (r && (l = a ? r(e, o, a, i) : r(e)), l !== void 0)
    return l;
  if (!sa(e))
    return e;
  var d = ia(e);
  if (d)
    l = VK(e);
  else {
    var p = va(e), f = p == l4 || p == EY;
    if (Of(e))
      return n4(e, c);
    if (p == c4 || p == s4 || f && !a)
      l = {};
    else {
      if (!Er[p])
        return a ? e : {};
      l = pY(e, p, c);
    }
  }
  i || (i = new Fs());
  var h = i.get(e);
  if (h)
    return h;
  i.set(e, l), vY(e) ? e.forEach(function(C) {
    l.add(tp(C, t, r, C, e, i));
  }) : gY(e) && e.forEach(function(C, b) {
    l.set(b, tp(C, t, r, b, e, i));
  });
  var g = a4, y = d ? void 0 : g(e);
  return IG(y || e, function(C, b) {
    y && (b = C, C = e[b]), Fy(l, b, tp(C, t, r, b, e, i));
  }), l;
}
function UY(e, t) {
  return e != null && t in Object(e);
}
function HY(e, t, r) {
  t = Ul(t, e);
  for (var o = -1, a = t.length, i = !1; ++o < a; ) {
    var l = Pf(t[o]);
    if (!(i = e != null && r(e, l)))
      break;
    e = e[l];
  }
  return i || ++o != a ? i : (a = e == null ? 0 : e.length, !!a && Ly(a) && wf(l, a) && (ia(e) || Nl(e)));
}
function GY(e, t) {
  return e != null && HY(e, t, UY);
}
function qY(e) {
  return function(t, r, o) {
    for (var a = -1, i = Object(t), l = o(t), c = l.length; c--; ) {
      var d = l[++a];
      if (r(i[d], d, i) === !1)
        break;
    }
    return t;
  };
}
var KY = qY();
function Fg(e, t, r) {
  (r !== void 0 && !Tf(e[t], r) || r === void 0 && !(t in e)) && _y(e, t, r);
}
function YY(e) {
  return Li(e) && xu(e);
}
function Lg(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function ZY(e) {
  return H5(e, jy(e));
}
function XY(e, t, r, o, a, i, l) {
  var c = Lg(e, r), d = Lg(t, r), p = l.get(d);
  if (p) {
    Fg(e, r, p);
    return;
  }
  var f = i ? i(c, d, r + "", e, t, l) : void 0, h = f === void 0;
  if (h) {
    var g = ia(d), y = !g && Of(d), C = !g && !y && Dy(d);
    f = d, g || y || C ? ia(c) ? f = c : YY(c) ? f = EG(c) : y ? (h = !1, f = n4(d, !0)) : C ? (h = !1, f = i4(d, !0)) : f = [] : t4(d) || Nl(d) ? (f = c, Nl(c) ? f = ZY(c) : (!sa(c) || My(c)) && (f = fY(d))) : h = !1;
  }
  h && (l.set(d, f), a(f, d, o, i, l), l.delete(d)), Fg(e, r, f);
}
function u4(e, t, r, o, a) {
  e !== t && KY(t, function(i, l) {
    if (a || (a = new Fs()), sa(i))
      XY(e, t, l, r, u4, o, a);
    else {
      var c = o ? o(Lg(e, l), i, l + "", e, t, a) : void 0;
      c === void 0 && (c = i), Fg(e, l, c);
    }
  }, jy);
}
var JY = jG(function(e, t, r, o) {
  u4(e, t, r, o);
});
function QY(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function eZ(e, t) {
  return t.length < 2 ? e : Vy(e, vK(t, 0, -1));
}
var tZ = "[object Map]", rZ = "[object Set]", nZ = Object.prototype, oZ = nZ.hasOwnProperty;
function xh(e) {
  if (e == null)
    return !0;
  if (xu(e) && (ia(e) || typeof e == "string" || typeof e.splice == "function" || Of(e) || Dy(e) || Nl(e)))
    return !e.length;
  var t = va(e);
  if (t == tZ || t == rZ)
    return !e.size;
  if (Ef(e))
    return !J5(e).length;
  for (var r in e)
    if (oZ.call(e, r))
      return !1;
  return !0;
}
function aZ(e) {
  return e == null;
}
function iZ(e) {
  return e === void 0;
}
function sZ(e, t) {
  return t = Ul(t, e), e = eZ(e, t), e == null || delete e[Pf(QY(t))];
}
function lZ(e) {
  return t4(e) ? void 0 : e;
}
var cZ = 1, uZ = 2, dZ = 4, $o = Q5(function(e, t) {
  var r = {};
  if (e == null)
    return r;
  var o = !1;
  t = z5(t, function(i) {
    return i = Ul(i, e), o || (o = i.length > 1), i;
  }), H5(e, a4(e), r), o && (r = tp(r, cZ | uZ | dZ, lZ));
  for (var a = t.length; a--; )
    sZ(r, t[a]);
  return r;
});
function d4(e, t, r, o) {
  if (!sa(e))
    return e;
  t = Ul(t, e);
  for (var a = -1, i = t.length, l = i - 1, c = e; c != null && ++a < i; ) {
    var d = Pf(t[a]), p = r;
    if (d === "__proto__" || d === "constructor" || d === "prototype")
      return e;
    if (a != l) {
      var f = c[d];
      p = void 0, p === void 0 && (p = sa(f) ? f : wf(t[a + 1]) ? [] : {});
    }
    Fy(c, d, p), c = c[d];
  }
  return e;
}
function pZ(e, t, r) {
  for (var o = -1, a = t.length, i = {}; ++o < a; ) {
    var l = t[o], c = Vy(e, l);
    r(c, l) && d4(i, Ul(l, e), c);
  }
  return i;
}
function fZ(e, t) {
  return pZ(e, t, function(r, o) {
    return GY(e, o);
  });
}
var mZ = Q5(function(e, t) {
  return e == null ? {} : fZ(e, t);
});
function Mc(e, t, r) {
  return e == null ? e : d4(e, t, r);
}
const hZ = {
  ui: {
    black: "#000000",
    white: "#FFFFFF",
    gray: {
      0: "#FFFFFF",
      5: "#FCFDFD",
      10: "#F7F9FA",
      20: "#F1F4F6",
      30: "#DFE3E8",
      40: "#C1C6CE",
      50: "#98A0A9",
      60: "#6E7680",
      70: "#555B62",
      80: "#3B3F44",
      90: "#323539",
      100: "#27282B",
      110: "#1D1E20",
      120: "#131619"
    },
    blue: {
      10: "#F2F8FF",
      20: "#D0E3FB",
      30: "#A8CCF8",
      40: "#7AB1F4",
      50: "#4793F1",
      60: "#0E72ED",
      70: "#2057B1",
      80: "#213C77",
      90: "#1F3363",
      100: "#1B2749"
    },
    orange: {
      10: "#FFF7F2",
      20: "#FFD1B9",
      30: "#FFAB81",
      40: "#FF8548",
      50: "#FF5F0F",
      60: "#CF4B0A",
      70: "#9D3B0F",
      80: "#6B2C0F",
      90: "#59260F",
      100: "#441E0D"
    },
    teal: {
      10: "#E9FEFD",
      20: "#D4FCFB",
      30: "#61F6F2",
      40: "#00B2AE",
      50: "#009E9A",
      60: "#009591",
      70: "#007C7C",
      80: "#007573",
      90: "#006462",
      100: "#003130",
      110: "#002322",
      120: "#001E1E"
    },
    purple: {
      10: "#FAF7FD",
      20: "#F7F2FB",
      30: "#EBDDF6",
      40: "#BB8CE0",
      50: "#AD75DA",
      60: "#A66BD7",
      70: "#9053C2",
      80: "#864EB5",
      90: "#73439A",
      100: "#38214C",
      110: "#261735",
      120: "#22132D"
    },
    red: {
      10: "#FFF2F5",
      20: "#FAD1D9",
      30: "#F6AAB8",
      40: "#F17E93",
      50: "#ED4D6A",
      60: "#E8173D",
      70: "#AF1E30",
      80: "#771D23",
      90: "#621B1E",
      100: "#491718"
    },
    yellow: {
      10: "#FFF9F2",
      20: "#F0DCC4",
      30: "#E1BD93",
      40: "#D19F61",
      50: "#C28030",
      60: "#B36200",
      70: "#884B0A",
      80: "#5D350E",
      90: "#4D2D0E",
      100: "#3B230C"
    },
    green: {
      10: "#F2FFF6",
      20: "#C9E7D2",
      30: "#9ECEAD",
      40: "#74B688",
      50: "#4B9D64",
      60: "#268543",
      70: "#196830",
      80: "#174823",
      90: "#173C1F",
      100: "#142E19"
    },
    steelblue: {
      10: "#F6F9FC",
      20: "#F0F4F9",
      30: "#D8E3F0",
      40: "#77A4CE",
      50: "#5892C4",
      60: "#478BBF",
      70: "#2974A8",
      80: "#286D9D",
      90: "#265D85",
      100: "#1A2D3E",
      110: "#151F29",
      120: "#131B24"
    }
  },
  brand: {
    blue: "#2D8CFF",
    purple: "#925DFF",
    bloom: "#0B5CFF",
    rose: "#FF0055",
    goldenrod: "#FFCD00",
    spearmint: "#00FF91",
    saffron: "#FF7A00",
    lavender: "#9D5BD3",
    agave: "#00F0EA"
  },
  accent: {
    r500: "#FD3D4A",
    r400: "#F46670",
    br600: "#CF5A35",
    o550: "#FF5F0F",
    o600: "#DC7929",
    o500: "#FF8422",
    gld500: "#C28030",
    y400: "#FFBF39",
    g400: "#66CC84",
    t500: "#14BCA0",
    t600: "#2BA09B",
    b500: "#2D8CFF",
    b600: "#1E71D6",
    b700: "#0956B5",
    b800: "#285081",
    bp400: "#A477FF",
    bp500: "#9D87C9",
    bp600: "#925DFF",
    p500: "#5B4FB0",
    p600: "#493AB7",
    gry100: "#F7F9FA",
    gry800: "#252A30"
  }
}, Zi = {
  fontFamily: {
    sfPro: "SF Pro",
    segoeUI: "Segoe UI",
    roboto: "Roboto",
    ubuntu: "Ubuntu"
  },
  fontWeight: {
    display1: "700",
    display2: "600",
    display3: "600",
    bodyLargeBold: "600",
    bodyLargeMedium: "500",
    bodyLarge: "400",
    bodyBold: "600",
    body: "400",
    subtitleBold: "600",
    subtitle: "400",
    caption: "400",
    label: "600"
  },
  fontSize: {
    display1: "36px",
    display2: "24px",
    display3: "20px",
    bodyLargeBold: "16px",
    bodyLargeMedium: "16px",
    bodyLarge: "16px",
    bodyBold: "14px",
    body: "14px",
    subtitleBold: "12px",
    subtitle: "12px",
    caption: "10px",
    label: "10px"
  },
  lineHeight: {
    display1: "40px",
    display2: "28px",
    display3: "24px",
    bodyLargeBold: "20px",
    bodyLargeMedium: "20px",
    bodyLarge: "20px",
    bodyBold: "20px",
    body: "20px",
    subtitleBold: "16px",
    subtitle: "16px",
    caption: "12px",
    label: "12px"
  }
}, gZ = {
  bg: {
    default: "#131619",
    neutral: "#1D1E20"
  },
  fill: {
    default: "#222325",
    neutral: "#939BA4",
    primary: "#599EF2",
    error: "#FF6682",
    warning: "#C28030",
    success: "#48AD67",
    complementary: "#FF5F0F",
    supplementary1: "#A66BD7",
    supplementary2: "#009591",
    contrary: {
      transparent: "#FFFFFF54",
      // #FFFFFF 33%
      subtler: {
        transparent: "#FFFFFF0A"
        // #FFFFFF 4%
      },
      subtle: {
        transparent: "#FFFFFF1A"
        // #FFFFFF 10%
      },
      strong: {
        transparent: "#FFFFFF7A"
        // #FFFFFF 48%
      }
    },
    blend: {
      transparent: "#0000006B",
      // #000000 42%
      subtle: {
        transparent: "#0000001F"
        // #000000 12%
      },
      strong: {
        transparent: "#0000008F"
        // #000000 56%
      }
    },
    subtler: {
      neutral: "#2A2B2D",
      primary: "#1A2A52",
      error: "#54171A",
      warning: "#4D2D0E",
      success: "#123019",
      complementary: "#59260F",
      supplementary1: "#261735",
      supplementary2: "#002322"
    },
    subtle: {
      neutral: "#313235",
      primary: "#033A7D",
      error: "#7A051B",
      warning: "#603400",
      success: "#0A491D",
      complementary: "#6E2603",
      supplementary1: "#261735",
      supplementary2: "#002322"
    },
    global: {
      primary: "#0D6BDE",
      error: "#DA1639",
      dark: {
        transparent: "#0000006B"
        // #000000 42%
      },
      light: {
        transparent: "#FFFFFF54"
        // #FFFFFF 33%
      },
      subtle: {
        dark: {
          transparent: "#0000001F"
          // #000000 12%
        },
        light: {
          transparent: "#FFFFFF1A"
          // #FFFFFF 10%
        }
      },
      strong: {
        dark: {
          transparent: "#0000008F"
          // #000000 56%
        },
        light: {
          transparent: "#FFFFFF7A"
          // #FFFFFF 48%
        }
      },
      success: "#247F40",
      supplementary1: "#9053C2",
      supplementary2: "#007C7C",
      supplementary3: "#2974A8",
      neutral: "#555B62",
      complementary: "#9D3B0F",
      warning: "#B36200"
    }
  },
  text: {
    neutral: "#939BA4",
    primary: "#599EF2",
    error: "#FF6682",
    warning: "#C28030",
    success: "#48AD67",
    complementary: "#FF5F0F",
    supplementary1: "#A66BD7",
    supplementary2: "#009591",
    strong: {
      neutral: "#DFE3E8",
      primary: "#A8CCF8",
      error: "#F6AAB8",
      warning: "#E1BD93",
      success: "#9ECEAD",
      complementary: "#FFAB81",
      supplementary1: "#BB8CE0",
      supplementary2: "#00B2AE"
    },
    stronger: {
      neutral: "#F7F9FA",
      primary: "#F2F8FF",
      error: "#FFF2F5",
      warning: "#FFF9F2",
      success: "#F2FFF6",
      complementary: "#FFF7F2",
      supplementary1: "#F7F2FB",
      supplementary2: "#D4FCFB"
    },
    inverse: {
      neutral: "#131619",
      primary: "#001F45",
      error: "#44010D",
      warning: "#361E00",
      success: "#022B0F",
      complementary: "#3D1501",
      supplementary1: "#22132D",
      supplementary2: "#001E1E"
    },
    global: {
      strong: {
        warning: "#E1BD93"
      }
    }
  },
  icon: {
    neutral: "#8E9194",
    primary: "#3B90F7",
    error: "#FF2638",
    warning: "#FFD700",
    success: "#09A639",
    complementary: "#FF5500",
    supplementary1: "#864EB5",
    supplementary2: "#007573",
    inverse: "#131619"
  },
  border: {
    neutral: "#686F79",
    primary: "#0D6BDE",
    error: "#DA1639",
    warning: "#B36200",
    success: "#247F40",
    complementary: "#CF4B0A",
    supplementary1: "#864EB5",
    supplementary2: "#007573",
    subtle: {
      neutral: "#313235",
      primary: "#213C77",
      error: "#771D23",
      warning: "#5D350E",
      success: "#174823",
      complementary: "#6B2C0F",
      supplementary1: "#38214C",
      supplementary2: "#003130"
    },
    strong: {
      neutral: "#C1C6CE",
      primary: "#7AB1F4",
      error: "#F17E93",
      warning: "#D19F61",
      success: "#74B688",
      complementary: "#FF8548",
      supplementary1: "#BB8CE0",
      supplementary2: "#00B2AE"
    }
  },
  state: {
    hover: "#FFFFFF54",
    // #FFFFFF 33%
    press: "#0000006B",
    // #000000 42%
    disable: "#596069",
    inactive: "#000000A6",
    // #000000 65%
    neutral: {
      hover: "#B6BAC0",
      press: "#3E4349"
    },
    subtle: {
      disable: "#313235",
      neutral: {
        hover: "#6E768054",
        // #6E7680 33%
        press: "#0000006B"
        // #000000 42%
      },
      primary: {
        hover: "#0E72ED54",
        // #0E72ED 33%
        press: "#0000006B",
        // #000000 42%
        disable: "#2B4588"
      },
      error: {
        hover: "#E8173D54",
        // #E8173D 33%
        press: "#0000006B",
        // #000000 42%
        disable: "#7A383B"
      },
      warning: {
        hover: "#B3620054",
        // #B36200 33%
        press: "#0000006B"
        // #000000 42%
      },
      success: {
        hover: "#26854354",
        // #268543 33%
        press: "#0000006B"
        // #000000 42%
      },
      complementary: {
        hover: "#CF4B0A54",
        // #CF4B0A 33%
        press: "#0000006B"
        // #000000 42%
      },
      supplementary1: {
        hover: "#9053C254",
        // #9053C2 33%
        press: "#0000006B"
        // #000000 42%
      },
      supplementary2: {
        hover: "#007C7C54",
        // #007C7C 33%
        press: "#0000006B"
        // #000000 42%
      }
    },
    primary: {
      hover: "#7DB4F7",
      press: "#084085"
    },
    error: {
      hover: "#F38498",
      press: "#830D23"
    },
    warning: {
      hover: "#FFB459",
      press: "#6C3B00"
    },
    success: {
      hover: "#78D995",
      press: "#164C26"
    },
    complementary: {
      hover: "#F89F73",
      press: "#7C2D06"
    },
    supplementary1: {
      hover: "#C8A9E1",
      press: "#572C7B"
    },
    supplementary2: {
      hover: "#3EFFFF",
      press: "#004A4A"
    },
    contrary: {
      subtler: {
        transparent: {
          hover: "#FFFFFF52",
          // #FFFFFF 32%
          press: "#0000007A"
          // #000000 48%
        }
      },
      subtle: {
        transparent: {
          hover: "#FFFFFF7A",
          // #FFFFFF 48%
          press: "#00000052"
          // #000000 32%
        }
      },
      transparent: {
        hover: "#FFFFFFA3",
        // #FFFFFF 64%
        press: "#0000003D"
        // #000000 24%
      },
      strong: {
        transparent: {
          hover: "#FFFFFFCC",
          // #FFFFFF 80%
          press: "#00000029"
          // #000000 16%
        }
      }
    },
    global: {
      disable: "#ADB1B8",
      dark: {
        transparent: {
          hover: "#0000007A",
          // #000000 48%
          press: "#000000CC"
          // #000000 80%
        }
      },
      light: {
        transparent: {
          hover: "#FFFFFFA3",
          // #FFFFFF 64%
          press: "#0000003D"
          // #000000 24%
        }
      },
      subtle: {
        dark: {
          transparent: {
            hover: "#0000003D",
            // #000000 24%
            press: "#0000007A"
            // #000000 48%
          }
        },
        light: {
          transparent: {
            hover: "#FFFFFF7A",
            // #FFFFFF 48%
            press: "#00000052"
            // #000000 32%
          }
        }
      },
      strong: {
        dark: {
          transparent: {
            hover: "#000000A3",
            // #000000 64%
            press: "#000000F5"
            // #000000 96%
          }
        },
        light: {
          transparent: {
            hover: "#FFFFFFCC",
            // #FFFFFF 80%
            press: "#00000029"
            // #000000 16%
          }
        }
      }
    }
  },
  inverse: {
    default: "#131619",
    neutral: "#1D1E20",
    global: {
      default: "#FFFFFF"
    }
  },
  underlay: {
    dark: "#00000085",
    // #000000 52%
    default: "#000000CC",
    // #000000 80%
    dropShadow: "#00000014"
    // #000000 8%
  },
  component: {
    input: {
      border: "#555B62"
    }
  }
}, bZ = {
  bg: {
    default: "#FFFFFF",
    neutral: "#FCFDFD"
  },
  fill: {
    default: "#FFFFFF",
    neutral: "#686F79",
    primary: "#0D6BDE",
    error: "#DA1639",
    warning: "#B36200",
    success: "#247F40",
    complementary: "#FF5F0F",
    supplementary1: "#9053C2",
    supplementary2: "#007C7C",
    contrary: {
      transparent: "#0000006B",
      // #000000 42%
      subtler: {
        transparent: "#0000000A"
        // #000000 4%
      },
      subtle: {
        transparent: "#0000001F"
        // #000000 12%
      },
      strong: {
        transparent: "#0000008F"
        // #000000 56%
      }
    },
    blend: {
      transparent: "#FFFFFF54",
      // #FFFFFF 33%
      subtle: {
        transparent: "#FFFFFF1A"
        // #FFFFFF 10%
      },
      strong: {
        transparent: "#FFFFFF7A"
        // #FFFFFF 48%
      }
    },
    subtler: {
      neutral: "#F7F9FA",
      primary: "#F2F8FF",
      error: "#FFF2F5",
      warning: "#FFF9F2",
      success: "#F2FFF6",
      complementary: "#FFF7F2",
      supplementary1: "#F7F2FB",
      supplementary2: "#D4FCFB"
    },
    subtle: {
      neutral: "#F1F4F6",
      primary: "#F2F8FF",
      error: "#FFF2F5",
      warning: "#FFF9F2",
      success: "#F2FFF6",
      complementary: "#FFF7F2",
      supplementary1: "#F7F2FB",
      supplementary2: "#D4FCFB"
    },
    global: {
      primary: "#0D6BDE",
      error: "#DA1639",
      dark: {
        transparent: "#0000006B"
        // #000000 42%
      },
      light: {
        transparent: "#FFFFFF54"
        // #FFFFFF 33%
      },
      subtle: {
        dark: {
          transparent: "#0000001F"
          // #000000 12%
        },
        light: {
          transparent: "#FFFFFF1A"
          // #FFFFFF 10%
        }
      },
      strong: {
        dark: {
          transparent: "#0000008F"
          // #000000 56%
        },
        light: {
          transparent: "#FFFFFF7A"
          // #FFFFFF 48%
        }
      },
      success: "#247F40",
      supplementary1: "#9053C2",
      supplementary2: "#007C7C",
      supplementary3: "#2974A8",
      neutral: "#555B62",
      complementary: "#9D3B0F",
      warning: "#B36200"
    }
  },
  text: {
    neutral: "#686F79",
    primary: "#0D6BDE",
    error: "#DA1639",
    warning: "#B36200",
    success: "#247F40",
    complementary: "#CF4B0A",
    supplementary1: "#9053C2",
    supplementary2: "#007C7C",
    strong: {
      neutral: "#555B62",
      primary: "#2057B1",
      error: "#AF1E30",
      warning: "#884B0A",
      success: "#196830",
      complementary: "#9D3B0F",
      supplementary1: "#73439A",
      supplementary2: "#006462"
    },
    stronger: {
      neutral: "#2A2B2D",
      primary: "#1A2A52",
      error: "#54171A",
      warning: "#4D2D0E",
      success: "#123019",
      complementary: "#59260F",
      supplementary1: "#261735",
      supplementary2: "#002322"
    },
    global: {
      strong: {
        warning: "#884B0A"
      }
    },
    inverse: {
      neutral: "#F7F9FA",
      primary: "#F2F8FF",
      error: "#FFF2F5",
      warning: "#FFF9F2",
      success: "#F2FFF6",
      complementary: "#FFF7F2",
      supplementary1: "#FAF7FD",
      supplementary2: "#E9FEFD"
    }
  },
  icon: {
    neutral: "#8E9194",
    primary: "#3B90F7",
    error: "#FF2638",
    warning: "#FFD700",
    success: "#09A639",
    complementary: "#FF5500",
    supplementary1: "#AD75DA",
    supplementary2: "#009E9A",
    inverse: "#FFFFFF"
  },
  border: {
    neutral: "#939BA4",
    primary: "#4B96F1",
    error: "#FF6682",
    warning: "#C28030",
    success: "#48AD67",
    complementary: "#FF5F0F",
    supplementary1: "#AD75DA",
    supplementary2: "#009E9A",
    subtle: {
      neutral: "#DFE3E8",
      primary: "#A8CCF8",
      error: "#F6AAB8",
      warning: "#E1BD93",
      success: "#9ECEAD",
      complementary: "#FFAB81",
      supplementary1: "#EBDDF6",
      supplementary2: "#61F6F2"
    },
    strong: {
      neutral: "#555B62",
      primary: "#2057B1",
      error: "#AF1E30",
      warning: "#884B0A",
      success: "#196830",
      complementary: "#9D3B0F",
      supplementary1: "#73439A",
      supplementary2: "#006462"
    }
  },
  state: {
    hover: "#0000001F",
    // #000000 12%
    press: "#0000006B",
    // #000000 42%
    disable: "#ADB1B8",
    inactive: "#FFFFFF99",
    // #FFFFFF 60%
    neutral: {
      hover: "#5E646D",
      press: "#3E4349"
    },
    subtle: {
      disable: "#E6EBEF",
      neutral: {
        hover: "#6E76801F",
        // #6E7680 12%
        press: "#6E76806B"
        // #6E7680 42%
      },
      primary: {
        hover: "#0E72ED1F",
        // #0E72ED 12%
        press: "#0E72ED6B",
        // #0E72ED 42%
        disable: "#AACDF8"
      },
      error: {
        hover: "#E8173D1F",
        // #E8173D 12%
        press: "#E8173D6B",
        // #E8173D 42%
        disable: "#F7BAC6"
      },
      warning: {
        hover: "#B362001F",
        // #B36200 12%
        press: "#B362006B"
        // #B36200 42%
      },
      success: {
        hover: "#2685431F",
        // #268543 12%
        press: "#2685436B"
        // #268543 42%
      },
      complementary: {
        hover: "#CF4B0A1F",
        // #CF4B0A 12%
        press: "#CF4B0A6B"
        // #CF4B0A 42%
      },
      supplementary1: {
        hover: "#9053C21F",
        // #9053C2 12%
        press: "#9053C26B"
        // #9053C2 42%
      },
      supplementary2: {
        hover: "#007C7C1F",
        // #007C7C 12%
        press: "#007C7C6B"
        // #007C7C 42%
      }
    },
    primary: {
      hover: "#0C60C8",
      press: "#084085"
    },
    error: {
      hover: "#C41434",
      press: "#830D23"
    },
    warning: {
      hover: "#A15800",
      press: "#6C3B00"
    },
    success: {
      hover: "#207239",
      press: "#164C26"
    },
    complementary: {
      hover: "#BA4409",
      press: "#7C2D06"
    },
    supplementary1: {
      hover: "#8341B8",
      press: "#572C7B"
    },
    supplementary2: {
      hover: "#007070",
      press: "#004A4A"
    },
    contrary: {
      subtle: {
        transparent: {
          hover: "#0000003D",
          // #000000 24%
          press: "#0000007A"
          // #000000 48%
        }
      },
      subtler: {
        transparent: {
          hover: "#00000014",
          // #000000 8%
          press: "#0000003D"
          // #000000 24%
        }
      },
      transparent: {
        hover: "#0000007A",
        // #000000 48%
        press: "#000000CC"
        // #000000 80%
      },
      strong: {
        transparent: {
          hover: "#000000A3",
          // #000000 64%
          press: "#000000F5"
          // #000000 96%
        }
      }
    },
    global: {
      disable: "#ADB1B8",
      dark: {
        transparent: {
          hover: "#0000007A",
          // #000000 48%
          press: "#000000CC"
          // #000000 80%
        }
      },
      light: {
        transparent: {
          hover: "#FFFFFFA3",
          // #FFFFFF 64%
          press: "#0000003D"
          // #000000 24%
        }
      },
      subtle: {
        dark: {
          transparent: {
            hover: "#0000003D",
            // #000000 24%
            press: "#0000007A"
            // #000000 48%
          }
        },
        light: {
          transparent: {
            hover: "#FFFFFF7A",
            // #FFFFFF 48%
            press: "#00000052"
            // #000000 32%
          }
        }
      },
      strong: {
        dark: {
          transparent: {
            hover: "#000000A3",
            // #000000 64%
            press: "#000000F5"
            // #000000 96%
          }
        },
        light: {
          transparent: {
            hover: "#FFFFFFCC",
            // #FFFFFF 80%
            press: "#00000029"
            // #000000 16%
          }
        }
      }
    }
  },
  inverse: {
    default: "#FFFFFF",
    neutral: "#F7F9FA",
    global: {
      default: "#FFFFFF"
    }
  },
  underlay: {
    dark: "#00000033",
    // #000000 20%
    default: "#FFFFFFCC",
    // #FFFFFF 80%
    dropShadow: "#00000014"
    // #000000 8%
  },
  component: {
    input: {
      border: "#C1C6CE"
    }
  }
};
function yZ() {
  return {
    fontFamily: [
      "system-ui",
      "Segoe UI Emoji",
      "Segoe UI Symbol",
      Zi.fontFamily.segoeUI,
      "Apple Color Emoji",
      "Twemoji Mozilla",
      "Noto Color Emoji",
      "Android Emoji",
      Zi.fontFamily.sfPro,
      "Almaden Sans",
      Zi.fontFamily.roboto,
      Zi.fontFamily.ubuntu,
      "Helvetica",
      "Arial"
    ].join(","),
    fontSize: Zi.fontSize,
    fontWeight: Zi.fontWeight,
    lineHeight: Zi.lineHeight
  };
}
function vZ() {
  return {
    keys: ["s", "m", "l", "xl", "xxl"],
    unit: "px"
  };
}
const xZ = 1, ha = 1e3, Ha = 100;
function CZ() {
  return {
    base: xZ,
    // >=1 common base layer zIndex
    overlay: ha,
    // >=1000 common ovelay zIndex
    // base layer
    // XXX: baseZIndex + overlayOffset * 1, // >=101
    // TODO new components
    // overlay
    Drawer: ha + Ha * 2,
    // >=1200
    Dialog: ha + Ha * 3,
    // >=1300
    DatePicker: ha + Ha * 3,
    // >=1300
    TimePicker: ha + Ha * 3,
    // >=1300
    ColorPicker: ha + Ha * 3,
    // >=1300
    Dropdown: ha + Ha * 3,
    // >=1300
    Popover: ha + Ha * 3,
    // >=1300
    Toast: ha + Ha * 4,
    // >=1400
    Tooltip: ha + Ha * 5
    // >=1500
    // TODO new components
  };
}
function SZ() {
  const e = "rgba(0, 0, 0, 0.08)";
  return {
    sm: `0 4px 8px 0 ${e}, 0 2px 4px 0 ${e}`,
    md: `0 12px 24px 0 ${e}, 0 6px 12px 0 ${e}`,
    lg: `0 24px 48px 0 ${e}, 0 12px 24px 0 ${e}`
  };
}
function wZ() {
  return hZ;
}
function p4() {
  return {
    light: bZ,
    dark: gZ
  };
}
function TZ() {
  return {
    color: wZ(),
    semantic: p4(),
    typography: yZ(),
    breakpoints: vZ(),
    zIndex: CZ(),
    shadow: SZ()
  };
}
function ca(e) {
  const t = e?.zoomUI?.semantic ?? p4(), r = e?.palette?.mode ?? "light";
  return {
    ...r === "light" ? t.light : t.dark,
    activeMode: r
  };
}
function Ao() {
  const e = TZ();
  return {
    color: e.color,
    semantic: e.semantic,
    typography: e.typography,
    breakpoints: e.breakpoints,
    shadow: e.shadow,
    zIndex: e.zIndex
  };
}
function yl(e, t) {
  const r = (o, a) => {
    const i = o, l = Object.prototype.toString.call(a);
    if (l === "[object Object]")
      Object.keys(a).forEach((c) => {
        Object.prototype.hasOwnProperty.call(i, c) || (Object.prototype.toString.call(a[c]) === "[object Object]" ? i[c] = {} : Object.prototype.toString.call(a[c]) === "[object Array]" ? i[c] = [] : i[c] = a[c]), r(i[c], a[c]);
      });
    else if (l === "[object Array]" && i.length < a.length)
      for (let c = i.length; c < a.length; c += 1) {
        const d = Object.prototype.toString.call(a[c]);
        d === "[object Object]" ? (i[c] = {}, r(i[c], a[c])) : d === "[object Array]" ? (i[c] = [], r(i[c], a[c])) : i[c] = a[c];
      }
  };
  return r(e, t), e;
}
function Gy(e) {
  return /^{.*}$/.test(`${e}`);
}
function f4(e, t, r) {
  try {
    if (typeof t == "string" && Gy(t)) {
      const i = t.replace(/^{|}$/g, "").replace(/\[(\d+)\]/g, ".$1").split(".").reduce((l, c) => Object(l)[c], e);
      return typeof i == "number" || typeof i == "string" ? i : r;
    }
  } catch (o) {
    console.warn(o);
  }
}
function m4(e, t) {
  const r = Ao();
  return {
    palette: {
      mode: e
    },
    typography: {
      fontFamily: r.typography.fontFamily,
      fontSize: 14
    },
    // Zoom UI Custom Theme
    zoomUI: yl({}, r)
  };
}
function EZ(e) {
  const { componentName: t, theme: r, themeToken: o } = e, a = o;
  let i = a.light;
  r?.palette?.mode === "dark" && (i = yl(a.dark, a.light)), r?.zoomUI?.componentTokens?.[t] && (r?.palette?.mode === "dark" ? i = yl(r?.zoomUI?.componentTokens?.[t]?.dark, i) : i = yl(r?.zoomUI?.componentTokens?.[t]?.light, i));
  const l = r?.zoomUI || m4(r?.palette?.mode)?.zoomUI;
  function c(d) {
    return Gy(d) ? f4(l, d) : d;
  }
  return [i, c];
}
function mn(e) {
  const { componentName: t, theme: r, dynamicToken: o } = e;
  let a = o;
  r?.zoomUI?.componentTokens?.[t] && (r?.palette?.mode === "dark" ? a = yl(r?.zoomUI?.componentTokens?.[t]?.dark, a) : a = yl(r?.zoomUI?.componentTokens?.[t]?.light, a));
  const i = r?.zoomUI || m4(r?.palette?.mode)?.zoomUI;
  function l(c) {
    return Gy(c) ? f4(i, c) : c;
  }
  return [a, l];
}
const to = () => Math.random().toString(36).substring(2);
function OZ(e, t, r) {
  function o(a) {
    return a === null || r?.(a) ? null : t(a) ? a : o(a.parentElement);
  }
  return o(e.nodeType === 1 ? e : e.parentElement);
}
const _l = "navigation-with-keyboard", wp = typeof document == "object" ? document?.documentElement : void 0, h4 = typeof document == "object" ? document?.body : void 0;
h4?.addEventListener("keydown", () => {
  wp?.classList.contains(_l) || wp?.classList.add(_l);
}, { capture: !0 });
h4?.addEventListener("mousedown", (e) => {
  e.offsetX !== 0 && e.offsetY !== 0 && wp?.classList.contains(_l) && wp?.classList.remove(_l);
}, { capture: !0 });
function $Z(e) {
  const t = e.getAttribute?.("tabindex");
  let r = !1;
  return t ? r = +t >= 0 : e.tagName === "A" ? r = !!e.href : (
    // There is also `<map>` which can be focusable actually. But this is not
    // easy to handle with and is rarely used. Ignore it here.
    ["INPUT", "SELECT", "TEXTAREA", "BUTTON", "OBJECT"].includes(e.tagName) && (r = !e.disabled)
  ), r && window.getComputedStyle(e).visibility !== "hidden" && !OZ(e, (o) => window.getComputedStyle(o).display === "none");
}
function Nd(e, t) {
  const r = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT);
  for (r.currentNode = e; ; ) {
    const o = t ? r.previousNode() : r.nextNode();
    if (!o)
      return null;
    if ($Z(o))
      return o;
  }
}
function RZ(e) {
  const { style: t } = e;
  t.position = "absolute", t.top = "-1px", t.width = "1px", t.height = "1px", t.clip = "rect(0,0,0,0)", t.borderWidth = "0", t.padding = "0", t.overflow = "hidden", t.whiteSpace = "nowrap";
}
function qy(e) {
  const t = document.createElement("div");
  RZ(t), t.role = "alert", t.ariaRoleDescription = " ", t.innerText = e, document.body.appendChild(t), setTimeout(() => {
    document.body.removeChild(t);
  }, 500);
}
function PZ(e, t) {
  const r = typeof t == "function" ? t : (i) => t.includes(i), o = {}, a = {};
  return Object.keys(e).forEach((i) => {
    r(i) ? o[i] = e[i] : a[i] = e[i];
  }), [o, a];
}
function Tp(e) {
  return PZ(e, (t) => t === "role" || t === "tabIndex" || t.startsWith("aria-"));
}
const kZ = {
  up: { transform: "rotate(-90deg)" },
  left: { transform: "rotate(180deg)" },
  down: { transform: "rotate(90deg)" },
  right: {}
}, AZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4ZM3.33325 2.00001C3.33325 1.63182 3.63173 1.33334 3.99992 1.33334C4.36811 1.33334 4.66658 1.63182 4.66658 2.00001V3.72384L5.41277 4.47002C5.67312 4.73037 5.67312 5.15248 5.41277 5.41283C5.15242 5.67318 4.73031 5.67318 4.46996 5.41283L3.59007 4.53294C3.43376 4.41094 3.33325 4.22076 3.33325 4.0071V2.00001Z", fill: "#8E9194" })
    )
  );
}, IZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4ZM6.75 4C6.75 5.51878 5.51878 6.75 4 6.75C3.46694 6.75 2.9693 6.59833 2.54788 6.33579L6.33579 2.54788C6.59833 2.9693 6.75 3.46694 6.75 4ZM5.45186 1.66405L1.66405 5.45186C1.40161 5.0305 1.25 4.53295 1.25 4C1.25 2.48122 2.48122 1.25 4 1.25C4.53295 1.25 5.0305 1.40161 5.45186 1.66405Z", fill: "#FF2638" })
    )
  );
}, NZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4ZM2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L3.29289 4L2.14645 5.14645C1.95118 5.34171 1.95118 5.65829 2.14645 5.85355C2.34171 6.04882 2.65829 6.04882 2.85355 5.85355L4 4.70711L5.14645 5.85355C5.34171 6.04882 5.65829 6.04882 5.85355 5.85355C6.04882 5.65829 6.04882 5.34171 5.85355 5.14645L4.70711 4L5.85355 2.85355C6.04882 2.65829 6.04882 2.34171 5.85355 2.14645C5.65829 1.95118 5.34171 1.95118 5.14645 2.14645L4 3.29289L2.85355 2.14645Z", fill: "#FF2638" })
    )
  );
}, MZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M13.3481 3.32203C13.411 3.36973 13.4638 3.42936 13.5035 3.49749C13.5433 3.56563 13.5692 3.64094 13.5799 3.71911C13.5905 3.79728 13.5856 3.87678 13.5655 3.95305C13.5453 4.02933 13.5104 4.10089 13.4625 4.16363L7.06254 12.5636C7.01062 12.6317 6.94475 12.6878 6.86935 12.7283C6.79395 12.7688 6.71076 12.7927 6.62536 12.7984C6.53996 12.804 6.45434 12.7914 6.37424 12.7613C6.29414 12.7311 6.22141 12.6842 6.16094 12.6236L2.56094 9.02363C2.45495 8.90989 2.39725 8.75946 2.4 8.60401C2.40274 8.44857 2.46571 8.30027 2.57564 8.19034C2.68557 8.08041 2.83388 8.01744 2.98932 8.01469C3.14476 8.01195 3.2952 8.06965 3.40894 8.17563L6.52414 11.29L12.5081 3.43643C12.6044 3.30999 12.747 3.22694 12.9045 3.20549C13.062 3.18404 13.2215 3.22595 13.3481 3.32203Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
    )
  );
}, _Z = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, direction: c = "right", ...d } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: {
      color: o,
      fontSize: r ?? 14,
      background: a,
      ...kZ[c],
      ...i
    }, "aria-hidden": !0, ...d },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M6.1675 4.12408C5.93782 4.36294 5.94527 4.74277 6.18414 4.97244L9.33434 7.93994L6.18414 10.9074C5.94527 11.1371 5.93783 11.5169 6.1675 11.7558C6.39718 11.9947 6.777 12.0021 7.01587 11.7724L10.6159 8.37244C10.7335 8.25932 10.8 8.10315 10.8 7.93994C10.8 7.77673 10.7335 7.62056 10.6159 7.50744L7.01587 4.10744C6.777 3.87777 6.39718 3.88521 6.1675 4.12408Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
    )
  );
}, kf = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M5.02426 4.17574C4.78995 3.94142 4.41005 3.94142 4.17574 4.17574C3.94142 4.41005 3.94142 4.78995 4.17574 5.02426L7.15147 8L4.17574 10.9757C3.94142 11.2101 3.94142 11.59 4.17574 11.8243C4.41005 12.0586 4.78995 12.0586 5.02426 11.8243L8 8.84853L10.9757 11.8243C11.2101 12.0586 11.59 12.0586 11.8243 11.8243C12.0586 11.59 12.0586 11.2101 11.8243 10.9757L8.84853 8L11.8243 5.02426C12.0586 4.78995 12.0586 4.41005 11.8243 4.17574C11.59 3.94142 11.2101 3.94142 10.9757 4.17574L8 7.15147L5.02426 4.17574Z", fill: "currentColor" })
    )
  );
}, FZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM2.66667 3.33334C2.29848 3.33334 2 3.63182 2 4.00001C2 4.3682 2.29848 4.66668 2.66667 4.66668H5.33333C5.70152 4.66668 6 4.3682 6 4.00001C6 3.63182 5.70152 3.33334 5.33333 3.33334H2.66667Z", fill: "#FF2638" })
    )
  );
}, g4 = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M8 15C8.95621 15 9.85523 14.817 10.6971 14.451C11.5435 14.085 12.2892 13.5794 12.9343 12.9343C13.5794 12.2892 14.085 11.5458 14.451 10.7039C14.817 9.85752 15 8.95621 15 8C15 7.04379 14.817 6.14477 14.451 5.30294C14.085 4.45654 13.5794 3.71078 12.9343 3.06569C12.2892 2.42059 11.5435 1.91503 10.6971 1.54902C9.85065 1.18301 8.94935 1 7.99314 1C7.03693 1 6.13562 1.18301 5.28922 1.54902C4.44739 1.91503 3.70392 2.42059 3.05882 3.06569C2.4183 3.71078 1.91503 4.45654 1.54902 5.30294C1.18301 6.14477 1 7.04379 1 8C1 8.95621 1.18301 9.85752 1.54902 10.7039C1.91503 11.5458 2.42059 12.2892 3.06569 12.9343C3.71078 13.5794 4.45425 14.085 5.29608 14.451C6.14248 14.817 7.04379 15 8 15ZM8 9.27647C7.63399 9.27647 7.44641 9.08889 7.43726 8.71373L7.34804 4.97353C7.34346 4.7951 7.40065 4.64641 7.51961 4.52745C7.64314 4.4085 7.80098 4.34902 7.99314 4.34902C8.18072 4.34902 8.33628 4.41078 8.4598 4.53431C8.58791 4.65327 8.64967 4.80196 8.6451 4.98039L8.54216 8.71373C8.53758 9.08889 8.35686 9.27647 8 9.27647ZM8 11.5755C7.79412 11.5755 7.6134 11.5046 7.45784 11.3627C7.30686 11.2209 7.23137 11.0471 7.23137 10.8412C7.23137 10.6399 7.30686 10.466 7.45784 10.3196C7.60882 10.1732 7.78954 10.1 8 10.1C8.20588 10.1 8.38431 10.1732 8.53529 10.3196C8.69085 10.4614 8.76863 10.6353 8.76863 10.8412C8.76863 11.0471 8.69085 11.2209 8.53529 11.3627C8.38431 11.5046 8.20588 11.5755 8 11.5755Z", fill: "currentColor" })
    )
  );
}, LZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", className: "ui-internal-icon", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M10.4947 3.38416C9.71624 3.14386 8.87926 3 8 3C3.42857 3 4.24916e-09 6.88889 4.24916e-09 8C4.24916e-09 8.60421 1.01385 10.0298 2.674 11.2048L3.39242 10.4864C3.22151 10.3699 3.0571 10.2498 2.89966 10.1273C2.24844 9.62082 1.74074 9.09226 1.4055 8.64781C1.23739 8.42494 1.12392 8.23812 1.05679 8.09908C1.03622 8.05648 1.02257 8.02367 1.01361 8C1.02257 7.97633 1.03622 7.94352 1.05679 7.90092C1.12392 7.76188 1.23739 7.57506 1.4055 7.35219C1.74074 6.90774 2.24844 6.37918 2.89966 5.87269C4.20806 4.85504 5.99788 4 8 4C8.58011 4 9.1424 4.07178 9.68032 4.19851L10.4947 3.38416Z", fill: "currentColor" }),
      N.createElement("path", { d: "M9.17626 4.70257C8.80865 4.57142 8.41266 4.5 8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 8.41266 4.57142 8.80865 4.70257 9.17626L5.52487 8.35396C5.50848 8.23833 5.5 8.12016 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C8.12016 5.5 8.23833 5.50848 8.35396 5.52487L9.17626 4.70257Z", fill: "currentColor" }),
      N.createElement("path", { d: "M0.139113 15.1539L14.4395 0.853553C14.442 0.85108 14.4444 0.848588 14.4468 0.846076L15.1464 0.146447C15.3417 -0.0488155 15.6583 -0.0488155 15.8536 0.146447C16.0488 0.341709 16.0488 0.658291 15.8536 0.853553L12.4628 4.24434C14.6281 5.48276 16 7.29714 16 8C16 9.11111 12.5714 13 8 13C6.719 13 5.52774 12.6946 4.47651 12.2306L0.853553 15.8536C0.658291 16.0488 0.341709 16.0488 0.146447 15.8536C-0.0463398 15.6608 -0.0487842 15.3497 0.139113 15.1539ZM11.7271 4.98003L10.8032 5.90391C11.2408 6.4882 11.5 7.21383 11.5 8C11.5 9.933 9.933 11.5 8 11.5C7.21383 11.5 6.4882 11.2408 5.90391 10.8032L5.24151 11.4656C6.08893 11.7947 7.01898 12 8 12C10.0021 12 11.7919 11.145 13.1003 10.1273C13.7516 9.62082 14.2593 9.09226 14.5945 8.64781C14.7626 8.42494 14.8761 8.23812 14.9432 8.09908C14.9638 8.05648 14.9774 8.02367 14.9864 8C14.9774 7.97633 14.9638 7.94352 14.9432 7.90092C14.8761 7.76188 14.7626 7.57506 14.5945 7.35219C14.2593 6.90774 13.7516 6.37918 13.1003 5.87269C12.6877 5.55171 12.2271 5.24692 11.7271 4.98003ZM10.0858 6.6213L6.6213 10.0858C7.01652 10.3476 7.49046 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 7.49046 10.3476 7.01652 10.0858 6.6213Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
    )
  );
}, BZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8C4.5 6.067 6.067 4.5 8 4.5C9.933 4.5 11.5 6.067 11.5 8ZM10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }),
      N.createElement("path", { d: "M8 3C3.42857 3 0 6.88889 0 8C0 9.11111 3.42857 13 8 13C12.5714 13 16 9.11111 16 8C16 6.88889 12.5714 3 8 3ZM1.05679 8.09908C1.03622 8.05648 1.02257 8.02367 1.01361 8C1.02257 7.97633 1.03622 7.94352 1.05679 7.90092C1.12392 7.76188 1.23739 7.57506 1.4055 7.35219C1.74074 6.90774 2.24844 6.37918 2.89966 5.87269C4.20806 4.85504 5.99788 4 8 4C10.0021 4 11.7919 4.85504 13.1003 5.87269C13.7516 6.37918 14.2593 6.90774 14.5945 7.35219C14.7626 7.57506 14.8761 7.76188 14.9432 7.90092C14.9638 7.94352 14.9774 7.97633 14.9864 8C14.9774 8.02367 14.9638 8.05648 14.9432 8.09908C14.8761 8.23812 14.7626 8.42494 14.5945 8.64781C14.2593 9.09226 13.7516 9.62082 13.1003 10.1273C11.7919 11.145 10.0021 12 8 12C5.99788 12 4.20806 11.145 2.89966 10.1273C2.24844 9.62082 1.74074 9.09226 1.4055 8.64781C1.23739 8.42494 1.12392 8.23812 1.05679 8.09908Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
    )
  );
}, DZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor" },
      N.createElement("path", { d: "M8 15C8.95621 15 9.85523 14.817 10.6971 14.451C11.5435 14.085 12.2892 13.5794 12.9343 12.9343C13.5794 12.2892 14.085 11.5458 14.451 10.7039C14.817 9.85752 15 8.95621 15 8C15 7.04379 14.817 6.14477 14.451 5.30294C14.085 4.45654 13.5794 3.71078 12.9343 3.06569C12.2892 2.42059 11.5435 1.91503 10.6971 1.54902C9.85065 1.18301 8.94935 1 7.99314 1C7.03693 1 6.13562 1.18301 5.28922 1.54902C4.44739 1.91503 3.70392 2.42059 3.05882 3.06569C2.4183 3.71078 1.91503 4.45654 1.54902 5.30294C1.18301 6.14477 1 7.04379 1 8C1 8.95621 1.18301 9.85752 1.54902 10.7039C1.91503 11.5458 2.42059 12.2892 3.06569 12.9343C3.71078 13.5794 4.45425 14.085 5.29608 14.451C6.14248 14.817 7.04379 15 8 15ZM8 13.8333C7.1902 13.8333 6.43301 13.6824 5.72843 13.3804C5.02386 13.0784 4.40392 12.6621 3.86863 12.1314C3.33791 11.5961 2.92157 10.9761 2.61961 10.2716C2.32222 9.56699 2.17353 8.8098 2.17353 8C2.17353 7.1902 2.32222 6.43301 2.61961 5.72843C2.92157 5.02386 3.33791 4.40392 3.86863 3.86863C4.39935 3.33333 5.01699 2.91699 5.72157 2.61961C6.42614 2.31765 7.18333 2.16667 7.99314 2.16667C8.80294 2.16667 9.56013 2.31765 10.2647 2.61961C10.9739 2.91699 11.5938 3.33333 12.1245 3.86863C12.6598 4.40392 13.0784 5.02386 13.3804 5.72843C13.6824 6.43301 13.8333 7.1902 13.8333 8C13.8333 8.8098 13.6824 9.56699 13.3804 10.2716C13.083 10.9761 12.6667 11.5961 12.1314 12.1314C11.5961 12.6621 10.9761 13.0784 10.2716 13.3804C9.56699 13.6824 8.8098 13.8333 8 13.8333ZM6.79902 11.8363H9.59216C9.73399 11.8363 9.85294 11.7905 9.94902 11.699C10.0451 11.6075 10.0931 11.4931 10.0931 11.3559C10.0931 11.2186 10.0451 11.1042 9.94902 11.0127C9.85294 10.9212 9.73399 10.8755 9.59216 10.8755H8.74118V7.38235C8.74118 7.19477 8.69543 7.04608 8.60392 6.93628C8.51242 6.8219 8.37974 6.76471 8.20588 6.76471H6.91569C6.77386 6.76471 6.6549 6.81046 6.55882 6.90196C6.46275 6.99346 6.41471 7.10784 6.41471 7.2451C6.41471 7.38235 6.46275 7.49673 6.55882 7.58824C6.6549 7.67974 6.77386 7.72549 6.91569 7.72549H7.65V10.8755H6.79902C6.65719 10.8755 6.53824 10.9212 6.44216 11.0127C6.34608 11.1042 6.29804 11.2186 6.29804 11.3559C6.29804 11.4931 6.34608 11.6075 6.44216 11.699C6.53824 11.7905 6.65719 11.8363 6.79902 11.8363ZM7.93824 5.61863C8.18987 5.61863 8.40033 5.5317 8.56961 5.35784C8.74346 5.18399 8.83039 4.97353 8.83039 4.72647C8.83039 4.47484 8.74346 4.26209 8.56961 4.08824C8.40033 3.91438 8.18987 3.82745 7.93824 3.82745C7.69118 3.82745 7.48072 3.91438 7.30686 4.08824C7.13301 4.26209 7.04608 4.47484 7.04608 4.72647C7.04608 4.97353 7.13301 5.18399 7.30686 5.35784C7.48072 5.5317 7.69118 5.61863 7.93824 5.61863Z", fill: "currentColor" })
    )
  );
}, b4 = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e, d = Math.random();
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("rect", { id: "Glyph", opacity: "0.9", x: "7", y: "1", width: "2", height: "4", rx: "1", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_2_${d}`, opacity: "0.8", x: "3.75684", y: "2.34326", width: "4", height: "2", rx: "1", transform: "rotate(45 3.75684 2.34326)", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_3_${d}`, opacity: "0.7", x: "1", y: "7", width: "4", height: "2", rx: "1", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_4_${d}`, opacity: "0.6", x: "5.17188", y: "9.41406", width: "2", height: "4", rx: "1", transform: "rotate(45 5.17188 9.41406)", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_5_${d}`, opacity: "0.5", x: "7", y: "11", width: "2", height: "4", rx: "1", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_6_${d}`, opacity: "0.4", x: "10.8281", y: "9.41406", width: "4", height: "2", rx: "1", transform: "rotate(45 10.8281 9.41406)", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_7_${d}`, opacity: "0.3", x: "11", y: "7", width: "4", height: "2", rx: "1", fill: "currentColor" }),
      N.createElement("rect", { id: `Glyph_8_${d}`, opacity: "0.2", x: "12.2432", y: "2.34326", width: "2", height: "4", rx: "1", transform: "rotate(45 12.2432 2.34326)", fill: "currentColor" })
    )
  );
}, jZ = Ro`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, zZ = Y(b4)`
  animation: ${jZ} 1s steps(8, end) infinite;
`, VZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M5.5 0.700012C5.5 0.42387 5.72386 0.200012 6 0.200012C6.27614 0.200012 6.5 0.42387 6.5 0.700012V1.20001C6.5 1.47615 6.27614 1.70001 6 1.70001C5.72386 1.70001 5.5 1.47615 5.5 1.20001V0.700012Z", fill: "#FF5500" }),
      N.createElement("path", { d: "M1.5 0.700012C1.5 0.42387 1.72386 0.200012 2 0.200012C2.27614 0.200012 2.5 0.42387 2.5 0.700012V1.20001C2.5 1.47615 2.27614 1.70001 2 1.70001C1.72386 1.70001 1.5 1.47615 1.5 1.20001V0.700012Z", fill: "#FF5500" }),
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 1H5V1.43751C5 1.43751 5 2.16668 6 2.16668C7 2.16668 7 1.43751 7 1.43751V1.09129C7.0646 1.11086 7.12434 1.13463 7.18099 1.16349C7.46323 1.3073 7.6927 1.53677 7.83651 1.81901C8 2.13988 8 2.55992 8 3.4V5.6C8 6.44008 8 6.86012 7.83651 7.18099C7.6927 7.46323 7.46323 7.6927 7.18099 7.83651C6.86012 8 6.44008 8 5.6 8H2.4C1.55992 8 1.13988 8 0.819014 7.83651C0.536771 7.6927 0.3073 7.46323 0.16349 7.18099C0 6.86012 0 6.44008 0 5.6V3.4C0 2.55992 0 2.13988 0.16349 1.81901C0.3073 1.53677 0.536771 1.3073 0.819014 1.16349C0.875663 1.13463 0.935403 1.11086 1 1.09129V1.43751C1 1.43751 1 2.16668 2 2.16668C3 2.16668 3 1.43751 3 1.43751V1ZM2 3.25C1.58579 3.25 1.25 3.58579 1.25 4V6C1.25 6.41421 1.58579 6.75 2 6.75H6C6.41421 6.75 6.75 6.41421 6.75 6V4C6.75 3.58579 6.41421 3.25 6 3.25H2Z", fill: "#FF5500" })
    )
  );
}, WZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.2224 0H1.3336C0.9644 0 0.6312 0.1512 0.3912 0.3912C0.1512 0.6312 0 0.9644 0 1.3332C0 5.0176 2.982 8 6.6668 8C6.6804 8 6.694 8 6.7076 8C7.4276 7.9956 8 7.3868 8 6.6668V5.7776C8 5.2868 7.602 4.8888 7.1112 4.8888H6.3304C5.9764 4.8888 5.6376 5.0292 5.3876 5.2796L5.0276 5.6392C4.9416 5.7252 4.8256 5.7728 4.7088 5.7728C4.6468 5.7728 4.5844 5.7592 4.5268 5.7308C3.5436 5.2516 2.7484 4.4568 2.2692 3.4736C2.1876 3.3064 2.2296 3.104 2.3612 2.9724L2.7208 2.6128C2.9708 2.3628 3.1112 2.0236 3.1112 1.67V0.8888C3.1112 0.398 2.7132 0 2.2224 0Z", fill: "#FF5500" })
    )
  );
}, UZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M0 4C0 2.73235 0 2.09852 0.213153 1.60076C0.480215 0.977115 0.977115 0.480215 1.60076 0.213153C2.09852 0 2.73235 0 4 0C5.26765 0 5.90148 0 6.39924 0.213153C7.02289 0.480215 7.51979 0.977115 7.78685 1.60076C8 2.09852 8 2.73235 8 4C8 5.26765 8 5.90148 7.78685 6.39924C7.51979 7.02289 7.02289 7.51979 6.39924 7.78685C5.90148 8 5.26765 8 4 8C2.73235 8 2.09852 8 1.60076 7.78685C0.977115 7.51979 0.480215 7.02289 0.213153 6.39924C0 5.90148 0 5.26765 0 4Z", fill: "#FF5500" }),
      N.createElement("path", { d: "M8.8999 3.12705C8.8999 2.74359 9.11917 2.3939 9.46435 2.22689L10.9951 1.48623C11.4599 1.26131 12 1.59994 12 2.11634V5.88366C12 6.40006 11.4599 6.73869 10.9951 6.51377L9.46435 5.77311C9.11917 5.6061 8.8999 5.25641 8.8999 4.87295V3.12705Z", fill: "#FF5500" })
    )
  );
}, HZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 1.25H2.5C2.36193 1.25 2.25 1.36193 2.25 1.5V6.5C2.25 6.63807 2.36193 6.75 2.5 6.75H5.5C5.63807 6.75 5.75 6.63807 5.75 6.5V1.5C5.75 1.36193 5.63807 1.25 5.5 1.25ZM2.5 0C1.67157 0 1 0.671573 1 1.5V6.5C1 7.32843 1.67157 8 2.5 8H5.5C6.32843 8 7 7.32843 7 6.5V1.5C7 0.671573 6.32843 0 5.5 0H2.5Z", fill: "#09A639" })
    )
  );
}, GZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6.75C5.51878 6.75 6.75 5.51878 6.75 4C6.75 2.48122 5.51878 1.25 4 1.25C2.48122 1.25 1.25 2.48122 1.25 4C1.25 5.51878 2.48122 6.75 4 6.75ZM4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z", fill: "#8E9194" })
    )
  );
}, qZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("circle", { cx: "4", cy: "4", r: "4", fill: "#09A639" })
    )
  );
}, KZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "none" },
      N.createElement("path", { d: "M1.5 0.5C1.5 0.223858 1.72386 0 2 0C2.27614 0 2.5 0.223858 2.5 0.5V1C2.5 1.27614 2.27614 1.5 2 1.5C1.72386 1.5 1.5 1.27614 1.5 1V0.5Z", fill: "#8E9194" }),
      N.createElement("path", { d: "M5.5 0.5C5.5 0.223858 5.72386 0 6 0C6.27614 0 6.5 0.223858 6.5 0.5V1C6.5 1.27614 6.27614 1.5 6 1.5C5.72386 1.5 5.5 1.27614 5.5 1V0.5Z", fill: "#8E9194" }),
      N.createElement("path", { d: "M4 4.29289L3.35355 3.64645C3.15829 3.45118 2.84171 3.45118 2.64645 3.64645C2.45118 3.84171 2.45118 4.15829 2.64645 4.35355L3.29289 5L2.64645 5.64645C2.45118 5.84171 2.45118 6.15829 2.64645 6.35355C2.84171 6.54882 3.15829 6.54882 3.35355 6.35355L4 5.70711L4.64645 6.35355C4.84171 6.54882 5.15829 6.54882 5.35355 6.35355C5.54882 6.15829 5.54882 5.84171 5.35355 5.64645L4.70711 5L5.35355 4.35355C5.54882 4.15829 5.54882 3.84171 5.35355 3.64645C5.15829 3.45118 4.84171 3.45118 4.64645 3.64645L4 4.29289Z", fill: "#8E9194" }),
      N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 0.799988H3V1.2375C3 1.2375 3 1.96667 2 1.96667C1 1.96667 1 1.2375 1 1.2375V0.891274C0.935403 0.910846 0.875663 0.934614 0.819014 0.963478C0.536771 1.10729 0.3073 1.33676 0.16349 1.619C0 1.93987 0 2.35991 0 3.19999V5.6C0 6.44008 0 6.85913 0.16349 7.18C0.3073 7.46224 0.536771 7.69619 0.819014 7.84C1.13324 8.00011 1.54259 8.00007 2.3484 8H5.6516C6.45741 8.00007 6.86676 8.00011 7.18099 7.84C7.46323 7.69619 7.6927 7.46224 7.83651 7.18C8 6.85913 8 6.44008 8 5.6V3.19999C8 2.35991 8 1.93987 7.83651 1.619C7.6927 1.33676 7.46323 1.10729 7.18099 0.963478C7.12434 0.934614 7.0646 0.910846 7 0.891274V1.2375C7 1.2375 7 1.96667 6 1.96667C5 1.96667 5 1.2375 5 1.2375V0.799988ZM1 4C1 3.44772 1.44772 3 2 3H6C6.55228 3 7 3.44772 7 4V6C7 6.55228 6.55228 7 6 7H2C1.44772 7 1 6.55228 1 6V4Z", fill: "#8E9194" })
    )
  );
}, YZ = (e) => {
  const { size: r, color: o, bgColor: a, sx: i, className: l, ...c } = e;
  return N.createElement(
    Tt,
    { component: "span", className: ot("ui-internal-icon", l), display: "inline-flex", sx: { color: o, fontSize: r ?? 14, background: a, ...i }, "aria-hidden": !0, ...c },
    N.createElement(
      "svg",
      { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
      N.createElement("path", { d: "M1.32031 6.70508C1.32031 5.95312 1.46159 5.24902 1.74414 4.59277C2.02669 3.93197 2.41862 3.35091 2.91992 2.84961C3.42122 2.34831 4 1.95638 4.65625 1.67383C5.31706 1.39128 6.02344 1.25 6.77539 1.25C7.52734 1.25 8.23145 1.39128 8.8877 1.67383C9.5485 1.95638 10.1296 2.34831 10.6309 2.84961C11.1322 3.35091 11.5241 3.93197 11.8066 4.59277C12.0892 5.24902 12.2305 5.95312 12.2305 6.70508C12.2305 7.32943 12.1302 7.92188 11.9297 8.48242C11.7337 9.04297 11.4603 9.55111 11.1094 10.0068L14.4521 13.3701C14.5251 13.443 14.5798 13.5273 14.6162 13.623C14.6572 13.7188 14.6777 13.8213 14.6777 13.9307C14.6777 14.0811 14.6436 14.2178 14.5752 14.3408C14.5114 14.4639 14.4202 14.5596 14.3018 14.6279C14.1833 14.7008 14.0465 14.7373 13.8916 14.7373C13.7822 14.7373 13.6774 14.7168 13.5771 14.6758C13.4814 14.6393 13.3926 14.5824 13.3105 14.5049L9.94727 11.1348C9.50065 11.4538 9.00846 11.7044 8.4707 11.8867C7.93294 12.069 7.36784 12.1602 6.77539 12.1602C6.02344 12.1602 5.31706 12.0189 4.65625 11.7363C4 11.4538 3.42122 11.0618 2.91992 10.5605C2.41862 10.0592 2.02669 9.48047 1.74414 8.82422C1.46159 8.16341 1.32031 7.45703 1.32031 6.70508ZM2.48926 6.70508C2.48926 7.29753 2.59863 7.85352 2.81738 8.37305C3.04069 8.88802 3.34831 9.34147 3.74023 9.7334C4.13672 10.1253 4.59245 10.4329 5.10742 10.6562C5.62695 10.8796 6.18294 10.9912 6.77539 10.9912C7.36784 10.9912 7.92155 10.8796 8.43652 10.6562C8.95605 10.4329 9.41178 10.1253 9.80371 9.7334C10.1956 9.34147 10.5033 8.88802 10.7266 8.37305C10.9499 7.85352 11.0615 7.29753 11.0615 6.70508C11.0615 6.11263 10.9499 5.55892 10.7266 5.04395C10.5033 4.52441 10.1956 4.06868 9.80371 3.67676C9.41178 3.28027 8.95605 2.97266 8.43652 2.75391C7.92155 2.5306 7.36784 2.41895 6.77539 2.41895C6.18294 2.41895 5.62695 2.5306 5.10742 2.75391C4.59245 2.97266 4.13672 3.28027 3.74023 3.67676C3.34831 4.06868 3.04069 4.52441 2.81738 5.04395C2.59863 5.55892 2.48926 6.11263 2.48926 6.70508Z", fill: "currentColor" })
    )
  );
};
function ZZ(e) {
  const t = ca(e), { shadow: r, typography: o } = e?.zoomUI ?? Ao();
  return {
    textField: {
      borderColor: t.component.input.border,
      borderRadius: {
        small: "6px",
        medium: "8px",
        large: "10px",
        extraLarge: "12px"
      },
      color: t.text.stronger.neutral,
      readOnlyColor: t.text.neutral,
      disabledColor: t.state.disable,
      placeholderColor: t.text.neutral,
      fontSize: {
        small: o.fontSize.subtitle,
        medium: o.fontSize.body,
        large: "16px",
        extraLarge: "16px"
      },
      height: {
        small: "14px",
        medium: "22px",
        large: "30px",
        extraLarge: "38px"
      }
    },
    icon: {
      size: {
        small: 14,
        medium: 16,
        large: 16,
        extraLarge: 16
      }
    },
    chip: {
      readOnlyColor: t.text.neutral
    },
    paper: {
      borderColor: t.border.subtle.neutral,
      background: t.fill.default
    },
    option: {
      color: t.text.strong.primary
    },
    color: {
      primary: {
        fill: t.fill.primary,
        text: t.text.primary
      },
      neutral: {
        default: t.text.neutral,
        stronger: t.text.stronger.neutral
      }
    },
    background: {
      secondary: {
        default: t.bg.default,
        hover: t.state.subtle.neutral.hover,
        active: t.state.subtle.neutral.press,
        readOnly: t.fill.subtler.neutral
      }
    },
    border: {
      secondary: {
        default: t.component.input.border,
        paper: t.border.subtle.neutral
      },
      error: {
        default: t.border.error,
        disabled: t.state.subtle.error.disable
      },
      disabled: t.state.subtle.disable
    },
    helpText: {
      error: t.text.error,
      default: t.text.neutral
    },
    boxShadow: {
      pager: r.md
    },
    fontFamily: o.fontFamily,
    outline: {
      default: "none",
      focus: `2px solid ${t.border.primary}`
    },
    outlineOffset: 2,
    group: {
      title: {
        color: t.text.stronger.neutral,
        fontSize: o.fontSize.bodyBold,
        fontWeight: o.fontWeight.bodyBold,
        lineHeight: o.lineHeight.bodyBold
      },
      borderColor: t.border.subtle.neutral
    }
  };
}
const XZ = "Autocomplete", Wo = "ui-Autocomplete", vn = {
  root: `${Wo}-root`,
  addOption: `${Wo}-addOption`,
  checkedIcon: `${Wo}-checkedIcon`,
  suffixIcon: `${Wo}-suffixIcon`,
  readOnly: `${Wo}-readOnly`,
  canCreate: `${Wo}-canCreate`
}, Nn = {
  paper: `${Wo}-paper`,
  small: `${Wo}-option-small`,
  medium: `${Wo}-option-medium`,
  large: `${Wo}-option-large`,
  extraLarge: `${Wo}-option-extraLarge`,
  withCheckbox: `${Wo}-option-with-checkbox`
};
function Md(e, t) {
  const r = ZZ(e), [o, a] = mn({
    componentName: XZ,
    theme: e,
    dynamicToken: r
  }), { size: i = "medium" } = t ?? {}, l = {
    color: a(o.textField.color),
    [`& .${jt.root}`]: {
      borderRadius: a(o.textField.borderRadius[i]),
      [`&.${Ke.inputRoot} .${Ke.input}`]: {
        padding: "0 2px"
      },
      [`&.${jt.disabled}`]: {
        color: a(o.textField.disabledColor)
      }
    },
    [`& .${jt.input}`]: {
      fontSize: a(o.textField.fontSize[i]),
      "&:disabled": {
        color: a(o.textField.disabledColor),
        textFillColor: a(o.textField.disabledColor)
      },
      "&::placeholder": {
        color: a(o.textField.placeholderColor),
        opacity: 1
      },
      "&:disabled::placeholder": {
        color: a(o.textField.disabledColor),
        textFillColor: a(o.textField.disabledColor)
      }
    },
    [`& .${jt.root}:not(.${jt.error}) .${jt.notchedOutline}`]: {
      borderColor: `${a(o.textField.borderColor)}`
    },
    [`& .${jt.root}.${jt.disabled} .${jt.notchedOutline} `]: {
      borderColor: `${a(o.border.disabled)}`
    },
    [`& .${jt.root}.${jt.error} .${jt.notchedOutline} `]: {
      borderColor: `${a(o.border.error.default)}`
    },
    [`& .${jt.root}.${jt.error}.${jt.disabled} .${jt.notchedOutline} `]: {
      borderColor: `${a(o.border.error.disabled)}`
    },
    [`& .${jt.notchedOutline}`]: {
      top: 0,
      borderColor: `${a(o.textField.borderColor)}`,
      borderWidth: "1px !important",
      legend: {
        display: "none !important"
      }
    }
  }, c = {
    [`&.${Kc.root}`]: {
      fontFamily: a(o.fontFamily),
      margin: "2px 0 0",
      color: a(o.helpText.default),
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      lineHeight: "unset",
      [`&.${Kc.error}`]: {
        display: "flex",
        alignItems: "center",
        color: a(o.helpText.error),
        lineHeight: "20px"
      }
    }
  }, d = {
    marginTop: "4px",
    color: a(o.color.neutral.stronger),
    fontSize: 14,
    borderRadius: "8px",
    background: a(o.paper.background),
    boxShadow: a(o.boxShadow.pager),
    fontFamily: a(o.fontFamily),
    padding: "8px",
    border: `0.5px solid ${a(o.border.secondary.paper)} !important`,
    paddingBottom: "8px",
    "&:empty": {
      // https://github.com/mui/material-ui/issues/40843
      display: "none"
    },
    // The following are dealing with situations where there's no matched items and creatable is true.
    // The `:has()` is not well-supported on Firefox currently but unluckily we do not have any better ways using MUI.
    // This will cause a slight spacing above the adding label on Firefox in that situation.
    [`&:has(.${Ke.listbox} > li:only-child)`]: {
      paddingBottom: "8px"
    },
    [`&.${vn.canCreate}`]: {
      paddingBottom: "52px",
      // // The following are dealing with situations where there's no matched items and creatable is true.
      // // The `:has()` is not well-supported on Firefox currently but unluckily we do not have any better ways using MUI.
      // // This will cause a slight spacing above the adding label on Firefox in that situation.
      [`&:has(.${Ke.listbox} > li:only-child)`]: {
        paddingBottom: "44px"
      }
    },
    [`& .${Ke.listbox}`]: {
      position: "static",
      padding: 0,
      ">li": {
        "&:first-of-type": {
          [`.${Ke.groupLabel}`]: {
            marginTop: 0,
            paddingTop: "8px",
            borderTop: "none"
          }
        }
      },
      [`& .${Ke.option}`]: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        lineHeight: "20px",
        overflowWrap: "break-word",
        minHeight: 0,
        padding: "7px 8px",
        borderRadius: "4px",
        [`.${vn.checkedIcon}`]: {
          color: a(o.color.primary.text),
          fontSize: 16,
          marginInlineStart: "8px"
        }
      },
      [`& .${Ke.option}[aria-selected="true"]`]: {
        backgroundColor: "transparent"
      },
      [`& .${Ke.option}.${Ke.focused}`]: {
        backgroundColor: a(o.background.secondary.hover)
      },
      [`& .${Ke.option}:active`]: {
        backgroundColor: a(o.background.secondary.active)
      },
      [`& .${Ke.option}[aria-selected="true"].${Ke.focused}`]: {
        backgroundColor: a(o.background.secondary.hover),
        "&:active": {
          backgroundColor: a(o.background.secondary.active)
        }
      },
      [`& .${Ke.option}[aria-disabled="true"]`]: {
        color: a(o.textField.disabledColor),
        opacity: 1
      },
      [`.${vn.addOption}`]: {
        position: "absolute",
        left: "8px",
        right: "8px",
        bottom: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        borderTop: `1px solid ${a(o.paper.borderColor)}`,
        color: a(o.option.color),
        justifyContent: "space-between",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        [`&:hover, &.${Ke.focused}`]: {
          borderTopColor: "transparent",
          borderRadius: "4px"
        }
      },
      [`& .${Ke.groupLabel}`]: {
        background: a(o.paper.background),
        marginTop: "8px",
        padding: "8px",
        paddingTop: "16px",
        fontSize: a(o.group.title.fontSize),
        fontWeight: a(o.group.title.fontWeight),
        lineHeight: a(o.group.title.lineHeight),
        borderTop: `1px solid ${a(o.group.borderColor)}`,
        color: a(o.group.title.color),
        "&:empty": {
          display: "none"
        }
      }
    },
    [`&.${Nn.small}`]: {
      [`.${Ke.listbox}`]: {
        [`.${Ke.option}`]: {
          lineHeight: "16px",
          [`&.${Nn.withCheckbox}`]: {
            lineHeight: "20px"
          },
          [`.${vn.checkedIcon}`]: {
            fontSize: "14px"
          }
        }
      }
    },
    [`.${Ke.noOptions}`]: {
      fontSize: 14,
      textAlign: "center",
      padding: "8px",
      lineHeight: "20px",
      color: a(o.color.neutral.default)
    },
    [`&.${Nn.paper} .${Ke.noOptions}`]: {
      lineHeight: "16px"
    },
    [`&.${Nn.small} `]: {
      [`.${Ke.noOptions}`]: {
        fontSize: 12
      },
      [`.${Ke.option}`]: {
        padding: "6px 8px",
        fontSize: 12
      }
    },
    [`&.${Nn.medium} `]: {
      [`.${Ke.noOptions}`]: {
        fontSize: 14
      },
      [`.${Ke.option}`]: {
        fontSize: 14,
        lineHeight: "18px"
      },
      [`.${Nn.withCheckbox}`]: {
        lineHeight: "20px",
        padding: "6px 8px"
      }
    },
    [`&.${Nn.large} `]: {
      [`.${Ke.noOptions}`]: {
        fontSize: 14
      },
      [`.${Ke.option}`]: {
        fontSize: 16,
        [`&.${Nn.withCheckbox}`]: {
          lineHeight: "20px"
        }
      }
    },
    [`&.${Nn.extraLarge} `]: {
      [`.${Ke.noOptions}`]: {
        fontSize: 14
      },
      [`.${Ke.option}`]: {
        fontSize: 16,
        lineHeight: "18px",
        padding: "7px 8px",
        [`&.${Nn.withCheckbox}`]: {
          lineHeight: "20px",
          padding: "6px 8px"
        }
      }
    },
    [`&.${Nn.large} .${Ke.noOptions}, &.${Nn.extraLarge} .${Ke.noOptions}`]: {
      fontSize: 16
    }
  }, p = {
    [`.${Ke.inputRoot}`]: {
      background: a(o.background.secondary.default),
      [`.${Ke.input}`]: {
        height: `${a(o.textField.height[i])}`,
        lineHeight: `${a(o.textField.height[i])}`
      }
    },
    [`&:hover:not(.${jt.focused})`]: {
      [`.${Ke.inputRoot}:not(.${jt.disabled}, .${vn.readOnly} *)`]: {
        background: a(o.background.secondary.hover)
      }
    },
    [`.${Ke.tag}`]: {
      marginTop: 0,
      marginBottom: 0,
      lineHeight: "20px",
      fontSize: 14
    },
    [`& .${Ke.inputRoot}`]: {
      maxHeight: "124px",
      overflow: "auto",
      position: "static",
      [`& .${Ke.input}`]: {
        minWidth: 50
      }
    },
    [`&.${jt.focused} .${Ke.inputRoot}`]: {
      outline: a(o.outline.focus),
      outlineOffset: a(o.outlineOffset),
      borderRadius: a(o.textField.borderRadius[i]),
      borderColor: a(o.textField.borderColor)
    },
    [`&.${Ke.hasClearIcon} .${jt.sizeSmall}`]: {
      paddingRight: "39px"
    },
    [`&.${Ke.hasPopupIcon} .${jt.sizeSmall}`]: {
      paddingRight: "39px"
    },
    [`& .${ys.root} + div`]: {
      position: "relative"
    },
    [`& .${jt.root}.${Ke.inputRoot}`]: {
      py: "5px",
      pl: i === "large" || i === "extraLarge" ? "12px" : "8px",
      borderRadius: a(o.textField.borderRadius[i]),
      minHeight: a(o.textField.height[i]),
      gap: "6px",
      boxSizing: "border-box"
    },
    [`& .${jt.root}.${Ke.inputRoot} input.${Ke.input}`]: {
      padding: "0 0 0 6px",
      "&:first-of-type": {
        padding: 0
      }
    },
    [`& .${Ke.endAdornment}`]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      top: 0,
      transform: "translate(0)",
      "& > button": {
        verticalAlign: "unset",
        padding: 0,
        borderRadius: "4px",
        background: "transparent"
      },
      [`& .${vn.suffixIcon}`]: {
        color: a(o.color.neutral.stronger),
        transform: "rotate(90deg)",
        fontSize: a(o.icon.size[i])
      },
      [`.${Nb.disabled} .${vn.suffixIcon}`]: {
        color: a(o.textField.disabledColor)
      }
    },
    [`& .${Ke.clearIndicator}`]: {
      visibility: "visible",
      marginInlineEnd: "4px",
      "&:hover": {
        backgroundColor: "unset"
      }
    },
    [`&:focus-within .${Ke.clearIndicator}`]: {
      visibility: "visible"
    },
    [`.${Bt.root}`]: {
      margin: "0"
    },
    [`.${jt.root} .${Ke.endAdornment}`]: {
      right: i === "large" || i === "extraLarge" ? "12px" : "8px"
    },
    [`.${Ke.popupIndicator}`]: {
      margin: 0
    },
    [`&.${vn.readOnly}`]: {
      [`.${jt.root}:not(.${jt.disabled})`]: {
        color: a(o.textField.readOnlyColor),
        background: a(o.background.secondary.readOnly),
        [`.${Ke.popupIndicator}`]: {
          display: "none"
        },
        [`.${Bt.label}`]: {
          color: a(o.chip.readOnlyColor)
        }
      }
    }
  };
  return { formHelperTextStyle: c, paperStyle: d, textFieldStyle: l, style: p };
}
const JZ = "_SELECT_ALL", hS = (e) => e?._inputValue ? e._inputValue : e, _d = (e, t = "value") => e && typeof e == "object" && t in e ? e[t] ?? e : e === void 0 ? void 0 : e ?? null, gS = (e) => e !== null && typeof e == "object" && !Array.isArray(e), Fd = /* @__PURE__ */ new Map(), Ga = (e) => {
  if (Fd.has(e))
    return Fd.get(e);
  const r = String(e).replace(/[-_]/g, (o) => o === "-" ? "·" : "‧");
  return Fd.size < 1e3 && Fd.set(e, r), r;
}, Bg = (e, t, r = /* @__PURE__ */ new WeakSet()) => {
  if (e === t)
    return !0;
  if (e == null || t == null)
    return e === t;
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length === 0 && t.length === 0)
      return !0;
    if (e.length === 0 || t.length === 0)
      return !1;
  }
  if (typeof e != typeof t)
    return !1;
  if (typeof e != "object" || r.has(e) || r.has(t))
    return e === t;
  if (r.add(e), r.add(t), gS(e) && gS(t)) {
    const o = "value" in e, a = "value" in t, i = "id" in e, l = "id" in t, c = "key" in e, d = "key" in t;
    if (o && a)
      return e.value === t.value;
    if (i && l)
      return e.id === t.id;
    if (c && d)
      return e.key === t.key;
    const p = (T) => {
      if (T.value !== void 0 && T.value !== null)
        return T.value;
      if (T.id !== void 0 && T.id !== null)
        return T.id;
      if (T.key !== void 0 && T.key !== null)
        return T.key;
    }, f = p(e), h = p(t);
    if (f !== void 0 && h !== void 0)
      return f === h;
    const g = (T) => {
      if (T.label !== void 0 && T.label !== null)
        return T.label;
      if (T.name !== void 0 && T.name !== null)
        return T.name;
      if (T.text !== void 0 && T.text !== null)
        return T.text;
    }, y = g(e), C = g(t);
    if (y !== void 0 && C !== void 0)
      return y === C;
    const b = Object.keys(e), v = Object.keys(t);
    return b.length !== v.length ? !1 : b.every((T) => v.includes(T) ? Bg(e[T], t[T], r) : !1);
  }
  return Array.isArray(e) && Array.isArray(t) ? e.length !== t.length ? !1 : e.every((o, a) => Bg(o, t[a], r)) : !1;
}, bS = (e, t, r = "option") => {
  if (e == null)
    return `${r}-null-${t}`;
  if (typeof e != "object")
    return `${r}-primitive-${Ga(e)}-${t}`;
  if (e._inputValue !== void 0 && e._inputValue !== null)
    return `create-${Ga(e._inputValue)}-${t}`;
  if (e[JZ])
    return "select-all";
  if (e?.id !== void 0 && e?.id !== null)
    return `${r}-id-${Ga(e.id)}`;
  if (e?.key !== void 0 && e?.key !== null)
    return `${r}-key-${Ga(e.key)}`;
  if (e?.value !== void 0 && e?.value !== null) {
    const o = typeof e.value == "object" ? `obj-${Ga(e.value?.id ?? e.value?.key ?? e.value?.value ?? t)}` : `val-${Ga(e.value)}`;
    return `${r}-${o}`;
  }
  return e?.label !== void 0 && e?.label !== null ? `${r}-label-${Ga(e.label)}-${t}` : e?.name !== void 0 && e?.name !== null ? `${r}-name-${Ga(e.name)}-${t}` : e?.text !== void 0 && e?.text !== null ? `${r}-text-${Ga(e.text)}-${t}` : `${r}-${t}`;
};
function Ky(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontFamily: r.fontFamily,
    baseCheckboxBorderRadius: 4,
    baseCheckboxWidth: 16,
    baseCheckboxHeight: 16,
    baseCheckboxPadding: 2,
    checkboxLabelMarginLeft: 6,
    checkboxLabelColor: t.text.stronger.neutral,
    checkboxLabelDisabledColor: t.state.disable,
    checkboxBorderColor: t.border.neutral,
    checkboxHoverBgColor: t.state.subtle.neutral.hover,
    checkboxPressBgColor: t.state.subtle.neutral.press,
    checkboxHoverBorderColor: t.border.neutral,
    checkboxActiveBorderColor: t.border.neutral,
    checkboxDisabledBgColor: t.state.subtle.disable,
    checkboxDisabledBorderColor: t.state.disable,
    checkboxFocusBoxShadow: `0 0 0 2px ${t.bg.default}, 0 0 0 4px ${t.fill.primary}`,
    checkboxCheckedBgColor: t.fill.global.primary,
    checkboxCheckedHoverBgColor: t.state.primary.hover,
    checkboxCheckedActiveBgColor: t.state.primary.press,
    checkboxCheckedDisabledBgColor: t.state.subtle.primary.disable,
    descriptionMarginTop: 4,
    descriptionColor: t.text.neutral,
    descriptionFontSize: r.fontSize.body,
    descriptionFontWeight: r.fontWeight.body,
    descriptionLineHeight: r.lineHeight.body
  };
}
const Yy = "Checkbox", Yn = {
  root: `ui-Checkbox-root-${to()}`,
  title: "ui-Checkbox-title",
  label: "ui-Checkbox-label",
  description: "ui-Checkbox-description",
  base: "ui-Checkbox-base",
  pressed: "ui-Checkbox-pressed"
};
function QZ(e, t) {
  const r = Ky(e), [o, a] = mn({
    componentName: Yy,
    theme: e,
    dynamicToken: r
  });
  return {
    [`&.${Yn.root}`]: {
      display: "inline-flex",
      flexDirection: "column",
      [`& .${Yn.title}`]: {
        display: "inline-flex",
        alignItems: "center",
        cursor: t?.disabled ? "not-allowed" : "pointer",
        fontFamily: a(o.fontFamily),
        "&:focus": {
          outline: "none"
        }
      },
      [`& .${Yn.base}`]: {
        padding: a(o.baseCheckboxPadding),
        alignSelf: "flex-start"
      },
      [`& .${Yn.label}`]: {
        marginInlineStart: a(o.checkboxLabelMarginLeft),
        color: t?.disabled ? a(o.checkboxLabelDisabledColor) : a(o.checkboxLabelColor),
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px"
      },
      [`& .${Yn.description}`]: {
        marginInlineStart: a(o.baseCheckboxWidth + o.baseCheckboxPadding * 2 + o.checkboxLabelMarginLeft),
        marginTop: a(o.descriptionMarginTop),
        color: t?.disabled ? a(o.checkboxLabelDisabledColor) : a(o.descriptionColor),
        fontSize: a(o.descriptionFontSize),
        fontWeight: a(o.descriptionFontWeight),
        lineHeight: a(o.descriptionLineHeight),
        "&:empty": {
          display: "none"
        }
      }
    }
  };
}
function eX(e) {
  const t = Ky(e), [r, o] = mn({
    componentName: Yy,
    theme: e,
    dynamicToken: t
  });
  return {
    display: "flex",
    boxSizing: "border-box",
    borderRadius: o(r.baseCheckboxBorderRadius),
    width: o(r.baseCheckboxWidth),
    height: o(r.baseCheckboxHeight),
    border: `1px solid ${o(r.checkboxBorderColor)}`,
    backgroundColor: "unset",
    "input:hover ~ &": {
      border: `1px solid ${o(r.checkboxHoverBorderColor)}`,
      backgroundColor: o(r.checkboxHoverBgColor)
    },
    [`input:active ~ &, .${Yn.pressed} input ~ &`]: {
      border: `1px solid ${o(r.checkboxActiveBorderColor)}`,
      backgroundColor: o(r.checkboxPressBgColor)
    },
    "input:disabled ~ &": {
      border: `1px solid ${o(r.checkboxDisabledBorderColor)}`,
      backgroundColor: o(r.checkboxDisabledBgColor)
    },
    [`.${Yn.root} .${Yn.title} input:focus-visible:not(:disabled) ~ &`]: {
      boxShadow: o(r.checkboxFocusBoxShadow)
    }
  };
}
function tX(e) {
  const t = Ky(e), [r, o] = mn({
    componentName: Yy,
    theme: e,
    dynamicToken: t
  });
  return {
    border: "none",
    position: "relative",
    "input ~ &": {
      backgroundColor: o(r.checkboxCheckedBgColor),
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      svg: {
        fontSize: 20,
        position: "absolute"
      }
    },
    "input:hover ~ &": {
      border: "none",
      backgroundColor: o(r.checkboxCheckedHoverBgColor)
    },
    [`input:active ~ &, .${Yn.pressed} input ~ &`]: {
      border: "none",
      backgroundColor: o(r.checkboxCheckedActiveBgColor)
    },
    "input:disabled ~ &": {
      border: "none",
      backgroundColor: o(r.checkboxCheckedDisabledBgColor)
    }
  };
}
const y4 = N.createContext(null);
y4.Provider;
const rX = () => N.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none" },
  N.createElement("rect", { x: "2", y: "2", width: "16", height: "16", rx: "4", fill: "none" }),
  N.createElement("path", { d: "M5.75 10.25L8.75 13.25L14.25 6.75", stroke: "#F7F9FA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
), nX = () => N.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none" },
  N.createElement("rect", { x: "2", y: "2", width: "16", height: "16", rx: "4", fill: "none" }),
  N.createElement("path", { d: "M6 10H14", stroke: "#F7F9FA", strokeWidth: "2", strokeLinecap: "round" })
);
function Zy(e, t, r, o) {
  const a = Xt(e), [i, l] = Ir(() => e !== void 0 ? e : t);
  Fc(() => {
    e !== void 0 && (a.current === void 0 || !0) && l(e), a.current = e;
  }, [e]);
  const c = Ln((p, ...f) => {
    a.current === void 0 && l(p);
  }, [r]);
  return [e !== void 0 ? e : i, c];
}
const oX = N.useId || (() => ra(() => to(), []));
function Xy(e) {
  const t = oX();
  return (r) => `${e}-${t}-${r}`;
}
const v4 = Y("span")((e) => eX(e.theme)), yS = Y(v4)((e) => tX(e.theme)), aX = N.forwardRef((e, t) => {
  const r = N.useContext(y4), { className: o, children: a, checkedIcon: i, defaultChecked: l, indeterminate: c, onChange: d, indeterminateIcon: p, icon: f, value: h, id: g, sx: y, description: C, inputProps: b, ...v } = e, [T, R] = Tp(v), [$, E] = Tp(b ?? {}), S = Xy("checkbox"), k = S("label"), A = S("desc"), _ = {};
  a && Object.assign(_, { "aria-labelledby": k }), C && Object.assign(_, { "aria-describedby": A });
  let { disabled: L, checked: O, name: F, onChange: B } = e;
  const M = N.useRef(null);
  if (r) {
    const X = (U, H) => {
      d?.(U, H), r?.onChange(h);
    };
    L = L || r.disabled, O = !!r.value?.includes(h), F = r.name, B = X;
  }
  const [j, W] = Zy(O, l);
  function V(X, U) {
    W(U), B?.(X, U);
  }
  return Dn(() => {
    M.current && (M.current.indeterminate = !!c);
  }, [c]), N.createElement(
    "div",
    { className: ot(Yn.root, o) },
    N.createElement(
      "label",
      { className: Yn.title, htmlFor: g },
      N.createElement(qb, { id: g, ref: t, name: F, disableRipple: !0, checked: !!j, disabled: L, indeterminate: !!c, onChange: V, value: h, icon: f ?? N.createElement(v4, { "aria-hidden": !0 }), checkedIcon: i ?? N.createElement(
        yS,
        { "aria-hidden": !0 },
        N.createElement(rX, null)
      ), indeterminateIcon: p ?? N.createElement(
        yS,
        { "aria-hidden": !0 },
        N.createElement(nX, null)
      ), className: ot(Yn.base), inputProps: {
        "aria-checked": c ? "mixed" : !!j,
        "aria-disabled": L,
        ..._,
        ...$,
        ...T,
        ...E
      }, ...R, inputRef: M, sx: y }),
      !!a && N.createElement("span", { id: k, className: Yn.label, "aria-hidden": !0 }, a)
    ),
    !!C && N.createElement("span", { id: A, className: Yn.description }, C)
  );
}), iX = Y(aX)(({ theme: e, disabled: t }) => QZ(e, { disabled: t })), sX = N.forwardRef((e, t) => N.createElement(iX, { ...e, ref: t }));
function lX(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontSize: 12,
    closeIconSize: 10,
    lineHeight: "16px",
    fontFamily: r.fontFamily,
    borderRadius: 5,
    gap: 4,
    color: {
      default: t.text.stronger.neutral,
      disabled: t.state.disable,
      error: t.text.error,
      errorDisabled: t.state.subtle.error.disable
    },
    background: {
      default: t.fill.subtler.neutral,
      hover: t.state.subtle.neutral.hover,
      active: t.state.subtle.neutral.press,
      disabled: t.fill.subtler.neutral
    },
    margin: {
      deleteIcon: "0"
    },
    padding: {
      root: "2px 8px",
      deleteIcon: "0"
    },
    outline: `2px solid ${t.border.primary}`,
    boxShadow: {
      error: `inset 0 0 0 1px ${t.border.error}`,
      errorDisabled: `inset 0 0 0 1px ${t.state.subtle.error.disable}`
    }
  };
}
const cX = "Tag", Xi = "ui-Tag", zr = {
  root: `${Xi}-root-${to()}`,
  label: `${Xi}-label`,
  disabled: `${Xi}-disabled`,
  error: `${Xi}-error`,
  deleteIcon: `${Xi}-deleteIcon`,
  clickable: `${Xi}-clickable`,
  avatar: `${Xi}-avatar`
};
function uX(e) {
  const t = lX(e), [r, o] = mn({
    componentName: cX,
    theme: e,
    dynamicToken: t
  });
  return {
    [`&.${zr.root}`]: {
      padding: o(r.padding.root),
      borderRadius: o(r.borderRadius),
      background: o(r.background.default),
      height: "auto",
      maxWidth: "auto",
      cursor: "auto",
      transition: "none",
      "&:focus-visible": {
        outline: o(r.outline),
        outlineOffset: "2px"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: o(r.gap)
      },
      "&:active": {
        boxShadow: "none"
      },
      [`&.${zr.clickable}`]: {
        cursor: "pointer",
        "&:hover": {
          background: o(r.background.hover)
        },
        "&:active": {
          background: o(r.background.active),
          [`&:has(.${zr.deleteIcon}:active)`]: {
            background: o(r.background.hover)
          }
        }
      },
      [`.${zr.deleteIcon}:focus-visible`]: {
        outline: o(r.outline)
      },
      [`.${zr.label}`]: {
        fontFamily: o(r.fontFamily),
        fontSize: o(r.fontSize),
        lineHeight: o(r.lineHeight),
        color: o(r.color.default),
        padding: 0
      },
      [`& .${zr.deleteIcon}`]: {
        color: o(r.color.default),
        fontSize: o(r.closeIconSize),
        lineHeight: 0,
        padding: o(r.padding.deleteIcon),
        borderRadius: "2px",
        margin: o(r.margin.deleteIcon),
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&:hover": {
          background: o(r.background.hover)
        },
        "&:active": {
          background: o(r.background.active)
        }
      },
      [`&.${zr.disabled}`]: {
        opacity: 1,
        background: o(r.background.disabled),
        [`& .${zr.label}, .${zr.deleteIcon}`]: {
          color: o(r.color.disabled)
        }
      },
      [`&.${zr.error}`]: {
        boxShadow: o(r.boxShadow.error),
        [`& .${zr.label}, .${zr.deleteIcon}`]: {
          color: o(r.color.error)
        }
      },
      [`&.${zr.disabled}.${zr.error}`]: {
        boxShadow: o(r.boxShadow.errorDisabled),
        [`& .${zr.label}, .${zr.deleteIcon}`]: {
          color: o(r.color.errorDisabled)
        }
      },
      [`.${zr.avatar}`]: {
        marginInlineStart: 0
      }
    }
  };
}
const dX = {
  Shared: {
    /** Click to confirm an action */
    ok: "OK",
    /** Click to cancel an action */
    cancel: "Cancel",
    /** Click to close a dialog or a panel */
    close: "Close",
    /** Conjunction for series of entities */
    conjunction: ", ",
    /** Conjunction for the last item in a series of entities */
    conjunctionLast: " and ",
    /**
     * Format for presenting a percentage.
     * {{number}} is the number of the percentage.
     * For example: 50%
     */
    percentage: "{{number}}%",
    /* Alert message in loading state */
    loading: "Loading"
  },
  Ellipsis: {
    /** Text for expanding truncated content */
    expandText: "View more",
    /** Text for collapsing expanded content */
    collapseText: "View less"
  },
  Autocomplete: {
    /** Click to select all items of a list */
    selectAll: "All",
    /**
     * Click to add a user-specified label into a list.
     * {{label}} is the content of the label.
     * For example (in a color platte): Add “Red”
     */
    addLabel: "Add “{{value}}”",
    /**
     * Click to remove a label from a list.
     * {{label}} is the content of the label.
     * For example (in a color palette): Remove “Red”
     */
    removeLabel: "Remove “{{label}}”",
    /**
     * The label for hidden items in a truncated list.
     * {{more}} is the number of hidden items.
     * For example (in the end of a truncated list with 3 hidden items): and 3 more
     * Translating to "+ {{more}}" is acceptable if there is no equivalent expression for specified language.
     */
    limitTags: "and {{more}} more",
    /** The label for loading state */
    loading: "Loading…",
    /** The label for an empty option list */
    noOptions: "No options",
    /** Click to clear all selected items */
    clear: "Clear",
    /**
     * Label for the selected item count of a list.
     * {{count}} is the number of items in the list.
     * For example (when the user selected 2 items): 2 selected
     */
    selectedCount: "{{count}} selected"
  },
  Avatar: {
    /** A general placeholder for a user's avatar (for screen reader / braille display only) */
    defaultProfileAvatar: "user profile avatar",
    /**
     * A placeholder for a user's avatar (for screen reader / braille display only).
     * {{name}} is the user's name.
     * For example (when the user focus on Bob's avatar image): Bob profile avatar
     */
    profileAvatar: "{{name}} profile avatar",
    /** A label for a user indicating the user is inactive */
    inactive: "inactive",
    /** A label for a user indicating the user is online */
    online: "online",
    /** A label for a user indicating the user is offline */
    offline: "offline",
    /** A label for a user indicating the user is using a mobile device */
    mobile: "mobile",
    /** A label for a user indicating the user is in a call */
    inCall: "in call",
    /** A label for a user indicating the user is in a meeting */
    inMeeting: "in meeting",
    /** A label for a user indicating the user is out of office */
    outOfOffice: "out of office",
    /** A label for a user indicating the user does not want to be disturbed */
    doNotDisturb: "do not disturb",
    /** A label for a user indicating the user is in a calendar event */
    inACalendarEvent: "in a calendar event",
    /** A label for a user indicating the user is away */
    away: "away",
    /** A label for a user indicating the user is blocking all messages */
    block: "block",
    /** A label for a user indicating the user is busy */
    busy: "busy"
  },
  ImageCropper: {
    /** Label for crop area of an image cropper */
    cropArea: "reposition cropping frame border",
    /** Instructions for moving the crop area */
    moveInstruction: "Use arrow keys to move",
    /** Label for top left corner controller of an image cropper */
    topLeftCorner: "top left corner cropper",
    /** Label for top right corner controller of an image cropper */
    topRightCorner: "top right corner cropper",
    /** Label for bottom left corner controller of an image cropper */
    bottomLeftCorner: "bottom left corner cropper",
    /** Label for bottom right corner controller of an image cropper */
    bottomRightCorner: "bottom right corner cropper",
    /** Label for top edge controller of an image cropper */
    topEdge: "top border cropper",
    /** Label for bottom edge controller of an image cropper */
    bottomEdge: "bottom border cropper",
    /** Label for left edge controller of an image cropper */
    leftEdge: "left border cropper",
    /** Label for right edge controller of an image cropper */
    rightEdge: "right border cropper",
    /** Instructions for resizing the crop area */
    resizeInstruction: "Use arrow keys to resize",
    /**
     * Label for the left cropping value
     * {{percentage}} is the percentage to the left edge to be cropped.
     * For example (when cropping 20% of image to the left): 20% from left edge
     */
    leftPercentage: "{{percentage}} from left edge",
    /**
     * Label for the top cropping value
     * {{percentage}} is the percentage to the top edge to be cropped.
     * For example (when cropping 20% of image to the top): 20% from top edge
     */
    topPercentage: "{{percentage}} from top edge",
    /**
     * Label for the right cropping value
     * {{percentage}} is the percentage to the right edge to be cropped.
     * For example (when cropping 20% of image to the right): 20% from right edge
     */
    rightPercentage: "{{percentage}} from right edge",
    /**
     * Label for the bottom cropping value
     * {{percentage}} is the percentage to the bottom edge to be cropped.
     * For example (when cropping 20% of image to the bottom): 20% from bottom edge
     */
    bottomPercentage: "{{percentage}} from bottom edge"
  },
  Input: {
    /**
     * The cue when there is a prefix before an input box (for screen reader / braille display only).
     * {{prefix}} is the content of the prefix.
     * For example (when the user focused on a text input box for an URL): Prefix is “https://”.
     */
    prefix: "Prefix is “{{prefix}}”.",
    /**
     * The cue when there is a suffix after an input box (for screen reader / braille display only).
     * {{suffix}} is the content of the suffix.
     * For example (when the user focused on a number input box who's unit is kilogram): Suffix is “kg”.
     */
    suffix: "Suffix is “{{suffix}}”.",
    /**
     * The cue when there are both prefix and suffix around an input box (for screen reader / braille display only).
     * {{prefix}} is the content of the prefix.
     * {{suffix}} is the content of the suffix.
     * For example (when the user focused on a text input box for an URL ends with ".com"): Prefix is “https://” and suffix is “.com”.
     */
    prefixAndSuffix: "Prefix is “{{prefix}}” and suffix is “{{suffix}}”.",
    /**
     * The cue for the max length of an input box when the user reached the limit (for screen reader / braille display only).
     * {{maxLength}} is the max characters the input box accepts.
     * For example (when the user tries to type more than 10 characters in a text box only accept 10 characters most): 10 character limit reached.
     */
    maxLengthMessage: "{{maxLength}} character limit reached.",
    /** Click to show (reveal) the password in a password input box */
    showPassword: "Show password",
    /** Click to hide (conceal) the password in a password input box */
    hidePassword: "Hide password",
    /** Click to clear the content inside an input box */
    clear: "Clear"
  },
  InputNumber: {
    /** Click to increase the value of a number input */
    increaseValue: "Increase value",
    /** Click to decrease the value of a number input */
    decreaseValue: "Decrease value",
    /** Default separator for a decimal number */
    decimalSeparator: "."
  },
  Pagination: {
    /**
     * The text indicating a page number.
     * {{page}} is the number of current page.
     * For example: Page 2
     */
    pageNumber: "Page {{page}}",
    /**
     * The text indicating how many items per page are shown.
     * {{items}} is the number of items shown on one page.
     * For example: 20 per page
     */
    perPage: "{{items}} per page",
    /**
     * The text indicating current and total pages.
     * {{page}} is the number of current page.
     * {{total}} is the number of total page.
     * For example: Page 1 of 5
     */
    pageIndex: "Page {{page}} of {{total}}",
    /** The text indicating how many items are in a list in total.
     * {{total}} is the number of current results.
     * For example: 32 results
     */
    result: "{{total}} result",
    results: "{{total}} results",
    /** The label for the page size selector */
    pageSizeLabel: "Page size",
    /** Click to go to the first page */
    firstPage: "First page",
    /** Click to go to the last page */
    lastPage: "Last page",
    /** Click to go to the previous page */
    previousPage: "Previous page",
    /** Click to go to the next page */
    nextPage: "Next page",
    /** The cue for more pages omitted before current page (for screen reader / braille display only) */
    morePreviousPage: "More pages before are omitted.",
    /** The cue for more pages omitted after current page (for screen reader / braille display only) */
    moreNextPage: "More pages after are omitted."
  },
  Select: {
    /** The label for an empty option list */
    noData: "No options",
    /** Click to clear all selected items */
    clear: "Clear"
  },
  Stepper: {
    /** The label for a step which is finished */
    finished: "Finished",
    /** The label for a step which is in progress */
    inProgress: "In Progress",
    /** The label for a step which has not started yet */
    notStarted: "Not started",
    /** The label for a step which has error status */
    error: "Error"
  },
  Table: {
    /** The label for an empty table */
    emptyText: "No data",
    /**
     * The label for a table cell with expandable options (for screen reader / braille display only).
     * {{rowIndex}} is the number of current row.
     * {{header}} is the current column header name.
     * {{cellValue}} is the value of current cell.
     * For example: More options about Row 2, User name: Alice.
     */
    expand: "More options about Row {{rowIndex}}, {{header}}: {{cellValue}}",
    /**
     * The label for a table cell inside a draggable row (for screen reader / braille display only).
     * {{rowIndex}} is the number of current row.
     * {{header}} is the current column header name.
     * {{cellValue}} is the value of current cell.
     * For example: Change order of Row 3, Age: 24.
     */
    dragRow: "Change order of Row {{rowIndex}}, {{header}}: {{cellValue}}",
    /**
     * The label for sorting a table by a specified column (for screen reader / braille display only)
     * {{header}} is the current column header name.
     */
    sortLabel: "Sort {{header}}",
    /**
     * The state for a column of table, which is currently sorted in descending order (for screen reader / braille display only)
     * {{header}} is the current column header name.
     */
    sortInDesc: "Sort {{header}} in descending order",
    /**
     * The state for a column of table, which is currently sorted in ascending order (for screen reader / braille display only)
     * {{header}} is the current column header name.
     */
    sortInAsc: "Sort {{header}} in ascending order",
    /** Click to sort by a specified column in descending order */
    triggerDesc: "Click to sort descending",
    /** Click to sort by a specified column in ascending order */
    triggerAsc: "Click to sort ascending",
    /** Click to cancel sorting of a specified column */
    cancelSort: "Click to cancel sorting",
    /** Click to select all rows in a table */
    toggleSelectAll: "Select all",
    /**
     * The label for a table cell, in which user can click to select the row (for screen reader / braille display only).
     * {{rowIndex}} is the number of current row.
     * {{header}} is the current column header name.
     * {{cellValue}} is the value of current cell.
     * For example: Select Row 3, User name: Bob.
     */
    toggleSelectRow: "Select Row {{rowIndex}}, {{header}}: {{cellValue}}",
    /**
     * The label for a table cell, in which user can click to select the row, where only one selection is acceptable (for screen reader / braille display only).
     * {{rowIndex}} is the number of current row.
     * {{header}} is the current column header name.
     * {{cellValue}} is the value of current cell.
     * For example: Select Row 3, User name: Bob (2 of 5).
     */
    toggleSingleSelect: "Select Row {{rowIndex}}, {{header}}: {{cellValue}}",
    /** Click to show all hidden columns of a table */
    showAll: "Show all",
    /** Click to reset all columns of a table to default settings */
    reset: "Reset",
    /** Click to confirm column settings of a table */
    confirm: "Confirm",
    /** The title of column settings of a table */
    columnSetting: "Column setting",
    /** The placeholder for blank cells of a table */
    blank: "blank"
  },
  Tag: {
    /**
     * Click to remove a label from a list.
     * {{label}} is the content of the label.
     * For example (in a color palette): Remove “Red”
     */
    remove: "Remove “{{label}}”"
  },
  Breadcrumbs: {
    /** Click to view more items in a truncated breadcrumb menu list */
    expand: "View more breadcrumbs",
    /** The cue for a list being a breadcrumb navigation menu (for screen reader / braille display only) */
    navLabel: "Breadcrumb"
  },
  Empty: {
    /** The label when there is no results in the page */
    noResults: "No results"
  },
  ColorPicker: {
    /** Click to confirm an action */
    ok: "OK",
    /** Click to add new color */
    add: "Add",
    /** Click to cancel an action */
    cancel: "Cancel",
    /** Click to edit an action */
    edit: "Edit",
    /** Name a color in a palette */
    nameLabel: "Name this color",
    /** Placeholder of a color's name */
    namePlaceholder: "Color name",
    /** A transparent color */
    transparent: "Transparent",
    /** The name of color white */
    white: "White",
    /** The name of color light gray */
    lightGray: "Light gray",
    /** The name of color gray */
    gray: "Gray",
    /** The name of color dark gray */
    darkGray: "Dark gray",
    /** The name of color black */
    black: "Black",
    /** The name of color light red */
    lightRed: "Light red",
    /** The name of color light orange */
    lightOrange: "Light orange",
    /** The name of color light yellow */
    lightYellow: "Light yellow",
    /** The name of color light green */
    lightGreen: "Light green",
    /** The name of color light blue */
    lightBlue: "Light blue",
    /** The name of color light purple */
    lightPurple: "Light purple",
    /** The name of color red */
    red: "Red",
    /** The name of color orange */
    orange: "Orange",
    /** The name of color yellow */
    yellow: "Yellow",
    /** The name of color green */
    green: "Green",
    /** The name of color blue */
    blue: "Blue",
    /** The name of color purple */
    purple: "Purple",
    /** The name of color dark red */
    darkRed: "Dark red",
    /** The name of color dark orange */
    darkOrange: "Dark orange",
    /** The name of color dark yellow */
    darkYellow: "Dark yellow",
    /** The name of color dark green */
    darkGreen: "Dark green",
    /** The name of color dark blue */
    darkBlue: "Dark blue",
    /** The name of color dark purple */
    darkPurple: "Dark purple",
    /** The title of the button to add color  */
    addColor: "Add color",
    /** The tip message of the tooltip for the Input of color name */
    colorNameTip: "Give your color swatch a name for those who are using a screen reader.",
    /** The tip message of the label for learning more about information */
    learnMore: "Learn more about information"
  },
  DatePicker: {
    /** Weekday names, separated by the comma (","), and start from Sunday */
    weekdayNames: "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
    /** Weekday names in short date format, separated by the comma (","), and start from Sunday */
    weekdayNamesShort: "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    /** (Commonly one-letter) weekday abbreviations used as the header of a calendar, separated by the comma (","), and start from Sunday */
    weekdayNamesAbbr: "S,M,T,W,T,F,S",
    /** Month names, separated by the comma (","), and start from January */
    monthNames: "January,February,March,April,May,June,July,August,September,October,November,December",
    /** Month names in short date format, separated by the comma (","), and start from January */
    monthNamesShort: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    /** The date format for presenting a specified year */
    yearFormat: "yyyy",
    /** The date format for presenting a specified year and month */
    yearMonthFormat: "MMMM yyyy",
    /** The date format for a specified year and month, in separated part */
    yearMonthFormatSeparated: "{{month}} {{year}}",
    /** The date format for presenting a specified date */
    dateFormat: "MM/dd/yyyy",
    /** Medium date format for presenting a specified date */
    mediumDateFormat: "MMM dd yyyy",
    /** Long date format for presenting a specified date */
    longDateFormat: "dddd MMM dd yyyy",
    /** Click to navigate to the previous month */
    previousMonth: "Previous month",
    /** Click to navigate to the next month */
    nextMonth: "Next month",
    /** Click to navigate to the previous year */
    previousYear: "Previous year",
    /** Click to navigate to the next year */
    nextYear: "Next year",
    /** Click to navigate to the previous decade */
    previousDecade: "Previous decade",
    /** Click to navigate to the next decade */
    nextDecade: "Next decade",
    /** Cue for a date that is selected (for screen reader / braille display only) */
    selected: "selected",
    /** Cue for a date that is the start date of user's selection (for screen reader / braille display only) */
    startDate: "start date",
    /** Cue for a date that is the end date of user's selection (for screen reader / braille display only) */
    endDate: "end date",
    /** Cue for a date that is in the user's selection range (for screen reader / braille display only) */
    inSelection: "in selection range",
    /** Default placeholder copy for the input of DatePicker  */
    selectDate: "Select date",
    /** Default placeholder copy for the start date input of DateTimePicker  */
    selectDateTime: "Select date and time",
    /** Default placeholder copy for the start date input of MonthPicker  */
    selectMonth: "Select month",
    /** Default placeholder copy for the start date input of YearPicker  */
    selectYear: "Select year",
    /** Default placeholder copy for the start date input of DateRangePicker  */
    selectStartDate: "Start date",
    /** Default placeholder copy for the end date input of DateRangePicker  */
    selectEndDate: "End date",
    /** The am and pm label in 12-hour time formats, separated by a comma (",") */
    amPm: "am,pm",
    /** The default time format */
    timeFormat: "hh:mm A",
    /** The default date and time format */
    dateTimeFormat: "MM/dd/yyyy hh:mm A",
    /**
     * The cue for selected hour part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected hour of a time.
     * For example (when the user select the "8" of time 8:05:30): Hour 8
     */
    hourOrder: "Hour {{number}}",
    /**
     * The cue for selected minute part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected minute of a time.
     * For example (when the user select the "05" of time 8:05:30): Minute 5
     */
    minuteOrder: "Minute {{number}}",
    /** The cue for selected second part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected second of a time.
     * For example (when the user select the "30" of time 8:05:30): Second 30
     */
    secondOrder: "Second {{number}}",
    /** The first day of week in a calendar.
     * Must be a number from 0 to 6. 0 stands for Sunday, 1 stands for Monday and so on.
     */
    firstDayOfWeek: "0",
    /** Click to clear the content inside an input box */
    clear: "Clear"
  },
  EmojiPicker: {
    /** label for the recently used emojis */
    recent: "Frequently used",
    /** label for the emojis of People category */
    categoryPeople: "Smileys & People",
    /** label for the emojis of Nature category */
    categoryNature: "Animals & Nature",
    /** label for the emojis of Foods category */
    categoryFoods: "Food & Drink",
    /** label for the emojis of Activity category */
    categoryActivity: "Activity",
    /** label for the emojis of Places category */
    categoryPlaces: "Travel & Places",
    /** label for the emojis of Objects category */
    categoryObjects: "Objects",
    /** label for the emojis of Symbols category */
    categorySymbols: "Symbols",
    /** label for the emojis of Flags category */
    categoryFlags: "Flags",
    /** the placeholder for the search text box */
    search: "Search",
    /** label for the search results of emojis */
    searchResults: "Search results",
    /** label for skin tone of emoji */
    skinTone: "Skin tone"
  },
  TimePicker: {
    /** The am and pm label in 12-hour time formats, separated by a comma (",") */
    amPm: "am,pm",
    /** The default time format */
    timeFormat: "hh:mm A",
    /** The abbreviation for the hour part of a time, used in the header of a selector */
    hourAbbr: "h",
    /** The abbreviation for the minute part of a time, used in the header of a selector */
    minuteAbbr: "min",
    /** The abbreviation for the second part of a time, used in the header of a selector */
    secondAbbr: "s",
    /** The label for the hour list */
    hour: "Hour",
    /** The label for the minute list */
    minute: "Minute",
    /** The label for the second list */
    second: "Second",
    /** The label for the period (AM/PM) list */
    period: "Period",
    /**
     * The cue for selected hour part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected hour of a time.
     * For example (when the user select the "8" of time 8:05:30): Hour 8
     */
    hourOrder: "Hour {{number}}",
    /**
     * The cue for selected minute part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected minute of a time.
     * For example (when the user select the "05" of time 8:05:30): Minute 5
     */
    minuteOrder: "Minute {{number}}",
    /** The cue for selected second part of a time (for screen reader / braille display only).
     * {{number}} is the user-selected second of a time.
     * For example (when the user select the "30" of time 8:05:30): Second 30
     */
    secondOrder: "Second {{number}}",
    /** Default placeholder copy for the input of TimePicker  */
    selectTime: "Select time"
  },
  VideoClipper: {
    /** Label for the media play button */
    play: "Play",
    /** Label for the media pause button */
    pause: "Pause",
    /** Role of a video progress bar, indicating the control is draggable to seek to a time of the video. */
    progressBar: "progress bar",
    /**
     * The label for a media progress bar.
     * {{current}} is the current time.
     * {{duration}} is the total duration of the media.
     * For example (when a 3-minute media plays to minute 1): 1:00 of 3:00
     */
    progressLabel: "{{current}} of {{duration}}",
    /** The tip for a keyboard user for a playhead for video clippers with single segment. */
    singlePlayheadDescription: "press Space to play from the section",
    /** The tip for a keyboard user for a playhead for video clippers with multiple segments. */
    multiplePlayheadDescription: "press Enter to add a new section, press Space to play from the nearest section",
    /**
     * The tip when a user trying to add a clip section when there is already one.
     * {{start}} is the start time of current clip section.
     * {{end}} is the end time of current clip section.
     * For example (when the user tries to add a clip section at 5:00): There is already clip here at 4:00 to 6:00
     */
    existingSection: "There is already clip here at {{start}} to {{end}}",
    /** The label for a list of video clip sections. */
    clipSections: "clip sections",
    /** The label for a video clip section. */
    clipSection: "clip section",
    /**
     * The label for a video clip section in a list.
     * {{order}} is the order number of the section.
     * For example (when the user selected the second section in a video section list): section 2
     */
    clipSectionOrder: "section {{order}}",
    /** The label for the leading edge (start point) of a video segment. User can drag this control to adjust the start time of a video clip. */
    leadingEdge: "start position",
    /** The label for the trailing edge (end point) of a video segment. User can drag this control to adjust the end time of a video clip. */
    trailingEdge: "end position",
    /** Label for a button to remove a section from the video section list. */
    removeSection: "remove section",
    /** Click to trim a video. */
    trim: "Trim",
    /**
     * The cue for a new section of video was added at a specified time on the video track.
     * {{timecode}} is the mm:ss format time code, for the time of video where the section is added.
     * For example (when the user add a video section at one minute of the track): new section added at 01:00
     */
    sectionAdded: "new section added at {{timecode}}"
  },
  Coachmark: {
    /** Click to show the next step of tutorial */
    next: "Next",
    /** Click to show the previous step of tutorial */
    previous: "Previous",
    /** Click to finish and close the tutorial */
    finish: "Finish",
    /**
     * Indicator for the current step.
     * {{current}} is the order of current step.
     * {{total}} is the number of steps in total.
     * For example: step 2 of 4
     */
    indicatorAriaLabel: "step {{current}} of {{total}}"
  },
  Carousel: {
    /** Click to switch to the previous carousel page */
    prevSlide: "Previous carousel page",
    /** Click to switch to the next carousel page */
    nextSlide: "Next carousel page",
    /** Click to start auto scrolling of the carousel */
    play: "Start auto scroll",
    /** Click to pause auto scrolling of the carousel */
    pause: "Pause auto scroll",
    /** The cue for a list being a carousel list (for screen reader / braille display only) */
    carouselRole: "carousel list",
    /**
     * The cue for the total item count and current item of a carousel (for screen reader / braille display only).
     * {{number}} is the order of current item.
     * {{total}} is the number of items in total.
     * For example: 2 of 4.
     */
    itemOrder: "{{number}} of {{total}}.",
    /** The cue for arrow key instruction of keyboard navigation (for screen reader / braille display only) */
    navigateViaArrowKeys: "Press arrow keys to move.",
    /** The cue for tab key instruction of keyboard navigation (for screen reader / braille display only) */
    interactiveElementsAvailable: "Press Tab for more interactive elements.",
    /**
     * Click to go to a specified page of a carousel (for screen reader / braille display only).
     * {{number}} is the number of page.
     * For example: Page 2
     */
    slideOrder: "Page {{number}}",
    /** The cue for the total page count and current page of a carousel (for screen reader / braille display only).
     * {{number}} is the order of current page.
     * {{total}} is the number of pages in total.
     * For example: Page 2 of 4
     */
    slideOrderWithTotal: "Page {{number}} of {{total}}"
  },
  FileUploader: {
    /** The title indicating user can upload a file */
    title: "File upload",
    /** The description of allowed file size and types to upload */
    description: "Max file size is 50MB. Supported file types are JPG, PNG, Video, and PDF.",
    /** Click to upload the file */
    uploadButton: "Upload",
    /** Instructions drag-and-drop a file or press the button to choose a file to upload.
     * {{chooseFileButton}} is the button to choose a file for the alternative way to upload.
     * For example: Drag and drop files or [Choose files]
     */
    dragDescription: "Drag and drop files or {{chooseFileButton}}",
    /** Click to choose a file to upload */
    chooseFile: "Choose files",
    /** Error message when the user uploaded an unaccepted type of file */
    acceptErrorMessage: "Unaccepted type.",
    /** Error message when the user uploaded an oversized file */
    limitSizeErrorMessage: "File exceeds size limit.",
    /** Error message when the user tries to upload multiple files while only one is accepted */
    multipleErrorMessage: "You can't select multiple files to upload.",
    /** Error message when the user tries to upload files more than we can accept */
    maxCountErrorMessage: "Exceeded maximum count of files",
    /** Remove the file with the specified file name
     * {{fileName}} is the full name of the file to be removed
     * For example: Remove file helloworld.jpg
     */
    removeFile: "Remove file {{fileName}}"
  },
  Tabs: {
    /** Press to switch to the previous tab page */
    previous: "Scroll to previous page of tabs",
    /** Press to switch to the next tab page */
    next: "Scroll to next page of tabs",
    /** scrolled the tab list to the previous */
    scrolledPrevious: "Scrolled to previous page",
    /** scrolled the tab list to the next */
    scrolledNext: "Scrolled to next page"
  },
  Form: {
    /** Label for an optional form field */
    optional: "Optional",
    /** button with tooltip for learn more information with complex label(label is not string) */
    learnMore: "Learn more",
    /** button with tooltip for learn more information with label */
    learnMoreWithName: "Learn more about {{name}}"
  },
  MediaControls: {
    /** Label for the media play button */
    play: "Play",
    /** Label for the media pause button */
    pause: "Pause",
    /** Label for the media volume button */
    volume: "Volume",
    /** Label for the media playback rate button */
    rate: "Rate"
  },
  VideoControls: {
    /** Label for the video full screen button */
    fullScreen: "Full screen"
  }
}, pX = {
  "en-US": dX
};
function fX() {
  return pX;
}
function mX() {
  return "en-US";
}
const Ch = mX(), vS = fX();
function Sh(e, t, r, o) {
  const a = o ? e[o] ?? {} : e;
  return (l, c) => {
    const d = ps(a, l) || "";
    if ((process.env.NODE_ENV === void 0 || process.env.NODE_ENV === "development") && (d || console.warn(`The locale key ${o ? `${o}.` : ""}${l} is not defined.`)), !c)
      return t ? [d] : d;
    if (t) {
      const p = [];
      return d.split(/\{\{([^}]+)\}\}/g).forEach((f, h) => {
        f && (r ? h % 2 ? p.push(N.createElement(N.Fragment, { key: h }, c[f])) : p.push(N.createElement(N.Fragment, { key: h }, f)) : h % 2 ? p.push(c[f]) : p.push(f));
      }), p;
    }
    return d.replace(/\{\{([^}]+)\}\}/g, (p, f) => `${c[f]}`);
  };
}
function ua(e) {
  const t = Yr(), r = t?.zoomUI?.localeMap, o = t?.zoomUI?.localeKey ?? Ch, a = ra(() => JY({}, vS[Ch], r?.[Ch], vS[o], r?.[o], (l, c) => c === "" ? l : void 0), [o, r]);
  return ra(() => ({
    t: Sh(a, !1, !1, e),
    translateArray: Sh(a, !0, !1, e),
    translateElement: Sh(a, !0, !0, e)
  }), [a, e]);
}
const Ep = {
  extraSmall: "20px",
  small: "24px",
  medium: "32px",
  large: "40px",
  extraLarge: "110px"
};
function x4(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontFamily: r.fontFamily,
    backgroundColor: "transparent",
    height: Ep,
    width: Ep,
    fontSize: {
      extraSmall: "10px",
      small: "10px",
      medium: "12px",
      large: "14px",
      extraLarge: "36px"
    },
    fontWeight: {
      extraSmall: r.fontWeight.label,
      small: r.fontWeight.label,
      medium: r.fontWeight.subtitleBold,
      large: r.fontWeight.bodyBold,
      extraLarge: r.fontWeight.display1
    },
    borderRadius: {
      extraSmall: "8px",
      small: "8px",
      medium: "10px",
      large: "14px",
      extraLarge: "38px"
    },
    color: t.inverse.global.default,
    background: {
      primary: {
        default: t.fill.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      secondary: {
        default: t.fill.error,
        hover: t.state.error.hover,
        active: t.state.error.press
      }
    },
    mask: {
      backgroundColor: {
        hover: t.state.hover,
        press: t.state.press,
        inactive: t.state.inactive
      }
    },
    status: {
      backgroundColor: t.bg.default,
      scale: {
        extraSmall: 1,
        small: 1,
        medium: 1,
        large: 1.5,
        extraLarge: 3
      }
    },
    outline: {
      focusVisible: `2px solid ${t.border.primary}`
    },
    initialColors: [
      t.fill.global.success,
      t.fill.global.supplementary1,
      t.fill.global.supplementary2,
      t.fill.global.supplementary3,
      t.fill.global.neutral,
      t.fill.global.complementary,
      t.fill.global.warning,
      t.fill.global.error
    ]
  };
}
const Jy = (e) => {
  let t = 0;
  const r = Object.entries(Ep).sort((a, i) => parseInt(a[1], 10) - parseInt(i[1], 10));
  let o = 0;
  for (o = 0; o < r.length; o++) {
    const a = r[o];
    o > 0 && (t = parseInt(r[o - 1][1], 10));
    const i = parseInt(a[1], 10);
    if (o === 0) {
      if (e <= i)
        return a[0];
    } else {
      if (e > i)
        continue;
      const l = (i + t) / 2;
      return e <= l ? r[o - 1][0] : a[0];
    }
  }
  return r[o - 1][0];
}, vs = (e) => typeof e != "number", Op = (e) => !(vs(e) && e !== "extraLarge"), hX = (e) => vs(e) ? parseInt(Ep[e], 10) : e, C4 = 32, rp = 12 / C4, gX = 10 / C4, wh = [
  { size: 24, borderRadius: "8px", fontSize: "10px" },
  // small All Prism design
  { size: 32, borderRadius: "10px", fontSize: "12px" },
  // medium All Prism design
  { size: 40, borderRadius: "14px", fontSize: "14px" },
  // large All Prism design
  { size: 48, borderRadius: "16px", fontSize: `${48 * rp}px` },
  { size: 64, borderRadius: "22px", fontSize: `${64 * rp}px` },
  { size: 80, borderRadius: "26px", fontSize: `${80 * rp}px` },
  { size: 110, borderRadius: "36px", fontSize: "36px" }
  // extraLarge All Prism design
];
function bX(e) {
  return `${Math.max(Math.floor(e * rp), 10)}px`;
}
function yX(e) {
  return `${Math.max(Math.floor(e * gX), 8)}px`;
}
function vX(e) {
  if (!(typeof e == "number" && e > 0))
    return {
      borderRadius: wh[1].borderRadius,
      fontSize: wh[1].fontSize
    };
  const t = wh.find((r) => r.size === e);
  return t ? {
    borderRadius: t.borderRadius,
    fontSize: t.fontSize
  } : {
    borderRadius: yX(e),
    fontSize: bX(e)
  };
}
const S4 = {
  away: "away",
  block: "block",
  busy: "busy",
  online: "online",
  offline: "offline",
  mobile: "mobile",
  inCall: "inCall",
  inMeeting: "inMeeting",
  outOfOffice: "outOfOffice",
  doNotDisturb: "doNotDisturb",
  inACalendarEvent: "inACalendarEvent"
}, w4 = {
  small: {
    circle: "M17.3447 0.171919C17.1222 0.738147 17 1.3548 17 2C17 4.76142 19.2386 7 22 7C22.6452 7 23.2619 6.87779 23.8281 6.65527C24 7.91147 24 9.5547 24 12C24 15.7275 24 17.5913 23.391 19.0615C22.5791 21.0217 21.0217 22.5791 19.0615 23.391C17.5913 24 15.7275 24 12 24C8.27247 24 6.4087 24 4.93853 23.391C2.97831 22.5791 1.42092 21.0217 0.608964 19.0615C0 17.5913 0 15.7275 0 12C0 8.27247 0 6.4087 0.608964 4.93853C1.42092 2.97831 2.97831 1.42092 4.93853 0.608964C6.4087 0 8.27247 0 12 0C14.4453 0 16.0885 4.49367e-07 17.3447 0.171919Z",
    mobile: "M18 0.285043V4.5C18 5.88071 19.1193 7 20.5 7H23.5C23.6247 7 23.7473 6.99087 23.8671 6.97324C24 8.18714 24 9.75577 24 12C24 15.7275 24 17.5913 23.391 19.0615C22.5791 21.0217 21.0217 22.5791 19.0615 23.391C17.5913 24 15.7275 24 12 24C8.27247 24 6.4087 24 4.93853 23.391C2.97831 22.5791 1.42092 21.0217 0.608964 19.0615C0 17.5913 0 15.7275 0 12C0 8.27247 0 6.4087 0.608964 4.93853C1.42092 2.97831 2.97831 1.42092 4.93853 0.608964C6.4087 0 8.27247 0 12 0C14.8942 0 16.6648 1.44969e-08 18 0.285043Z",
    camera: "M18.4416 6.9709C18.0099 6.94056 17.6017 6.87509 17.2071 6.70611C16.3472 6.33789 15.6621 5.65277 15.2939 4.79289C15.1249 4.39828 15.0594 3.99011 15.0291 3.55843C15 3.14403 15 2.63901 15 2.0347V2.03466V1.96531V1.96527C15 1.36096 15 0.855975 15.0291 0.44157C15.0391 0.298727 15.053 0.158459 15.0732 0.020404C14.2097 8.86696e-08 13.2017 0 12 0C8.27247 0 6.4087 0 4.93853 0.608964C2.97831 1.42092 1.42092 2.97831 0.608964 4.93853C0 6.4087 0 8.27247 0 12C0 15.7275 0 17.5913 0.608964 19.0615C1.42092 21.0217 2.97831 22.5791 4.93853 23.391C6.4087 24 8.27247 24 12 24C15.7275 24 17.5913 24 19.0615 23.391C21.0217 22.5791 22.5791 21.0217 23.391 19.0615C24 17.5913 24 15.7275 24 12C24 9.18833 24 7.43708 23.7387 6.1153C23.458 6.35756 23.1397 6.55761 22.7929 6.70611C22.3983 6.87509 21.9901 6.94056 21.5584 6.9709C21.144 7.00002 20.639 7.00001 20.0347 7H19.9653C19.361 7.00001 18.856 7.00002 18.4416 6.9709Z",
    phone: "M17.0413 0.134502C15.8254 1.10965e-06 14.2532 0 12 0C8.27247 0 6.4087 0 4.93853 0.608964C2.97831 1.42092 1.42092 2.97831 0.608964 4.93853C0 6.4087 0 8.27247 0 12C0 15.7275 0 17.5913 0.608964 19.0615C1.42092 21.0217 2.97831 22.5791 4.93853 23.391C6.4087 24 8.27247 24 12 24C15.7275 24 17.5913 24 19.0615 23.391C21.0217 22.5791 22.5791 21.0217 23.391 19.0615C24 17.5913 24 15.7275 24 12C24 9.74678 24 8.17458 23.8655 6.95866C20.2691 6.58564 17.4142 3.7306 17.0413 0.134502Z",
    calendar: "M17.0238 0.132576C15.8103 -8.72716e-08 14.2424 0 12 0C8.27247 0 6.4087 0 4.93853 0.608964C2.97831 1.42092 1.42092 2.97831 0.608964 4.93853C0 6.4087 0 8.27247 0 12C0 15.7275 0 17.5913 0.608964 19.0615C1.42092 21.0217 2.97831 22.5791 4.93853 23.391C6.4087 24 8.27247 24 12 24C15.7275 24 17.5913 24 19.0615 23.391C21.0217 22.5791 22.5791 21.0217 23.391 19.0615C24 17.5913 24 15.7275 24 12C24 9.64742 24 8.03724 23.8469 6.79985C23.778 6.8 23.7077 6.79999 23.6361 6.79999H20.3639C19.9748 6.80001 19.6247 6.80003 19.3334 6.77623C19.0214 6.75074 18.6899 6.69305 18.365 6.5275C17.8946 6.28782 17.5121 5.90537 17.2725 5.43496C17.1069 5.11006 17.0492 4.77859 17.0237 4.46662C16.9999 4.17532 17 3.8252 17 3.43614V1.1639C17 0.774837 16.9999 0.424659 17.0237 0.133359C17.0238 0.133098 17.0238 0.132837 17.0238 0.132576Z"
  },
  medium: {
    circle: "M25.2071 0.571385C25.0723 1.02405 25 1.50358 25 2C25 4.76142 27.2386 7 30 7C30.4964 7 30.976 6.92765 31.4286 6.79293C32 8.78895 32 11.4842 32 16C32 21.6005 32 24.4008 30.9101 26.5399C29.9513 28.4215 28.4215 29.9513 26.5399 30.9101C24.4008 32 21.6005 32 16 32C10.3995 32 7.59921 32 5.46009 30.9101C3.57847 29.9513 2.04867 28.4215 1.08993 26.5399C0 24.4008 0 21.6005 0 16C0 10.3995 0 7.59921 1.08993 5.46009C2.04867 3.57847 3.57847 2.04867 5.46009 1.08993C7.59921 0 10.3995 0 16 0C20.5158 0 23.2111 1.60163e-06 25.2071 0.571385Z",
    mobile: "M26 0.843535V4.5C26 5.88071 27.1193 7 28.5 7H31.4852C32 8.97523 32 11.6384 32 16C32 21.6005 32 24.4008 30.9101 26.5399C29.9513 28.4215 28.4215 29.9513 26.5399 30.9101C24.4008 32 21.6005 32 16 32C10.3995 32 7.59921 32 5.46009 30.9101C3.57847 29.9513 2.04867 28.4215 1.08993 26.5399C0 24.4008 0 21.6005 0 16C0 10.3995 0 7.59921 1.08993 5.46009C2.04867 3.57847 3.57847 2.04867 5.46009 1.08993C7.59921 0 10.3995 0 16 0C21.142 0 23.9235 2.60517e-08 26 0.843535Z",
    camera: "M26.4416 6.9709C26.0099 6.94056 25.6017 6.87509 25.2071 6.70611C24.3472 6.33789 23.6621 5.65277 23.2939 4.79289C23.1249 4.39828 23.0594 3.99011 23.0291 3.55843C23 3.14402 23 2.63899 23 2.03466V1.96531C23 1.36099 23 0.855984 23.0291 0.44157C23.0353 0.353779 23.0429 0.266961 23.0525 0.181031C21.311 2.10681e-06 19.0785 0 16 0C10.3995 0 7.59921 0 5.46009 1.08993C3.57847 2.04867 2.04867 3.57847 1.08993 5.46009C0 7.59921 0 10.3995 0 16C0 21.6005 0 24.4008 1.08993 26.5399C2.04867 28.4215 3.57847 29.9513 5.46009 30.9101C7.59921 32 10.3995 32 16 32C21.6005 32 24.4008 32 26.5399 30.9101C28.4215 29.9513 29.9513 28.4215 30.9101 26.5399C32 24.4008 32 21.6005 32 16C32 11.2046 32 8.46218 31.3158 6.42996C31.1503 6.5354 30.9755 6.6279 30.7929 6.70611C30.3983 6.87509 29.9901 6.94056 29.5584 6.9709C29.144 7.00002 28.639 7.00001 28.0347 7H27.9653C27.361 7.00001 26.856 7.00002 26.4416 6.9709Z",
    phone: "M25.0943 0.539903C23.1095 9.05817e-07 20.4313 0 16 0C10.3995 0 7.59921 0 5.46009 1.08993C3.57847 2.04867 2.04867 3.57847 1.08993 5.46009C0 7.59921 0 10.3995 0 16C0 21.6005 0 24.4008 1.08993 26.5399C2.04867 28.4215 3.57847 29.9513 5.46009 30.9101C7.59921 32 10.3995 32 16 32C21.6005 32 24.4008 32 26.5399 30.9101C28.4215 29.9513 29.9513 28.4215 30.9101 26.5399C32 24.4008 32 21.6005 32 16C32 11.5686 32 8.89042 31.4601 6.90568C28.1904 6.38944 25.6104 3.80935 25.0943 0.539903Z",
    calendar: "M25.0049 0.516086C23.0292 7.52193e-07 20.3652 0 16 0C10.3995 0 7.59921 0 5.46009 1.08993C3.57847 2.04867 2.04867 3.57847 1.08993 5.46009C0 7.59921 0 10.3995 0 16C0 21.6005 0 24.4008 1.08993 26.5399C2.04867 28.4215 3.57847 29.9513 5.46009 30.9101C7.59921 32 10.3995 32 16 32C21.6005 32 24.4008 32 26.5399 30.9101C28.4215 29.9513 29.9513 28.4215 30.9101 26.5399C32 24.4008 32 21.6005 32 16C32 11.4895 32 8.7953 31.4306 6.79999H28.3639C27.9748 6.80001 27.6247 6.80003 27.3334 6.77623C27.0214 6.75074 26.6899 6.69305 26.365 6.5275C25.8946 6.28782 25.5121 5.90537 25.2725 5.43496C25.1069 5.11006 25.0492 4.77859 25.0237 4.46662C24.9999 4.17532 25 3.8252 25 3.43614V1.1639C25 0.932853 25 0.715519 25.0049 0.516086Z"
  },
  large: {
    circle: "M30.3847 0.705562C30.1354 1.42436 30 2.19637 30 3C30 6.86599 33.134 10 37 10C37.8036 10 38.5756 9.86458 39.2944 9.6153C40 11.8214 40 14.6108 40 20C40 25.5858 40 28.3787 39.2144 30.6239C37.8072 34.6454 34.6454 37.8072 30.6239 39.2144C28.3787 40 25.5858 40 20 40C14.4142 40 11.6213 40 9.37609 39.2144C5.35464 37.8072 2.1928 34.6454 0.785633 30.6239C0 28.3787 0 25.5858 0 20C0 14.4142 0 11.6213 0.785633 9.37609C2.1928 5.35464 5.35464 2.1928 9.37609 0.785633C11.6213 0 14.4142 0 20 0C25.3892 0 28.1786 -8.64474e-08 30.3847 0.705562Z",
    mobile: "M31.5 1.12555V6.5C31.5 8.433 33.039 10 34.9375 10H39.0625C39.1778 10 39.2917 9.99422 39.404 9.98294C40 12.1344 40 14.9056 40 20C40 25.5858 40 28.3787 39.2144 30.6239C37.8072 34.6454 34.6454 37.8072 30.6239 39.2144C28.3787 40 25.5858 40 20 40C14.4142 40 11.6213 40 9.37609 39.2144C5.35464 37.8072 2.1928 34.6454 0.785633 30.6239C0 28.3787 0 25.5858 0 20C0 14.4142 0 11.6213 0.785633 9.37609C2.1928 5.35464 5.35464 2.1928 9.37609 0.785633C11.6213 0 14.4142 0 20 0C25.5858 0 28.3787 0 30.6239 0.785633C30.9207 0.8895 31.2129 1.00293 31.5 1.12555Z",
    camera: "M31.9165 9.95925C31.2999 9.91678 30.7168 9.82512 30.153 9.58855C28.9246 9.07304 27.9459 8.11387 27.4198 6.91004C27.1784 6.35759 27.0849 5.78615 27.0416 5.1818C27 4.60163 27 3.89459 27 3.04854V3.04852V2.95144V2.95142C27 2.10537 27 1.39837 27.0416 0.818197C27.0582 0.586047 27.0823 0.358753 27.1193 0.135526C25.3535 -7.91679e-08 23.1095 0 20 0C14.4142 0 11.6213 0 9.37609 0.785633C5.35464 2.1928 2.1928 5.35464 0.785633 9.37609C0 11.6213 0 14.4142 0 20C0 25.5858 0 28.3787 0.785633 30.6239C2.1928 34.6454 5.35464 37.8072 9.37609 39.2144C11.6213 40 14.4142 40 20 40C25.5858 40 28.3787 40 30.6239 39.2144C34.6454 37.8072 37.8072 34.6454 39.2144 30.6239C40 28.3787 40 25.5858 40 20C40 14.4142 40 11.6213 39.2144 9.37609C39.177 9.26929 39.1384 9.1631 39.0986 9.05753C38.799 9.26622 38.4756 9.44466 38.1327 9.58855C37.569 9.82512 36.9859 9.91678 36.3692 9.95925C35.7772 10 35.0557 10 34.1924 10H34.0933C33.23 10 32.5086 10 31.9165 9.95925Z",
    phone: "M30.0837 0.614697C27.9228 1.29232e-06 25.1471 0 20 0C14.4142 0 11.6213 0 9.37609 0.785633C5.35464 2.1928 2.1928 5.35464 0.785633 9.37609C0 11.6213 0 14.4142 0 20C0 25.5858 0 28.3787 0.785633 30.6239C2.1928 34.6454 5.35464 37.8072 9.37609 39.2144C11.6213 40 14.4142 40 20 40C25.5858 40 28.3787 40 30.6239 39.2144C34.6454 37.8072 37.8072 34.6454 39.2144 30.6239C40 28.3787 40 25.5858 40 20C40 14.8528 40 12.0771 39.3853 9.91623C34.5325 9.30888 30.6909 5.46703 30.0837 0.614697Z",
    calendar: "M30.0245 0.598062C27.8721 2.27585e-06 25.1003 0 20 0C14.4142 0 11.6213 0 9.37609 0.785633C5.35464 2.1928 2.1928 5.35464 0.785633 9.37609C0 11.6213 0 14.4142 0 20C0 25.5858 0 28.3787 0.785633 30.6239C2.1928 34.6454 5.35464 37.8072 9.37609 39.2144C11.6213 40 14.4142 40 20 40C25.5858 40 28.3787 40 30.6239 39.2144C34.6454 37.8072 37.8072 34.6454 39.2144 30.6239C40 28.3787 40 25.5858 40 20C40 14.9191 40 12.149 39.4087 9.99999C39.3696 10 39.3302 10 39.2905 10H34.7095C34.1647 10 33.6745 10.0001 33.2667 9.96606C32.8299 9.92964 32.3659 9.84723 31.911 9.61073C31.2524 9.26833 30.717 8.72197 30.3814 8.04996C30.1497 7.58581 30.0689 7.11228 30.0332 6.6666C29.9999 6.25046 29.9999 5.7503 30 5.1945V1.94843C29.9999 1.44585 29.9999 0.988687 30.0245 0.598062Z"
  }
}, T4 = {
  circle: "ui-Avatar-svg-extraLarge-circle",
  mobile: "ui-Avatar-svg-extraLarge-mobile",
  camera: "ui-Avatar-svg-extraLarge-camera",
  phone: "ui-Avatar-svg-extraLarge-phone",
  calendar: "ui-Avatar-svg-extraLarge-calendar"
}, $p = {
  away: "circle",
  block: "circle",
  busy: "circle",
  online: "circle",
  offline: "circle",
  mobile: "mobile",
  inCall: "phone",
  inMeeting: "camera",
  outOfOffice: "calendar",
  doNotDisturb: "circle",
  inACalendarEvent: "calendar"
}, E4 = "Avatar", In = "ui-Avatar", Zt = {
  container: `${In}-container-${to()}`,
  root: `${In}-root`,
  text: `${In}-text`,
  mask: `${In}-mask`,
  inactive: `${In}-inactive`,
  statusRoot: `${In}-status-root-${to()}`,
  statusBadge: `${In}-status-badge`,
  status: (e) => typeof e == "string" ? `${In}-status-${e}` : `${In}-status`,
  extrasSmall: `${In}-extrasSmall`,
  small: `${In}-small`,
  medium: `${In}-medium`,
  large: `${In}-large`,
  extraLarge: `${In}-extraLarge`,
  imageLoaded: `${In}-imageLoaded`
}, xX = (e, t) => {
  if (!t)
    return e[0];
  let r = 0;
  const { length: o } = e;
  for (let a = 0; a < t.length; a++)
    r += t.charCodeAt(a), r %= o;
  return e[r];
};
function CX(e, t) {
  const r = t.size ?? "medium", { status: o, color: a, backgroundColor: i } = t, l = x4(e), [c, d] = mn({
    componentName: E4,
    theme: e,
    dynamicToken: l
  }), p = vs(r) ? d(c.width[r]) : r, f = vs(r) ? d(c.height[r]) : r, h = vs(r) ? r : Jy(r);
  let g = "unset";
  !["extraSmall"].includes(h) && typeof o == "string" && S4[o] && (Op(r) ? g = `url('#${T4[$p[o]]}')` : g = `path('${w4[h][$p[o]]}')`);
  const y = typeof r == "number" ? vX(r) : null;
  return {
    [`&.${Zt.container}`]: {
      position: "relative",
      display: "inline-flex",
      height: f,
      width: p,
      borderRadius: d(c.borderRadius[h]),
      ...typeof r == "number" && y ? {
        borderRadius: y.borderRadius
      } : {},
      background: d(c.backgroundColor),
      overflow: "visible",
      flexShrink: 0,
      "&:focus-visible": {
        outline: d(c.outline.focusVisible),
        outlineOffset: 2
      },
      [`& .${Zt.root}`]: {
        color: typeof a == "string" && a ? a : d(c.color),
        backgroundColor: typeof i == "string" && i ? i : xX(c.initialColors, t.abbreviation),
        [`&.${Zt.imageLoaded}`]: {
          background: d(c.backgroundColor)
        }
      },
      [`.${Zt.mask}`]: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0,
        borderRadius: d(c.borderRadius[h]),
        ...typeof r == "number" && y ? {
          borderRadius: y.borderRadius
        } : {}
      },
      [`&.${Zt.inactive}`]: {
        [`.${Zt.mask}`]: {
          opacity: 1,
          background: d(c.mask.backgroundColor.inactive),
          clipPath: g
        }
      },
      [`&.${Zt.small}`]: {
        [`.${Zt.root}`]: {
          // lineHeight: 'unset',
          lineHeight: d(c.height[h])
        }
      },
      [`.${Zt.root}`]: {
        height: "100%",
        width: "100%",
        fontFamily: d(c.fontFamily),
        fontSize: d(c.fontSize[h]),
        fontWeight: d(c.fontWeight[h]),
        borderRadius: d(c.borderRadius[h]),
        ...typeof r == "number" && y ? {
          borderRadius: y.borderRadius,
          fontSize: y.fontSize
        } : {},
        clipPath: g
      }
    },
    [`button&.${Zt.container}`]: {
      appearance: "none",
      border: "none",
      padding: 0,
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#fff",
        [`.${Zt.mask}`]: {
          opacity: 1,
          background: d(c.mask.backgroundColor.hover),
          clipPath: g
        }
      },
      "&:active": {
        [`.${Zt.mask}`]: {
          opacity: 1,
          background: d(c.mask.backgroundColor.press),
          clipPath: g
        }
      }
    }
  };
}
function SX(e, t) {
  const r = t.size ?? "medium", o = vs(r) ? r : Jy(r), a = x4(e), [i] = mn({
    componentName: E4,
    theme: e,
    dynamicToken: a
  }), l = typeof t.status == "string" && S4[t.status], c = Op(r) ? (r === "extraLarge" ? 110 : r) / 32 : i.status.scale[o];
  let d = t.status === "inMeeting" ? "translate(32%, -25%)" : "translate(25%, -25%)";
  if (Op(r)) {
    const g = hX(r) / 40 * 12, y = c * (t.status === "inMeeting" ? 12 : 8), C = g - y;
    d = `translate(${Math.abs(C) * 100 / y}%, -10%)`;
  }
  const p = {
    minWidth: "unset",
    padding: 0,
    transform: `scale(${c}) ${d}`,
    zIndex: 0,
    height: "8px",
    svg: {
      width: "8px",
      height: "8px"
    },
    [`&.${Zt.status("inMeeting")}`]: {
      svg: {
        height: "8px",
        width: "12px"
      }
    }
  };
  return l || (p.transform = "unset"), {
    [`&.${Zt.statusRoot}`]: {
      width: "100%",
      height: "100%",
      margin: 0,
      [`& .${Zt.statusBadge}`]: {
        ...p
      }
    }
  };
}
const O4 = (e) => {
  if (!e)
    return "";
  const t = e.toUpperCase().trim().split(/\s+/, 2).filter((r) => !!r);
  if (t.length === 1)
    return t[0][0];
  if (t.length >= 1) {
    const r = t[0][0] + t[1][0];
    return /[\u4E00-\u9FA5]+/.test(e) ? t[0][0] : r;
  }
  return "";
}, wX = OI(({ status: e }) => {
  switch (e) {
    case "online":
      return N.createElement(qZ, null);
    case "offline":
      return N.createElement(GZ, null);
    case "mobile":
      return N.createElement(HZ, null);
    case "inCall":
      return N.createElement(WZ, null);
    case "inMeeting":
      return N.createElement(UZ, null);
    case "outOfOffice":
      return N.createElement(KZ, null);
    case "doNotDisturb":
      return N.createElement(FZ, null);
    case "inACalendarEvent":
      return N.createElement(VZ, null);
    case "away":
      return N.createElement(AZ, null);
    case "block":
      return N.createElement(IZ, null);
    case "busy":
      return N.createElement(NZ, null);
    default:
      return null;
  }
}), xS = Y(Hb)((e) => {
  const { theme: t, size: r, status: o } = e;
  return SX(t, { status: o, size: r });
}), Th = (e) => {
  const { children: t, src: r, displayName: o } = e, a = {
    root: Zt.root
  };
  let i;
  o && (i = O4(o));
  const [l, c] = Ir(!1), [d, p] = Ir(!1), f = {
    ...r ? {
      img: {
        onLoad: () => {
          c(!0), p(!1);
        },
        onError: () => {
          p(!0), c(!1);
        }
      }
    } : {}
  };
  return Dn(() => {
    r || (c(!1), p(!1));
  }, [r]), t ? N.createElement(
    N.Fragment,
    null,
    N.createElement(gl, { variant: "rounded", classes: a, "aria-hidden": !0, slotProps: f, className: ot({ [Zt.imageLoaded]: l }) }, t),
    N.createElement(Tt, { className: Zt.mask })
  ) : !r && i || r && d && i ? N.createElement(
    N.Fragment,
    null,
    N.createElement(gl, { variant: "rounded", classes: a, "aria-hidden": !0, slotProps: f, className: ot({ [Zt.imageLoaded]: l }), src: d ? void 0 : r }, i),
    N.createElement(Tt, { className: Zt.mask })
  ) : N.createElement(
    N.Fragment,
    null,
    N.createElement(gl, { variant: "rounded", classes: a, src: r, "aria-hidden": !0, slotProps: f, className: ot({ [Zt.imageLoaded]: l }) }),
    N.createElement("div", { className: Zt.mask })
  );
}, TX = N.forwardRef((e, t) => {
  const { status: r, size: o = "medium", sx: a, className: i, displayName: l, inactive: c, onClick: d, "aria-label": p, ariaLabel: f, tabIndex: h, ...g } = e, y = vs(o) ? o : Jy(o), C = ot(Zt.container, i, {
    [`${Zt.text}`]: !!l
  }, {
    [`${Zt.inactive}`]: c
  }, {
    [`${Zt.extrasSmall}`]: y === "extraSmall"
  }, {
    [`${Zt.small}`]: y === "small"
  }, {
    [`${Zt.medium}`]: y === "medium"
  }, {
    [`${Zt.large}`]: y === "large"
  }, {
    [`${Zt.extraLarge}`]: y === "extraLarge"
  }), { t: b } = ua("Avatar");
  Dn(() => {
    if (!r || !Op(o) || typeof r != "string")
      return;
    const T = T4[$p[r]], R = w4.large[$p[r]];
    if (!document.querySelector(`#${T}`)) {
      const $ = `<svg width="0" height="0" viewBox="0 0 148 147" version="1.1" xmlns="http://www.w3.org/2000/svg" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
  <clipPath id="${T}" clipPathUnits="objectBoundingBox">
    <path transform="scale(0.025, 0.025)" d="${R}" style="fill:none;" />
  </clipPath>
</svg>`, E = document.createElement("div");
      E.innerHTML = $, E.style.cssText = `
        height: 0;
        overflow: hidden;
      `, document.body.appendChild(E);
    }
  }, [y, o, r]);
  const v = {
    component: d ? "button" : "div",
    className: C,
    sx: a,
    tabIndex: h ?? 0,
    role: d ? "button" : "img",
    onClick: d,
    "aria-label": p ?? f,
    ...$o(g, "style")
  };
  if (!v["aria-label"]) {
    let T = l ? `${b("profileAvatar", { name: l })}` : b("defaultProfileAvatar");
    if (typeof r == "string") {
      const R = b(r);
      R && (T += `, ${R}`);
    } else pl(r) && r.props["aria-label"] && (T += `, ${r.props["aria-label"]}`);
    c && (T += `, ${b("inactive")}`), v["aria-label"] = T;
  }
  if (!r || ["extraSmall"].includes(y))
    return N.createElement(
      Tt,
      { ...v, ref: t },
      N.createElement(Th, { size: o, className: i, displayName: l, ...g })
    );
  if (typeof r == "string") {
    const T = N.createElement(wX, { status: r });
    return N.createElement(
      Tt,
      { ...v, ref: t },
      N.createElement(
        xS,
        { status: r, classes: {
          root: ot(Zt.statusRoot, i),
          badge: ot(Zt.statusBadge, Zt.status(r))
        }, size: o, badgeContent: T, anchorOrigin: { vertical: "top", horizontal: "right" }, "aria-hidden": !0 },
        N.createElement(Th, { size: o, className: i, displayName: l, ...g })
      )
    );
  }
  return N.createElement(
    Tt,
    { ...v, ref: t },
    N.createElement(
      xS,
      { status: r, classes: {
        root: ot(Zt.statusRoot, i),
        badge: Zt.statusBadge
      }, badgeContent: r, anchorOrigin: { vertical: "top", horizontal: "right" }, size: o, "aria-hidden": !0 },
      N.createElement(Th, { size: o, displayName: l, ...g })
    )
  );
}), EX = Y(TX)((e) => {
  const { theme: t, size: r, displayName: o, status: a, color: i, backgroundColor: l } = e;
  return CX(t, {
    size: r,
    abbreviation: O4(o),
    status: a,
    color: i,
    backgroundColor: l
  });
}), OX = N.forwardRef((e, t) => N.createElement(EX, { ...e, ref: t })), $X = Ps((e, t) => {
  const { className: r, sx: o, style: a, label: i, disabled: l, onClose: c, onClick: d, closeButtonProps: p, avatar: f, status: h, ...g } = e, { t: y } = ua("Tag"), C = !!d, b = !!c && !l, v = h === "error";
  return N.createElement(cf, { classes: zr, className: ot(zr.root, r, {
    [zr.clickable]: C,
    [zr.error]: v
  }), style: a, sx: o, icon: f ? N.createElement(OX, { size: "extraSmall", tabIndex: -1, ...f, className: zr.avatar }) : g.icon, label: N.createElement("span", { "aria-hidden": !0 }, i), component: "div", tabIndex: C ? 0 : -1, "aria-disabled": l, "aria-invalid": v, role: C ? "button" : "presentation", onDelete: c, disabled: l, onClick: d, "aria-label": typeof i == "string" ? i : void 0, deleteIcon: N.createElement(
    qr,
    { component: "div", disableRipple: !0, tabIndex: b && !l ? 0 : -1, "aria-label": typeof i == "string" ? y("remove", { label: i }) : void 0, ...p },
    N.createElement(kf, { "aria-hidden": !0, size: 14 })
  ), ...g, ref: t });
}), RX = Y($X, {
  shouldForwardProp: (e) => e !== "showShadow"
})((e) => {
  const { theme: t } = e;
  return uX(t);
});
function Qy(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao(), o = e?.palette?.mode === "dark", a = o ? "#3e4247" : "#edeeef", i = o ? "#171719" : "#c2c6ca", l = o ? "#672331" : "#fce3e7", c = o ? "#171719" : "#f59eae";
  return {
    fontFamily: r.fontFamily,
    focusBorderColor: t.border.primary,
    focusBorderBackground: t.bg.default,
    lineHeight: {
      default: r.lineHeight.body,
      extraSmall: r.lineHeight.subtitle,
      small: r.lineHeight.subtitle,
      medium: r.lineHeight.body,
      large: r.lineHeight.bodyLargeMedium,
      extraLarge: r.lineHeight.bodyLargeMedium
    },
    minWidth: {
      default: "60px",
      small: "47px",
      medium: "60px",
      large: "73px",
      extraLarge: "81px"
    },
    height: {
      default: "32px",
      small: "24px",
      medium: "32px",
      large: "40px",
      extraLarge: "48px"
    },
    padding: {
      default: "6px 12px",
      small: "4px 8px",
      medium: "6px 12px",
      large: "10px 16px",
      extraLarge: "14px 20px"
    },
    borderRadius: {
      default: "8px",
      small: "6px",
      medium: "8px",
      large: "10px",
      extraLarge: "12px"
    },
    fontSize: {
      default: r.fontSize.body,
      small: r.fontSize.body,
      medium: r.fontSize.body,
      large: r.fontSize.bodyLargeMedium,
      extraLarge: r.fontSize.bodyLargeMedium
    },
    fontWeight: {
      default: r.fontWeight.body,
      small: r.fontWeight.body,
      medium: r.fontWeight.body,
      large: r.fontWeight.bodyLargeMedium,
      extraLarge: r.fontWeight.bodyLargeMedium
    },
    loadingMask: t.fill.blend.strong.transparent,
    loadingColor: t.fill.contrary.strong.transparent,
    loadingMaskOffset: {
      default: -1,
      primary: -1,
      secondary: 0,
      tertiary: -1
    },
    color: {
      default: {
        default: t.inverse.global.default,
        hover: t.inverse.global.default,
        active: t.inverse.global.default
      },
      primary: {
        default: t.inverse.global.default,
        hover: t.inverse.global.default,
        active: t.inverse.global.default
      },
      secondary: {
        default: t.text.stronger.neutral,
        hover: t.text.stronger.neutral,
        active: t.text.stronger.neutral
      },
      tertiary: {
        default: t.text.primary,
        hover: t.text.primary,
        active: t.text.primary
      },
      disabled: {
        default: {
          default: t.state.disable,
          hover: t.state.disable,
          active: t.state.disable
        },
        primary: {
          default: t.state.disable,
          hover: t.state.disable,
          active: t.state.disable
        },
        secondary: {
          default: t.state.disable,
          hover: t.state.disable,
          active: t.state.disable
        },
        tertiary: {
          default: t.state.disable,
          hover: t.state.disable,
          active: t.state.disable
        }
      },
      danger: {
        default: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        primary: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        secondary: {
          default: t.text.error,
          hover: t.text.error,
          active: t.text.error
        },
        tertiary: {
          default: t.text.error,
          hover: t.text.error,
          active: t.text.error
        }
      }
    },
    background: {
      default: {
        default: t.fill.global.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      primary: {
        default: t.fill.global.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      secondary: {
        default: t.fill.default,
        // hover: semantic.state.subtle.neutral.hover,
        // active: semantic.state.subtle.neutral.press,
        hover: a,
        active: i
      },
      tertiary: {
        default: "transparent",
        hover: t.state.subtle.primary.hover,
        active: t.state.subtle.primary.press
      },
      disabled: {
        default: {
          default: t.state.subtle.disable,
          hover: t.state.subtle.disable,
          active: t.state.subtle.disable
        },
        primary: {
          default: t.state.subtle.disable,
          hover: t.state.subtle.disable,
          active: t.state.subtle.disable
        },
        secondary: {
          default: t.fill.default,
          hover: t.fill.default,
          active: t.fill.default
        },
        tertiary: {
          default: "transparent",
          hover: "transparent",
          active: "transparent"
        }
      },
      danger: {
        default: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        primary: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        secondary: {
          default: t.fill.default,
          // hover: semantic.state.subtle.error.hover,
          // active: semantic.state.subtle.error.press,
          hover: l,
          active: c
        },
        tertiary: {
          default: "transparent",
          hover: t.state.subtle.error.hover,
          active: t.state.subtle.error.press
        }
      }
    },
    borderColor: {
      default: {
        default: t.fill.global.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      primary: {
        default: t.fill.global.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      secondary: {
        default: t.border.neutral,
        hover: t.border.neutral,
        active: t.border.neutral
      },
      tertiary: {
        default: "transparent",
        hover: "transparent",
        active: "transparent"
      },
      disabled: {
        default: {
          default: t.state.subtle.disable,
          hover: t.state.subtle.disable,
          active: t.state.subtle.disable
        },
        primary: {
          default: t.state.subtle.disable,
          hover: t.state.subtle.disable,
          active: t.state.subtle.disable
        },
        secondary: {
          default: t.state.subtle.disable,
          hover: t.state.subtle.disable,
          active: t.state.subtle.disable
        },
        tertiary: {
          default: "transparent",
          hover: "transparent",
          active: "transparent"
        }
      },
      danger: {
        default: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        primary: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        secondary: {
          default: t.border.error,
          hover: t.border.error,
          active: t.border.error
        },
        tertiary: {
          default: "transparent",
          hover: "transparent",
          active: "transparent"
        }
      }
    },
    iconButton: {
      width: {
        default: "32px",
        extraSmall: "20px",
        small: "24px",
        medium: "32px",
        large: "40px",
        extraLarge: "48px"
      },
      height: {
        default: "32px",
        extraSmall: "20px",
        small: "24px",
        medium: "32px",
        large: "40px",
        extraLarge: "48px"
      },
      fontSize: {
        default: "16px",
        extraSmall: "14px",
        small: "14px",
        medium: "16px",
        large: "18px",
        extraLarge: "20px"
      },
      iconSize: {
        default: "14px",
        extraSmall: "14px",
        small: "14px",
        medium: "14px",
        large: "16px",
        extraLarge: "18px"
      },
      borderRadius: {
        default: "8px",
        extraSmall: "6px",
        small: "6px",
        medium: "8px",
        large: "10px",
        extraLarge: "12px"
      },
      color: {
        default: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        primary: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        secondary: {
          default: t.text.stronger.neutral,
          hover: t.text.stronger.neutral,
          active: t.text.stronger.neutral
        },
        tertiary: {
          default: t.text.stronger.neutral,
          hover: t.text.stronger.neutral,
          active: t.text.stronger.neutral
        },
        overlay: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        disabled: {
          default: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          primary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          secondary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          tertiary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          overlay: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          }
        },
        loading: {
          default: {
            default: t.fill.global.strong.light.transparent,
            hover: t.fill.global.strong.light.transparent,
            active: t.fill.global.strong.light.transparent
          },
          primary: {
            default: t.fill.global.strong.light.transparent,
            hover: t.fill.global.strong.light.transparent,
            active: t.fill.global.strong.light.transparent
          },
          secondary: {
            default: t.fill.contrary.strong.transparent,
            hover: t.fill.contrary.strong.transparent,
            active: t.fill.contrary.strong.transparent
          },
          tertiary: {
            default: t.fill.contrary.strong.transparent,
            hover: t.fill.contrary.strong.transparent,
            active: t.fill.contrary.strong.transparent
          },
          overlay: {
            default: t.inverse.global.default,
            hover: t.inverse.global.default,
            active: t.inverse.global.default
          }
        }
      },
      background: {
        default: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        primary: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        secondary: {
          default: t.fill.default,
          // hover: semantic.state.subtle.neutral.hover,
          // active: semantic.state.subtle.neutral.press,
          hover: a,
          active: i
        },
        tertiary: {
          default: "transparent",
          hover: t.state.subtle.neutral.hover,
          active: t.state.subtle.neutral.press
        },
        overlay: {
          default: t.fill.global.dark.transparent,
          hover: t.state.global.dark.transparent.hover,
          active: t.state.global.dark.transparent.press
        },
        disabled: {
          default: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          primary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          secondary: {
            default: t.fill.default,
            hover: t.fill.default,
            active: t.fill.default
          },
          tertiary: {
            default: "transparent",
            hover: "transparent",
            active: "transparent"
          },
          overlay: {
            default: t.fill.global.dark.transparent,
            hover: t.fill.global.dark.transparent,
            active: t.fill.global.dark.transparent
          }
        }
      },
      borderColor: {
        default: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        primary: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        secondary: {
          default: t.border.neutral,
          hover: t.border.neutral,
          active: t.border.neutral
        },
        tertiary: {
          default: "transparent",
          hover: "transparent",
          active: "transparent"
        },
        overlay: {
          default: "transparent",
          hover: "transparent",
          active: "transparent"
        },
        disabled: {
          default: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          primary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          secondary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          tertiary: {
            default: "transparent",
            hover: "transparent",
            active: "transparent"
          },
          overlay: {
            default: "transparent",
            hover: "transparent",
            active: "transparent"
          }
        }
      }
    },
    homeButton: {
      width: "56px",
      height: "56px",
      fontSize: "30px",
      borderRadius: "16px",
      color: {
        default: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        primary: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        secondary: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        tertiary: {
          default: t.inverse.global.default,
          hover: t.inverse.global.default,
          active: t.inverse.global.default
        },
        disabled: {
          default: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          primary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          secondary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          },
          tertiary: {
            default: t.state.disable,
            hover: t.state.disable,
            active: t.state.disable
          }
        }
      },
      background: {
        default: {
          default: t.fill.complementary,
          hover: t.state.complementary.hover,
          active: t.state.complementary.press
        },
        primary: {
          default: t.fill.complementary,
          hover: t.state.complementary.hover,
          active: t.state.complementary.press
        },
        secondary: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        tertiary: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        disabled: {
          default: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          primary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          secondary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          tertiary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          }
        }
      },
      borderColor: {
        default: {
          default: t.fill.complementary,
          hover: t.state.complementary.hover,
          active: t.state.complementary.press
        },
        primary: {
          default: t.fill.complementary,
          hover: t.state.complementary.hover,
          active: t.state.complementary.press
        },
        secondary: {
          default: t.fill.global.primary,
          hover: t.state.primary.hover,
          active: t.state.primary.press
        },
        tertiary: {
          default: t.fill.global.error,
          hover: t.state.error.hover,
          active: t.state.error.press
        },
        disabled: {
          default: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          primary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          secondary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          },
          tertiary: {
            default: t.state.subtle.disable,
            hover: t.state.subtle.disable,
            active: t.state.subtle.disable
          }
        }
      }
    }
  };
}
function xs(e) {
  return ["primary", "secondary", "tertiary"].includes(e);
}
function Eh(e) {
  return ["primary", "secondary", "tertiary", "overlay"].includes(e);
}
function ev(e) {
  const t = Object.keys(e), r = {};
  return t.forEach((o) => {
    const a = o.toLowerCase();
    (a.startsWith("aria-") || a.startsWith("data-") || a.startsWith("on") || ["id", "title", "role", "tabindex"].includes(a) || typeof e.href == "string" && ["href", "target", "download"].includes(a)) && (r[o] = e[o]);
  }), r;
}
function tv() {
  return {
    ".zmicon": {
      display: "inline-block",
      verticalAlign: "-0.125em",
      lineHeight: 0
    },
    ".zmicon-acc-outline": {
      outline: "2px solid #4f9af7"
    },
    ".zmicon-acc-no-outline": {
      outline: "none"
    }
  };
}
const PX = "Button", Xr = `ui-${PX}`, Ue = {
  root: `${Xr}-root-${to()}`,
  focusVisible: `${Xr}-focusVisible`,
  extraSmall: `${Xr}-extraSmall`,
  small: `${Xr}-small`,
  medium: `${Xr}-medium`,
  large: `${Xr}-large`,
  extraLarge: `${Xr}-extraLarge`,
  primary: `${Xr}-primary`,
  secondary: `${Xr}-secondary`,
  tertiary: `${Xr}-tertiary`,
  overlay: `${Xr}-overlay`,
  loading: `${Xr}-loading`,
  disabled: `${Xr}-disabled`,
  danger: `${Xr}-danger`,
  startIcon: `${Xr}-startIcon`,
  endIcon: `${Xr}-endIcon`,
  loadingIcon: `${Xr}-loadingIcon`,
  loadingMask: `${Xr}-loadingMask`,
  iconButton: `${Xr}-iconButton`,
  homeButton: `${Xr}-homeButton`
};
function kX(e) {
  const t = Qy(e), [r, o] = mn({
    componentName: "Button",
    theme: e,
    dynamicToken: t
  }), a = (f) => {
    const h = f;
    return {
      height: o(r.height[h]),
      minWidth: o(r.minWidth[h]),
      padding: o(r.padding[h]),
      fontSize: o(r.fontSize[h]),
      fontWeight: o(r.fontWeight[h]),
      borderRadius: o(r.borderRadius[h]),
      lineHeight: o(r.lineHeight[h]),
      // icon
      [`.${Ue.startIcon}, .${Ue.endIcon}`]: {
        fontSize: o(r.fontSize[h]),
        svg: {
          fontSize: o(r.fontSize[h])
        }
      },
      // loading mask
      [`.${Ue.loadingMask}`]: {
        borderRadius: o(r.borderRadius[h])
      }
    };
  }, i = (f) => {
    const h = f;
    return {
      background: o(r.background[h].default),
      color: o(r.color[h].default),
      borderColor: o(r.borderColor[h].default),
      "&:hover": {
        background: o(r.background[h].hover),
        color: o(r.color[h].hover),
        borderColor: o(r.borderColor[h].hover)
      },
      "&:active": {
        background: o(r.background[h].active),
        color: o(r.color[h].active),
        borderColor: o(r.borderColor[h].active)
      },
      // loading mask offset
      [`.${Ue.loadingMask}`]: {
        left: o(r.loadingMaskOffset[h]),
        right: o(r.loadingMaskOffset[h]),
        top: o(r.loadingMaskOffset[h]),
        bottom: o(r.loadingMaskOffset[h])
      }
    };
  }, l = (f) => {
    const h = f && xs(f) ? f : "default";
    return {
      background: o(r.background.danger[h].default),
      color: o(r.color.danger[h].default),
      borderColor: o(r.borderColor.danger[h].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: o(r.background.danger[h].hover),
        color: o(r.color.danger[h].hover),
        borderColor: o(r.borderColor.danger[h].hover)
      },
      "&:active": {
        background: o(r.background.danger[h].active),
        color: o(r.color.danger[h].active),
        borderColor: o(r.borderColor.danger[h].active)
      }
    };
  }, c = (f) => {
    const h = f && xs(f) ? f : "default";
    return {
      "&, &:hover, &:active": {
        background: o(r.background[h].default),
        color: o(r.color[h].default),
        borderColor: o(r.borderColor[h].default)
      },
      [`&.${Ue.danger}`]: {
        "&, &:hover, &:active": {
          background: o(r.background.danger[h].default),
          color: o(r.color.danger[h].default),
          borderColor: o(r.borderColor.danger[h].default)
        }
      }
    };
  }, d = (f) => {
    const h = f && xs(f) ? f : "default";
    return {
      background: o(r.background.disabled[h].default),
      color: o(r.color.disabled[h].default),
      borderColor: o(r.borderColor.disabled[h].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: o(r.background.disabled[h].hover),
        color: o(r.color.disabled[h].hover),
        borderColor: o(r.borderColor.disabled[h].hover)
      },
      "&:active": {
        background: o(r.background.disabled[h].active),
        color: o(r.color.disabled[h].active),
        borderColor: o(r.borderColor.disabled[h].active)
      }
    };
  };
  return {
    [`&.${Ue.root}`]: {
      fontFamily: o(r.fontFamily),
      textTransform: "none",
      // boxShadow: 'none',
      borderStyle: "solid",
      borderWidth: 1,
      whiteSpace: "nowrap",
      position: "relative",
      // box style
      height: o(r.height.default),
      minWidth: o(r.minWidth.default),
      padding: o(r.padding.default),
      borderRadius: o(r.borderRadius.default),
      lineHeight: o(r.lineHeight.default),
      // text style
      fontSize: o(r.fontSize.default),
      fontWeight: o(r.fontWeight.default),
      // color style
      background: o(r.background.default.default),
      color: o(r.color.default.default),
      borderColor: o(r.borderColor.default.default),
      "&:hover": {
        background: o(r.background.default.hover),
        color: o(r.color.default.hover),
        borderColor: o(r.borderColor.default.hover)
      },
      "&:active": {
        background: o(r.background.default.active),
        color: o(r.color.default.active),
        borderColor: o(r.borderColor.default.active)
      },
      [`&.${Ue.focusVisible}, &:focus-visible`]: {
        outline: `2px solid ${o(r.focusBorderColor)}`,
        outlineOffset: "2px"
      },
      // icon
      [`.${Ue.startIcon}, .${Ue.endIcon}`]: {
        fontSize: o(r.fontSize.default),
        svg: {
          fontSize: o(r.fontSize.default)
        }
      },
      [`.${Ue.startIcon}`]: {
        marginInlineStart: 0,
        marginInlineEnd: "4px"
      },
      [`.${Ue.endIcon}`]: {
        marginInlineStart: "4px",
        marginInlineEnd: 0
      },
      [`&.${Ue.small}`]: a("small"),
      [`&.${Ue.medium}`]: a("medium"),
      [`&.${Ue.large}`]: a("large"),
      [`&.${Ue.extraLarge}`]: a("extraLarge"),
      [`&.${Ue.primary}`]: i("primary"),
      [`&.${Ue.secondary}`]: i("secondary"),
      [`&.${Ue.tertiary}`]: i("tertiary"),
      [`&.${Ue.danger}`]: {
        ...l(),
        [`&.${Ue.primary}`]: l("primary"),
        [`&.${Ue.secondary}`]: l("secondary"),
        [`&.${Ue.tertiary}`]: l("tertiary")
      },
      [`&.${Ue.loading}`]: {
        cursor: "default",
        ...c(),
        [`&.${Ue.primary}`]: c("primary"),
        [`&.${Ue.secondary}`]: c("secondary"),
        [`&.${Ue.tertiary}`]: c("tertiary")
      },
      [`&.${Ue.disabled}, &.${Ue.loading}.${Ue.disabled}`]: {
        cursor: "not-allowed",
        pointerEvents: "auto",
        ...d(),
        [`&.${Ue.primary}`]: d("primary"),
        [`&.${Ue.secondary}`]: d("secondary"),
        [`&.${Ue.tertiary}`]: d("tertiary")
      },
      [`.${Ue.loadingMask}`]: {
        background: o(r.loadingMask),
        position: "absolute",
        left: o(r.loadingMaskOffset.default),
        right: o(r.loadingMaskOffset.default),
        top: o(r.loadingMaskOffset.default),
        bottom: o(r.loadingMaskOffset.default),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: o(r.borderRadius.default),
        [`.${Ue.loadingIcon}`]: {
          color: o(r.loadingColor),
          svg: {
            fontSize: 16
          }
        }
      },
      ...tv()
    }
  };
}
function Oh(e) {
  const t = [];
  return t.push(Ue.root), e.type && t.push(Ue[e.type]), e.size && ["extraSmall", "small", "medium", "large", "extraLarge"].includes(e.size) && (e.size === "extraSmall" ? e.variant === "icon" && t.push(Ue[e.size]) : t.push(Ue[e.size])), e.danger && t.push(Ue.danger), e.loading && t.push(Ue.loading), e.disabled && t.push(Ue.disabled), ot(t);
}
function AX(e, t) {
  const r = Qy(e), [o, a] = mn({
    componentName: "Button",
    theme: e,
    dynamicToken: r
  }), i = (g) => {
    const y = g, C = {
      height: a(o.iconButton.height[y]),
      minWidth: a(o.iconButton.width[y]),
      width: a(o.iconButton.width[y]),
      borderRadius: a(o.iconButton.borderRadius[y]),
      padding: 0,
      fontSize: a(o.iconButton.fontSize[y]),
      svg: {
        fontSize: a(o.iconButton.iconSize[y])
      },
      // icon
      [`.${Ue.startIcon}, .${Ue.endIcon}`]: {
        display: "none"
      }
    };
    return t?.fullWidth && delete C.width, C;
  }, l = (g) => {
    const y = g && Eh(g) ? g : "default";
    return {
      background: a(o.iconButton.background[y].default),
      color: a(o.iconButton.color[y].default),
      borderColor: a(o.iconButton.borderColor[y].default),
      "&:hover": {
        background: a(o.iconButton.background[y].hover),
        color: a(o.iconButton.color[y].hover),
        borderColor: a(o.iconButton.borderColor[y].hover)
      },
      "&:active": {
        background: a(o.iconButton.background[y].active),
        color: a(o.iconButton.color[y].active),
        borderColor: a(o.iconButton.borderColor[y].active)
      }
    };
  }, c = (g) => {
    const y = g && xs(g) ? g : "default";
    return {
      background: a(o.background.disabled[y].default),
      color: a(o.color.disabled[y].default),
      borderColor: a(o.borderColor.disabled[y].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: a(o.background.disabled[y].hover),
        color: a(o.color.disabled[y].hover),
        borderColor: a(o.borderColor.disabled[y].hover)
      },
      "&:active": {
        background: a(o.background.disabled[y].active),
        color: a(o.color.disabled[y].active),
        borderColor: a(o.borderColor.disabled[y].active)
      }
    };
  }, d = (g) => {
    const y = g && xs(g) ? g : "default";
    return {
      background: a(o.background.danger[y].default),
      color: a(o.color.danger[y].default),
      borderColor: a(o.borderColor.danger[y].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: a(o.background.danger[y].hover),
        color: a(o.color.danger[y].hover),
        borderColor: a(o.borderColor.danger[y].hover)
      },
      "&:active": {
        background: a(o.background.danger[y].active),
        color: a(o.color.danger[y].active),
        borderColor: a(o.borderColor.danger[y].active)
      }
    };
  }, p = (g) => {
    const y = g && Eh(g) ? g : "default";
    return {
      background: a(o.iconButton.background.disabled[y].default),
      color: a(o.iconButton.color.disabled[y].default),
      borderColor: a(o.iconButton.borderColor.disabled[y].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: a(o.iconButton.background.disabled[y].hover),
        color: a(o.iconButton.color.disabled[y].hover),
        borderColor: a(o.iconButton.borderColor.disabled[y].hover)
      },
      "&:active": {
        background: a(o.iconButton.background.disabled[y].active),
        color: a(o.iconButton.color.disabled[y].active),
        borderColor: a(o.iconButton.borderColor.disabled[y].active)
      }
    };
  }, f = (g) => {
    const y = g && Eh(g) ? g : "default";
    return {
      color: a(o.iconButton.color.loading[y].default),
      "&:hover": {
        color: a(o.iconButton.color.loading[y].hover)
      },
      "&:active": {
        color: a(o.iconButton.color.loading[y].active)
      },
      "&, &:hover, &:active": {
        background: a(o.iconButton.background[y].default),
        borderColor: a(o.iconButton.borderColor[y].default)
      },
      [`&.${Ue.danger}`]: {
        "&, &:hover, &:active": {
          background: a(o.background.danger[y === "overlay" ? "default" : y].default),
          borderColor: a(o.borderColor.danger[y === "overlay" ? "default" : y].default)
        }
      }
    };
  };
  return {
    [`&.${Ue.root}`]: {
      textTransform: "none",
      // boxShadow: 'none',
      borderStyle: "solid",
      borderWidth: 1,
      whiteSpace: "nowrap",
      // box style
      height: a(o.height.default),
      minWidth: a(o.minWidth.default),
      padding: a(o.padding.default),
      borderRadius: a(o.borderRadius.default),
      // text style
      fontSize: a(o.fontSize.default),
      fontWeight: a(o.fontWeight.default),
      // color style
      background: a(o.background.default.default),
      color: a(o.color.default.default),
      borderColor: a(o.borderColor.default.default),
      "&:hover": {
        background: a(o.background.default.hover),
        color: a(o.color.default.hover),
        borderColor: a(o.borderColor.default.hover)
      },
      "&:active": {
        background: a(o.background.default.active),
        color: a(o.color.default.active),
        borderColor: a(o.borderColor.default.active)
      },
      [`&.${Ue.focusVisible}, &:focus-visible`]: {
        outline: `2px solid ${a(o.focusBorderColor)}`,
        outlineOffset: "2px"
      },
      // icon
      [`.${Ue.startIcon}, .${Ue.endIcon}`]: {
        fontSize: a(o.fontSize.default),
        svg: {
          fontSize: a(o.fontSize.default)
        }
      },
      [`&.${Ue.disabled}`]: {
        cursor: "not-allowed",
        ...c(),
        [`&.${Ue.primary}`]: c("primary"),
        [`&.${Ue.secondary}`]: c("secondary"),
        [`&.${Ue.tertiary}`]: c("tertiary")
      },
      // iconButton variant style
      [`&.${Ue.iconButton}`]: {
        ...i("medium"),
        ...l("default"),
        [`&.${Ue.extraSmall}`]: i("extraSmall"),
        [`&.${Ue.small}`]: i("small"),
        [`&.${Ue.medium}`]: i("medium"),
        [`&.${Ue.large}`]: i("large"),
        [`&.${Ue.extraLarge}`]: i("extraLarge"),
        [`&.${Ue.primary}`]: l("primary"),
        [`&.${Ue.secondary}`]: l("secondary"),
        [`&.${Ue.tertiary}`]: l("tertiary"),
        [`&.${Ue.overlay}`]: l("overlay"),
        [`&.${Ue.danger}`]: {
          ...d(),
          [`&.${Ue.primary}`]: d("primary"),
          [`&.${Ue.secondary}`]: d("secondary"),
          [`&.${Ue.tertiary}`]: d("tertiary")
        },
        [`&.${Ue.loading}`]: {
          cursor: "default",
          ...f(),
          [`&.${Ue.primary}`]: f("primary"),
          [`&.${Ue.secondary}`]: f("secondary"),
          [`&.${Ue.tertiary}`]: f("tertiary"),
          [`&.${Ue.overlay}`]: f("overlay")
        },
        [`&.${Ue.disabled}, &.${Ue.loading}.${Ue.disabled}`]: {
          cursor: "not-allowed",
          ...p(),
          [`&.${Ue.primary}`]: p("primary"),
          [`&.${Ue.secondary}`]: p("secondary"),
          [`&.${Ue.tertiary}`]: p("tertiary"),
          [`&.${Ue.overlay}`]: p("overlay")
        }
      },
      ...tv()
    }
  };
}
function IX() {
  const e = [];
  return e.push(Ue.root), e.push(Ue.iconButton), ot(e);
}
const NX = Ro`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $4 = Y(b4)`
  animation: ${NX} 1s steps(8, end) infinite;
`, MX = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, autoFocus: i, sx: l, classes: c, fullWidth: d, htmlType: p, loading: f, autoLoading: h, ...g } = e, y = ev(g);
  return N.createElement(hu, { ref: t, disableRipple: !0, className: a, onClick: o, autoFocus: i, classes: {
    startIcon: Ue.startIcon,
    endIcon: Ue.endIcon,
    focusVisible: Ue.focusVisible
  }, sx: l, fullWidth: d, type: p, ...y }, f ? N.createElement($4, { className: Ue.loadingIcon }) : r);
}), _X = Y(MX)((e) => {
  const { theme: t } = e;
  return AX(t, e);
}), FX = N.forwardRef((e, t) => N.createElement(_X, { ...e, ref: t })), LX = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, type: i, size: l, disabled: c, autoFocus: d, sx: p, fullWidth: f, ...h } = e;
  return N.createElement(FX, { ref: t, className: ot(IX(), a), onClick: o, size: l, type: i, disabled: c, autoFocus: d, sx: p, fullWidth: f, ...h }, r);
});
function BX(e, t) {
  const r = Qy(e), [o, a] = mn({
    componentName: "Button",
    theme: e,
    dynamicToken: r
  }), i = (d) => {
    const p = d && xs(d) ? d : "default";
    return {
      background: a(o.homeButton.background[p].default),
      color: a(o.homeButton.color[p].default),
      borderColor: a(o.homeButton.borderColor[p].default),
      "&:hover": {
        background: a(o.homeButton.background[p].hover),
        color: a(o.homeButton.color[p].hover),
        borderColor: a(o.homeButton.borderColor[p].hover)
      },
      "&:active": {
        background: a(o.homeButton.background[p].active),
        color: a(o.homeButton.color[p].active),
        borderColor: a(o.homeButton.borderColor[p].active)
      }
    };
  }, l = (d) => {
    const p = d && xs(d) ? d : "default";
    return {
      background: a(o.homeButton.background.disabled[p].default),
      color: a(o.homeButton.color.disabled[p].default),
      borderColor: a(o.homeButton.borderColor.disabled[p].default),
      // fontWeight: tk(token.fontWeight[type]),
      "&:hover": {
        background: a(o.homeButton.background.disabled[p].hover),
        color: a(o.homeButton.color.disabled[p].hover),
        borderColor: a(o.homeButton.borderColor.disabled[p].hover)
      },
      "&:active": {
        background: a(o.homeButton.background.disabled[p].active),
        color: a(o.homeButton.color.disabled[p].active),
        borderColor: a(o.homeButton.borderColor.disabled[p].active)
      }
    };
  };
  return {
    [`&.${Ue.root}`]: {
      textTransform: "none",
      // boxShadow: 'none',
      borderStyle: "solid",
      borderWidth: 1,
      whiteSpace: "nowrap",
      [`&.${Ue.focusVisible}, &:focus-visible`]: {
        outline: `2px solid ${a(o.focusBorderColor)}`,
        outlineOffset: "2px"
      },
      // homeButton variant style
      [`&.${Ue.homeButton}`]: {
        height: a(o.homeButton.height),
        minWidth: a(o.homeButton.width),
        ...!t?.fullWidth && { width: a(o.homeButton.width) },
        padding: 0,
        fontSize: a(o.homeButton.fontSize),
        svg: {
          fontSize: a(o.homeButton.fontSize)
        },
        borderRadius: a(o.homeButton.borderRadius),
        ...i("default"),
        // hide startIcon and endIcon
        [`.${Ue.startIcon}, .${Ue.endIcon}`]: {
          display: "none"
        },
        [`&.${Ue.primary}`]: i("primary"),
        [`&.${Ue.secondary}`]: i("secondary"),
        [`&.${Ue.tertiary}`]: i("tertiary"),
        [`&.${Ue.disabled}`]: {
          cursor: "not-allowed",
          ...l(),
          [`&.${Ue.primary}`]: l("primary"),
          [`&.${Ue.secondary}`]: l("secondary"),
          [`&.${Ue.tertiary}`]: l("tertiary")
        }
      },
      ...tv()
    }
  };
}
function DX() {
  const e = [];
  return e.push(Ue.root), e.push(Ue.homeButton), ot(e);
}
const jX = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, autoFocus: i, sx: l, classes: c, fullWidth: d, htmlType: p, ...f } = e, h = ev(f);
  return N.createElement(hu, { ref: t, disableRipple: !0, className: a, onClick: o, autoFocus: i, classes: {
    startIcon: Ue.startIcon,
    endIcon: Ue.endIcon,
    focusVisible: Ue.focusVisible
  }, sx: l, fullWidth: d, type: p, ...h }, r);
}), zX = Y(jX)((e) => {
  const { theme: t } = e;
  return BX(t, e);
}), VX = N.forwardRef((e, t) => N.createElement(zX, { ...e, ref: t })), WX = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, type: i, size: l, disabled: c, autoFocus: d, sx: p, variant: f, fullWidth: h, ...g } = e;
  return N.createElement(VX, { ref: t, className: ot(DX(), a), onClick: o, size: l, type: i, disabled: c, autoFocus: d, sx: p, fullWidth: h, ...g }, r);
});
function UX({ autoLoading: e, loading: t, onClick: r }) {
  const [o, a] = Ir(t), { t: i } = ua("Shared");
  return Dn(() => {
    a(t);
  }, [t]), [o, async (c) => {
    if (!t)
      if (e) {
        if (o)
          return;
        try {
          a(!0), qy(i("loading")), await r?.(c);
        } catch (d) {
          console.error(d);
        }
        a(!1);
      } else
        r?.(c);
  }];
}
const HX = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, style: i, autoFocus: l, startIcon: c, endIcon: d, loading: p, sx: f, classes: h, fullWidth: g, htmlType: y, disabled: C, ...b } = e, v = ev(b);
  return N.createElement(
    hu,
    { ref: t, disableRipple: !0, className: a, style: i, onClick: o, autoFocus: l, startIcon: c, endIcon: d, classes: {
      startIcon: Ue.startIcon,
      endIcon: Ue.endIcon,
      focusVisible: Ue.focusVisible
    }, sx: f, fullWidth: g, type: y, ...v },
    r,
    p ? N.createElement(
      "div",
      { "aria-hidden": !0, className: Ue.loadingMask },
      N.createElement($4, { className: Ue.loadingIcon })
    ) : null
  );
}), GX = Y(HX)((e) => {
  const { theme: t } = e;
  return kX(t);
}), qX = N.forwardRef((e, t) => N.createElement(GX, { ...e, ref: t })), Di = N.forwardRef((e, t) => {
  const { children: r, onClick: o, className: a, type: i, size: l, danger: c, disabled: d, autoFocus: p, startIcon: f, endIcon: h, loading: g, autoLoading: y, sx: C, variant: b, fullWidth: v, ...T } = e;
  let R = T;
  const [$, E] = UX({
    loading: !!g,
    autoLoading: y,
    onClick: o
  }), S = !!($ || d);
  return d && ("aria-disabled" in R || (R["aria-disabled"] = "true"), "tabIndex" in R || (R.tabIndex = -1), R = $o(R, ["href"])), typeof r == "string" && !("aria-label" in R) && (R["aria-label"] = r), b === "icon" ? N.createElement(LX, { ref: t, className: ot(Oh({
    ...e,
    loading: $
  }), a), size: l, type: i, disabled: d, autoFocus: p, sx: C, fullWidth: v, loading: $, danger: c, onClick: S ? void 0 : E, ...R }, r) : b === "home" ? N.createElement(WX, { ref: t, className: ot(Oh({
    ...e,
    loading: $
  }), a), size: l, type: i, disabled: d, autoFocus: p, sx: C, fullWidth: v, onClick: S ? void 0 : E, ...R }, r) : N.createElement(qX, { ref: t, className: ot(Oh({
    ...e,
    loading: $
  }), a), size: l, type: i, danger: c, disabled: d, autoFocus: p, startIcon: f, endIcon: h, loading: $, sx: C, fullWidth: v, onClick: S ? void 0 : E, ...R }, r);
});
function KX(e) {
  const { t } = ua("Autocomplete");
  return N.createElement(
    Di,
    { variant: "icon", type: "tertiary", size: "small", "aria-label": t("clear"), ...e },
    N.createElement(kf, { "aria-hidden": !0 })
  );
}
function YX(e) {
  const { semantic: t, shadow: r, typography: o, zIndex: a } = e;
  return {
    zIndex: a.Tooltip,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize.subtitle,
    fontWeight: o.fontWeight.subtitle,
    lineHeight: o.lineHeight.subtitle,
    borderColor: t.light.border.subtle.neutral,
    backgroundColor: t.light.fill.default,
    boxShadow: r.sm,
    textColor: t.light.text.stronger.neutral
  };
}
function ZX(e) {
  const { semantic: t, shadow: r, typography: o, zIndex: a } = e;
  return {
    zIndex: a.Tooltip,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize.subtitle,
    fontWeight: o.fontWeight.subtitle,
    lineHeight: o.lineHeight.subtitle,
    borderColor: t.dark.border.subtle.neutral,
    backgroundColor: t.dark.fill.default,
    boxShadow: r.sm,
    textColor: t.dark.text.stronger.neutral
  };
}
function XX(e) {
  return {
    light: YX(e),
    dark: ZX(e)
  };
}
const Za = {
  popper: `ui-tooltip-popper-${to()}`,
  tooltip: `ui-tooltip-${to()}`,
  arrow: "ui-tooltip-arrow"
};
function JX(e, t) {
  const r = XX(e.zoomUI || Ao()), [o, a] = EZ({
    componentName: "Tooltip",
    theme: e,
    themeToken: r
  }), { maxWidth: i, mode: l, width: c } = t, p = typeof l < "u" && l !== e?.palette?.mode ? r[l] : o;
  return {
    [`& .${Za.tooltip}`]: {
      fontFamily: a(p.fontFamily),
      backgroundColor: a(p.backgroundColor),
      color: a(p.textColor),
      padding: "3px 6px",
      fontSize: a(p.fontSize),
      lineHeight: a(p.lineHeight),
      fontWeight: a(p.fontWeight),
      borderRadius: "4px",
      border: `0.5px solid ${a(p.borderColor)}`,
      boxShadow: a(p.boxShadow),
      width: c ? `${c}px` : "auto",
      maxWidth: i ? `${i}px` : "240px"
    },
    [`& .${Za.arrow}`]: {
      color: a(p.backgroundColor),
      "&::before": {
        border: `1px solid ${a(p.borderColor)}`
      }
    },
    [`&.${Za.popper}`]: {
      zIndex: a(p.zIndex),
      '&[data-popper-placement="top"], &[data-popper-placement*="top"]': {
        [`.${Za.tooltip}`]: {
          marginBottom: "4px"
        }
      },
      '&[data-popper-placement="bottom"], &[data-popper-placement*="bottom"]': {
        [`.${Za.tooltip}`]: {
          marginTop: "4px"
        }
      },
      '&[data-popper-placement="left"], &[data-popper-placement*="left"]': {
        [`.${Za.tooltip}`]: {
          marginInlineEnd: "4px"
        }
      },
      '&[data-popper-placement="right"], &[data-popper-placement*="right"]': {
        [`.${Za.tooltip}`]: {
          marginInlineStart: "4px"
        }
      }
    }
  };
}
function CS(e, t) {
  if (process.env.NODE_ENV === void 0 || process.env.NODE_ENV === "development") {
    const r = Xt(!1);
    !r.current && e() && (console.warn(t), r.current = !0);
  }
}
function R4(e) {
  const t = ca(e), { typography: r, shadow: o, zIndex: a } = e?.zoomUI ?? Ao();
  return {
    zIndex: a.Popover,
    width: "auto",
    maxWidth: "400px",
    padding: 12,
    fontSize: r.fontSize.body,
    fontFamily: r.fontFamily,
    border: t.border.subtle.neutral,
    borderRadius: 8,
    arrow: {
      width: "1em",
      height: "0.71em",
      color: t.fill.default,
      border: t.border.subtle.neutral
    },
    title: {
      color: t.text.stronger.neutral,
      fontWeight: r.fontWeight.bodyBold,
      lineHeight: r.lineHeight.bodyBold,
      paddingRight: "30px",
      marginBottom: "4px"
    },
    closeIcon: {
      position: "absolute",
      right: "-6px",
      top: "-6px"
    },
    content: {
      color: t.text.stronger.neutral,
      fontWeight: r.fontWeight.body,
      lineHeight: r.lineHeight.body,
      paddingRight: "30px",
      a: {
        color: t.text.primary
      }
    },
    footer: {
      marginTop: 16,
      paddingRight: 36,
      ok: {
        marginLeft: 8
      }
    },
    outline: {
      default: "none",
      focus: `2px solid ${t.border.primary}`,
      offset: 2
    },
    background: t.fill.default,
    boxShadow: o.lg
  };
}
const P4 = "Popover", Si = "ui-Popover", Jr = {
  root: `${Si}-root-${to()}`,
  paper: `${Si}-paper`,
  arrow: `${Si}-arrow`,
  title: `${Si}-title`,
  closeIcon: `${Si}-closeIcon`,
  content: `${Si}-content`,
  footer: `${Si}-footer`,
  okButton: `${Si}-okButton`
};
function QX(e, t) {
  const { width: r, maxWidth: o, closable: a, title: i, content: l, mode: c } = t, d = typeof c < "u" && c !== e?.palette?.mode, p = {
    ...e
  };
  d && (p.palette = {
    ...p.palette,
    mode: c === "dark" ? "dark" : "light"
  });
  const f = R4(p), [h, g] = mn({
    componentName: P4,
    theme: p,
    dynamicToken: f
  });
  return {
    [`&.${Jr.root}`]: {
      zIndex: g(h.zIndex),
      [`.${Jr.paper}`]: {
        width: r ?? g(h.width),
        maxWidth: o ?? g(h.maxWidth),
        padding: g(h.padding),
        background: g(h.background),
        boxShadow: g(h.boxShadow),
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: g(h.border),
        borderRadius: g(h.borderRadius),
        position: "relative",
        fontSize: "16px"
      },
      [`.${Jr.arrow}`]: {
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em",
        boxSizing: "border-box",
        color: g(h.arrow.color),
        "&::before": {
          content: '""',
          margin: "auto",
          display: "block",
          width: "100%",
          height: "100%",
          backgroundColor: "currentColor",
          borderStyle: "solid",
          borderWidth: 1,
          borderColor: g(h.arrow.border),
          transform: "rotate(45deg)",
          borderRadius: 3
        }
      },
      [`&[data-popper-placement*="bottom"] .${Jr.arrow}`]: {
        top: 0,
        left: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${Jr.arrow}`]: {
        bottom: 0,
        left: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${Jr.arrow}`]: {
        left: 0,
        marginInlineStart: "-0.71em",
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${Jr.arrow}`]: {
        right: 0,
        marginInlineEnd: "-0.71em",
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      },
      [`.${Jr.title}`]: {
        display: "flex",
        color: g(h.title.color),
        fontWeight: g(h.title.fontWeight),
        lineHeight: g(h.title.lineHeight),
        fontFamily: g(h.fontFamily),
        fontSize: g(h.fontSize),
        marginBottom: g(h.title.marginBottom),
        ...a && { paddingRight: g(h.title.paddingRight) }
      },
      [`.${Jr.closeIcon}`]: {
        position: g(h.closeIcon.position),
        right: g(h.closeIcon.right),
        top: g(h.closeIcon.top)
      },
      [`.${Jr.content}`]: {
        color: g(h.content.color),
        lineHeight: g(h.content.lineHeight),
        fontFamily: g(h.fontFamily),
        fontWeight: g(h.content.fontWeight),
        fontSize: g(h.fontSize),
        ...a && !i && { paddingRight: g(h.content.paddingRight) }
      },
      [`.${Jr.footer}`]: {
        marginTop: g(h.footer.marginTop),
        display: "flex",
        justifyContent: "flex-end",
        fontFamily: g(h.fontFamily),
        ...a && !i && !l && { paddingRight: g(h.footer.paddingRight) },
        [`.${Jr.okButton}`]: {
          marginInlineStart: g(h.footer.ok.marginLeft)
        }
      }
    }
  };
}
function eJ(e) {
  const t = R4(e), [r, o] = mn({
    componentName: P4,
    theme: e,
    dynamicToken: t
  });
  return {
    zIndex: o(r.zIndex),
    background: "transparent"
  };
}
const SS = (e) => {
  const { onClick: t, onClose: r } = e, [o, a] = Ir(!1), i = (l) => {
    const c = t?.(l);
    Object.prototype.toString.call(c) === "[object Promise]" ? (a(!0), c?.then(() => {
      a(!1), r?.(l);
    }).catch((d) => {
      a(!1), console.error(d);
    })) : r?.(l);
  };
  return N.createElement(Di, { ...e, loading: o, disabled: o, onClick: i });
}, tJ = Ps((e, t) => {
  const { children: r, focusBehavior: o = "loop", autoFocus: a = !0, autoFocusCallback: i, restoreFocus: l = !0, restoreFocusCallback: c, onEscape: d, disableSentinel: p, shouldEscapeOnClickAway: f, ...h } = e, g = Xt(null), y = Xt(null), C = Jt(y, t), b = Xt(null), v = Xt(null), T = Xt(!1), [R, $] = Ir(!1), E = Ln(() => {
    $(y.current?.contains(document.activeElement) ?? !1);
  }, []), S = Xt(c), k = Xt(l);
  Dn(() => {
    S.current = c;
  }, [c]), Dn(() => {
    k.current = l;
  }, [l]), Fc(() => (setTimeout(() => {
    const F = b.current, B = v.current, M = y.current;
    if (T.current = !0, g.current || (g.current = document.activeElement), typeof i == "function")
      i({ container: M, start: F, end: B });
    else if (F && a) {
      const j = document.activeElement;
      if (M.contains(j) && j !== F && j !== B)
        return;
      const W = Nd(F);
      if (!W || !M.contains(W) || W === F || W === B)
        return;
      W.focus();
    }
  }, 0), E(), document.body.addEventListener("focusin", E), document.body.addEventListener("focusout", E), () => {
    document.body.removeEventListener("focusin", E), document.body.removeEventListener("focusout", E);
    const F = g.current;
    typeof S.current == "function" ? S.current({
      originActiveElement: F
    }) : k.current && (F && F !== document.body ? document.activeElement && // eslint-disable-next-line react-hooks/exhaustive-deps
    y.current?.contains(document.activeElement) && F.focus({ preventScroll: !0 }) : document.activeElement?.blur());
  }), []), Fc(() => {
    if (d) {
      const F = (B) => {
        T.current && !y.current?.contains(B.target) && (!f || f(B)) && d(B);
      };
      return document.body.addEventListener("mousedown", F), document.body.addEventListener("touchstart", F), () => {
        document.body.removeEventListener("mousedown", F), document.body.removeEventListener("touchstart", F);
      };
    }
  }, [d, f]);
  function A(F, B) {
    if (o !== "loop") {
      d?.(B);
      return;
    }
    const M = F ? v.current : b.current;
    if (M) {
      const j = Nd(M, F);
      if (j === (F ? b.current : v.current)) {
        document.activeElement?.blur();
        return;
      }
      j?.focus();
    }
  }
  const _ = (F) => {
    const B = b.current, M = v.current;
    F.key === "Tab" && !F.ctrlKey && !F.metaKey ? document.activeElement && !p && (F.shiftKey ? Nd(document.activeElement, !0) === B && (F.preventDefault(), F.stopPropagation(), A(!0, F)) : Nd(document.activeElement) === M && (F.preventDefault(), F.stopPropagation(), A(!1, F))) : F.key === "Escape" && !F.ctrlKey && !F.metaKey && !F.shiftKey && d?.(F);
  };
  function L(F) {
    return N.createElement(Tt, { ref: F ? v : b, tabIndex: R && !p ? 0 : -1, "data-testid": F ? "sentinelEnd" : "sentinelStart", "aria-hidden": !0, sx: {
      position: "absolute",
      pointerEvents: "none",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ":focus": {
        outline: "none"
      },
      ":focus-visible": {
        outline: "none"
      }
    }, onFocus: (B) => {
      y.current?.getAttribute("aria-modal") !== "true" && A(!F, B);
    } });
  }
  function O(F) {
    g.current || (g.current = F.relatedTarget), h.onFocus?.(F);
  }
  return N.createElement(
    Tt,
    { ref: C, onKeyDown: _, role: o === "loop" ? "dialog" : void 0, sx: { position: "relative" }, onFocus: O, ...h },
    L(!1),
    r,
    L(!0)
  );
}), rJ = (e) => {
  const { t } = ua("Shared"), r = (
    // eslint-disable-next-line react/destructuring-assignment
    e.disablePortal && // eslint-disable-next-line react/destructuring-assignment
    (e.trigger === "hover" || e.trigger === "focus")
  ), { open: o, defaultOpen: a, className: i, closable: l, width: c, maxWidth: d, title: p, content: f, footer: h, okText: g = t("ok"), cancelText: y = t("cancel"), cancelButtonProps: C, okButtonProps: b, onOpen: v, onOk: T, onCancel: R, onClose: $, children: E, loopFocus: S, autoFocus: k = !r, autoFocusCallback: A, restoreFocus: _, restoreFocusCallback: L, anchorEl: O, closeButtonProps: F, maskClosable: B = !0, trigger: M = "click", arrow: j = !0, handlerRef: W, mode: V, disabled: X, enterDelay: U = M === "hover" ? 100 : 0, leaveDelay: H = M === "hover" ? 100 : 0, backdrop: Z = !1, backdropProps: G, disableBlurClose: ye = !1, ...de } = e, [ne, fe] = Tp(de), [ie, oe] = Zy(o, a), [ce, Ce] = Ir(null), [xe, Re] = Ir(null), [J, Ie] = Ir(O), { className: le = "", ...qe } = b ?? {}, q = Xt(null), K = Xt(null);
  Dn(() => {
    O ? (Ie(O), K.current = O) : q.current && (Ie(q.current), K.current = q.current);
  }, [O]);
  const he = Xy("popover")("content"), we = !!X || !p && !f && !T && !R, se = Ln(() => {
    ie || we || (oe(!0), v?.());
  }, [ie, we, oe, v]), ue = Ln((rt, He) => {
    ie && (oe(!1), $?.(rt, He));
  }, [ie, oe, $]);
  Fc(() => {
    we && ue(void 0, { type: "invalid" });
  }, [we, ue]), Ss(W, () => ({
    open: se,
    close: ue
  }), [se, ue]);
  const Qe = Xt(se), We = Xt(ue);
  Qe.current = se, We.current = ue;
  const be = Xt(), Se = Ln(() => {
    be.current && clearTimeout(be.current), U ? be.current = setTimeout(() => {
      Qe.current();
    }, U) : se();
  }, [U, se]), De = Ln((rt, He) => {
    be.current && clearTimeout(be.current), H ? be.current = setTimeout(() => {
      We.current(rt, He);
    }, H) : ue(rt, He);
  }, [ue, H]), Ye = () => l ? N.createElement(
    Di,
    { className: Jr.closeIcon, variant: "icon", type: "tertiary", onClick: (rt) => {
      ue(rt, { type: "closeButtonClick" });
    }, "aria-label": t("close"), ...F },
    N.createElement(kf, { size: 20, "aria-hidden": !0 })
  ) : null, et = () => {
    if (h === null)
      return null;
    if (!h || !N.isValidElement(h))
      return R || T ? N.createElement(
        Tt,
        { className: Jr.footer },
        N.createElement(SS, { key: "cancel", type: "secondary", onClick: R, onClose: (He) => {
          ue(He, { type: "cancelButtonClick" });
        }, ...C }, y),
        N.createElement(SS, { key: "ok", onClick: T, onClose: (He) => {
          ue(He, { type: "okButtonClick" });
        }, className: ot(Jr.okButton, le), ...qe }, g)
      ) : null;
    const rt = N.Children.only(h);
    return N.cloneElement(rt, { ...rt.props });
  }, Je = Ln((rt) => B && !K.current?.contains(rt.target), [B]);
  function tt() {
    M === "hover" && Se();
  }
  function Rt() {
    M === "hover" && De(void 0, { type: "hoverAway" });
  }
  Dn(() => {
    if (ye || !ie || !B)
      return;
    const rt = (Oe) => {
      De(Oe, { type: "blurAway" });
    };
    function He(Oe) {
      if (xe) {
        const Ze = Oe.target;
        (!Ze || !xe.contains(Ze) && !K.current?.contains(Ze)) && rt(Oe);
      }
    }
    return document.body.addEventListener("focusin", He), window.addEventListener("blur", rt), () => {
      document.body.removeEventListener("focusin", He), window.removeEventListener("blur", rt);
    };
  }, [ie, B, De, xe, ye]);
  const xt = Jt(q, E?.ref);
  return N.createElement(
    N.Fragment,
    null,
    E ? N.cloneElement(E, {
      ref: xt,
      "aria-describedby": E.props["aria-describedby"] ?? (ie ? he : void 0),
      "aria-expanded": E.props["aria-expanded"] ?? ((M === "click" || M === "contextMenu") && o === void 0 ? !!ie : void 0),
      onClick: (rt) => (M === "click" && ie ? De(rt, { type: "click" }) : M !== "contextMenu" && Se(), E.props.onClick?.(rt)),
      onContextMenu: (rt) => {
        M === "contextMenu" && (rt.preventDefault(), ie ? De(rt, { type: "contextMenu" }) : Se()), E.props.onContextMenu?.(rt);
      },
      onKeyDown: (rt) => {
        rt.key === "Escape" ? De(rt, { type: "escapeKeyDown" }) : rt.shiftKey && rt.key === "F10" && M === "contextMenu" && (ie ? De(rt, { type: "contextMenuKeyDown" }) : Se()), E.props.onKeyDown?.(rt);
      },
      onFocus: (rt) => {
        (M === "hover" || M === "focus") && (be.current && clearTimeout(be.current), se()), E.props.onFocus?.(rt);
      },
      onMouseEnter: (rt) => {
        tt(), E.props.onMouseEnter?.(rt);
      },
      onMouseLeave: (rt) => {
        Rt(), E.props.onMouseLeave?.(rt);
      }
    }) : null,
    J && Z && ie && M !== "hover" && N.createElement(mu, { open: ie, onClick: (rt) => {
      ue(rt, { type: "backdropClick" });
    }, ...G, sx: [
      (rt) => eJ(rt),
      ...Array.isArray(G?.sx) ? G.sx : [G?.sx]
    ] }),
    J && N.createElement(Is, { transition: !0, open: ie ?? !1, ref: Re, modifiers: [
      {
        name: "preventOverflow",
        options: { enabled: !0, boundariesElement: "viewport" }
      },
      {
        name: "arrow",
        options: {
          enabled: j,
          element: ce
        }
      },
      {
        name: "offset",
        options: {
          offset: [0, j ? 10 : 8]
        }
      }
    ], anchorEl: J, className: ot(Jr.root, i), onMouseEnter: tt, onMouseLeave: Rt, role: "presentation", ...fe }, ({ TransitionProps: rt }) => N.createElement(
      Al,
      { timeout: 200, ...rt },
      N.createElement(
        tJ,
        { focusBehavior: S ?? (!!l || !B) ? "loop" : "dismiss", "aria-modal": !B, className: Jr.paper, onEscape: (He) => {
          let Oe = "blurAway";
          if (He instanceof MouseEvent) {
            const Ze = He.target;
            if (Oe = "clickAway", Ze?.classList?.contains?.(dT.root))
              return;
          } else He?.type === "keydown" && He?.code === "Escape" && (Oe = "escapeKeyDown");
          ue(He, { type: Oe });
        }, id: he, shouldEscapeOnClickAway: Je, disableSentinel: S === void 0 ? r : !S, autoFocus: k, autoFocusCallback: A, restoreFocus: _, restoreFocusCallback: L, role: "dialog", ...ne },
        j ? N.createElement("span", { ref: Ce, className: Jr.arrow }) : null,
        N.createElement(
          Tt,
          { sx: { position: "relative" } },
          p ? N.createElement(Tt, { className: Jr.title }, p) : null,
          Ye(),
          f ? N.createElement(Tt, { className: Jr.content }, f) : null
        ),
        et()
      )
    ))
  );
}, nJ = Y(rJ)((e) => {
  const { theme: t, width: r, maxWidth: o, title: a, content: i, closable: l, mode: c } = e;
  return QX(t, { width: r, maxWidth: o, title: a, content: i, closable: l, mode: c });
}), oJ = N.forwardRef((e, t) => N.createElement(nJ, { ...e, ref: t }));
function wS(e, t) {
  return (r) => {
    const o = t?.(r);
    return e(r), o;
  };
}
function aJ(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
const k4 = x.forwardRef(({
  arrow: e = !1,
  title: t,
  children: r,
  describeChild: o,
  classes: a,
  mode: i,
  width: l,
  maxWidth: c,
  disablePortal: d = !1,
  PopperProps: p = {},
  trigger: f = ["hover", "touch", "focus"],
  open: h,
  onClose: g,
  onOpen: y,
  className: C,
  sx: b,
  // We extract the `enterDelay` prop and use 0 instead, to avoid the delay for ax
  // Then we use CSS animation to emulate the delay.
  enterDelay: v,
  disabled: T,
  ...R
}, $) => {
  const [E, S] = Bn({
    controlled: h,
    default: !1,
    name: "Tooltip",
    state: "open"
  }), k = x.useRef(null), A = Jt(k, p.ref), _ = x.useRef(), L = r.props, O = {}, F = new Set(aJ(f)), B = () => {
    clearTimeout(_.current);
  }, M = (X) => {
    E !== X && S(X);
  }, j = !!T || !t, W = (X, U = 0, H = () => {
  }) => {
    B(), !(j && X) && (U === 0 ? (M(X), H()) : _.current = setTimeout(() => {
      M(X), H();
    }, U));
  };
  x.useLayoutEffect(() => {
    j && E && W(!1, 0, () => g?.());
  }, [j]);
  const V = {
    disableFocusListener: !F.has("focus"),
    disableHoverListener: !F.has("hover"),
    disableTouchListener: !F.has("touch")
  };
  if (e || (F.has("click") && (O.onClick = wS((X) => {
    W(!0, 0, () => {
      y?.(X);
    });
  }, L.onClick)), F.has("contextMenu") && (O.onContextMenu = wS((X) => {
    X.preventDefault(), W(!0, 0, () => {
      y?.(X);
    });
  }, L.onContextMenu)), O.onKeyDown = (X) => {
    X.key === "Enter" || X.key === " " ? W(!0, 0, () => {
      y?.(X);
    }) : X.key === "Tab" && !d && E && W(!1, R?.leaveDelay ?? 0, () => {
      g?.(X);
    }), L.onKeyDown?.(X);
  }), !j && o !== !1 && (typeof t == "string" ? O["aria-description"] = R["aria-description"] ?? t : !e && (F.has("click") || F.has("contextMenu")) && (O["aria-expanded"] = R["aria-expanded"] ?? !!E)), CS(
    /* istanbul ignore next */
    () => F.has("click") || F.has("contextMenu"),
    "[Tooltip] You specified click or context menu trigger for Tooltip. It's probably not what you need for most cases. It's recommended to use Popover instead."
  ), CS(
    /* istanbul ignore next */
    () => e,
    "[Tooltip] You specified an arrow for Tooltip. It's probably not what you need for most cases. It's recommended to use Popover instead."
  ), e) {
    const X = F.has("hover") || F.has("touch") ? "hover" : "click";
    return x.createElement(oJ, { content: t, width: l, maxWidth: c, disablePortal: d, trigger: X, open: h, onOpen: y, onClose: g, className: C, placement: "top", sx: b, mode: i, disabled: T, enterDelay: v, role: "tooltip", ...R, ref: $ }, x.cloneElement(r, O));
  }
  return x.createElement(
    Il,
    { onClickAway: (X) => {
      const { target: U } = X;
      !(k.current === U || k.current?.contains(U)) && E && W(!1, R?.leaveDelay ?? 0, () => g?.(X));
    } },
    x.createElement(Cf, { className: C, sx: b, classes: {
      ...a,
      popper: ot(Za.popper, a?.popper),
      tooltip: ot(Za.tooltip, a?.tooltip)
    }, open: E, placement: "top", arrow: !1, describeChild: o ?? !0, PopperProps: {
      ...p,
      disablePortal: p.disablePortal ?? d,
      sx: [
        (X) => JX(X, { mode: i, width: l, maxWidth: c }),
        ...Array.isArray(p.sx) ? p.sx : [p.sx]
      ],
      ref: A
    }, TransitionProps: E ? {
      style: {
        transitionDelay: `${v ?? 100}ms`,
        transitionDuration: 150
      },
      timeout: (v ?? 100) + 150
    } : {}, onOpen: (X) => {
      W(!0), y?.(X);
    }, onClose: (X) => {
      W(!1), g?.(X);
    }, ref: $, title: t, enterDelay: 0, ...$o(R, ["style", "sx", "className"]), ...V }, x.cloneElement(r, O))
  );
});
function iJ(e, t) {
  const r = Xt(null), o = Xt();
  return [Ln((i) => {
    o.current?.(), i && (o.current = e(i)), r.current = i;
  }, t), r];
}
const sJ = ({ component: e = "div", title: t, tooltipProps: r, children: o, ...a }) => {
  const [i, l] = Ir(!1), c = Ln(() => {
    const h = p.current;
    h && l(h.clientWidth < h.scrollWidth);
  }, []), [d, p] = iJ((h) => {
    if (window.ResizeObserver) {
      const g = new window.ResizeObserver(c);
      return g.observe(h), c(), () => {
        g.disconnect();
      };
    }
  }, [c]), f = t ?? (typeof o == "string" ? o : void 0);
  return N.createElement(k4, { title: i ? f : void 0, disableInteractive: !0, "aria-describedby": void 0, "aria-description": "", ...r }, N.createElement(e, a, N.createElement(Tt, { sx: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
    verticalAlign: "top",
    maxWidth: "100%"
  }, ref: d }, o)));
}, Ld = "_SELECT_ALL";
function lJ(e, t) {
  const { t: r } = ua("Autocomplete");
  x.useEffect(() => {
    const { creatable: Oe, multiple: Ze, checkboxSelection: Pt, renderOption: Mt, showDuplicateLabels: Ct } = e;
    if (process.env.NODE_ENV !== "production" && (Oe && Ze && Pt && console.warn("[Autocomplete] Using creatable + multiple + checkboxSelection together may cause state synchronization issues. Consider using simpler combinations for better reliability."), Mt && Ct === !1 && console.warn("[Autocomplete] Using custom renderOption with showDuplicateLabels=false may cause rendering issues. Ensure your custom render function handles filtered options correctly."), Pt && typeof Pt == "object" && Pt.valueName)) {
      const { valueName: bt } = Pt;
      (typeof bt != "string" || bt.trim() === "") && console.warn("[Autocomplete] checkboxSelection.valueName should be a non-empty string representing a valid object property name.");
    }
  }, [e]);
  const o = $o(e, ["style", "disableClearable"]), { autoFocus: a, checkboxSelection: i, componentsProps: l = {}, creatable: c = !1, className: d, disabled: p, readOnly: f, allowClear: h, status: g, freeSolo: y, getCreateLabel: C = (Oe) => r("addLabel", { value: Oe }), getOptionLabel: b = (Oe) => Oe?.label ?? Oe, getLimitTagsText: v = (Oe) => r("limitTags", { more: Oe }), helperText: T, inputRef: R, inputProps: $, loadingText: E = r("loading"), multiple: S = !1, noOptionsText: k = r("noOptions"), onChange: A, value: _, optionFilterName: L = "children", options: O = [], sx: F = [], placeholder: B, size: M = "medium", getOptionDisabled: j, renderGroup: W, renderOption: V, longOptionsDisplay: X, showDuplicateLabels: U = !0, clearButtonProps: H = {}, ...Z } = o, [G, ye] = Tp(Z), { filterOptions: de, defaultValue: ne } = ye, fe = g === "error", ie = x.useRef(), [oe, ce] = x.useState();
  function Ce(Oe) {
    ye.onOpen?.(Oe), ce(ie.current?.clientWidth);
  }
  const xe = x.useRef(), Re = x.useRef(!1), J = (Oe) => {
    if (Re.current = Oe, !xe.current)
      return;
    const Ze = xe.current;
    Oe ? Ze.classList.contains(vn.canCreate) || Ze.classList.add(vn.canCreate) : !Oe && Ze.classList.contains(vn.canCreate) && Ze.classList.remove(vn.canCreate);
  }, { current: Ie } = x.useRef({
    [Ld]: `${i?.selectAllLabel || r("selectAll")} `
  }), [le, qe] = Zy(_, ne), { valueName: q } = i ?? {};
  x.useEffect(() => {
    _ === void 0 && ne === void 0 ? qe(S ? [] : null) : _ === void 0 && ne !== void 0 && qe(ne);
  }, [_, qe, S, ne]);
  const K = x.useCallback((Oe) => j?.(Oe) ?? Oe?.disabled ?? !1, [j]), ee = O.filter((Oe) => !K(Oe)), he = S && ee?.length && (typeof i == "boolean" ? i : !!i && (i?.showSelectAll ?? !0)), we = (Oe = le) => {
    if (!he)
      return !1;
    let Ze = 0;
    return ee.forEach((Pt) => {
      const Mt = _d(Pt, q);
      Oe?.some((bt) => _d(bt, q) === Mt) && Ze++;
    }), !!Ze && Ze === ee.length;
  }, se = we(), ue = he ? [Ie, ...O] : O, Qe = he ? se ? {
    value: i?.expandAllTags ? [...ue.slice(1), ue[0]] : [ue[0]]
  } : {
    value: le ?? []
  } : {}, { sx: We } = l.paper ?? {}, be = {
    ...l,
    paper: {
      ...l.paper,
      ref: Jt(xe, l?.paper?.ref),
      sx: [
        (Oe) => Md(Oe).paperStyle,
        ...Array.isArray(We) ? We : [We]
      ],
      className: ot(Nn.paper, Nn[M])
    },
    popupIndicator: {
      ...l.popupIndicator,
      "aria-hidden": !0
    },
    clearIndicator: {
      component: Tt,
      type: void 0,
      "aria-label": void 0,
      title: void 0,
      role: "none",
      ...l.popupIndicator
    }
  }, Se = (Oe) => Oe?._inputValue || Oe?.[Ld] || (Oe === null ? "" : b(Oe)), De = () => (Oe, Ze) => Oe == null || Ze == null ? Oe === Ze : Oe === Ze ? !0 : Oe._inputValue && Ze._inputValue ? Oe._inputValue === Ze._inputValue : Oe._inputValue && typeof Ze == "string" ? Oe._inputValue === Ze : typeof Oe == "string" && Ze._inputValue ? Oe === Ze._inputValue : Oe._inputValue || Ze._inputValue ? !1 : Oe.id !== void 0 && Ze.id !== void 0 ? Oe.id === Ze.id : Bg(Oe, Ze), Ye = (Oe, Ze) => {
    if (de) {
      const nt = [...de(Oe, Ze)];
      if (c) {
        const { inputValue: ft } = Ze, er = nt.some((Ut) => ft === Se(Ut));
        if (ft !== "" && !er) {
          const Ut = {
            _inputValue: ft
          };
          nt.push(Ut), setTimeout(() => {
            J(!0);
          }, 0);
        } else Re.current && J(!1);
      }
      return nt;
    }
    const Pt = Oe.reduce((bt, nt) => {
      const ft = Se(nt);
      return bt[ft] = (bt[ft] || 0) + 1, bt;
    }, {});
    let Ct = Mb({
      stringify: (bt) => {
        const nt = bt[L]?.toString() ?? Se(bt), ft = Se(bt);
        if (Pt[ft] > 1 && U) {
          const er = [
            bt.value,
            bt.id,
            bt.category,
            bt.description,
            bt.type
          ].filter((Ut) => Ut != null && Ut !== "").join(" ");
          return `${nt} ${er}`;
        }
        return nt;
      }
    })(Oe, Ze);
    if (!U) {
      const bt = /* @__PURE__ */ new Set();
      Ct = Ct.filter((nt) => {
        const ft = Se(nt);
        return bt.has(ft) ? !1 : (bt.add(ft), !0);
      });
    }
    if (c) {
      const { inputValue: bt } = Ze, nt = Oe.some((ft) => bt === Se(ft));
      if (bt !== "" && !nt) {
        const ft = {
          _inputValue: bt
        };
        Ct.push(ft), setTimeout(() => {
          J(!0);
        }, 0);
      } else Re.current && J(!1);
    }
    return Ct;
  }, et = (Oe, Ze, Pt, Mt) => {
    let Ct = Ze, bt = Ze;
    if (c)
      Array.isArray(Ze) ? bt = Ze.map((nt) => {
        const ft = hS(nt);
        return i && typeof nt == "object" && nt !== null && !nt._inputValue ? nt : ft;
      }) : bt = hS(Ze);
    else if (he) {
      const nt = i?.expandAllTags, ft = Mt?.option === Ie, er = Pt !== "removeOption" && ft;
      let Ut;
      nt ? Ut = er ? ee : Ze.filter((Ft) => Ft !== Ie) : er ? Ut = ee : Ut = Ze.find((Ft) => Ft[Ld]) ? ee.filter((Ft) => !Ze.find((ct) => Ft === ct)) : Ze, Pt === "removeOption" && ft && (Ut = []), Ct = Ut, bt = Ut;
    }
    if (_ === void 0 && qe(Ct), A) {
      const { nativeEvent: nt } = Oe, ft = new nt.constructor(nt.type, nt);
      Object.defineProperty(ft, "target", {
        writable: !0,
        value: { value: bt }
      }), A(ft, bt, Pt, Mt);
    }
  }, Je = (Oe, Ze) => {
    const Pt = (Mt) => Mt.map((Ct, bt) => {
      const nt = Se(Ct), ft = Ct === Ie, er = (Ft, ct) => bS(Ft, ct, "autocomplete-tag"), Ut = (Ft) => {
        if (ft)
          return `${nt}(${ee.length})`;
        if (Oe.filter((fr) => Se(fr) === nt).length > 1 && U) {
          const fr = Ft?.category || Ft?.type || Ft?.value || Ft?.id;
          return fr && fr !== nt ? `${nt} (${fr})` : nt;
        }
        return nt;
      };
      return x.createElement(RX, { "aria-hidden": !0, label: Ut(Ct), ...Ze({ index: bt }), key: er(Ct, bt) });
    });
    return i?.expandAllTags && Oe.find((Mt) => Mt === Ie) ? Pt(ue.filter((Mt) => Mt !== Ie)) : Pt(Oe);
  }, tt = (Oe) => x.createElement(
    x.Fragment,
    null,
    x.createElement(ky, { ...Oe, inputProps: {
      ...G,
      ...Oe.inputProps,
      ...$,
      // (partially) fix the behavior on MacOS with VO, which reads "completion selected" with aria-controls
      "aria-controls": void 0,
      "aria-description": S && le?.length ? r("selectedCount", { count: le.length }) : void 0
    }, placeholder: le?.length ? "" : B, inputRef: R, error: fe, autoFocus: a, sx: [(Ze) => Md(Ze, { size: M }).textFieldStyle], size: M }),
    T ? x.createElement(
      yf,
      { error: fe, role: "alert", sx: [(Ze) => Md(Ze).formHelperTextStyle] },
      fe && x.createElement(g4, { "aria-hidden": !0 }),
      x.createElement(Tt, { component: "span", sx: { ml: "4px" } }, T)
    ) : null
  ), xt = W ?? ((Oe) => x.createElement(
    "li",
    { key: Oe.key },
    x.createElement("div", { className: Ke.groupLabel }, Oe.group),
    x.createElement(Tt, { "aria-label": Oe.group, component: "ul", className: Ke.groupUl, sx: {
      padding: 0
    } }, Oe.children)
  )), rt = ({ multiline: Oe }) => {
    let Ze = 0;
    return function(Mt, Ct, { selected: bt }) {
      const nt = Ze++, ft = Ct?._inputValue, er = c && ft ? {
        className: ot(vn.addOption, Mt.className)
      } : {
        className: ot(Nn.withCheckbox, Mt.className)
      }, Ut = ft ? C(ft) : Se(Ct), Ft = !!Ct?.[Ld], ct = we(le), fr = !ct && le?.length > 0, at = K(Ct);
      let lt = bt;
      if (V && i)
        if (Ft)
          lt = ct;
        else {
          const Wt = _d(Ct, q), Lr = le?.some((hn) => _d(hn, q) === Wt) ?? !1;
          lt = ct || Lr;
        }
      let St;
      if (i) {
        const Wt = V ? lt : bt;
        St = at ? Wt : ct || Wt;
      } else
        St = at ? !1 : bt;
      const kt = (Wt, Lr) => bS(Wt, Lr, "autocomplete-option");
      return V ? V(Mt, Ct, {
        selected: lt,
        indeterminate: Ft ? fr : !1
      }) : x.createElement(
        "li",
        { ...Mt, ...er, key: kt(Ct, nt), role: "option", "aria-selected": St },
        x.createElement(
          Tt,
          { flex: "1 1 0%", display: "flex", minWidth: 0 },
          !!i && x.createElement(sX, { checked: St, indeterminate: Ft && fr, inputProps: { tabIndex: -1 }, sx: { mr: "8px" }, disabled: !Ft && K(Ct) }),
          x.createElement(Tt, { flex: "0 1 auto", minWidth: 0 }, Oe ? Ut : x.createElement(sJ, null, Ut))
        ),
        !i && St && x.createElement(MZ, { className: vn.checkedIcon })
      );
    };
  };
  let He;
  return _ !== void 0 ? S || i ? Array.isArray(_) ? He = _ : _ ? He = [_] : He = [] : He = _ : He = le ?? (i || S ? [] : null), x.createElement(Ub, { className: ot(d, vn.root, {
    [vn.readOnly]: f
  }), autoHighlight: !0, options: ue, multiple: i ? !0 : S, disabled: p, readOnly: f, disableClearable: !h, clearIcon: x.createElement(KX, { ...H }), disableCloseOnSelect: S, freeSolo: c || y, clearOnBlur: c ? !0 : !y && !S, getLimitTagsText: v, getOptionLabel: Se, filterOptions: Ye, isOptionEqualToValue: ye.isOptionEqualToValue ?? De(), componentsProps: be, popupIcon: x.createElement(_Z, { className: vn.suffixIcon, size: 16 }), loadingText: x.createElement("span", { role: "alert" }, E), noOptionsText: x.createElement("span", { role: "alert" }, k), onChange: et, value: He, renderInput: tt, renderGroup: xt, renderOption: rt({
    multiline: X === "multiline"
  }), renderTags: Je, getOptionDisabled: K, ref: (Oe) => {
    typeof t == "function" ? t(Oe) : t && (t.current = Oe), ie.current = Oe, Oe && ce(Oe.clientWidth);
  }, ...Qe, ...ye, slotProps: {
    ...ye.slotProps,
    popper: {
      style: {
        width: X === "multiline" || X === "trim" ? oe : void 0,
        minWidth: oe,
        maxWidth: "calc(100% - 32px)"
      },
      placement: "bottom-start",
      ...ye.slotProps?.popper
    }
  }, onOpen: Ce, sx: [
    (Oe) => Md(Oe, { size: M }).style,
    ...Array.isArray(F) ? F : [F]
  ] });
}
const TS = x.forwardRef(lJ);
function cJ(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontFamily: r.fontFamily,
    color: t.border.subtle.neutral,
    textAlign: 5
  };
}
const uJ = "Divider", tr = {
  root: `ui-Divider-root-${to()}`,
  textAlignLeft: "ui-Divider-textAlignLeft",
  textAlignRight: "ui-Divider-textAlignRight",
  wrapper: "ui-Divider-wrapper",
  flexItem: "ui-Divider-flexItem",
  withChildren: "ui-Divider-WithChildren",
  withChildrenVertical: "ui-Divider-withChildrenVertical",
  horizontal: "ui-Divider-horizontal",
  vertical: "ui-Divider-vertical",
  fullHeight: "ui-Divider-fullHeight"
};
function dJ(e, t) {
  const r = cJ(e), { unit: o = "px", orientationMargin: a } = t, [i, l] = mn({
    componentName: uJ,
    theme: e,
    dynamicToken: r
  }), c = l(i.textAlign), d = 100 - c, p = t?.dashed ? "dashed" : "solid", f = l(i.color);
  return {
    [`&.${tr.root}`]: {
      fontFamily: l(i.fontFamily),
      borderColor: f,
      borderStyle: p,
      [`&.${tr.horizontal}`]: {
        [`&.${tr.withChildren}::before, &.${tr.withChildren}::after`]: { borderTopColor: f, borderTopStyle: p }
      },
      [`&.${tr.withChildrenVertical}::before, &.${tr.withChildrenVertical}::after`]: {
        borderLeftColor: f,
        borderLeftStyle: p
      },
      [`&.${tr.vertical}:not(.${tr.flexItem}, .${tr.withChildrenVertical})`]: {
        display: "inline-block",
        minHeight: "1em",
        margin: "0 8px",
        verticalAlign: "-3px",
        [`&.${tr.fullHeight}`]: {
          height: "100%"
        }
      },
      [`&.${tr.vertical}.${tr.fullHeight}:not(.${tr.flexItem})`]: {
        height: "100%",
        verticalAlign: "middle"
      }
    },
    [`&.${tr.textAlignLeft}::before, &.${tr.textAlignRight}::after`]: {
      width: `${c}%`
    },
    [`&.${tr.textAlignRight}::before, &.${tr.textAlignLeft}::after`]: {
      width: `${d}%`
    },
    [`&.${tr.textAlignLeft}.orientationMargin::before`]: {
      width: `${a}${o}`
    },
    [`&.${tr.textAlignRight}.orientationMargin::after`]: {
      width: `${a}${o}`
    },
    ...a === 0 && {
      [`&.${tr.textAlignRight}.orientationMargin .${tr.wrapper}`]: {
        paddingRight: 0
      },
      [`&.${tr.textAlignLeft}.orientationMargin .${tr.wrapper}`]: {
        paddingLeft: 0
      }
    }
  };
}
const pJ = (e) => {
  const { orientation: t = "horizontal", fullHeight: r = !1, orientationMargin: o, className: a, sx: i } = e;
  return N.createElement(qc, { className: a, classes: {
    root: ot(tr.root, {
      [`${tr.fullHeight}`]: r && t === "vertical",
      [`${tr.horizontal}`]: t === "horizontal",
      [`${tr.vertical}`]: t === "vertical",
      orientationMargin: !!o || o === 0
    }),
    textAlignLeft: tr.textAlignLeft,
    textAlignRight: tr.textAlignRight,
    wrapper: tr.wrapper,
    flexItem: tr.flexItem,
    withChildren: tr.withChildren,
    withChildrenVertical: tr.withChildrenVertical
  }, ...$o(e, [
    "fullHeight",
    "dashed",
    "orientationMargin",
    "unit",
    "style"
  ]), sx: i });
}, fJ = Y(pJ)((e) => {
  const { theme: t, ...r } = e;
  return dJ(t, r);
}), mJ = N.forwardRef((e, t) => N.createElement(fJ, { ...e, ref: t }));
function hJ(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    font: {
      family: r.fontFamily
    },
    textDecoration: {
      default: {
        default: "none",
        hover: "underline",
        active: "underline"
      },
      primary: {
        default: "none",
        hover: "underline",
        active: "underline"
      },
      secondary: {
        default: "underline",
        hover: "underline",
        active: "underline"
      },
      disabled: {
        default: "none",
        hover: "none",
        active: "none"
      }
    },
    color: {
      default: {
        default: t.text.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      primary: {
        default: t.text.primary,
        hover: t.state.primary.hover,
        active: t.state.primary.press
      },
      secondary: {
        default: t.text.stronger.neutral,
        hover: t.text.strong.neutral,
        active: t.text.neutral
      },
      disabled: {
        default: t.state.disable,
        hover: t.state.disable,
        active: t.state.disable
      }
    },
    focusVisible: {
      outline: `2px solid ${t.border.primary}`
    }
  };
}
const ss = {
  root: `ui-Link-root-${to()}`,
  focusVisible: "ui-Link-focusVisible",
  icon: "ui-Link-icon",
  primary: "ui-Link-primary",
  secondary: "ui-Link-secondary"
};
function gJ(e, t) {
  const r = hJ(e), [o, a] = mn({
    componentName: "Link",
    theme: e,
    dynamicToken: r
  }), { type: i, disabled: l, underline: c } = t, d = i !== void 0 && Object.keys(o.color).includes(i) ? i : "default", p = (g) => {
    switch (c) {
      case "always":
        return "underline";
      case "none":
        return "none";
      case "hover":
        return g ? "underline" : "none";
      default:
        return;
    }
  }, f = {
    display: "inline-flex",
    alignItems: "center",
    fontFamily: o.font.family,
    color: a(o.color[d].default),
    textDecoration: p(!1) ?? a(o.textDecoration[d].default),
    textUnderlinePosition: "under",
    cursor: "pointer",
    verticalAlign: "baseline",
    "&:hover": {
      color: a(o.color[d].hover),
      textDecoration: p(!0) ?? a(o.textDecoration[d].hover),
      textUnderlinePosition: "under"
    },
    "&:active": {
      color: a(o.color[d].active),
      textDecoration: p(!0) ?? a(o.textDecoration[d].active)
    },
    ...l && {
      color: a(o.color.disabled.default),
      textDecoration: a(o.textDecoration.disabled.default),
      cursor: "not-allowed",
      "&:hover": {
        color: a(o.color.disabled.hover),
        textDecoration: a(o.textDecoration.disabled.hover)
      },
      "&:active": {
        color: a(o.color.disabled.active),
        textDecoration: a(o.textDecoration.disabled.active)
      }
    },
    [`html.${_l} &:focus-visible, body.${_l} &:focus-visible`]: {
      outline: a(o.focusVisible.outline),
      outlineOffset: 2,
      borderRadius: 2
    }
  };
  return {
    [`&.${ss.root}`]: f,
    [`& .${ss.icon}`]: {
      marginInlineStart: "4px"
    }
  };
}
const bJ = x.forwardRef((e, t) => x.createElement(
  Tt,
  { component: "span", className: e.className ?? "ui-Link-icon", ...e, sx: {
    ...e.sx,
    display: "flex",
    flexShrink: 0,
    transform: "scale(0.75) translateY(2px)"
  }, ref: t },
  x.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 9 9", fill: "none" },
    x.createElement("path", { d: "M8.33105 6.02637C8.33105 6.19499 8.27409 6.33626 8.16016 6.4502C8.04622 6.55957 7.91634 6.61426 7.77051 6.61426C7.62012 6.61426 7.48796 6.55729 7.37402 6.44336C7.26465 6.32943 7.20996 6.19954 7.20996 6.05371V4.44727L7.32617 1.76074L6.43066 2.79297L1.33105 7.89941C1.22168 8.00879 1.0918 8.06348 0.941406 8.06348C0.791016 8.06348 0.656576 8.00423 0.538086 7.88574C0.424154 7.76725 0.367188 7.63281 0.367188 7.48242C0.367188 7.33659 0.424154 7.20898 0.538086 7.09961L5.63086 1.99316L6.66309 1.11133L3.95605 1.20703H2.37695C2.23112 1.20703 2.10124 1.15234 1.9873 1.04297C1.87793 0.933594 1.82324 0.80599 1.82324 0.660156C1.82324 0.509766 1.87565 0.379883 1.98047 0.270508C2.08529 0.156576 2.22428 0.0996094 2.39746 0.0996094H7.72949C7.91178 0.0996094 8.05534 0.156576 8.16016 0.270508C8.26953 0.379883 8.32422 0.521159 8.32422 0.694336L8.33105 6.02637Z", fill: "currentColor" })
  )
)), yJ = N.forwardRef((e, t) => {
  const { disabled: r = !1, target: o, rel: a, children: i, endIcon: l, showArrowIcon: c = !0, classes: d, onClick: p, type: f, className: h, ...g } = e, y = o === "_blank", C = !a && y ? "noopener noreferrer" : a, b = ra(() => l || (y && c ? N.createElement(bJ, { className: ss.icon }) : null), [l, y, c]);
  let v = g;
  r && (v = $o(v, ["onClick", "href"]));
  function T(R) {
    R.currentTarget.tagName === "A" && !r && R.key === "Enter" && p?.(R), v.onKeyPress?.(R);
  }
  return N.createElement(
    iy,
    { ref: t, rel: C, target: o, role: "link", tabIndex: r ? -1 : 0, "aria-disabled": r, ...$o(v, ["style"]), onClick: r ? (R) => {
      R.preventDefault();
    } : p, onKeyPress: T, classes: {
      ...d,
      root: ss.root,
      focusVisible: ss.focusVisible
    }, className: ot({
      [ss.primary]: f === "primary",
      [ss.secondary]: f === "secondary"
    }, h) },
    i,
    b
  );
}), vJ = Y(yJ)((e) => {
  const { theme: t, disabled: r, type: o, underline: a } = e;
  return gJ(t, { disabled: r, type: o, underline: a });
}), xJ = N.forwardRef((e, t) => N.createElement(vJ, { ...e, ref: t }));
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
function CJ(e, t) {
  if (ro(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(e, t);
    if (ro(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function A4(e) {
  var t = CJ(e, "string");
  return ro(t) == "symbol" ? t : t + "";
}
function Uo(e, t, r) {
  return (t = A4(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ES(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ES(Object(r), !0).forEach(function(o) {
      Uo(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ES(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
var $h = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var OS;
function SJ() {
  return OS || (OS = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var i = "", l = 0; l < arguments.length; l++) {
          var c = arguments[l];
          c && (i = a(i, o(c)));
        }
        return i;
      }
      function o(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return r.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var l = "";
        for (var c in i)
          t.call(i, c) && i[c] && (l = a(l, c));
        return l;
      }
      function a(i, l) {
        return l ? i ? i + " " + l : i + l : i;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }($h)), $h.exports;
}
var wJ = SJ();
const zo = /* @__PURE__ */ e2(wJ);
function tl(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function Rh(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function _c(e, t, r, o) {
  if (r) {
    var a = t;
    if (t.type === "click") {
      var i = e.cloneNode(!0);
      a = Object.create(t, {
        target: {
          value: i
        },
        currentTarget: {
          value: i
        }
      }), i.value = "", r(a);
      return;
    }
    if (o !== void 0) {
      a = Object.create(t, {
        target: {
          value: e
        },
        currentTarget: {
          value: e
        }
      }), e.value = o, r(a);
      return;
    }
    r(a);
  }
}
function TJ(e, t) {
  if (e) {
    e.focus(t);
    var r = t || {}, o = r.cursor;
    if (o) {
      var a = e.value.length;
      switch (o) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(a, a);
          break;
        default:
          e.setSelectionRange(0, a);
      }
    }
  }
}
function Dg(e) {
  return typeof e > "u" || e === null ? "" : String(e);
}
var I4 = function(t) {
  var r, o, a = t.inputElement, i = t.prefixCls, l = t.prefix, c = t.suffix, d = t.addonBefore, p = t.addonAfter, f = t.className, h = t.style, g = t.disabled, y = t.readOnly, C = t.focused, b = t.triggerFocus, v = t.allowClear, T = t.value, R = t.handleReset, $ = t.hidden, E = t.classes, S = t.classNames, k = t.dataAttrs, A = t.styles, _ = t.components, L = _?.affixWrapper || "span", O = _?.groupWrapper || "span", F = _?.wrapper || "span", B = _?.groupAddon || "span", M = Xt(null), j = function(ie) {
    var oe;
    (oe = M.current) !== null && oe !== void 0 && oe.contains(ie.target) && b?.();
  }, W = function() {
    var ie;
    if (!v)
      return null;
    var oe = !g && !y && T, ce = "".concat(i, "-clear-icon"), Ce = ro(v) === "object" && v !== null && v !== void 0 && v.clearIcon ? v.clearIcon : "✖";
    return /* @__PURE__ */ N.createElement("span", {
      onClick: R,
      onMouseDown: function(Re) {
        return Re.preventDefault();
      },
      className: zo(ce, (ie = {}, Uo(ie, "".concat(ce, "-hidden"), !oe), Uo(ie, "".concat(ce, "-has-suffix"), !!c), ie)),
      role: "button",
      tabIndex: -1
    }, Ce);
  }, V = /* @__PURE__ */ ms(a, {
    value: T,
    hidden: $,
    className: zo((r = a.props) === null || r === void 0 ? void 0 : r.className, !Rh(t) && !tl(t) && f) || null,
    style: xo(xo({}, (o = a.props) === null || o === void 0 ? void 0 : o.style), !Rh(t) && !tl(t) ? h : {})
  });
  if (Rh(t)) {
    var X, U = "".concat(i, "-affix-wrapper"), H = zo(U, (X = {}, Uo(X, "".concat(U, "-disabled"), g), Uo(X, "".concat(U, "-focused"), C), Uo(X, "".concat(U, "-readonly"), y), Uo(X, "".concat(U, "-input-with-clear-btn"), c && v && T), X), !tl(t) && f, E?.affixWrapper, S?.affixWrapper), Z = (c || v) && /* @__PURE__ */ N.createElement("span", {
      className: zo("".concat(i, "-suffix"), S?.suffix),
      style: A?.suffix
    }, W(), c);
    V = /* @__PURE__ */ N.createElement(L, Ea({
      className: H,
      style: xo(xo({}, tl(t) ? void 0 : h), A?.affixWrapper),
      hidden: !tl(t) && $,
      onClick: j
    }, k?.affixWrapper, {
      ref: M
    }), l && /* @__PURE__ */ N.createElement("span", {
      className: zo("".concat(i, "-prefix"), S?.prefix),
      style: A?.prefix
    }, l), /* @__PURE__ */ ms(a, {
      value: T,
      hidden: null
    }), Z);
  }
  if (tl(t)) {
    var G = "".concat(i, "-group"), ye = "".concat(G, "-addon"), de = zo("".concat(i, "-wrapper"), G, E?.wrapper), ne = zo("".concat(i, "-group-wrapper"), f, E?.group);
    return /* @__PURE__ */ N.createElement(O, {
      className: ne,
      style: h,
      hidden: $
    }, /* @__PURE__ */ N.createElement(F, {
      className: de
    }, d && /* @__PURE__ */ N.createElement(B, {
      className: ye
    }, d), /* @__PURE__ */ ms(V, {
      hidden: null
    }), p && /* @__PURE__ */ N.createElement(B, {
      className: ye
    }, p)));
  }
  return V;
};
function jg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = Array(t); r < t; r++) o[r] = e[r];
  return o;
}
function EJ(e) {
  if (Array.isArray(e)) return jg(e);
}
function OJ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function N4(e, t) {
  if (e) {
    if (typeof e == "string") return jg(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? jg(e, t) : void 0;
  }
}
function $J() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eu(e) {
  return EJ(e) || OJ(e) || N4(e) || $J();
}
function RJ(e) {
  if (Array.isArray(e)) return e;
}
function PJ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var o, a, i, l, c = [], d = !0, p = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(d = (o = i.call(r)).done) && (c.push(o.value), c.length !== t); d = !0) ;
    } catch (f) {
      p = !0, a = f;
    } finally {
      try {
        if (!d && r.return != null && (l = r.return(), Object(l) !== l)) return;
      } finally {
        if (p) throw a;
      }
    }
    return c;
  }
}
function kJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Co(e, t) {
  return RJ(e) || PJ(e, t) || N4(e, t) || kJ();
}
function rv(e, t) {
  if (e == null) return {};
  var r, o, a = Pb(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++) r = i[o], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function $S(e) {
  var t = x.useRef();
  t.current = e;
  var r = x.useCallback(function() {
    for (var o, a = arguments.length, i = new Array(a), l = 0; l < a; l++)
      i[l] = arguments[l];
    return (o = t.current) === null || o === void 0 ? void 0 : o.call.apply(o, [t].concat(i));
  }, []);
  return r;
}
function AJ() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var RS = process.env.NODE_ENV !== "test" && AJ() ? x.useLayoutEffect : x.useEffect, zg = function(t, r) {
  var o = x.useRef(!0);
  RS(function() {
    return t(o.current);
  }, r), RS(function() {
    return o.current = !1, function() {
      o.current = !0;
    };
  }, []);
}, PS = function(t, r) {
  zg(function(o) {
    if (!o)
      return t();
  }, r);
};
function kS(e) {
  var t = x.useRef(!1), r = x.useState(e), o = Co(r, 2), a = o[0], i = o[1];
  x.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function l(c, d) {
    d && t.current || i(c);
  }
  return [a, l];
}
function Ph(e) {
  return e !== void 0;
}
function nv(e, t) {
  var r = t || {}, o = r.defaultValue, a = r.value, i = r.onChange, l = r.postState, c = kS(function() {
    return Ph(a) ? a : Ph(o) ? typeof o == "function" ? o() : o : typeof e == "function" ? e() : e;
  }), d = Co(c, 2), p = d[0], f = d[1], h = a !== void 0 ? a : p, g = l ? l(h) : h, y = $S(i), C = kS([h]), b = Co(C, 2), v = b[0], T = b[1];
  PS(function() {
    var $ = v[0];
    p !== $ && y(p, $);
  }, [v]), PS(function() {
    Ph(a) || f(a);
  }, [a]);
  var R = $S(function($, E) {
    f($, E), T([h], E);
  });
  return [g, R];
}
function IJ(e, t) {
  var r = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(o) {
    delete r[o];
  }), r;
}
var NJ = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "type", "classes", "classNames", "styles"], MJ = /* @__PURE__ */ Ps(function(e, t) {
  var r = e.autoComplete, o = e.onChange, a = e.onFocus, i = e.onBlur, l = e.onPressEnter, c = e.onKeyDown, d = e.prefixCls, p = d === void 0 ? "rc-input" : d, f = e.disabled, h = e.htmlSize, g = e.className, y = e.maxLength, C = e.suffix, b = e.showCount, v = e.type, T = v === void 0 ? "text" : v, R = e.classes, $ = e.classNames, E = e.styles, S = rv(e, NJ), k = nv(e.defaultValue, {
    value: e.value
  }), A = Co(k, 2), _ = A[0], L = A[1], O = Ir(!1), F = Co(O, 2), B = F[0], M = F[1], j = Xt(null), W = function(ne) {
    j.current && TJ(j.current, ne);
  };
  Ss(t, function() {
    return {
      focus: W,
      blur: function() {
        var ne;
        (ne = j.current) === null || ne === void 0 || ne.blur();
      },
      setSelectionRange: function(ne, fe, ie) {
        var oe;
        (oe = j.current) === null || oe === void 0 || oe.setSelectionRange(ne, fe, ie);
      },
      select: function() {
        var ne;
        (ne = j.current) === null || ne === void 0 || ne.select();
      },
      input: j.current
    };
  }), Dn(function() {
    M(function(de) {
      return de && f ? !1 : de;
    });
  }, [f]);
  var V = function(ne) {
    e.value === void 0 && L(ne.target.value), j.current && _c(j.current, ne, o);
  }, X = function(ne) {
    l && ne.key === "Enter" && l(ne), c?.(ne);
  }, U = function(ne) {
    M(!0), a?.(ne);
  }, H = function(ne) {
    M(!1), i?.(ne);
  }, Z = function(ne) {
    L(""), W(), j.current && _c(j.current, ne, o);
  }, G = function() {
    var ne = IJ(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ N.createElement("input", Ea({
      autoComplete: r
    }, ne, {
      onChange: V,
      onFocus: U,
      onBlur: H,
      onKeyDown: X,
      className: zo(p, Uo({}, "".concat(p, "-disabled"), f), $?.input),
      style: E?.input,
      ref: j,
      size: h,
      type: T
    }));
  }, ye = function() {
    var ne = Number(y) > 0;
    if (C || b) {
      var fe = Dg(_), ie = eu(fe).length, oe = ro(b) === "object" ? b.formatter({
        value: fe,
        count: ie,
        maxLength: y
      }) : "".concat(ie).concat(ne ? " / ".concat(y) : "");
      return /* @__PURE__ */ N.createElement(N.Fragment, null, !!b && /* @__PURE__ */ N.createElement("span", {
        className: zo("".concat(p, "-show-count-suffix"), Uo({}, "".concat(p, "-show-count-has-suffix"), !!C), $?.count),
        style: xo({}, E?.count)
      }, oe), C);
    }
    return null;
  };
  return /* @__PURE__ */ N.createElement(I4, Ea({}, S, {
    prefixCls: p,
    className: g,
    inputElement: G(),
    handleReset: Z,
    value: Dg(_),
    focused: B,
    triggerFocus: W,
    suffix: ye(),
    disabled: f,
    classes: R,
    classNames: $,
    styles: E
  }));
});
function M4(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontSize: {
      small: r.fontSize.subtitle,
      medium: r.fontSize.body,
      large: "16px",
      extraLarge: "16px"
    },
    fontFamily: r.fontFamily,
    fontWeight: r.fontWeight.body,
    Input: {
      height: {
        small: "24px",
        medium: "32px",
        large: "40px",
        extraLarge: "48px"
      },
      border: "1px solid",
      borderColor: t.component.input.border,
      color: t.text.stronger.neutral,
      placeholderColor: t.text.neutral,
      borderRadius: {
        small: "6px",
        medium: "8px",
        large: "10px",
        extraLarge: "12px"
      },
      padding: {
        small: "6px 8px",
        medium: "6px 8px",
        large: "6px 12px",
        extraLarge: "6px 12px"
      },
      backgroundColor: t.bg.default,
      focus: {
        outline: `2px solid ${t.border.primary}`,
        outlineOffset: 2
      }
    },
    label: {
      color: t.text.stronger.neutral,
      fontSize: 12,
      lineHeight: "20px",
      height: 20
    },
    helperText: {
      color: t.text.neutral,
      fontSize: 12,
      lineHeight: "16px",
      paddingLeft: 8,
      height: 16
    },
    required: {
      color: t.text.error,
      fontSize: 14,
      lineHeight: "20px",
      marginLeft: 2
    },
    optional: {
      color: t.text.strong.neutral,
      fontSize: 14,
      lineHeight: "20px",
      fontWeight: 400,
      marginLeft: 2
    },
    affix: {
      border: "1px solid",
      borderColor: t.component.input.border,
      padding: {
        small: "6px 8px",
        medium: "6px 8px",
        large: "6px 12px",
        extraLarge: "6px 12px"
      },
      backgroundColor: t.bg.default
    },
    hover: {
      backgroundColor: t.state.subtle.neutral.hover
    },
    prefix: {
      marginInlineEnd: 6
    },
    suffix: {
      marginInlineStart: 6
    },
    addon: {
      backgroundColor: t.fill.subtler.neutral,
      color: t.text.neutral,
      border: "1px solid",
      borderColor: t.component.input.border,
      padding: {
        small: "6px 8px",
        medium: "6px 8px",
        large: "6px 12px",
        extraLarge: "6px 12px"
      },
      lineHeight: "20px"
    },
    icon: {
      fill: t.text.neutral
    },
    clearIcon: {
      fill: t.text.neutral,
      marginRight: 4
    },
    loadingicon: {
      fill: t.text.neutral
    },
    searchIcon: {
      fill: t.text.neutral
    },
    visibleIcon: {
      fill: t.text.stronger.neutral
    },
    showCount: {
      color: t.text.neutral,
      fontSize: 12,
      lineHeight: "16px",
      fontWeight: 400
    },
    error: {
      borderColor: t.border.error
    },
    warning: {
      borderColor: t.border.warning
    },
    readOnly: {
      color: t.text.neutral,
      backgroundColor: t.fill.subtler.neutral
    },
    disabled: {
      color: t.state.disable,
      borderColor: t.state.subtle.disable,
      backgroundColor: t.bg.default,
      error: {
        borderColor: t.state.subtle.error.disable
      },
      warning: {
        // This is not available for now
        // borderColor: semantic.state.subtle.warning.disable,
        borderColor: t.state.subtle.warning.hover
      }
    },
    TextArea: {
      height: {
        small: 48,
        medium: 60,
        large: 72,
        extraLarge: 72
      },
      border: "1px solid",
      borderColor: t.component.input.border,
      color: t.text.stronger.neutral,
      placeholderColor: t.text.neutral,
      borderRadius: {
        small: "6px",
        medium: "8px",
        large: "10px",
        extraLarge: "12px"
      },
      padding: {
        small: "6px 8px",
        medium: "6px 8px",
        large: "6px 12px",
        extraLarge: "6px 12px"
      },
      lineHeight: {
        small: r.lineHeight.subtitle,
        medium: r.lineHeight.body,
        large: "20px",
        extraLarge: "20px"
      },
      backgroundColor: t.bg.default,
      allowClear: {
        TextArea: {
          paddingInlineEnd: 28
        }
      }
    }
  };
}
const _4 = "Input", Cr = "ui-Input", un = "ui-textarea", kh = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", pt = {
  // It is recommended that the root classname of the react-ui component be added with a random string.
  // This is mainly to avoid classname naming conflicts in the application
  root: `${Cr}-root-${to()}`,
  rootError: `${Cr}-root-error`,
  rootWarning: `${Cr}-root-warning`,
  input: `${Cr}-input`,
  inputDisabled: `${Cr}-input-disabled`,
  inputReadOnly: `${Cr}-input-readOnly`,
  label: `${Cr}-label`,
  helperText: `${Cr}-helper-text`,
  required: `${Cr}-required`,
  affix: `${Cr}-affix-wrapper`,
  affixFocused: `${Cr}-affix-wrapper-focused`,
  affixDisabled: `${Cr}-affix-wrapper-disabled`,
  affixReadOnly: `${Cr}-affix-wrapper-readonly`,
  suffix: `${Cr}-suffix`,
  prefix: `${Cr}-prefix`,
  clearIcon: `${Cr}-clear-icon`,
  clearIconHasSuffix: `${Cr}-clear-icon-has-suffix`,
  readOnly: `${Cr}-readOnly`,
  disabled: `${Cr}-disabled`,
  group: `${Cr}-group`,
  groupFocused: `${Cr}-group-focused`,
  groupDisabled: `${Cr}-group-disabled`,
  addon: `${Cr}-group-addon`,
  showCount: `${Cr}-show-count-suffix`,
  clearIconHidden: `${Cr}-clear-icon-hidden`,
  loadingIcon: `${Cr}-loading-icon`
}, $t = {
  root: `${un}-root-${to()}`,
  rootReadOnly: `${un}-root-readOnly`,
  rootShowCount: `${un}-root-show-count`,
  rootShowCountPosition: `${un}-root-show-count-position`,
  affix: `${un}-affix-wrapper`,
  affixFocused: `${un}-affix-wrapper-focused`,
  affixDisabled: `${un}-affix-wrapper-disabled`,
  textArea: `${un}-textArea`,
  textAreaDisabled: `${un}-disabled`,
  clearIcon: `${un}-clear-icon`,
  suffix: `${un}-suffix`,
  allowClear: `${un}-allow-clear`,
  showCount: `${un}-show-count-suffix`,
  showCountPosition: `${un}-show-count-position`,
  clearIconHidden: `${un}-clear-icon-hidden`,
  rootError: `${un}-root-error`,
  rootWarning: `${un}-root-warning`
}, Rp = {
  password: "ui-password",
  visibleIcon: "ui-password-visible-icon"
}, Pp = {
  search: "ui-search",
  searchIcon: "ui-search-icon-search"
};
function ov(e, t) {
  const r = M4(e), [o, a] = mn({
    componentName: _4,
    theme: e,
    dynamicToken: r
  }), { status: i, shouldRenderAffix: l, size: c = "medium" } = t, d = (() => {
    let f = {}, h = {};
    return i === "error" && (f = l ? {
      [`.${pt.affix}`]: {
        borderColor: a(o.error.borderColor),
        [`&.${pt.affixDisabled}`]: {
          borderColor: a(o.disabled.error.borderColor)
        }
      }
    } : {
      [`.${pt.input}`]: {
        borderColor: a(o.error.borderColor),
        [`&.${pt.inputDisabled}`]: {
          borderColor: a(o.disabled.error.borderColor)
        }
      }
    }), i === "warning" && (h = l ? {
      [`.${pt.affix}`]: {
        borderColor: a(o.warning.borderColor),
        [`&.${pt.affixDisabled}`]: {
          borderColor: a(o.disabled.warning.borderColor)
        }
      }
    } : {
      [`.${pt.input}`]: {
        borderColor: a(o.warning.borderColor),
        [`&.${pt.inputDisabled}`]: {
          borderColor: a(o.disabled.warning.borderColor)
        }
      }
    }), {
      [`&.${pt.rootError}`]: f,
      [`&.${pt.rootWarning}`]: h
    };
  })();
  return {
    [`&.${pt.root}`]: {
      lineHeight: a(o.Input.height[c]),
      maxWidth: "100%",
      [`.${pt.group}`]: {
        display: "flex",
        margin: 0,
        padding: 0,
        width: "100%",
        height: a(o.Input.height[c]),
        position: "relative",
        [`.${pt.input}`]: {
          flex: "1 0 0",
          minWidth: 0,
          "&:focus": {
            outline: "none"
          }
        },
        // The element is inside `rc-input` and it's not possible for emotion
        // to inject style elements into the group. Should be safe here in SSR.
        [`& > .${pt.input}:not(:first-child)${kh}`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        },
        [`& > .${pt.input}:not(:last-child)`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        },
        // The element is inside `rc-input` and it's not possible for emotion
        // to inject style elements into the group. Should be safe here in SSR.
        [`& > .${pt.affix}:not(:first-child)${kh}`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        },
        [`& > .${pt.affix}:not(:last-child)`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        },
        [`.${pt.addon}`]: {
          flex: "0 1 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          whiteSpace: "nowrap",
          backgroundColor: a(o.addon.backgroundColor),
          color: a(o.addon.color),
          border: a(o.addon.border),
          borderColor: a(o.addon.borderColor),
          borderRadius: a(o.Input.borderRadius[c]),
          padding: a(o.addon.padding[c]),
          lineHeight: a(o.addon.lineHeight),
          fontFamily: a(o.fontFamily),
          fontSize: a(o.fontSize[c]),
          fontWeight: a(o.fontWeight),
          // The element is inside `rc-input` and it's not possible for emotion
          // to inject style elements into the group. Should be safe here in SSR.
          [`&:first-child${kh}`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderInlineEnd: 0
          },
          "&:last-child": {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderInlineStart: 0
          }
        }
      },
      [`.${pt.affix}`]: {
        display: "inline-flex",
        verticalAlign: "top",
        height: a(o.Input.height[c]),
        padding: a(o.affix.padding[c]),
        border: a(o.affix.border),
        borderColor: a(o.affix.borderColor),
        borderRadius: a(o.Input.borderRadius[c]),
        boxSizing: "border-box",
        alignItems: "center",
        width: "100%",
        backgroundColor: a(o.affix.backgroundColor),
        [`&:hover:not(:focus, .${pt.disabled} *, .${pt.readOnly} *)`]: {
          backgroundColor: a(o.hover.backgroundColor),
          [`.${pt.input}`]: {
            backgroundColor: "unset"
          }
        },
        [`&.${pt.affixFocused}`]: {
          outline: a(o.Input.focus.outline),
          outlineOffset: a(o.Input.focus.outlineOffset),
          [`&:hover:not(:focus, .${pt.affixDisabled}, .${pt.affixReadOnly})`]: {
            backgroundColor: o.Input.backgroundColor
          }
        },
        [`&.${pt.affixReadOnly}`]: {
          color: a(o.readOnly.color),
          backgroundColor: a(o.readOnly.backgroundColor)
        },
        [`.${pt.input}`]: {
          height: "100%",
          width: "100%",
          padding: 0,
          border: "none",
          borderColor: "unset",
          borderRadius: 0,
          flex: "1 1 auto",
          "&:focus": {
            outline: "none"
          }
        },
        [`.${pt.prefix}`]: {
          display: "flex",
          height: "100%",
          alignItems: "center",
          marginInlineEnd: a(o.prefix.marginInlineEnd),
          fontSize: a(o.fontSize[c]),
          color: a(o.icon.fill)
          // '.zmicon': {
          //   display: 'inline-flex',
          //   alignItems: 'center',
          // },
        },
        [`.${pt.suffix}`]: {
          display: "flex",
          height: "100%",
          alignItems: "center",
          marginInlineStart: a(o.suffix.marginInlineStart),
          flex: "0 0 auto",
          fontSize: a(o.fontSize[c]),
          color: a(o.icon.fill)
        },
        [`.${Pp.searchIcon}`]: {
          color: a(o.searchIcon.fill)
        },
        [`.${pt.clearIcon}`]: {
          cursor: "pointer",
          flex: "0 0 auto",
          display: "inline-flex",
          alignItems: "center",
          marginInlineEnd: "-6px",
          svg: {
            width: 14,
            height: 14,
            viewBox: "0 0 14 14"
          },
          path: {
            fill: a(o.clearIcon.fill)
          },
          [`&.${pt.clearIconHasSuffix}`]: {
            marginInlineEnd: a(o.clearIcon.marginRight)
          },
          [`&.${pt.clearIconHidden}`]: {
            display: "none"
          }
        },
        [`.${Rp.visibleIcon}`]: {
          cursor: "pointer",
          marginInlineEnd: "-6px",
          svg: {
            path: {
              fill: a(o.visibleIcon.fill)
            }
          }
        },
        [`&.${pt.affixDisabled}`]: {
          color: a(o.disabled.color),
          borderColor: a(o.disabled.borderColor),
          backgroundColor: a(o.disabled.backgroundColor),
          [`.${pt.prefix}, .${pt.suffix}, .${Pp.searchIcon}, .${pt.loadingIcon}`]: {
            color: a(o.disabled.color)
          },
          [`.${Rp.visibleIcon}`]: {
            pointerEvents: "none",
            svg: {
              path: {
                fill: a(o.disabled.color)
              }
            }
          }
        },
        [`.${pt.showCount}`]: {
          color: a(o.showCount.color),
          lineHeight: a(o.showCount.lineHeight),
          fontFamily: a(o.fontFamily),
          fontSize: a(o.showCount.fontSize),
          fontWeight: a(o.showCount.fontWeight),
          flex: "1 0 auto"
        }
      },
      [`.${pt.groupFocused}`]: {
        [`.${pt.group}`]: {
          borderRadius: a(o.Input.borderRadius[c]),
          outline: a(o.Input.focus.outline),
          outlineOffset: a(o.Input.focus.outlineOffset),
          [`.${pt.affixFocused}`]: {
            outline: "none"
          }
        }
      },
      [`.${pt.groupDisabled}`]: {
        [`.${pt.addon}, .${pt.affix}`]: {
          color: a(o.disabled.color),
          borderColor: a(o.disabled.borderColor)
        }
      },
      [`.${pt.input}`]: {
        verticalAlign: "top",
        height: a(o.Input.height[c]),
        padding: a(o.Input.padding[c]),
        border: a(o.Input.border),
        borderColor: a(o.Input.borderColor),
        borderRadius: a(o.Input.borderRadius[c]),
        color: a(o.Input.color),
        fontFamily: a(o.fontFamily),
        fontSize: a(o.fontSize[c]),
        fontWeight: a(o.fontWeight),
        backgroundColor: a(o.Input.backgroundColor),
        width: "100%",
        boxSizing: "border-box",
        "&::placeholder": {
          color: a(o.Input.placeholderColor)
        },
        "&:disabled::placeholder": {
          color: a(o.disabled.color)
        },
        [`&:hover:not(:focus, .${pt.inputDisabled}, .${pt.inputReadOnly})`]: {
          backgroundColor: a(o.hover.backgroundColor)
        },
        [`&.${pt.inputReadOnly}`]: {
          color: a(o.readOnly.color),
          backgroundColor: a(o.readOnly.backgroundColor)
        },
        [`&.${pt.inputDisabled}`]: {
          color: a(o.disabled.color),
          borderColor: a(o.disabled.borderColor),
          backgroundColor: a(o.disabled.backgroundColor)
        },
        "&:focus-visible": {
          borderColor: a(o.Input.borderColor)
        },
        "&:focus": {
          outline: a(o.Input.focus.outline),
          outlineOffset: a(o.Input.focus.outlineOffset)
        }
      },
      [`.${pt.label}`]: {
        color: a(o.label.color),
        lineHeight: a(o.label.lineHeight),
        fontSize: a(o.label.fontSize),
        marginBottom: 2,
        height: a(o.label.height),
        baseAlign: "vertical",
        [`&.${pt.required}::after`]: {
          display: "inline-block",
          color: a(o.required.color),
          lineHeight: a(o.required.lineHeight),
          content: '"*"',
          fontSize: a(o.required.fontSize),
          marginInlineStart: a(o.required.marginLeft)
        },
        [`&.${pt.required}::after`]: {
          display: "inline-block",
          color: a(o.optional.color),
          lineHeight: a(o.optional.lineHeight),
          content: '"(Optional)"',
          fontSize: a(o.optional.fontSize),
          marginInlineStart: a(o.optional.marginLeft)
        }
      },
      [`.${pt.helperText}`]: {
        color: a(o.helperText.color),
        lineHeight: a(o.helperText.lineHeight),
        fontSize: a(o.helperText.fontSize),
        paddingLeft: a(o.helperText.paddingLeft),
        height: a(o.helperText.height)
      },
      ...d
    }
  };
}
function _J(e, t) {
  const r = M4(e), [o, a] = mn({
    componentName: _4,
    theme: e,
    dynamicToken: r
  }), { status: i, shouldRenderAffix: l, size: c = "medium", resizable: d } = t, p = (() => {
    let h = {}, g = {};
    return i === "error" && (h = l ? {
      [`.${$t.affix}`]: {
        borderColor: a(o.error.borderColor),
        [`&.${$t.affixDisabled}`]: {
          borderColor: a(o.disabled.error.borderColor)
        }
      }
    } : {
      [`.${$t.textArea}`]: {
        borderColor: a(o.error.borderColor),
        [`&.${$t.textAreaDisabled}`]: {
          borderColor: a(o.disabled.error.borderColor)
        }
      }
    }), i === "warning" && (g = l ? {
      [`.${$t.affix}`]: {
        borderColor: a(o.warning.borderColor),
        [`&.${$t.affixDisabled}`]: {
          borderColor: a(o.disabled.warning.borderColor)
        }
      }
    } : {
      [`.${$t.textArea}`]: {
        borderColor: a(o.warning.borderColor),
        [`&.${$t.textAreaDisabled}`]: {
          borderColor: a(o.disabled.warning.borderColor)
        }
      }
    }), {
      [`&.${$t.rootError}`]: h,
      [`&.${$t.rootWarning}`]: g
    };
  })();
  return {
    [`&.${$t.root}`]: {
      [`.${$t.textArea}`]: {
        width: "100%",
        height: a(o.TextArea.height[c]),
        padding: a(o.TextArea.padding[c]),
        border: a(o.TextArea.border),
        borderColor: a(o.TextArea.borderColor),
        borderRadius: a(o.TextArea.borderRadius[c]),
        color: a(o.TextArea.color),
        lineHeight: a(o.TextArea.lineHeight[c]),
        fontFamily: a(o.fontFamily),
        fontSize: a(o.fontSize[c]),
        fontWeight: a(o.fontWeight),
        backgroundColor: a(o.TextArea.backgroundColor),
        boxSizing: "border-box",
        display: "block",
        "&::placeholder": {
          color: a(o.TextArea.placeholderColor)
        },
        "&:disabled::placeholder": {
          color: a(o.disabled.color)
        },
        [`&:hover:not(:focus, .${$t.textAreaDisabled}, .${$t.rootReadOnly} *)`]: {
          backgroundColor: a(o.hover.backgroundColor)
        },
        "&:focus": {
          outline: a(o.Input.focus.outline),
          outlineOffset: a(o.Input.focus.outlineOffset)
        },
        [`&.${$t.textAreaDisabled}`]: {
          color: a(o.disabled.color),
          borderColor: a(o.disabled.borderColor),
          backgroundColor: a(o.disabled.backgroundColor)
        },
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        resize: d === !0 ? "both" : d || "none"
      },
      [`&.${$t.allowClear}`]: {
        [`.${$t.textArea}`]: {
          paddingInlineEnd: a(o.TextArea.allowClear.TextArea.paddingInlineEnd)
        }
      },
      [`.${$t.affix}`]: {
        display: "inline-flex",
        padding: 0,
        border: a(o.affix.border),
        borderColor: a(o.affix.borderColor),
        borderRadius: a(o.TextArea.borderRadius[c]),
        boxSizing: "border-box",
        alignItems: "center",
        width: "100%",
        position: "relative",
        [`&.${$t.affixFocused}`]: {
          outline: a(o.Input.focus.outline),
          outlineOffset: a(o.Input.focus.outlineOffset)
        },
        [`&.${$t.affixDisabled}`]: {
          color: a(o.disabled.color),
          borderColor: a(o.disabled.borderColor),
          backgroundColor: a(o.disabled.backgroundColor)
        },
        [`.${$t.textArea}`]: {
          border: "none",
          outline: "none"
        },
        [`.${$t.suffix}`]: {
          fontSize: a(o.fontSize.medium),
          ".zmicon": {
            display: "inline-flex",
            alignItems: "center"
          }
        },
        [`.${$t.clearIcon}`]: {
          cursor: "pointer",
          position: "absolute",
          top: "2px",
          right: "2px",
          svg: {
            width: 14,
            height: 14,
            viewBox: "0 0 14 14"
          },
          path: {
            fill: a(o.clearIcon.fill)
          },
          [`&.${$t.clearIconHidden}`]: {
            display: "none"
          }
        },
        [`.${$t.showCount}`]: {
          position: "absolute",
          [`&.${$t.showCountPosition}-top-start`]: {
            left: 0,
            top: -22
          },
          [`&.${$t.showCountPosition}-top-end`]: {
            right: 0,
            top: -22
          },
          [`&.${$t.showCountPosition}-bottom-start`]: {
            left: 0,
            bottom: -22
          },
          [`&.${$t.showCountPosition}-bottom-end`]: {
            right: 0,
            bottom: -22
          },
          color: a(o.showCount.color),
          lineHeight: a(o.showCount.lineHeight),
          fontFamily: a(o.fontFamily),
          fontSize: a(o.showCount.fontSize),
          fontWeight: a(o.showCount.fontWeight)
        }
      },
      [`&.${$t.rootReadOnly}`]: {
        [`.${$t.affix}`]: {
          color: a(o.readOnly.color),
          backgroundColor: a(o.readOnly.backgroundColor)
        },
        [`.${$t.textArea}:not(.${$t.textAreaDisabled})`]: {
          color: a(o.readOnly.color),
          backgroundColor: a(o.readOnly.backgroundColor)
        },
        [`.${$t.clearIcon}`]: {
          display: "none"
        }
      },
      [`&.${$t.rootShowCount}`]: {
        [`&.${$t.rootShowCountPosition}-bottom-start, &.${$t.rootShowCountPosition}-bottom-end`]: {
          paddingBottom: 20
        },
        [`&.${$t.rootShowCountPosition}-top-start, &.${$t.rootShowCountPosition}-top-end`]: {
          paddingTop: 20
        }
      },
      ...p
    }
  };
}
function F4({ className: e }) {
  const { t } = ua("Input"), r = Ln((o) => {
    o?.parentElement && (o.parentElement.removeAttribute("role"), o.parentElement.removeAttribute("tabindex"));
  }, []);
  return N.createElement(
    Di,
    { variant: "icon", type: "tertiary", size: "small", className: e, "aria-label": t("clear"), ref: r },
    N.createElement(kf, { "aria-hidden": !0 })
  );
}
function FJ(e) {
  const t = { ...e };
  return e.defaultValue === null && (t.defaultValue = ""), e.value === null && (t.value = ""), t;
}
const LJ = Ps((e, t) => {
  const r = FJ(e), { sx: o, prefix: a, suffix: i, addonBefore: l, addonAfter: c, className: d, allowClear: p, status: f, showCount: h, maxLength: g, onChange: y, onBlur: C, onFocus: b, onKeyDown: v, disabled: T, readOnly: R, inputRef: $, handlerRef: E, "aria-describedby": S, ...k } = r, { t: A } = ua("Input"), _ = Xy("input"), [L, O] = Ir(!1), F = Xt(null);
  Ss($, () => F.current?.input, []), Ss(E, () => ({
    blur: () => {
      F.current?.blur();
    },
    focus: () => {
      F.current?.focus();
    },
    select: () => {
      F.current?.select();
    },
    setSelectionRange: (ye, de, ne) => {
      F.current?.setSelectionRange(ye, de, ne);
    }
  }), []);
  let B;
  typeof p == "object" ? B = p : p && (B = {
    clearIcon: N.createElement(F4, { className: ot({
      [`${pt.clearIconHasSuffix}`]: !!i || h
    }) })
  });
  const M = (G) => {
    O(!1), C?.(G);
  }, j = (G) => {
    O(!0), b?.(G);
  }, W = (G) => {
    y?.(G);
  }, V = (G) => {
    if (v?.(G), g && !R && !T && !G.ctrlKey && !G.metaKey && (G.nativeEvent.isComposing || G.key.length === 1)) {
      const { currentTarget: ye } = G;
      setTimeout(() => {
        ye.value.length >= g && qy(A("maxLengthMessage", { maxLength: g }));
      }, 0);
    }
  }, X = typeof l == "string" ? A("prefix", { prefix: l }) : void 0, U = typeof c == "string" ? A("suffix", { suffix: c }) : void 0, H = X && U ? A("prefixAndSuffix", {
    prefix: l,
    suffix: c
  }) : X ?? U, Z = S ?? (H ? _("desc") : void 0);
  return N.createElement(
    Tt,
    { ref: t, className: ot(d, pt.root, { [`${pt.rootError}`]: f === "error" }, { [`${pt.rootWarning}`]: f === "warning" }, { [`${pt.disabled}`]: T }, { [`${pt.readOnly}`]: R }), sx: o },
    N.createElement(MJ, { ...k, addonAfter: c, addonBefore: l, onBlur: M, onFocus: j, onKeyDown: V, prefix: a, suffix: i, allowClear: B, prefixCls: Cr, onChange: W, showCount: h, maxLength: g, disabled: T, readOnly: R, "aria-describedby": Z, "aria-invalid": f === "error", classNames: {
      input: ot(pt.input, { [`${pt.inputDisabled}`]: T }, { [`${pt.inputReadOnly}`]: R })
    }, classes: {
      group: ot({ [`${pt.groupFocused}`]: L }, { [`${pt.groupDisabled}`]: T })
    }, ref: F }),
    H ? N.createElement("div", { id: _("desc"), style: { display: "none" } }, H) : null
  );
}), BJ = Y(LJ)((e) => {
  const { theme: t, disabled: r, readOnly: o, status: a, prefix: i, suffix: l, allowClear: c, size: d, showCount: p } = e;
  return ov(t, {
    status: a,
    size: d,
    shouldRenderAffix: !!i || !!l || !!c || !!p
  });
}), DJ = N.forwardRef((e, t) => N.createElement(BJ, { ...e, ref: t })), av = N.forwardRef((e, t) => {
  const r = $o(e, ["style"]);
  return N.createElement(DJ, { ...r, ref: t });
}), jJ = (e) => e ? N.createElement(LZ, null) : N.createElement(BZ, null), zJ = Ps((e, t) => {
  const { visible: r, onVisibleChange: o, iconRender: a = jJ, disabled: i, ...l } = e, { t: c } = ua("Input"), d = typeof r < "u", [p, f] = Ir(() => d ? r : !1), h = () => {
    i || f((y) => {
      const C = !y;
      return o?.(C), C;
    });
  }, g = () => {
    const y = a(p);
    return N.createElement(Di, { variant: "icon", type: "tertiary", size: "small", onClick: h, className: `${Rp.visibleIcon}`, disabled: i, tabIndex: i ? -1 : 0, "aria-label": c(p ? "hidePassword" : "showPassword"), key: "passwordIcon", onMouseDown: (C) => {
      C.preventDefault();
    }, onMouseUp: (C) => {
      C.preventDefault();
    } }, y);
  };
  return N.createElement(av, { suffix: g(), type: p ? "text" : "password", disabled: i, ...l, ref: t, className: ot(l.className, Rp.password) });
}), VJ = Y(zJ)((e) => {
  const { theme: t, disabled: r, readOnly: o, status: a, prefix: i, suffix: l, allowClear: c, size: d } = e;
  return ov(t, {
    status: a,
    size: d,
    shouldRenderAffix: !!i || !!l || !!c
  });
}), WJ = N.forwardRef((e, t) => N.createElement(VJ, { ...e, ref: t })), UJ = N.forwardRef((e, t) => {
  const r = $o(e, ["style"]);
  return N.createElement(WJ, { ...r, ref: t });
}), HJ = N.forwardRef((e, t) => {
  const { onSearch: r, onChange: o, onKeyDown: a, prefix: i, suffix: l, loading: c, inputRef: d, ...p } = e, f = Xt(null);
  Ss(d, () => f?.current, []);
  const h = (v) => {
    v?.target && v.type === "click" && r && r(v?.target?.value, v, {
      source: "clear"
    }), o && o(v);
  }, g = (v) => {
    r && r(f.current?.value, v, {
      source: "input"
    });
  }, y = (v) => {
    a?.(v), f.current && v.key === "Enter" && v.nativeEvent.isComposing === !1 && g(v);
  }, C = () => N.createElement(
    N.Fragment,
    null,
    N.createElement(YZ, { "aria-hidden": !0, className: ot(Pp.searchIcon) }),
    i
  ), b = () => N.createElement(
    N.Fragment,
    null,
    c && N.createElement(zZ, { className: ot(pt.loadingIcon) }),
    l
  );
  return N.createElement(av, { ...p, onKeyDown: y, prefix: C(), onChange: h, suffix: b(), className: ot(p.className, Pp.search), inputRef: f, ref: t, "aria-busy": c });
}), GJ = Y(HJ)((e) => {
  const { theme: t, disabled: r, readOnly: o, status: a, prefix: i, suffix: l, allowClear: c, size: d } = e;
  return ov(t, {
    status: a,
    size: d,
    shouldRenderAffix: !!i || !!l || !!c
  });
}), qJ = N.forwardRef((e, t) => N.createElement(GJ, { ...e, ref: t })), KJ = N.forwardRef((e, t) => {
  const r = $o(e, ["style"]);
  return N.createElement(qJ, { ...r, ref: t });
});
var YJ = Symbol.for("react.element"), ZJ = Symbol.for("react.transitional.element"), XJ = Symbol.for("react.fragment");
function L4(e) {
  return (
    // Base object type
    e && ro(e) === "object" && // React Element type
    (e.$$typeof === YJ || e.$$typeof === ZJ) && // React Fragment type
    e.type === XJ
  );
}
function Vg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return N.Children.forEach(e, function(o) {
    o == null && !t.keepEmpty || (Array.isArray(o) ? r = r.concat(Vg(o)) : L4(o) && o.props ? r = r.concat(Vg(o.props.children, t)) : r.push(o));
  }), r;
}
var JJ = [];
function AS(e, t) {
  if (process.env.NODE_ENV !== "production" && console !== void 0) {
    var r = JJ.reduce(function(o, a) {
      return a(o ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function IS(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function QJ(e) {
  return e && ro(e) === "object" && IS(e.nativeElement) ? e.nativeElement : IS(e) ? e : null;
}
function Ah(e) {
  var t = QJ(e);
  if (t)
    return t;
  if (e instanceof N.Component) {
    var r;
    return (r = cl.findDOMNode) === null || r === void 0 ? void 0 : r.call(cl, e);
  }
  return null;
}
var Bd = { exports: {} }, ur = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NS;
function eQ() {
  if (NS) return ur;
  NS = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), C;
  C = Symbol.for("react.module.reference");
  function b(v) {
    if (typeof v == "object" && v !== null) {
      var T = v.$$typeof;
      switch (T) {
        case e:
          switch (v = v.type, v) {
            case r:
            case a:
            case o:
            case p:
            case f:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case c:
                case l:
                case d:
                case g:
                case h:
                case i:
                  return v;
                default:
                  return T;
              }
          }
        case t:
          return T;
      }
    }
  }
  return ur.ContextConsumer = l, ur.ContextProvider = i, ur.Element = e, ur.ForwardRef = d, ur.Fragment = r, ur.Lazy = g, ur.Memo = h, ur.Portal = t, ur.Profiler = a, ur.StrictMode = o, ur.Suspense = p, ur.SuspenseList = f, ur.isAsyncMode = function() {
    return !1;
  }, ur.isConcurrentMode = function() {
    return !1;
  }, ur.isContextConsumer = function(v) {
    return b(v) === l;
  }, ur.isContextProvider = function(v) {
    return b(v) === i;
  }, ur.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, ur.isForwardRef = function(v) {
    return b(v) === d;
  }, ur.isFragment = function(v) {
    return b(v) === r;
  }, ur.isLazy = function(v) {
    return b(v) === g;
  }, ur.isMemo = function(v) {
    return b(v) === h;
  }, ur.isPortal = function(v) {
    return b(v) === t;
  }, ur.isProfiler = function(v) {
    return b(v) === a;
  }, ur.isStrictMode = function(v) {
    return b(v) === o;
  }, ur.isSuspense = function(v) {
    return b(v) === p;
  }, ur.isSuspenseList = function(v) {
    return b(v) === f;
  }, ur.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === a || v === o || v === p || v === f || v === y || typeof v == "object" && v !== null && (v.$$typeof === g || v.$$typeof === h || v.$$typeof === i || v.$$typeof === l || v.$$typeof === d || v.$$typeof === C || v.getModuleId !== void 0);
  }, ur.typeOf = b, ur;
}
var dr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MS;
function tQ() {
  return MS || (MS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), C = !1, b = !1, v = !1, T = !1, R = !1, $;
    $ = Symbol.for("react.module.reference");
    function E(le) {
      return !!(typeof le == "string" || typeof le == "function" || le === r || le === a || R || le === o || le === p || le === f || T || le === y || C || b || v || typeof le == "object" && le !== null && (le.$$typeof === g || le.$$typeof === h || le.$$typeof === i || le.$$typeof === l || le.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      le.$$typeof === $ || le.getModuleId !== void 0));
    }
    function S(le) {
      if (typeof le == "object" && le !== null) {
        var qe = le.$$typeof;
        switch (qe) {
          case e:
            var q = le.type;
            switch (q) {
              case r:
              case a:
              case o:
              case p:
              case f:
                return q;
              default:
                var K = q && q.$$typeof;
                switch (K) {
                  case c:
                  case l:
                  case d:
                  case g:
                  case h:
                  case i:
                    return K;
                  default:
                    return qe;
                }
            }
          case t:
            return qe;
        }
      }
    }
    var k = l, A = i, _ = e, L = d, O = r, F = g, B = h, M = t, j = a, W = o, V = p, X = f, U = !1, H = !1;
    function Z(le) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(le) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ye(le) {
      return S(le) === l;
    }
    function de(le) {
      return S(le) === i;
    }
    function ne(le) {
      return typeof le == "object" && le !== null && le.$$typeof === e;
    }
    function fe(le) {
      return S(le) === d;
    }
    function ie(le) {
      return S(le) === r;
    }
    function oe(le) {
      return S(le) === g;
    }
    function ce(le) {
      return S(le) === h;
    }
    function Ce(le) {
      return S(le) === t;
    }
    function xe(le) {
      return S(le) === a;
    }
    function Re(le) {
      return S(le) === o;
    }
    function J(le) {
      return S(le) === p;
    }
    function Ie(le) {
      return S(le) === f;
    }
    dr.ContextConsumer = k, dr.ContextProvider = A, dr.Element = _, dr.ForwardRef = L, dr.Fragment = O, dr.Lazy = F, dr.Memo = B, dr.Portal = M, dr.Profiler = j, dr.StrictMode = W, dr.Suspense = V, dr.SuspenseList = X, dr.isAsyncMode = Z, dr.isConcurrentMode = G, dr.isContextConsumer = ye, dr.isContextProvider = de, dr.isElement = ne, dr.isForwardRef = fe, dr.isFragment = ie, dr.isLazy = oe, dr.isMemo = ce, dr.isPortal = Ce, dr.isProfiler = xe, dr.isStrictMode = Re, dr.isSuspense = J, dr.isSuspenseList = Ie, dr.isValidElementType = E, dr.typeOf = S;
  }()), dr;
}
var _S;
function rQ() {
  return _S || (_S = 1, process.env.NODE_ENV === "production" ? Bd.exports = eQ() : Bd.exports = tQ()), Bd.exports;
}
var Ih = rQ();
function nQ(e, t, r) {
  var o = x.useRef({});
  return (!("value" in o.current) || r(o.current.condition, t)) && (o.current.value = e(), o.current.condition = t), o.current.value;
}
var oQ = Number($I.split(".")[0]), aQ = function(t, r) {
  typeof t == "function" ? t(r) : ro(t) === "object" && t && "current" in t && (t.current = r);
}, iQ = function() {
  for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
    r[o] = arguments[o];
  var a = r.filter(Boolean);
  return a.length <= 1 ? a[0] : function(i) {
    r.forEach(function(l) {
      aQ(l, i);
    });
  };
}, sQ = function() {
  for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
    r[o] = arguments[o];
  return nQ(function() {
    return iQ.apply(void 0, r);
  }, r, function(a, i) {
    return a.length !== i.length || a.every(function(l, c) {
      return l !== i[c];
    });
  });
}, lQ = function(t) {
  var r, o;
  if (!t)
    return !1;
  if (B4(t) && oQ >= 19)
    return !0;
  var a = Ih.isMemo(t) ? t.type.type : t.type;
  return !(typeof a == "function" && !((r = a.prototype) !== null && r !== void 0 && r.render) && a.$$typeof !== Ih.ForwardRef || typeof t == "function" && !((o = t.prototype) !== null && o !== void 0 && o.render) && t.$$typeof !== Ih.ForwardRef);
};
function B4(e) {
  return /* @__PURE__ */ pl(e) && !L4(e);
}
var cQ = function(t) {
  if (t && B4(t)) {
    var r = t;
    return r.props.propertyIsEnumerable("ref") ? r.props.ref : r.ref;
  }
  return null;
}, Wg = /* @__PURE__ */ x.createContext(null);
function uQ(e) {
  var t = e.children, r = e.onBatchResize, o = x.useRef(0), a = x.useRef([]), i = x.useContext(Wg), l = x.useCallback(function(c, d, p) {
    o.current += 1;
    var f = o.current;
    a.current.push({
      size: c,
      element: d,
      data: p
    }), Promise.resolve().then(function() {
      f === o.current && (r?.(a.current), a.current = []);
    }), i?.(c, d, p);
  }, [r, i]);
  return /* @__PURE__ */ x.createElement(Wg.Provider, {
    value: l
  }, t);
}
var D4 = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var o = -1;
    return t.some(function(a, i) {
      return a[0] === r ? (o = i, !0) : !1;
    }), o;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var o = e(this.__entries__, r), a = this.__entries__[o];
        return a && a[1];
      }, t.prototype.set = function(r, o) {
        var a = e(this.__entries__, r);
        ~a ? this.__entries__[a][1] = o : this.__entries__.push([r, o]);
      }, t.prototype.delete = function(r) {
        var o = this.__entries__, a = e(o, r);
        ~a && o.splice(a, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, o) {
        o === void 0 && (o = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var l = i[a];
          r.call(o, l[1], l[0]);
        }
      }, t;
    }()
  );
}(), Ug = typeof window < "u" && typeof document < "u" && window.document === document, kp = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), dQ = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(kp) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), pQ = 2;
function fQ(e, t) {
  var r = !1, o = !1, a = 0;
  function i() {
    r && (r = !1, e()), o && c();
  }
  function l() {
    dQ(i);
  }
  function c() {
    var d = Date.now();
    if (r) {
      if (d - a < pQ)
        return;
      o = !0;
    } else
      r = !0, o = !1, setTimeout(l, t);
    a = d;
  }
  return c;
}
var mQ = 20, hQ = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], gQ = typeof MutationObserver < "u", bQ = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = fQ(this.refresh.bind(this), mQ);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, o = r.indexOf(t);
      ~o && r.splice(o, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Ug || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), gQ ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Ug || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, o = r === void 0 ? "" : r, a = hQ.some(function(i) {
        return !!~o.indexOf(i);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), j4 = function(e, t) {
  for (var r = 0, o = Object.keys(t); r < o.length; r++) {
    var a = o[r];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Fl = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || kp;
}, z4 = Af(0, 0, 0, 0);
function Ap(e) {
  return parseFloat(e) || 0;
}
function FS(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(o, a) {
    var i = e["border-" + a + "-width"];
    return o + Ap(i);
  }, 0);
}
function yQ(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, o = 0, a = t; o < a.length; o++) {
    var i = a[o], l = e["padding-" + i];
    r[i] = Ap(l);
  }
  return r;
}
function vQ(e) {
  var t = e.getBBox();
  return Af(0, 0, t.width, t.height);
}
function xQ(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return z4;
  var o = Fl(e).getComputedStyle(e), a = yQ(o), i = a.left + a.right, l = a.top + a.bottom, c = Ap(o.width), d = Ap(o.height);
  if (o.boxSizing === "border-box" && (Math.round(c + i) !== t && (c -= FS(o, "left", "right") + i), Math.round(d + l) !== r && (d -= FS(o, "top", "bottom") + l)), !SQ(e)) {
    var p = Math.round(c + i) - t, f = Math.round(d + l) - r;
    Math.abs(p) !== 1 && (c -= p), Math.abs(f) !== 1 && (d -= f);
  }
  return Af(a.left, a.top, c, d);
}
var CQ = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Fl(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Fl(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function SQ(e) {
  return e === Fl(e).document.documentElement;
}
function wQ(e) {
  return Ug ? CQ(e) ? vQ(e) : xQ(e) : z4;
}
function TQ(e) {
  var t = e.x, r = e.y, o = e.width, a = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, l = Object.create(i.prototype);
  return j4(l, {
    x: t,
    y: r,
    width: o,
    height: a,
    top: r,
    right: t + o,
    bottom: a + r,
    left: t
  }), l;
}
function Af(e, t, r, o) {
  return { x: e, y: t, width: r, height: o };
}
var EQ = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Af(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = wQ(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), OQ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var o = TQ(r);
      j4(this, { target: t, contentRect: o });
    }
    return e;
  }()
), $Q = (
  /** @class */
  function() {
    function e(t, r, o) {
      if (this.activeObservations_ = [], this.observations_ = new D4(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = o;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Fl(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new EQ(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Fl(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(o) {
          return new OQ(o.target, o.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), V4 = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new D4(), W4 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = bQ.getInstance(), o = new $Q(t, r, this);
      V4.set(this, o);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  W4.prototype[e] = function() {
    var t;
    return (t = V4.get(this))[e].apply(t, arguments);
  };
});
var RQ = function() {
  return typeof kp.ResizeObserver < "u" ? kp.ResizeObserver : W4;
}(), ti = /* @__PURE__ */ new Map();
function U4(e) {
  e.forEach(function(t) {
    var r, o = t.target;
    (r = ti.get(o)) === null || r === void 0 || r.forEach(function(a) {
      return a(o);
    });
  });
}
var H4 = new RQ(U4);
process.env.NODE_ENV;
process.env.NODE_ENV;
function PQ(e, t) {
  ti.has(e) || (ti.set(e, /* @__PURE__ */ new Set()), H4.observe(e)), ti.get(e).add(t);
}
function kQ(e, t) {
  ti.has(e) && (ti.get(e).delete(t), ti.get(e).size || (H4.unobserve(e), ti.delete(e)));
}
function AQ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function IQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, A4(o.key), o);
  }
}
function NQ(e, t, r) {
  return t && IQ(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function MQ(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && mp(e, t);
}
function Ip(e) {
  return Ip = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ip(e);
}
function G4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (G4 = function() {
    return !!e;
  })();
}
function _Q(e, t) {
  if (t && (ro(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return gw(e);
}
function FQ(e) {
  var t = G4();
  return function() {
    var r, o = Ip(e);
    if (t) {
      var a = Ip(this).constructor;
      r = Reflect.construct(o, arguments, a);
    } else r = o.apply(this, arguments);
    return _Q(this, r);
  };
}
var LQ = /* @__PURE__ */ function(e) {
  MQ(r, e);
  var t = FQ(r);
  function r() {
    return AQ(this, r), t.apply(this, arguments);
  }
  return NQ(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(x.Component);
function BQ(e, t) {
  var r = e.children, o = e.disabled, a = x.useRef(null), i = x.useRef(null), l = x.useContext(Wg), c = typeof r == "function", d = c ? r(a) : r, p = x.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), f = !c && /* @__PURE__ */ x.isValidElement(d) && lQ(d), h = f ? cQ(d) : null, g = sQ(h, a), y = function() {
    var T;
    return Ah(a.current) || // Support `nativeElement` format
    (a.current && ro(a.current) === "object" ? Ah((T = a.current) === null || T === void 0 ? void 0 : T.nativeElement) : null) || Ah(i.current);
  };
  x.useImperativeHandle(t, function() {
    return y();
  });
  var C = x.useRef(e);
  C.current = e;
  var b = x.useCallback(function(v) {
    var T = C.current, R = T.onResize, $ = T.data, E = v.getBoundingClientRect(), S = E.width, k = E.height, A = v.offsetWidth, _ = v.offsetHeight, L = Math.floor(S), O = Math.floor(k);
    if (p.current.width !== L || p.current.height !== O || p.current.offsetWidth !== A || p.current.offsetHeight !== _) {
      var F = {
        width: L,
        height: O,
        offsetWidth: A,
        offsetHeight: _
      };
      p.current = F;
      var B = A === Math.round(S) ? S : A, M = _ === Math.round(k) ? k : _, j = xo(xo({}, F), {}, {
        offsetWidth: B,
        offsetHeight: M
      });
      l?.(j, v, $), R && Promise.resolve().then(function() {
        R(j, v);
      });
    }
  }, []);
  return x.useEffect(function() {
    var v = y();
    return v && !o && PQ(v, b), function() {
      return kQ(v, b);
    };
  }, [a.current, o]), /* @__PURE__ */ x.createElement(LQ, {
    ref: i
  }, f ? /* @__PURE__ */ x.cloneElement(d, {
    ref: g
  }) : d);
}
var q4 = /* @__PURE__ */ x.forwardRef(BQ);
process.env.NODE_ENV !== "production" && (q4.displayName = "SingleObserver");
var DQ = "rc-observer-key";
function jQ(e, t) {
  var r = e.children, o = typeof r == "function" ? [r] : Vg(r);
  return process.env.NODE_ENV !== "production" && (o.length > 1 ? AS(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : o.length === 0 && AS(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), o.map(function(a, i) {
    var l = a?.key || "".concat(DQ, "-").concat(i);
    return /* @__PURE__ */ x.createElement(q4, Ea({}, e, {
      key: l,
      ref: i === 0 ? t : void 0
    }), a);
  });
}
var iv = /* @__PURE__ */ x.forwardRef(jQ);
process.env.NODE_ENV !== "production" && (iv.displayName = "ResizeObserver");
iv.Collection = uQ;
var K4 = function(t) {
  return +setTimeout(t, 16);
}, Y4 = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (K4 = function(t) {
  return window.requestAnimationFrame(t);
}, Y4 = function(t) {
  return window.cancelAnimationFrame(t);
});
var LS = 0, If = /* @__PURE__ */ new Map();
function Z4(e) {
  If.delete(e);
}
var Np = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  LS += 1;
  var o = LS;
  function a(i) {
    if (i === 0)
      Z4(o), t();
    else {
      var l = K4(function() {
        a(i - 1);
      });
      If.set(o, l);
    }
  }
  return a(r), o;
};
Np.cancel = function(e) {
  var t = If.get(e);
  return Z4(e), Y4(t);
};
process.env.NODE_ENV !== "production" && (Np.ids = function() {
  return If;
});
var zQ = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, VQ = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], Nh = {}, jo;
function WQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && Nh[r])
    return Nh[r];
  var o = window.getComputedStyle(e), a = o.getPropertyValue("box-sizing") || o.getPropertyValue("-moz-box-sizing") || o.getPropertyValue("-webkit-box-sizing"), i = parseFloat(o.getPropertyValue("padding-bottom")) + parseFloat(o.getPropertyValue("padding-top")), l = parseFloat(o.getPropertyValue("border-bottom-width")) + parseFloat(o.getPropertyValue("border-top-width")), c = VQ.map(function(p) {
    return "".concat(p, ":").concat(o.getPropertyValue(p));
  }).join(";"), d = {
    sizingStyle: c,
    paddingSize: i,
    borderSize: l,
    boxSizing: a
  };
  return t && r && (Nh[r] = d), d;
}
function UQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  jo || (jo = document.createElement("textarea"), jo.setAttribute("tab-index", "-1"), jo.setAttribute("aria-hidden", "true"), document.body.appendChild(jo)), e.getAttribute("wrap") ? jo.setAttribute("wrap", e.getAttribute("wrap")) : jo.removeAttribute("wrap");
  var a = WQ(e, t), i = a.paddingSize, l = a.borderSize, c = a.boxSizing, d = a.sizingStyle;
  jo.setAttribute("style", "".concat(d, ";").concat(zQ)), jo.value = e.value || e.placeholder || "";
  var p = void 0, f = void 0, h, g = jo.scrollHeight;
  if (c === "border-box" ? g += l : c === "content-box" && (g -= i), r !== null || o !== null) {
    jo.value = " ";
    var y = jo.scrollHeight - i;
    r !== null && (p = y * r, c === "border-box" && (p = p + i + l), g = Math.max(p, g)), o !== null && (f = y * o, c === "border-box" && (f = f + i + l), h = g > f ? "" : "hidden", g = Math.min(f, g));
  }
  var C = {
    height: g,
    overflowY: h,
    resize: "none"
  };
  return p && (C.minHeight = p), f && (C.maxHeight = f), C;
}
var HQ = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], Mh = 0, _h = 1, Fh = 2, GQ = /* @__PURE__ */ x.forwardRef(function(e, t) {
  var r = e, o = r.prefixCls;
  r.onPressEnter;
  var a = r.defaultValue, i = r.value, l = r.autoSize, c = r.onResize, d = r.className, p = r.style, f = r.disabled, h = r.onChange, g = r.onInternalAutoSize, y = rv(r, HQ), C = nv(a, {
    value: i,
    postState: function(fe) {
      return fe ?? "";
    }
  }), b = Co(C, 2), v = b[0], T = b[1], R = function(fe) {
    T(fe.target.value), h?.(fe);
  }, $ = x.useRef();
  x.useImperativeHandle(t, function() {
    return {
      textArea: $.current
    };
  });
  var E = x.useMemo(function() {
    return l && ro(l) === "object" ? [l.minRows, l.maxRows] : [];
  }, [l]), S = Co(E, 2), k = S[0], A = S[1], _ = !!l, L = function() {
    try {
      if (document.activeElement === $.current) {
        var fe = $.current, ie = fe.selectionStart, oe = fe.selectionEnd, ce = fe.scrollTop;
        $.current.setSelectionRange(ie, oe), $.current.scrollTop = ce;
      }
    } catch {
    }
  }, O = x.useState(Fh), F = Co(O, 2), B = F[0], M = F[1], j = x.useState(), W = Co(j, 2), V = W[0], X = W[1], U = function() {
    M(Mh), process.env.NODE_ENV === "test" && g?.();
  };
  zg(function() {
    _ && U();
  }, [i, k, A, _]), zg(function() {
    if (B === Mh)
      M(_h);
    else if (B === _h) {
      var ne = UQ($.current, !1, k, A);
      M(Fh), X(ne);
    } else
      L();
  }, [B]);
  var H = x.useRef(), Z = function() {
    Np.cancel(H.current);
  }, G = function(fe) {
    B === Fh && (c?.(fe), l && (Z(), H.current = Np(function() {
      U();
    })));
  };
  x.useEffect(function() {
    return Z;
  }, []);
  var ye = _ ? V : null, de = xo(xo({}, p), ye);
  return (B === Mh || B === _h) && (de.overflowY = "hidden", de.overflowX = "hidden"), /* @__PURE__ */ x.createElement(iv, {
    onResize: G,
    disabled: !(l || c)
  }, /* @__PURE__ */ x.createElement("textarea", Ea({}, y, {
    ref: $,
    style: de,
    className: zo(o, d, Uo({}, "".concat(o, "-disabled"), f)),
    disabled: f,
    value: v,
    onChange: R
  })));
}), qQ = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "classes", "showCount", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"];
function X4(e, t) {
  return eu(e || "").slice(0, t).join("");
}
function BS(e, t, r, o) {
  var a = r;
  return e ? a = X4(r, o) : eu(t || "").length < r.length && eu(r || "").length > o && (a = t), a;
}
var KQ = /* @__PURE__ */ N.forwardRef(function(e, t) {
  var r, o = e.defaultValue, a = e.value, i = e.onFocus, l = e.onBlur, c = e.onChange, d = e.allowClear, p = e.maxLength, f = e.onCompositionStart, h = e.onCompositionEnd, g = e.suffix, y = e.prefixCls, C = y === void 0 ? "rc-textarea" : y, b = e.classes, v = e.showCount, T = e.className, R = e.style, $ = e.disabled, E = e.hidden, S = e.classNames, k = e.styles, A = e.onResize, _ = rv(e, qQ), L = nv(o, {
    value: a,
    defaultValue: o
  }), O = Co(L, 2), F = O[0], B = O[1], M = Xt(null), j = N.useState(!1), W = Co(j, 2), V = W[0], X = W[1], U = N.useState(!1), H = Co(U, 2), Z = H[0], G = H[1], ye = N.useRef(), de = N.useRef(0), ne = N.useState(null), fe = Co(ne, 2), ie = fe[0], oe = fe[1], ce = function() {
    var be;
    (be = M.current) === null || be === void 0 || be.textArea.focus();
  };
  Ss(t, function() {
    return {
      resizableTextArea: M.current,
      focus: ce,
      blur: function() {
        var be;
        (be = M.current) === null || be === void 0 || be.textArea.blur();
      }
    };
  }), Dn(function() {
    X(function(We) {
      return !$ && We;
    });
  }, [$]);
  var Ce = Number(p) > 0, xe = function(be) {
    G(!0), ye.current = F, de.current = be.currentTarget.selectionStart, f?.(be);
  }, Re = function(be) {
    G(!1);
    var Se = be.currentTarget.value;
    if (Ce) {
      var De, Ye = de.current >= p + 1 || de.current === ((De = ye.current) === null || De === void 0 ? void 0 : De.length);
      Se = BS(Ye, ye.current, Se, p);
    }
    Se !== F && (B(Se), _c(be.currentTarget, be, c, Se)), h?.(be);
  }, J = function(be) {
    var Se = be.target.value;
    if (!Z && Ce) {
      var De = be.target.selectionStart >= p + 1 || be.target.selectionStart === Se.length || !be.target.selectionStart;
      Se = BS(De, F, Se, p);
    }
    B(Se), _c(be.currentTarget, be, c, Se);
  }, Ie = function(be) {
    var Se = _.onPressEnter, De = _.onKeyDown;
    be.key === "Enter" && Se && Se(be), De?.(be);
  }, le = function(be) {
    X(!0), i?.(be);
  }, qe = function(be) {
    X(!1), l?.(be);
  }, q = function(be) {
    var Se;
    B(""), ce(), _c((Se = M.current) === null || Se === void 0 ? void 0 : Se.textArea, be, c);
  }, K = Dg(F);
  !Z && Ce && a == null && (K = X4(K, p));
  var ee = g, he;
  if (v) {
    var we = eu(K).length;
    ro(v) === "object" ? he = v.formatter({
      value: K,
      count: we,
      maxLength: p
    }) : he = "".concat(we).concat(Ce ? " / ".concat(p) : ""), ee = /* @__PURE__ */ N.createElement(N.Fragment, null, ee, /* @__PURE__ */ N.createElement("span", {
      className: zo("".concat(C, "-data-count"), S?.count),
      style: k?.count
    }, he));
  }
  var se = function(be) {
    var Se;
    A?.(be), (Se = M.current) !== null && Se !== void 0 && Se.textArea.style.height && oe(!0);
  }, ue = !_.autoSize && !v && !d, Qe = /* @__PURE__ */ N.createElement(I4, {
    value: K,
    allowClear: d,
    handleReset: q,
    suffix: ee,
    prefixCls: C,
    classes: {
      affixWrapper: zo(b?.affixWrapper, (r = {}, Uo(r, "".concat(C, "-show-count"), v), Uo(r, "".concat(C, "-textarea-allow-clear"), d), r))
    },
    disabled: $,
    focused: V,
    className: T,
    style: xo(xo({}, R), ie && !ue ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof he == "string" ? he : void 0
      }
    },
    hidden: E,
    inputElement: /* @__PURE__ */ N.createElement(GQ, Ea({}, _, {
      onKeyDown: Ie,
      onChange: J,
      onFocus: le,
      onBlur: qe,
      onCompositionStart: xe,
      onCompositionEnd: Re,
      className: S?.textarea,
      style: xo(xo({}, k?.textarea), {}, {
        resize: R?.resize
      }),
      disabled: $,
      prefixCls: C,
      onResize: se,
      ref: M
    }))
  });
  return Qe;
});
function YQ(e, t) {
  if (!e)
    return;
  e.focus(t);
  const { cursor: r } = t ?? {};
  if (r) {
    const o = e.value.length;
    switch (r) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(o, o);
        break;
      default:
        e.setSelectionRange(0, o);
        break;
    }
  }
}
const ZQ = Ps((e, t) => {
  const { sx: r, className: o, allowClear: a, readOnly: i, disabled: l, status: c, onChange: d, onPressEnter: p, onResize: f, onKeyDown: h, maxLength: g, showCount: y, showCountPosition: C = "bottom-start", handlerRef: b, resizable: v, ...T } = e, { t: R } = ua("Input"), $ = Xt(null);
  Ss(b, () => ({
    resizableTextArea: $.current?.resizableTextArea,
    focus: (k) => {
      YQ($.current?.resizableTextArea?.textArea, k);
    },
    blur: () => $.current?.blur(),
    setSelectionRange: (k, A, _) => {
      const L = $.current?.resizableTextArea?.textArea;
      L instanceof HTMLTextAreaElement && L.setSelectionRange(k, A, _);
    }
  }));
  let E;
  typeof a == "object" && a?.clearIcon ? E = a : a && (E = {
    clearIcon: N.createElement(F4, { className: $t.clearIcon })
  });
  const S = (k) => {
    if (h?.(k), g && !i && !l && !k.ctrlKey && !k.metaKey && (k.nativeEvent.isComposing || k.key.length === 1)) {
      const { currentTarget: A } = k;
      setTimeout(() => {
        A.value.length >= g && qy(R("maxLengthMessage", { maxLength: g }));
      }, 0);
    }
  };
  return N.createElement(
    Tt,
    { ref: t, className: ot($t.root, {
      [`${$t.allowClear}`]: a,
      [`${$t.rootReadOnly}`]: i,
      [`${$t.rootShowCount}`]: y,
      [`${$t.rootError}`]: c === "error",
      [`${$t.rootWarning}`]: c === "warning"
    }, `${$t.rootShowCountPosition}-${C}`, o), sx: r },
    N.createElement(KQ, { ...T, allowClear: E, prefixCls: un, classNames: {
      textarea: $t.textArea,
      count: ot($t.showCount, `${$t.showCountPosition}-${C}`)
    }, disabled: l, readOnly: i, onResize: f, onChange: d, onPressEnter: p, onKeyDown: S, ref: $, maxLength: g, showCount: y })
  );
}), XQ = Y(ZQ)((e) => {
  const { theme: t, status: r, allowClear: o, showCount: a, size: i } = e;
  return _J(t, {
    status: r,
    shouldRenderAffix: !!o || !!a,
    size: i,
    resizable: e.autoSize ? !1 : e.resizable ?? !1
  });
}), JQ = N.forwardRef((e, t) => N.createElement(XQ, { ...e, ref: t })), QQ = N.forwardRef((e, t) => {
  const r = $o(e, ["style"]);
  return N.createElement(JQ, { ...r, ref: t });
}), ho = av;
ho.Search = KJ;
ho.Password = UJ;
ho.TextArea = QQ;
var Cu = (e) => e.type === "checkbox", dl = (e) => e instanceof Date, _n = (e) => e == null;
const J4 = (e) => typeof e == "object";
var ln = (e) => !_n(e) && !Array.isArray(e) && J4(e) && !dl(e), Q4 = (e) => ln(e) && e.target ? Cu(e.target) ? e.target.checked : e.target.value : e, eee = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, e$ = (e, t) => e.has(eee(t)), tee = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return ln(t) && t.hasOwnProperty("isPrototypeOf");
}, sv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Fn(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(sv && (e instanceof Blob || e instanceof FileList)) && (r || ln(e)))
    if (t = r ? [] : {}, !r && !tee(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = Fn(e[o]));
  else
    return e;
  return t;
}
var Hl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], $r = (e) => e === void 0, st = (e, t, r) => {
  if (!t || !ln(e))
    return r;
  const o = Hl(t.split(/[,[\].]+?/)).reduce((a, i) => _n(a) ? a : a[i], e);
  return $r(o) || o === e ? $r(e[t]) ? r : e[t] : o;
};
const Mp = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ho = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qa = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, t$ = N.createContext(null), Su = () => N.useContext(t$), ree = (e) => {
  const { children: t, ...r } = e;
  return N.createElement(t$.Provider, { value: r }, t);
};
var r$ = (e, t, r, o = !0) => {
  const a = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(a, i, {
      get: () => {
        const l = i;
        return t._proxyFormState[l] !== Ho.all && (t._proxyFormState[l] = !o || Ho.all), r && (r[l] = !0), e[l];
      }
    });
  return a;
}, go = (e) => ln(e) && !Object.keys(e).length, n$ = (e, t, r, o) => {
  r(e);
  const { name: a, ...i } = e;
  return go(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((l) => t[l] === (!o || Ho.all));
}, So = (e) => Array.isArray(e) ? e : [e], o$ = (e, t, r) => r && t ? e === t : !e || !t || e === t || So(e).some((o) => o && (o.startsWith(t) || t.startsWith(o)));
function Nf(e) {
  const t = N.useRef(e);
  t.current = e, N.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
function a$(e) {
  const t = Su(), { control: r = t.control, disabled: o, name: a, exact: i } = e || {}, [l, c] = N.useState(r._formState), d = N.useRef(!0), p = N.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), f = N.useRef(a);
  return f.current = a, Nf({
    disabled: o,
    next: (h) => d.current && o$(f.current, h.name, i) && n$(h, p.current, r._updateFormState) && c({
      ...r._formState,
      ...h
    }),
    subject: r._subjects.state
  }), N.useEffect(() => (d.current = !0, p.current.isValid && r._updateValid(!0), () => {
    d.current = !1;
  }), [r]), r$(l, r, p.current, !1);
}
var Ca = (e) => typeof e == "string", i$ = (e, t, r, o, a) => Ca(e) ? (o && t.watch.add(e), st(r, e, a)) : Array.isArray(e) ? e.map((i) => (o && t.watch.add(i), st(r, i))) : (o && (t.watchAll = !0), r);
function nee(e) {
  const t = Su(), { control: r = t.control, name: o, defaultValue: a, disabled: i, exact: l } = e || {}, c = N.useRef(o);
  c.current = o, Nf({
    disabled: i,
    subject: r._subjects.values,
    next: (f) => {
      o$(c.current, f.name, l) && p(Fn(i$(c.current, r._names, f.values || r._formValues, !1, a)));
    }
  });
  const [d, p] = N.useState(r._getWatch(o, a));
  return N.useEffect(() => r._removeUnmounted()), d;
}
var lv = (e) => /^\w*$/.test(e), s$ = (e) => Hl(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function gr(e, t, r) {
  let o = -1;
  const a = lv(t) ? [t] : s$(t), i = a.length, l = i - 1;
  for (; ++o < i; ) {
    const c = a[o];
    let d = r;
    if (o !== l) {
      const p = e[c];
      d = ln(p) || Array.isArray(p) ? p : isNaN(+a[o + 1]) ? {} : [];
    }
    e[c] = d, e = e[c];
  }
  return e;
}
function oee(e) {
  const t = Su(), { name: r, control: o = t.control, shouldUnregister: a } = e, i = e$(o._names.array, r), l = nee({
    control: o,
    name: r,
    defaultValue: st(o._formValues, r, st(o._defaultValues, r, e.defaultValue)),
    exact: !0
  }), c = a$({
    control: o,
    name: r
  }), d = N.useRef(o.register(r, {
    ...e.rules,
    value: l
  }));
  return d.current = o.register(r, e.rules), N.useEffect(() => {
    const p = o._options.shouldUnregister || a, f = (h, g) => {
      const y = st(o._fields, h);
      y && (y._f.mount = g);
    };
    if (f(r, !0), p) {
      const h = Fn(st(o._options.defaultValues, r));
      gr(o._defaultValues, r, h), $r(st(o._formValues, r)) && gr(o._formValues, r, h);
    }
    return () => {
      (i ? p && !o._state.action : p) ? o.unregister(r) : f(r, !1);
    };
  }, [r, o, i, a]), {
    field: {
      name: r,
      value: l,
      onChange: N.useCallback((p) => d.current.onChange({
        target: {
          value: Q4(p),
          name: r
        },
        type: Mp.CHANGE
      }), [r]),
      onBlur: N.useCallback(() => d.current.onBlur({
        target: {
          value: st(o._formValues, r),
          name: r
        },
        type: Mp.BLUR
      }), [r, o]),
      ref: (p) => {
        const f = st(o._fields, r);
        f && p && (f._f.ref = {
          focus: () => p.focus(),
          select: () => p.select(),
          setCustomValidity: (h) => p.setCustomValidity(h),
          reportValidity: () => p.reportValidity()
        });
      }
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!st(c.errors, r)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!st(c.dirtyFields, r)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!st(c.touchedFields, r)
      },
      error: {
        enumerable: !0,
        get: () => st(c.errors, r)
      }
    })
  };
}
const aee = (e) => e.render(oee(e));
var iee = (e, t, r, o, a) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [o]: a || !0
  }
} : {};
const _p = (e, t, r) => {
  for (const o of r || Object.keys(e)) {
    const a = st(e, o);
    if (a) {
      const { _f: i, ...l } = a;
      if (i && t(i.name)) {
        if (i.ref.focus) {
          i.ref.focus();
          break;
        } else if (i.refs && i.refs[0].focus) {
          i.refs[0].focus();
          break;
        }
      } else ln(l) && _p(l, t);
    }
  }
};
var wi = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const r = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? r : r & 3 | 8).toString(16);
  });
}, Lh = (e, t, r = {}) => r.shouldFocus || $r(r.shouldFocus) ? r.focusName || `${e}.${$r(r.focusIndex) ? t : r.focusIndex}.` : "", Hg = (e) => ({
  isOnSubmit: !e || e === Ho.onSubmit,
  isOnBlur: e === Ho.onBlur,
  isOnChange: e === Ho.onChange,
  isOnAll: e === Ho.all,
  isOnTouch: e === Ho.onTouched
}), Gg = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((o) => e.startsWith(o) && /^\.\w+/.test(e.slice(o.length)))), l$ = (e, t, r) => {
  const o = Hl(st(e, r));
  return gr(o, "root", t[r]), gr(e, r, o), e;
}, vl = (e) => typeof e == "boolean", cv = (e) => e.type === "file", ki = (e) => typeof e == "function", Fp = (e) => {
  if (!sv)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, np = (e) => Ca(e), uv = (e) => e.type === "radio", Lp = (e) => e instanceof RegExp;
const DS = {
  value: !1,
  isValid: !1
}, jS = { value: !0, isValid: !0 };
var c$ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !$r(e[0].attributes.value) ? $r(e[0].value) || e[0].value === "" ? jS : { value: e[0].value, isValid: !0 } : jS
    ) : DS;
  }
  return DS;
};
const zS = {
  isValid: !1,
  value: null
};
var u$ = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, zS) : zS;
function VS(e, t, r = "validate") {
  if (np(e) || Array.isArray(e) && e.every(np) || vl(e) && !e)
    return {
      type: r,
      message: np(e) ? e : "",
      ref: t
    };
}
var rl = (e) => ln(e) && !Lp(e) ? e : {
  value: e,
  message: ""
}, qg = async (e, t, r, o, a) => {
  const { ref: i, refs: l, required: c, maxLength: d, minLength: p, min: f, max: h, pattern: g, validate: y, name: C, valueAsNumber: b, mount: v, disabled: T } = e._f, R = st(t, C);
  if (!v || T)
    return {};
  const $ = l ? l[0] : i, E = (B) => {
    o && $.reportValidity && ($.setCustomValidity(vl(B) ? "" : B || ""), $.reportValidity());
  }, S = {}, k = uv(i), A = Cu(i), _ = k || A, L = (b || cv(i)) && $r(i.value) && $r(R) || Fp(i) && i.value === "" || R === "" || Array.isArray(R) && !R.length, O = iee.bind(null, C, r, S), F = (B, M, j, W = qa.maxLength, V = qa.minLength) => {
    const X = B ? M : j;
    S[C] = {
      type: B ? W : V,
      message: X,
      ref: i,
      ...O(B ? W : V, X)
    };
  };
  if (a ? !Array.isArray(R) || !R.length : c && (!_ && (L || _n(R)) || vl(R) && !R || A && !c$(l).isValid || k && !u$(l).isValid)) {
    const { value: B, message: M } = np(c) ? { value: !!c, message: c } : rl(c);
    if (B && (S[C] = {
      type: qa.required,
      message: M,
      ref: $,
      ...O(qa.required, M)
    }, !r))
      return E(M), S;
  }
  if (!L && (!_n(f) || !_n(h))) {
    let B, M;
    const j = rl(h), W = rl(f);
    if (!_n(R) && !isNaN(R)) {
      const V = i.valueAsNumber || R && +R;
      _n(j.value) || (B = V > j.value), _n(W.value) || (M = V < W.value);
    } else {
      const V = i.valueAsDate || new Date(R), X = (Z) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Z), U = i.type == "time", H = i.type == "week";
      Ca(j.value) && R && (B = U ? X(R) > X(j.value) : H ? R > j.value : V > new Date(j.value)), Ca(W.value) && R && (M = U ? X(R) < X(W.value) : H ? R < W.value : V < new Date(W.value));
    }
    if ((B || M) && (F(!!B, j.message, W.message, qa.max, qa.min), !r))
      return E(S[C].message), S;
  }
  if ((d || p) && !L && (Ca(R) || a && Array.isArray(R))) {
    const B = rl(d), M = rl(p), j = !_n(B.value) && R.length > +B.value, W = !_n(M.value) && R.length < +M.value;
    if ((j || W) && (F(j, B.message, M.message), !r))
      return E(S[C].message), S;
  }
  if (g && !L && Ca(R)) {
    const { value: B, message: M } = rl(g);
    if (Lp(B) && !R.match(B) && (S[C] = {
      type: qa.pattern,
      message: M,
      ref: i,
      ...O(qa.pattern, M)
    }, !r))
      return E(M), S;
  }
  if (y) {
    if (ki(y)) {
      const B = await y(R, t), M = VS(B, $);
      if (M && (S[C] = {
        ...M,
        ...O(qa.validate, M.message)
      }, !r))
        return E(M.message), S;
    } else if (ln(y)) {
      let B = {};
      for (const M in y) {
        if (!go(B) && !r)
          break;
        const j = VS(await y[M](R, t), $, M);
        j && (B = {
          ...j,
          ...O(M, j.message)
        }, E(j.message), r && (S[C] = B));
      }
      if (!go(B) && (S[C] = {
        ref: $,
        ...B
      }, !r))
        return S;
    }
  }
  return E(!0), S;
};
function Bh(e, t) {
  return [...e, ...So(t)];
}
var Dh = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function jh(e, t, r) {
  return [
    ...e.slice(0, t),
    ...So(r),
    ...e.slice(t)
  ];
}
var zh = (e, t, r) => Array.isArray(e) ? ($r(e[r]) && (e[r] = void 0), e.splice(r, 0, e.splice(t, 1)[0]), e) : [];
function Vh(e, t) {
  return [...So(t), ...So(e)];
}
function see(e, t) {
  let r = 0;
  const o = [...e];
  for (const a of t)
    o.splice(a - r, 1), r++;
  return Hl(o).length ? o : [];
}
var Wh = (e, t) => $r(t) ? [] : see(e, So(t).sort((r, o) => r - o)), Uh = (e, t, r) => {
  e[t] = [e[r], e[r] = e[t]][0];
};
function lee(e, t) {
  const r = t.slice(0, -1).length;
  let o = 0;
  for (; o < r; )
    e = $r(e) ? o++ : e[t[o++]];
  return e;
}
function cee(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !$r(e[t]))
      return !1;
  return !0;
}
function dn(e, t) {
  const r = Array.isArray(t) ? t : lv(t) ? [t] : s$(t), o = r.length === 1 ? e : lee(e, r), a = r.length - 1, i = r[a];
  return o && delete o[i], a !== 0 && (ln(o) && go(o) || Array.isArray(o) && cee(o)) && dn(e, r.slice(0, -1)), e;
}
var WS = (e, t, r) => (e[t] = r, e);
function uee(e) {
  const t = Su(), { control: r = t.control, name: o, keyName: a = "id", shouldUnregister: i } = e, [l, c] = N.useState(r._getFieldArray(o)), d = N.useRef(r._getFieldArray(o).map(wi)), p = N.useRef(l), f = N.useRef(o), h = N.useRef(!1);
  f.current = o, p.current = l, r._names.array.add(o), e.rules && r.register(o, e.rules), Nf({
    next: ({ values: S, name: k }) => {
      if (k === f.current || !k) {
        const A = st(S, f.current);
        Array.isArray(A) && (c(A), d.current = A.map(wi));
      }
    },
    subject: r._subjects.array
  });
  const g = N.useCallback((S) => {
    h.current = !0, r._updateFieldArray(o, S);
  }, [r, o]), y = (S, k) => {
    const A = So(Fn(S)), _ = Bh(r._getFieldArray(o), A);
    r._names.focus = Lh(o, _.length - 1, k), d.current = Bh(d.current, A.map(wi)), g(_), c(_), r._updateFieldArray(o, _, Bh, {
      argA: Dh(S)
    });
  }, C = (S, k) => {
    const A = So(Fn(S)), _ = Vh(r._getFieldArray(o), A);
    r._names.focus = Lh(o, 0, k), d.current = Vh(d.current, A.map(wi)), g(_), c(_), r._updateFieldArray(o, _, Vh, {
      argA: Dh(S)
    });
  }, b = (S) => {
    const k = Wh(r._getFieldArray(o), S);
    d.current = Wh(d.current, S), g(k), c(k), r._updateFieldArray(o, k, Wh, {
      argA: S
    });
  }, v = (S, k, A) => {
    const _ = So(Fn(k)), L = jh(r._getFieldArray(o), S, _);
    r._names.focus = Lh(o, S, A), d.current = jh(d.current, S, _.map(wi)), g(L), c(L), r._updateFieldArray(o, L, jh, {
      argA: S,
      argB: Dh(k)
    });
  }, T = (S, k) => {
    const A = r._getFieldArray(o);
    Uh(A, S, k), Uh(d.current, S, k), g(A), c(A), r._updateFieldArray(o, A, Uh, {
      argA: S,
      argB: k
    }, !1);
  }, R = (S, k) => {
    const A = r._getFieldArray(o);
    zh(A, S, k), zh(d.current, S, k), g(A), c(A), r._updateFieldArray(o, A, zh, {
      argA: S,
      argB: k
    }, !1);
  }, $ = (S, k) => {
    const A = Fn(k), _ = WS(r._getFieldArray(o), S, A);
    d.current = [..._].map((L, O) => !L || O === S ? wi() : d.current[O]), g(_), c([..._]), r._updateFieldArray(o, _, WS, {
      argA: S,
      argB: A
    }, !0, !1);
  }, E = (S) => {
    const k = So(Fn(S));
    d.current = k.map(wi), g([...k]), c([...k]), r._updateFieldArray(o, [...k], (A) => A, {}, !0, !1);
  };
  return N.useEffect(() => {
    if (r._state.action = !1, Gg(o, r._names) && r._subjects.state.next({
      ...r._formState
    }), h.current && (!Hg(r._options.mode).isOnSubmit || r._formState.isSubmitted))
      if (r._options.resolver)
        r._executeSchema([o]).then((S) => {
          const k = st(S.errors, o), A = st(r._formState.errors, o);
          (A ? !k && A.type || k && (A.type !== k.type || A.message !== k.message) : k && k.type) && (k ? gr(r._formState.errors, o, k) : dn(r._formState.errors, o), r._subjects.state.next({
            errors: r._formState.errors
          }));
        });
      else {
        const S = st(r._fields, o);
        S && S._f && qg(S, r._formValues, r._options.criteriaMode === Ho.all, r._options.shouldUseNativeValidation, !0).then((k) => !go(k) && r._subjects.state.next({
          errors: l$(r._formState.errors, k, o)
        }));
      }
    r._subjects.values.next({
      name: o,
      values: { ...r._formValues }
    }), r._names.focus && _p(r._fields, (S) => !!S && S.startsWith(r._names.focus || "")), r._names.focus = "", r._updateValid();
  }, [l, o, r]), N.useEffect(() => (!st(r._formValues, o) && r._updateFieldArray(o), () => {
    (r._options.shouldUnregister || i) && r.unregister(o);
  }), [o, r, a, i]), {
    swap: N.useCallback(T, [g, o, r]),
    move: N.useCallback(R, [g, o, r]),
    prepend: N.useCallback(C, [g, o, r]),
    append: N.useCallback(y, [g, o, r]),
    remove: N.useCallback(b, [g, o, r]),
    insert: N.useCallback(v, [g, o, r]),
    update: N.useCallback($, [g, o, r]),
    replace: N.useCallback(E, [g, o, r]),
    fields: N.useMemo(() => l.map((S, k) => ({
      ...S,
      [a]: d.current[k] || wi()
    })), [l, a])
  };
}
function Hh() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const i of e)
        i.next && i.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((i) => i !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var Bp = (e) => _n(e) || !J4(e);
function fs(e, t) {
  if (Bp(e) || Bp(t))
    return e === t;
  if (dl(e) && dl(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), o = Object.keys(t);
  if (r.length !== o.length)
    return !1;
  for (const a of r) {
    const i = e[a];
    if (!o.includes(a))
      return !1;
    if (a !== "ref") {
      const l = t[a];
      if (dl(i) && dl(l) || ln(i) && ln(l) || Array.isArray(i) && Array.isArray(l) ? !fs(i, l) : i !== l)
        return !1;
    }
  }
  return !0;
}
var d$ = (e) => e.type === "select-multiple", dee = (e) => uv(e) || Cu(e), Gh = (e) => Fp(e) && e.isConnected, p$ = (e) => {
  for (const t in e)
    if (ki(e[t]))
      return !0;
  return !1;
};
function Dp(e, t = {}) {
  const r = Array.isArray(e);
  if (ln(e) || r)
    for (const o in e)
      Array.isArray(e[o]) || ln(e[o]) && !p$(e[o]) ? (t[o] = Array.isArray(e[o]) ? [] : {}, Dp(e[o], t[o])) : _n(e[o]) || (t[o] = !0);
  return t;
}
function f$(e, t, r) {
  const o = Array.isArray(e);
  if (ln(e) || o)
    for (const a in e)
      Array.isArray(e[a]) || ln(e[a]) && !p$(e[a]) ? $r(t) || Bp(r[a]) ? r[a] = Array.isArray(e[a]) ? Dp(e[a], []) : { ...Dp(e[a]) } : f$(e[a], _n(t) ? {} : t[a], r[a]) : r[a] = !fs(e[a], t[a]);
  return r;
}
var qh = (e, t) => f$(e, t, Dp(t)), m$ = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: o }) => $r(e) ? e : t ? e === "" ? NaN : e && +e : r && Ca(e) ? new Date(e) : o ? o(e) : e;
function Kh(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : t.disabled))
    return cv(t) ? t.files : uv(t) ? u$(e.refs).value : d$(t) ? [...t.selectedOptions].map(({ value: r }) => r) : Cu(t) ? c$(e.refs).value : m$($r(t.value) ? e.ref.value : t.value, e);
}
var pee = (e, t, r, o) => {
  const a = {};
  for (const i of e) {
    const l = st(t, i);
    l && gr(a, i, l._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: o
  };
}, yc = (e) => $r(e) ? e : Lp(e) ? e.source : ln(e) ? Lp(e.value) ? e.value.source : e.value : e, fee = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function US(e, t, r) {
  const o = st(e, r);
  if (o || lv(r))
    return {
      error: o,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const i = a.join("."), l = st(t, i), c = st(e, i);
    if (l && !Array.isArray(l) && r !== i)
      return { name: r };
    if (c && c.type)
      return {
        name: i,
        error: c
      };
    a.pop();
  }
  return {
    name: r
  };
}
var mee = (e, t, r, o, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(t || e) : (r ? o.isOnBlur : a.isOnBlur) ? !e : (r ? o.isOnChange : a.isOnChange) ? e : !0, hee = (e, t) => !Hl(st(e, t)).length && dn(e, t);
const gee = {
  mode: Ho.onSubmit,
  reValidateMode: Ho.onChange,
  shouldFocusError: !0
};
function bee(e = {}, t) {
  let r = {
    ...gee,
    ...e
  }, o = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ki(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, a = {}, i = ln(r.defaultValues) || ln(r.values) ? Fn(r.defaultValues || r.values) || {} : {}, l = r.shouldUnregister ? {} : Fn(i), c = {
    action: !1,
    mount: !1,
    watch: !1
  }, d = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, p, f = 0;
  const h = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, g = {
    values: Hh(),
    array: Hh(),
    state: Hh()
  }, y = e.resetOptions && e.resetOptions.keepDirtyValues, C = Hg(r.mode), b = Hg(r.reValidateMode), v = r.criteriaMode === Ho.all, T = (q) => (K) => {
    clearTimeout(f), f = setTimeout(q, K);
  }, R = async (q) => {
    if (h.isValid || q) {
      const K = r.resolver ? go((await L()).errors) : await F(a, !0);
      K !== o.isValid && g.state.next({
        isValid: K
      });
    }
  }, $ = (q) => h.isValidating && g.state.next({
    isValidating: q
  }), E = (q, K = [], ee, he, we = !0, se = !0) => {
    if (he && ee) {
      if (c.action = !0, se && Array.isArray(st(a, q))) {
        const ue = ee(st(a, q), he.argA, he.argB);
        we && gr(a, q, ue);
      }
      if (se && Array.isArray(st(o.errors, q))) {
        const ue = ee(st(o.errors, q), he.argA, he.argB);
        we && gr(o.errors, q, ue), hee(o.errors, q);
      }
      if (h.touchedFields && se && Array.isArray(st(o.touchedFields, q))) {
        const ue = ee(st(o.touchedFields, q), he.argA, he.argB);
        we && gr(o.touchedFields, q, ue);
      }
      h.dirtyFields && (o.dirtyFields = qh(i, l)), g.state.next({
        name: q,
        isDirty: M(q, K),
        dirtyFields: o.dirtyFields,
        errors: o.errors,
        isValid: o.isValid
      });
    } else
      gr(l, q, K);
  }, S = (q, K) => {
    gr(o.errors, q, K), g.state.next({
      errors: o.errors
    });
  }, k = (q, K, ee, he) => {
    const we = st(a, q);
    if (we) {
      const se = st(l, q, $r(ee) ? st(i, q) : ee);
      $r(se) || he && he.defaultChecked || K ? gr(l, q, K ? se : Kh(we._f)) : V(q, se), c.mount && R();
    }
  }, A = (q, K, ee, he, we) => {
    let se = !1, ue = !1;
    const Qe = {
      name: q
    };
    if (!ee || he) {
      h.isDirty && (ue = o.isDirty, o.isDirty = Qe.isDirty = M(), se = ue !== Qe.isDirty);
      const We = fs(st(i, q), K);
      ue = st(o.dirtyFields, q), We ? dn(o.dirtyFields, q) : gr(o.dirtyFields, q, !0), Qe.dirtyFields = o.dirtyFields, se = se || h.dirtyFields && ue !== !We;
    }
    if (ee) {
      const We = st(o.touchedFields, q);
      We || (gr(o.touchedFields, q, ee), Qe.touchedFields = o.touchedFields, se = se || h.touchedFields && We !== ee);
    }
    return se && we && g.state.next(Qe), se ? Qe : {};
  }, _ = (q, K, ee, he) => {
    const we = st(o.errors, q), se = h.isValid && vl(K) && o.isValid !== K;
    if (e.delayError && ee ? (p = T(() => S(q, ee)), p(e.delayError)) : (clearTimeout(f), p = null, ee ? gr(o.errors, q, ee) : dn(o.errors, q)), (ee ? !fs(we, ee) : we) || !go(he) || se) {
      const ue = {
        ...he,
        ...se && vl(K) ? { isValid: K } : {},
        errors: o.errors,
        name: q
      };
      o = {
        ...o,
        ...ue
      }, g.state.next(ue);
    }
    $(!1);
  }, L = async (q) => r.resolver(l, r.context, pee(q || d.mount, a, r.criteriaMode, r.shouldUseNativeValidation)), O = async (q) => {
    const { errors: K } = await L();
    if (q)
      for (const ee of q) {
        const he = st(K, ee);
        he ? gr(o.errors, ee, he) : dn(o.errors, ee);
      }
    else
      o.errors = K;
    return K;
  }, F = async (q, K, ee = {
    valid: !0
  }) => {
    for (const he in q) {
      const we = q[he];
      if (we) {
        const { _f: se, ...ue } = we;
        if (se) {
          const Qe = d.array.has(se.name), We = await qg(we, l, v, r.shouldUseNativeValidation && !K, Qe);
          if (We[se.name] && (ee.valid = !1, K))
            break;
          !K && (st(We, se.name) ? Qe ? l$(o.errors, We, se.name) : gr(o.errors, se.name, We[se.name]) : dn(o.errors, se.name));
        }
        ue && await F(ue, K, ee);
      }
    }
    return ee.valid;
  }, B = () => {
    for (const q of d.unMount) {
      const K = st(a, q);
      K && (K._f.refs ? K._f.refs.every((ee) => !Gh(ee)) : !Gh(K._f.ref)) && ie(q);
    }
    d.unMount = /* @__PURE__ */ new Set();
  }, M = (q, K) => (q && K && gr(l, q, K), !fs(G(), i)), j = (q, K, ee) => i$(q, d, {
    ...c.mount ? l : $r(K) ? i : Ca(q) ? { [q]: K } : K
  }, ee, K), W = (q) => Hl(st(c.mount ? l : i, q, e.shouldUnregister ? st(i, q, []) : [])), V = (q, K, ee = {}) => {
    const he = st(a, q);
    let we = K;
    if (he) {
      const se = he._f;
      se && (!se.disabled && gr(l, q, m$(K, se)), we = Fp(se.ref) && _n(K) ? "" : K, d$(se.ref) ? [...se.ref.options].forEach((ue) => ue.selected = we.includes(ue.value)) : se.refs ? Cu(se.ref) ? se.refs.length > 1 ? se.refs.forEach((ue) => (!ue.defaultChecked || !ue.disabled) && (ue.checked = Array.isArray(we) ? !!we.find((Qe) => Qe === ue.value) : we === ue.value)) : se.refs[0] && (se.refs[0].checked = !!we) : se.refs.forEach((ue) => ue.checked = ue.value === we) : cv(se.ref) ? se.ref.value = "" : (se.ref.value = we, se.ref.type || g.values.next({
        name: q,
        values: { ...l }
      })));
    }
    (ee.shouldDirty || ee.shouldTouch) && A(q, we, ee.shouldTouch, ee.shouldDirty, !0), ee.shouldValidate && Z(q);
  }, X = (q, K, ee) => {
    for (const he in K) {
      const we = K[he], se = `${q}.${he}`, ue = st(a, se);
      (d.array.has(q) || !Bp(we) || ue && !ue._f) && !dl(we) ? X(se, we, ee) : V(se, we, ee);
    }
  }, U = (q, K, ee = {}) => {
    const he = st(a, q), we = d.array.has(q), se = Fn(K);
    gr(l, q, se), we ? (g.array.next({
      name: q,
      values: { ...l }
    }), (h.isDirty || h.dirtyFields) && ee.shouldDirty && g.state.next({
      name: q,
      dirtyFields: qh(i, l),
      isDirty: M(q, se)
    })) : he && !he._f && !_n(se) ? X(q, se, ee) : V(q, se, ee), Gg(q, d) && g.state.next({ ...o }), g.values.next({
      name: q,
      values: { ...l }
    }), !c.mount && t();
  }, H = async (q) => {
    const K = q.target;
    let ee = K.name, he = !0;
    const we = st(a, ee), se = () => K.type ? Kh(we._f) : Q4(q);
    if (we) {
      let ue, Qe;
      const We = se(), be = q.type === Mp.BLUR || q.type === Mp.FOCUS_OUT, Se = !fee(we._f) && !r.resolver && !st(o.errors, ee) && !we._f.deps || mee(be, st(o.touchedFields, ee), o.isSubmitted, b, C), De = Gg(ee, d, be);
      gr(l, ee, We), be ? (we._f.onBlur && we._f.onBlur(q), p && p(0)) : we._f.onChange && we._f.onChange(q);
      const Ye = A(ee, We, be, !1), et = !go(Ye) || De;
      if (!be && g.values.next({
        name: ee,
        type: q.type,
        values: { ...l }
      }), Se)
        return h.isValid && R(), et && g.state.next({ name: ee, ...De ? {} : Ye });
      if (!be && De && g.state.next({ ...o }), $(!0), r.resolver) {
        const { errors: Je } = await L([ee]), tt = US(o.errors, a, ee), Rt = US(Je, a, tt.name || ee);
        ue = Rt.error, ee = Rt.name, Qe = go(Je);
      } else
        ue = (await qg(we, l, v, r.shouldUseNativeValidation))[ee], he = isNaN(We) || We === st(l, ee, We), he && (ue ? Qe = !1 : h.isValid && (Qe = await F(a, !0)));
      he && (we._f.deps && Z(we._f.deps), _(ee, Qe, ue, Ye));
    }
  }, Z = async (q, K = {}) => {
    let ee, he;
    const we = So(q);
    if ($(!0), r.resolver) {
      const se = await O($r(q) ? q : we);
      ee = go(se), he = q ? !we.some((ue) => st(se, ue)) : ee;
    } else q ? (he = (await Promise.all(we.map(async (se) => {
      const ue = st(a, se);
      return await F(ue && ue._f ? { [se]: ue } : ue);
    }))).every(Boolean), !(!he && !o.isValid) && R()) : he = ee = await F(a);
    return g.state.next({
      ...!Ca(q) || h.isValid && ee !== o.isValid ? {} : { name: q },
      ...r.resolver || !q ? { isValid: ee } : {},
      errors: o.errors,
      isValidating: !1
    }), K.shouldFocus && !he && _p(a, (se) => se && st(o.errors, se), q ? we : d.mount), he;
  }, G = (q) => {
    const K = {
      ...i,
      ...c.mount ? l : {}
    };
    return $r(q) ? K : Ca(q) ? st(K, q) : q.map((ee) => st(K, ee));
  }, ye = (q, K) => ({
    invalid: !!st((K || o).errors, q),
    isDirty: !!st((K || o).dirtyFields, q),
    isTouched: !!st((K || o).touchedFields, q),
    error: st((K || o).errors, q)
  }), de = (q) => {
    q && So(q).forEach((K) => dn(o.errors, K)), g.state.next({
      errors: q ? o.errors : {}
    });
  }, ne = (q, K, ee) => {
    const he = (st(a, q, { _f: {} })._f || {}).ref;
    gr(o.errors, q, {
      ...K,
      ref: he
    }), g.state.next({
      name: q,
      errors: o.errors,
      isValid: !1
    }), ee && ee.shouldFocus && he && he.focus && he.focus();
  }, fe = (q, K) => ki(q) ? g.values.subscribe({
    next: (ee) => q(j(void 0, K), ee)
  }) : j(q, K, !0), ie = (q, K = {}) => {
    for (const ee of q ? So(q) : d.mount)
      d.mount.delete(ee), d.array.delete(ee), K.keepValue || (dn(a, ee), dn(l, ee)), !K.keepError && dn(o.errors, ee), !K.keepDirty && dn(o.dirtyFields, ee), !K.keepTouched && dn(o.touchedFields, ee), !r.shouldUnregister && !K.keepDefaultValue && dn(i, ee);
    g.values.next({
      values: { ...l }
    }), g.state.next({
      ...o,
      ...K.keepDirty ? { isDirty: M() } : {}
    }), !K.keepIsValid && R();
  }, oe = (q, K = {}) => {
    let ee = st(a, q);
    const he = vl(K.disabled);
    return gr(a, q, {
      ...ee || {},
      _f: {
        ...ee && ee._f ? ee._f : { ref: { name: q } },
        name: q,
        mount: !0,
        ...K
      }
    }), d.mount.add(q), $r(K.value) || gr(l, q, K.value), ee ? he && gr(l, q, K.disabled ? void 0 : st(l, q, Kh(ee._f))) : k(q, !0, K.value), {
      ...he ? { disabled: K.disabled } : {},
      ...r.progressive ? {
        required: !!K.required,
        min: yc(K.min),
        max: yc(K.max),
        minLength: yc(K.minLength),
        maxLength: yc(K.maxLength),
        pattern: yc(K.pattern)
      } : {},
      name: q,
      onChange: H,
      onBlur: H,
      ref: (we) => {
        if (we) {
          oe(q, K), ee = st(a, q);
          const se = $r(we.value) && we.querySelectorAll && we.querySelectorAll("input,select,textarea")[0] || we, ue = dee(se), Qe = ee._f.refs || [];
          if (ue ? Qe.find((We) => We === se) : se === ee._f.ref)
            return;
          gr(a, q, {
            _f: {
              ...ee._f,
              ...ue ? {
                refs: [
                  ...Qe.filter(Gh),
                  se,
                  ...Array.isArray(st(i, q)) ? [{}] : []
                ],
                ref: { type: se.type, name: q }
              } : { ref: se }
            }
          }), k(q, !1, void 0, se);
        } else
          ee = st(a, q, {}), ee._f && (ee._f.mount = !1), (r.shouldUnregister || K.shouldUnregister) && !(e$(d.array, q) && c.action) && d.unMount.add(q);
      }
    };
  }, ce = () => r.shouldFocusError && _p(a, (q) => q && st(o.errors, q), d.mount), Ce = (q, K) => async (ee) => {
    ee && (ee.preventDefault && ee.preventDefault(), ee.persist && ee.persist());
    let he = Fn(l);
    if (g.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: we, values: se } = await L();
      o.errors = we, he = se;
    } else
      await F(a);
    dn(o.errors, "root"), go(o.errors) ? (g.state.next({
      errors: {}
    }), await q(he, ee)) : (K && await K({ ...o.errors }, ee), ce(), setTimeout(ce)), g.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: go(o.errors),
      submitCount: o.submitCount + 1,
      errors: o.errors
    });
  }, xe = (q, K = {}) => {
    st(a, q) && ($r(K.defaultValue) ? U(q, st(i, q)) : (U(q, K.defaultValue), gr(i, q, K.defaultValue)), K.keepTouched || dn(o.touchedFields, q), K.keepDirty || (dn(o.dirtyFields, q), o.isDirty = K.defaultValue ? M(q, st(i, q)) : M()), K.keepError || (dn(o.errors, q), h.isValid && R()), g.state.next({ ...o }));
  }, Re = (q, K = {}) => {
    const ee = q || i, he = Fn(ee), we = q && !go(q) ? he : i;
    if (K.keepDefaultValues || (i = ee), !K.keepValues) {
      if (K.keepDirtyValues || y)
        for (const se of d.mount)
          st(o.dirtyFields, se) ? gr(we, se, st(l, se)) : U(se, st(we, se));
      else {
        if (sv && $r(q))
          for (const se of d.mount) {
            const ue = st(a, se);
            if (ue && ue._f) {
              const Qe = Array.isArray(ue._f.refs) ? ue._f.refs[0] : ue._f.ref;
              if (Fp(Qe)) {
                const We = Qe.closest("form");
                if (We) {
                  We.reset();
                  break;
                }
              }
            }
          }
        a = {};
      }
      l = e.shouldUnregister ? K.keepDefaultValues ? Fn(i) : {} : Fn(we), g.array.next({
        values: { ...we }
      }), g.values.next({
        values: { ...we }
      });
    }
    d = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !c.mount && t(), c.mount = !h.isValid || !!K.keepIsValid, c.watch = !!e.shouldUnregister, g.state.next({
      submitCount: K.keepSubmitCount ? o.submitCount : 0,
      isDirty: K.keepDirty ? o.isDirty : !!(K.keepDefaultValues && !fs(q, i)),
      isSubmitted: K.keepIsSubmitted ? o.isSubmitted : !1,
      dirtyFields: K.keepDirtyValues ? o.dirtyFields : K.keepDefaultValues && q ? qh(i, q) : {},
      touchedFields: K.keepTouched ? o.touchedFields : {},
      errors: K.keepErrors ? o.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, J = (q, K) => Re(ki(q) ? q(l) : q, K);
  return {
    control: {
      register: oe,
      unregister: ie,
      getFieldState: ye,
      handleSubmit: Ce,
      setError: ne,
      _executeSchema: L,
      _getWatch: j,
      _getDirty: M,
      _updateValid: R,
      _removeUnmounted: B,
      _updateFieldArray: E,
      _getFieldArray: W,
      _reset: Re,
      _resetDefaultValues: () => ki(r.defaultValues) && r.defaultValues().then((q) => {
        J(q, r.resetOptions), g.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (q) => {
        o = {
          ...o,
          ...q
        };
      },
      _subjects: g,
      _proxyFormState: h,
      get _fields() {
        return a;
      },
      get _formValues() {
        return l;
      },
      get _state() {
        return c;
      },
      set _state(q) {
        c = q;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return d;
      },
      set _names(q) {
        d = q;
      },
      get _formState() {
        return o;
      },
      set _formState(q) {
        o = q;
      },
      get _options() {
        return r;
      },
      set _options(q) {
        r = {
          ...r,
          ...q
        };
      }
    },
    trigger: Z,
    register: oe,
    handleSubmit: Ce,
    watch: fe,
    setValue: U,
    getValues: G,
    reset: J,
    resetField: xe,
    clearErrors: de,
    unregister: ie,
    setError: ne,
    setFocus: (q, K = {}) => {
      const ee = st(a, q), he = ee && ee._f;
      if (he) {
        const we = he.refs ? he.refs[0] : he.ref;
        we.focus && (we.focus(), K.shouldSelect && we.select());
      }
    },
    getFieldState: ye
  };
}
function yee(e = {}) {
  const t = N.useRef(), r = N.useRef(), [o, a] = N.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ki(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: ki(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...bee(e, () => a((l) => ({ ...l }))),
    formState: o
  });
  const i = t.current.control;
  return i._options = e, Nf({
    subject: i._subjects.state,
    next: (l) => {
      n$(l, i._proxyFormState, i._updateFormState, !0) && a({ ...i._formState });
    }
  }), N.useEffect(() => {
    e.values && !fs(e.values, r.current) ? (i._reset(e.values, i._options.resetOptions), r.current = e.values) : i._resetDefaultValues();
  }, [e.values, i]), N.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), t.current.formState = r$(o, i), t.current;
}
const h$ = {
  default: "Validation error on field '{name}'",
  required: "'{name}' is required",
  min: "'{name}' must be minimum {min}",
  max: "'{name}' must be maximum {max}",
  minLength: "'{name}' must be at least {minLength} characters",
  maxLength: "'{name}' must be up to {maxLength} characters"
}, Mf = Symbol("FORM_INTERNAL_HOOKS"), Aa = N.createContext({
  labelAlign: "right",
  validateMessages: h$,
  form: null
}), vee = ["parentNode"], xee = "form_item";
function g$(e, t) {
  if (!e)
    return;
  const r = vee.includes(e);
  return t ? `${t}_${e}` : r ? `${xee}_${e}` : e;
}
function HS(e, t) {
  return e.replace(/\{\w+\}/g, (r) => {
    const o = r.slice(1, -1);
    return `${t[o]}`;
  });
}
function b$(e, t) {
  const { label: r, name: o, validateMessages: a } = t, i = {};
  return e?.forEach((l) => {
    const { message: c, validator: d, required: p, ...f } = l;
    if (Object.keys(f).forEach((h) => {
      const g = h, y = f[g], C = a[g], b = c ?? HS(C, {
        name: typeof r == "string" ? r : o,
        ...f
      });
      i[h] = { value: y, message: b };
    }), !aZ(p)) {
      let h = p, g = c;
      typeof p == "string" && (h = !0, c || (g = p));
      const y = a.required;
      g || (g = HS(y, {
        name: typeof r == "string" ? r : o
      })), i.required = { value: h, message: g };
    }
    d && typeof d == "function" && (i.validate = async (h, g) => {
      try {
        const y = await d(h, g);
        return await Promise.resolve(y);
      } catch (y) {
        return typeof y == "string" ? await Promise.resolve(y) : await Promise.resolve(y.message);
      }
    });
  }), i;
}
function GS(e, t) {
  let r = e;
  for (let o = 0; o < t.length; o += 1) {
    if (r == null)
      return;
    r = r[t[o]];
  }
  return r;
}
function qS(e) {
  return Array.isArray(e) ? [] : {};
}
function Cee(...e) {
  let t = qS(e[0]);
  return e.forEach((r) => {
    function o(a, i) {
      const l = new Set(i), c = GS(r, a), d = Array.isArray(c);
      if (d || sa(c) && !(c instanceof Date)) {
        if (!l.has(c)) {
          l.add(c);
          const p = GS(t, a);
          d ? t = Mc(t, a, []) : (!p || typeof p != "object") && (t = Mc(t, a, qS(c))), Oq(c).forEach((f) => {
            o([...a, f], l);
          });
        }
      } else
        t = Mc(t, a, c);
    }
    o([]);
  }), t;
}
function y$(e, t = "") {
  return Object.keys(e).reduce((r, o) => {
    const a = `${t}.${o}`, i = ps(e, o);
    return typeof i == "object" && i && !i._f ? r.concat(y$(i, `${a}`)) : r.concat(a);
  }, []);
}
function See(e) {
  const t = [], r = Object.keys(e);
  for (let o = 0; o < r.length; o++) {
    const a = r[o], i = ps(e, a);
    if (i) {
      const { _f: l } = i;
      l ? t.push(a) : t.push(...y$(i, a));
    }
  }
  return t;
}
class wee {
  constructor(t) {
    this.callbacks = {}, this.getInitialValues = () => this.rhfForm.control._options.defaultValues, this.getFieldValue = (r) => this.rhfForm.getValues(r), this.getFieldsValue = (r) => {
      if (r && r.length > 0) {
        const o = this.rhfForm.getValues(r), a = {};
        return r.forEach((i, l) => {
          Mc(a, i, o[l]);
        }), a;
      }
      return this.rhfForm.getValues();
    }, this.getFieldError = (r) => {
      const { errors: o, isValid: a } = this.rhfForm.formState;
      if (a)
        return [];
      const i = ps(o, r);
      if (i?.root)
        return [i.root.message];
      if (Array.isArray(i)) {
        const l = [];
        return i.forEach((c) => {
          c && Object.keys(c).forEach((d) => {
            l.push(c[d].message);
          });
        }), l;
      }
      return i?.message ? [i.message] : [];
    }, this.getFieldsError = (r) => {
      const o = r ?? See(this.rhfForm.control._fields), a = [];
      return o.forEach((i) => {
        const l = ps(this.rhfForm.control._formState.errors, i);
        l && (l?.root ? a.push({ name: i, errors: [l.root.message] }) : Array.isArray(l) ? l.filter(Boolean).forEach((c, d) => {
          Object.keys(c).forEach((p) => {
            const f = [i, d, p].join("."), h = c[p].message;
            a.push({ name: f, errors: [h] });
          });
        }) : a.push({
          name: i,
          errors: [l.message]
        }));
      }), a;
    }, this.setFieldValue = (r, o) => {
      this.rhfForm.setValue(r, o);
    }, this.setFieldsValue = (r) => {
      const o = this.rhfForm.getValues();
      this.rhfForm.reset(Cee(o, r), {
        keepDefaultValues: !0
      });
    }, this.resetFields = (r) => {
      const o = {
        ...this.getInitialValues()
      };
      if (!r) {
        this.rhfForm.reset(o, {
          keepDirtyValues: !1,
          keepValues: !1,
          keepDefaultValues: !0
        });
        return;
      }
      const a = { ...this.rhfForm.getValues() };
      r?.forEach((i) => {
        Mc(a, i, ps(o, i));
      }), this.rhfForm.reset(a, {
        keepDirtyValues: !1,
        keepValues: !1,
        keepDefaultValues: !0
      });
    }, this.resetField = (r) => {
      this.rhfForm.resetField(r, {
        keepDirty: !1,
        keepError: !1,
        keepTouched: !1
      });
    }, this.validateFields = async (r) => await this.rhfForm.trigger(r) ? this.rhfForm?.getValues() : await Promise.reject(this.getFieldsError(r)), this.isValid = () => this.rhfForm.formState.isValid, this.isValidating = () => this.rhfForm.formState.isValidating, this.setCallbacks = (r) => {
      this.callbacks = r;
    }, this.submit = async () => {
      const { onFinish: r, onFinishFailed: o } = this.callbacks;
      if (await this.rhfForm.trigger())
        try {
          r?.(this.getFieldsValue());
        } catch (i) {
          console.error(i);
        }
      else
        o?.(this.getFieldsError());
    }, this.watch = (r, o) => typeof r == "string" ? this.rhfForm.watch((a, { name: i, type: l }) => {
      r === i && (l === "change" || !l) && o?.(ps(a, r));
    }) : this.rhfForm.watch((a, { name: i, type: l }) => {
      if (i && r.includes(i) && (l === "change" || !l)) {
        const c = mZ(a, r);
        o?.(c);
      }
    }), this.getInternalHooks = (r) => r !== Mf ? null : {
      setCallbacks: this.setCallbacks,
      getInitialValues: this.getInitialValues,
      handleSubmit: this.rhfForm.handleSubmit,
      rhfForm: this.rhfForm,
      watch: this.rhfForm.watch
    }, this.getExtendsForm = () => ({
      getFieldValue: this.getFieldValue,
      getFieldsValue: this.getFieldsValue,
      getFieldError: this.getFieldError,
      getFieldsError: this.getFieldsError,
      resetFields: this.resetFields,
      resetField: this.resetField,
      setFieldValue: this.setFieldValue,
      setFieldsValue: this.setFieldsValue,
      validateFields: this.validateFields,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      submit: this.submit,
      isValid: this.isValid,
      isValidating: this.isValidating,
      _getInternalHooks: this.getInternalHooks,
      getInternalRhfForm: () => this.rhfForm,
      watch: this.watch
    }), this.rhfForm = t;
  }
}
function v$(e) {
  const t = N.useRef(), r = yee({
    mode: "onChange",
    reValidateMode: "onChange",
    criteriaMode: "all",
    ...e,
    defaultValues: e?.initialValues
  });
  if (!t.current) {
    const o = new wee(r);
    t.current = {
      ...o.getExtendsForm(),
      scrollToField(a, i) {
        const l = g$(a, t.current?.__INTERNAL__.name), c = l ? document.getElementById(l) : null;
        c && c.scrollIntoView(i);
      },
      // __INTERNAL__ is an object used in form internal, save some static variable
      // Currently only saving the name prop of the form component for `form.scrollToField`
      __INTERNAL__: {}
    };
  }
  return [t.current];
}
function Tee(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    padding: 4,
    lineHeight: {
      default: 1,
      label: "14px",
      explain: "14px"
    },
    fontSize: {
      default: 14,
      small: 12
    },
    fontFamily: r.fontFamily,
    label: {
      color: t.text.stronger.neutral,
      descriptionColor: t.text.neutral,
      height: {
        vertical: 20
      },
      description: {
        color: t.text.neutral,
        fontWeight: r.fontWeight.body,
        fontSize: r.fontSize.body,
        lineHeight: r.lineHeight.body
      }
    },
    control: {
      height: {
        default: 32,
        large: 40
      }
    },
    margin: {
      xxs: 4,
      xs: 8,
      default: 16,
      large: 24
    },
    color: {
      text: t.text.stronger.neutral,
      secondary: t.text.neutral,
      error: t.text.error,
      warning: t.text.warning,
      primary: t.text.primary,
      optional: t.text.neutral,
      tooltipIcon: t.icon.neutral
    },
    border: {
      color: {
        default: t.border.neutral,
        error: t.border.error
      },
      width: 1,
      type: "solid"
    },
    motion: {
      duration: {
        mid: 0.2
      },
      type: {
        easeOut: "cubic-bezier(0.215, 0.61, 0.355, 1)"
      }
    },
    screen: {
      max: {
        sm: 575
      }
    }
  };
}
const Eee = "Form", ll = `ui-${Eee}`, mo = `${ll}-item`, yn = `${mo}-label`, Ve = {
  root: ll,
  large: `${ll}-large`,
  item: {
    root: mo,
    explain: `${mo}-explain`,
    explainError: `${mo}-explain-error`,
    explainWarning: `${mo}-explain-warning`,
    extra: `${mo}-extra`,
    extraWithExplain: `${mo}-extra-with-explain`,
    withHelp: `${mo}-with-help`,
    hidden: `${mo}-hidden`,
    hasError: `${mo}-has-error`
  },
  label: {
    root: `${yn}-root`,
    container: `${yn}-container`,
    label: `${yn}-label`,
    wrapper: `${yn}-wrapper`,
    outerWrapper: `${yn}-outerWrapper`,
    innerWrapper: `${yn}-innerWrapper`,
    left: `${yn}-left`,
    right: `${yn}-right`,
    wrap: `${yn}-wrap`,
    required: `${yn}-required`,
    optional: `${yn}-optional`,
    tooltipWrapper: `${yn}-tooltipWrapper`,
    tooltip: `${yn}-tooltip`,
    colon: `${yn}-colon`,
    requiredMark: `${yn}-requiredMark`,
    optionalMark: `${yn}-optionalMark`,
    description: `${yn}-desc`
  },
  layout: {
    vertical: `${ll}-vertical`,
    horizontal: `${ll}-horizontal`,
    inline: `${ll}-inline`
  },
  control: {
    root: `${mo}-control`,
    input: `${mo}-control-input`,
    content: `${mo}-control-input-content`
  }
}, x$ = (e) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: e.color.text,
  fontSize: e.fontSize.default,
  listStyle: "none",
  fontFamily: e.fontFamily
}), Oee = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.margin.large,
    padding: 0,
    color: e.color.secondary,
    fontSize: e.fontSize.default,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${e.border.width}px ${e.border.type} ${e.border.color.default}`
  },
  label: {
    fontSize: e.fontSize.default
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.color.text,
    fontSize: e.fontSize.default,
    lineHeight: e.lineHeight.default
  }
}), $ee = (e) => ({
  [`.${Ve.item.root}`]: {
    [`.${Ve.item.root}-label > label`]: {
      height: e
    },
    [`.${Ve.item.root}-control-input`]: {
      minHeight: e
    }
  }
}), Ree = (e) => ({
  [`&.${Ve.root}`]: {
    ...x$(e),
    ...Oee(e),
    [`.${Ve.root}-text`]: {
      display: "inline-block",
      paddingInlineEnd: e.padding
    },
    [`.${Ve.large}`]: {
      ...$ee(e.control.height.large)
    }
  }
}), Pee = (e) => (
  // const iconCls = '';
  {
    [`.${Ve.item.root}`]: {
      ...x$(e),
      marginBottom: e.margin.default,
      verticalAlign: "top",
      [`&.${Ve.item.withHelp}`]: {
        transition: "none"
      },
      [`&.${Ve.item.hidden},&.${Ve.item.hidden}.${Ve.root}-grid`]: {
        display: "none"
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`.${Ve.label.root}`]: {
        [`.${Ve.label.container}`]: {
          display: "flex"
        },
        [`.${Ve.label.wrapper}`]: {
          display: "inline-flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "4px",
          [`@media (max-width: ${e.screen.max.sm}px)`]: {
            justifyContent: "flex-start"
          },
          [`.${Ve.label.outerWrapper}`]: {
            [`.${Ve.label.innerWrapper}`]: {
              display: "inline-block",
              verticalAlign: "top",
              [`.${Ve.label.tooltipWrapper}`]: {
                display: "inline-block",
                verticalAlign: "inherit",
                fontSize: 0
              }
            }
          },
          [`.${Ve.label.label}`]: {
            color: e.label.color,
            fontSize: e.fontSize.default,
            lineHeight: "20px",
            wordWrap: "break-word",
            wordBreak: "break-word",
            verticalAlign: "inherit"
          },
          [`.${Ve.label.requiredMark}`]: {
            color: e.color.error,
            height: "20px",
            lineHeight: "20px",
            overflow: "hidden",
            flexShrink: 0,
            marginInlineStart: "4px"
          },
          [`.${Ve.label.optionalMark}`]: {
            color: e.color.optional
          },
          [`&.${Ve.label.colon}`]: {
            "&::after": {
              content: '":"'
              // compatible with browsers that don't support content alt text
            }
          },
          [`&.${Ve.label.colon}::after`]: {
            content: '":" / ""',
            // use content alt text to hide the colon from screen readers
            height: "20px",
            lineHeight: "18px"
          }
        },
        [`&.${Ve.label.right}`]: {
          [`.${Ve.label.outerWrapper}`]: {
            flex: 1,
            textAlign: "right",
            [`@media (max-width: ${e.screen.max.sm}px)`]: {
              textAlign: "unset",
              flex: "unset"
            }
          }
        },
        [`&.${Ve.label.left}`]: {
          [`.${Ve.label.wrapper}`]: {
            justifyContent: "flex-start"
          }
        },
        [`&.${Ve.label.wrap}`]: {
          overflow: "unset",
          whiteSpace: "unset"
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`.${Ve.control.root}`]: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        '&:first-of-type:not([class^="MuiGrid"]):not([class*="MuiGrid"])': {
          width: "100%"
        },
        [`.${Ve.control.input}`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.control.height.default,
          [`.${Ve.control.content}`]: {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      }
    },
    // ==============================================================
    // =                           Explain                          =
    // ==============================================================
    [`.${Ve.item.explain}, .${Ve.item.extra}`]: {
      clear: "both",
      color: e.color.secondary,
      fontSize: e.fontSize.small,
      transition: `color ${e.motion.duration.mid} ${e.motion.type.easeOut}`
      // sync input color transition
    },
    [`.${Ve.item.explain}-connected`]: {
      width: "100%"
    },
    [`.${Ve.item.explainError}-container`]: {
      display: "flex",
      flexWrap: "nowrap",
      marginTop: 8,
      alignItems: "center"
    },
    [`.${Ve.item.explainError}-icon`]: {
      display: "inline-block",
      height: 14,
      lineHeight: e.lineHeight.explain,
      color: e.color.error,
      marginInlineEnd: 4
    },
    [`.${Ve.item.explain}`]: {
      [`.${Ve.item.explainError}`]: {
        color: e.color.error
      },
      [`.${Ve.item.explainWarning}`]: {
        color: e.color.warning
      }
    },
    [`&.${Ve.item.withHelp} .${Ve.item.explain}`]: {
      height: "auto",
      lineHeight: e.lineHeight.explain,
      opacity: 1
    },
    [`&.${Ve.item.hasError}`]: {
      "> input": {
        borderColor: `${e.border.color.error}`
      }
    },
    [`.${Ve.item.extra}`]: {
      marginTop: 4
    },
    [`.${Ve.item.extraWithExplain}`]: {
      marginTop: 4
    }
  }
), kee = () => ({
  [`&.${Ve.layout.horizontal}`]: {
    [`.${Ve.label.root}`]: {
      flexGrow: 0,
      alignItems: "flex-start",
      [`.${Ve.label.wrapper}`]: {
        width: "100%",
        minHeight: "32px",
        paddingRight: "8px"
      }
    },
    [`.${Ve.control.root}`]: {
      flex: "1 1 0",
      minWidth: 0
    }
  }
}), Aee = (e) => ({
  [`&.${Ve.layout.inline}`]: {
    display: "flex",
    flexWrap: "wrap",
    [`.${Ve.item.root}`]: {
      flex: "none",
      flexWrap: "nowrap",
      marginInlineEnd: e.margin.default,
      marginBottom: 0,
      [`.${Ve.label.root}`]: {
        [`.${Ve.label.wrapper}`]: {
          minHeight: "32px",
          paddingRight: "8px"
        }
      },
      [`&.${Ve.item.withHelp}`]: {
        marginBottom: e.margin.default
      },
      [`> .${Ve.label.root},
        > .${Ve.control.root}`]: {
        display: "inline-block",
        verticalAlign: "top"
      },
      [`> .${Ve.label.root}`]: {
        flex: "none"
      },
      [`.${Ve.root}-text`]: {
        display: "inline-block"
      }
    }
  }
}), C$ = (e) => ({
  margin: 0,
  padding: `0 0 ${e.padding}px`,
  whiteSpace: "initial",
  textAlign: "start"
}), Iee = (e) => ({
  [`.${Ve.item.root} .${Ve.label.root}`]: {
    ...C$(e)
  },
  [`&.${Ve.root}`]: {
    [`.${Ve.item.root}`]: {
      flexWrap: "wrap",
      [`.${Ve.label.root},
          .${Ve.control.root}`]: {
        flex: "0 0 100%",
        maxWidth: "100%"
      }
    }
  }
}), Nee = (e) => ({
  [`&.${Ve.root}-vertical`]: {
    [`.${Ve.item.root}`]: {
      [`.${Ve.item.root}-grid`]: {
        flexDirection: "column"
      },
      [`.${Ve.label.root}`]: {
        [`.${Ve.label.container}`]: {
          justifyContent: "space-between"
        },
        [`.${Ve.label.wrapper}`]: {
          justifyContent: "flex-start",
          paddingBottom: "4px",
          width: "auto",
          height: "auto",
          lineHeight: "20px"
        }
      },
      [`.${Ve.label.description}`]: {
        paddingBottom: "4px",
        ...e.label.description
      },
      [`.${Ve.control.root}`]: {
        width: "100%"
      }
    }
  },
  [`&.${Ve.root}-vertical .${Ve.item.root}-label`]: {
    ...C$(e)
  },
  [`@media (max-width: ${e.screen.max.sm}px)`]: {
    ...Iee(e)
  }
});
function _f(e) {
  const t = Tee(e), [r] = mn({
    componentName: "Form",
    theme: e,
    dynamicToken: t
  });
  return {
    ...Ree(r),
    ...Pee(r),
    ...kee(),
    ...Aee(r),
    ...Nee(r)
  };
}
function Mee(e) {
  const t = Xt(e);
  return Dn(() => {
    t.current = e;
  }, [e]), t;
}
const _ee = (e, t) => {
  const { form: r, validateTrigger: o = "onChange", initialValues: a, onFinish: i = () => {
  }, onFinishFailed: l, children: c, onValuesChange: d, scrollToFirstError: p, labelAlign: f, labelCol: h, labelWrap: g, wrapperCol: y, layout: C = "horizontal", colon: b, className: v, disabled: T, validateMessages: R = h$, name: $ } = e, E = Mee(d), S = o === "all" || o === "onTouched" ? "onChange" : o, [k] = v$({
    mode: o,
    reValidateMode: S,
    criteriaMode: "all",
    initialValues: a
  }), A = r ?? k;
  A.__INTERNAL__.name = $;
  const _ = N.useRef(null);
  _.current || (_.current = !0), N.useImperativeHandle(t, () => A);
  const { handleSubmit: L, setCallbacks: O, rhfForm: F, watch: B } = A._getInternalHooks(Mf), M = Ln(() => {
    l?.(A.getFieldsError()), p && setTimeout(() => {
      document.querySelectorAll(`.${Ve.item.hasError}`)?.[0]?.scrollIntoView?.(p);
    }, 0);
  }, [l, p, A]), j = Ln(() => {
    M();
  }, [M]), W = Ln(async (H) => {
    await r?.validateFields(), i(H);
  }, [r, i]), V = ra(() => L(W, j), [L, W, j]), X = ra(() => ({
    form: A,
    name: $,
    labelAlign: f,
    labelCol: h,
    labelWrap: g,
    wrapperCol: y,
    layout: C,
    colon: b,
    initialValues: a,
    disabled: T,
    validateMessages: R
  }), [
    $,
    A,
    f,
    h,
    g,
    y,
    C,
    b,
    a,
    T,
    R
  ]);
  Dn(() => {
    const H = B((Z, { type: G, name: ye }) => {
      E.current?.(Z, { type: G, name: ye });
    });
    return () => {
      H.unsubscribe();
    };
  }, [E, B]), O({
    onFinish: i,
    onFinishFailed: M
  });
  const U = ot(v, Ve.root, {
    [`${Ve.layout.vertical}`]: C === "vertical",
    [`${Ve.layout.inline}`]: C === "inline",
    [`${Ve.layout.horizontal}`]: C === "horizontal"
  });
  return N.createElement(
    Aa.Provider,
    { value: X },
    N.createElement(
      ree,
      { ...F },
      N.createElement("form", { onSubmit: V, className: U }, c)
    )
  );
}, Fee = Y(N.forwardRef(_ee))((e) => {
  const { theme: t } = e;
  return _f(t);
}), Lee = N.forwardRef((e, t) => N.createElement(Fee, { ...e, ref: t }));
let tu = L5.Unstable_Grid2;
tu || (tu = L5.Grid2);
function Bee(e) {
  return e ? typeof e == "object" && !N.isValidElement(e) ? e : {
    title: e
  } : null;
}
function Dee(e) {
  const { className: t, label: r, labelWidth: o, labelCol: a, labelAlign: i, colon: l, htmlFor: c, required: d, requiredMark: p, tooltip: f, labelExtra: h, description: g } = e, { t: y } = ua("Form");
  return r ? N.createElement(Aa.Consumer, null, ({ labelCol: C, labelAlign: b, layout: v, colon: T, labelWrap: R }) => {
    const $ = a ?? C ?? {}, E = i ?? b;
    let S = r, k = null;
    const _ = (l === !0 || T !== !1 && l !== !1) && v !== "vertical";
    _ && typeof r == "string" && r.trim() !== "" && (S = r.replace(/[:|：]\s*$/, "")), p !== !1 && (!d && p === "optional" && (k = N.createElement(
      "span",
      { className: Ve.label.optionalMark },
      "(",
      y("optional"),
      ")"
    )), d && (k = N.createElement("span", { className: Ve.label.requiredMark, "aria-hidden": !0 }, "*")));
    let L = null;
    const O = Bee(f);
    if (O) {
      const { icon: M = N.createElement(DZ, null), ...j } = O;
      L = N.createElement(
        k4,
        { ...j, arrow: !0 },
        N.createElement(Di, { variant: "icon", type: "tertiary", size: "small", "aria-label": typeof r == "string" ? y("learnMoreWithName", { name: `${r}` }) : y("learnMore"), role: "button", sx: {
          minWidth: "20px !important",
          width: "20px !important",
          height: "20px !important"
        }, className: Ve.label.tooltip }, M)
      );
    }
    const F = ot(t, Ve.label.label, {
      [`${Ve.label.required}`]: d,
      [`${Ve.label.optional}`]: !d && p !== !1
    }), B = ot(Ve.label.root, $.className, {
      [`${Ve.label.left}`]: E === "left",
      [`${Ve.label.wrap}`]: !!R,
      [`${Ve.label.right}`]: E === "right" || iZ(E) && v === "horizontal"
    });
    return N.createElement(
      tu,
      { ...$, className: B },
      N.createElement(
        Tt,
        { className: ot(Ve.label.container) },
        N.createElement(
          Tt,
          { className: ot(Ve.label.wrapper, {
            [`${Ve.label.colon}`]: _
          }) },
          N.createElement(
            Tt,
            { className: Ve.label.outerWrapper },
            N.createElement(
              Tt,
              { className: Ve.label.innerWrapper },
              N.createElement("label", { htmlFor: c, className: F, style: { width: o } }, S),
              k,
              N.createElement("span", { className: Ve.label.tooltipWrapper }, L)
            )
          )
        ),
        h ? N.createElement(Tt, null, h) : null
      ),
      g && v === "vertical" ? N.createElement(Tt, { className: ot(Ve.label.description), id: `${c}-desc` }, g) : null
    );
  }) : null;
}
const jee = Y(Dee)((e) => {
  const { theme: t } = e;
  return _f(t);
}), zee = N.forwardRef((e, t) => N.createElement(jee, { ...e, ref: t })), Vee = [];
function Wee(e, t, r, o) {
  return {
    key: typeof e == "string" ? e : `${r}-${o}`,
    error: e,
    errorStatus: t
  };
}
function S$({ errors: e = Vee, className: t, fieldId: r }) {
  const o = x.useMemo(() => e.map((i, l) => Wee(i, "error", "error", l)), [e]), a = {};
  return r && (a.id = `${r}_errormessage`), x.createElement("div", { ...a, className: ot(Ve.item.explain, t), role: "alert" }, o.map((i) => {
    const { key: l, error: c, errorStatus: d } = i;
    return x.createElement("div", { key: l, className: ot({
      [`${Ve.item.explain}-${d}`]: d
    }) }, c);
  }));
}
const Uee = (e) => {
  const { wrapperCol: t, children: r, errors: o, extra: a, fieldId: i } = e, l = x.useContext(Aa), c = t ?? l.wrapperCol ?? {}, d = ot(`${Ve.control.root}`, c.className), p = x.useMemo(() => ({ ...l }), [l]);
  delete p.labelCol, delete p.wrapperCol;
  const f = x.createElement(
    "div",
    { className: `${Ve.control.input}` },
    x.createElement("div", { className: `${Ve.control.content}` }, r)
  ), h = o.length ? x.createElement(
    "div",
    { className: `${Ve.item.explainError}-container` },
    x.createElement(g4, { className: `${Ve.item.explainError}-icon` }),
    x.createElement(S$, { errors: o, className: `${Ve.item.explain}-connected`, fieldId: i })
  ) : null, g = {};
  i && (g.id = `${i}_extra`);
  const y = a ? x.createElement("div", { ...g, className: ot(Ve.item.extra, {
    [`${Ve.item.extraWithExplain}`]: !!h
  }) }, a) : null;
  return x.createElement(
    Aa.Provider,
    { value: p },
    x.createElement(
      tu,
      { ...c, className: d },
      f,
      h,
      y
    )
  );
}, Hee = N.memo(
  // eslint-disable-next-line react/prop-types
  (e) => e.children,
  (e, t) => e.value === t.value && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((r, o) => r === t.childProps[o])
);
function Gee(e) {
  const { children: t, label: r, labelExtra: o, description: a, labelWidth: i, labelClassName: l, labelAlign: c, labelCol: d, wrapperCol: p, name: f = "", required: h, colon: g, rules: y, noStyle: C, hidden: b, tooltip: v, extra: T, valuePropName: R, className: $, normalize: E, requiredMark: S, validateStatus: k, help: A } = e, { validateMessages: _, form: L, name: O } = Cs(Aa), { formState: F, getFieldState: B } = Su(), M = f, j = g$(f, O), W = ra(() => {
    if (A)
      return [A];
    const { error: ne } = B(M, F);
    return ne ? [ne.message] : [];
  }, [F, B, A, M]);
  let V = "";
  k !== void 0 ? V = k : W.length > 0 && (V = "error");
  const X = ot($, Ve.item.root, {
    [`${Ve.item.withHelp}`]: W.length > 0,
    [`${Ve.item.hasError}`]: V === "error",
    [`${Ve.item.hidden}`]: b
  }), { disabled: U } = Cs(Aa), H = ra(() => b$(y ?? [], { label: r, name: M, validateMessages: _ }), [r, M, y, _]), Z = (
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    h !== void 0 ? h : !!y?.some((ne) => !!(ne && typeof ne == "object" && ne.required))
  );
  let G = null;
  const ye = (ne) => {
    if (N.isValidElement(t)) {
      const { defaultValue: fe, ...ie } = t.props;
      fe !== void 0 && console.warn("Warning: [Form.Item] `defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const oe = R ?? "value", ce = {
        ...ie,
        ...$o(ne || {}, ["value", "ref"]),
        [oe]: ne?.value,
        disabled: ie.disabled ?? U,
        status: V,
        onChange: (...xe) => {
          E ? ne?.onChange(E(...xe)) : ne?.onChange(...xe), t.props.onChange?.(...xe);
        }
      };
      ce.id || (ce.id = j), a && (ce["aria-describedby"] = ot(ce["aria-describedby"], `${j}-desc`)), T && M && (ce["aria-describedby"] = ot(ce["aria-describedby"], `${j}_extra`)), W.length > 0 && (ce["aria-invalid"] = "true", ce["aria-errormessage"] = `${j}_errormessage`), Z && (ce["aria-required"] = "true");
      const Ce = [
        ce["aria-required"],
        ce["aria-invalid"],
        ce["aria-describedby"],
        ce["aria-errormessage"]
      ];
      return ne ? N.createElement(Hee, { value: ne.value, update: t, childProps: Ce }, N.cloneElement(t, ce)) : N.cloneElement(t, ce);
    }
    return typeof t == "function" ? N.createElement(N.Fragment, null, t(L)) : N.createElement(N.Fragment, null, t);
  }, de = (ne) => N.createElement(
    "div",
    { className: X },
    N.createElement(
      tu,
      { container: !0, className: `${Ve.item.root}-grid` },
      N.createElement(zee, { label: r, labelWidth: i, className: l, required: Z, requiredMark: S, labelCol: d, labelAlign: c, colon: g, htmlFor: j, tooltip: v, labelExtra: o, description: a }),
      N.createElement(Uee, { errors: W, extra: T, fieldId: j, wrapperCol: p }, ne)
    )
  );
  return M ? Array.isArray(t) && M && process.env.NODE_ENV !== "production" ? (console.warn("Warning: A `Form.Item` with a `name` prop must have a single child element."), N.createElement(N.Fragment, null, t)) : (G = N.createElement(aee, { rules: H, name: M, control: L._getInternalHooks(Mf)?.rhfForm.control, render: ({ field: ne }) => ye(ne) }), C && !b ? G : de(G)) : de(ye());
}
const qee = Y(Gee)((e) => {
  const { theme: t } = e;
  return _f(t);
}), Kee = N.forwardRef((e, t) => N.createElement(qee, { ...e, ref: t }));
function Yee(e) {
  const { name: t, children: r, rules: o, className: a } = e, { validateMessages: i, form: l } = Cs(Aa), c = ra(() => b$(o ?? [], {
    name: t,
    label: void 0,
    validateMessages: i
  }), [t, o, i]), { fields: d, ...p } = uee({
    name: t,
    rules: c,
    keyName: "key"
  }), f = ot(a);
  return N.createElement("div", { className: f }, r(d, p, { errors: l.getFieldError(t) }));
}
const Zee = Y(Yee)((e) => {
  const { theme: t } = e;
  return _f(t);
}), Xee = N.forwardRef((e, t) => N.createElement(Zee, { ...e, ref: t }));
function Jee() {
  const { form: e } = Cs(Aa);
  return e;
}
function Qee(e, t) {
  const { form: r } = Cs(Aa), o = t ?? r;
  if (!o)
    return console.warn("Warning: useWatch requires a form instance since it can not auto detect from context."), typeof e == "string" ? null : [];
  const { watch: a, rhfForm: { formState: { defaultValues: i } } } = o._getInternalHooks(Mf);
  return Array.isArray(e) ? a(e, i) : a(e);
}
function ete(e) {
  const { form: t } = Cs(Aa), r = e ?? t, o = Xt(!1);
  r || console.warn("Warning: useIsValid requires a form instance since it can not auto detect from context.");
  const a = ra(() => r?.getInternalRhfForm(), [r]), i = a$({
    control: a.control
  });
  Dn(() => {
    const { isValid: d, errors: p } = i;
    (!d || !xh(p)) && !o.current && (o.current = !0, !d && xh(p) && a.trigger());
  }, [i, a]);
  const { isValid: l, errors: c } = i;
  return l && xh(c);
}
const Gr = Lee;
Gr.Item = Kee;
Gr.List = Xee;
Gr.useForm = v$;
Gr.useWatch = Qee;
Gr.useFormInstance = Jee;
Gr.useIsValid = ete;
Gr.ErrorList = S$;
function tte(e) {
  const t = ca(e), { typography: r } = e?.zoomUI ?? Ao();
  return {
    fontSize: {
      small: 10,
      medium: 14,
      large: 16
    },
    fontFamily: r.fontFamily,
    height: {
      small: 16,
      medium: 32,
      large: 48
    },
    gap: {
      small: 3,
      medium: 6,
      large: 9
    },
    spikesItemSize: {
      small: 2,
      medium: 4,
      large: 6
    },
    labelTop: {
      small: 4,
      medium: 8,
      large: 8
    },
    color: {
      spikesItem: t.activeMode === "dark" ? "white" : "black",
      neutral: t.text.stronger.neutral
    },
    underlay: t.underlay.dark
  };
}
const rte = "Spinning", ga = "ui-Spinning", Or = {
  // It is recommended that the root classname of the react-ui component be added with a random string.
  // This is mainly to avoid classname naming conflicts in the application
  root: `${ga}-root-${to()}`,
  text: `${ga}-text`,
  spinWrapper: `${ga}-spin-wrapper`,
  spinWrapperClipping: `${ga}-spin-wrapper-clipping`,
  spinWrapperClipped: `${ga}-spin-wrapper-clipped`,
  spikes: `${ga}-spikes`,
  spikesSpin: `${ga}-spikes-spin`,
  spikesItem: `${ga}-spikes-item`,
  nestedWrapper: `${ga}-nested-wrapper`,
  nestedContentWrapper: `${ga}-nested-content-wrapper`
};
function nte(e, t) {
  const r = tte(e), [o, a] = mn({
    componentName: rte,
    theme: e,
    dynamicToken: r
  }), i = a(o.spikesItemSize[t.size]), l = i * 2;
  return {
    [`&.${Or.nestedWrapper}`]: {
      position: "relative",
      [`>.${Or.nestedContentWrapper}`]: {
        position: "relative",
        transition: "opacity 0.2s",
        "&::after": {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0,
          zIndex: 10,
          background: a(o.underlay),
          content: '""',
          pointerEvents: "none",
          userSelect: "none"
        },
        "&-blur": {
          opacity: 0.5,
          pointerEvents: "none",
          userSelect: "none"
        }
      },
      [`>.${Or.spinWrapper}`]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        [`&.${Or.spinWrapperClipping}.${Or.spinWrapperClipped}`]: {
          padding: 8,
          width: "auto",
          height: "auto",
          transform: "translate(-50%,-50%)"
        }
      }
    },
    [`&.${Or.spinWrapper}`]: {
      display: "inline-flex",
      position: "relative",
      textAlign: "center",
      [`.${Or.text}`]: {
        marginTop: a(o.labelTop[t.size]),
        color: a(o.color.neutral),
        fontFamily: a(o.fontFamily),
        fontSize: a(o.fontSize[t.size])
      },
      [`.${Or.spikes}`]: {
        position: "relative",
        display: "inline-block",
        width: a(o.height[t.size]),
        height: a(o.height[t.size]),
        textAlign: "center",
        "&-spin": {
          animationName: "antSpinRotate",
          animationDuration: "1.5s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          "@keyframes antSpinRotate": {
            from: { transform: "rotate(0)" },
            to: { transform: "rotate(360deg)" }
          }
        },
        "&-item": {
          position: "absolute",
          top: `calc(50% - ${l}px - ${a(o.gap[t.size])}px)`,
          left: `calc(50% - ${i / 2}px)`,
          background: a(o.color.spikesItem),
          width: i,
          height: l,
          borderRadius: 33,
          transformOrigin: `50% ${a(o.gap[t.size]) + l}px`,
          "&:nth-of-type(1)": {
            opacity: "40%"
          },
          "&:nth-of-type(2)": {
            opacity: "35%",
            transform: "rotate(45deg)"
          },
          "&:nth-of-type(3)": {
            opacity: "30%",
            transform: "rotate(90deg)"
          },
          "&:nth-of-type(4)": {
            opacity: "25%",
            transform: "rotate(135deg)"
          },
          "&:nth-of-type(5)": {
            opacity: "20%",
            transform: "rotate(180deg)"
          },
          "&:nth-of-type(6)": {
            opacity: "15%",
            transform: "rotate(225deg)"
          },
          "&:nth-of-type(7)": {
            opacity: "10%",
            transform: "rotate(270deg)"
          },
          "&:nth-of-type(8)": {
            opacity: "8%",
            transform: "rotate(315deg)"
          }
        }
      }
    }
  };
}
const ote = {
  position: "absolute",
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  pointerEvents: "none"
};
function ate({ onVisibleAreaChange: e, ...t }) {
  const r = Xt(e);
  r.current = e;
  const o = Xt(null), a = Xt(), i = Xt([0, 0]), l = Xt(), c = Xt(), d = Ln((h) => {
    const g = c.current;
    (!g || h.visible !== g.visible || h.visible && (h.left !== g.left || h.top !== g.top || h.width !== g.width || h.height !== g.height)) && (r.current?.(h), c.current = h);
  }, []), p = ra(() => {
    const h = new IntersectionObserver(([g]) => {
      const y = o.current, { target: C, boundingClientRect: b, intersectionRect: v } = g;
      h.unobserve(C);
      const T = v.width > 0 && v.height > 0, R = v.left - b.left, $ = v.top - b.top, { width: E, height: S } = v;
      d({
        left: R,
        top: $,
        width: E,
        height: S,
        visible: T
      }), y?.removeChild(C), l.current = requestAnimationFrame(f);
    });
    return h;
  }, []), f = Ln(() => {
    const h = o.current, g = h?.getBoundingClientRect(), y = a.current, C = i.current;
    if (g && y && C[0] === window.innerWidth && C[1] === window.innerHeight && g.left === y.left && g.top === y.top && g.right === y.right && g.bottom === y.bottom && g.width === y.width && g.height === y.height)
      l.current = requestAnimationFrame(f);
    else {
      const b = document.createElement("div"), { style: v } = b;
      v.position = "absolute", v.left = "0", v.right = "0", v.top = "0", v.bottom = "0", v.pointerEvents = "none", h?.appendChild(b), p.observe(b);
    }
    a.current = g, i.current = [window.innerWidth, window.innerHeight];
  }, [p]);
  return Fc(() => (f(), () => {
    l.current && (cancelAnimationFrame(l.current), l.current = void 0);
  }), [f]), N.createElement(Tt, { ...t, ref: o, sx: [ote, t.sx] });
}
function ite(e, t) {
  return !!e && !!t && !Number.isNaN(Number(t));
}
const ste = (e) => {
  const { sx: t, className: r, spinning: o = !0, label: a, delay: i, viewportClipping: l, children: c } = e, [d, p] = N.useState(() => o && !ite(o, i)), f = Xt(null);
  N.useEffect(() => {
    if (!o) {
      p(!1);
      return;
    }
    const C = As(() => {
      p(!0);
    }, i);
    return C(), () => {
      C.clear();
    };
  }, [o, i]);
  const h = N.createElement(
    "div",
    { className: ot(Or.spikes, Or.spikesSpin) },
    N.createElement("div", { className: Or.spikesItem, key: 1 }),
    N.createElement("div", { className: Or.spikesItem, key: 2 }),
    N.createElement("div", { className: Or.spikesItem, key: 3 }),
    N.createElement("div", { className: Or.spikesItem, key: 4 }),
    N.createElement("div", { className: Or.spikesItem, key: 5 }),
    N.createElement("div", { className: Or.spikesItem, key: 6 }),
    N.createElement("div", { className: Or.spikesItem, key: 7 }),
    N.createElement("div", { className: Or.spikesItem, key: 8 })
  ), g = N.createElement(
    Tt,
    { sx: t, className: ot(r, Or.spinWrapper, {
      [`${Or.spinWrapperClipping}`]: l
    }), ref: f, "aria-live": "polite", "aria-busy": d },
    h,
    a ? N.createElement("div", { className: Or.text }, a) : null
  );
  if (!c && d)
    return g;
  function y(C) {
    const b = f.current;
    if (!b)
      return;
    const { style: v, classList: T, parentElement: R } = b;
    if (C.visible) {
      T.add(Or.spinWrapperClipped);
      const $ = b.clientWidth, E = b.clientHeight, S = R.clientWidth, k = R.clientHeight;
      let A = C.left + C.width / 2, _ = C.top + C.height / 2;
      S > $ && C.width < $ && (C.left < 1 && (A = $ / 2), C.left + C.width > S - 1 && (A = S - $ / 2)), k > E && C.height < E && (C.top < 1 && (_ = E / 2), C.top + C.height > k - 1 && (_ = k - E / 2)), v.left = `${A}px`, v.top = `${_}px`;
    } else
      T.remove(Or.spinWrapperClipped), v.top = "", v.left = "";
  }
  return N.createElement(
    Tt,
    { className: ot(Or.nestedWrapper, r), sx: {
      position: "relative",
      ...t
    } },
    d && g,
    d && l && N.createElement(ate, { onVisibleAreaChange: y }),
    N.createElement("div", { className: ot(Or.nestedContentWrapper, {
      [`${Or.nestedContentWrapper}-blur`]: d
    }) }, c)
  );
}, lte = Y(ste)((e) => {
  const { theme: t, size: r } = e;
  return nte(t, { size: r });
}), cte = N.forwardRef((e, t) => N.createElement(lte, { ...e, ref: t })), ute = N.forwardRef((e, t) => {
  const r = $o(e, ["style"]);
  return N.createElement(cte, { ...r, ref: t, size: e.size ? e.size : "medium" });
}), KS = /* @__PURE__ */ JSON.parse(`[{"code":"93","value":"AF","label":"Afghanistan","useType":"both"},{"code":"358","value":"AX","label":"Åland Islands","useType":"both"},{"code":"355","value":"AL","label":"Albania","useType":"both"},{"code":"213","value":"DZ","label":"Algeria","useType":"both"},{"code":"1","value":"AS","label":"American Samoa","useType":"both"},{"code":"376","value":"AD","label":"Andorra","useType":"both"},{"code":"244","value":"AO","label":"Angola","useType":"both"},{"code":"1","value":"AI","label":"Anguilla","useType":"both"},{"code":"672","value":"AQ","label":"Antarctica","useType":"both"},{"code":"1","value":"AG","label":"Antigua and Barbuda","useType":"both"},{"code":"54","value":"AR","label":"Argentina","useType":"both"},{"code":"374","value":"AM","label":"Armenia","useType":"both"},{"code":"297","value":"AW","label":"Aruba","useType":"both"},{"code":"247","value":"AC","label":"Ascension Island","useType":"web"},{"code":"61","value":"AU","label":"Australia","useType":"both"},{"code":"43","value":"AT","label":"Austria","useType":"both"},{"code":"994","value":"AZ","label":"Azerbaijan","useType":"both"},{"code":"1","value":"BS","label":"Bahamas","useType":"both"},{"code":"973","value":"BH","label":"Bahrain","useType":"both"},{"code":"880","value":"BD","label":"Bangladesh","useType":"both"},{"code":"1","value":"BB","label":"Barbados","useType":"both"},{"code":"375","value":"BY","label":"Belarus","useType":"both"},{"code":"32","value":"BE","label":"Belgium","useType":"both"},{"code":"501","value":"BZ","label":"Belize","useType":"both"},{"code":"229","value":"BJ","label":"Benin","useType":"both"},{"code":"1","value":"BM","label":"Bermuda","useType":"both"},{"code":"975","value":"BT","label":"Bhutan","useType":"both"},{"code":"591","value":"BO","label":"Bolivia","useType":"both"},{"code":"599","value":"BQ","label":"Bonaire, Sint Eustatius and Saba","useType":"both"},{"code":"387","value":"BA","label":"Bosnia and Herzegovina","useType":"both"},{"code":"267","value":"BW","label":"Botswana","useType":"both"},{"value":"BV","label":"Bouvet Island","useType":"both"},{"code":"55","value":"BR","label":"Brazil","useType":"both"},{"value":"IO","label":"British Indian Ocean Territory","useType":"web"},{"code":"673","value":"BN","label":"Brunei Darussalam","useType":"both"},{"code":"359","value":"BG","label":"Bulgaria","useType":"both"},{"code":"226","value":"BF","label":"Burkina Faso","useType":"both"},{"code":"257","value":"BI","label":"Burundi","useType":"both"},{"code":"238","value":"CV","label":"Cabo Verde","useType":"both"},{"code":"855","value":"KH","label":"Cambodia","useType":"both"},{"code":"237","value":"CM","label":"Cameroon","useType":"both"},{"code":"1","value":"CA","label":"Canada","useType":"both"},{"value":"IC","label":"Canary Islands","useType":"both"},{"code":"1","value":"KY","label":"Cayman Islands","useType":"both"},{"code":"236","value":"CF","label":"Central African Republic","useType":"both"},{"value":"EA","label":"Ceuta and Melilla","useType":"web"},{"code":"235","value":"TD","label":"Chad","useType":"both"},{"code":"56","value":"CL","label":"Chile","useType":"both"},{"code":"86","value":"CN","label":"Chinese Mainland","useType":"both"},{"code":"61","value":"CX","label":"Christmas Island","useType":"both"},{"value":"CP","label":"Clipperton Island","useType":"web"},{"code":"61","value":"CC","label":"Cocos (Keeling) Islands","useType":"both"},{"code":"57","value":"CO","label":"Colombia","useType":"both"},{"code":"269","value":"KM","label":"Comoros","useType":"both"},{"code":"243","value":"CD","label":"Congo, Democratic Republic of the","useType":"both"},{"code":"682","value":"CK","label":"Cook Islands","useType":"both"},{"code":"506","value":"CR","label":"Costa Rica","useType":"both"},{"code":"225","value":"CI","label":"Côte d'Ivoire","useType":"both"},{"code":"385","value":"HR","label":"Croatia","useType":"both"},{"code":"599","value":"CW","label":"Curaçao","useType":"both"},{"code":"357","value":"CY","label":"Cyprus","useType":"both"},{"code":"420","value":"CZ","label":"Czech Republic","useType":"both"},{"code":"45","value":"DK","label":"Denmark","useType":"both"},{"code":"246","value":"DG","label":"Diego Garcia","useType":"web"},{"code":"253","value":"DJ","label":"Djibouti","useType":"both"},{"code":"1","value":"DM","label":"Dominica","useType":"both"},{"code":"1","value":"DO","label":"Dominican Republic","useType":"both"},{"code":"593","value":"EC","label":"Ecuador","useType":"both"},{"code":"20","value":"EG","label":"Egypt","useType":"both"},{"code":"503","value":"SV","label":"El Salvador","useType":"both"},{"code":"240","value":"GQ","label":"Equatorial Guinea","useType":"both"},{"code":"291","value":"ER","label":"Eritrea","useType":"both"},{"code":"372","value":"EE","label":"Estonia","useType":"both"},{"code":"268","value":"SZ","label":"Eswatini","useType":"both"},{"code":"251","value":"ET","label":"Ethiopia","useType":"both"},{"code":"500","value":"FK","label":"Falkland Islands (Malvinas)","useType":"both"},{"code":"298","value":"FO","label":"Faroe Islands","useType":"both"},{"code":"679","value":"FJ","label":"Fiji","useType":"both"},{"code":"358","value":"FI","label":"Finland","useType":"both"},{"code":"33","value":"FR","label":"France","useType":"both"},{"code":"594","value":"GF","label":"French Guiana","useType":"both"},{"code":"689","value":"PF","label":"French Polynesia","useType":"both"},{"value":"TF","label":"French Southern Territories","useType":"both"},{"code":"241","value":"GA","label":"Gabon","useType":"both"},{"code":"220","value":"GM","label":"Gambia","useType":"both"},{"code":"995","value":"GE","label":"Georgia","useType":"both"},{"code":"49","value":"DE","label":"Germany","useType":"both"},{"code":"233","value":"GH","label":"Ghana","useType":"both"},{"code":"350","value":"GI","label":"Gibraltar","useType":"both"},{"code":"30","value":"GR","label":"Greece","useType":"both"},{"code":"299","value":"GL","label":"Greenland","useType":"both"},{"code":"1","value":"GD","label":"Grenada","useType":"both"},{"code":"590","value":"GP","label":"Guadeloupe","useType":"both"},{"code":"1","value":"GU","label":"Guam","useType":"both"},{"code":"502","value":"GT","label":"Guatemala","useType":"both"},{"code":"44","value":"GG","label":"Guernsey","useType":"both"},{"code":"","value":"GN","label":"Guinea","useType":"both"},{"code":"245","value":"GW","label":"Guinea-Bissau","useType":"both"},{"code":"592","value":"GY","label":"Guyana","useType":"both"},{"code":"509","value":"HT","label":"Haiti","useType":"both"},{"code":"","value":"HM","label":"Heard Island and McDonald Islands","useType":"both"},{"code":"379","value":"VA","label":"Holy See (Vatican City)","useType":"both"},{"code":"504","value":"HN","label":"Honduras","useType":"both"},{"code":"852","value":"HK","label":"Hong Kong SAR","useType":"both"},{"code":"36","value":"HU","label":"Hungary","useType":"both"},{"code":"354","value":"IS","label":"Iceland","useType":"both"},{"code":"91","value":"IN","label":"India","useType":"both"},{"code":"62","value":"ID","label":"Indonesia","useType":"both"},{"code":"964","value":"IQ","label":"Iraq","useType":"both"},{"code":"353","value":"IE","label":"Ireland","useType":"both"},{"code":"44","value":"IM","label":"Isle of Man","useType":"both"},{"code":"972","value":"IL","label":"Israel","useType":"both"},{"code":"39","value":"IT","label":"Italy","useType":"both"},{"code":"1","value":"JM","label":"Jamaica","useType":"both"},{"code":"81","value":"JP","label":"Japan","useType":"both"},{"code":"44","value":"JE","label":"Jersey","useType":"both"},{"code":"962","value":"JO","label":"Jordan","useType":"both"},{"code":"7","value":"KZ","label":"Kazakhstan","useType":"both"},{"code":"254","value":"KE","label":"Kenya","useType":"both"},{"code":"686","value":"KI","label":"Kiribati","useType":"both"},{"code":"82","value":"KR","label":"Korea, Republic of","useType":"both"},{"code":"","value":"XK","label":"Kosovo","useType":"both"},{"code":"965","value":"KW","label":"Kuwait","useType":"both"},{"code":"996","value":"KG","label":"Kyrgyzstan","useType":"both"},{"code":"856","value":"LA","label":"Lao People's Democratic Republic","useType":"both"},{"code":"371","value":"LV","label":"Latvia","useType":"both"},{"code":"","value":"LB","label":"Lebanon","useType":"both"},{"code":"266","value":"LS","label":"Lesotho","useType":"both"},{"code":"231","value":"LR","label":"Liberia","useType":"both"},{"code":"218","value":"LY","label":"Libya","useType":"both"},{"code":"423","value":"LI","label":"Liechtenstein","useType":"both"},{"code":"370","value":"LT","label":"Lithuania","useType":"both"},{"code":"352","value":"LU","label":"Luxembourg","useType":"both"},{"code":"853","value":"MO","label":"Macau SAR","useType":"both"},{"code":"261","value":"MG","label":"Madagascar","useType":"both"},{"code":"265","value":"MW","label":"Malawi","useType":"both"},{"code":"60","value":"MY","label":"Malaysia","useType":"both"},{"code":"960","value":"MV","label":"Maldives","useType":"both"},{"code":"223","value":"ML","label":"Mali","useType":"both"},{"code":"356","value":"MT","label":"Malta","useType":"both"},{"code":"692","value":"MH","label":"Marshall Islands","useType":"both"},{"code":"596","value":"MQ","label":"Martinique","useType":"both"},{"code":"222","value":"MR","label":"Mauritania","useType":"both"},{"code":"230","value":"MU","label":"Mauritius","useType":"both"},{"code":"262","value":"YT","label":"Mayotte","useType":"both"},{"value":"FX","label":"Metropolitan France","useType":"web"},{"code":"52","value":"MX","label":"Mexico","useType":"both"},{"code":"691","value":"FM","label":"Micronesia (Federated States of)","useType":"both"},{"code":"373","value":"MD","label":"Moldova, Republic of","useType":"both"},{"code":"377","value":"MC","label":"Monaco","useType":"both"},{"code":"976","value":"MN","label":"Mongolia","useType":"both"},{"code":"382","value":"ME","label":"Montenegro","useType":"both"},{"code":"1","value":"MS","label":"Montserrat","useType":"both"},{"code":"212","value":"MA","label":"Morocco","useType":"both"},{"code":"258","value":"MZ","label":"Mozambique","useType":"both"},{"code":"95","value":"MM","label":"Myanmar","useType":"both"},{"code":"264","value":"NA","label":"Namibia","useType":"both"},{"code":"674","value":"NR","label":"Nauru","useType":"both"},{"code":"977","value":"NP","label":"Nepal","useType":"both"},{"code":"31","value":"NL","label":"Netherlands","useType":"both"},{"code":"599","value":"AN","label":"Netherlands Antilles","useType":"web"},{"value":"NT","label":"Neutral Zone","useType":"web"},{"code":"687","value":"NC","label":"New Caledonia","useType":"both"},{"code":"64","value":"NZ","label":"New Zealand","useType":"both"},{"code":"505","value":"NI","label":"Nicaragua","useType":"both"},{"code":"227","value":"NE","label":"Niger","useType":"both"},{"code":"234","value":"NG","label":"Nigeria","useType":"both"},{"code":"683","value":"NU","label":"Niue","useType":"both"},{"code":"672","value":"NF","label":"Norfolk Island","useType":"both"},{"code":"1","value":"MP","label":"Northern Mariana Islands","useType":"both"},{"code":"389","value":"MK","label":"North Macedonia","useType":"both"},{"code":"47","value":"NO","label":"Norway","useType":"both"},{"code":"968","value":"OM","label":"Oman","useType":"both"},{"value":"QO","label":"Outlying Oceania","useType":"web"},{"code":"92","value":"PK","label":"Pakistan","useType":"both"},{"code":"680","value":"PW","label":"Palau","useType":"both"},{"code":"970","value":"PS","label":"Palestinian Territories","useType":"both"},{"code":"507","value":"PA","label":"Panama","useType":"both"},{"code":"675","value":"PG","label":"Papua New Guinea","useType":"both"},{"code":"595","value":"PY","label":"Paraguay","useType":"both"},{"code":"51","value":"PE","label":"Peru","useType":"both"},{"code":"63","value":"PH","label":"Philippines","useType":"both"},{"code":"870","value":"PN","label":"Pitcairn","useType":"both"},{"code":"48","value":"PL","label":"Poland","useType":"both"},{"code":"351","value":"PT","label":"Portugal","useType":"both"},{"code":"1","value":"PR","label":"Puerto Rico","useType":"both"},{"code":"974","value":"QA","label":"Qatar","useType":"both"},{"code":"242","value":"CG","label":"Republic of Congo","useType":"both"},{"code":"262","value":"RE","label":"Réunion","useType":"both"},{"code":"40","value":"RO","label":"Romania","useType":"both"},{"code":"7","value":"RU","label":"Russia","useType":"both"},{"code":"250","value":"RW","label":"Rwanda","useType":"both"},{"code":"590","value":"BL","label":"Saint Barthélemy","useType":"both"},{"code":"290","value":"SH","label":"Saint Helena, Ascension and Tristan da Cunha","useType":"both"},{"code":"1","value":"KN","label":"Saint Kitts and Nevis","useType":"both"},{"code":"1","value":"LC","label":"Saint Lucia","useType":"both"},{"code":"590","value":"MF","label":"Saint-Martin (French)","useType":"both"},{"code":"508","value":"PM","label":"Saint Pierre and Miquelon","useType":"both"},{"code":"1","value":"VC","label":"Saint Vincent and the Grenadines","useType":"both"},{"code":"685","value":"WS","label":"Samoa","useType":"both"},{"code":"378","value":"SM","label":"San Marino","useType":"both"},{"code":"239","value":"ST","label":"Sao Tome and Principe","useType":"both"},{"code":"966","value":"SA","label":"Saudi Arabia","useType":"both"},{"code":"221","value":"SN","label":"Senegal","useType":"both"},{"code":"381","value":"RS","label":"Serbia","useType":"both"},{"code":"381","value":"CS","label":"Serbia and Montenegro","useType":"web"},{"code":"248","value":"SC","label":"Seychelles","useType":"both"},{"code":"232","value":"SL","label":"Sierra Leone","useType":"both"},{"code":"65","value":"SG","label":"Singapore","useType":"both"},{"code":"","value":"SX","label":"Sint-Maarten (Dutch)","useType":"both"},{"code":"421","value":"SK","label":"Slovakia","useType":"both"},{"code":"386","value":"SI","label":"Slovenia","useType":"both"},{"code":"677","value":"SB","label":"Solomon Islands","useType":"both"},{"code":"252","value":"SO","label":"Somalia","useType":"both"},{"code":"27","value":"ZA","label":"South Africa","useType":"both"},{"value":"GS","label":"South Georgia and the South Sandwich Islands","useType":"both"},{"value":"SS","label":"South Sudan","useType":"both"},{"code":"34","value":"ES","label":"Spain","useType":"both"},{"code":"94","value":"LK","label":"Sri Lanka","useType":"both"},{"code":"249","value":"SD","label":"Sudan","useType":"both"},{"code":"597","value":"SR","label":"Suriname","useType":"both"},{"value":"SJ","label":"Svalbard and Jan Mayen","useType":"both"},{"code":"46","value":"SE","label":"Sweden","useType":"both"},{"code":"41","value":"CH","label":"Switzerland","useType":"both"},{"code":"886","value":"TW","label":"Taiwan","useType":"both"},{"code":"992","value":"TJ","label":"Tajikistan","useType":"both"},{"code":"255","value":"TZ","label":"Tanzania","useType":"both"},{"code":"66","value":"TH","label":"Thailand","useType":"both"},{"code":"670","value":"TL","label":"Timor-Leste","useType":"both"},{"code":"228","value":"TG","label":"Togo","useType":"both"},{"code":"690","value":"TK","label":"Tokelau","useType":"both"},{"code":"676","value":"TO","label":"Tonga","useType":"both"},{"code":"1","value":"TT","label":"Trinidad and Tobago","useType":"both"},{"value":"TA","label":"Tristan da Cunha","useType":"web"},{"code":"216","value":"TN","label":"Tunisia","useType":"both"},{"code":"90","value":"TR","label":"Turkey","useType":"both"},{"code":"993","value":"TM","label":"Turkmenistan","useType":"both"},{"code":"1","value":"TC","label":"Turks and Caicos Islands","useType":"both"},{"code":"688","value":"TV","label":"Tuvalu","useType":"both"},{"code":"256","value":"UG","label":"Uganda","useType":"both"},{"code":"380","value":"UA","label":"Ukraine","useType":"both"},{"code":"971","value":"AE","label":"United Arab Emirates","useType":"both"},{"code":"44","value":"GB","label":"United Kingdom","useType":"both"},{"code":"1","value":"US","label":"United States","useType":"both"},{"value":"UM","label":"United States Minor Outlying Islands","useType":"web"},{"code":"598","value":"UY","label":"Uruguay","useType":"both"},{"code":"998","value":"UZ","label":"Uzbekistan","useType":"both"},{"code":"678","value":"VU","label":"Vanuatu","useType":"both"},{"code":"58","value":"VE","label":"Venezuela","useType":"both"},{"code":"84","value":"VN","label":"Vietnam","useType":"both"},{"code":"284","value":"VG","label":"Virgin Islands (British)","useType":"web"},{"code":"1","value":"VI","label":"Virgin Islands (U.S.)","useType":"web"},{"code":"681","value":"WF","label":"Wallis and Futuna","useType":"both"},{"value":"EH","label":"Western Sahara","useType":"both"},{"code":"967","value":"YE","label":"Yemen","useType":"both"},{"code":"260","value":"ZM","label":"Zambia","useType":"both"},{"code":"263","value":"ZW","label":"Zimbabwe","useType":"both"}]`), dte = [{ value: "Armed Forces America", label: "Armed Forces America" }, { value: "Armed Forces", label: "Armed Forces" }, { value: "Armed Forces Pacific", label: "Armed Forces Pacific" }, { value: "Alaska", label: "Alaska" }, { value: "Alabama", label: "Alabama" }, { value: "Arizona", label: "Arizona" }, { value: "Arkansas", label: "Arkansas" }, { value: "California", label: "California" }, { value: "Colorado", label: "Colorado" }, { value: "Connecticut", label: "Connecticut" }, { value: "Washington DC", label: "Washington DC" }, { value: "Delaware", label: "Delaware" }, { value: "Florida", label: "Florida" }, { value: "Georgia", label: "Georgia" }, { value: "Guam", label: "Guam" }, { value: "Hawaii", label: "Hawaii" }, { value: "Idaho", label: "Idaho" }, { value: "Illinois", label: "Illinois" }, { value: "Indiana", label: "Indiana" }, { value: "Iowa", label: "Iowa" }, { value: "Kansas", label: "Kansas" }, { value: "Kentucky", label: "Kentucky" }, { value: "Louisiana", label: "Louisiana" }, { value: "Maine", label: "Maine" }, { value: "Maryland", label: "Maryland" }, { value: "Massachusetts", label: "Massachusetts" }, { value: "Michigan", label: "Michigan" }, { value: "Minnesota", label: "Minnesota" }, { value: "Mississippi", label: "Mississippi" }, { value: "Missouri", label: "Missouri" }, { value: "Montana", label: "Montana" }, { value: "Nebraska", label: "Nebraska" }, { value: "Nevada", label: "Nevada" }, { value: "New Hampshire", label: "New Hampshire" }, { value: "New Jersey", label: "New Jersey" }, { value: "New Mexico", label: "New Mexico" }, { value: "New York", label: "New York" }, { value: "North Carolina", label: "North Carolina" }, { value: "North Dakota", label: "North Dakota" }, { value: "Ohio", label: "Ohio" }, { value: "Oklahoma", label: "Oklahoma" }, { value: "Oregon", label: "Oregon" }, { value: "Pennsylvania", label: "Pennsylvania" }, { value: "Puerto Rico", label: "Puerto Rico" }, { value: "Rhode Island", label: "Rhode Island" }, { value: "South Carolina", label: "South Carolina" }, { value: "South Dakota", label: "South Dakota" }, { value: "Tennessee", label: "Tennessee" }, { value: "Texas", label: "Texas" }, { value: "Utah", label: "Utah" }, { value: "Vermont", label: "Vermont" }, { value: "Virginia", label: "Virginia" }, { value: "Virgin Islands", label: "Virgin Islands" }, { value: "Washington", label: "Washington" }, { value: "West Virginia", label: "West Virginia" }, { value: "Wisconsin", label: "Wisconsin" }, { value: "Wyoming", label: "Wyoming" }], pte = [{ value: "Alberta", label: "Alberta" }, { value: "British Columbia", label: "British Columbia" }, { value: "Manitoba", label: "Manitoba" }, { value: "New Brunswick", label: "New Brunswick" }, { value: "Newfoundland and Labrador", label: "Newfoundland and Labrador" }, { value: "Northwest Territories", label: "Northwest Territories" }, { value: "Nova Scotia", label: "Nova Scotia" }, { value: "Nunavut", label: "Nunavut" }, { value: "Ontario", label: "Ontario" }, { value: "Prince Edward Island", label: "Prince Edward Island" }, { value: "Quebec", label: "Quebec" }, { value: "Saskatchewan", label: "Saskatchewan" }, { value: "Yukon", label: "Yukon" }], fte = [{ value: "Andaman and Nicobar", label: "Andaman and Nicobar" }, { value: "Andhra Pradesh", label: "Andhra Pradesh" }, { value: "Arunachal Pradesh", label: "Arunachal Pradesh" }, { value: "Assam", label: "Assam" }, { value: "Bihar", label: "Bihar" }, { value: "Chandigarh", label: "Chandigarh" }, { value: "Chhattisgarh", label: "Chhattisgarh" }, { value: "Dadra and Nagar Haveli", label: "Dadra and Nagar Haveli" }, { value: "Daman and Diu", label: "Daman and Diu" }, { value: "Delhi", label: "Delhi" }, { value: "Goa", label: "Goa" }, { value: "Gujarat", label: "Gujarat" }, { value: "Haryana", label: "Haryana" }, { value: "Himachal Pradesh", label: "Himachal Pradesh" }, { value: "Jammu and Kashmir", label: "Jammu and Kashmir" }, { value: "Jharkhand", label: "Jharkhand" }, { value: "Karnataka", label: "Karnataka" }, { value: "Kerala", label: "Kerala" }, { value: "Ladakh", label: "Ladakh" }, { value: "Lakshadweep", label: "Lakshadweep" }, { value: "Madhya Pradesh", label: "Madhya Pradesh" }, { value: "Maharashtra", label: "Maharashtra" }, { value: "Manipur", label: "Manipur" }, { value: "Meghalaya", label: "Meghalaya" }, { value: "Mizoram", label: "Mizoram" }, { value: "Nagaland", label: "Nagaland" }, { value: "Odisha", label: "Odisha" }, { value: "Other Territory", label: "Other Territory" }, { value: "Puducherry", label: "Puducherry" }, { value: "Punjab", label: "Punjab" }, { value: "Rajasthan", label: "Rajasthan" }, { value: "Sikkim", label: "Sikkim" }, { value: "Tamil Nadu", label: "Tamil Nadu" }, { value: "Telangana", label: "Telangana" }, { value: "Tripura", label: "Tripura" }, { value: "Uttar Pradesh", label: "Uttar Pradesh" }, { value: "Uttarakhand", label: "Uttarakhand" }, { value: "West Bengal", label: "West Bengal" }], mte = [{ value: "Australian Capital Territory", label: "Australian Capital Territory" }, { value: "New South Wales", label: "New South Wales" }, { value: "Northern Territory", label: "Northern Territory" }, { value: "Queensland", label: "Queensland" }, { value: "South Australia", label: "South Australia" }, { value: "Tasmania", label: "Tasmania" }, { value: "Victoria", label: "Victoria" }, { value: "Western Australia", label: "Western Australia" }], hte = [{ value: "Abu Dhabi", label: "Abu Dhabi" }, { value: "Ajman", label: "Ajman" }, { value: "Dubai", label: "Dubai" }, { value: "Emirate of Umm Al Quwain", label: "Emirate of Umm Al Quwain" }, { value: "Fujairah", label: "Fujairah" }, { value: "Ras Al Khaimah", label: "Ras Al Khaimah" }, { value: "Sharjah", label: "Sharjah" }], vc = {
  US: dte,
  CA: pte,
  IN: fte,
  AU: mte,
  AE: hte
}, YS = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "SE",
  "MC",
  "IM",
  "GB"
], ZS = {
  GR: "EL",
  MC: "FR",
  IM: "GB"
};
function gte(e) {
  for (var t = 0, r = [1, 2, 1, 2, 1, 2, 1], o = 0, a = 0; a < 7; a++)
    o = Number(e.charAt(a)) * r[a], o > 9 ? t += Math.floor(o / 10) + o % 10 : t += o;
  return t = 10 - (t + 4) % 10, t == 10 && (t = 0), t == e.slice(7, 8);
}
function bte(e) {
  return e.length == 9 && (e = "0" + e), 97 - e.slice(0, 8) % 97 == e.slice(8, 10);
}
function yte(e) {
  if (e.length == 9) {
    for (var i = 0, r = 0, t = 0; t < 8; t++) r += Number(e.charAt(t)) * (t + 1);
    if (i = r % 11, i != 10)
      return i == e.slice(8);
    for (var r = 0, t = 0; t < 8; t++) r += Number(e.charAt(t)) * (t + 3);
    return i = r % 11, i == 10 && (i = 0), i == e.slice(8);
  }
  if (/^\d\d[0-5]\d[0-3]\d\d{4}$/.test(e)) {
    var o = Number(e.slice(2, 4));
    if (o > 0 && o < 13 || o > 20 && o < 33 || o > 40 && o < 53) {
      for (var a = [2, 4, 8, 5, 10, 9, 7, 3, 6], i = 0, t = 0; t < 9; t++) i += Number(e.charAt(t)) * a[t];
      if (i = i % 11, i == 10 && (i = 0), i == e.substr(9, 1)) return !0;
    }
  }
  for (var a = [21, 19, 17, 13, 11, 9, 7, 3, 1], i = 0, t = 0; t < 9; t++) i += Number(e.charAt(t)) * a[t];
  if (i % 10 == e.substr(9, 1)) return !0;
  for (var a = [4, 3, 2, 7, 6, 5, 4, 3, 2], i = 0, t = 0; t < 9; t++) i += Number(e.charAt(t)) * a[t];
  return i = 11 - i % 11, i == 10 ? !1 : (i == 11 && (i = 0), i == e.substr(9, 1));
}
function vte(e) {
  for (var t = [5, 4, 3, 2, 7, 6, 5, 4], r = 0, o = 0; o < 8; o++) r += Number(e.charAt(o)) * t[o];
  return r = 11 - r % 11, r == 10 ? !1 : (r == 11 && (r = 0), r == e.substr(8, 1));
}
function xte(e) {
  if (+(e.slice(0, 2) == 12)) return !1;
  for (var t = 0, r = 0; r < 8; r++) {
    var o = Number(e.charAt(r));
    if (r % 2 == 0)
      switch (o) {
        case 0:
          o = 1;
          break;
        case 1:
          o = 0;
          break;
        case 2:
          o = 5;
          break;
        case 3:
          o = 7;
          break;
        case 4:
          o = 9;
          break;
        default:
          o = o * 2 + 3;
      }
    t += o;
  }
  return t = t % 26, t = String.fromCharCode(t + 65), t == e.substr(8, 1);
}
function Cte(e) {
  var t = 0, r = [8, 7, 6, 5, 4, 3, 2], o = new Array();
  o[0] = /^\d{8}$/, o[1] = /^[0-5][0-9][0|1|5|6][0-9][0-3][0-9]\d{3}$/, o[2] = /^6\d{8}$/, o[3] = /^\d{2}[0-3|5-8][0-9][0-3][0-9]\d{4}$/;
  var a = 0;
  if (o[0].test(e)) {
    for (var a = 0; a < 7; a++) t += Number(e.charAt(a)) * r[a];
    return t = 11 - t % 11, t == 10 && (t = 0), t == 11 && (t = 1), t == e.slice(7, 8);
  } else {
    if (o[1].test(e))
      return !(d = Number(e.slice(0, 2)) > 62);
    if (o[2].test(e)) {
      for (var a = 0; a < 7; a++) t += Number(e.charAt(a + 1)) * r[a];
      if (t % 11 == 0)
        var i = t + 11;
      else
        var i = Math.ceil(t / 11) * 11;
      var l = i - t, c = [8, 7, 6, 5, 4, 3, 2, 1, 0, 9, 8];
      return c[l - 1] == e.slice(8, 9);
    } else if (o[3].test(e)) {
      var d = Number(e.slice(0, 2)) + Number(e.slice(2, 4)) + Number(e.slice(4, 6)) + Number(e.slice(6, 8)) + Number(e.slice(8));
      return d % 11 == 0 && Number(e) % 11 == 0;
    }
  }
  return !1;
}
function Ste(e) {
  for (var t = 10, r = 0, o = 0, a = 0; a < 8; a++)
    r = (Number(e.charAt(a)) + t) % 10, r == 0 && (r = 10), t = 2 * r % 11;
  return 11 - t == 10 ? o = 0 : o = 11 - t, o == e.slice(8, 9);
}
function wte(e) {
  for (var t = 0, r = [2, 7, 6, 5, 4, 3, 2, 1], o = 0; o < 8; o++) t += Number(e.charAt(o)) * r[o];
  return t = t % 11, t == 0;
}
function Tte(e) {
  for (var t = 0, r = [3, 7, 1, 3, 7, 1, 3, 7], o = 0; o < 8; o++) t += Number(e.charAt(o)) * r[o];
  return t = 10 - t % 10, t == 10 && (t = 0), t == e.slice(8, 9);
}
function Ete(e) {
  var t = 0, r = [256, 128, 64, 32, 16, 8, 4, 2];
  e.length == 8 && (e = "0" + e);
  for (var o = 0; o < 8; o++) t += Number(e.charAt(o)) * r[o];
  return t = t % 11, t > 9 && (t = 0), t == e.slice(8, 9);
}
function Ote(e) {
  var t = 0, r = 0, o = [2, 1, 2, 1, 2, 1, 2], a = new Array();
  a[0] = /^[A-H|J|U|V]\d{8}$/, a[1] = /^[A-H|N-S|W]\d{7}[A-J]$/, a[2] = /^[0-9|Y|Z]\d{7}[A-Z]$/, a[3] = /^[K|L|M|X]\d{7}[A-Z]$/;
  var i = 0;
  if (a[0].test(e)) {
    for (i = 0; i < 7; i++)
      r = Number(e.charAt(i + 1)) * o[i], r > 9 ? t += Math.floor(r / 10) + r % 10 : t += r;
    return t = 10 - t % 10, t == 10 && (t = 0), t == e.slice(8, 9);
  } else if (a[1].test(e)) {
    for (i = 0; i < 7; i++)
      r = Number(e.charAt(i + 1)) * o[i], r > 9 ? t += Math.floor(r / 10) + r % 10 : t += r;
    return t = 10 - t % 10, t = String.fromCharCode(t + 64), t == e.slice(8, 9);
  } else if (a[2].test(e)) {
    var l = e;
    return l.substring(0, 1) == "Y" && (l = l.replace(/Y/, "1")), l.substring(0, 1) == "Z" && (l = l.replace(/Z/, "2")), l.charAt(8) == "TRWAGMYFPDXBNJZSQVHLCKE".charAt(Number(l.substring(0, 8)) % 23);
  } else return a[3].test(e) ? e.charAt(8) == "TRWAGMYFPDXBNJZSQVHLCKE".charAt(Number(e.substring(1, 8)) % 23) : !1;
}
function $te(e) {
  return !0;
}
function Rte(e) {
  for (var t = 0, r = [7, 9, 10, 5, 8, 4, 2], o = 0; o < 7; o++) t += Number(e.charAt(o)) * r[o];
  return t = 11 - t % 11, t > 9 && (t = 0), t == e.slice(7, 8);
}
function Pte(e) {
  if (!/^\d{11}$/.test(e)) return !0;
  var t = e.substring(2);
  return t = (t * 100 + 12) % 97, t == e.slice(0, 2);
}
function kte(e) {
  var t = [8, 7, 6, 5, 4, 3, 2];
  if (e.substr(0, 2) == "GD")
    return e.substr(2, 3) < 500;
  if (e.substr(0, 2) == "HA")
    return e.substr(2, 3) > 499;
  var r = 0;
  if (Number(e.slice(0)) == 0) return !1;
  for (var o = Number(e.slice(0, 7)), a = 0; a < 7; a++) r += Number(e.charAt(a)) * t[a];
  for (var i = r; i > 0; )
    i = i - 97;
  return i = Math.abs(i), i == e.slice(7, 9) && o < 9990001 && (o < 1e5 || o > 999999) && (o < 9490001 || o > 97e5) || (i >= 55 ? i = i - 55 : i = i + 42, i == e.slice(7, 9) && o > 1e6);
}
function Ate(e) {
  for (var t = 10, r = 0, o = 0; o < 10; o++)
    r = (Number(e.charAt(o)) + t) % 10, r == 0 && (r = 10), t = 2 * r % 11;
  return (t + e.slice(10, 11) * 1) % 10 == 1;
}
function Ite(e) {
  for (var t = 0, r = [9, 7, 3, 1, 9, 7, 3], o = 0; o < 7; o++) t += Number(e.charAt(o)) * r[o];
  return t = 10 - t % 10, t == 10 && (t = 0), t == e.slice(7, 8);
}
function Nte(e) {
  var t = 0, r = [8, 7, 6, 5, 4, 3, 2];
  /^\d[A-Z\*\+]/.test(e) && (e = "0" + e.substring(2, 7) + e.substring(0, 1) + e.substring(7, 8));
  for (var o = 0; o < 7; o++) t += Number(e.charAt(o)) * r[o];
  return /^\d{7}[A-Z][AH]$/.test(e) && (e.charAt(8) == "H" ? t += 72 : t += 9), t = t % 23, t == 0 ? t = "W" : t = String.fromCharCode(t + 64), t == e.slice(7, 8);
}
function Mte(e) {
  var t = 0, r = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2], o;
  if (Number(e.slice(0, 7)) == 0 || (o = Number(e.slice(7, 10)), o < 1 || o > 201 && o != 999 && o != 888)) return !1;
  for (var a = 0; a < 10; a++)
    o = Number(e.charAt(a)) * r[a], o > 9 ? t += Math.floor(o / 10) + o % 10 : t += o;
  return t = 10 - t % 10, t > 9 && (t = 0), t == e.slice(10, 11);
}
function _te(e) {
  if (e.length == 9) {
    if (!/^\d{7}1/.test(e)) return !1;
    for (var t = 0, r = 0; r < 8; r++) t += Number(e.charAt(r)) * (r + 1);
    if (t % 11 == 10) {
      var o = [3, 4, 5, 6, 7, 8, 9, 1];
      for (t = 0, r = 0; r < 8; r++) t += Number(e.charAt(r)) * o[r];
    }
    return t = t % 11, t == 10 && (t = 0), t == e.slice(8, 9);
  } else {
    if (!/^\d{10}1/.test(e)) return !1;
    for (var t = 0, o = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2], r = 0; r < 11; r++) t += Number(e.charAt(r)) * o[r];
    if (t % 11 == 10) {
      var o = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4];
      for (t = 0, r = 0; r < 11; r++) t += Number(e.charAt(r)) * o[r];
    }
    return t = t % 11, t == 10 && (t = 0), t == e.slice(11, 12);
  }
}
function Fte(e) {
  return e.slice(0, 6) % 89 == e.slice(6, 8);
}
function Lte(e) {
  if (/^[0-3]/.test(e))
    return !!/^[0-3][0-9][0-1][0-9]/.test(e);
  for (var t = 0, r = [9, 1, 4, 8, 3, 10, 2, 5, 7, 6], o = 0; o < 10; o++) t += Number(e.charAt(o)) * r[o];
  return t % 11 == 4 && e[0] == 9 && (t = t - 45), t % 11 == 4 ? t = 4 - t % 11 : t % 11 > 4 ? t = 14 - t % 11 : t % 11 < 4 && (t = 3 - t % 11), t == e.slice(10, 11);
}
function Bte(e) {
  for (var t = 0, r = [3, 4, 6, 7, 8, 9], o = 0; o < 6; o++) t += Number(e.charAt(o)) * r[o];
  return t = 37 - t % 37, t == e.slice(6, 8) * 1;
}
function Dte(e) {
  function t(i) {
    for (var l = "NL" + i, c = "", d = "", p = 0; p < l.length; p++)
      c = l.charCodeAt(p), c > 41 && c < 44 ? c = c - 6 : c > 47 && c < 58 ? c = c - 48 : c > 64 && c < 91 && (c = c - 55), d = d + c;
    return d;
  }
  function r(i, l) {
    for (var c = 7; i.length > c; ) {
      var d = i.substring(0, c);
      i = d % l + i.substring(c);
    }
    return i % l;
  }
  function o() {
    for (var i = 0, l = [9, 8, 7, 6, 5, 4, 3, 2], c = 0; c < 8; c++) i += Number(e.charAt(c)) * l[c];
    return i = i % 11, i > 9 && (i = 0), i == e.slice(8, 9);
  }
  function a(i) {
    var l = t(i);
    return r(l, 97) == 1;
  }
  return o() ? !0 : !!a(e);
}
function jte(e) {
  for (var t = 0, r = [3, 2, 7, 6, 5, 4, 3, 2], o = 0; o < 8; o++) t += Number(e.charAt(o)) * r[o];
  if (t = 11 - t % 11, t == 11 && (t = 0), t < 10)
    return t == e.slice(8, 9);
}
function zte(e) {
  for (var t = 0, r = [6, 5, 7, 2, 3, 4, 5, 6, 7], o = 0; o < 9; o++) t += Number(e.charAt(o)) * r[o];
  return t = t % 11, t > 9 && (t = 0), t == e.slice(9, 10);
}
function Vte(e) {
  for (var t = 0, r = [9, 8, 7, 6, 5, 4, 3, 2], o = 0; o < 8; o++) t += Number(e.charAt(o)) * r[o];
  return t = 11 - t % 11, t > 9 && (t = 0), t == e.slice(8, 9);
}
function Wte(e) {
  var t = [7, 5, 3, 2, 1, 7, 5, 3, 2], r = e.length;
  t = t.slice(10 - r);
  for (var o = 0, a = 0; a < e.length - 1; a++)
    o += Number(e.charAt(a)) * t[a];
  return o = 10 * o % 11, o == 10 && (o = 0), o == e.slice(e.length - 1, e.length);
}
function Ute(e) {
  for (var t = 10, r = 0, o = 0; o < 8; o++)
    r = (Number(e.charAt(o)) + t) % 10, r == 0 && (r = 10), t = 2 * r % 11;
  return (t + e.slice(8, 9) * 1) % 10 == 1;
}
function Hte(e) {
  if (e.length == 10) {
    for (var t = 0, r = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0], o = 0; o < 10; o++)
      t += Number(e.charAt(o)) * r[o];
    return t = t % 11, t > 9 && (t = t % 10), t == e.slice(9, 10);
  } else if (e.length == 12) {
    for (var a = 0, i = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0], l = 0, c = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0], o = 0; o < 11; o++) a += Number(e.charAt(o)) * i[o];
    a = a % 11, a > 9 && (a = a % 10);
    for (var o = 0; o < 11; o++) l += Number(e.charAt(o)) * c[o];
    return l = l % 11, l > 9 && (l = l % 10), a == e.slice(10, 11) && l == e.slice(11, 12);
  }
}
function Gte(e) {
  for (var t = 0, r, o = 0; o < 9; o = o + 2)
    r = Number(e.charAt(o)), t += Math.floor(r / 5) + r * 2 % 10;
  for (var a = 0, o = 1; o < 9; o = o + 2) a += Number(e.charAt(o));
  var i = (10 - (t + a) % 10) % 10;
  return i == e.slice(9, 10);
}
function qte(e) {
  for (var t = 0, r = [8, 7, 6, 5, 4, 3, 2], o = 0; o < 7; o++) t += Number(e.charAt(o)) * r[o];
  return t = 11 - t % 11, t == 10 && (t = 0), t != 11 && t == e.slice(7, 8);
}
function Kte(e) {
  return Number(e % 11) == 0;
}
const Yh = {
  ATVATCheckDigit: gte,
  BEVATCheckDigit: bte,
  BGVATCheckDigit: yte,
  CHEVATCheckDigit: vte,
  CYVATCheckDigit: xte,
  CZVATCheckDigit: Cte,
  DEVATCheckDigit: Ste,
  DKVATCheckDigit: wte,
  EEVATCheckDigit: Tte,
  ELVATCheckDigit: Ete,
  ESVATCheckDigit: Ote,
  EUVATCheckDigit: $te,
  FIVATCheckDigit: Rte,
  FRVATCheckDigit: Pte,
  GBVATCheckDigit: kte,
  HRVATCheckDigit: Ate,
  HUVATCheckDigit: Ite,
  IEVATCheckDigit: Nte,
  ITVATCheckDigit: Mte,
  LTVATCheckDigit: _te,
  LUVATCheckDigit: Fte,
  LVVATCheckDigit: Lte,
  MTVATCheckDigit: Bte,
  NLVATCheckDigit: Dte,
  NOVATCheckDigit: jte,
  PLVATCheckDigit: zte,
  PTVATCheckDigit: Vte,
  ROVATCheckDigit: Wte,
  RSVATCheckDigit: Ute,
  RUVATCheckDigit: Hte,
  SEVATCheckDigit: Gte,
  SIVATCheckDigit: qte,
  SKVATCheckDigit: Kte
};
var Rc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var Yte = Rc.exports, XS;
function Zte() {
  return XS || (XS = 1, function(e, t) {
    (function() {
      var r, o = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", p = 500, f = "__lodash_placeholder__", h = 1, g = 2, y = 4, C = 1, b = 2, v = 1, T = 2, R = 4, $ = 8, E = 16, S = 32, k = 64, A = 128, _ = 256, L = 512, O = 30, F = "...", B = 800, M = 16, j = 1, W = 2, V = 3, X = 1 / 0, U = 9007199254740991, H = 17976931348623157e292, Z = NaN, G = 4294967295, ye = G - 1, de = G >>> 1, ne = [
        ["ary", A],
        ["bind", v],
        ["bindKey", T],
        ["curry", $],
        ["curryRight", E],
        ["flip", L],
        ["partial", S],
        ["partialRight", k],
        ["rearg", _]
      ], fe = "[object Arguments]", ie = "[object Array]", oe = "[object AsyncFunction]", ce = "[object Boolean]", Ce = "[object Date]", xe = "[object DOMException]", Re = "[object Error]", J = "[object Function]", Ie = "[object GeneratorFunction]", le = "[object Map]", qe = "[object Number]", q = "[object Null]", K = "[object Object]", ee = "[object Promise]", he = "[object Proxy]", we = "[object RegExp]", se = "[object Set]", ue = "[object String]", Qe = "[object Symbol]", We = "[object Undefined]", be = "[object WeakMap]", Se = "[object WeakSet]", De = "[object ArrayBuffer]", Ye = "[object DataView]", et = "[object Float32Array]", Je = "[object Float64Array]", tt = "[object Int8Array]", Rt = "[object Int16Array]", xt = "[object Int32Array]", rt = "[object Uint8Array]", He = "[object Uint8ClampedArray]", Oe = "[object Uint16Array]", Ze = "[object Uint32Array]", Pt = /\b__p \+= '';/g, Mt = /\b(__p \+=) '' \+/g, Ct = /(__e\(.*?\)|\b__t\)) \+\n'';/g, bt = /&(?:amp|lt|gt|quot|#39);/g, nt = /[&<>"']/g, ft = RegExp(bt.source), er = RegExp(nt.source), Ut = /<%-([\s\S]+?)%>/g, Ft = /<%([\s\S]+?)%>/g, ct = /<%=([\s\S]+?)%>/g, fr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, at = /^\w*$/, lt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, St = /[\\^$.*+?()[\]{}|]/g, kt = RegExp(St.source), Wt = /^\s+/, Lr = /\s/, hn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, oo = /\{\n\/\* \[wrapped with (.+)\] \*/, te = /,? & /, _e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Xe = /[()=,{}\[\]\/\s]/, yt = /\\(\\)?/g, Ht = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Te = /\w*$/, ve = /^[-+]0x[0-9a-f]+$/i, je = /^0b[01]+$/i, ht = /^\[object .+?Constructor\]$/, mt = /^0o[0-7]+$/i, vt = /^(?:0|[1-9]\d*)$/, Kt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, br = /($^)/, $n = /['\n\r\u2028\u2029\\]/g, Wr = "\\ud800-\\udfff", ui = "\\u0300-\\u036f", Ls = "\\ufe20-\\ufe2f", Bs = "\\u20d0-\\u20ff", Qt = ui + Ls + Bs, ao = "\\u2700-\\u27bf", Zo = "a-z\\xdf-\\xf6\\xf8-\\xff", ji = "\\xac\\xb1\\xd7\\xf7", Ff = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", w$ = "\\u2000-\\u206f", T$ = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", dv = "A-Z\\xc0-\\xd6\\xd8-\\xde", pv = "\\ufe0e\\ufe0f", fv = ji + Ff + w$ + T$, Lf = "['’]", E$ = "[" + Wr + "]", mv = "[" + fv + "]", wu = "[" + Qt + "]", hv = "\\d+", O$ = "[" + ao + "]", gv = "[" + Zo + "]", bv = "[^" + Wr + fv + hv + ao + Zo + dv + "]", Bf = "\\ud83c[\\udffb-\\udfff]", $$ = "(?:" + wu + "|" + Bf + ")", yv = "[^" + Wr + "]", Df = "(?:\\ud83c[\\udde6-\\uddff]){2}", jf = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ds = "[" + dv + "]", vv = "\\u200d", xv = "(?:" + gv + "|" + bv + ")", R$ = "(?:" + Ds + "|" + bv + ")", Cv = "(?:" + Lf + "(?:d|ll|m|re|s|t|ve))?", Sv = "(?:" + Lf + "(?:D|LL|M|RE|S|T|VE))?", wv = $$ + "?", Tv = "[" + pv + "]?", P$ = "(?:" + vv + "(?:" + [yv, Df, jf].join("|") + ")" + Tv + wv + ")*", k$ = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", A$ = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ev = Tv + wv + P$, I$ = "(?:" + [O$, Df, jf].join("|") + ")" + Ev, N$ = "(?:" + [yv + wu + "?", wu, Df, jf, E$].join("|") + ")", M$ = RegExp(Lf, "g"), _$ = RegExp(wu, "g"), zf = RegExp(Bf + "(?=" + Bf + ")|" + N$ + Ev, "g"), F$ = RegExp([
        Ds + "?" + gv + "+" + Cv + "(?=" + [mv, Ds, "$"].join("|") + ")",
        R$ + "+" + Sv + "(?=" + [mv, Ds + xv, "$"].join("|") + ")",
        Ds + "?" + xv + "+" + Cv,
        Ds + "+" + Sv,
        A$,
        k$,
        hv,
        I$
      ].join("|"), "g"), L$ = RegExp("[" + vv + Wr + Qt + pv + "]"), B$ = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, D$ = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], j$ = -1, kr = {};
      kr[et] = kr[Je] = kr[tt] = kr[Rt] = kr[xt] = kr[rt] = kr[He] = kr[Oe] = kr[Ze] = !0, kr[fe] = kr[ie] = kr[De] = kr[ce] = kr[Ye] = kr[Ce] = kr[Re] = kr[J] = kr[le] = kr[qe] = kr[K] = kr[we] = kr[se] = kr[ue] = kr[be] = !1;
      var wr = {};
      wr[fe] = wr[ie] = wr[De] = wr[Ye] = wr[ce] = wr[Ce] = wr[et] = wr[Je] = wr[tt] = wr[Rt] = wr[xt] = wr[le] = wr[qe] = wr[K] = wr[we] = wr[se] = wr[ue] = wr[Qe] = wr[rt] = wr[He] = wr[Oe] = wr[Ze] = !0, wr[Re] = wr[J] = wr[be] = !1;
      var z$ = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, V$ = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, W$ = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, U$ = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, H$ = parseFloat, G$ = parseInt, Ov = typeof cd == "object" && cd && cd.Object === Object && cd, q$ = typeof self == "object" && self && self.Object === Object && self, gn = Ov || q$ || Function("return this")(), Vf = t && !t.nodeType && t, zi = Vf && !0 && e && !e.nodeType && e, $v = zi && zi.exports === Vf, Wf = $v && Ov.process, Io = function() {
        try {
          var pe = zi && zi.require && zi.require("util").types;
          return pe || Wf && Wf.binding && Wf.binding("util");
        } catch {
        }
      }(), Rv = Io && Io.isArrayBuffer, Pv = Io && Io.isDate, kv = Io && Io.isMap, Av = Io && Io.isRegExp, Iv = Io && Io.isSet, Nv = Io && Io.isTypedArray;
      function io(pe, ke, Ee) {
        switch (Ee.length) {
          case 0:
            return pe.call(ke);
          case 1:
            return pe.call(ke, Ee[0]);
          case 2:
            return pe.call(ke, Ee[0], Ee[1]);
          case 3:
            return pe.call(ke, Ee[0], Ee[1], Ee[2]);
        }
        return pe.apply(ke, Ee);
      }
      function K$(pe, ke, Ee, ut) {
        for (var At = -1, rr = pe == null ? 0 : pe.length; ++At < rr; ) {
          var on = pe[At];
          ke(ut, on, Ee(on), pe);
        }
        return ut;
      }
      function No(pe, ke) {
        for (var Ee = -1, ut = pe == null ? 0 : pe.length; ++Ee < ut && ke(pe[Ee], Ee, pe) !== !1; )
          ;
        return pe;
      }
      function Y$(pe, ke) {
        for (var Ee = pe == null ? 0 : pe.length; Ee-- && ke(pe[Ee], Ee, pe) !== !1; )
          ;
        return pe;
      }
      function Mv(pe, ke) {
        for (var Ee = -1, ut = pe == null ? 0 : pe.length; ++Ee < ut; )
          if (!ke(pe[Ee], Ee, pe))
            return !1;
        return !0;
      }
      function di(pe, ke) {
        for (var Ee = -1, ut = pe == null ? 0 : pe.length, At = 0, rr = []; ++Ee < ut; ) {
          var on = pe[Ee];
          ke(on, Ee, pe) && (rr[At++] = on);
        }
        return rr;
      }
      function Tu(pe, ke) {
        var Ee = pe == null ? 0 : pe.length;
        return !!Ee && js(pe, ke, 0) > -1;
      }
      function Uf(pe, ke, Ee) {
        for (var ut = -1, At = pe == null ? 0 : pe.length; ++ut < At; )
          if (Ee(ke, pe[ut]))
            return !0;
        return !1;
      }
      function Nr(pe, ke) {
        for (var Ee = -1, ut = pe == null ? 0 : pe.length, At = Array(ut); ++Ee < ut; )
          At[Ee] = ke(pe[Ee], Ee, pe);
        return At;
      }
      function pi(pe, ke) {
        for (var Ee = -1, ut = ke.length, At = pe.length; ++Ee < ut; )
          pe[At + Ee] = ke[Ee];
        return pe;
      }
      function Hf(pe, ke, Ee, ut) {
        var At = -1, rr = pe == null ? 0 : pe.length;
        for (ut && rr && (Ee = pe[++At]); ++At < rr; )
          Ee = ke(Ee, pe[At], At, pe);
        return Ee;
      }
      function Z$(pe, ke, Ee, ut) {
        var At = pe == null ? 0 : pe.length;
        for (ut && At && (Ee = pe[--At]); At--; )
          Ee = ke(Ee, pe[At], At, pe);
        return Ee;
      }
      function Gf(pe, ke) {
        for (var Ee = -1, ut = pe == null ? 0 : pe.length; ++Ee < ut; )
          if (ke(pe[Ee], Ee, pe))
            return !0;
        return !1;
      }
      var X$ = qf("length");
      function J$(pe) {
        return pe.split("");
      }
      function Q$(pe) {
        return pe.match(_e) || [];
      }
      function _v(pe, ke, Ee) {
        var ut;
        return Ee(pe, function(At, rr, on) {
          if (ke(At, rr, on))
            return ut = rr, !1;
        }), ut;
      }
      function Eu(pe, ke, Ee, ut) {
        for (var At = pe.length, rr = Ee + (ut ? 1 : -1); ut ? rr-- : ++rr < At; )
          if (ke(pe[rr], rr, pe))
            return rr;
        return -1;
      }
      function js(pe, ke, Ee) {
        return ke === ke ? dR(pe, ke, Ee) : Eu(pe, Fv, Ee);
      }
      function eR(pe, ke, Ee, ut) {
        for (var At = Ee - 1, rr = pe.length; ++At < rr; )
          if (ut(pe[At], ke))
            return At;
        return -1;
      }
      function Fv(pe) {
        return pe !== pe;
      }
      function Lv(pe, ke) {
        var Ee = pe == null ? 0 : pe.length;
        return Ee ? Yf(pe, ke) / Ee : Z;
      }
      function qf(pe) {
        return function(ke) {
          return ke == null ? r : ke[pe];
        };
      }
      function Kf(pe) {
        return function(ke) {
          return pe == null ? r : pe[ke];
        };
      }
      function Bv(pe, ke, Ee, ut, At) {
        return At(pe, function(rr, on, yr) {
          Ee = ut ? (ut = !1, rr) : ke(Ee, rr, on, yr);
        }), Ee;
      }
      function tR(pe, ke) {
        var Ee = pe.length;
        for (pe.sort(ke); Ee--; )
          pe[Ee] = pe[Ee].value;
        return pe;
      }
      function Yf(pe, ke) {
        for (var Ee, ut = -1, At = pe.length; ++ut < At; ) {
          var rr = ke(pe[ut]);
          rr !== r && (Ee = Ee === r ? rr : Ee + rr);
        }
        return Ee;
      }
      function Zf(pe, ke) {
        for (var Ee = -1, ut = Array(pe); ++Ee < pe; )
          ut[Ee] = ke(Ee);
        return ut;
      }
      function rR(pe, ke) {
        return Nr(ke, function(Ee) {
          return [Ee, pe[Ee]];
        });
      }
      function Dv(pe) {
        return pe && pe.slice(0, Wv(pe) + 1).replace(Wt, "");
      }
      function so(pe) {
        return function(ke) {
          return pe(ke);
        };
      }
      function Xf(pe, ke) {
        return Nr(ke, function(Ee) {
          return pe[Ee];
        });
      }
      function Gl(pe, ke) {
        return pe.has(ke);
      }
      function jv(pe, ke) {
        for (var Ee = -1, ut = pe.length; ++Ee < ut && js(ke, pe[Ee], 0) > -1; )
          ;
        return Ee;
      }
      function zv(pe, ke) {
        for (var Ee = pe.length; Ee-- && js(ke, pe[Ee], 0) > -1; )
          ;
        return Ee;
      }
      function nR(pe, ke) {
        for (var Ee = pe.length, ut = 0; Ee--; )
          pe[Ee] === ke && ++ut;
        return ut;
      }
      var oR = Kf(z$), aR = Kf(V$);
      function iR(pe) {
        return "\\" + U$[pe];
      }
      function sR(pe, ke) {
        return pe == null ? r : pe[ke];
      }
      function zs(pe) {
        return L$.test(pe);
      }
      function lR(pe) {
        return B$.test(pe);
      }
      function cR(pe) {
        for (var ke, Ee = []; !(ke = pe.next()).done; )
          Ee.push(ke.value);
        return Ee;
      }
      function Jf(pe) {
        var ke = -1, Ee = Array(pe.size);
        return pe.forEach(function(ut, At) {
          Ee[++ke] = [At, ut];
        }), Ee;
      }
      function Vv(pe, ke) {
        return function(Ee) {
          return pe(ke(Ee));
        };
      }
      function fi(pe, ke) {
        for (var Ee = -1, ut = pe.length, At = 0, rr = []; ++Ee < ut; ) {
          var on = pe[Ee];
          (on === ke || on === f) && (pe[Ee] = f, rr[At++] = Ee);
        }
        return rr;
      }
      function Ou(pe) {
        var ke = -1, Ee = Array(pe.size);
        return pe.forEach(function(ut) {
          Ee[++ke] = ut;
        }), Ee;
      }
      function uR(pe) {
        var ke = -1, Ee = Array(pe.size);
        return pe.forEach(function(ut) {
          Ee[++ke] = [ut, ut];
        }), Ee;
      }
      function dR(pe, ke, Ee) {
        for (var ut = Ee - 1, At = pe.length; ++ut < At; )
          if (pe[ut] === ke)
            return ut;
        return -1;
      }
      function pR(pe, ke, Ee) {
        for (var ut = Ee + 1; ut--; )
          if (pe[ut] === ke)
            return ut;
        return ut;
      }
      function Vs(pe) {
        return zs(pe) ? mR(pe) : X$(pe);
      }
      function Xo(pe) {
        return zs(pe) ? hR(pe) : J$(pe);
      }
      function Wv(pe) {
        for (var ke = pe.length; ke-- && Lr.test(pe.charAt(ke)); )
          ;
        return ke;
      }
      var fR = Kf(W$);
      function mR(pe) {
        for (var ke = zf.lastIndex = 0; zf.test(pe); )
          ++ke;
        return ke;
      }
      function hR(pe) {
        return pe.match(zf) || [];
      }
      function gR(pe) {
        return pe.match(F$) || [];
      }
      var bR = function pe(ke) {
        ke = ke == null ? gn : Ws.defaults(gn.Object(), ke, Ws.pick(gn, D$));
        var Ee = ke.Array, ut = ke.Date, At = ke.Error, rr = ke.Function, on = ke.Math, yr = ke.Object, Qf = ke.RegExp, yR = ke.String, Mo = ke.TypeError, $u = Ee.prototype, vR = rr.prototype, Us = yr.prototype, Ru = ke["__core-js_shared__"], Pu = vR.toString, pr = Us.hasOwnProperty, xR = 0, Uv = function() {
          var s = /[^.]+$/.exec(Ru && Ru.keys && Ru.keys.IE_PROTO || "");
          return s ? "Symbol(src)_1." + s : "";
        }(), ku = Us.toString, CR = Pu.call(yr), SR = gn._, wR = Qf(
          "^" + Pu.call(pr).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Au = $v ? ke.Buffer : r, mi = ke.Symbol, Iu = ke.Uint8Array, Hv = Au ? Au.allocUnsafe : r, Nu = Vv(yr.getPrototypeOf, yr), Gv = yr.create, qv = Us.propertyIsEnumerable, Mu = $u.splice, Kv = mi ? mi.isConcatSpreadable : r, ql = mi ? mi.iterator : r, Vi = mi ? mi.toStringTag : r, _u = function() {
          try {
            var s = qi(yr, "defineProperty");
            return s({}, "", {}), s;
          } catch {
          }
        }(), TR = ke.clearTimeout !== gn.clearTimeout && ke.clearTimeout, ER = ut && ut.now !== gn.Date.now && ut.now, OR = ke.setTimeout !== gn.setTimeout && ke.setTimeout, Fu = on.ceil, Lu = on.floor, em = yr.getOwnPropertySymbols, $R = Au ? Au.isBuffer : r, Yv = ke.isFinite, RR = $u.join, PR = Vv(yr.keys, yr), an = on.max, Cn = on.min, kR = ut.now, AR = ke.parseInt, Zv = on.random, IR = $u.reverse, tm = qi(ke, "DataView"), Kl = qi(ke, "Map"), rm = qi(ke, "Promise"), Hs = qi(ke, "Set"), Yl = qi(ke, "WeakMap"), Zl = qi(yr, "create"), Bu = Yl && new Yl(), Gs = {}, NR = Ki(tm), MR = Ki(Kl), _R = Ki(rm), FR = Ki(Hs), LR = Ki(Yl), Du = mi ? mi.prototype : r, Xl = Du ? Du.valueOf : r, Xv = Du ? Du.toString : r;
        function D(s) {
          if (Br(s) && !It(s) && !(s instanceof qt)) {
            if (s instanceof _o)
              return s;
            if (pr.call(s, "__wrapped__"))
              return J0(s);
          }
          return new _o(s);
        }
        var qs = /* @__PURE__ */ function() {
          function s() {
          }
          return function(u) {
            if (!_r(u))
              return {};
            if (Gv)
              return Gv(u);
            s.prototype = u;
            var m = new s();
            return s.prototype = r, m;
          };
        }();
        function ju() {
        }
        function _o(s, u) {
          this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = r;
        }
        D.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Ut,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Ft,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: ct,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: D
          }
        }, D.prototype = ju.prototype, D.prototype.constructor = D, _o.prototype = qs(ju.prototype), _o.prototype.constructor = _o;
        function qt(s) {
          this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = G, this.__views__ = [];
        }
        function BR() {
          var s = new qt(this.__wrapped__);
          return s.__actions__ = Vn(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Vn(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Vn(this.__views__), s;
        }
        function DR() {
          if (this.__filtered__) {
            var s = new qt(this);
            s.__dir__ = -1, s.__filtered__ = !0;
          } else
            s = this.clone(), s.__dir__ *= -1;
          return s;
        }
        function jR() {
          var s = this.__wrapped__.value(), u = this.__dir__, m = It(s), w = u < 0, I = m ? s.length : 0, z = J3(0, I, this.__views__), Q = z.start, ae = z.end, me = ae - Q, Le = w ? ae : Q - 1, Be = this.__iteratees__, Ge = Be.length, it = 0, gt = Cn(me, this.__takeCount__);
          if (!m || !w && I == me && gt == me)
            return C0(s, this.__actions__);
          var Et = [];
          e:
            for (; me-- && it < gt; ) {
              Le += u;
              for (var Lt = -1, Ot = s[Le]; ++Lt < Ge; ) {
                var Gt = Be[Lt], Yt = Gt.iteratee, uo = Gt.type, kn = Yt(Ot);
                if (uo == W)
                  Ot = kn;
                else if (!kn) {
                  if (uo == j)
                    continue e;
                  break e;
                }
              }
              Et[it++] = Ot;
            }
          return Et;
        }
        qt.prototype = qs(ju.prototype), qt.prototype.constructor = qt;
        function Wi(s) {
          var u = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++u < m; ) {
            var w = s[u];
            this.set(w[0], w[1]);
          }
        }
        function zR() {
          this.__data__ = Zl ? Zl(null) : {}, this.size = 0;
        }
        function VR(s) {
          var u = this.has(s) && delete this.__data__[s];
          return this.size -= u ? 1 : 0, u;
        }
        function WR(s) {
          var u = this.__data__;
          if (Zl) {
            var m = u[s];
            return m === d ? r : m;
          }
          return pr.call(u, s) ? u[s] : r;
        }
        function UR(s) {
          var u = this.__data__;
          return Zl ? u[s] !== r : pr.call(u, s);
        }
        function HR(s, u) {
          var m = this.__data__;
          return this.size += this.has(s) ? 0 : 1, m[s] = Zl && u === r ? d : u, this;
        }
        Wi.prototype.clear = zR, Wi.prototype.delete = VR, Wi.prototype.get = WR, Wi.prototype.has = UR, Wi.prototype.set = HR;
        function Na(s) {
          var u = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++u < m; ) {
            var w = s[u];
            this.set(w[0], w[1]);
          }
        }
        function GR() {
          this.__data__ = [], this.size = 0;
        }
        function qR(s) {
          var u = this.__data__, m = zu(u, s);
          if (m < 0)
            return !1;
          var w = u.length - 1;
          return m == w ? u.pop() : Mu.call(u, m, 1), --this.size, !0;
        }
        function KR(s) {
          var u = this.__data__, m = zu(u, s);
          return m < 0 ? r : u[m][1];
        }
        function YR(s) {
          return zu(this.__data__, s) > -1;
        }
        function ZR(s, u) {
          var m = this.__data__, w = zu(m, s);
          return w < 0 ? (++this.size, m.push([s, u])) : m[w][1] = u, this;
        }
        Na.prototype.clear = GR, Na.prototype.delete = qR, Na.prototype.get = KR, Na.prototype.has = YR, Na.prototype.set = ZR;
        function Ma(s) {
          var u = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++u < m; ) {
            var w = s[u];
            this.set(w[0], w[1]);
          }
        }
        function XR() {
          this.size = 0, this.__data__ = {
            hash: new Wi(),
            map: new (Kl || Na)(),
            string: new Wi()
          };
        }
        function JR(s) {
          var u = Qu(this, s).delete(s);
          return this.size -= u ? 1 : 0, u;
        }
        function QR(s) {
          return Qu(this, s).get(s);
        }
        function e3(s) {
          return Qu(this, s).has(s);
        }
        function t3(s, u) {
          var m = Qu(this, s), w = m.size;
          return m.set(s, u), this.size += m.size == w ? 0 : 1, this;
        }
        Ma.prototype.clear = XR, Ma.prototype.delete = JR, Ma.prototype.get = QR, Ma.prototype.has = e3, Ma.prototype.set = t3;
        function Ui(s) {
          var u = -1, m = s == null ? 0 : s.length;
          for (this.__data__ = new Ma(); ++u < m; )
            this.add(s[u]);
        }
        function r3(s) {
          return this.__data__.set(s, d), this;
        }
        function n3(s) {
          return this.__data__.has(s);
        }
        Ui.prototype.add = Ui.prototype.push = r3, Ui.prototype.has = n3;
        function Jo(s) {
          var u = this.__data__ = new Na(s);
          this.size = u.size;
        }
        function o3() {
          this.__data__ = new Na(), this.size = 0;
        }
        function a3(s) {
          var u = this.__data__, m = u.delete(s);
          return this.size = u.size, m;
        }
        function i3(s) {
          return this.__data__.get(s);
        }
        function s3(s) {
          return this.__data__.has(s);
        }
        function l3(s, u) {
          var m = this.__data__;
          if (m instanceof Na) {
            var w = m.__data__;
            if (!Kl || w.length < a - 1)
              return w.push([s, u]), this.size = ++m.size, this;
            m = this.__data__ = new Ma(w);
          }
          return m.set(s, u), this.size = m.size, this;
        }
        Jo.prototype.clear = o3, Jo.prototype.delete = a3, Jo.prototype.get = i3, Jo.prototype.has = s3, Jo.prototype.set = l3;
        function Jv(s, u) {
          var m = It(s), w = !m && Yi(s), I = !m && !w && vi(s), z = !m && !w && !I && Xs(s), Q = m || w || I || z, ae = Q ? Zf(s.length, yR) : [], me = ae.length;
          for (var Le in s)
            (u || pr.call(s, Le)) && !(Q && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Le == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            I && (Le == "offset" || Le == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            z && (Le == "buffer" || Le == "byteLength" || Le == "byteOffset") || // Skip index properties.
            Ba(Le, me))) && ae.push(Le);
          return ae;
        }
        function Qv(s) {
          var u = s.length;
          return u ? s[fm(0, u - 1)] : r;
        }
        function c3(s, u) {
          return ed(Vn(s), Hi(u, 0, s.length));
        }
        function u3(s) {
          return ed(Vn(s));
        }
        function nm(s, u, m) {
          (m !== r && !Qo(s[u], m) || m === r && !(u in s)) && _a(s, u, m);
        }
        function Jl(s, u, m) {
          var w = s[u];
          (!(pr.call(s, u) && Qo(w, m)) || m === r && !(u in s)) && _a(s, u, m);
        }
        function zu(s, u) {
          for (var m = s.length; m--; )
            if (Qo(s[m][0], u))
              return m;
          return -1;
        }
        function d3(s, u, m, w) {
          return hi(s, function(I, z, Q) {
            u(w, I, m(I), Q);
          }), w;
        }
        function e0(s, u) {
          return s && pa(u, cn(u), s);
        }
        function p3(s, u) {
          return s && pa(u, Un(u), s);
        }
        function _a(s, u, m) {
          u == "__proto__" && _u ? _u(s, u, {
            configurable: !0,
            enumerable: !0,
            value: m,
            writable: !0
          }) : s[u] = m;
        }
        function om(s, u) {
          for (var m = -1, w = u.length, I = Ee(w), z = s == null; ++m < w; )
            I[m] = z ? r : Bm(s, u[m]);
          return I;
        }
        function Hi(s, u, m) {
          return s === s && (m !== r && (s = s <= m ? s : m), u !== r && (s = s >= u ? s : u)), s;
        }
        function Fo(s, u, m, w, I, z) {
          var Q, ae = u & h, me = u & g, Le = u & y;
          if (m && (Q = I ? m(s, w, I, z) : m(s)), Q !== r)
            return Q;
          if (!_r(s))
            return s;
          var Be = It(s);
          if (Be) {
            if (Q = e6(s), !ae)
              return Vn(s, Q);
          } else {
            var Ge = Sn(s), it = Ge == J || Ge == Ie;
            if (vi(s))
              return T0(s, ae);
            if (Ge == K || Ge == fe || it && !I) {
              if (Q = me || it ? {} : W0(s), !ae)
                return me ? W3(s, p3(Q, s)) : V3(s, e0(Q, s));
            } else {
              if (!wr[Ge])
                return I ? s : {};
              Q = t6(s, Ge, ae);
            }
          }
          z || (z = new Jo());
          var gt = z.get(s);
          if (gt)
            return gt;
          z.set(s, Q), y1(s) ? s.forEach(function(Ot) {
            Q.add(Fo(Ot, u, m, Ot, s, z));
          }) : g1(s) && s.forEach(function(Ot, Gt) {
            Q.set(Gt, Fo(Ot, u, m, Gt, s, z));
          });
          var Et = Le ? me ? Tm : wm : me ? Un : cn, Lt = Be ? r : Et(s);
          return No(Lt || s, function(Ot, Gt) {
            Lt && (Gt = Ot, Ot = s[Gt]), Jl(Q, Gt, Fo(Ot, u, m, Gt, s, z));
          }), Q;
        }
        function f3(s) {
          var u = cn(s);
          return function(m) {
            return t0(m, s, u);
          };
        }
        function t0(s, u, m) {
          var w = m.length;
          if (s == null)
            return !w;
          for (s = yr(s); w--; ) {
            var I = m[w], z = u[I], Q = s[I];
            if (Q === r && !(I in s) || !z(Q))
              return !1;
          }
          return !0;
        }
        function r0(s, u, m) {
          if (typeof s != "function")
            throw new Mo(l);
          return ac(function() {
            s.apply(r, m);
          }, u);
        }
        function Ql(s, u, m, w) {
          var I = -1, z = Tu, Q = !0, ae = s.length, me = [], Le = u.length;
          if (!ae)
            return me;
          m && (u = Nr(u, so(m))), w ? (z = Uf, Q = !1) : u.length >= a && (z = Gl, Q = !1, u = new Ui(u));
          e:
            for (; ++I < ae; ) {
              var Be = s[I], Ge = m == null ? Be : m(Be);
              if (Be = w || Be !== 0 ? Be : 0, Q && Ge === Ge) {
                for (var it = Le; it--; )
                  if (u[it] === Ge)
                    continue e;
                me.push(Be);
              } else z(u, Ge, w) || me.push(Be);
            }
          return me;
        }
        var hi = P0(da), n0 = P0(im, !0);
        function m3(s, u) {
          var m = !0;
          return hi(s, function(w, I, z) {
            return m = !!u(w, I, z), m;
          }), m;
        }
        function Vu(s, u, m) {
          for (var w = -1, I = s.length; ++w < I; ) {
            var z = s[w], Q = u(z);
            if (Q != null && (ae === r ? Q === Q && !co(Q) : m(Q, ae)))
              var ae = Q, me = z;
          }
          return me;
        }
        function h3(s, u, m, w) {
          var I = s.length;
          for (m = _t(m), m < 0 && (m = -m > I ? 0 : I + m), w = w === r || w > I ? I : _t(w), w < 0 && (w += I), w = m > w ? 0 : x1(w); m < w; )
            s[m++] = u;
          return s;
        }
        function o0(s, u) {
          var m = [];
          return hi(s, function(w, I, z) {
            u(w, I, z) && m.push(w);
          }), m;
        }
        function bn(s, u, m, w, I) {
          var z = -1, Q = s.length;
          for (m || (m = n6), I || (I = []); ++z < Q; ) {
            var ae = s[z];
            u > 0 && m(ae) ? u > 1 ? bn(ae, u - 1, m, w, I) : pi(I, ae) : w || (I[I.length] = ae);
          }
          return I;
        }
        var am = k0(), a0 = k0(!0);
        function da(s, u) {
          return s && am(s, u, cn);
        }
        function im(s, u) {
          return s && a0(s, u, cn);
        }
        function Wu(s, u) {
          return di(u, function(m) {
            return Da(s[m]);
          });
        }
        function Gi(s, u) {
          u = bi(u, s);
          for (var m = 0, w = u.length; s != null && m < w; )
            s = s[fa(u[m++])];
          return m && m == w ? s : r;
        }
        function i0(s, u, m) {
          var w = u(s);
          return It(s) ? w : pi(w, m(s));
        }
        function Rn(s) {
          return s == null ? s === r ? We : q : Vi && Vi in yr(s) ? X3(s) : u6(s);
        }
        function sm(s, u) {
          return s > u;
        }
        function g3(s, u) {
          return s != null && pr.call(s, u);
        }
        function b3(s, u) {
          return s != null && u in yr(s);
        }
        function y3(s, u, m) {
          return s >= Cn(u, m) && s < an(u, m);
        }
        function lm(s, u, m) {
          for (var w = m ? Uf : Tu, I = s[0].length, z = s.length, Q = z, ae = Ee(z), me = 1 / 0, Le = []; Q--; ) {
            var Be = s[Q];
            Q && u && (Be = Nr(Be, so(u))), me = Cn(Be.length, me), ae[Q] = !m && (u || I >= 120 && Be.length >= 120) ? new Ui(Q && Be) : r;
          }
          Be = s[0];
          var Ge = -1, it = ae[0];
          e:
            for (; ++Ge < I && Le.length < me; ) {
              var gt = Be[Ge], Et = u ? u(gt) : gt;
              if (gt = m || gt !== 0 ? gt : 0, !(it ? Gl(it, Et) : w(Le, Et, m))) {
                for (Q = z; --Q; ) {
                  var Lt = ae[Q];
                  if (!(Lt ? Gl(Lt, Et) : w(s[Q], Et, m)))
                    continue e;
                }
                it && it.push(Et), Le.push(gt);
              }
            }
          return Le;
        }
        function v3(s, u, m, w) {
          return da(s, function(I, z, Q) {
            u(w, m(I), z, Q);
          }), w;
        }
        function ec(s, u, m) {
          u = bi(u, s), s = q0(s, u);
          var w = s == null ? s : s[fa(Bo(u))];
          return w == null ? r : io(w, s, m);
        }
        function s0(s) {
          return Br(s) && Rn(s) == fe;
        }
        function x3(s) {
          return Br(s) && Rn(s) == De;
        }
        function C3(s) {
          return Br(s) && Rn(s) == Ce;
        }
        function tc(s, u, m, w, I) {
          return s === u ? !0 : s == null || u == null || !Br(s) && !Br(u) ? s !== s && u !== u : S3(s, u, m, w, tc, I);
        }
        function S3(s, u, m, w, I, z) {
          var Q = It(s), ae = It(u), me = Q ? ie : Sn(s), Le = ae ? ie : Sn(u);
          me = me == fe ? K : me, Le = Le == fe ? K : Le;
          var Be = me == K, Ge = Le == K, it = me == Le;
          if (it && vi(s)) {
            if (!vi(u))
              return !1;
            Q = !0, Be = !1;
          }
          if (it && !Be)
            return z || (z = new Jo()), Q || Xs(s) ? j0(s, u, m, w, I, z) : Y3(s, u, me, m, w, I, z);
          if (!(m & C)) {
            var gt = Be && pr.call(s, "__wrapped__"), Et = Ge && pr.call(u, "__wrapped__");
            if (gt || Et) {
              var Lt = gt ? s.value() : s, Ot = Et ? u.value() : u;
              return z || (z = new Jo()), I(Lt, Ot, m, w, z);
            }
          }
          return it ? (z || (z = new Jo()), Z3(s, u, m, w, I, z)) : !1;
        }
        function w3(s) {
          return Br(s) && Sn(s) == le;
        }
        function cm(s, u, m, w) {
          var I = m.length, z = I, Q = !w;
          if (s == null)
            return !z;
          for (s = yr(s); I--; ) {
            var ae = m[I];
            if (Q && ae[2] ? ae[1] !== s[ae[0]] : !(ae[0] in s))
              return !1;
          }
          for (; ++I < z; ) {
            ae = m[I];
            var me = ae[0], Le = s[me], Be = ae[1];
            if (Q && ae[2]) {
              if (Le === r && !(me in s))
                return !1;
            } else {
              var Ge = new Jo();
              if (w)
                var it = w(Le, Be, me, s, u, Ge);
              if (!(it === r ? tc(Be, Le, C | b, w, Ge) : it))
                return !1;
            }
          }
          return !0;
        }
        function l0(s) {
          if (!_r(s) || a6(s))
            return !1;
          var u = Da(s) ? wR : ht;
          return u.test(Ki(s));
        }
        function T3(s) {
          return Br(s) && Rn(s) == we;
        }
        function E3(s) {
          return Br(s) && Sn(s) == se;
        }
        function O3(s) {
          return Br(s) && id(s.length) && !!kr[Rn(s)];
        }
        function c0(s) {
          return typeof s == "function" ? s : s == null ? Hn : typeof s == "object" ? It(s) ? p0(s[0], s[1]) : d0(s) : A1(s);
        }
        function um(s) {
          if (!oc(s))
            return PR(s);
          var u = [];
          for (var m in yr(s))
            pr.call(s, m) && m != "constructor" && u.push(m);
          return u;
        }
        function $3(s) {
          if (!_r(s))
            return c6(s);
          var u = oc(s), m = [];
          for (var w in s)
            w == "constructor" && (u || !pr.call(s, w)) || m.push(w);
          return m;
        }
        function dm(s, u) {
          return s < u;
        }
        function u0(s, u) {
          var m = -1, w = Wn(s) ? Ee(s.length) : [];
          return hi(s, function(I, z, Q) {
            w[++m] = u(I, z, Q);
          }), w;
        }
        function d0(s) {
          var u = Om(s);
          return u.length == 1 && u[0][2] ? H0(u[0][0], u[0][1]) : function(m) {
            return m === s || cm(m, s, u);
          };
        }
        function p0(s, u) {
          return Rm(s) && U0(u) ? H0(fa(s), u) : function(m) {
            var w = Bm(m, s);
            return w === r && w === u ? Dm(m, s) : tc(u, w, C | b);
          };
        }
        function Uu(s, u, m, w, I) {
          s !== u && am(u, function(z, Q) {
            if (I || (I = new Jo()), _r(z))
              R3(s, u, Q, m, Uu, w, I);
            else {
              var ae = w ? w(km(s, Q), z, Q + "", s, u, I) : r;
              ae === r && (ae = z), nm(s, Q, ae);
            }
          }, Un);
        }
        function R3(s, u, m, w, I, z, Q) {
          var ae = km(s, m), me = km(u, m), Le = Q.get(me);
          if (Le) {
            nm(s, m, Le);
            return;
          }
          var Be = z ? z(ae, me, m + "", s, u, Q) : r, Ge = Be === r;
          if (Ge) {
            var it = It(me), gt = !it && vi(me), Et = !it && !gt && Xs(me);
            Be = me, it || gt || Et ? It(ae) ? Be = ae : Ur(ae) ? Be = Vn(ae) : gt ? (Ge = !1, Be = T0(me, !0)) : Et ? (Ge = !1, Be = E0(me, !0)) : Be = [] : ic(me) || Yi(me) ? (Be = ae, Yi(ae) ? Be = C1(ae) : (!_r(ae) || Da(ae)) && (Be = W0(me))) : Ge = !1;
          }
          Ge && (Q.set(me, Be), I(Be, me, w, z, Q), Q.delete(me)), nm(s, m, Be);
        }
        function f0(s, u) {
          var m = s.length;
          if (m)
            return u += u < 0 ? m : 0, Ba(u, m) ? s[u] : r;
        }
        function m0(s, u, m) {
          u.length ? u = Nr(u, function(z) {
            return It(z) ? function(Q) {
              return Gi(Q, z.length === 1 ? z[0] : z);
            } : z;
          }) : u = [Hn];
          var w = -1;
          u = Nr(u, so(wt()));
          var I = u0(s, function(z, Q, ae) {
            var me = Nr(u, function(Le) {
              return Le(z);
            });
            return { criteria: me, index: ++w, value: z };
          });
          return tR(I, function(z, Q) {
            return z3(z, Q, m);
          });
        }
        function P3(s, u) {
          return h0(s, u, function(m, w) {
            return Dm(s, w);
          });
        }
        function h0(s, u, m) {
          for (var w = -1, I = u.length, z = {}; ++w < I; ) {
            var Q = u[w], ae = Gi(s, Q);
            m(ae, Q) && rc(z, bi(Q, s), ae);
          }
          return z;
        }
        function k3(s) {
          return function(u) {
            return Gi(u, s);
          };
        }
        function pm(s, u, m, w) {
          var I = w ? eR : js, z = -1, Q = u.length, ae = s;
          for (s === u && (u = Vn(u)), m && (ae = Nr(s, so(m))); ++z < Q; )
            for (var me = 0, Le = u[z], Be = m ? m(Le) : Le; (me = I(ae, Be, me, w)) > -1; )
              ae !== s && Mu.call(ae, me, 1), Mu.call(s, me, 1);
          return s;
        }
        function g0(s, u) {
          for (var m = s ? u.length : 0, w = m - 1; m--; ) {
            var I = u[m];
            if (m == w || I !== z) {
              var z = I;
              Ba(I) ? Mu.call(s, I, 1) : gm(s, I);
            }
          }
          return s;
        }
        function fm(s, u) {
          return s + Lu(Zv() * (u - s + 1));
        }
        function A3(s, u, m, w) {
          for (var I = -1, z = an(Fu((u - s) / (m || 1)), 0), Q = Ee(z); z--; )
            Q[w ? z : ++I] = s, s += m;
          return Q;
        }
        function mm(s, u) {
          var m = "";
          if (!s || u < 1 || u > U)
            return m;
          do
            u % 2 && (m += s), u = Lu(u / 2), u && (s += s);
          while (u);
          return m;
        }
        function zt(s, u) {
          return Am(G0(s, u, Hn), s + "");
        }
        function I3(s) {
          return Qv(Js(s));
        }
        function N3(s, u) {
          var m = Js(s);
          return ed(m, Hi(u, 0, m.length));
        }
        function rc(s, u, m, w) {
          if (!_r(s))
            return s;
          u = bi(u, s);
          for (var I = -1, z = u.length, Q = z - 1, ae = s; ae != null && ++I < z; ) {
            var me = fa(u[I]), Le = m;
            if (me === "__proto__" || me === "constructor" || me === "prototype")
              return s;
            if (I != Q) {
              var Be = ae[me];
              Le = w ? w(Be, me, ae) : r, Le === r && (Le = _r(Be) ? Be : Ba(u[I + 1]) ? [] : {});
            }
            Jl(ae, me, Le), ae = ae[me];
          }
          return s;
        }
        var b0 = Bu ? function(s, u) {
          return Bu.set(s, u), s;
        } : Hn, M3 = _u ? function(s, u) {
          return _u(s, "toString", {
            configurable: !0,
            enumerable: !1,
            value: zm(u),
            writable: !0
          });
        } : Hn;
        function _3(s) {
          return ed(Js(s));
        }
        function Lo(s, u, m) {
          var w = -1, I = s.length;
          u < 0 && (u = -u > I ? 0 : I + u), m = m > I ? I : m, m < 0 && (m += I), I = u > m ? 0 : m - u >>> 0, u >>>= 0;
          for (var z = Ee(I); ++w < I; )
            z[w] = s[w + u];
          return z;
        }
        function F3(s, u) {
          var m;
          return hi(s, function(w, I, z) {
            return m = u(w, I, z), !m;
          }), !!m;
        }
        function Hu(s, u, m) {
          var w = 0, I = s == null ? w : s.length;
          if (typeof u == "number" && u === u && I <= de) {
            for (; w < I; ) {
              var z = w + I >>> 1, Q = s[z];
              Q !== null && !co(Q) && (m ? Q <= u : Q < u) ? w = z + 1 : I = z;
            }
            return I;
          }
          return hm(s, u, Hn, m);
        }
        function hm(s, u, m, w) {
          var I = 0, z = s == null ? 0 : s.length;
          if (z === 0)
            return 0;
          u = m(u);
          for (var Q = u !== u, ae = u === null, me = co(u), Le = u === r; I < z; ) {
            var Be = Lu((I + z) / 2), Ge = m(s[Be]), it = Ge !== r, gt = Ge === null, Et = Ge === Ge, Lt = co(Ge);
            if (Q)
              var Ot = w || Et;
            else Le ? Ot = Et && (w || it) : ae ? Ot = Et && it && (w || !gt) : me ? Ot = Et && it && !gt && (w || !Lt) : gt || Lt ? Ot = !1 : Ot = w ? Ge <= u : Ge < u;
            Ot ? I = Be + 1 : z = Be;
          }
          return Cn(z, ye);
        }
        function y0(s, u) {
          for (var m = -1, w = s.length, I = 0, z = []; ++m < w; ) {
            var Q = s[m], ae = u ? u(Q) : Q;
            if (!m || !Qo(ae, me)) {
              var me = ae;
              z[I++] = Q === 0 ? 0 : Q;
            }
          }
          return z;
        }
        function v0(s) {
          return typeof s == "number" ? s : co(s) ? Z : +s;
        }
        function lo(s) {
          if (typeof s == "string")
            return s;
          if (It(s))
            return Nr(s, lo) + "";
          if (co(s))
            return Xv ? Xv.call(s) : "";
          var u = s + "";
          return u == "0" && 1 / s == -X ? "-0" : u;
        }
        function gi(s, u, m) {
          var w = -1, I = Tu, z = s.length, Q = !0, ae = [], me = ae;
          if (m)
            Q = !1, I = Uf;
          else if (z >= a) {
            var Le = u ? null : q3(s);
            if (Le)
              return Ou(Le);
            Q = !1, I = Gl, me = new Ui();
          } else
            me = u ? [] : ae;
          e:
            for (; ++w < z; ) {
              var Be = s[w], Ge = u ? u(Be) : Be;
              if (Be = m || Be !== 0 ? Be : 0, Q && Ge === Ge) {
                for (var it = me.length; it--; )
                  if (me[it] === Ge)
                    continue e;
                u && me.push(Ge), ae.push(Be);
              } else I(me, Ge, m) || (me !== ae && me.push(Ge), ae.push(Be));
            }
          return ae;
        }
        function gm(s, u) {
          return u = bi(u, s), s = q0(s, u), s == null || delete s[fa(Bo(u))];
        }
        function x0(s, u, m, w) {
          return rc(s, u, m(Gi(s, u)), w);
        }
        function Gu(s, u, m, w) {
          for (var I = s.length, z = w ? I : -1; (w ? z-- : ++z < I) && u(s[z], z, s); )
            ;
          return m ? Lo(s, w ? 0 : z, w ? z + 1 : I) : Lo(s, w ? z + 1 : 0, w ? I : z);
        }
        function C0(s, u) {
          var m = s;
          return m instanceof qt && (m = m.value()), Hf(u, function(w, I) {
            return I.func.apply(I.thisArg, pi([w], I.args));
          }, m);
        }
        function bm(s, u, m) {
          var w = s.length;
          if (w < 2)
            return w ? gi(s[0]) : [];
          for (var I = -1, z = Ee(w); ++I < w; )
            for (var Q = s[I], ae = -1; ++ae < w; )
              ae != I && (z[I] = Ql(z[I] || Q, s[ae], u, m));
          return gi(bn(z, 1), u, m);
        }
        function S0(s, u, m) {
          for (var w = -1, I = s.length, z = u.length, Q = {}; ++w < I; ) {
            var ae = w < z ? u[w] : r;
            m(Q, s[w], ae);
          }
          return Q;
        }
        function ym(s) {
          return Ur(s) ? s : [];
        }
        function vm(s) {
          return typeof s == "function" ? s : Hn;
        }
        function bi(s, u) {
          return It(s) ? s : Rm(s, u) ? [s] : X0(ar(s));
        }
        var L3 = zt;
        function yi(s, u, m) {
          var w = s.length;
          return m = m === r ? w : m, !u && m >= w ? s : Lo(s, u, m);
        }
        var w0 = TR || function(s) {
          return gn.clearTimeout(s);
        };
        function T0(s, u) {
          if (u)
            return s.slice();
          var m = s.length, w = Hv ? Hv(m) : new s.constructor(m);
          return s.copy(w), w;
        }
        function xm(s) {
          var u = new s.constructor(s.byteLength);
          return new Iu(u).set(new Iu(s)), u;
        }
        function B3(s, u) {
          var m = u ? xm(s.buffer) : s.buffer;
          return new s.constructor(m, s.byteOffset, s.byteLength);
        }
        function D3(s) {
          var u = new s.constructor(s.source, Te.exec(s));
          return u.lastIndex = s.lastIndex, u;
        }
        function j3(s) {
          return Xl ? yr(Xl.call(s)) : {};
        }
        function E0(s, u) {
          var m = u ? xm(s.buffer) : s.buffer;
          return new s.constructor(m, s.byteOffset, s.length);
        }
        function O0(s, u) {
          if (s !== u) {
            var m = s !== r, w = s === null, I = s === s, z = co(s), Q = u !== r, ae = u === null, me = u === u, Le = co(u);
            if (!ae && !Le && !z && s > u || z && Q && me && !ae && !Le || w && Q && me || !m && me || !I)
              return 1;
            if (!w && !z && !Le && s < u || Le && m && I && !w && !z || ae && m && I || !Q && I || !me)
              return -1;
          }
          return 0;
        }
        function z3(s, u, m) {
          for (var w = -1, I = s.criteria, z = u.criteria, Q = I.length, ae = m.length; ++w < Q; ) {
            var me = O0(I[w], z[w]);
            if (me) {
              if (w >= ae)
                return me;
              var Le = m[w];
              return me * (Le == "desc" ? -1 : 1);
            }
          }
          return s.index - u.index;
        }
        function $0(s, u, m, w) {
          for (var I = -1, z = s.length, Q = m.length, ae = -1, me = u.length, Le = an(z - Q, 0), Be = Ee(me + Le), Ge = !w; ++ae < me; )
            Be[ae] = u[ae];
          for (; ++I < Q; )
            (Ge || I < z) && (Be[m[I]] = s[I]);
          for (; Le--; )
            Be[ae++] = s[I++];
          return Be;
        }
        function R0(s, u, m, w) {
          for (var I = -1, z = s.length, Q = -1, ae = m.length, me = -1, Le = u.length, Be = an(z - ae, 0), Ge = Ee(Be + Le), it = !w; ++I < Be; )
            Ge[I] = s[I];
          for (var gt = I; ++me < Le; )
            Ge[gt + me] = u[me];
          for (; ++Q < ae; )
            (it || I < z) && (Ge[gt + m[Q]] = s[I++]);
          return Ge;
        }
        function Vn(s, u) {
          var m = -1, w = s.length;
          for (u || (u = Ee(w)); ++m < w; )
            u[m] = s[m];
          return u;
        }
        function pa(s, u, m, w) {
          var I = !m;
          m || (m = {});
          for (var z = -1, Q = u.length; ++z < Q; ) {
            var ae = u[z], me = w ? w(m[ae], s[ae], ae, m, s) : r;
            me === r && (me = s[ae]), I ? _a(m, ae, me) : Jl(m, ae, me);
          }
          return m;
        }
        function V3(s, u) {
          return pa(s, $m(s), u);
        }
        function W3(s, u) {
          return pa(s, z0(s), u);
        }
        function qu(s, u) {
          return function(m, w) {
            var I = It(m) ? K$ : d3, z = u ? u() : {};
            return I(m, s, wt(w, 2), z);
          };
        }
        function Ks(s) {
          return zt(function(u, m) {
            var w = -1, I = m.length, z = I > 1 ? m[I - 1] : r, Q = I > 2 ? m[2] : r;
            for (z = s.length > 3 && typeof z == "function" ? (I--, z) : r, Q && Pn(m[0], m[1], Q) && (z = I < 3 ? r : z, I = 1), u = yr(u); ++w < I; ) {
              var ae = m[w];
              ae && s(u, ae, w, z);
            }
            return u;
          });
        }
        function P0(s, u) {
          return function(m, w) {
            if (m == null)
              return m;
            if (!Wn(m))
              return s(m, w);
            for (var I = m.length, z = u ? I : -1, Q = yr(m); (u ? z-- : ++z < I) && w(Q[z], z, Q) !== !1; )
              ;
            return m;
          };
        }
        function k0(s) {
          return function(u, m, w) {
            for (var I = -1, z = yr(u), Q = w(u), ae = Q.length; ae--; ) {
              var me = Q[s ? ae : ++I];
              if (m(z[me], me, z) === !1)
                break;
            }
            return u;
          };
        }
        function U3(s, u, m) {
          var w = u & v, I = nc(s);
          function z() {
            var Q = this && this !== gn && this instanceof z ? I : s;
            return Q.apply(w ? m : this, arguments);
          }
          return z;
        }
        function A0(s) {
          return function(u) {
            u = ar(u);
            var m = zs(u) ? Xo(u) : r, w = m ? m[0] : u.charAt(0), I = m ? yi(m, 1).join("") : u.slice(1);
            return w[s]() + I;
          };
        }
        function Ys(s) {
          return function(u) {
            return Hf(P1(R1(u).replace(M$, "")), s, "");
          };
        }
        function nc(s) {
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return new s();
              case 1:
                return new s(u[0]);
              case 2:
                return new s(u[0], u[1]);
              case 3:
                return new s(u[0], u[1], u[2]);
              case 4:
                return new s(u[0], u[1], u[2], u[3]);
              case 5:
                return new s(u[0], u[1], u[2], u[3], u[4]);
              case 6:
                return new s(u[0], u[1], u[2], u[3], u[4], u[5]);
              case 7:
                return new s(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
            }
            var m = qs(s.prototype), w = s.apply(m, u);
            return _r(w) ? w : m;
          };
        }
        function H3(s, u, m) {
          var w = nc(s);
          function I() {
            for (var z = arguments.length, Q = Ee(z), ae = z, me = Zs(I); ae--; )
              Q[ae] = arguments[ae];
            var Le = z < 3 && Q[0] !== me && Q[z - 1] !== me ? [] : fi(Q, me);
            if (z -= Le.length, z < m)
              return F0(
                s,
                u,
                Ku,
                I.placeholder,
                r,
                Q,
                Le,
                r,
                r,
                m - z
              );
            var Be = this && this !== gn && this instanceof I ? w : s;
            return io(Be, this, Q);
          }
          return I;
        }
        function I0(s) {
          return function(u, m, w) {
            var I = yr(u);
            if (!Wn(u)) {
              var z = wt(m, 3);
              u = cn(u), m = function(ae) {
                return z(I[ae], ae, I);
              };
            }
            var Q = s(u, m, w);
            return Q > -1 ? I[z ? u[Q] : Q] : r;
          };
        }
        function N0(s) {
          return La(function(u) {
            var m = u.length, w = m, I = _o.prototype.thru;
            for (s && u.reverse(); w--; ) {
              var z = u[w];
              if (typeof z != "function")
                throw new Mo(l);
              if (I && !Q && Ju(z) == "wrapper")
                var Q = new _o([], !0);
            }
            for (w = Q ? w : m; ++w < m; ) {
              z = u[w];
              var ae = Ju(z), me = ae == "wrapper" ? Em(z) : r;
              me && Pm(me[0]) && me[1] == (A | $ | S | _) && !me[4].length && me[9] == 1 ? Q = Q[Ju(me[0])].apply(Q, me[3]) : Q = z.length == 1 && Pm(z) ? Q[ae]() : Q.thru(z);
            }
            return function() {
              var Le = arguments, Be = Le[0];
              if (Q && Le.length == 1 && It(Be))
                return Q.plant(Be).value();
              for (var Ge = 0, it = m ? u[Ge].apply(this, Le) : Be; ++Ge < m; )
                it = u[Ge].call(this, it);
              return it;
            };
          });
        }
        function Ku(s, u, m, w, I, z, Q, ae, me, Le) {
          var Be = u & A, Ge = u & v, it = u & T, gt = u & ($ | E), Et = u & L, Lt = it ? r : nc(s);
          function Ot() {
            for (var Gt = arguments.length, Yt = Ee(Gt), uo = Gt; uo--; )
              Yt[uo] = arguments[uo];
            if (gt)
              var kn = Zs(Ot), po = nR(Yt, kn);
            if (w && (Yt = $0(Yt, w, I, gt)), z && (Yt = R0(Yt, z, Q, gt)), Gt -= po, gt && Gt < Le) {
              var Hr = fi(Yt, kn);
              return F0(
                s,
                u,
                Ku,
                Ot.placeholder,
                m,
                Yt,
                Hr,
                ae,
                me,
                Le - Gt
              );
            }
            var ea = Ge ? m : this, za = it ? ea[s] : s;
            return Gt = Yt.length, ae ? Yt = d6(Yt, ae) : Et && Gt > 1 && Yt.reverse(), Be && me < Gt && (Yt.length = me), this && this !== gn && this instanceof Ot && (za = Lt || nc(za)), za.apply(ea, Yt);
          }
          return Ot;
        }
        function M0(s, u) {
          return function(m, w) {
            return v3(m, s, u(w), {});
          };
        }
        function Yu(s, u) {
          return function(m, w) {
            var I;
            if (m === r && w === r)
              return u;
            if (m !== r && (I = m), w !== r) {
              if (I === r)
                return w;
              typeof m == "string" || typeof w == "string" ? (m = lo(m), w = lo(w)) : (m = v0(m), w = v0(w)), I = s(m, w);
            }
            return I;
          };
        }
        function Cm(s) {
          return La(function(u) {
            return u = Nr(u, so(wt())), zt(function(m) {
              var w = this;
              return s(u, function(I) {
                return io(I, w, m);
              });
            });
          });
        }
        function Zu(s, u) {
          u = u === r ? " " : lo(u);
          var m = u.length;
          if (m < 2)
            return m ? mm(u, s) : u;
          var w = mm(u, Fu(s / Vs(u)));
          return zs(u) ? yi(Xo(w), 0, s).join("") : w.slice(0, s);
        }
        function G3(s, u, m, w) {
          var I = u & v, z = nc(s);
          function Q() {
            for (var ae = -1, me = arguments.length, Le = -1, Be = w.length, Ge = Ee(Be + me), it = this && this !== gn && this instanceof Q ? z : s; ++Le < Be; )
              Ge[Le] = w[Le];
            for (; me--; )
              Ge[Le++] = arguments[++ae];
            return io(it, I ? m : this, Ge);
          }
          return Q;
        }
        function _0(s) {
          return function(u, m, w) {
            return w && typeof w != "number" && Pn(u, m, w) && (m = w = r), u = ja(u), m === r ? (m = u, u = 0) : m = ja(m), w = w === r ? u < m ? 1 : -1 : ja(w), A3(u, m, w, s);
          };
        }
        function Xu(s) {
          return function(u, m) {
            return typeof u == "string" && typeof m == "string" || (u = Do(u), m = Do(m)), s(u, m);
          };
        }
        function F0(s, u, m, w, I, z, Q, ae, me, Le) {
          var Be = u & $, Ge = Be ? Q : r, it = Be ? r : Q, gt = Be ? z : r, Et = Be ? r : z;
          u |= Be ? S : k, u &= ~(Be ? k : S), u & R || (u &= -4);
          var Lt = [
            s,
            u,
            I,
            gt,
            Ge,
            Et,
            it,
            ae,
            me,
            Le
          ], Ot = m.apply(r, Lt);
          return Pm(s) && K0(Ot, Lt), Ot.placeholder = w, Y0(Ot, s, u);
        }
        function Sm(s) {
          var u = on[s];
          return function(m, w) {
            if (m = Do(m), w = w == null ? 0 : Cn(_t(w), 292), w && Yv(m)) {
              var I = (ar(m) + "e").split("e"), z = u(I[0] + "e" + (+I[1] + w));
              return I = (ar(z) + "e").split("e"), +(I[0] + "e" + (+I[1] - w));
            }
            return u(m);
          };
        }
        var q3 = Hs && 1 / Ou(new Hs([, -0]))[1] == X ? function(s) {
          return new Hs(s);
        } : Um;
        function L0(s) {
          return function(u) {
            var m = Sn(u);
            return m == le ? Jf(u) : m == se ? uR(u) : rR(u, s(u));
          };
        }
        function Fa(s, u, m, w, I, z, Q, ae) {
          var me = u & T;
          if (!me && typeof s != "function")
            throw new Mo(l);
          var Le = w ? w.length : 0;
          if (Le || (u &= -97, w = I = r), Q = Q === r ? Q : an(_t(Q), 0), ae = ae === r ? ae : _t(ae), Le -= I ? I.length : 0, u & k) {
            var Be = w, Ge = I;
            w = I = r;
          }
          var it = me ? r : Em(s), gt = [
            s,
            u,
            m,
            w,
            I,
            Be,
            Ge,
            z,
            Q,
            ae
          ];
          if (it && l6(gt, it), s = gt[0], u = gt[1], m = gt[2], w = gt[3], I = gt[4], ae = gt[9] = gt[9] === r ? me ? 0 : s.length : an(gt[9] - Le, 0), !ae && u & ($ | E) && (u &= -25), !u || u == v)
            var Et = U3(s, u, m);
          else u == $ || u == E ? Et = H3(s, u, ae) : (u == S || u == (v | S)) && !I.length ? Et = G3(s, u, m, w) : Et = Ku.apply(r, gt);
          var Lt = it ? b0 : K0;
          return Y0(Lt(Et, gt), s, u);
        }
        function B0(s, u, m, w) {
          return s === r || Qo(s, Us[m]) && !pr.call(w, m) ? u : s;
        }
        function D0(s, u, m, w, I, z) {
          return _r(s) && _r(u) && (z.set(u, s), Uu(s, u, r, D0, z), z.delete(u)), s;
        }
        function K3(s) {
          return ic(s) ? r : s;
        }
        function j0(s, u, m, w, I, z) {
          var Q = m & C, ae = s.length, me = u.length;
          if (ae != me && !(Q && me > ae))
            return !1;
          var Le = z.get(s), Be = z.get(u);
          if (Le && Be)
            return Le == u && Be == s;
          var Ge = -1, it = !0, gt = m & b ? new Ui() : r;
          for (z.set(s, u), z.set(u, s); ++Ge < ae; ) {
            var Et = s[Ge], Lt = u[Ge];
            if (w)
              var Ot = Q ? w(Lt, Et, Ge, u, s, z) : w(Et, Lt, Ge, s, u, z);
            if (Ot !== r) {
              if (Ot)
                continue;
              it = !1;
              break;
            }
            if (gt) {
              if (!Gf(u, function(Gt, Yt) {
                if (!Gl(gt, Yt) && (Et === Gt || I(Et, Gt, m, w, z)))
                  return gt.push(Yt);
              })) {
                it = !1;
                break;
              }
            } else if (!(Et === Lt || I(Et, Lt, m, w, z))) {
              it = !1;
              break;
            }
          }
          return z.delete(s), z.delete(u), it;
        }
        function Y3(s, u, m, w, I, z, Q) {
          switch (m) {
            case Ye:
              if (s.byteLength != u.byteLength || s.byteOffset != u.byteOffset)
                return !1;
              s = s.buffer, u = u.buffer;
            case De:
              return !(s.byteLength != u.byteLength || !z(new Iu(s), new Iu(u)));
            case ce:
            case Ce:
            case qe:
              return Qo(+s, +u);
            case Re:
              return s.name == u.name && s.message == u.message;
            case we:
            case ue:
              return s == u + "";
            case le:
              var ae = Jf;
            case se:
              var me = w & C;
              if (ae || (ae = Ou), s.size != u.size && !me)
                return !1;
              var Le = Q.get(s);
              if (Le)
                return Le == u;
              w |= b, Q.set(s, u);
              var Be = j0(ae(s), ae(u), w, I, z, Q);
              return Q.delete(s), Be;
            case Qe:
              if (Xl)
                return Xl.call(s) == Xl.call(u);
          }
          return !1;
        }
        function Z3(s, u, m, w, I, z) {
          var Q = m & C, ae = wm(s), me = ae.length, Le = wm(u), Be = Le.length;
          if (me != Be && !Q)
            return !1;
          for (var Ge = me; Ge--; ) {
            var it = ae[Ge];
            if (!(Q ? it in u : pr.call(u, it)))
              return !1;
          }
          var gt = z.get(s), Et = z.get(u);
          if (gt && Et)
            return gt == u && Et == s;
          var Lt = !0;
          z.set(s, u), z.set(u, s);
          for (var Ot = Q; ++Ge < me; ) {
            it = ae[Ge];
            var Gt = s[it], Yt = u[it];
            if (w)
              var uo = Q ? w(Yt, Gt, it, u, s, z) : w(Gt, Yt, it, s, u, z);
            if (!(uo === r ? Gt === Yt || I(Gt, Yt, m, w, z) : uo)) {
              Lt = !1;
              break;
            }
            Ot || (Ot = it == "constructor");
          }
          if (Lt && !Ot) {
            var kn = s.constructor, po = u.constructor;
            kn != po && "constructor" in s && "constructor" in u && !(typeof kn == "function" && kn instanceof kn && typeof po == "function" && po instanceof po) && (Lt = !1);
          }
          return z.delete(s), z.delete(u), Lt;
        }
        function La(s) {
          return Am(G0(s, r, t1), s + "");
        }
        function wm(s) {
          return i0(s, cn, $m);
        }
        function Tm(s) {
          return i0(s, Un, z0);
        }
        var Em = Bu ? function(s) {
          return Bu.get(s);
        } : Um;
        function Ju(s) {
          for (var u = s.name + "", m = Gs[u], w = pr.call(Gs, u) ? m.length : 0; w--; ) {
            var I = m[w], z = I.func;
            if (z == null || z == s)
              return I.name;
          }
          return u;
        }
        function Zs(s) {
          var u = pr.call(D, "placeholder") ? D : s;
          return u.placeholder;
        }
        function wt() {
          var s = D.iteratee || Vm;
          return s = s === Vm ? c0 : s, arguments.length ? s(arguments[0], arguments[1]) : s;
        }
        function Qu(s, u) {
          var m = s.__data__;
          return o6(u) ? m[typeof u == "string" ? "string" : "hash"] : m.map;
        }
        function Om(s) {
          for (var u = cn(s), m = u.length; m--; ) {
            var w = u[m], I = s[w];
            u[m] = [w, I, U0(I)];
          }
          return u;
        }
        function qi(s, u) {
          var m = sR(s, u);
          return l0(m) ? m : r;
        }
        function X3(s) {
          var u = pr.call(s, Vi), m = s[Vi];
          try {
            s[Vi] = r;
            var w = !0;
          } catch {
          }
          var I = ku.call(s);
          return w && (u ? s[Vi] = m : delete s[Vi]), I;
        }
        var $m = em ? function(s) {
          return s == null ? [] : (s = yr(s), di(em(s), function(u) {
            return qv.call(s, u);
          }));
        } : Hm, z0 = em ? function(s) {
          for (var u = []; s; )
            pi(u, $m(s)), s = Nu(s);
          return u;
        } : Hm, Sn = Rn;
        (tm && Sn(new tm(new ArrayBuffer(1))) != Ye || Kl && Sn(new Kl()) != le || rm && Sn(rm.resolve()) != ee || Hs && Sn(new Hs()) != se || Yl && Sn(new Yl()) != be) && (Sn = function(s) {
          var u = Rn(s), m = u == K ? s.constructor : r, w = m ? Ki(m) : "";
          if (w)
            switch (w) {
              case NR:
                return Ye;
              case MR:
                return le;
              case _R:
                return ee;
              case FR:
                return se;
              case LR:
                return be;
            }
          return u;
        });
        function J3(s, u, m) {
          for (var w = -1, I = m.length; ++w < I; ) {
            var z = m[w], Q = z.size;
            switch (z.type) {
              case "drop":
                s += Q;
                break;
              case "dropRight":
                u -= Q;
                break;
              case "take":
                u = Cn(u, s + Q);
                break;
              case "takeRight":
                s = an(s, u - Q);
                break;
            }
          }
          return { start: s, end: u };
        }
        function Q3(s) {
          var u = s.match(oo);
          return u ? u[1].split(te) : [];
        }
        function V0(s, u, m) {
          u = bi(u, s);
          for (var w = -1, I = u.length, z = !1; ++w < I; ) {
            var Q = fa(u[w]);
            if (!(z = s != null && m(s, Q)))
              break;
            s = s[Q];
          }
          return z || ++w != I ? z : (I = s == null ? 0 : s.length, !!I && id(I) && Ba(Q, I) && (It(s) || Yi(s)));
        }
        function e6(s) {
          var u = s.length, m = new s.constructor(u);
          return u && typeof s[0] == "string" && pr.call(s, "index") && (m.index = s.index, m.input = s.input), m;
        }
        function W0(s) {
          return typeof s.constructor == "function" && !oc(s) ? qs(Nu(s)) : {};
        }
        function t6(s, u, m) {
          var w = s.constructor;
          switch (u) {
            case De:
              return xm(s);
            case ce:
            case Ce:
              return new w(+s);
            case Ye:
              return B3(s, m);
            case et:
            case Je:
            case tt:
            case Rt:
            case xt:
            case rt:
            case He:
            case Oe:
            case Ze:
              return E0(s, m);
            case le:
              return new w();
            case qe:
            case ue:
              return new w(s);
            case we:
              return D3(s);
            case se:
              return new w();
            case Qe:
              return j3(s);
          }
        }
        function r6(s, u) {
          var m = u.length;
          if (!m)
            return s;
          var w = m - 1;
          return u[w] = (m > 1 ? "& " : "") + u[w], u = u.join(m > 2 ? ", " : " "), s.replace(hn, `{
/* [wrapped with ` + u + `] */
`);
        }
        function n6(s) {
          return It(s) || Yi(s) || !!(Kv && s && s[Kv]);
        }
        function Ba(s, u) {
          var m = typeof s;
          return u = u ?? U, !!u && (m == "number" || m != "symbol" && vt.test(s)) && s > -1 && s % 1 == 0 && s < u;
        }
        function Pn(s, u, m) {
          if (!_r(m))
            return !1;
          var w = typeof u;
          return (w == "number" ? Wn(m) && Ba(u, m.length) : w == "string" && u in m) ? Qo(m[u], s) : !1;
        }
        function Rm(s, u) {
          if (It(s))
            return !1;
          var m = typeof s;
          return m == "number" || m == "symbol" || m == "boolean" || s == null || co(s) ? !0 : at.test(s) || !fr.test(s) || u != null && s in yr(u);
        }
        function o6(s) {
          var u = typeof s;
          return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? s !== "__proto__" : s === null;
        }
        function Pm(s) {
          var u = Ju(s), m = D[u];
          if (typeof m != "function" || !(u in qt.prototype))
            return !1;
          if (s === m)
            return !0;
          var w = Em(m);
          return !!w && s === w[0];
        }
        function a6(s) {
          return !!Uv && Uv in s;
        }
        var i6 = Ru ? Da : Gm;
        function oc(s) {
          var u = s && s.constructor, m = typeof u == "function" && u.prototype || Us;
          return s === m;
        }
        function U0(s) {
          return s === s && !_r(s);
        }
        function H0(s, u) {
          return function(m) {
            return m == null ? !1 : m[s] === u && (u !== r || s in yr(m));
          };
        }
        function s6(s) {
          var u = od(s, function(w) {
            return m.size === p && m.clear(), w;
          }), m = u.cache;
          return u;
        }
        function l6(s, u) {
          var m = s[1], w = u[1], I = m | w, z = I < (v | T | A), Q = w == A && m == $ || w == A && m == _ && s[7].length <= u[8] || w == (A | _) && u[7].length <= u[8] && m == $;
          if (!(z || Q))
            return s;
          w & v && (s[2] = u[2], I |= m & v ? 0 : R);
          var ae = u[3];
          if (ae) {
            var me = s[3];
            s[3] = me ? $0(me, ae, u[4]) : ae, s[4] = me ? fi(s[3], f) : u[4];
          }
          return ae = u[5], ae && (me = s[5], s[5] = me ? R0(me, ae, u[6]) : ae, s[6] = me ? fi(s[5], f) : u[6]), ae = u[7], ae && (s[7] = ae), w & A && (s[8] = s[8] == null ? u[8] : Cn(s[8], u[8])), s[9] == null && (s[9] = u[9]), s[0] = u[0], s[1] = I, s;
        }
        function c6(s) {
          var u = [];
          if (s != null)
            for (var m in yr(s))
              u.push(m);
          return u;
        }
        function u6(s) {
          return ku.call(s);
        }
        function G0(s, u, m) {
          return u = an(u === r ? s.length - 1 : u, 0), function() {
            for (var w = arguments, I = -1, z = an(w.length - u, 0), Q = Ee(z); ++I < z; )
              Q[I] = w[u + I];
            I = -1;
            for (var ae = Ee(u + 1); ++I < u; )
              ae[I] = w[I];
            return ae[u] = m(Q), io(s, this, ae);
          };
        }
        function q0(s, u) {
          return u.length < 2 ? s : Gi(s, Lo(u, 0, -1));
        }
        function d6(s, u) {
          for (var m = s.length, w = Cn(u.length, m), I = Vn(s); w--; ) {
            var z = u[w];
            s[w] = Ba(z, m) ? I[z] : r;
          }
          return s;
        }
        function km(s, u) {
          if (!(u === "constructor" && typeof s[u] == "function") && u != "__proto__")
            return s[u];
        }
        var K0 = Z0(b0), ac = OR || function(s, u) {
          return gn.setTimeout(s, u);
        }, Am = Z0(M3);
        function Y0(s, u, m) {
          var w = u + "";
          return Am(s, r6(w, p6(Q3(w), m)));
        }
        function Z0(s) {
          var u = 0, m = 0;
          return function() {
            var w = kR(), I = M - (w - m);
            if (m = w, I > 0) {
              if (++u >= B)
                return arguments[0];
            } else
              u = 0;
            return s.apply(r, arguments);
          };
        }
        function ed(s, u) {
          var m = -1, w = s.length, I = w - 1;
          for (u = u === r ? w : u; ++m < u; ) {
            var z = fm(m, I), Q = s[z];
            s[z] = s[m], s[m] = Q;
          }
          return s.length = u, s;
        }
        var X0 = s6(function(s) {
          var u = [];
          return s.charCodeAt(0) === 46 && u.push(""), s.replace(lt, function(m, w, I, z) {
            u.push(I ? z.replace(yt, "$1") : w || m);
          }), u;
        });
        function fa(s) {
          if (typeof s == "string" || co(s))
            return s;
          var u = s + "";
          return u == "0" && 1 / s == -X ? "-0" : u;
        }
        function Ki(s) {
          if (s != null) {
            try {
              return Pu.call(s);
            } catch {
            }
            try {
              return s + "";
            } catch {
            }
          }
          return "";
        }
        function p6(s, u) {
          return No(ne, function(m) {
            var w = "_." + m[0];
            u & m[1] && !Tu(s, w) && s.push(w);
          }), s.sort();
        }
        function J0(s) {
          if (s instanceof qt)
            return s.clone();
          var u = new _o(s.__wrapped__, s.__chain__);
          return u.__actions__ = Vn(s.__actions__), u.__index__ = s.__index__, u.__values__ = s.__values__, u;
        }
        function f6(s, u, m) {
          (m ? Pn(s, u, m) : u === r) ? u = 1 : u = an(_t(u), 0);
          var w = s == null ? 0 : s.length;
          if (!w || u < 1)
            return [];
          for (var I = 0, z = 0, Q = Ee(Fu(w / u)); I < w; )
            Q[z++] = Lo(s, I, I += u);
          return Q;
        }
        function m6(s) {
          for (var u = -1, m = s == null ? 0 : s.length, w = 0, I = []; ++u < m; ) {
            var z = s[u];
            z && (I[w++] = z);
          }
          return I;
        }
        function h6() {
          var s = arguments.length;
          if (!s)
            return [];
          for (var u = Ee(s - 1), m = arguments[0], w = s; w--; )
            u[w - 1] = arguments[w];
          return pi(It(m) ? Vn(m) : [m], bn(u, 1));
        }
        var g6 = zt(function(s, u) {
          return Ur(s) ? Ql(s, bn(u, 1, Ur, !0)) : [];
        }), b6 = zt(function(s, u) {
          var m = Bo(u);
          return Ur(m) && (m = r), Ur(s) ? Ql(s, bn(u, 1, Ur, !0), wt(m, 2)) : [];
        }), y6 = zt(function(s, u) {
          var m = Bo(u);
          return Ur(m) && (m = r), Ur(s) ? Ql(s, bn(u, 1, Ur, !0), r, m) : [];
        });
        function v6(s, u, m) {
          var w = s == null ? 0 : s.length;
          return w ? (u = m || u === r ? 1 : _t(u), Lo(s, u < 0 ? 0 : u, w)) : [];
        }
        function x6(s, u, m) {
          var w = s == null ? 0 : s.length;
          return w ? (u = m || u === r ? 1 : _t(u), u = w - u, Lo(s, 0, u < 0 ? 0 : u)) : [];
        }
        function C6(s, u) {
          return s && s.length ? Gu(s, wt(u, 3), !0, !0) : [];
        }
        function S6(s, u) {
          return s && s.length ? Gu(s, wt(u, 3), !0) : [];
        }
        function w6(s, u, m, w) {
          var I = s == null ? 0 : s.length;
          return I ? (m && typeof m != "number" && Pn(s, u, m) && (m = 0, w = I), h3(s, u, m, w)) : [];
        }
        function Q0(s, u, m) {
          var w = s == null ? 0 : s.length;
          if (!w)
            return -1;
          var I = m == null ? 0 : _t(m);
          return I < 0 && (I = an(w + I, 0)), Eu(s, wt(u, 3), I);
        }
        function e1(s, u, m) {
          var w = s == null ? 0 : s.length;
          if (!w)
            return -1;
          var I = w - 1;
          return m !== r && (I = _t(m), I = m < 0 ? an(w + I, 0) : Cn(I, w - 1)), Eu(s, wt(u, 3), I, !0);
        }
        function t1(s) {
          var u = s == null ? 0 : s.length;
          return u ? bn(s, 1) : [];
        }
        function T6(s) {
          var u = s == null ? 0 : s.length;
          return u ? bn(s, X) : [];
        }
        function E6(s, u) {
          var m = s == null ? 0 : s.length;
          return m ? (u = u === r ? 1 : _t(u), bn(s, u)) : [];
        }
        function O6(s) {
          for (var u = -1, m = s == null ? 0 : s.length, w = {}; ++u < m; ) {
            var I = s[u];
            w[I[0]] = I[1];
          }
          return w;
        }
        function r1(s) {
          return s && s.length ? s[0] : r;
        }
        function $6(s, u, m) {
          var w = s == null ? 0 : s.length;
          if (!w)
            return -1;
          var I = m == null ? 0 : _t(m);
          return I < 0 && (I = an(w + I, 0)), js(s, u, I);
        }
        function R6(s) {
          var u = s == null ? 0 : s.length;
          return u ? Lo(s, 0, -1) : [];
        }
        var P6 = zt(function(s) {
          var u = Nr(s, ym);
          return u.length && u[0] === s[0] ? lm(u) : [];
        }), k6 = zt(function(s) {
          var u = Bo(s), m = Nr(s, ym);
          return u === Bo(m) ? u = r : m.pop(), m.length && m[0] === s[0] ? lm(m, wt(u, 2)) : [];
        }), A6 = zt(function(s) {
          var u = Bo(s), m = Nr(s, ym);
          return u = typeof u == "function" ? u : r, u && m.pop(), m.length && m[0] === s[0] ? lm(m, r, u) : [];
        });
        function I6(s, u) {
          return s == null ? "" : RR.call(s, u);
        }
        function Bo(s) {
          var u = s == null ? 0 : s.length;
          return u ? s[u - 1] : r;
        }
        function N6(s, u, m) {
          var w = s == null ? 0 : s.length;
          if (!w)
            return -1;
          var I = w;
          return m !== r && (I = _t(m), I = I < 0 ? an(w + I, 0) : Cn(I, w - 1)), u === u ? pR(s, u, I) : Eu(s, Fv, I, !0);
        }
        function M6(s, u) {
          return s && s.length ? f0(s, _t(u)) : r;
        }
        var _6 = zt(n1);
        function n1(s, u) {
          return s && s.length && u && u.length ? pm(s, u) : s;
        }
        function F6(s, u, m) {
          return s && s.length && u && u.length ? pm(s, u, wt(m, 2)) : s;
        }
        function L6(s, u, m) {
          return s && s.length && u && u.length ? pm(s, u, r, m) : s;
        }
        var B6 = La(function(s, u) {
          var m = s == null ? 0 : s.length, w = om(s, u);
          return g0(s, Nr(u, function(I) {
            return Ba(I, m) ? +I : I;
          }).sort(O0)), w;
        });
        function D6(s, u) {
          var m = [];
          if (!(s && s.length))
            return m;
          var w = -1, I = [], z = s.length;
          for (u = wt(u, 3); ++w < z; ) {
            var Q = s[w];
            u(Q, w, s) && (m.push(Q), I.push(w));
          }
          return g0(s, I), m;
        }
        function Im(s) {
          return s == null ? s : IR.call(s);
        }
        function j6(s, u, m) {
          var w = s == null ? 0 : s.length;
          return w ? (m && typeof m != "number" && Pn(s, u, m) ? (u = 0, m = w) : (u = u == null ? 0 : _t(u), m = m === r ? w : _t(m)), Lo(s, u, m)) : [];
        }
        function z6(s, u) {
          return Hu(s, u);
        }
        function V6(s, u, m) {
          return hm(s, u, wt(m, 2));
        }
        function W6(s, u) {
          var m = s == null ? 0 : s.length;
          if (m) {
            var w = Hu(s, u);
            if (w < m && Qo(s[w], u))
              return w;
          }
          return -1;
        }
        function U6(s, u) {
          return Hu(s, u, !0);
        }
        function H6(s, u, m) {
          return hm(s, u, wt(m, 2), !0);
        }
        function G6(s, u) {
          var m = s == null ? 0 : s.length;
          if (m) {
            var w = Hu(s, u, !0) - 1;
            if (Qo(s[w], u))
              return w;
          }
          return -1;
        }
        function q6(s) {
          return s && s.length ? y0(s) : [];
        }
        function K6(s, u) {
          return s && s.length ? y0(s, wt(u, 2)) : [];
        }
        function Y6(s) {
          var u = s == null ? 0 : s.length;
          return u ? Lo(s, 1, u) : [];
        }
        function Z6(s, u, m) {
          return s && s.length ? (u = m || u === r ? 1 : _t(u), Lo(s, 0, u < 0 ? 0 : u)) : [];
        }
        function X6(s, u, m) {
          var w = s == null ? 0 : s.length;
          return w ? (u = m || u === r ? 1 : _t(u), u = w - u, Lo(s, u < 0 ? 0 : u, w)) : [];
        }
        function J6(s, u) {
          return s && s.length ? Gu(s, wt(u, 3), !1, !0) : [];
        }
        function Q6(s, u) {
          return s && s.length ? Gu(s, wt(u, 3)) : [];
        }
        var eP = zt(function(s) {
          return gi(bn(s, 1, Ur, !0));
        }), tP = zt(function(s) {
          var u = Bo(s);
          return Ur(u) && (u = r), gi(bn(s, 1, Ur, !0), wt(u, 2));
        }), rP = zt(function(s) {
          var u = Bo(s);
          return u = typeof u == "function" ? u : r, gi(bn(s, 1, Ur, !0), r, u);
        });
        function nP(s) {
          return s && s.length ? gi(s) : [];
        }
        function oP(s, u) {
          return s && s.length ? gi(s, wt(u, 2)) : [];
        }
        function aP(s, u) {
          return u = typeof u == "function" ? u : r, s && s.length ? gi(s, r, u) : [];
        }
        function Nm(s) {
          if (!(s && s.length))
            return [];
          var u = 0;
          return s = di(s, function(m) {
            if (Ur(m))
              return u = an(m.length, u), !0;
          }), Zf(u, function(m) {
            return Nr(s, qf(m));
          });
        }
        function o1(s, u) {
          if (!(s && s.length))
            return [];
          var m = Nm(s);
          return u == null ? m : Nr(m, function(w) {
            return io(u, r, w);
          });
        }
        var iP = zt(function(s, u) {
          return Ur(s) ? Ql(s, u) : [];
        }), sP = zt(function(s) {
          return bm(di(s, Ur));
        }), lP = zt(function(s) {
          var u = Bo(s);
          return Ur(u) && (u = r), bm(di(s, Ur), wt(u, 2));
        }), cP = zt(function(s) {
          var u = Bo(s);
          return u = typeof u == "function" ? u : r, bm(di(s, Ur), r, u);
        }), uP = zt(Nm);
        function dP(s, u) {
          return S0(s || [], u || [], Jl);
        }
        function pP(s, u) {
          return S0(s || [], u || [], rc);
        }
        var fP = zt(function(s) {
          var u = s.length, m = u > 1 ? s[u - 1] : r;
          return m = typeof m == "function" ? (s.pop(), m) : r, o1(s, m);
        });
        function a1(s) {
          var u = D(s);
          return u.__chain__ = !0, u;
        }
        function mP(s, u) {
          return u(s), s;
        }
        function td(s, u) {
          return u(s);
        }
        var hP = La(function(s) {
          var u = s.length, m = u ? s[0] : 0, w = this.__wrapped__, I = function(z) {
            return om(z, s);
          };
          return u > 1 || this.__actions__.length || !(w instanceof qt) || !Ba(m) ? this.thru(I) : (w = w.slice(m, +m + (u ? 1 : 0)), w.__actions__.push({
            func: td,
            args: [I],
            thisArg: r
          }), new _o(w, this.__chain__).thru(function(z) {
            return u && !z.length && z.push(r), z;
          }));
        });
        function gP() {
          return a1(this);
        }
        function bP() {
          return new _o(this.value(), this.__chain__);
        }
        function yP() {
          this.__values__ === r && (this.__values__ = v1(this.value()));
          var s = this.__index__ >= this.__values__.length, u = s ? r : this.__values__[this.__index__++];
          return { done: s, value: u };
        }
        function vP() {
          return this;
        }
        function xP(s) {
          for (var u, m = this; m instanceof ju; ) {
            var w = J0(m);
            w.__index__ = 0, w.__values__ = r, u ? I.__wrapped__ = w : u = w;
            var I = w;
            m = m.__wrapped__;
          }
          return I.__wrapped__ = s, u;
        }
        function CP() {
          var s = this.__wrapped__;
          if (s instanceof qt) {
            var u = s;
            return this.__actions__.length && (u = new qt(this)), u = u.reverse(), u.__actions__.push({
              func: td,
              args: [Im],
              thisArg: r
            }), new _o(u, this.__chain__);
          }
          return this.thru(Im);
        }
        function SP() {
          return C0(this.__wrapped__, this.__actions__);
        }
        var wP = qu(function(s, u, m) {
          pr.call(s, m) ? ++s[m] : _a(s, m, 1);
        });
        function TP(s, u, m) {
          var w = It(s) ? Mv : m3;
          return m && Pn(s, u, m) && (u = r), w(s, wt(u, 3));
        }
        function EP(s, u) {
          var m = It(s) ? di : o0;
          return m(s, wt(u, 3));
        }
        var OP = I0(Q0), $P = I0(e1);
        function RP(s, u) {
          return bn(rd(s, u), 1);
        }
        function PP(s, u) {
          return bn(rd(s, u), X);
        }
        function kP(s, u, m) {
          return m = m === r ? 1 : _t(m), bn(rd(s, u), m);
        }
        function i1(s, u) {
          var m = It(s) ? No : hi;
          return m(s, wt(u, 3));
        }
        function s1(s, u) {
          var m = It(s) ? Y$ : n0;
          return m(s, wt(u, 3));
        }
        var AP = qu(function(s, u, m) {
          pr.call(s, m) ? s[m].push(u) : _a(s, m, [u]);
        });
        function IP(s, u, m, w) {
          s = Wn(s) ? s : Js(s), m = m && !w ? _t(m) : 0;
          var I = s.length;
          return m < 0 && (m = an(I + m, 0)), sd(s) ? m <= I && s.indexOf(u, m) > -1 : !!I && js(s, u, m) > -1;
        }
        var NP = zt(function(s, u, m) {
          var w = -1, I = typeof u == "function", z = Wn(s) ? Ee(s.length) : [];
          return hi(s, function(Q) {
            z[++w] = I ? io(u, Q, m) : ec(Q, u, m);
          }), z;
        }), MP = qu(function(s, u, m) {
          _a(s, m, u);
        });
        function rd(s, u) {
          var m = It(s) ? Nr : u0;
          return m(s, wt(u, 3));
        }
        function _P(s, u, m, w) {
          return s == null ? [] : (It(u) || (u = u == null ? [] : [u]), m = w ? r : m, It(m) || (m = m == null ? [] : [m]), m0(s, u, m));
        }
        var FP = qu(function(s, u, m) {
          s[m ? 0 : 1].push(u);
        }, function() {
          return [[], []];
        });
        function LP(s, u, m) {
          var w = It(s) ? Hf : Bv, I = arguments.length < 3;
          return w(s, wt(u, 4), m, I, hi);
        }
        function BP(s, u, m) {
          var w = It(s) ? Z$ : Bv, I = arguments.length < 3;
          return w(s, wt(u, 4), m, I, n0);
        }
        function DP(s, u) {
          var m = It(s) ? di : o0;
          return m(s, ad(wt(u, 3)));
        }
        function jP(s) {
          var u = It(s) ? Qv : I3;
          return u(s);
        }
        function zP(s, u, m) {
          (m ? Pn(s, u, m) : u === r) ? u = 1 : u = _t(u);
          var w = It(s) ? c3 : N3;
          return w(s, u);
        }
        function VP(s) {
          var u = It(s) ? u3 : _3;
          return u(s);
        }
        function WP(s) {
          if (s == null)
            return 0;
          if (Wn(s))
            return sd(s) ? Vs(s) : s.length;
          var u = Sn(s);
          return u == le || u == se ? s.size : um(s).length;
        }
        function UP(s, u, m) {
          var w = It(s) ? Gf : F3;
          return m && Pn(s, u, m) && (u = r), w(s, wt(u, 3));
        }
        var HP = zt(function(s, u) {
          if (s == null)
            return [];
          var m = u.length;
          return m > 1 && Pn(s, u[0], u[1]) ? u = [] : m > 2 && Pn(u[0], u[1], u[2]) && (u = [u[0]]), m0(s, bn(u, 1), []);
        }), nd = ER || function() {
          return gn.Date.now();
        };
        function GP(s, u) {
          if (typeof u != "function")
            throw new Mo(l);
          return s = _t(s), function() {
            if (--s < 1)
              return u.apply(this, arguments);
          };
        }
        function l1(s, u, m) {
          return u = m ? r : u, u = s && u == null ? s.length : u, Fa(s, A, r, r, r, r, u);
        }
        function c1(s, u) {
          var m;
          if (typeof u != "function")
            throw new Mo(l);
          return s = _t(s), function() {
            return --s > 0 && (m = u.apply(this, arguments)), s <= 1 && (u = r), m;
          };
        }
        var Mm = zt(function(s, u, m) {
          var w = v;
          if (m.length) {
            var I = fi(m, Zs(Mm));
            w |= S;
          }
          return Fa(s, w, u, m, I);
        }), u1 = zt(function(s, u, m) {
          var w = v | T;
          if (m.length) {
            var I = fi(m, Zs(u1));
            w |= S;
          }
          return Fa(u, w, s, m, I);
        });
        function d1(s, u, m) {
          u = m ? r : u;
          var w = Fa(s, $, r, r, r, r, r, u);
          return w.placeholder = d1.placeholder, w;
        }
        function p1(s, u, m) {
          u = m ? r : u;
          var w = Fa(s, E, r, r, r, r, r, u);
          return w.placeholder = p1.placeholder, w;
        }
        function f1(s, u, m) {
          var w, I, z, Q, ae, me, Le = 0, Be = !1, Ge = !1, it = !0;
          if (typeof s != "function")
            throw new Mo(l);
          u = Do(u) || 0, _r(m) && (Be = !!m.leading, Ge = "maxWait" in m, z = Ge ? an(Do(m.maxWait) || 0, u) : z, it = "trailing" in m ? !!m.trailing : it);
          function gt(Hr) {
            var ea = w, za = I;
            return w = I = r, Le = Hr, Q = s.apply(za, ea), Q;
          }
          function Et(Hr) {
            return Le = Hr, ae = ac(Gt, u), Be ? gt(Hr) : Q;
          }
          function Lt(Hr) {
            var ea = Hr - me, za = Hr - Le, I1 = u - ea;
            return Ge ? Cn(I1, z - za) : I1;
          }
          function Ot(Hr) {
            var ea = Hr - me, za = Hr - Le;
            return me === r || ea >= u || ea < 0 || Ge && za >= z;
          }
          function Gt() {
            var Hr = nd();
            if (Ot(Hr))
              return Yt(Hr);
            ae = ac(Gt, Lt(Hr));
          }
          function Yt(Hr) {
            return ae = r, it && w ? gt(Hr) : (w = I = r, Q);
          }
          function uo() {
            ae !== r && w0(ae), Le = 0, w = me = I = ae = r;
          }
          function kn() {
            return ae === r ? Q : Yt(nd());
          }
          function po() {
            var Hr = nd(), ea = Ot(Hr);
            if (w = arguments, I = this, me = Hr, ea) {
              if (ae === r)
                return Et(me);
              if (Ge)
                return w0(ae), ae = ac(Gt, u), gt(me);
            }
            return ae === r && (ae = ac(Gt, u)), Q;
          }
          return po.cancel = uo, po.flush = kn, po;
        }
        var qP = zt(function(s, u) {
          return r0(s, 1, u);
        }), KP = zt(function(s, u, m) {
          return r0(s, Do(u) || 0, m);
        });
        function YP(s) {
          return Fa(s, L);
        }
        function od(s, u) {
          if (typeof s != "function" || u != null && typeof u != "function")
            throw new Mo(l);
          var m = function() {
            var w = arguments, I = u ? u.apply(this, w) : w[0], z = m.cache;
            if (z.has(I))
              return z.get(I);
            var Q = s.apply(this, w);
            return m.cache = z.set(I, Q) || z, Q;
          };
          return m.cache = new (od.Cache || Ma)(), m;
        }
        od.Cache = Ma;
        function ad(s) {
          if (typeof s != "function")
            throw new Mo(l);
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return !s.call(this);
              case 1:
                return !s.call(this, u[0]);
              case 2:
                return !s.call(this, u[0], u[1]);
              case 3:
                return !s.call(this, u[0], u[1], u[2]);
            }
            return !s.apply(this, u);
          };
        }
        function ZP(s) {
          return c1(2, s);
        }
        var XP = L3(function(s, u) {
          u = u.length == 1 && It(u[0]) ? Nr(u[0], so(wt())) : Nr(bn(u, 1), so(wt()));
          var m = u.length;
          return zt(function(w) {
            for (var I = -1, z = Cn(w.length, m); ++I < z; )
              w[I] = u[I].call(this, w[I]);
            return io(s, this, w);
          });
        }), _m = zt(function(s, u) {
          var m = fi(u, Zs(_m));
          return Fa(s, S, r, u, m);
        }), m1 = zt(function(s, u) {
          var m = fi(u, Zs(m1));
          return Fa(s, k, r, u, m);
        }), JP = La(function(s, u) {
          return Fa(s, _, r, r, r, u);
        });
        function QP(s, u) {
          if (typeof s != "function")
            throw new Mo(l);
          return u = u === r ? u : _t(u), zt(s, u);
        }
        function ek(s, u) {
          if (typeof s != "function")
            throw new Mo(l);
          return u = u == null ? 0 : an(_t(u), 0), zt(function(m) {
            var w = m[u], I = yi(m, 0, u);
            return w && pi(I, w), io(s, this, I);
          });
        }
        function tk(s, u, m) {
          var w = !0, I = !0;
          if (typeof s != "function")
            throw new Mo(l);
          return _r(m) && (w = "leading" in m ? !!m.leading : w, I = "trailing" in m ? !!m.trailing : I), f1(s, u, {
            leading: w,
            maxWait: u,
            trailing: I
          });
        }
        function rk(s) {
          return l1(s, 1);
        }
        function nk(s, u) {
          return _m(vm(u), s);
        }
        function ok() {
          if (!arguments.length)
            return [];
          var s = arguments[0];
          return It(s) ? s : [s];
        }
        function ak(s) {
          return Fo(s, y);
        }
        function ik(s, u) {
          return u = typeof u == "function" ? u : r, Fo(s, y, u);
        }
        function sk(s) {
          return Fo(s, h | y);
        }
        function lk(s, u) {
          return u = typeof u == "function" ? u : r, Fo(s, h | y, u);
        }
        function ck(s, u) {
          return u == null || t0(s, u, cn(u));
        }
        function Qo(s, u) {
          return s === u || s !== s && u !== u;
        }
        var uk = Xu(sm), dk = Xu(function(s, u) {
          return s >= u;
        }), Yi = s0(/* @__PURE__ */ function() {
          return arguments;
        }()) ? s0 : function(s) {
          return Br(s) && pr.call(s, "callee") && !qv.call(s, "callee");
        }, It = Ee.isArray, pk = Rv ? so(Rv) : x3;
        function Wn(s) {
          return s != null && id(s.length) && !Da(s);
        }
        function Ur(s) {
          return Br(s) && Wn(s);
        }
        function fk(s) {
          return s === !0 || s === !1 || Br(s) && Rn(s) == ce;
        }
        var vi = $R || Gm, mk = Pv ? so(Pv) : C3;
        function hk(s) {
          return Br(s) && s.nodeType === 1 && !ic(s);
        }
        function gk(s) {
          if (s == null)
            return !0;
          if (Wn(s) && (It(s) || typeof s == "string" || typeof s.splice == "function" || vi(s) || Xs(s) || Yi(s)))
            return !s.length;
          var u = Sn(s);
          if (u == le || u == se)
            return !s.size;
          if (oc(s))
            return !um(s).length;
          for (var m in s)
            if (pr.call(s, m))
              return !1;
          return !0;
        }
        function bk(s, u) {
          return tc(s, u);
        }
        function yk(s, u, m) {
          m = typeof m == "function" ? m : r;
          var w = m ? m(s, u) : r;
          return w === r ? tc(s, u, r, m) : !!w;
        }
        function Fm(s) {
          if (!Br(s))
            return !1;
          var u = Rn(s);
          return u == Re || u == xe || typeof s.message == "string" && typeof s.name == "string" && !ic(s);
        }
        function vk(s) {
          return typeof s == "number" && Yv(s);
        }
        function Da(s) {
          if (!_r(s))
            return !1;
          var u = Rn(s);
          return u == J || u == Ie || u == oe || u == he;
        }
        function h1(s) {
          return typeof s == "number" && s == _t(s);
        }
        function id(s) {
          return typeof s == "number" && s > -1 && s % 1 == 0 && s <= U;
        }
        function _r(s) {
          var u = typeof s;
          return s != null && (u == "object" || u == "function");
        }
        function Br(s) {
          return s != null && typeof s == "object";
        }
        var g1 = kv ? so(kv) : w3;
        function xk(s, u) {
          return s === u || cm(s, u, Om(u));
        }
        function Ck(s, u, m) {
          return m = typeof m == "function" ? m : r, cm(s, u, Om(u), m);
        }
        function Sk(s) {
          return b1(s) && s != +s;
        }
        function wk(s) {
          if (i6(s))
            throw new At(i);
          return l0(s);
        }
        function Tk(s) {
          return s === null;
        }
        function Ek(s) {
          return s == null;
        }
        function b1(s) {
          return typeof s == "number" || Br(s) && Rn(s) == qe;
        }
        function ic(s) {
          if (!Br(s) || Rn(s) != K)
            return !1;
          var u = Nu(s);
          if (u === null)
            return !0;
          var m = pr.call(u, "constructor") && u.constructor;
          return typeof m == "function" && m instanceof m && Pu.call(m) == CR;
        }
        var Lm = Av ? so(Av) : T3;
        function Ok(s) {
          return h1(s) && s >= -U && s <= U;
        }
        var y1 = Iv ? so(Iv) : E3;
        function sd(s) {
          return typeof s == "string" || !It(s) && Br(s) && Rn(s) == ue;
        }
        function co(s) {
          return typeof s == "symbol" || Br(s) && Rn(s) == Qe;
        }
        var Xs = Nv ? so(Nv) : O3;
        function $k(s) {
          return s === r;
        }
        function Rk(s) {
          return Br(s) && Sn(s) == be;
        }
        function Pk(s) {
          return Br(s) && Rn(s) == Se;
        }
        var kk = Xu(dm), Ak = Xu(function(s, u) {
          return s <= u;
        });
        function v1(s) {
          if (!s)
            return [];
          if (Wn(s))
            return sd(s) ? Xo(s) : Vn(s);
          if (ql && s[ql])
            return cR(s[ql]());
          var u = Sn(s), m = u == le ? Jf : u == se ? Ou : Js;
          return m(s);
        }
        function ja(s) {
          if (!s)
            return s === 0 ? s : 0;
          if (s = Do(s), s === X || s === -X) {
            var u = s < 0 ? -1 : 1;
            return u * H;
          }
          return s === s ? s : 0;
        }
        function _t(s) {
          var u = ja(s), m = u % 1;
          return u === u ? m ? u - m : u : 0;
        }
        function x1(s) {
          return s ? Hi(_t(s), 0, G) : 0;
        }
        function Do(s) {
          if (typeof s == "number")
            return s;
          if (co(s))
            return Z;
          if (_r(s)) {
            var u = typeof s.valueOf == "function" ? s.valueOf() : s;
            s = _r(u) ? u + "" : u;
          }
          if (typeof s != "string")
            return s === 0 ? s : +s;
          s = Dv(s);
          var m = je.test(s);
          return m || mt.test(s) ? G$(s.slice(2), m ? 2 : 8) : ve.test(s) ? Z : +s;
        }
        function C1(s) {
          return pa(s, Un(s));
        }
        function Ik(s) {
          return s ? Hi(_t(s), -U, U) : s === 0 ? s : 0;
        }
        function ar(s) {
          return s == null ? "" : lo(s);
        }
        var Nk = Ks(function(s, u) {
          if (oc(u) || Wn(u)) {
            pa(u, cn(u), s);
            return;
          }
          for (var m in u)
            pr.call(u, m) && Jl(s, m, u[m]);
        }), S1 = Ks(function(s, u) {
          pa(u, Un(u), s);
        }), ld = Ks(function(s, u, m, w) {
          pa(u, Un(u), s, w);
        }), Mk = Ks(function(s, u, m, w) {
          pa(u, cn(u), s, w);
        }), _k = La(om);
        function Fk(s, u) {
          var m = qs(s);
          return u == null ? m : e0(m, u);
        }
        var Lk = zt(function(s, u) {
          s = yr(s);
          var m = -1, w = u.length, I = w > 2 ? u[2] : r;
          for (I && Pn(u[0], u[1], I) && (w = 1); ++m < w; )
            for (var z = u[m], Q = Un(z), ae = -1, me = Q.length; ++ae < me; ) {
              var Le = Q[ae], Be = s[Le];
              (Be === r || Qo(Be, Us[Le]) && !pr.call(s, Le)) && (s[Le] = z[Le]);
            }
          return s;
        }), Bk = zt(function(s) {
          return s.push(r, D0), io(w1, r, s);
        });
        function Dk(s, u) {
          return _v(s, wt(u, 3), da);
        }
        function jk(s, u) {
          return _v(s, wt(u, 3), im);
        }
        function zk(s, u) {
          return s == null ? s : am(s, wt(u, 3), Un);
        }
        function Vk(s, u) {
          return s == null ? s : a0(s, wt(u, 3), Un);
        }
        function Wk(s, u) {
          return s && da(s, wt(u, 3));
        }
        function Uk(s, u) {
          return s && im(s, wt(u, 3));
        }
        function Hk(s) {
          return s == null ? [] : Wu(s, cn(s));
        }
        function Gk(s) {
          return s == null ? [] : Wu(s, Un(s));
        }
        function Bm(s, u, m) {
          var w = s == null ? r : Gi(s, u);
          return w === r ? m : w;
        }
        function qk(s, u) {
          return s != null && V0(s, u, g3);
        }
        function Dm(s, u) {
          return s != null && V0(s, u, b3);
        }
        var Kk = M0(function(s, u, m) {
          u != null && typeof u.toString != "function" && (u = ku.call(u)), s[u] = m;
        }, zm(Hn)), Yk = M0(function(s, u, m) {
          u != null && typeof u.toString != "function" && (u = ku.call(u)), pr.call(s, u) ? s[u].push(m) : s[u] = [m];
        }, wt), Zk = zt(ec);
        function cn(s) {
          return Wn(s) ? Jv(s) : um(s);
        }
        function Un(s) {
          return Wn(s) ? Jv(s, !0) : $3(s);
        }
        function Xk(s, u) {
          var m = {};
          return u = wt(u, 3), da(s, function(w, I, z) {
            _a(m, u(w, I, z), w);
          }), m;
        }
        function Jk(s, u) {
          var m = {};
          return u = wt(u, 3), da(s, function(w, I, z) {
            _a(m, I, u(w, I, z));
          }), m;
        }
        var Qk = Ks(function(s, u, m) {
          Uu(s, u, m);
        }), w1 = Ks(function(s, u, m, w) {
          Uu(s, u, m, w);
        }), eA = La(function(s, u) {
          var m = {};
          if (s == null)
            return m;
          var w = !1;
          u = Nr(u, function(z) {
            return z = bi(z, s), w || (w = z.length > 1), z;
          }), pa(s, Tm(s), m), w && (m = Fo(m, h | g | y, K3));
          for (var I = u.length; I--; )
            gm(m, u[I]);
          return m;
        });
        function tA(s, u) {
          return T1(s, ad(wt(u)));
        }
        var rA = La(function(s, u) {
          return s == null ? {} : P3(s, u);
        });
        function T1(s, u) {
          if (s == null)
            return {};
          var m = Nr(Tm(s), function(w) {
            return [w];
          });
          return u = wt(u), h0(s, m, function(w, I) {
            return u(w, I[0]);
          });
        }
        function nA(s, u, m) {
          u = bi(u, s);
          var w = -1, I = u.length;
          for (I || (I = 1, s = r); ++w < I; ) {
            var z = s == null ? r : s[fa(u[w])];
            z === r && (w = I, z = m), s = Da(z) ? z.call(s) : z;
          }
          return s;
        }
        function oA(s, u, m) {
          return s == null ? s : rc(s, u, m);
        }
        function aA(s, u, m, w) {
          return w = typeof w == "function" ? w : r, s == null ? s : rc(s, u, m, w);
        }
        var E1 = L0(cn), O1 = L0(Un);
        function iA(s, u, m) {
          var w = It(s), I = w || vi(s) || Xs(s);
          if (u = wt(u, 4), m == null) {
            var z = s && s.constructor;
            I ? m = w ? new z() : [] : _r(s) ? m = Da(z) ? qs(Nu(s)) : {} : m = {};
          }
          return (I ? No : da)(s, function(Q, ae, me) {
            return u(m, Q, ae, me);
          }), m;
        }
        function sA(s, u) {
          return s == null ? !0 : gm(s, u);
        }
        function lA(s, u, m) {
          return s == null ? s : x0(s, u, vm(m));
        }
        function cA(s, u, m, w) {
          return w = typeof w == "function" ? w : r, s == null ? s : x0(s, u, vm(m), w);
        }
        function Js(s) {
          return s == null ? [] : Xf(s, cn(s));
        }
        function uA(s) {
          return s == null ? [] : Xf(s, Un(s));
        }
        function dA(s, u, m) {
          return m === r && (m = u, u = r), m !== r && (m = Do(m), m = m === m ? m : 0), u !== r && (u = Do(u), u = u === u ? u : 0), Hi(Do(s), u, m);
        }
        function pA(s, u, m) {
          return u = ja(u), m === r ? (m = u, u = 0) : m = ja(m), s = Do(s), y3(s, u, m);
        }
        function fA(s, u, m) {
          if (m && typeof m != "boolean" && Pn(s, u, m) && (u = m = r), m === r && (typeof u == "boolean" ? (m = u, u = r) : typeof s == "boolean" && (m = s, s = r)), s === r && u === r ? (s = 0, u = 1) : (s = ja(s), u === r ? (u = s, s = 0) : u = ja(u)), s > u) {
            var w = s;
            s = u, u = w;
          }
          if (m || s % 1 || u % 1) {
            var I = Zv();
            return Cn(s + I * (u - s + H$("1e-" + ((I + "").length - 1))), u);
          }
          return fm(s, u);
        }
        var mA = Ys(function(s, u, m) {
          return u = u.toLowerCase(), s + (m ? $1(u) : u);
        });
        function $1(s) {
          return jm(ar(s).toLowerCase());
        }
        function R1(s) {
          return s = ar(s), s && s.replace(Kt, oR).replace(_$, "");
        }
        function hA(s, u, m) {
          s = ar(s), u = lo(u);
          var w = s.length;
          m = m === r ? w : Hi(_t(m), 0, w);
          var I = m;
          return m -= u.length, m >= 0 && s.slice(m, I) == u;
        }
        function gA(s) {
          return s = ar(s), s && er.test(s) ? s.replace(nt, aR) : s;
        }
        function bA(s) {
          return s = ar(s), s && kt.test(s) ? s.replace(St, "\\$&") : s;
        }
        var yA = Ys(function(s, u, m) {
          return s + (m ? "-" : "") + u.toLowerCase();
        }), vA = Ys(function(s, u, m) {
          return s + (m ? " " : "") + u.toLowerCase();
        }), xA = A0("toLowerCase");
        function CA(s, u, m) {
          s = ar(s), u = _t(u);
          var w = u ? Vs(s) : 0;
          if (!u || w >= u)
            return s;
          var I = (u - w) / 2;
          return Zu(Lu(I), m) + s + Zu(Fu(I), m);
        }
        function SA(s, u, m) {
          s = ar(s), u = _t(u);
          var w = u ? Vs(s) : 0;
          return u && w < u ? s + Zu(u - w, m) : s;
        }
        function wA(s, u, m) {
          s = ar(s), u = _t(u);
          var w = u ? Vs(s) : 0;
          return u && w < u ? Zu(u - w, m) + s : s;
        }
        function TA(s, u, m) {
          return m || u == null ? u = 0 : u && (u = +u), AR(ar(s).replace(Wt, ""), u || 0);
        }
        function EA(s, u, m) {
          return (m ? Pn(s, u, m) : u === r) ? u = 1 : u = _t(u), mm(ar(s), u);
        }
        function OA() {
          var s = arguments, u = ar(s[0]);
          return s.length < 3 ? u : u.replace(s[1], s[2]);
        }
        var $A = Ys(function(s, u, m) {
          return s + (m ? "_" : "") + u.toLowerCase();
        });
        function RA(s, u, m) {
          return m && typeof m != "number" && Pn(s, u, m) && (u = m = r), m = m === r ? G : m >>> 0, m ? (s = ar(s), s && (typeof u == "string" || u != null && !Lm(u)) && (u = lo(u), !u && zs(s)) ? yi(Xo(s), 0, m) : s.split(u, m)) : [];
        }
        var PA = Ys(function(s, u, m) {
          return s + (m ? " " : "") + jm(u);
        });
        function kA(s, u, m) {
          return s = ar(s), m = m == null ? 0 : Hi(_t(m), 0, s.length), u = lo(u), s.slice(m, m + u.length) == u;
        }
        function AA(s, u, m) {
          var w = D.templateSettings;
          m && Pn(s, u, m) && (u = r), s = ar(s), u = ld({}, u, w, B0);
          var I = ld({}, u.imports, w.imports, B0), z = cn(I), Q = Xf(I, z), ae, me, Le = 0, Be = u.interpolate || br, Ge = "__p += '", it = Qf(
            (u.escape || br).source + "|" + Be.source + "|" + (Be === ct ? Ht : br).source + "|" + (u.evaluate || br).source + "|$",
            "g"
          ), gt = "//# sourceURL=" + (pr.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++j$ + "]") + `
`;
          s.replace(it, function(Ot, Gt, Yt, uo, kn, po) {
            return Yt || (Yt = uo), Ge += s.slice(Le, po).replace($n, iR), Gt && (ae = !0, Ge += `' +
__e(` + Gt + `) +
'`), kn && (me = !0, Ge += `';
` + kn + `;
__p += '`), Yt && (Ge += `' +
((__t = (` + Yt + `)) == null ? '' : __t) +
'`), Le = po + Ot.length, Ot;
          }), Ge += `';
`;
          var Et = pr.call(u, "variable") && u.variable;
          if (!Et)
            Ge = `with (obj) {
` + Ge + `
}
`;
          else if (Xe.test(Et))
            throw new At(c);
          Ge = (me ? Ge.replace(Pt, "") : Ge).replace(Mt, "$1").replace(Ct, "$1;"), Ge = "function(" + (Et || "obj") + `) {
` + (Et ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ae ? ", __e = _.escape" : "") + (me ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ge + `return __p
}`;
          var Lt = k1(function() {
            return rr(z, gt + "return " + Ge).apply(r, Q);
          });
          if (Lt.source = Ge, Fm(Lt))
            throw Lt;
          return Lt;
        }
        function IA(s) {
          return ar(s).toLowerCase();
        }
        function NA(s) {
          return ar(s).toUpperCase();
        }
        function MA(s, u, m) {
          if (s = ar(s), s && (m || u === r))
            return Dv(s);
          if (!s || !(u = lo(u)))
            return s;
          var w = Xo(s), I = Xo(u), z = jv(w, I), Q = zv(w, I) + 1;
          return yi(w, z, Q).join("");
        }
        function _A(s, u, m) {
          if (s = ar(s), s && (m || u === r))
            return s.slice(0, Wv(s) + 1);
          if (!s || !(u = lo(u)))
            return s;
          var w = Xo(s), I = zv(w, Xo(u)) + 1;
          return yi(w, 0, I).join("");
        }
        function FA(s, u, m) {
          if (s = ar(s), s && (m || u === r))
            return s.replace(Wt, "");
          if (!s || !(u = lo(u)))
            return s;
          var w = Xo(s), I = jv(w, Xo(u));
          return yi(w, I).join("");
        }
        function LA(s, u) {
          var m = O, w = F;
          if (_r(u)) {
            var I = "separator" in u ? u.separator : I;
            m = "length" in u ? _t(u.length) : m, w = "omission" in u ? lo(u.omission) : w;
          }
          s = ar(s);
          var z = s.length;
          if (zs(s)) {
            var Q = Xo(s);
            z = Q.length;
          }
          if (m >= z)
            return s;
          var ae = m - Vs(w);
          if (ae < 1)
            return w;
          var me = Q ? yi(Q, 0, ae).join("") : s.slice(0, ae);
          if (I === r)
            return me + w;
          if (Q && (ae += me.length - ae), Lm(I)) {
            if (s.slice(ae).search(I)) {
              var Le, Be = me;
              for (I.global || (I = Qf(I.source, ar(Te.exec(I)) + "g")), I.lastIndex = 0; Le = I.exec(Be); )
                var Ge = Le.index;
              me = me.slice(0, Ge === r ? ae : Ge);
            }
          } else if (s.indexOf(lo(I), ae) != ae) {
            var it = me.lastIndexOf(I);
            it > -1 && (me = me.slice(0, it));
          }
          return me + w;
        }
        function BA(s) {
          return s = ar(s), s && ft.test(s) ? s.replace(bt, fR) : s;
        }
        var DA = Ys(function(s, u, m) {
          return s + (m ? " " : "") + u.toUpperCase();
        }), jm = A0("toUpperCase");
        function P1(s, u, m) {
          return s = ar(s), u = m ? r : u, u === r ? lR(s) ? gR(s) : Q$(s) : s.match(u) || [];
        }
        var k1 = zt(function(s, u) {
          try {
            return io(s, r, u);
          } catch (m) {
            return Fm(m) ? m : new At(m);
          }
        }), jA = La(function(s, u) {
          return No(u, function(m) {
            m = fa(m), _a(s, m, Mm(s[m], s));
          }), s;
        });
        function zA(s) {
          var u = s == null ? 0 : s.length, m = wt();
          return s = u ? Nr(s, function(w) {
            if (typeof w[1] != "function")
              throw new Mo(l);
            return [m(w[0]), w[1]];
          }) : [], zt(function(w) {
            for (var I = -1; ++I < u; ) {
              var z = s[I];
              if (io(z[0], this, w))
                return io(z[1], this, w);
            }
          });
        }
        function VA(s) {
          return f3(Fo(s, h));
        }
        function zm(s) {
          return function() {
            return s;
          };
        }
        function WA(s, u) {
          return s == null || s !== s ? u : s;
        }
        var UA = N0(), HA = N0(!0);
        function Hn(s) {
          return s;
        }
        function Vm(s) {
          return c0(typeof s == "function" ? s : Fo(s, h));
        }
        function GA(s) {
          return d0(Fo(s, h));
        }
        function qA(s, u) {
          return p0(s, Fo(u, h));
        }
        var KA = zt(function(s, u) {
          return function(m) {
            return ec(m, s, u);
          };
        }), YA = zt(function(s, u) {
          return function(m) {
            return ec(s, m, u);
          };
        });
        function Wm(s, u, m) {
          var w = cn(u), I = Wu(u, w);
          m == null && !(_r(u) && (I.length || !w.length)) && (m = u, u = s, s = this, I = Wu(u, cn(u)));
          var z = !(_r(m) && "chain" in m) || !!m.chain, Q = Da(s);
          return No(I, function(ae) {
            var me = u[ae];
            s[ae] = me, Q && (s.prototype[ae] = function() {
              var Le = this.__chain__;
              if (z || Le) {
                var Be = s(this.__wrapped__), Ge = Be.__actions__ = Vn(this.__actions__);
                return Ge.push({ func: me, args: arguments, thisArg: s }), Be.__chain__ = Le, Be;
              }
              return me.apply(s, pi([this.value()], arguments));
            });
          }), s;
        }
        function ZA() {
          return gn._ === this && (gn._ = SR), this;
        }
        function Um() {
        }
        function XA(s) {
          return s = _t(s), zt(function(u) {
            return f0(u, s);
          });
        }
        var JA = Cm(Nr), QA = Cm(Mv), eI = Cm(Gf);
        function A1(s) {
          return Rm(s) ? qf(fa(s)) : k3(s);
        }
        function tI(s) {
          return function(u) {
            return s == null ? r : Gi(s, u);
          };
        }
        var rI = _0(), nI = _0(!0);
        function Hm() {
          return [];
        }
        function Gm() {
          return !1;
        }
        function oI() {
          return {};
        }
        function aI() {
          return "";
        }
        function iI() {
          return !0;
        }
        function sI(s, u) {
          if (s = _t(s), s < 1 || s > U)
            return [];
          var m = G, w = Cn(s, G);
          u = wt(u), s -= G;
          for (var I = Zf(w, u); ++m < s; )
            u(m);
          return I;
        }
        function lI(s) {
          return It(s) ? Nr(s, fa) : co(s) ? [s] : Vn(X0(ar(s)));
        }
        function cI(s) {
          var u = ++xR;
          return ar(s) + u;
        }
        var uI = Yu(function(s, u) {
          return s + u;
        }, 0), dI = Sm("ceil"), pI = Yu(function(s, u) {
          return s / u;
        }, 1), fI = Sm("floor");
        function mI(s) {
          return s && s.length ? Vu(s, Hn, sm) : r;
        }
        function hI(s, u) {
          return s && s.length ? Vu(s, wt(u, 2), sm) : r;
        }
        function gI(s) {
          return Lv(s, Hn);
        }
        function bI(s, u) {
          return Lv(s, wt(u, 2));
        }
        function yI(s) {
          return s && s.length ? Vu(s, Hn, dm) : r;
        }
        function vI(s, u) {
          return s && s.length ? Vu(s, wt(u, 2), dm) : r;
        }
        var xI = Yu(function(s, u) {
          return s * u;
        }, 1), CI = Sm("round"), SI = Yu(function(s, u) {
          return s - u;
        }, 0);
        function wI(s) {
          return s && s.length ? Yf(s, Hn) : 0;
        }
        function TI(s, u) {
          return s && s.length ? Yf(s, wt(u, 2)) : 0;
        }
        return D.after = GP, D.ary = l1, D.assign = Nk, D.assignIn = S1, D.assignInWith = ld, D.assignWith = Mk, D.at = _k, D.before = c1, D.bind = Mm, D.bindAll = jA, D.bindKey = u1, D.castArray = ok, D.chain = a1, D.chunk = f6, D.compact = m6, D.concat = h6, D.cond = zA, D.conforms = VA, D.constant = zm, D.countBy = wP, D.create = Fk, D.curry = d1, D.curryRight = p1, D.debounce = f1, D.defaults = Lk, D.defaultsDeep = Bk, D.defer = qP, D.delay = KP, D.difference = g6, D.differenceBy = b6, D.differenceWith = y6, D.drop = v6, D.dropRight = x6, D.dropRightWhile = C6, D.dropWhile = S6, D.fill = w6, D.filter = EP, D.flatMap = RP, D.flatMapDeep = PP, D.flatMapDepth = kP, D.flatten = t1, D.flattenDeep = T6, D.flattenDepth = E6, D.flip = YP, D.flow = UA, D.flowRight = HA, D.fromPairs = O6, D.functions = Hk, D.functionsIn = Gk, D.groupBy = AP, D.initial = R6, D.intersection = P6, D.intersectionBy = k6, D.intersectionWith = A6, D.invert = Kk, D.invertBy = Yk, D.invokeMap = NP, D.iteratee = Vm, D.keyBy = MP, D.keys = cn, D.keysIn = Un, D.map = rd, D.mapKeys = Xk, D.mapValues = Jk, D.matches = GA, D.matchesProperty = qA, D.memoize = od, D.merge = Qk, D.mergeWith = w1, D.method = KA, D.methodOf = YA, D.mixin = Wm, D.negate = ad, D.nthArg = XA, D.omit = eA, D.omitBy = tA, D.once = ZP, D.orderBy = _P, D.over = JA, D.overArgs = XP, D.overEvery = QA, D.overSome = eI, D.partial = _m, D.partialRight = m1, D.partition = FP, D.pick = rA, D.pickBy = T1, D.property = A1, D.propertyOf = tI, D.pull = _6, D.pullAll = n1, D.pullAllBy = F6, D.pullAllWith = L6, D.pullAt = B6, D.range = rI, D.rangeRight = nI, D.rearg = JP, D.reject = DP, D.remove = D6, D.rest = QP, D.reverse = Im, D.sampleSize = zP, D.set = oA, D.setWith = aA, D.shuffle = VP, D.slice = j6, D.sortBy = HP, D.sortedUniq = q6, D.sortedUniqBy = K6, D.split = RA, D.spread = ek, D.tail = Y6, D.take = Z6, D.takeRight = X6, D.takeRightWhile = J6, D.takeWhile = Q6, D.tap = mP, D.throttle = tk, D.thru = td, D.toArray = v1, D.toPairs = E1, D.toPairsIn = O1, D.toPath = lI, D.toPlainObject = C1, D.transform = iA, D.unary = rk, D.union = eP, D.unionBy = tP, D.unionWith = rP, D.uniq = nP, D.uniqBy = oP, D.uniqWith = aP, D.unset = sA, D.unzip = Nm, D.unzipWith = o1, D.update = lA, D.updateWith = cA, D.values = Js, D.valuesIn = uA, D.without = iP, D.words = P1, D.wrap = nk, D.xor = sP, D.xorBy = lP, D.xorWith = cP, D.zip = uP, D.zipObject = dP, D.zipObjectDeep = pP, D.zipWith = fP, D.entries = E1, D.entriesIn = O1, D.extend = S1, D.extendWith = ld, Wm(D, D), D.add = uI, D.attempt = k1, D.camelCase = mA, D.capitalize = $1, D.ceil = dI, D.clamp = dA, D.clone = ak, D.cloneDeep = sk, D.cloneDeepWith = lk, D.cloneWith = ik, D.conformsTo = ck, D.deburr = R1, D.defaultTo = WA, D.divide = pI, D.endsWith = hA, D.eq = Qo, D.escape = gA, D.escapeRegExp = bA, D.every = TP, D.find = OP, D.findIndex = Q0, D.findKey = Dk, D.findLast = $P, D.findLastIndex = e1, D.findLastKey = jk, D.floor = fI, D.forEach = i1, D.forEachRight = s1, D.forIn = zk, D.forInRight = Vk, D.forOwn = Wk, D.forOwnRight = Uk, D.get = Bm, D.gt = uk, D.gte = dk, D.has = qk, D.hasIn = Dm, D.head = r1, D.identity = Hn, D.includes = IP, D.indexOf = $6, D.inRange = pA, D.invoke = Zk, D.isArguments = Yi, D.isArray = It, D.isArrayBuffer = pk, D.isArrayLike = Wn, D.isArrayLikeObject = Ur, D.isBoolean = fk, D.isBuffer = vi, D.isDate = mk, D.isElement = hk, D.isEmpty = gk, D.isEqual = bk, D.isEqualWith = yk, D.isError = Fm, D.isFinite = vk, D.isFunction = Da, D.isInteger = h1, D.isLength = id, D.isMap = g1, D.isMatch = xk, D.isMatchWith = Ck, D.isNaN = Sk, D.isNative = wk, D.isNil = Ek, D.isNull = Tk, D.isNumber = b1, D.isObject = _r, D.isObjectLike = Br, D.isPlainObject = ic, D.isRegExp = Lm, D.isSafeInteger = Ok, D.isSet = y1, D.isString = sd, D.isSymbol = co, D.isTypedArray = Xs, D.isUndefined = $k, D.isWeakMap = Rk, D.isWeakSet = Pk, D.join = I6, D.kebabCase = yA, D.last = Bo, D.lastIndexOf = N6, D.lowerCase = vA, D.lowerFirst = xA, D.lt = kk, D.lte = Ak, D.max = mI, D.maxBy = hI, D.mean = gI, D.meanBy = bI, D.min = yI, D.minBy = vI, D.stubArray = Hm, D.stubFalse = Gm, D.stubObject = oI, D.stubString = aI, D.stubTrue = iI, D.multiply = xI, D.nth = M6, D.noConflict = ZA, D.noop = Um, D.now = nd, D.pad = CA, D.padEnd = SA, D.padStart = wA, D.parseInt = TA, D.random = fA, D.reduce = LP, D.reduceRight = BP, D.repeat = EA, D.replace = OA, D.result = nA, D.round = CI, D.runInContext = pe, D.sample = jP, D.size = WP, D.snakeCase = $A, D.some = UP, D.sortedIndex = z6, D.sortedIndexBy = V6, D.sortedIndexOf = W6, D.sortedLastIndex = U6, D.sortedLastIndexBy = H6, D.sortedLastIndexOf = G6, D.startCase = PA, D.startsWith = kA, D.subtract = SI, D.sum = wI, D.sumBy = TI, D.template = AA, D.times = sI, D.toFinite = ja, D.toInteger = _t, D.toLength = x1, D.toLower = IA, D.toNumber = Do, D.toSafeInteger = Ik, D.toString = ar, D.toUpper = NA, D.trim = MA, D.trimEnd = _A, D.trimStart = FA, D.truncate = LA, D.unescape = BA, D.uniqueId = cI, D.upperCase = DA, D.upperFirst = jm, D.each = i1, D.eachRight = s1, D.first = r1, Wm(D, function() {
          var s = {};
          return da(D, function(u, m) {
            pr.call(D.prototype, m) || (s[m] = u);
          }), s;
        }(), { chain: !1 }), D.VERSION = o, No(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
          D[s].placeholder = D;
        }), No(["drop", "take"], function(s, u) {
          qt.prototype[s] = function(m) {
            m = m === r ? 1 : an(_t(m), 0);
            var w = this.__filtered__ && !u ? new qt(this) : this.clone();
            return w.__filtered__ ? w.__takeCount__ = Cn(m, w.__takeCount__) : w.__views__.push({
              size: Cn(m, G),
              type: s + (w.__dir__ < 0 ? "Right" : "")
            }), w;
          }, qt.prototype[s + "Right"] = function(m) {
            return this.reverse()[s](m).reverse();
          };
        }), No(["filter", "map", "takeWhile"], function(s, u) {
          var m = u + 1, w = m == j || m == V;
          qt.prototype[s] = function(I) {
            var z = this.clone();
            return z.__iteratees__.push({
              iteratee: wt(I, 3),
              type: m
            }), z.__filtered__ = z.__filtered__ || w, z;
          };
        }), No(["head", "last"], function(s, u) {
          var m = "take" + (u ? "Right" : "");
          qt.prototype[s] = function() {
            return this[m](1).value()[0];
          };
        }), No(["initial", "tail"], function(s, u) {
          var m = "drop" + (u ? "" : "Right");
          qt.prototype[s] = function() {
            return this.__filtered__ ? new qt(this) : this[m](1);
          };
        }), qt.prototype.compact = function() {
          return this.filter(Hn);
        }, qt.prototype.find = function(s) {
          return this.filter(s).head();
        }, qt.prototype.findLast = function(s) {
          return this.reverse().find(s);
        }, qt.prototype.invokeMap = zt(function(s, u) {
          return typeof s == "function" ? new qt(this) : this.map(function(m) {
            return ec(m, s, u);
          });
        }), qt.prototype.reject = function(s) {
          return this.filter(ad(wt(s)));
        }, qt.prototype.slice = function(s, u) {
          s = _t(s);
          var m = this;
          return m.__filtered__ && (s > 0 || u < 0) ? new qt(m) : (s < 0 ? m = m.takeRight(-s) : s && (m = m.drop(s)), u !== r && (u = _t(u), m = u < 0 ? m.dropRight(-u) : m.take(u - s)), m);
        }, qt.prototype.takeRightWhile = function(s) {
          return this.reverse().takeWhile(s).reverse();
        }, qt.prototype.toArray = function() {
          return this.take(G);
        }, da(qt.prototype, function(s, u) {
          var m = /^(?:filter|find|map|reject)|While$/.test(u), w = /^(?:head|last)$/.test(u), I = D[w ? "take" + (u == "last" ? "Right" : "") : u], z = w || /^find/.test(u);
          I && (D.prototype[u] = function() {
            var Q = this.__wrapped__, ae = w ? [1] : arguments, me = Q instanceof qt, Le = ae[0], Be = me || It(Q), Ge = function(Gt) {
              var Yt = I.apply(D, pi([Gt], ae));
              return w && it ? Yt[0] : Yt;
            };
            Be && m && typeof Le == "function" && Le.length != 1 && (me = Be = !1);
            var it = this.__chain__, gt = !!this.__actions__.length, Et = z && !it, Lt = me && !gt;
            if (!z && Be) {
              Q = Lt ? Q : new qt(this);
              var Ot = s.apply(Q, ae);
              return Ot.__actions__.push({ func: td, args: [Ge], thisArg: r }), new _o(Ot, it);
            }
            return Et && Lt ? s.apply(this, ae) : (Ot = this.thru(Ge), Et ? w ? Ot.value()[0] : Ot.value() : Ot);
          });
        }), No(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
          var u = $u[s], m = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", w = /^(?:pop|shift)$/.test(s);
          D.prototype[s] = function() {
            var I = arguments;
            if (w && !this.__chain__) {
              var z = this.value();
              return u.apply(It(z) ? z : [], I);
            }
            return this[m](function(Q) {
              return u.apply(It(Q) ? Q : [], I);
            });
          };
        }), da(qt.prototype, function(s, u) {
          var m = D[u];
          if (m) {
            var w = m.name + "";
            pr.call(Gs, w) || (Gs[w] = []), Gs[w].push({ name: u, func: m });
          }
        }), Gs[Ku(r, T).name] = [{
          name: "wrapper",
          func: r
        }], qt.prototype.clone = BR, qt.prototype.reverse = DR, qt.prototype.value = jR, D.prototype.at = hP, D.prototype.chain = gP, D.prototype.commit = bP, D.prototype.next = yP, D.prototype.plant = xP, D.prototype.reverse = CP, D.prototype.toJSON = D.prototype.valueOf = D.prototype.value = SP, D.prototype.first = D.prototype.head, ql && (D.prototype[ql] = vP), D;
      }, Ws = bR();
      zi ? ((zi.exports = Ws)._ = Ws, Vf._ = Ws) : gn._ = Ws;
    }).call(Yte);
  }(Rc, Rc.exports)), Rc.exports;
}
var Xte = Zte();
function Jte(e) {
  var t = /^[^0-9]{3,4}(-?)[0-9]{6}(-?)[A-Za-z0-9]{3}$/;
  return e = e.replace(/\s/g, ""), t.test(e);
}
function Qte(e) {
  var t = /^\d{10}$/;
  return e = e.replace(/\s/g, "").replace(/-/g, ""), t.test(e);
}
function ere(e) {
  var t = /^[A-Za-z0-9]{15}$/;
  return e = e.replace(/\s/g, "").replace(/-/g, ""), t.test(e);
}
function tre(e) {
  return e = e.replace(/\s/g, "").replace(/-/g, ""), e.length !== 0 && e.length <= 20;
}
function rre(e) {
  var t = /^[A-Za-z0-9]{10}$/;
  return e = e.replace(/\s/g, ""), t.test(e);
}
function nre(e) {
  var t = /^[4]\d{9}$/;
  return e = e.replace(/\s/g, "").replace(/-/g, ""), t.test(e);
}
function ore(e) {
  var t = /^\d{15}$/;
  return e = e.replace(/\s/g, "").replace(/-/g, ""), t.test(e);
}
function are(e) {
  var t = !0;
  if (e = e.replace(/\s/g, ""), t &= e && /^\d{11}$/.test(e), t) {
    for (var r = 0, o = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19], a = 0; a < o.length; a++)
      r += (parseInt(e[a]) - (a === 0 ? 1 : 0)) * o[a];
    t &= r % 89 === 0;
  }
  return t;
}
function Kg(e) {
  var t = new Array(), r = "GB";
  t.push(/^(AT)U(\d{8})$/), t.push(/^(BE)(0?\d{9})$/), t.push(/^(BE)([0-1]\d{9})$/), t.push(/^(BG)(\d{9,10})$/), t.push(/^(CHE)(\d{9})(MWST|TVA|IVA)?$/), t.push(/^(CY)([0-60]\d{7}[A-Z])$/), t.push(/^(CZ)(\d{8,10})(\d{3})?$/), t.push(/^(DE)([1-9]\d{8})$/), t.push(/^(DK)(\d{8})$/), t.push(/^(EE)(10\d{7})$/), t.push(/^(EL)(\d{9})$/), t.push(/^(ES)([A-Z]\d{8})$/), t.push(/^(ES)([A-HN-SW]\d{7}[A-J])$/), t.push(/^(ES)([0-9YZ]\d{7}[A-Z])$/), t.push(/^(ES)([KLMX]\d{7}[A-Z])$/), t.push(/^(EU)(\d{9})$/), t.push(/^(FI)(\d{8})$/), t.push(/^(FR)(\d{11})$/), t.push(/^(FR)([A-HJ-NP-Z]\d{10})$/), t.push(/^(FR)(\d[A-HJ-NP-Z]\d{9})$/), t.push(/^(FR)([A-HJ-NP-Z]{2}\d{9})$/), t.push(/^(GB)?(\d{9})$/), t.push(/^(GB)?(\d{12})$/), t.push(/^(GB)?(GD\d{3})$/), t.push(/^(GB)?(HA\d{3})$/), t.push(/^(HR)(\d{11})$/), t.push(/^(HU)(\d{8})$/), t.push(/^(IE)(\d{7}[A-W])$/), t.push(/^(IE)([7-9][A-Z\*\+)]\d{5}[A-W])$/), t.push(/^(IE)(\d{7}[A-W][AH])$/), t.push(/^(IT)(\d{11})$/), t.push(/^(LV)(\d{11})$/), t.push(/^(LT)(\d{9}|\d{12})$/), t.push(/^(LU)(\d{8})$/), t.push(/^(MT)([1-9]\d{7})$/), t.push(/^(NL)(\d{9}B\d{2})$/), t.push(/^(NL)([A-Z0-9\*\+]{10}\d{2})$/), t.push(/^(NO)(\d{9})$/), t.push(/^(PL)(\d{10})$/), t.push(/^(PT)(\d{9})$/), t.push(/^(RO)([1-9]\d{1,9})$/), t.push(/^(RU)(\d{10}|\d{12})$/), t.push(/^(RS)(\d{9})$/), t.push(/^(SI)([1-9]\d{7})$/), t.push(/^(SK)([1-9]\d[2346-9]\d{7})$/), t.push(/^(SE)(\d{10}01)$/);
  var o = e.toUpperCase();
  o = o.replace(/(\s|-|\.)+/g, "");
  var a = !1;
  for (let c = 0; c < t.length; c++)
    if (t[c].test(o)) {
      var i = RegExp.$1, l = RegExp.$2;
      i.length == 0 && (i = r), Yh && Xte.isFunction(Yh[i + "VATCheckDigit"]) && Yh[i + "VATCheckDigit"](l) && (a = o);
      break;
    }
  return a;
}
const ire = () => ({
  AM: {
    validation: /^\d{8}\/1$/
  },
  AU: {
    prefix: "GST",
    validation: are
  },
  BS: {
    validation: /^\d{9}$/
  },
  BH: {
    validation: /^\d{15}$/
  },
  BD: {},
  BB: {
    validation: /^\d{13}$/
  },
  BY: {
    validation: /^\d{9}$/
  },
  CO: {
    validation: /^\d{9}-\d$/
  },
  KH: {
    validation: /^[LlKk]00\d-\d{9}$|^[Ee]00\d-\d{10}$/
  },
  CM: {},
  CL: {
    ignore: /-|\s|\./g,
    validation: /^(\w{9})$/
  },
  EG: {
    validation: /^\d{3}-\d{3}-\d{3}$|^\d{3}\/\d{3}\/\d{3}$/
  },
  GE: {
    validation: /^\d{9}$/
  },
  GH: {
    validation: /^[CV]\d{10}$/
  },
  IS: {
    validation: /^\d{5}$|^\d{6}$/
  },
  IN: {
    validation: /^\d{2}[A-Za-z0-9]{13}$/
  },
  ID: {
    validation: ere
  },
  JP: {},
  KZ: {
    validation: /^\d{12}$/
  },
  KE: {
    validation: /^[AP][0-9]{9}[A-Z]$/
  },
  KR: {
    prefix: "KR",
    validation: Qte
  },
  LI: {
    prefix: "MWST",
    validation: /^\d{5}$/
  },
  MY: {},
  SN: {
    validation: /^[0-9]{9} ?[012][a-zA-Z][0-9]$/
  },
  MX: {
    validation: Jte
  },
  MD: {
    validation: /^1\d{12}$/
  },
  NG: {
    validation: /^[0-9]{8}-[0-9]{4}$/
  },
  NO: {
    validation: /^\d{9}$/
  },
  OM: {
    prefix: "OM",
    validation: /^\d{10}$/
  },
  RU: {
    prefix: "RU"
  },
  SA: {
    prefix: "SA",
    validation: tre
  },
  RS: {
    validation: /^\d{9}$/
  },
  SG: {
    prefix: "GST",
    validation: rre
  },
  ZA: {
    validation: nre
  },
  CH: {
    validation: Kg
  },
  TW: {
    validation: /^\d{8}$/
  },
  TZ: {
    validation: /^\d{2}-\d{6}-[A-Z]$/
  },
  TH: {
    validation: /^\d{13}$/
  },
  TR: {
    prefix: "VAT",
    validation: /^\d{10,11}$/
  },
  UG: {
    validation: /^\d{10}$/
  },
  UA: {
    validation: /^\d{9}$|^\d{10}$|^\d{12}$/
  },
  UZ: {
    validation: /^\d{12}$/
  },
  AE: {
    validation: ore
  },
  VN: {
    validation: /^\d{10}$/
  },
  GB: {
    validation: Kg
  },
  IM: {}
});
/*! js-cookie v3.0.5 | MIT */
function Dd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var o in r)
      e[o] = r[o];
  }
  return e;
}
var sre = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Yg(e, t) {
  function r(a, i, l) {
    if (!(typeof document > "u")) {
      l = Dd({}, t, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var d in l)
        l[d] && (c += "; " + d, l[d] !== !0 && (c += "=" + l[d].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + c;
    }
  }
  function o(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], l = {}, c = 0; c < i.length; c++) {
        var d = i[c].split("="), p = d.slice(1).join("=");
        try {
          var f = decodeURIComponent(d[0]);
          if (l[f] = e.read(p, f), a === f)
            break;
        } catch {
        }
      }
      return a ? l[a] : l;
    }
  }
  return Object.create(
    {
      set: r,
      get: o,
      remove: function(a, i) {
        r(
          a,
          "",
          Dd({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Yg(this.converter, Dd({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Yg(Dd({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var lre = Yg(sre, { path: "/" });
const JS = {
  "en-US": {
    // Form titles and labels
    title: "Billing address",
    edit: "Edit",
    paymentMethod: "Payment method",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    company: "Company Name",
    companyName: "Company Name",
    street: "Street Address",
    streetAddress: "Street Address",
    apt: "Apt/Suite",
    city: "City/Town",
    state: "State/Province",
    zip: "Zip/Postal",
    country: "Country/Region",
    vat: "VAT/Tax ID",
    // Buttons
    continueToPayment: "Continue to payment",
    payAndBook: "Pay and book",
    // Validation messages
    requiredField: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidVAT: "Invalid VAT/Tax ID format",
    selectState: "Please select your state/province!",
    enterState: "Please enter your state/province!",
    enterZip: "Please input your zip/postal code!",
    inputFirstName: "Please input your first name!",
    inputLastName: "Please input your last name!",
    inputCity: "Please input your city/town!",
    selectCountry: "Please select your country/region!",
    enterStreetAddress: "Please enter your street address!",
    // Placeholders
    firstNamePlaceholder: "Enter your first name",
    lastNamePlaceholder: "Enter your last name",
    emailPlaceholder: "Enter your email",
    companyPlaceholder: "Enter your company name",
    streetPlaceholder: "Street address",
    aptPlaceholder: "Apt/Suite",
    cityPlaceholder: "City/Town",
    statePlaceholder: "Select state",
    enterStatePlaceholder: "Enter your state/province",
    zipPlaceholder: "Zip/Postal",
    vatPlaceholder: "Enter VAT or Tax ID",
    selectCountryPlaceholder: "Select country",
    // Status messages
    validating: "Validating...",
    paymentCompleted: "Payment completed!",
    // Country names
    unitedStates: "United States"
  },
  cn: {}
}, cre = "_zm_lang", Dt = (e, { pattern: t, ...r } = {}) => {
  const o = lre.get(cre) || "en-US";
  return JS[o]?.[e] || JS["en-US"][e] || e;
};
function ure({ user: e = {}, onFormSubmit: t = () => {
}, onFormValidationChange: r = () => {
}, taxStatus: o, onTaxValidationStart: a = () => {
}, continueToPaymentBtnProps: i = {}, continueToPaymentBtnText: l = "" }) {
  const [c] = Gr.useForm({
    mode: "onBlur"
  }), d = Xt(!1), [p, f] = Ir(!1), [h, g] = Ir(null), [y, C] = Ir(!1), [b, v] = Ir(!1), [T, R] = Ir([]), [$, E] = Ir(!1), S = Xt(null), k = Xt(null), A = Xt(!1), [_, L] = Ir(!1), [O, F] = Ir(!1), B = () => {
    const U = ire(), H = (Z) => ZS[Z] ? ZS[Z] : U[Z]?.prefix || YS.indexOf(Z) !== -1 ? Z : "";
    return async (Z, G) => {
      if (!G?.vat || G?.vat.trim().length === 0)
        return Promise.resolve();
      const ye = c.getFieldValue("country")?.value || c.getFieldValue("country");
      if (!ye)
        return Promise.resolve();
      const de = G?.vat.trim(), ne = U[ye], fe = YS.indexOf(ye) !== -1, ie = H(ye);
      try {
        if (L(!0), !ne && !fe)
          return Promise.resolve();
        let oe;
        if (fe)
          oe = Kg(ie + de);
        else if (typeof ne?.validation == "object") {
          let ce = de;
          ne?.ignore && (ce = de.replace(ne?.ignore, "")), oe = ne.validation.test(ce);
        } else typeof ne?.validation == "function" ? oe = ne.validation(de) : oe = !0;
        return oe ? Promise.resolve() : Promise.reject(new Error("Invalid VAT/Tax ID format"));
      } catch {
        return Promise.reject(new Error("VAT/Tax ID validation failed"));
      } finally {
        L(!1);
      }
    };
  }, M = async () => {
    A.current || (k.current && clearTimeout(k.current), k.current = setTimeout(async () => {
      A.current = !0;
      try {
        const U = c.getFieldsValue(), Z = ["firstName", "lastName", "email", "country", "street", "city", "zip"].every((de) => {
          const ne = U[de];
          return de === "country" ? ne && (ne.value || ne) : ne && String(ne).trim() !== "";
        });
        let G = !0;
        if ($) {
          const de = U.state;
          G = de && de.value;
        } else {
          const de = U.state;
          G = de && String(de).trim() !== "";
        }
        if (!Z || !G) {
          C(!1), r(!1);
          return;
        }
        await c.validateFields(), C(!0), r(!0), v(!0);
        const ye = c.getFieldsValue();
        await a(ye), v(!1);
      } catch {
        C(!1), r(!1);
      } finally {
        A.current = !1;
      }
    }, 500));
  };
  Dn(() => {
    if (!d.current) {
      const U = e.country || {
        label: Dt("unitedStates"),
        value: "US"
      }, H = U.value || U;
      if (c.setFieldsValue({
        firstName: e.firstName || "",
        lastName: e.lastName || "",
        email: e.email || "",
        company: e.company || "",
        country: KS.find((Z) => Z.value === H) || {
          label: H,
          value: H
        },
        street: e.street || "",
        apt: e.apt || "",
        city: e.city || "",
        state: e.state || null,
        zip: e.zip || "",
        vat: e.vat || ""
      }), vc[H]) {
        if (R(vc[H]), E(!0), e.state) {
          const Z = vc[H].find(
            (G) => G.value === e.state || G.label === e.state
          );
          Z && c.setFieldsValue({ state: Z });
        }
      } else
        R([]), E(!1);
      S.current = H, d.current = !0, setTimeout(() => {
        M();
      }, 200);
    }
  }, [e, c]), Dn(() => () => {
    k.current && clearTimeout(k.current), A.current = !1;
  }, []);
  const j = (U) => {
    if (M(), U.country) {
      const H = U.country.value || U.country;
      if (S.current === H)
        return;
      if (S.current = H, vc[H])
        R(vc[H]), E(!0), c.getFieldValue("state") && c.setFieldsValue({ state: null });
      else {
        R([]), E(!1);
        const G = c.getFieldValue("state");
        G !== "" && G !== null && c.setFieldsValue({ state: null });
      }
      c.getFieldValue("vat") && c.validateFields(["vat"]);
    }
  }, W = async (U) => {
    g(U), F(!0);
    try {
      await t(U), f(!0);
    } catch {
      F(!1);
    } finally {
      F(!1);
    }
  }, V = () => {
    t(!1);
  }, X = () => {
    const U = (H, Z = !0) => {
      const G = H.map((ye) => {
        const de = h?.[ye];
        return !de || de === "" ? null : typeof de == "object" ? de.label || de.value : de;
      }).filter(Boolean);
      return G.length === 0 ? null : /* @__PURE__ */ P.jsx("div", { style: { marginBottom: 8 }, children: Z ? G.join(", ") : G.join(" ") });
    };
    return /* @__PURE__ */ P.jsxs("div", { className: "form-preview", children: [
      U(["firstName", "lastName"], !1),
      U(["email"]),
      U(["company"]),
      U(["street", "apt"]),
      U(["state", "city"]),
      U(["country"]),
      U(["vat"]),
      /* @__PURE__ */ P.jsx(
        xJ,
        {
          component: "button",
          onClick: () => f(!1),
          sx: { marginTop: "8px" },
          children: Dt("edit")
        }
      )
    ] });
  };
  return /* @__PURE__ */ P.jsx("div", { className: "billing-form", children: p ? X() : /* @__PURE__ */ P.jsxs(
    Gr,
    {
      form: c,
      layout: "vertical",
      onFinish: W,
      onFinishFailed: V,
      autoComplete: "off",
      onValuesChange: j,
      children: [
        /* @__PURE__ */ P.jsxs(Gn, { container: !0, columns: 12, spacing: 2, children: [
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(
            Gr.Item,
            {
              label: Dt("firstName"),
              name: "firstName",
              rules: [
                { required: !0, message: Dt("inputFirstName") }
              ],
              children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("firstNamePlaceholder") })
            }
          ) }),
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(
            Gr.Item,
            {
              label: Dt("lastName"),
              name: "lastName",
              rules: [
                { required: !0, message: Dt("inputLastName") }
              ],
              children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("lastNamePlaceholder") })
            }
          ) })
        ] }),
        /* @__PURE__ */ P.jsx(
          Gr.Item,
          {
            label: Dt("email"),
            name: "email",
            rules: [
              {
                validator: async (U, H) => {
                  const Z = String(H.email || "").trim(), G = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  return Z ? G.test(Z) ? Promise.resolve() : Promise.reject(
                    new Error(Dt("invalidEmail"))
                  ) : Promise.resolve();
                }
              }
            ],
            children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("emailPlaceholder") })
          }
        ),
        /* @__PURE__ */ P.jsx(
          Gr.Item,
          {
            name: "company",
            label: Dt("companyName"),
            requiredMark: "optional",
            children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("companyPlaceholder") })
          }
        ),
        /* @__PURE__ */ P.jsx(
          Gr.Item,
          {
            name: "country",
            label: Dt("country"),
            rules: [
              { required: !0, message: Dt("selectCountry") }
            ],
            children: /* @__PURE__ */ P.jsx(
              TS,
              {
                placeholder: Dt("selectCountryPlaceholder"),
                options: KS,
                isOptionEqualToValue: (U, H) => U.value === (H?.value || H)
              }
            )
          }
        ),
        /* @__PURE__ */ P.jsx(
          Gr.Item,
          {
            name: "street",
            label: Dt("streetAddress"),
            rules: [
              { required: !0, message: Dt("enterStreetAddress") }
            ],
            children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("streetPlaceholder") })
          }
        ),
        /* @__PURE__ */ P.jsxs(Gn, { container: !0, columns: 12, spacing: 2, children: [
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(Gr.Item, { label: Dt("apt"), name: "apt", requiredMark: "optional", children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("aptPlaceholder") }) }) }),
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(
            Gr.Item,
            {
              label: Dt("city"),
              name: "city",
              rules: [
                { required: !0, message: Dt("inputCity") }
              ],
              children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("cityPlaceholder") })
            }
          ) })
        ] }),
        /* @__PURE__ */ P.jsxs(Gn, { container: !0, columns: 12, spacing: 2, children: [
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(
            Gr.Item,
            {
              name: "state",
              label: Dt("state"),
              rules: [
                {
                  required: !0,
                  validator: (U, H) => $ ? H.state && typeof H.state == "object" && H.state.value ? Promise.resolve() : Promise.reject(
                    new Error(Dt("selectState"))
                  ) : typeof H.state == "string" && String(H.state).trim() !== "" ? Promise.resolve() : Promise.reject(
                    new Error(Dt("enterState"))
                  )
                }
              ],
              children: $ ? /* @__PURE__ */ P.jsx(
                TS,
                {
                  placeholder: Dt("statePlaceholder"),
                  options: T,
                  isOptionEqualToValue: (U, H) => U.value === (H?.value || H)
                }
              ) : /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("enterStatePlaceholder") })
            }
          ) }),
          /* @__PURE__ */ P.jsx(Gn, { item: !0, xs: 6, children: /* @__PURE__ */ P.jsx(
            Gr.Item,
            {
              label: Dt("zip"),
              name: "zip",
              rules: [
                {
                  required: !0,
                  message: Dt("enterZip")
                }
              ],
              children: /* @__PURE__ */ P.jsx(ho, { placeholder: Dt("zipPlaceholder") })
            }
          ) })
        ] }),
        /* @__PURE__ */ P.jsx(
          Gr.Item,
          {
            name: "vat",
            label: Dt("vat"),
            requiredMark: "optional",
            rules: [
              {
                validator: B(),
                message: Dt("invalidVAT")
              }
            ],
            children: /* @__PURE__ */ P.jsx(
              ho,
              {
                placeholder: Dt("vatPlaceholder"),
                suffix: _ ? /* @__PURE__ */ P.jsx("span", { children: Dt("validating") }) : null
              }
            )
          }
        ),
        /* @__PURE__ */ P.jsx(Gr.Item, { children: /* @__PURE__ */ P.jsx("div", { className: "billing-form-btn-line", children: /* @__PURE__ */ P.jsx(
          Di,
          {
            className: "billing-form-submit_btn",
            onClick: () => c.submit(),
            type: "primary",
            loading: O,
            disabled: !y || b || !o,
            ...i,
            children: l || Dt("continueToPayment")
          }
        ) }) })
      ]
    }
  ) });
}
const dre = /* @__PURE__ */ JSON.parse('[{"Code_Category":"Contact bank","Stripe_Code":"approve_with_id","CustomerMessage":"We could not process your payment at this time, please contact your bank or try a different payment method."},{"Code_Category":"Contact bank","Stripe_Code":"new_account_information_available","CustomerMessage":"We could not process your payment at this time, please contact your bank or try a different payment method."},{"Code_Category":"Currency not supported","Stripe_Code":"currency_not_supported","CustomerMessage":"This transaction has been declined because this currency is not supported on this card. Please contact your bank or try a different payment method."},{"Code_Category":"Funds not availble","Stripe_Code":"card_velocity_exceeded","CustomerMessage":"Payment is declined because the account has insufficient funds, please contact your bank or try a different payment method."},{"Code_Category":"Funds not availble","Stripe_Code":"insufficient_funds","CustomerMessage":"Payment is declined because the account has insufficient funds, please contact your bank or try a different payment method."},{"Code_Category":"Funds not availble","Stripe_Code":"invalid_amount","CustomerMessage":"Payment is declined because the account has insufficient funds, please contact your bank or try a different payment method."},{"Code_Category":"Funds not availble","Stripe_Code":"withdrawal_count_limit_exceeded","CustomerMessage":"Payment is declined because the account has insufficient funds, please contact your bank or try a different payment method."},{"Code_Category":"General Decline","Stripe_Code":"generic_decline","CustomerMessage":"The system could not process your request at this time, please try again later or using another payment method. If the issue persists, please contact Zoom support"},{"Code_Category":"General Decline","Stripe_Code":"invalid_request","CustomerMessage":"The system could not process your request at this time, please try again later or using another payment method. If the issue persists, please contact Zoom support"},{"Code_Category":"Invaild CC Number","Stripe_Code":"authentication_required","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"expired_card","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"incorrect_cvc","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"incorrect_number","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"incorrect_pin","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"invalid_account","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"invalid_cvc","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"invalid_expiry_year","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"invalid_number","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"invalid_pin","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"offline_pin_required","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"online_or_offline_pin_required","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"Invaild CC Number","Stripe_Code":"testmode_decline","CustomerMessage":"Your purchase could not be processed due to an invalid card number. Please update the card information or try a different payment method. If the issue persists, we recommend contacting your bank."},{"Code_Category":"missing / invalid address","Stripe_Code":"incorrect_zip","CustomerMessage":"Your purchase could not be processed due to an invalid address. Please update your payment method’s address to match what your bank has on file or contact your bank to confirm the correct address for your payment method."},{"Code_Category":"missing / invalid address","Stripe_Code":"Missing Field","CustomerMessage":"Your purchase could not be processed due to an invalid address. Please update your payment method’s address to match what your bank has on file or contact your bank to confirm the correct address for your payment method."},{"Code_Category":"pin exceeded","Stripe_Code":"pin_try_exceeded","CustomerMessage":"You have exceeded the amount of attempts to process payment for this card with an invalid number. Please try another payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"call_issuer","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"card_not_supported","CustomerMessage":"This transaction type is not allowed on this card. Please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"do_not_honor","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"do_not_try_again","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"fraudulent","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"lost_card","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"merchant_blacklist","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"no_action_taken","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"not_permitted","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"pickup_card","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"restricted_card","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"revocation_of_all_authorizations","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"revocation_of_authorization","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"security_violation","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"service_not_allowed","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"stolen_card","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"stop_payment_order","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"transaction_not_allowed","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"Suspected fraud/security","Stripe_Code":"try_again_later","CustomerMessage":"We are unable to process this request due to an issue with the card, please contact your bank or try a different payment method."},{"Code_Category":"System Error","Stripe_Code":"issuer_not_available","CustomerMessage":"The system could not process your request at this time, please try again later or using another payment method. If the issue persists, please contact Zoom support"},{"Code_Category":"System Error","Stripe_Code":"processing_error","CustomerMessage":"The system could not process your request at this time, please try again later or using another payment method. If the issue persists, please contact Zoom support"},{"Code_Category":"System Error","Stripe_Code":"reenter_transaction","CustomerMessage":"The system could not process your request at this time, please try again later or using another payment method. If the issue persists, please contact Zoom support"}]');
function pre(e, t) {
  if (!e)
    return t;
  const r = dre.find(
    (o) => o.Stripe_Code === e
  );
  return r && r.CustomerMessage ? r.CustomerMessage : t;
}
function fre(e) {
  if (!e)
    return {
      success: !0
    };
  const t = e, r = t.code, o = t.message;
  return {
    success: !1,
    error: {
      type: t.type,
      code: r,
      message: pre(r, o),
      originalMessage: o,
      docUrl: t.doc_url
    }
  };
}
function mre({ formDataReady: e, onPayResult: t, onCanContinuePay: r, payAndBookBtnProps: o = {}, payAndBookBtnText: a = "" }) {
  const i = XI(), l = ZI(), [c, d] = Ir(!1), [p, f] = Ir(!1), h = async () => {
    if (!i || !l) return;
    if (f(!0), r && !await r()) {
      f(!1);
      return;
    }
    const { error: y } = await i.confirmPayment({
      elements: l,
      redirect: "if_required"
    });
    f(!1);
    const C = fre(y);
    t(C);
  }, g = () => {
    d(!0);
  };
  return /* @__PURE__ */ P.jsxs("div", { className: "billing-stripe-inside", children: [
    /* @__PURE__ */ P.jsxs("div", { style: { position: "relative" }, children: [
      c && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
        /* @__PURE__ */ P.jsx(mJ, { sx: { my: 2 } }),
        /* @__PURE__ */ P.jsx("div", { className: "billing-address-title", children: Dt("paymentMethod") })
      ] }),
      /* @__PURE__ */ P.jsx(QI, { id: "payment-element", onReady: g }),
      !c && /* @__PURE__ */ P.jsx("div", { style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1
      }, children: /* @__PURE__ */ P.jsx(ute, { size: "medium" }) })
    ] }),
    c && /* @__PURE__ */ P.jsx(P.Fragment, { children: /* @__PURE__ */ P.jsx("div", { className: "billing-stripe-btn-line", children: /* @__PURE__ */ P.jsx(
      Di,
      {
        disabled: !e || p,
        className: "billing-stripe-submit_btn",
        onClick: h,
        type: "primary",
        loading: p,
        ...o,
        children: a || Dt("payAndBook")
      }
    ) }) })
  ] });
}
const bre = ({
  clientSecret: e,
  stripePublicKey: t,
  locale: r,
  account: o,
  userInitInfo: a,
  onPayResult: i,
  onFormValidationChange: l,
  taxStatus: c,
  onTaxValidationStart: d,
  onFormReady: p,
  onCanContinuePay: f,
  payAndBookBtnProps: h,
  payAndBookBtnText: g,
  continueToPaymentBtnProps: y,
  continueToPaymentBtnText: C
}) => {
  const [b, v] = Ir(null), [T, R] = Ir(!1), $ = i8(t, {
    locale: r,
    stripeAccount: o
  }), E = {
    clientSecret: e,
    appearance: {
      theme: "stripe",
      rules: {
        ".Label": {
          fontSize: "14px",
          fontWeight: "500"
        },
        ".Input": {
          color: "#131619",
          border: "1px solid #d9d9d9",
          padding: "4px 11px",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)"
        }
      }
    }
  }, S = async (A) => {
    await p?.(A);
  }, k = (A) => {
    l?.(A);
  };
  return /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx("div", { className: "billing-address-title", children: Dt("title") }),
    /* @__PURE__ */ P.jsx(
      ure,
      {
        user: a,
        onFormSubmit: async (A) => A ? (v(A), R(!0), await S(A)) : (v(null), R(!1), await S(null)),
        onFormValidationChange: k,
        taxStatus: c,
        onTaxValidationStart: d,
        continueToPaymentBtnProps: y,
        continueToPaymentBtnText: C
      }
    ),
    e && /* @__PURE__ */ P.jsx(a2, { options: E, stripe: $, children: /* @__PURE__ */ P.jsx(
      mre,
      {
        formDataReady: T,
        onPayResult: (A) => {
          i(A, b);
        },
        onCanContinuePay: f,
        payAndBookBtnProps: h,
        payAndBookBtnText: g
      }
    ) })
  ] });
};
export {
  bre as StripeForm
};
